webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLiveList = getLiveList;
exports.getLiveCategoryList = getLiveCategoryList;
exports.getChatRoomOnlineUserList = getChatRoomOnlineUserList;
exports.getChatRoomOnlineUserCount = getChatRoomOnlineUserCount;
exports.getLiveCommonExpressionsList = getLiveCommonExpressionsList;
exports.getChatRoomDetails = getChatRoomDetails;
exports.chatRoomSendMsg = chatRoomSendMsg;
exports.getGiftList = getGiftList;
exports.giveGift = giveGift;
exports.startLive = startLive;
exports.addLiveCommonExpressions = addLiveCommonExpressions;
exports.delLiveCommonExpressions = delLiveCommonExpressions;
exports.getChatRoomAdminUserList = getChatRoomAdminUserList;
exports.addAdmin = addAdmin;
exports.delAdmin = delAdmin;
exports.getChatRoomUserDetails = getChatRoomUserDetails;
exports.getUserLiveRecordList = getUserLiveRecordList;
exports.bannedToPostUser = bannedToPostUser;
exports.relieveBannedToPostUser = relieveBannedToPostUser;
exports.kickOutChatRoom = kickOutChatRoom;
exports.updNotice = updNotice;
exports.getGoodsList = getGoodsList;
exports.submitOrder = submitOrder;
exports.getUserOrderList = getUserOrderList;
exports.closeChatRoom = closeChatRoom;
exports.checkIsLogin = checkIsLogin;
exports.delLiveRecord = delLiveRecord;
exports.quitChatRoom = quitChatRoom;
exports.setGoodsExplain = setGoodsExplain;
exports.getLiveIsExplainGoodsInfo = getLiveIsExplainGoodsInfo;
exports.sendRefreshMsg = sendRefreshMsg;

var _request = __webpack_require__(60);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getLiveList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getLiveList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getLiveCategoryList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getLiveCategoryList/v1_0_0',
    method: 'post',
    params: query
  });
}
function getChatRoomOnlineUserList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getChatRoomOnlineUserList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getChatRoomOnlineUserCount(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getChatRoomOnlineUserCount/v1_0_0',
    method: 'get',
    params: query
  });
}
function getLiveCommonExpressionsList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getLiveCommonExpressionsList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getChatRoomDetails(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getChatRoomDetails/v1_0_0',
    method: 'get',
    params: query
  });
}
function chatRoomSendMsg(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/chatRoomSendMsg/v1_0_0',
    method: 'post',
    data: data
  });
}
function getGiftList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getGiftList/v1_0_0',
    method: 'get',
    params: query
  });
}
function giveGift(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/giveGift/v1_0_0',
    method: 'post',
    data: data
  });
}
function startLive(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/startLive/v1_0_0',
    method: 'post',
    data: data
  });
}
function addLiveCommonExpressions(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/addLiveCommonExpressions/v1_0_0',
    method: 'post',
    data: data
  });
}
function delLiveCommonExpressions(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/delLiveCommonExpressions/v1_0_0',
    method: 'post',
    data: data
  });
}
function getChatRoomAdminUserList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getChatRoomAdminUserList/v1_0_0',
    method: 'get',
    params: query
  });
}
function addAdmin(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/addAdmin/v1_0_0',
    method: 'post',
    data: data
  });
}
function delAdmin(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/delAdmin/v1_0_0',
    method: 'post',
    data: data
  });
}
function getChatRoomUserDetails(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getChatRoomUserDetails/v1_0_0',
    method: 'get',
    params: query
  });
}
function getUserLiveRecordList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getUserLiveRecordList/v1_0_0',
    method: 'get',
    params: query
  });
}
function bannedToPostUser(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/bannedToPostUser/v1_0_0',
    method: 'post',
    data: data
  });
}
function relieveBannedToPostUser(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/relieveBannedToPostUser/v1_0_0',
    method: 'post',
    data: data
  });
}
function kickOutChatRoom(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/kickOutChatRoom/v1_0_0',
    method: 'post',
    data: data
  });
}
function updNotice(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/updNotice/v1_0_0',
    method: 'post',
    data: data
  });
}
function getGoodsList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getGoodsList/v1_0_0',
    method: 'get',
    params: query
  });
}
function submitOrder(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/submitOrder/v1_0_0',
    method: 'post',
    data: data
  });
}
function getUserOrderList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getUserOrderList/v1_0_0',
    method: 'get',
    params: query
  });
}
function closeChatRoom(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/closeChatRoom/v1_0_0',
    method: 'post',
    data: data
  });
}

function checkIsLogin(query) {
  return (0, _request2.default)({
    url: '/app-api/auth/checkIsLogin/v1_0_0',
    method: 'get',
    params: query
  });
}
function delLiveRecord(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/delLiveRecord/v1_0_0',
    method: 'post',
    data: data
  });
}
function quitChatRoom(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/quitChatRoom/v1_0_0',
    method: 'post',
    data: data
  });
}
function setGoodsExplain(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/setGoodsExplain/v1_0_0',
    method: 'post',
    data: data
  });
}
function getLiveIsExplainGoodsInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getLiveIsExplainGoodsInfo/v1_0_0',
    method: 'get',
    params: query
  });
}
function sendRefreshMsg(data) {
  return (0, _request2.default)({
    url: '/app-api/service/live/sendRefreshMsg/v1_0_0',
    method: 'post',
    data: data
  });
}

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPresentUserInfo = getPresentUserInfo;
exports.getAppSysMsgList = getAppSysMsgList;
exports.getFaqList = getFaqList;
exports.submitFeedback = submitFeedback;
exports.updatePassWord = updatePassWord;
exports.getHtmlContentByType = getHtmlContentByType;
exports.getBalanceBillList = getBalanceBillList;
exports.updUserInfo = updUserInfo;
exports.getMsgUnreadCount = getMsgUnreadCount;
exports.getAppDownloadConfig = getAppDownloadConfig;
exports.getFlowRecordList = getFlowRecordList;
exports.getAppConfigInfo = getAppConfigInfo;
exports.deleteVermicelli = deleteVermicelli;
exports.followOrCancelFollow = followOrCancelFollow;
exports.getUserFollowList = getUserFollowList;
exports.getUserVermicelliList = getUserVermicelliList;
exports.addCollectOrCancelCollectVideo = addCollectOrCancelCollectVideo;
exports.addGiveLikeOrCancelGiveLikeVideo = addGiveLikeOrCancelGiveLikeVideo;
exports.commentVideo = commentVideo;
exports.getChildCommentList = getChildCommentList;
exports.getUserCollectVideoList = getUserCollectVideoList;
exports.getUserGiveLikeVideoList = getUserGiveLikeVideoList;
exports.getVideoCommentList = getVideoCommentList;
exports.getVideoList = getVideoList;
exports.replyCommentVideo = replyCommentVideo;
exports.deleteComment = deleteComment;
exports.viewUserVideoList = viewUserVideoList;
exports.viewUserInfo = viewUserInfo;

var _request = __webpack_require__(60);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPresentUserInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getPresentUserInfo/v1_0_0',
    method: 'get',
    params: query
  });
}
function getAppSysMsgList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getAppSysMsgList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getFaqList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/common/getFaqList/v1_0_0',
    method: 'get',
    params: query
  });
}
function submitFeedback(data) {
  return (0, _request2.default)({
    url: '/app-api/service/common/submitFeedback/v1_0_0',
    method: 'post',
    data: data
  });
}
function updatePassWord(data) {
  return (0, _request2.default)({
    url: '/app-api/service/user/updatePassWord/v1_0_0',
    method: 'post',
    data: data
  });
}
function getHtmlContentByType(query) {
  return (0, _request2.default)({
    url: '/app-api/service/common/getHtmlContentByType/v1_0_0',
    method: 'get',
    params: query
  });
}
function getBalanceBillList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getBalanceBillList/v1_0_0',
    method: 'get',
    params: query
  });
}
function updUserInfo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/user/updUserInfo/v1_0_0',
    method: 'post',
    data: data
  });
}
function getMsgUnreadCount(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getMsgUnreadCount/v1_0_0',
    method: 'get',
    params: query
  });
}
function getAppDownloadConfig(query) {
  return (0, _request2.default)({
    url: '/app-api/service/common/getAppDownloadConfig/v1_0_0',
    method: 'get',
    params: query
  });
}

function getFlowRecordList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getFlowRecordList/v1_0_0',
    method: 'get',
    params: query
  });
}

function getAppConfigInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/common/getAppConfigInfo',
    method: 'get',
    params: query
  });
}
function deleteVermicelli(data) {
  return (0, _request2.default)({
    url: '/app-api/service/user/deleteVermicelli/v1_0_0',
    method: 'post',
    data: data
  });
}
function followOrCancelFollow(data) {
  return (0, _request2.default)({
    url: '/app-api/service/user/followOrCancelFollow/v1_0_0',
    method: 'post',
    data: data
  });
}
function getUserFollowList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getUserFollowList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getUserVermicelliList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/getUserVermicelliList/v1_0_0',
    method: 'get',
    params: query
  });
}
function addCollectOrCancelCollectVideo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/addCollectOrCancelCollectVideo/v1_0_0',
    method: 'post',
    data: data
  });
}
function addGiveLikeOrCancelGiveLikeVideo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/addGiveLikeOrCancelGiveLikeVideo/v1_0_0',
    method: 'post',
    data: data
  });
}
function commentVideo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/commentVideo/v1_0_0',
    method: 'post',
    data: data
  });
}
function getChildCommentList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/video/getChildCommentList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getUserCollectVideoList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/video/getUserCollectVideoList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getUserGiveLikeVideoList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/video/getUserGiveLikeVideoList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getVideoCommentList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/video/getVideoCommentList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getVideoList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/video/getVideoList/v1_0_0',
    method: 'get',
    params: query
  });
}
function replyCommentVideo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/replyCommentVideo/v1_0_0',
    method: 'post',
    data: data
  });
}
function deleteComment(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/deleteComment/v1_0_0',
    method: 'post',
    data: data
  });
}
function viewUserVideoList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/video/viewUserVideoList/v1_0_0',
    method: 'get',
    params: query
  });
}
function viewUserInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/user/viewUserInfo/v1_0_0',
    method: 'get',
    params: query
  });
}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAB5UlEQVR4AezYjU3DMBAFYMICrFQ2gIloJwImgJHYILxnxZLVOo3PvmdZldE5fzR3/uymav389GB/EzT6hM4ZmjPUeQTmW67zgJvLzRkyD1nnG0wztK7rCe2tVx9Ry1yvGITkhPwA84njD+ylsdWI9U6lxYpBSPiHFuO8FYznrvst9zlJ+pIc3z0sBi3L8otMF7QYElQGc0Ht71j0aF8MYiIk5qjJUDsY1mT5omYCMaMK5YFh/8wg3uSN8sKwb1Ug3uiF8sSwX9Ug3tyK8sawT00gJqhFEYP70ween2bpOf5tj2YQS1pRKgz74gJiolKUEsN+uIGY7AilxrAPriAm3EP1wLC+O4hJcyhcTx94lw8A5LwJCYhVMiheZpNhmFwGYnK0Fe06cteuX1N9LgNlnpnYScm39JhcAspg+A2dLdaVodxBOQyfJzZo5ChX0B4GkBA9UG6gI0wQYaNGuYBKMfCEUKKaQVZMEGGjQjWBajHwhFCgqkGtmCDCxhtVBfLCwBPCE2UGeWOCCBsvlAmkwsATwgNVDAKGa9vynwA7KPnatvQnQAYlW9t+x3vjdSuIQ11sNWI92dr2Fwpx0V4nSTKjlrle8TOU1Bn6cIKGnh50bs4QBmHomDM09PSgc3OGMAhDxz8AAAD//7vOvBIAAAAGSURBVAMAvKIkeJQMC+oAAAAASUVORK5CYII="

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(780)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  "data-v-2b7b57be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABb0lEQVR4AeTV4VHCMBiH8dYJGEE3kBHYQDZwA2UCYQJ1EnQC2AA30A1kg/o8Sjw42pA0Pb7A5X9Ne21+15eXcFWd+XPhYNM0n81froeqfEpJxVbAt0Ogp8AxyBsR3YA+Mi8aUbCu6y2ZIiyI4xn0yUnfRMGwKOic+Yw45qBLMvIkN0mgi4K+cLTEXxzviCW21EzTRzLokqAfHCdEVCy7mbJAoApUzDft1UzZ4A7t3Uy9QFHD2x41k9djKQJdGPSgmejee693pRhsWfi75dr/pWKQN3pgtQ2xa9e88TvzzlEEgrnrWFKBVzB/Ms470wsEGpElq9o0HKoZWNI+mw0CWTpL6G6zRZuAhbfkND6yQDD/olYsKfq7AYCtOU8eySDYfnO4y4zBRJMxb0wCwfabYwE0JZbTNbISBYHamiM0ShYUbo6C3BSaw9JZwuTm4NnWcQr0ITE70b8mz4sSBfmebnYRLYLCw1Ew3DTk8ezgDwAAAP//1TY7JwAAAAZJREFUAwB3CH45oCB+gwAAAABJRU5ErkJggg=="

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(208);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(140);

var _store2 = _interopRequireDefault(_store);

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _routes = __webpack_require__(209);

var _routes2 = _interopRequireDefault(_routes);

var _router = __webpack_require__(459);

var _router2 = _interopRequireDefault(_router);

var _elementUi = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = _axios2.default.create({
  baseURL: 'https://test.unishow.live/prod-api/',
  timeout: 10000,
  withCredentials: true
});

service.interceptors.request.use(function (config) {
  var token = _store2.default.state.token;
  var language = localStorage.getItem('Language');
  if (token) {
    config.headers['unishow_api_token'] = token;
  }
  var langMap = {
    'cn': 'chinese',
    'en': 'english',
    'tw': 'taiwan',
    'ja': 'japanese',
    'ko': 'korean'
  };
  config.headers['language'] = language ? langMap[language] || 'taiwan' : 'taiwan';
  return config;
}, function (error) {
  return _promise2.default.reject(error);
});

service.interceptors.response.use(function (response) {
  var res = response.data;
  console.log(res, 123);
  if (res.code == 200) {
    return res;
  } else if (res.code == 500) {
    (0, _elementUi.Message)({ message: res.msg, type: 'error' });
    return _promise2.default.reject(res);
  } else if (res.code == 401) {
    (0, _elementUi.Message)({ message: res.msg, type: 'error' });

    setTimeout(function (v) {
      sessionStorage.setItem('user', 1);
      window.location.href = '#/login';
    }, 1000);
    return _promise2.default.reject(res);
  } else {
    (0, _elementUi.Message)({ message: res.msg, type: 'error' });
    return _promise2.default.reject(res);
  }
}.bind(new _vue2.default()), function (error) {
  return _promise2.default.reject(error);
});

exports.default = service;

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toWithdrawal = toWithdrawal;
exports.toGive = toGive;
exports.getWalletBillTypeEnums = getWalletBillTypeEnums;
exports.getWalletBalanceBillList = getWalletBalanceBillList;
exports.getGiveAmountConfig = getGiveAmountConfig;
exports.getUserWalletInfo = getUserWalletInfo;
exports.getUserWalletList = getUserWalletList;
exports.toRecharge = toRecharge;
exports.getRechargeStatusInfo = getRechargeStatusInfo;

var _request = __webpack_require__(60);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toWithdrawal(data) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/toWithdrawal/v1_0_0',
    method: 'post',
    data: data
  });
}
function toGive(data) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/toGive/v1_0_0',
    method: 'post',
    data: data
  });
}
function getWalletBillTypeEnums(query) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/getWalletBillTypeEnums/v1_0_0',
    method: 'get',
    params: query
  });
}
function getWalletBalanceBillList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/getWalletBalanceBillList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getGiveAmountConfig(query) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/getGiveAmountConfig/v1_0_0',
    method: 'get',
    params: query
  });
}
function getUserWalletInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/getUserWalletInfo/v1_0_0',
    method: 'get',
    params: query
  });
}
function getUserWalletList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/getUserWalletList/v1_0_0',
    method: 'get',
    params: query
  });
}
function toRecharge(data) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/toRecharge/v1_0_0',
    method: 'post',
    data: data
  });
}
function getRechargeStatusInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/wallet/getRechargeStatusInfo/v1_0_0',
    method: 'get',
    params: query
  });
}

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAB00lEQVR4AeyTsUoDQRRFEwsDgqBYBSxiYycoqexEwcoUQVCsYiX4F9pY+wv+QbC0sbCwCgh2gugnCBHFKp4bEk12XnZmdZNsseGdzM7Oe2/v3J2dKWTslwvyvZBghzqdTgmqsAtHPU4YfTTI2YcaqH4+TlSQIBqt0aQBVaiAmgouvVEiYwnKoHptRiNTN7yCELNK2SakGXJKG3N6egVRMXI3rP0n5LpTHysId/RahFOYwo1yr/9Qq1hBZG7BNuzBARwHoFyxTq7ODsPIcNZNQSivwAttruEQarADOks+lCtOyb8AbYTBjNnoXVMQSbdgHjruJw1tRFh1+gKH7juCcEZWpyWm/zD17F8PjkEOpS1GApb1F4LjEEXjEDRH36CwBC0EVSZPcr4oq4UlyMqb2L1ckM/q3KHcIZ8DvvX8DEUcakfmhWk79J41QZlyqF0sFqcq6DPyelqReXdqnaHX7srvX1pXHwON7nHnaWD+czkpQc88URuVK1eIeWRuhiXogcw3SDPuEHEDLfiKa+wIokBizuOKEq7JmeB+jiA9DFGXjHVowl8ckwjVScgG/TSnlT9MQSqjSRPqoIaLjElihWTVnTHKcbUMYqSgoOoxJGVO0DcAAAD//weUUncAAAAGSURBVAMAKpiMSRLb4w8AAAAASUVORK5CYII="

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHelpLive = createHelpLive;
exports.getAppHelpLiveConfig = getAppHelpLiveConfig;
exports.kickOutHelp = kickOutHelp;
exports.updateHelpLiveConfig = updateHelpLiveConfig;
exports.getHelpUserList = getHelpUserList;
exports.getHelpUserInfo = getHelpUserInfo;
exports.updateHelpLiveUser = updateHelpLiveUser;
exports.getHelpKeyInfo = getHelpKeyInfo;
exports.joinHelpLive = joinHelpLive;
exports.exitHelp = exitHelp;
exports.updateCameraStatus = updateCameraStatus;
exports.updateMicrophoneStatus = updateMicrophoneStatus;
exports.getLiveBgList = getLiveBgList;

var _request = __webpack_require__(60);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createHelpLive(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/createHelpLive/v1_0_0',
    method: 'post',
    data: data
  });
}
function getAppHelpLiveConfig(query) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/getAppHelpLiveConfig/v1_0_0',
    method: 'get',
    params: query
  });
}
function kickOutHelp(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/kickOutHelp/v1_0_0',
    method: 'post',
    data: data
  });
}
function updateHelpLiveConfig(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/updateHelpLiveConfig/v1_0_0',
    method: 'post',
    data: data
  });
}
function getHelpUserList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/getHelpUserList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getHelpUserInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/getHelpUserInfo/v1_0_0',
    method: 'get',
    params: query
  });
}
function updateHelpLiveUser(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/updateHelpLiveUser/v1_0_0',
    method: 'post',
    data: data
  });
}
function getHelpKeyInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/getHelpKeyInfo/v1_0_0',
    method: 'get',
    params: query
  });
}
function joinHelpLive(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/joinHelpLive/v1_0_0',
    method: 'post',
    data: data
  });
}
function exitHelp(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/exitHelp/v1_0_0',
    method: 'post',
    data: data
  });
}
function updateCameraStatus(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/updateCameraStatus/v1_0_0',
    method: 'post',
    data: data
  });
}
function updateMicrophoneStatus(data) {
  return (0, _request2.default)({
    url: '/app-api/service/helpLive/updateMicrophoneStatus/v1_0_0',
    method: 'post',
    data: data
  });
}
function getLiveBgList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/live/getLiveBgList/v1_0_0',
    method: 'get',
    params: query
  });
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.client = client;

var COS = __webpack_require__(732);

function client() {
  try {
    var cosClient = new COS({
      region: 'ap-hongkong',
      SecretId: 'IKIDCINMSZUBj5HSUyJWaS9k3Ol2eHpS4a3M',
      SecretKey: 'FKBxrY1WzHQM4atyrfKmBnJeoposuqgL',
      bucket: 'unishow-live-1383640469',
      secure: true,
      cname: false,
      endpoint: 'https://cos.ap-hongkong.myqcloud.com'
    });

    if (!cosClient || typeof cosClient.putObject !== 'function') {
      throw new Error('COS 实例初始化失败，缺少 putObject 方法');
    }

    return cosClient;
  } catch (err) {
    console.error('COS 客户端创建异常：', err);

    return null;
  }
}

var getFileNameUUID = exports.getFileNameUUID = function getFileNameUUID() {
  function rx() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  return +new Date() + '_' + rx() + rx();
};

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAADoklEQVR4AeyWjVnbMBCGlU5AN4ANYILCBrABnaDpBCkbwASlE9BOAJ2AdgLYgG6Qfq+ic5VasqPgOH545Efn08/9fXcnJ+/cG3sqoKkXtFaoVmjkDNSWGznhxe5qhYpTNrJCrdDICS92VytUnLKRFWqFRk54sbvOCi2Xy2PRYbHVHSkolt54soCkDJBHxfak+an4XodiiOM5zgWTBSSFA5GNrzIYr21/FB5830fO/kTztWkW0Gw2+yXJGxGD7NwHw6wHoU2MBJ+AIQZUbhTbM5MUZQEF4S/iABNzlPlRDsyw2/UjX96n/MDFHLEQk8s9nYCUCUp7IWUMiTnAcKcWcsbc7eKR7QPRQra5w+aHGC5CTDpKj05AqMgA5f3OPCKyRAtyt8xhdLzdVCD4igHkSRbwIdaMhxBLs5Ga9AKSEwI244CDsMX+pSZUjFa8luypaOOPB7KicxG6VAPCl9nAF5WRGzeXXO/XtheQLHEhxfw4U5aONPsowpmYH/T4J82QfZFjiAreaU4VY2KPBLxIHroTRxcbmvoBiMvg67PfWb2wY2BXO/+9OwEpmIXkqYSYu5IDD0L8VgSwMx18E/l9cRs4JZvn2qCKMbFH8MjouBncV76qJO1E9rHrxB8kwb6YIxZicrknC0hgUKb86D7LsM1Ze9IefW2ZPNEmzsX8IMsE6RfRC/CQnSF3JFvvRXNRbMPU8I0O687WywKSJu0j5geV8JPcS4EQGJlHBKBkmSB1tDYInuoij+yhTi1Y1i3SOeBpczvLtl4SkKpDWakQBppWY5Ej6QDG2uhnTi7aNxk+0ehGR+2pQFG53tZrAVJgAKHEWE22GgcJ4s7YNs5tnuOxTKybk2efuKyaydZrAZIWXx0xP3pbzUutXh9WzNlFdj0PLUcrIbYRIFUJ+bj16CT0G0oBQgmBjVoNwUAWVJz5cNRmIThAcdgkg0UXSQ/7V0Hmd+ANawGSAlXh4lLeRrBrojblDpTcHzNXdI9MSTESGzHObc94CxAHUrA+ZbkJWXWQJYPwTSiWjW306uZiTALqtdYWaFpGjuIg25LrO7SctXgRoHUz/1ZDAbJgSsDw8QAMoIioSQqLbWkoQARGDLe8CulHkDcbYbkdGwoQHxL+Gfj/XyWhqEWvJe/1xV89BgGkoPgBttYpDkr6/FUat0LFUe5JYZAK7Sn2pNsKKJmWCW3WCk2oGMlQaoWSaZnQZq3QhIqRDKVWKJmWCW2+uQr9BQAA//+S82DIAAAABklEQVQDAFl1LHg1shNdAAAAAElFTkSuQmCC"

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAEnklEQVR4AezYgXUTORAGYPsqgA5IB9ABVHB3FQAVECogVABUQKjg0gF0AB1AB0cHuf/z27m3rL22lJiYx1ve/pG0mhnNrxnNyvyx+s3+LYR+9YAuEVoidMc7sKTcHW9493JLhLq37I4Vlgjd8YZ3L/dTI3R9ff0geDzBg24vOxSOSiiO3wteBB+Df+PH1+DjBF/NBWSepj0qwaMQilOiwHEk3obA4+BeMPeYI3MZAQTfs5H+rZ9bEYoTDwNEgIPl0Pd0PgXvgufB38GTQP91WnNp/n+epSdiiN0qYjciFBJS602c+ByMiXCU42fr9frJer0+Dy6Dq+BToH+R1tw6ugjSSXfzICZirzajG/zpJhQyD7MOIudp6+EUJ4HjIlRzs22IIbjZgAh9COq5yDqIdUeri1AWeZEVpVct9C1jJACpDPufEPsWiI7UZJMRayA13jjv96KZUMhIAwfegWbU+XgUR25MhJExYusq40cB22k2z5th7c3g0J8mQjH4PoYuAo90ep7FnQ9972YRXedNFQS7PitrIna/B6LyMuOyLwX5kFf7n4OE4hBD0oEl6SC9lFvjWUTPR1V6KuVakEJNlSykZINoWdM6z2KTL/qz2EtoMDAl82XW2jARPZFAYFwBh9kVe0o0mdW+fyGFjKKhJXqQ1CyhOKUsW5whBkVGa3wI0rMcdsaUZwe+NsPcwd22yAwpvpnewk5CIaMAyGMKSDSTiS5nn1IMvsQhusqzb5EUQjBTK2eqCozxLGJj40MEtGlW51nnlc4UW4QiyCE7TJYBDmmNW0C/5MpOjbXj741vmncHMSI1LhRb+luEYnm8a+N+prqf+zs0yqEdU02vxvrj/kZ5i1B2Qp67bxFAqOkAEx5Af+iuKvVqrB2nSnPkh8xRaCoDXsfXLf0tQlaMoFSpjxsDzaSia9fG5+RznPkrUKE4VGniXG05ZP0porvxIe+1aVbvsg4f9X/ATkIkoqAoVL4z1Ewq+qpaOYvAP3mnqlUZN1dZkKn5ZweZD4NvO5VmCZGOorLdTSp6HPb9KF3mCqLXVGhCxmaIqg2ljwyf9HdiLyEacY6BcoxhKSR6pmcRvbpwnkUIObif961knL8uMllndZAQoTiBVKWIQuHCCPpEZhFdxPykAOdrVtZEouLu58PpelX2FQA+ENmLJkIsxDGH0IXREERJtP40OAZCxhkb/9ayAS+HtZuWaCbEWgy7MEohZ8QrKXgVR5ounBR2IfpuDdIL2CRmDelpTeMmdBFiMaSkEFKVgl5LBzdplVDue7cXISG1xkREp3R8MvzWGn/Tam5v202orIWYFESsCoYpTl3GWQ9yfsf4/nC8vkVvMykS9V9cdOiCCohI028tClPcmBBDISVaoqOCjYmZ5qhbge8PAvUt8jPeXB14sohIL+iOCgOFWxEqIyGmgiEmYj6qHHSgS2TamiOjsFQpN57KdY+bCbVYDjERc6Wx0y6mCIreGGeRKxKuMMi1mG+SOSqh6YpxHEHRG0P1mooebfxTCR3Nyw5DC6GOzTqJ6BKhk2x7x6JLhDo26ySiS4ROsu0diy4R6tisk4j+BwAA///o7K39AAAABklEQVQDAL4C8XgbMq9bAAAAAElFTkSuQmCC"

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABp0lEQVR4AczYzVHDMBAF4JgbjeRMIaEQztTBmUJCIXClEK7mPUXS+EcbrXalJIzWdmRJ7yPjwTZPhwf7eWzQPM9H1MutvjRk7fLyN4SThLwD84bjV+yHtpiR8o4pLIPQ8YdK7RQnpM9d93Ht02LR53ScQdM0/aLzjEptCKqAOSP7J4VmEDtw4gv7YSgBw0zEXtoKxK5RKA2G+TsQO3ujtBhmF0E80QvVgmGuCOJJL6oVw8yrIA6woiwY5lVBHNSKsmKYpQJxoBblwTBHDeLgGsqLYUYTiBMkVA8M128GcVIJhf7lvYm3g9VfYJxXNROIKxdQ7GaZMZxsBnEyakJtW6lvO0b8bAYVrpkU4npKMIEKGD4hsNyoZlAJw+uJBY0b1QSSMICE1gOlBtUwQYSNF6UCaTHwhOZBVUGtmCDCxoq6CrJi4AnNghJBXkwQYdOKKoI2GCx7cN0OWlA7UG8MfxuWFrUCjcIQxNKgMggYvtt3eYRguFQCqvpu77pmJEzqL6DEd/tPTPqIE3A4rsWMlCe+239jIP/pME6yWBlZu7x8DS3G3fXwHwAA///RKPvqAAAABklEQVQDAHj8IlhmNfZPAAAAAElFTkSuQmCC"

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAEsklEQVR4AcyYz28bRRTHvzPhyMGcyjEF7k3+g/UaNaJxISUnioRB4ocEh5C/IO1f0OTQS1WJhkM4mSZKUmGkeoe/IOFekXArp+RQcUr39X03no3X9dq7tht3tOO38+a9N5+dfTMe22KMEgRLlSCoB2F4Yz0M64+r4eJRNayfaJVOPanW6gdao1BtgtonS/QZY0iMBEzIarUeGXt2ZCwigV0RYAkwswAquCgVCOa0BrQxMvNYfU5CfTjCY4RSCrgDekBIGATIwmmz2MWHI3w1vHkU1BYbxbzOrQoB62ucPZ9RRDCYw8SKzBoxj5gyHKNI2KHAQa2+oq/xQEE5o0VilrcRBBwjCBd/xpAyEDgI62tGsI4RX736lbkqBuae5vfaIKdc4AQWuINLLqJjDoLuCzwtWD83g6BfA05yVp/SO09LErpfTmeAuVI1Zy89DfImRXN6jUzd/RlgY85+0c7ujV+bU70qZiZhSiFS4CC88TUMArxtRbc8fmF5rBTYYGbgdoJOWV7+FFtbD9FofNHRlBeM8eDBBiiLeJsZ3PN2CXBQu6nnAOE5wOtz5cL1j/H+lStofHUbo0DT56cfv8NHH36A5c8/yx0n06HnET/LCbAVaWQMBjRafz5Ne8tCE5Y+PkCrdRHL6/KkznKSAVZXYUWSk1aeaVbfbO5gc/O3VEkAgqSKnBva0NZ3M8bmr1u+OVwmsxxULGZell5oHIgD+lEIQiDf7pXso43X05cxfLug1N3r3TkLkdLAHIADcmDesxKIYLzvrtSxz+voQ1/fLiOtjZesflFcK+PUbcuBCeB1BCNg2tadhDrfpi19fLusjMXMWv3NoVONkQsBCOIDEJDQSdWdxOtpQ1vfHkUaY69ZxCi0nWFAIQiBvEkCPWHY89iii85grBlGp/RCd9TJjsI+3x5TKvCYETLuuiAybTb66agfsVoITtGnlFX15qz3T9JDF59vjylPLYyMDdwLy3xm9XATgxY5tnrmPPSBR5F9YfUbjHk7cWhrTm0M/IsRSx6sDzdpaCPx31a3tW0/QBk5DNbHmiS0CCILvHNYduEVhZ00tMj/f1nntrnoCudxWdhB0EUP8IwhIjvOOd0ltKVTfVdFoWthoZbacVHxlaeKITe0pY83W7h+Ecvr8qSB8PemniTUwrk9p2lRaJabzV08e/YP7t9/CAKoe6mLPoR+/vw/tFrtYr66nUXRkx0aW36wimCVcljlAf77H1bQ/D3xH2bet5/Qt7/8tnAMZUv/ekiBO7Ps+o4wRaXCaurub3qEFJgKkbNvNDW4CNmcfuWxgUxdJBlg5/441tVYeAF2xXkjt2LkLpm6g2eA2eHc/roAU4c2yuDa+/yrl1hpfQ2YPa69d2ea0IRtKwNZemtfYBpNC3oQLLlygdmZQMeyeikLUReYQFbzZpY8rAOBaZDktJzNK/Qb2/K4dekONe/65CwZuutQYBpzpUbRXlXiWLc9OaZuItXgUGJUncbmGEViFgL2gZx78iiK9q9KbG4JzLbXl5J89QInCho93Zt3PBaUCFAK2Md1bnfbtXdvSfziPUngscGUEUH2qKpwgBzz4QTYEIUUeXH1fEb1/ILy5RUAAAD//wRvDGEAAAAGSURBVAMAkLElZoOcCmcAAAAASUVORK5CYII="

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitLiveApply = submitLiveApply;
exports.getUserLiveApplyRecordList = getUserLiveApplyRecordList;
exports.getLiveApplyInfo = getLiveApplyInfo;
exports.returnLiveApply = returnLiveApply;
exports.getLiveApplyTimeList = getLiveApplyTimeList;

var _request = __webpack_require__(60);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function submitLiveApply(data) {
  return (0, _request2.default)({
    url: '/app-api/service/liveApply/submitLiveApply/v1_0_0',
    method: 'post',
    data: data
  });
}
function getUserLiveApplyRecordList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/liveApply/getUserLiveApplyRecordList/v1_0_0',
    method: 'get',
    params: query
  });
}
function getLiveApplyInfo(query) {
  return (0, _request2.default)({
    url: '/app-api/service/liveApply/getLiveApplyInfo/v1_0_0',
    method: 'get',
    params: query
  });
}
function returnLiveApply(data) {
  return (0, _request2.default)({
    url: '/app-api/service/liveApply/returnLiveApply/v1_0_0',
    method: 'post',
    data: data
  });
}
function getLiveApplyTimeList(data) {
  return (0, _request2.default)({
    url: '/app-api/service/liveApply/getLiveApplyTimeList/v1_0_0',
    method: 'post',
    data: data
  });
}

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAB70lEQVR4AezYjU2EQBAFYM8G7AUoQDvQioSK1Aq8AqAXKwDfS1xDVpD9mbchlzVsGDHM7Me43MH93Y39VNDZG1o7VDtU+ArUf7nCFzy6XO1Q9CUrfEJUh7que2zb9rnUHFPqBYMIWZblE5i3pmlesZdurOHqERZaLBh0uVy+XFLEPQu63633zM0aq7wPq/jfMBg0juMVRQaXDbEE5WNQZ0DtD1f3aB8MYiIk7lmAMQdiU9QOpmet0BEFYlIVygLD+UWDeJI1ygrDuSWBeKIVyhLDeSWDeHIuyhrDOWWBmCAVRQxvKszBgZh3s6gbAM/zRzaICWNRKgznYgJiolCUEsN5mIGY7AilxnAOpiAm3EOVwLC+OYhJt1BY9L8LHrHJDYC1/CEBsYiP4jEOJYb5ZSAmn+d54X495vnvsfXfc2MZyF8zbqLokOkXWpfX7SUgHwPEwOGKIpahzEFbGK4nDkDkz1OmoD2M60wJlBnoCFMKZQIKxZRAZYNiMWpUFigVo0Qlg3IxKlQSyAqjQEWDrDHWqCiQCmOJCgbx3TY+6eWPAFsfviXebcueZ9gtH4VjmnfbSPyCLj2xIGLp9lPD1dO8256m6R2FrlLJKnlKveA1tKpz6rCCTt0eTK52CBfh1Fvt0Knbg8nVDuEinHr7BgAA///EweDkAAAABklEQVQDAD2mMHjoTqU9AAAAAElFTkSuQmCC"

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAp0lEQVR4AdTS2w2AIAwFUHECR9BR3MiR3IRRdBO8NxJjEPpI+NHQ+ConpTAOna+fgymlI90xWztjWTKxCJh31dXAFcKJIGZCRTCEQMyFiiAqG7yoCgroxH9lmEBOqlS68XsZZrCc2Ho3g/nYREDccW7WjufPMIEVbM0t8IMejLpYoRdTQSS8e9ZcJvKeIVaYs7gBJoz5IojGLzmIMl8NEVRnVxK6gxcAAAD//5z3AiIAAAAGSURBVAMADbpGKWhQuJoAAAAASUVORK5CYII="

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAGRUlEQVR4AeyZT4jVVRTH78QsZtHCwCgoGKMWBQUFSUWESUSBAxkVFCkZtSgwLFQyLEwKmiioSMGoSMgQydCgKMFgBAOjIqMWLoJcuDB04cLFLILp87lz78ydee/33u/3mzdW4ON+f+fcf+eec+8999+7JPzPfxcN+LcHcOAjMDU1tQSsAi+CdxK2Qh8CSwZt8MAMQLkV4AAKngFfgXHwfMLr0P3gDGW+ASvgBxJqGUCD94BtYOn8Vkmzxz8hfQKsBsOgKph3P5kT1NsLroBfUOhrAI047Pboq7T0OfERaAzwozA/gnUgh3MwO8AasDLhUei74DTIwbRjyLg2J7ShfQ1A6HlwFhju5vMWCDR8FdRevw5qUPH1MJcPDQ09Bz4DEwn7oC+Qdw14GmRDlsEfRZYdAds89DWAhv9G7MNgEhjW0+BTMHuACkDCyRDCcsruBJYn2hnImwQfk3MHOAEMV/I5iEynF2yz0NcAxdHoD1B7FxLDLr6OBiSc4rOSMn9AawXKarDTK9e5mYobQeNQywCl0qg959w2WvbWOvJUyPTaoI7TSD/JI7aFUdDfasuwYG0DLAw2A+c9JAYV/z5yLT4Y4cg6Fa2t8g/INEEjA2hQP1hLA04bSNAHolOH9r/dRdWxgq/FNjJAiRih8t2c2uw2cATtGOve7qcJGhugcIxw6Eun3sH8vc28pkCWPlCuSI1ENDYARV3/Aw2XTu3mtp+8qxu1PlvYPcTYMDL0BflaaGwAUl2zL4UaSqdW+U9RQGPMuyBoY4A77161YxScu6VTuzcs1KkVXRttDFD4GD29TQYjBu3Uiq2NtgbYgCdPqf4wMKeOAht8FmLAnGYYiUE69RzZvSINDOglZibvgjt1TwOY5xuAF49uZ/byPBQtYBTaOnUpSxke10dT2x9Cy/zYVv5UGkAll0ovIV48pLlObICIx2DI3IARbZw63/Q8bmf5XqBs2/uDS/TchlKs0gAU8SKThV2fykvyEXgpRnYVTN3aTo0MO8qluZQtf6OfBE+uiZ1LKg1IxfIWv4yGci8dTXmSVX66ASPqOrUn0DxFomzacjPMnXYSWbkjO5rqZ8CxVMMG7kz8F4lKNtGYefLdUMepNxUVDybeQ50jYzTrIN+BfgZ4mc+VvHy45v9EQr4TOPQbiHcNqecqd2qM92rqbcz6xyl/SAY8DnL4NjPdaD8DFJgPWqtpUIWV87KfhHHS70t8B0Gprk5NHd+G8g3Pejqtq4+LQ+wsEp06X0IrQ08DaNyjbl6BnCr5+OAZ/u0k1XQPeGWvpaxpgpwOpybH0XWuw4bdlMmKbg0h5PRdpOcOJLkz9DQgFX8PmoWsoeey475Eeh5eG9xD3gHQ9V6AIvOdOs9xZTyLLHtfP3tGHtj7vu7BVoe+BtCwypdT5iOUHCXd0XkQ0eWV0PORj1V/UsYN8A3oayArWzo1VYOyH0PWJGW8Z3g/Hg7Tv3HS/5pmq799DbAqgnZC7SlIcI76NKgRbjxPkuiGU67V3pVN20Kexlcdv728aKBPjIcpaz1IcDl9U6YfahmQhLia5E3MhjQiThcM3EcZX90cfht3dEiaCT2P35Ryv5lZ94mvRaZTCLZ3qG0AAn1evBdxPqVAQjbCR98R8h2ND6B3hRAuAy6Plvcx91biMz1KmflO7UhQJCjbRzJpqPOrbYDCaFjBKmgvmzTCx+XPOe//Ac7jQLnz4FdwGBwCP4PYo8z1OMeJl06NmBjseduIkTqfRgYokIZd1+1ZFY9Kka5fuGKcQsFfwPtgI3giQd40X7J/I63KqfUHOwWR9UJjAxSLEU6X7fA+0ubtn2gMTh2fXNwnXKGEvGlOJed6lVM3vlO3MiCqyQdD3P5dSnVg/4XxmEFOz3Cc3BOMQpz3yHBEWz+ULcgAFIkBJTwxvgJdToIObE/6gk00BkfBNP87uIVym4F7QMyEn+/UtR/KBmJA1CJ9UOYcOEK0PEU6UkdIdyUjqzOQVzq1fuBDWXT4ztKzKQM3YFZ0K67cqb1/ZGevFLY4BlQ21zuDUXBVe4RSrnBjxGemGWldw3/KADVE6bNgO/jOeD8spgHlcaLk++nUKH8xDbAHf0cbzzlfQxclLJoBTIHT4CZwA2h0PGhi6aIZ0ESJhZT9BwAA///W0uTzAAAABklEQVQDAGQXQX8yl6wmAAAAAElFTkSuQmCC"

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(759)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  "data-v-075dbba1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _stringify = __webpack_require__(143);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(141);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(460);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(461);

var getters = _interopRequireWildcard(_getters);

var _jsCookie = __webpack_require__(106);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
var store = new _vuex2.default.Store({
		state: {
				token: null,
				count: 2,
				userInfo: null,
				searchQuery: null,
				userId: '',
				language: 'chinese',
				sysMsgCount: 0
		},
		mutations: {
				changeToken: function changeToken(state, newValue) {
						state.token = newValue;
						_jsCookie2.default.set('token', (0, _stringify2.default)(newValue));
				},
				changeCount: function changeCount(state, newValue) {
						state.count = newValue;
						_jsCookie2.default.set('count', (0, _stringify2.default)(newValue));
				},
				changeUserInfo: function changeUserInfo(state, newValue) {
						state.userInfo = newValue;
						_jsCookie2.default.set('userInfo', (0, _stringify2.default)(newValue));
				},
				changeSearchQuery: function changeSearchQuery(state, newValue) {
						state.searchQuery = newValue;
						_jsCookie2.default.set('searchQuery', (0, _stringify2.default)(newValue));
				},
				changeUserId: function changeUserId(state, newValue) {
						state.userId = newValue;
						_jsCookie2.default.set('userId', (0, _stringify2.default)(newValue));
				},
				changeLiveId: function changeLiveId(state, newValue) {
						state.liveId = newValue;
						_jsCookie2.default.set('liveId', (0, _stringify2.default)(newValue));
				},
				changeLanguage: function changeLanguage(state, newValue) {
						state.language = newValue;
				},
				changeSysMsgCount: function changeSysMsgCount(state, newValue) {
						state.sysMsgCount = newValue;
						_jsCookie2.default.set('sysMsgCount', (0, _stringify2.default)(newValue));
				}
		}
});
var data = {};

var token = _jsCookie2.default.get('token');
if (token) {
		data.token = JSON.parse(token);
}
var count = _jsCookie2.default.get('count');
if (count) {
		data.count = JSON.parse(count);
}
var userInfo = _jsCookie2.default.get('userInfo');
if (userInfo) {
		data.userInfo = JSON.parse(userInfo);
}
var searchQuery = _jsCookie2.default.get('searchQuery');
if (searchQuery) {
		data.searchQuery = JSON.parse(searchQuery);
}
var userId = _jsCookie2.default.get('userId');
if (userId) {
		data.userId = JSON.parse(userId);
}
var liveId = _jsCookie2.default.get('liveId');
if (liveId) {
		data.liveId = JSON.parse(liveId);
}
var language = localStorage.getItem('Language');
if (language) {
		var langMap = {
				'cn': 'chinese',
				'en': 'english',
				'tw': 'taiwan',
				'ja': 'japanese',
				'ko': 'korean'
		};
		data.language = langMap[language] || 'chinese';
}
var sysMsgCount = _jsCookie2.default.get('sysMsgCount');
if (sysMsgCount) {
		data.sysMsgCount = JSON.parse(sysMsgCount);
}
store.replaceState(data);

exports.default = store;

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAELklEQVR4AeyZi1XcMBAAj1QQKghUEKgg0AFUEKgAUgFQAVABpALSAaQCSAWhA0gFZMZ4eTrHp/MPzuQdT2tZsrTa0ep7fJj8Z39LoLE7dOmhpYfeuAfe1ZB7enraQNZyffRugAA5AOQW+c37BnFteBdAABxh/RkS4TFeqvHogUqY48Tw/ZWVlfskPfU6aqAKjF7ZBuZyiqCSGC0QMKfYGp4JmBvysmGUQMBcYPUhYnB46Zk7E/NkVECAfESE2SsNbwVjndEAAfIRg66RKoxQZDcLowACxs1SmNhfhHCYGTcjKUstHKgGRtME/OJLW1koUAIjgLanHrnk+1cz28jCgDBWCIeZsTZ/57GJ7CMRWkMtBAgY58o1Vr/AsGHuIY+IG2dnqM5AGLWFHCHXiAdGoiI88DTvjHgLo6cCeVWYcyBiZSvKku4M1RoIgwRxqCju5BodPa1BLr/meToWTNhiLliXAtazDK+TE4yPDdT0i5DfCaoxEMa46Xkc0SANjsY9lvwgoQGKx5N0cgvrXLiijHVTGDuE7PrQBaoRkDA0qTFpb2q8e8UqDe8inoIV89Yp7wR3ovNahJ3i+fzQM1mY52KTCXptpzqnHLaTur9GQFQUJpTY+xqt8XqDz/8GDLlDnBvCWScK6dH0bhP5M2P0VKHUUVt+LhDecZgFjAfETRqYCVJthbLCpN5yyHleqxbNptEjlJ1j++qsLZ8FAkaQGGYq0TMze6e2BTIxxjrqsUPImeygO52H5s0V9NwjoaO2fBaIGnqHqAidYIqaPDBEqF1eIxzFy5DxTCB6UO9EL15ikB7q1XapIxYKl//Q30tvWnkmEIXSVSmMILt3cC6EkrSNyOsV54DitOtxpPEiMM8avKQuh59FP/sYUnJADjnbyk5CC3QQoawWbfg+iOSAXF5tpPfcUUlF/pTpaKNM9o9yQP21L0BDDijG+eor2PWp1BltlMn+UQ4o5s7gExezY+5EG2QNE3JAv8om1tiTBtsvSl0xd36WbQwW5YC8EkRDQ+4XHlhDb7onRV6veCZQuV/E8npAz3qv6dVYqaO47KHohjYGX0FnAtGg4cSHglxhUAwVku1CWddrSFT8Fi9DxlkgelAPxdBzIp+WhrWyoawjTHjZ3xEGXxA0KgtkAcTbYgwNx/8tBoZhfM4Hyrqg+J83O8TCXvy8Svg+uMwFwkvuFdu0HFDC+MPHBcaGkXyeDnzzNO2kTz2jV9Q1XXjA1Fwg2wJKmPTWaXZ4Szh/3RFQca49UECQWABITs559LpTUX9uaASkFqA8dQuRDkE/6TGHld8Ul/h08XAeCnKoDiu8pjQGCiMwysued3uHjr2uwQ7LKKI3zXOFFEQxHd9fNW4NFNYA5j5ir2uwP2WRVYR1nuYdE78ZSNjVGSgUjC1eAo3NI1V7lh6q9sjY0n8BAAD//3wxVcEAAAAGSURBVAMAPxZ9eMLOou4AAAAASUVORK5CYII="

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAYAAADhu0ooAAAEUUlEQVR4AdyYC04UQRCGYSOKqBBCUEMIKjF6AU/iBbyAXsADeAE9gJ7Ai3gBE+MLElFCEFQeoiz/15me7Mz2vLtnZ5ZUbc/0o6q+rp7uGQYzAf6Gw+FAuiBdlt6SbkjvSR+klLp11a1J6cuYIDF5M6pAgSPYdc3dppRyVeWSdF46J00LdQuqvC6lL2Puyxbwiyovqd6LNAZVMGSBIIGjJPCmdrFxW4Sbss+KaAxcOyAFMCclA+iygqptS2PzhBXRGLhWcAJcUWR3pMy8ilbEAuO7ssNKoAIkixvygrNKYzXGl6woDjaxSsu5dLAyvqhIySIbiy4nKmxidxUTj0ypQEqByiAZZHMo1b+U5+adiGU1iq3QGp1zO0WGAM3tN8FGlnJhfLmgPYC081sImwkqSNZ/4UxZTx0ogWUfcYbiBBUkD3ufIC3cTcXu3I2doBrFS0BWm5o7K8S85oqOhkS9ZoRMktFEfY9u5iOGRMgJUHUAENBEpx7e8HGRWMIJUAFNA6QwZuDi3OfaKBXmIspm5q5lOvXrh6+qqzbkGFQVE8ymvIcRvnONZQPaYjafyeu7SJ+rDC1LYjOM5kfe4hTrOpQA9lTGb0T6RCX3KoIJfHzemYcWL208m49xlFJgU1Xeb69hkf/zQN3GBzSZxOeotjHBnKsDILvwfTkK7/saxivmx7flDtqbB7SNjWjS7JcBRScdSGj/JqO83/pyZM/J9zKYVlU5Jd2Pe85ajiPngBqVZjPyBUpgnIuu3bVqbNjg6MFe1bGu/nM+l63rnHQ5rVIHbJX+mX19gmY66UKDT9DXAYDe+rIJ6JknY69k5430l7SpYOOljLyQ+pAzQP/7sBTZILBHun7oUFU5xdUXG0ycc0CNSgP6t8bAvg05J6OnfYu6RrzHgJ4UDZyC9hNAyej5FMDkIZwOZmdngWwjq+yk6WAO0xUB7o9gJKPY/sNPYHWds97OyZzYzWRa0AN1JLMqggnHhT1nya7PczIv6CMaDSip1Q2wKoKKPWd9n5NZQR+I7R+NBpQL6W/ptMmeBYpBRX6sSpNmldMgcTaBiUG5kX6Xhn5W5aIVibOJtwSossoL/j4NPdc9sZhn03IkQKlUB2aijXMVdyH0LGJI2B4DjVq/qezjEibmLcU+Jk5QzQhL+MdY7+5XjC1ZG7ITlEbB8kbBMua2Dwpk5v6SCQqZYAFFue2yApkbZy4oZD2ALYSEoxCUThEszywPO1VdUGLZiWIrjKcUKFZk8KfKL1I2KhWty6hDjr/Piol9ZLQ+87o0KBZkmDPqk65znwe1hxKyyFL9qlgSLwRFDiuBWmNyAijApWfUjm1Q8h5OFvFd2UwtULwIluzu6DokMBnkyNiSv21ppSwqtlhqg1oLcj4KDDgzb5vrlMBhY1eDP8r+rpQvK93Wl8ag1rWCAfhQ5bbqPkh5FSNYvnMJ3LWJUcfGwkc/fRkDHNnbly2gZaq5XAAAAP//kp8ZigAAAAZJREFUAwC2PFHR8X7oiwAAAABJRU5ErkJggg=="

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAYAAADhu0ooAAAD/UlEQVR4AdyYy27UMBSGpyNKh4JaVVUBVVWBCiF2sIIdj8OOp2HH67CCFTs2iFsrUaiq0gp6YaDD/1lxNJlkcrMzk7g6Z+w4zvH/+ThO0n6vgb/RaNSXL8vX5Lfk2/J78gcTTtuW2jbl9OWaRjR5CyqhwCF2S3O3I6fcULkqH8gX5ZNG27Iab8jpyzX3FQv4FZVX1O7FnEElhiwgEjhKhLvGJcZtEe4oPivCGbi2IAlYlJMBfE2iasfStXnGinAGriVOgOtSdkfOzKuYiVlgxq48YCVQAZLFbY3CYJWu1TW+bF062MQqLefSYhV8RUrJIhuLqnM1NrG70sQtU0pIKVAFJINsDqX6lxrZvRNaNiJthdHonNspCgRobr85nmQpF+rLBe0ApJ3fQtipoIJk/RfOlB2pBSWw7COZUjJBBcnN3iVIC3dT2jN340xQXcVLwLRzOt1aQ/NmljpOJNo1I2SSjCbaO3QwiBgSkhOg6gAgoIlOHTzg4yKxhBOgAgoBUhg9uHjuUzdOg6lE2Zy6a5lO3frhq+qalRyDqmGO2dTozRjfuSayAQ0wmwZOP6tiM4zmRw1xilUPyeDj887ctICFdG/CM+7XOeD/PFDP8gOacWfpPFf7QLbh+7JJcBiXzE+To7Qk9gDQUDei8Tm+Cig+3hhi3WSU91tfcE8V6Ln8haMT45li+DKzGfkCRdgTKVuSuxoxHikI8VQ426LPZfvQWU46wON0U70Wn6D1FMzoKp+g7xrQ/N5XTECHnoK9VRxgL1S6GjHeKMhruQ8bAvrPR6QoBsJeqf7S0YnBxCmMFzOgf7yEaneQSzLKMmm3THd1Z4CeF8UJ4Pw5oGT0MgCYPISL/sLCApAhZ/UURjLKTPzmJ1A/gcuCHuuAzKoIzk4hMqCkVgfAqgjKjsX2FyIDSkX+Sx6aHVqgGFTkZ2o0aVYZgsXZBCYG5UD+XR7KvRpnU0zx/3Wp95RVXvCPzEG3fw7FYu5NizGZUWCZiS4/V4eChMEymjIFalp7vW8qu7iE0bwr7SnLBNWMsIR/pHq3vyG1ZK3kTFBOCpY3itQS4FxLHcip+8tUUGAECyjOYZsdyFyduaCQdQC2EBKOQlA6RbDcs9zsNLXB0bIfaSvUUwqUKAr4U+UXORuVipnb+IA8/j5LE/vIePvUemlQIigwz6hPqufeDzrflJFFlupXaUm8EBQNWAnUBtMggAJcekbttQ4l7+FkkbErh6kFyiiCJbv7qjcJTAZ5ZOxqvD15pSxKW2y1QW0EDT4ODDgzb0/XKYEjxoEu/qj4B3K+rHRY35xB7dASA/CJyj21fZDzKoZYvnMRnrWJ0cbGwkc/fbkGOLJ3pFhAK5S7/QcAAP//Aaj7MwAAAAZJREFUAwAurknR9QbVBwAAAABJRU5ErkJggg=="

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADVklEQVR4AeyYv2sUQRzF50QhhUUKLewEFVMYMFiaRhQUtPEvUCtN5YkKioIIgoKRaGUaQUs7ywgKFim0MhCLgBEshBQKWgYUzs9bZ45ddnazezezm+CF79v59Z35vjczmb2dbWaL/40EtL2AUVeg1+uNge0xRUYTAPGjEF8TbJ5seIsiwBJegO442AUWbB3ZsBZcgCUq8jtTVJWPIiKoAA95CRGkJYqIYAIKyJ+FuRBNRBABReQ7nc66EFPE0ALKyEM8sZgihhLgIb8I4wtA5/847X2oDqhNPmRNkP+JUgEQ2Aeegs/gN8gYLERGRMgmNs1TZ/9PUh/UJh+aE1Pfxcyg/wqKpZgPKR5MPAsehQLoeJk+n8AlsB9EfaMyftoUSzGvUbkEl6ukXvMKsB0e02MMyP7wkJgl0iagWOvEkonDLJw0oSpnkBOAo5bsXspLQnbzjzgJphrCJPH3gHng7AHctCqunKQ5AdRqy0g1WTMP4SvglwpNQjHBDDE1gSRGnHJbySfgjLyBlvAmadt2FwLawiTmhB5p+ATstQ6rzEDjM29j9xPLYcVWOG62aIxPgE4AOTjVyrcNx8Vx6/PxCeg3boVMDQGbU85IQNvrMtAK8EI5Ds6V4EhTwmoLgPRJyL0Bz0vwHr/ckYd/cKstAAbuSCNbarkjr9R7wMbaAnixvCXWKXC+BNP4rdIe3WoLECPIvQYvSvBBfk1gIAFNEKsa4/8UwAlzEcwFwC3G0M/kqhOe86u9AgQ8zSj60OiSDgt9OHm/tBi7ktUWwKg/QNWjFNcN7euGHiUOtQVw8uiEmWDMYwGgT9SXjDOw+QS42S18ESHiC3gXALogqELecXHc+n18Ar7Z1gn2u67HbbGdxHJwH/O57eYT4C5ipfpOO7QzUe9TcifVK/IZ8wl4hIc+6ElMlxnQzVzjK0FcXUvOQUK3JCRGnJ4pk0ZOAPtav2FupJw0wBoDLoOPDWGZ+N+BjmmSxG7DzX3cJxV65ASoEscnpLrWk2qyRkt4iMzhhqBY2sKEM+LQhZN2hsoZeAXIw3aYIj8LtCq5E4D6WKZYiqkXpm4ENaHeWIUC5I2IFXAdHAA7QDUb3kuxFHOGoSREdLwoFeDtsckqRwLaXpDRCrS9An8BAAD//2QhcagAAAAGSURBVAMAfGcufxGuzG4AAAAASUVORK5CYII="

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(757)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  "data-v-06850c3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  "data-v-241a2e81",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(960);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(958);

var _2 = _interopRequireDefault(_);

var _zhibodaping = __webpack_require__(983);

var _zhibodaping2 = _interopRequireDefault(_zhibodaping);

var _Home = __webpack_require__(959);

var _Home2 = _interopRequireDefault(_Home);

var _shouye = __webpack_require__(969);

var _shouye2 = _interopRequireDefault(_shouye);

var _zhibo = __webpack_require__(976);

var _zhibo2 = _interopRequireDefault(_zhibo);

var _zhibojilu = __webpack_require__(978);

var _zhibojilu2 = _interopRequireDefault(_zhibojilu);

var _wode = __webpack_require__(971);

var _wode2 = _interopRequireDefault(_wode);

var _zhibojian = __webpack_require__(977);

var _zhibojian2 = _interopRequireDefault(_zhibojian);

var _bofangshipin = __webpack_require__(961);

var _bofangshipin2 = _interopRequireDefault(_bofangshipin);

var _liushuijilu = __webpack_require__(966);

var _liushuijilu2 = _interopRequireDefault(_liushuijilu);

var _zhibozhongxin = __webpack_require__(982);

var _zhibozhongxin2 = _interopRequireDefault(_zhibozhongxin);

var _huifang = __webpack_require__(964);

var _huifang2 = _interopRequireDefault(_huifang);

var _tijiaoshenqing = __webpack_require__(970);

var _tijiaoshenqing2 = _interopRequireDefault(_tijiaoshenqing);

var _shenqingjilu = __webpack_require__(968);

var _shenqingjilu2 = _interopRequireDefault(_shenqingjilu);

var _zhibojinyao = __webpack_require__(979);

var _zhibojinyao2 = _interopRequireDefault(_zhibojinyao);

var _youjiantongzhi = __webpack_require__(975);

var _youjiantongzhi2 = _interopRequireDefault(_youjiantongzhi);

var _kaishizhibo = __webpack_require__(965);

var _kaishizhibo2 = _interopRequireDefault(_kaishizhibo);

var _zhiboshangpin = __webpack_require__(980);

var _zhiboshangpin2 = _interopRequireDefault(_zhiboshangpin);

var _zhibozhong = __webpack_require__(981);

var _zhibozhong2 = _interopRequireDefault(_zhibozhong);

var _wodequanbao = __webpack_require__(973);

var _wodequanbao2 = _interopRequireDefault(_wodequanbao);

var _chongzhierweima = __webpack_require__(963);

var _chongzhierweima2 = _interopRequireDefault(_chongzhierweima);

var _chongzhichenggong = __webpack_require__(962);

var _chongzhichenggong2 = _interopRequireDefault(_chongzhichenggong);

var _querentbi = __webpack_require__(967);

var _querentbi2 = _interopRequireDefault(_querentbi);

var _wodeqianbao = __webpack_require__(972);

var _wodeqianbao2 = _interopRequireDefault(_wodeqianbao);

var _yonghuzhuye = __webpack_require__(974);

var _yonghuzhuye2 = _interopRequireDefault(_yonghuzhuye);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '首页',
    leaf: true,
    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670575807654.undefined',
    selectedIconCls: 'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17824522768521047.png',
    children: [{ path: '/shouye', component: _shouye2.default, name: '首页', meta: { CnName: '首页', EnName: 'Home', TwName: '首頁', JaName: 'ホーム', KoName: '홈', keepAlive: true } }]
}, {
    path: '/',
    component: _Home2.default,
    name: '直播',
    leaf: true,
    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670576515180.undefined',
    selectedIconCls: 'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17824522983621238.png',
    children: [{ path: '/zhibojilu', component: _zhibojilu2.default, name: '直播', meta: { CnName: '直播', EnName: 'Live', TwName: '直播', JaName: 'ライブ', KoName: '라이브' } }]
}, {
    path: '/',
    component: _Home2.default,
    name: '我的',
    leaf: true,
    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670576903559.undefined',
    selectedIconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/1767057707558124.undefined',
    children: [{ path: '/wode', component: _wode2.default, name: '我的', meta: { CnName: '我的', EnName: 'My', TwName: '我的', JaName: 'マイページ', KoName: '마이페이지' } }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    hidden: true,
    children: [{ path: '/liushuijilu', component: _liushuijilu2.default, name: 'liushuijilu', hidden: true }, { path: '/zhibozhongxin', component: _zhibozhongxin2.default, name: 'zhibozhongxin', hidden: true }, { path: '/huifang', component: _huifang2.default, name: 'huifang', hidden: true }, { path: '/tijiaoshenqing', component: _tijiaoshenqing2.default, name: 'tijiaoshenqing', hidden: true }, { path: '/shenqingjilu', component: _shenqingjilu2.default, name: 'shenqingjilu', hidden: true }, { path: '/zhibojinyao', component: _zhibojinyao2.default, name: 'zhibojinyao', hidden: true }, { path: '/youjiantongzhi', component: _youjiantongzhi2.default, name: 'youjiantongzhi', hidden: true }, { path: '/kaishizhibo', component: _kaishizhibo2.default, name: 'kaishizhibo', hidden: true }, { path: '/zhiboshangpin', component: _zhiboshangpin2.default, name: 'zhiboshangpin', hidden: true }, { path: '/zhibozhong', component: _zhibozhong2.default, name: 'zhibozhong', hidden: true }, { path: '/wodequanbao', component: _wodequanbao2.default, name: 'wodequanbao', hidden: true }, { path: '/chongzhierweima', component: _chongzhierweima2.default, name: 'chongzhierweima', hidden: true }, { path: '/chongzhichenggong', component: _chongzhichenggong2.default, name: 'chongzhichenggong', hidden: true }, { path: '/querentbi', component: _querentbi2.default, name: 'querentbi', hidden: true }, { path: '/wodeqianbao', component: _wodeqianbao2.default, name: 'wodeqianbao', hidden: true }, { path: '/yonghuzhuye', component: _yonghuzhuye2.default, name: 'yonghuzhuye', hidden: true }, { path: '/bofangshipin', component: _bofangshipin2.default, name: 'bofangshipin', hidden: true }]
}, {
    path: '/zhibojian',
    name: 'zhibojian',
    component: _zhibojian2.default,
    hidden: true
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLogin = toLogin;
exports.sendSmsCode = sendSmsCode;
exports.toForgetPassword = toForgetPassword;
exports.toRegister = toRegister;
exports.getAllCountry = getAllCountry;

var _request = __webpack_require__(60);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toLogin(data) {
  return (0, _request2.default)({
    url: '/app-api/auth/toLogin/v1_0_0',
    method: 'post',
    data: data
  });
}
function sendSmsCode(data) {
  return (0, _request2.default)({
    url: '/app-api/service/common/sendSmsCode/v1_0_0',
    method: 'post',
    data: data
  });
}
function toForgetPassword(data) {
  return (0, _request2.default)({
    url: '/app-api/auth/toForgetPassword/v1_0_0',
    method: 'post',
    data: data
  });
}
function toRegister(data) {
  return (0, _request2.default)({
    url: '/app-api/auth/toRegister/v1_0_0',
    method: 'post',
    data: data
  });
}
function getAllCountry(query) {
  return (0, _request2.default)({
    url: '/app-api/service/common/getAllCountry/v1_0_0',
    method: 'get',
    params: query
  });
}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(61);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _all;

var _zhCN = __webpack_require__(191);

var _zhCN2 = _interopRequireDefault(_zhCN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	all: (_all = {
		jiantizhongwen: '简体中文',
		fantizhongwen: '繁体中文',
		yingwen: '英文',
		ribenyu: '日文',
		hanguoyu: '韩文',
		jizhuzhanghao: '记住账号',
		jizhumima: '记住密码',
		jizhuzhanghaomima: '记住账号密码',
		yuyanxuanze: '语言选择',
		shezhi: '设置',
		xiugaimima: '修改密码',
		yinsizhengce: '隐私政策',
		guanyuwomen: '关于我们',
		mimashuoming: '密码必须是8-20位大小写字母和数字组合，不能是纯数字或纯字母',
		qingshurujiumima: '请输入旧密码',
		qingshuruxinmima: '请输入新密码',
		quedingxiugai: '确定修改',

		shouye: '首页',
		zhibo: '直播',
		wode: '我的',
		xitongxiaoxi: '系统消息',
		wodedingdan: '我的订单',
		bangzhufankui: '帮助反馈',
		xiugaiziliao: '修改资料',
		xiaofeimingxi: '消费明细',
		zhibojilu: '直播记录',
		tijiao: '提交',
		caozuochenggong: '操作成功',
		tishi: '提示',
		quedingtuichudenglu: '确定退出登录吗？',
		queding: '确定',
		wentibangzhu: '问题帮助',
		woyaofankui: '我要反馈',
		fankuiwenti: '反馈问题',
		qingmiaoshuniyaofankuidewenti: '请描叙你要反馈的问题...',
		sousuo: '搜索',
		sousuoniganxingqudeneirong: '搜索你感兴趣的内容',
		zhibojianbiaoti: '直播间标题',
		zhibojianbeijing: '直播间背景',
		zhibojianfengmian: '直播间封面',
		xuanzebackground: '选择背景',
		shangchuanbeijing: '上传背景',
		yixuanze: '已选择',
		qingxuanzebeijing: '请选择背景',
		xietongzhiboweiqidong: '协同直播功能未启动',
		zhibojianbiaoqian: '直播间标签',
		zhibojianhuazhi: '直播间画质',
		geinidezhibojianqugemingziba: '给你的直播间取一个名字吧~',
		qingshurukaibomiyao: '请输入开播秘钥',
		kaishizhibo: '开始直播',
		shengyin: '声音',
		liwutexiao: '礼物特效',
		gengduo: '更多',
		gouwuche: '购物车',
		zaixianguanzhong: '在线观众',
		danmushuoming: '平台严禁未成年人充值打赏，严禁以陪玩等方式诱导打赏私下交易，严禁涉黄涉政、谩骂等内容，请注意财产安全，谨防网络诈骗，理性消费。',
		tianjiaguanliyuan: '添加管理员',
		jinyan: '禁言',
		jiechuejinyan: '解除禁言',
		tichufangjian: '踢出房间',
		shangpinxiangqing: '商品详情',
		lijijiagou: '立即加购',
		xuanzeguige: '选择规格',
		quanbuliwu: '全部礼物',
		ge: '个',
		bi: '币',
		guanliyuan: '管理员',
		kuaijieduanyu: '快捷短语',
		gonggao: '公告',
		xinzengkuaijieduanyu: '新增快捷短语',
		qingshuru: '请输入',
		qingshuruzhengque: '请输入正确的金额',
		shuru: '输入',
		wangjimima: '忘记密码',
		youxiangzhuce: '邮箱注册',
		huoquyanzhengma: '获取验证码',
		youxiang: '邮箱',
		yanzhengma: '验证码',
		anquanyanzheng: '安全验证',
		fasongyanzhengma: '发送验证码',
		qingshuruyouxiangyanzhengma: '请输入邮箱验证码',
		fasongchenggong: '发送成功',
		qingshuruningdeyouxiangzhanghao: '输入您的邮箱账号',
		qingshuruyanzhengma: '请输入验证码',
		qingshurumima: '请输入密码',
		mimadenglu: '密码登录',
		woyiyuedubingtongyi: '我已阅读并同意',
		yonghuxieyi: '用户协议',
		yinsixieyi: '隐私协议',
		denglu: '登录',
		chongxindenglu: '重新登陆',
		xiayibu: '下一步',
		haimeizhanghao: '还没有账号',
		quzhuce: '去注册',
		yiyouzhanghao: '已有账号',
		qudenglu: '去登录',
		shezhijibenxinxi: '设置基本信息',
		nichengtishi: '仅支持字母、数字和标点符号，最少6位，不能使用空格',
		shezhiyonghuming: '设置用户名',
		yonghumingtishi: '用户名为6-18位，大小写字母或数字',
		shezhijiaoyimima: '设置交易密码',
		jiaoyimimatishi: '交易密码必须是6位数字组合',
		qingxuanze: '请选择',
		yaoqingma: '邀请码（选填）',
		qingshuruyaoqingma: '输入邀请码',
		shezhixinmima: '设置新密码',
		xuanzeningdeguojia: '选择您的国家',
		zhuce: '注册',
		qingshuruyonghuming: '请输入用户名',
		gaoqinghuazhi: '高清画质',
		biaoqinghuazhi: '标清画质',
		chaoqinghuazhi: '超清画质',
		putonghuazhi: '普通画质'
	}, (0, _defineProperty3.default)(_all, 'kaishizhibo', '开始直播'), (0, _defineProperty3.default)(_all, 'zengsong', '赠送'), (0, _defineProperty3.default)(_all, 'jinrulezhibojian', '进入直播间'), (0, _defineProperty3.default)(_all, 'shuodianshenmene', '说点什么呢...'), (0, _defineProperty3.default)(_all, 'zanwushuju', '暂无数据'), (0, _defineProperty3.default)(_all, 'songgei', '送给'), (0, _defineProperty3.default)(_all, 'huifang', '回放'), (0, _defineProperty3.default)(_all, 'quedingtuichudengluma', '确定退出登录吗?'), (0, _defineProperty3.default)(_all, 'xunibi', '虚拟币'), (0, _defineProperty3.default)(_all, 'quanbu', '全部'), (0, _defineProperty3.default)(_all, 'appxiazai', 'APP下载'), (0, _defineProperty3.default)(_all, 'dingdanjine', '订单金额'), (0, _defineProperty3.default)(_all, 'dingdanbianhao', '订单编号'), (0, _defineProperty3.default)(_all, 'chuangjianshijian', '创建时间'), (0, _defineProperty3.default)(_all, 'zhubozanshilikai', '主播暂时离开'), (0, _defineProperty3.default)(_all, 'mashanghuilai', '马上回来'), (0, _defineProperty3.default)(_all, 'guojianzhuoxiazai', '国际安卓下载'), (0, _defineProperty3.default)(_all, 'anzhuoxiazai', '安卓下载'), (0, _defineProperty3.default)(_all, 'guojipingguoxiazai', '国际苹果下载'), (0, _defineProperty3.default)(_all, 'pingguoxiazai', '苹果下载'), (0, _defineProperty3.default)(_all, 'weixiazai', '暂无下载'), (0, _defineProperty3.default)(_all, 'quanbushangpin', '全部商品'), (0, _defineProperty3.default)(_all, 'yiqiangguang', '已抢光'), (0, _defineProperty3.default)(_all, 'jiagou', '加购'), (0, _defineProperty3.default)(_all, 'shangpinxiangqing', '商品详情'), (0, _defineProperty3.default)(_all, 'lijijiagou', '立即加购'), (0, _defineProperty3.default)(_all, 'yixuan', '已选'), (0, _defineProperty3.default)(_all, 'xuanzeguiige', '选择规格'), (0, _defineProperty3.default)(_all, 'xuazeguige', '选择规格'), (0, _defineProperty3.default)(_all, 'shangchuanzhong', '上传中'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', '上传失败'), (0, _defineProperty3.default)(_all, 'browserbu\u652F\u6301', '您的浏览器不支持媒体设备访问'), (0, _defineProperty3.default)(_all, 'qingkaiqi', '请开启摄像头和麦克风权限'), (0, _defineProperty3.default)(_all, 'meiyoushebei', '未检测到摄像头或麦克风设备'), (0, _defineProperty3.default)(_all, 'shebeibeizhan', '设备被其他程序占用，请关闭后重试'), (0, _defineProperty3.default)(_all, 'quxianchengong', '获取媒体权限失败'), (0, _defineProperty3.default)(_all, 'shifouquedingjieshuzhibo', '是否确定关闭直播？'), (0, _defineProperty3.default)(_all, 'qingyuedubingtongyiyonghuxieyiheyinsixieyi', '请阅读并同意用户协议和隐私协议！'), (0, _defineProperty3.default)(_all, 'quedingqudengluma', '确定去登录吗？'), (0, _defineProperty3.default)(_all, 'remen', '热门'), (0, _defineProperty3.default)(_all, 'pinglun', '评论'), (0, _defineProperty3.default)(_all, 'huifu', '回复'), (0, _defineProperty3.default)(_all, 'shanchu', '删除'), (0, _defineProperty3.default)(_all, 'chakanhuifu', '查看回复'), (0, _defineProperty3.default)(_all, 'jiazaizhong', '加载中'), (0, _defineProperty3.default)(_all, 'jiazaigengduo', '加载更多'), (0, _defineProperty3.default)(_all, 'meiyougengduo', '没有更多了'), (0, _defineProperty3.default)(_all, 'shuodianshenme', '发送一条评论吧...'), (0, _defineProperty3.default)(_all, 'fasong', '发送'), (0, _defineProperty3.default)(_all, 'fabiao', '发表'), (0, _defineProperty3.default)(_all, 'ganggang', '刚刚'), (0, _defineProperty3.default)(_all, 'fenzhongqian', '{n}分钟前'), (0, _defineProperty3.default)(_all, 'xiaoshiqian', '{n}小时前'), (0, _defineProperty3.default)(_all, 'tianqian', '{n}天前'), (0, _defineProperty3.default)(_all, 'shanchupinglun', '确定删除该评论吗？'), (0, _defineProperty3.default)(_all, 'duanyingyin', '短视频'), (0, _defineProperty3.default)(_all, 'wofabu', '我发布的'), (0, _defineProperty3.default)(_all, 'wodianzan', '我点赞的'), (0, _defineProperty3.default)(_all, 'woshoucang', '我收藏的'), (0, _defineProperty3.default)(_all, 'fabuduanyingyin', '发布短影音'), (0, _defineProperty3.default)(_all, 'zhibohuaxu', '直播花絮'), (0, _defineProperty3.default)(_all, 'qingshurubiaoti', '请输入标题'), (0, _defineProperty3.default)(_all, 'shangchuanduanyingyin', '上传短影音'), (0, _defineProperty3.default)(_all, 'yonghuzhuye', '个人主页'), (0, _defineProperty3.default)(_all, 'guanzhuta', '关注Ta'), (0, _defineProperty3.default)(_all, 'yiguanzhu', '已关注'), (0, _defineProperty3.default)(_all, 'guanzhu', '关注'), (0, _defineProperty3.default)(_all, 'fensi', '粉丝'), (0, _defineProperty3.default)(_all, 'guanzhong', '关注中'), (0, _defineProperty3.default)(_all, 'huguan', '互关'), (0, _defineProperty3.default)(_all, 'shanchuguanzhu', '删除关注'), (0, _defineProperty3.default)(_all, 'yichufensi', '移除粉丝'), (0, _defineProperty3.default)(_all, 'huiyuanid', '会员ID:'), (0, _defineProperty3.default)(_all, 'zhibozhongxin', '直播中心'), (0, _defineProperty3.default)(_all, 'zongzichanguzhi', '总资产估值'), (0, _defineProperty3.default)(_all, 'liushuijilu', '流水记录'), (0, _defineProperty3.default)(_all, 'chongbi', '充币'), (0, _defineProperty3.default)(_all, 'tibi', '提币'), (0, _defineProperty3.default)(_all, 'gaibizhongbuzhichichongzhi', '该币种暂不支持充值'), (0, _defineProperty3.default)(_all, 'gaibizhongbuzhichitibi', '该币种暂不支持提币'), (0, _defineProperty3.default)(_all, 'dashang', '打赏'), (0, _defineProperty3.default)(_all, 'riqi', '日期'), (0, _defineProperty3.default)(_all, 'leixing', '类型'), (0, _defineProperty3.default)(_all, 'miaoshu', '描述'), (0, _defineProperty3.default)(_all, 'jine', '金额'), (0, _defineProperty3.default)(_all, 'zhuangtai', '状态'), (0, _defineProperty3.default)(_all, 'yiwancheng', '已完成'), (0, _defineProperty3.default)(_all, 'shenhezhong', '审核中'), (0, _defineProperty3.default)(_all, 'shenhejujue', '审核拒绝'), (0, _defineProperty3.default)(_all, 'tibibeibohui', '提币被驳回'), (0, _defineProperty3.default)(_all, 'zhidaole', '知道了'), (0, _defineProperty3.default)(_all, 'bohuiyuanyin', '驳回原因：'), (0, _defineProperty3.default)(_all, 'kaishiriqi', '开始日期'), (0, _defineProperty3.default)(_all, 'jieshuriqi', '结束日期'), (0, _defineProperty3.default)(_all, 'wangluo', '网络'), (0, _defineProperty3.default)(_all, 'dizhi', '地址'), (0, _defineProperty3.default)(_all, 'tibishuliang', '提币数量'), (0, _defineProperty3.default)(_all, 'daozhangshisuan', '到账试算'), (0, _defineProperty3.default)(_all, 'shouxufei', '手续费'), (0, _defineProperty3.default)(_all, 'meiridaozhang', '每日到账'), (0, _defineProperty3.default)(_all, 'keyong', '可用'), (0, _defineProperty3.default)(_all, 'dongjie', '冻结'), (0, _defineProperty3.default)(_all, 'zuixiaotibishuliang', '最小提币数量'), (0, _defineProperty3.default)(_all, 'shouxufeibilv', '手续费'), (0, _defineProperty3.default)(_all, 'meirishenyueddu', '每日剩余额度'), (0, _defineProperty3.default)(_all, 'shenqingzhibo', '申请直播'), (0, _defineProperty3.default)(_all, 'shenqingjilu', '申请记录'), (0, _defineProperty3.default)(_all, 'huifangjilu', '回放记录'), (0, _defineProperty3.default)(_all, 'yikaifang', '已开放'), (0, _defineProperty3.default)(_all, 'guankanhuifang', '观看回放'), (0, _defineProperty3.default)(_all, 'beisu', '倍数'), (0, _defineProperty3.default)(_all, 'zhiboriqi', '直播日期'), (0, _defineProperty3.default)(_all, 'shijianshiduan', '时间时段'), (0, _defineProperty3.default)(_all, 'shoujizhibo', '手机直播'), (0, _defineProperty3.default)(_all, 'zhibodaihuo', '直播带货'), (0, _defineProperty3.default)(_all, 'kaiqi', '开启'), (0, _defineProperty3.default)(_all, 'guanbi', '关闭'), (0, _defineProperty3.default)(_all, 'beizhu', '备注'), (0, _defineProperty3.default)(_all, 'huodongzhuti', '活动主题、设备说明'), (0, _defineProperty3.default)(_all, 'shenqinghouliucheng', '申请后流程'), (0, _defineProperty3.default)(_all, 'shenqinghouliuchengdesc', '后台审核通过后，将邮件发送直播会铃定直播地址。'), (0, _defineProperty3.default)(_all, 'daishenhe', '待审核'), (0, _defineProperty3.default)(_all, 'tijiaoshenqing', '提交申请'), (0, _defineProperty3.default)(_all, 'qingxuanzeriqi', '请选择直播日期'), (0, _defineProperty3.default)(_all, 'qingxuanzeshijian', '请选择时间时段'), (0, _defineProperty3.default)(_all, 'tijiaochenggong', '提交成功'), (0, _defineProperty3.default)(_all, 'nian', '年'), (0, _defineProperty3.default)(_all, 'yue', '月'), (0, _defineProperty3.default)(_all, 'tongshiduanbukezhongfu', '同时段不可重复'), (0, _defineProperty3.default)(_all, 'keshenqingshiduan', '可申请时段'), (0, _defineProperty3.default)(_all, 'querenShiduan', '确认时段'), (0, _defineProperty3.default)(_all, 'zhanghaoid', '账号 ID'), (0, _defineProperty3.default)(_all, 'qingtianxie', '请填写'), (0, _defineProperty3.default)(_all, 'zhou1', '一'), (0, _defineProperty3.default)(_all, 'zhou2', '二'), (0, _defineProperty3.default)(_all, 'zhou3', '三'), (0, _defineProperty3.default)(_all, 'zhou4', '四'), (0, _defineProperty3.default)(_all, 'zhou5', '五'), (0, _defineProperty3.default)(_all, 'zhou6', '六'), (0, _defineProperty3.default)(_all, 'zhou7', '日'), (0, _defineProperty3.default)(_all, 'shenqingyitijiao', '申请已提交'), (0, _defineProperty3.default)(_all, 'shenqingtijiaodesc', '直播管理员将审核直播间、时段和带货资料。'), (0, _defineProperty3.default)(_all, 'chakanshenheJilu', '查看审核记录'), (0, _defineProperty3.default)(_all, 'shenqingriqi', '申请日期'), (0, _defineProperty3.default)(_all, 'zhiboshijianduan', '直播时间段'), (0, _defineProperty3.default)(_all, 'zhiboleixing', '直播类型'), (0, _defineProperty3.default)(_all, 'daihuo', '带货'), (0, _defineProperty3.default)(_all, 'yitongguo', '已通过'), (0, _defineProperty3.default)(_all, 'weitongguo', '未通过'), (0, _defineProperty3.default)(_all, 'xiangqing', '详情'), (0, _defineProperty3.default)(_all, 'yuanyin', '原因'), (0, _defineProperty3.default)(_all, 'shenqingxiangqing', '申请详情'), (0, _defineProperty3.default)(_all, 'shenheyuanyin', '审核原因'), (0, _defineProperty3.default)(_all, 'xutiaozheng', '需调整'), (0, _defineProperty3.default)(_all, 'shenheyuanyindesc', '该时段直播间已被占用，请重新选择直播日期或时间段后再次提交。'), (0, _defineProperty3.default)(_all, 'wancheng', '完成'), (0, _defineProperty3.default)(_all, 'chulizhong', '处理中'), (0, _defineProperty3.default)(_all, 'daichuli', '待处理'), (0, _defineProperty3.default)(_all, 'houtaishenhe', '后台审核'), (0, _defineProperty3.default)(_all, 'chanshengmiyao', '产生金钥'), (0, _defineProperty3.default)(_all, 'youjiankuaidi', '邮件通知'), (0, _defineProperty3.default)(_all, 'kechakan', '可查看'), (0, _defineProperty3.default)(_all, 'jinwanxinpinfuli', '今晚新品福利直播'), (0, _defineProperty3.default)(_all, 'chehuishenqing', '撤回申请'), (0, _defineProperty3.default)(_all, 'chongxinshenqing', '重新申请'), (0, _defineProperty3.default)(_all, 'zhibojinyao', '直播金钥'), (0, _defineProperty3.default)(_all, 'zhibojian', '直播间'), (0, _defineProperty3.default)(_all, 'keyongshiduan', '可用时段'), (0, _defineProperty3.default)(_all, 'youxiao', '有效'), (0, _defineProperty3.default)(_all, 'tuiliudizhi', '推流地址'), (0, _defineProperty3.default)(_all, 'tuiliumamiyao', '推流码/秘钥'), (0, _defineProperty3.default)(_all, 'youjiantongzhidesc', '同直播间同时段不会重复生成金钥。'), (0, _defineProperty3.default)(_all, 'yifasong', '已发送'), (0, _defineProperty3.default)(_all, 'fuzhiquanbu', '复制全部'), (0, _defineProperty3.default)(_all, 'fuzhichenggong', '复制成功'), (0, _defineProperty3.default)(_all, 'youjiantongzhi', '邮件通知'), (0, _defineProperty3.default)(_all, 'zhiboshenhetongguo', '直播审核通过'), (0, _defineProperty3.default)(_all, 'shoujianren', '收件人'), (0, _defineProperty3.default)(_all, 'youjianneirongdesc', '内容包含直播间、可用时段、推拉流地址、密钥和开播前设置入口'), (0, _defineProperty3.default)(_all, 'youjianbianhao', '邮件编号'), (0, _defineProperty3.default)(_all, 'chongxinfasong', '重新发送'), (0, _defineProperty3.default)(_all, 'yinyuedaren', '音乐达人'), (0, _defineProperty3.default)(_all, 'wudaodaren', '舞蹈达人'), (0, _defineProperty3.default)(_all, 'yanzhi', '颜值'), (0, _defineProperty3.default)(_all, 'jichushezhi', '基础设置'), (0, _defineProperty3.default)(_all, 'yishangchuan', '已上传'), (0, _defineProperty3.default)(_all, 'zhiboshangpin', '直播商品'), (0, _defineProperty3.default)(_all, 'laiziyunimall', '来自 UNImall 商城控制'), (0, _defineProperty3.default)(_all, 'jian', '件'), (0, _defineProperty3.default)(_all, 'zhiboliucheng', '直播流程'), (0, _defineProperty3.default)(_all, 'liuchang', '流畅'), (0, _defineProperty3.default)(_all, 'gaoqing', '高清'), (0, _defineProperty3.default)(_all, 'chaoqing', '超清'), (0, _defineProperty3.default)(_all, 'languang', '蓝光'), (0, _defineProperty3.default)(_all, 'tongguo', '通过'), (0, _defineProperty3.default)(_all, 'jinxingzhong', '进行中'), (0, _defineProperty3.default)(_all, 'daikaiqi', '待开启'), (0, _defineProperty3.default)(_all, 'qianzhizuoye', '前置作业'), (0, _defineProperty3.default)(_all, 'qingshangchuan', '请上传'), (0, _defineProperty3.default)(_all, 'shangpinxuhao', '商品序号'), (0, _defineProperty3.default)(_all, 'shangpinshoutu', '商品首图'), (0, _defineProperty3.default)(_all, 'shangpinmingcheng', '商品名称'), (0, _defineProperty3.default)(_all, 'shangchengkucun', '商城库存'), (0, _defineProperty3.default)(_all, 'zhibokucun', '直播库存'), (0, _defineProperty3.default)(_all, 'shangchengjiage', '商城价格'), (0, _defineProperty3.default)(_all, 'zhibojiage', '直播价格'), (0, _defineProperty3.default)(_all, 'caozuo', '操作'), (0, _defineProperty3.default)(_all, 'yichu', '移除'), (0, _defineProperty3.default)(_all, 'zhibojiansetting', '直播间设置'), (0, _defineProperty3.default)(_all, 'kaiqishengyin', '开启声音'), (0, _defineProperty3.default)(_all, 'guanbishengyin', '关闭声音'), (0, _defineProperty3.default)(_all, 'kaiqidanmu', '开启弹幕'), (0, _defineProperty3.default)(_all, 'guanbidanmu', '关闭弹幕'), (0, _defineProperty3.default)(_all, 'kaiqimeiyan', '开启美颜'), (0, _defineProperty3.default)(_all, 'guanbimeiyan', '关闭美颜'), (0, _defineProperty3.default)(_all, 'kaiqimaikefeng', '开启麦克风'), (0, _defineProperty3.default)(_all, 'guanbimaikefeng', '关闭麦克风'), (0, _defineProperty3.default)(_all, 'kaiqimaike', '开麦克风'), (0, _defineProperty3.default)(_all, 'guanbimaike', '关麦克风'), (0, _defineProperty3.default)(_all, 'gonggao', '公告'), (0, _defineProperty3.default)(_all, 'fenxianglianjie', '分享链接'), (0, _defineProperty3.default)(_all, 'xietongzhibo', '协同直播'), (0, _defineProperty3.default)(_all, 'yaoqingjinbo', '邀请助播'), (0, _defineProperty3.default)(_all, 'tongyikongzhi', '统一控制'), (0, _defineProperty3.default)(_all, 'tichuzhubozb', '踢出选中助播'), (0, _defineProperty3.default)(_all, 'zhuborenshushangxian', '助播人数上限'), (0, _defineProperty3.default)(_all, 'ren', '人'), (0, _defineProperty3.default)(_all, 'tongzhibojinyao', '同直播金钥'), (0, _defineProperty3.default)(_all, 'zhuboquanxian', '助播权限'), (0, _defineProperty3.default)(_all, 'yunxufayan', '允许发言'), (0, _defineProperty3.default)(_all, 'yunxukamai', '允许开麦'), (0, _defineProperty3.default)(_all, 'yunxukashipin', '允许开视频'), (0, _defineProperty3.default)(_all, 'yikaiqi', '已开启'), (0, _defineProperty3.default)(_all, 'shengchengyaoqingjinyao', '生成邀请金钥'), (0, _defineProperty3.default)(_all, 'xietongzhiborenshu', '协同直播人数'), (0, _defineProperty3.default)(_all, 'dangqianzhibo', '当前助播'), (0, _defineProperty3.default)(_all, 'kenenghaiyaoqing', '可能还邀请'), (0, _defineProperty3.default)(_all, 'weizhibo', '位助播'), (0, _defineProperty3.default)(_all, 'baocunshangxian', '保存上限'), (0, _defineProperty3.default)(_all, 'fenxiangyaoqing', '分享邀请'), (0, _defineProperty3.default)(_all, 'yaoqinglianjie', '邀请链接'), (0, _defineProperty3.default)(_all, 'fenxiangfangshi', '分享方式'), (0, _defineProperty3.default)(_all, 'fuzhilianjie', '复制链接'), (0, _defineProperty3.default)(_all, 'baocunerweima', '保存二维码'), (0, _defineProperty3.default)(_all, 'fuzhiyaoqinglianjie', '复制邀请链接'), (0, _defineProperty3.default)(_all, 'zhubo', '助播'), (0, _defineProperty3.default)(_all, 'guanli', '管理'), (0, _defineProperty3.default)(_all, 'yijinru', '已进入'), (0, _defineProperty3.default)(_all, 'maikefeng', '麦克风'), (0, _defineProperty3.default)(_all, 'shexiangtou', '摄像头'), (0, _defineProperty3.default)(_all, 'guanbishexiangtou', '关闭摄像头'), (0, _defineProperty3.default)(_all, 'kaiqishexiangtou', '开启摄像头'), (0, _defineProperty3.default)(_all, 'guanbijingxiang', '关闭镜像'), (0, _defineProperty3.default)(_all, 'kaiqijingxiang', '开启镜像'), (0, _defineProperty3.default)(_all, 'sheweizhuyemian', '设为主画面'), (0, _defineProperty3.default)(_all, 'quxiaozhuyemian', '取消主画面'), (0, _defineProperty3.default)(_all, 'tichuzhibo', '踢出直播间'), (0, _defineProperty3.default)(_all, 'tichuhoubukejinru', '踢出后不可再进入该直播间'), (0, _defineProperty3.default)(_all, 'tongyikongmai', '统一控麦'), (0, _defineProperty3.default)(_all, 'quanjukongzhi', '全局控制'), (0, _defineProperty3.default)(_all, 'quantijingyin', '全体静音'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaimai', '允许助播开麦'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaishipin', '允许助播开视频'), (0, _defineProperty3.default)(_all, 'huifukaimai', '恢复开麦'), (0, _defineProperty3.default)(_all, 'guanbishipin', '关闭视频'), (0, _defineProperty3.default)(_all, 'kaiqishipin', '开视频'), (0, _defineProperty3.default)(_all, 'yunxushipin', '允许视频'), (0, _defineProperty3.default)(_all, 'yingyongshezhi', '应用设置'), (0, _defineProperty3.default)(_all, 'shipin', '视频'), (0, _defineProperty3.default)(_all, 'kaimai', '开麦'), (0, _defineProperty3.default)(_all, 'weikaiqi', '未开启'), (0, _defineProperty3.default)(_all, 'shipinkaiqi', '视频开启'), (0, _defineProperty3.default)(_all, 'shipinguanbi', '视频关闭'), (0, _defineProperty3.default)(_all, 'bimai', '闭麦'), (0, _defineProperty3.default)(_all, 'yunxufayan', '允许发言'), (0, _defineProperty3.default)(_all, 'jinzhifayan', '禁止发言'), (0, _defineProperty3.default)(_all, 'zhuboxiwei', '助播席位'), (0, _defineProperty3.default)(_all, 'guankanzhibo', '观看直播'), (0, _defineProperty3.default)(_all, 'goumai', '购买'), (0, _defineProperty3.default)(_all, 'goumaishangpin', '购买商品'), (0, _defineProperty3.default)(_all, 'yishouqing', '已售罄'), (0, _defineProperty3.default)(_all, 'qianggou', '抢购'), (0, _defineProperty3.default)(_all, 'dashang', '打赏'), (0, _defineProperty3.default)(_all, 'chakangg', '查看公告'), (0, _defineProperty3.default)(_all, 'quxiao', '取消'), (0, _defineProperty3.default)(_all, 'queren', '确认'), (0, _defineProperty3.default)(_all, 'wodequanbao', '我的钱包'), (0, _defineProperty3.default)(_all, 'jiangjie', '讲解'), (0, _defineProperty3.default)(_all, 'jiangjiezhong', '讲解中'), (0, _defineProperty3.default)(_all, 'kucun', '库存'), (0, _defineProperty3.default)(_all, 'qrcodenotexist', '二维码不存在'), (0, _defineProperty3.default)(_all, 'qrcodesaved', '二维码保存成功'), (0, _defineProperty3.default)(_all, 'wodeqianbao', '我的钱包'), (0, _defineProperty3.default)(_all, 'lianshangbaobishibei', '链上包币市币'), (0, _defineProperty3.default)(_all, 'zonge', '总额'), (0, _defineProperty3.default)(_all, 'keyongshuliang', '可用数量'), (0, _defineProperty3.default)(_all, 'dongjieshuliang', '冻结数量'), (0, _defineProperty3.default)(_all, 'chakanliushui', '查看流水'), (0, _defineProperty3.default)(_all, 'chongzhitip', '充币提示：仅支持同链网络，区块链确认到链转账资产无法找回'), (0, _defineProperty3.default)(_all, 'chongzhishuliang', '充值数量'), (0, _defineProperty3.default)(_all, 'zuidicharge', '最低充值金额'), (0, _defineProperty3.default)(_all, 'xiaoyuzuixiaoe', '小于最小金额充值将不会上账'), (0, _defineProperty3.default)(_all, 'yujidaozhang', '预计到账'), (0, _defineProperty3.default)(_all, 'shijidaozhang', '实际到账'), (0, _defineProperty3.default)(_all, 'lijichongzhi', '立即充值'), (0, _defineProperty3.default)(_all, 'chongzhierweima', '充值二维码'), (0, _defineProperty3.default)(_all, 'chongbidizhi', '充币地址'), (0, _defineProperty3.default)(_all, 'chongbixiangqing', '充币详情'), (0, _defineProperty3.default)(_all, 'tibixiangqing', '提币详情'), (0, _defineProperty3.default)(_all, 'fuzhidizhi', '复制地址'), (0, _defineProperty3.default)(_all, 'chongzhichenggong', '充值成功'), (0, _defineProperty3.default)(_all, 'dengdaiquerenzhong', '等待确认中...'), (0, _defineProperty3.default)(_all, 'baocunchenggong', '保存成功'), (0, _defineProperty3.default)(_all, 'chongbichenggong', '充币成功'), (0, _defineProperty3.default)(_all, 'bizhong', '币种'), (0, _defineProperty3.default)(_all, 'shuliang', '数量'), (0, _defineProperty3.default)(_all, 'shijian', '时间'), (0, _defineProperty3.default)(_all, 'tibidizhi', '提币地址'), (0, _defineProperty3.default)(_all, 'qingshurutibidizhi', '请输入提币地址'), (0, _defineProperty3.default)(_all, 'tibishisuan', '提币试算'), (0, _defineProperty3.default)(_all, 'zuiditixianjin', '最低提现金额'), (0, _defineProperty3.default)(_all, 'tibishenqingyitijiao', '提币申请已提交'), (0, _defineProperty3.default)(_all, 'tibishenqingdesc', '后台审核通过后，将进行链上提币。'), (0, _defineProperty3.default)(_all, 'shenhezhong', '审核中'), (0, _defineProperty3.default)(_all, 'zhuangtai', '状态'), (0, _defineProperty3.default)(_all, 'chakantibi', '查看提币记录'), (0, _defineProperty3.default)(_all, 'meiriyushutixian', '每日剩余提现金额'), (0, _defineProperty3.default)(_all, 'keyongyu', '可用余额'), (0, _defineProperty3.default)(_all, 'tijiaotibi', '提交提币'), (0, _defineProperty3.default)(_all, 'xuanzetibidizhi', '选择提币地址'), (0, _defineProperty3.default)(_all, 'sousuodizhi', '搜索地址'), (0, _defineProperty3.default)(_all, 'xuanze', '选择'), (0, _defineProperty3.default)(_all, 'querentbi', '确认提币'), (0, _defineProperty3.default)(_all, 'xuanzedashangbizhong', '选择打赏币种'), (0, _defineProperty3.default)(_all, 'xuanzebizhong', '选择币种'), (0, _defineProperty3.default)(_all, 'chuzhidizhi', '储值地址'), (0, _defineProperty3.default)(_all, 'yue', '余额'), (0, _defineProperty3.default)(_all, 'dashangjine', '打赏金额'), (0, _defineProperty3.default)(_all, 'zhanshidashangxinxi', '展示打赏信息'), (0, _defineProperty3.default)(_all, 'zidingyi', '自定义'), (0, _defineProperty3.default)(_all, 'querendashang', '确认打赏'), (0, _defineProperty3.default)(_all, 'zaixianguanzhong', '在线观众'), (0, _defineProperty3.default)(_all, 'yizhibo', '已直播'), (0, _defineProperty3.default)(_all, 'jieshizhibo', '结束直播'), (0, _defineProperty3.default)(_all, 'zhibozhong', '直播中'), (0, _defineProperty3.default)(_all, 'zanwuzaixianguanzhong', '暂无在线观众'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', '视频上传失败，请稍后重试'), (0, _defineProperty3.default)(_all, 'qingshurucontent', '请填写标题并上传视频'), (0, _defineProperty3.default)(_all, 'fabuchenggong', '发布成功'), (0, _defineProperty3.default)(_all, 'fabushibai', '发布失败'), (0, _defineProperty3.default)(_all, 'qingshurushuju', '请输入数据'), (0, _defineProperty3.default)(_all, 'confirmDelete', '确认删除该视频？'), (0, _defineProperty3.default)(_all, 'shanchuchenggong', '删除成功'), (0, _defineProperty3.default)(_all, 'confirmWithdraw', '确认撤回该视频？'), (0, _defineProperty3.default)(_all, 'chehuichenggong', '撤回成功'), (0, _defineProperty3.default)(_all, 'yongjiujinyan', '永久禁言'), (0, _defineProperty3.default)(_all, 'jiaruzhibo', '加入直播'), (0, _defineProperty3.default)(_all, 'jiaruxietongzhibo', '加入协同直播'), (0, _defineProperty3.default)(_all, 'tuichuxietongzhibo', '退出协同直播'), (0, _defineProperty3.default)(_all, 'zhubojinyao', '助播金钥'), (0, _defineProperty3.default)(_all, 'qingshuruzhubojinyao', '请输入助播金钥'), (0, _defineProperty3.default)(_all, 'jiaru', '加入'), (0, _defineProperty3.default)(_all, 'shenqingchenggong', '申请成功'), (0, _defineProperty3.default)(_all, 'youxiaoqi', '有效期'), (0, _defineProperty3.default)(_all, 'tichubenchang', '踢出本场'), (0, _defineProperty3.default)(_all, 'zhanshidashangxiaoxi', '展示打赏消息'), (0, _defineProperty3.default)(_all, 'zanwugonggao', '暂无公告'), (0, _defineProperty3.default)(_all, 'dashang', '打赏'), (0, _defineProperty3.default)(_all, 'songgei', '送给'), (0, _defineProperty3.default)(_all, 'ge', '个'), (0, _defineProperty3.default)(_all, 'bi', '币'), (0, _defineProperty3.default)(_all, 'zanweiyourenjiaruxietongzhibo', '暂未有人加入协同直播'), (0, _defineProperty3.default)(_all, 'zanweikaiqi', '暂未开启协同直播'), _all)
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(61);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _all;

var _en = __webpack_require__(280);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	all: (_all = {
		jiantizhongwen: 'Simplified Chinese',
		fantizhongwen: 'Traditional Chinese',
		yingwen: 'English',
		ribenyu: 'Japanese',
		hanguoyu: 'Korean',
		jizhuzhanghao: 'Remember account',
		jizhumima: 'Remember password',
		jizhuzhanghaomima: 'Remember account & password',
		yuyanxuanze: 'Language selection',
		shezhi: 'setting',
		xiugaimima: 'Change password',
		yinsizhengce: 'Privacy Policy',
		guanyuwomen: 'About Us',
		mimashuoming: 'The password must consist of a combination of 8-20 characters, including uppercase and lowercase letters and numbers, and cannot be composed solely of numbers or letters',
		qingshurujiumima: 'Please enter your old password',
		qingshuruxinmima: 'Please enter a new password',
		quedingxiugai: 'Confirm modification',

		shouye: 'Home Page',
		zhibo: 'live broadcast',
		wode: 'my',
		xitongxiaoxi: 'System',
		wodedingdan: 'Order',
		bangzhufankui: 'Feedback',
		xiugaiziliao: 'Modify profile',
		xiaofeimingxi: 'Consumption Details',
		zhibojilu: 'Live broadcast record',
		tijiao: 'Submit',
		caozuochenggong: 'Operation successful',
		tishi: 'prompt',
		quedingtuichudengluma: 'Are you sure you want to log out?',
		queding: 'confirm',
		wentibangzhu: 'Question Help',
		woyaofankui: 'I want to give feedback',
		fankuiwenti: 'feedback issue',
		qingmiaoshuniyaofankuidewenti: 'Please describe the problem you want to feedback...',
		sousuo: 'search',
		sousuoniganxingqudeneirong: 'Search for content that interests you',
		zhibojianbiaoti: 'live stream title',
		zhibojianbeijing: 'Live streaming room background',
		zhibojianfengmian: 'Live streaming room cover',
		xuanzebackground: 'Select Background',
		shangchuanbeijing: 'Upload Background',
		yixuanze: 'Selected',
		qingxuanzebeijing: 'Please select background',
		xietongzhiboweiqidong: 'Co-live function not activated',
		zhibojianbiaoqian: 'live streaming room tag',
		zhibojianhuazhi: 'live streaming video quality',
		geinidezhibojianqugemingziba: 'Give your live streaming room a name~',
		qingshurukaibomiyao: 'Please enter the broadcast secret key',
		kaishizhibo: 'Start live streaming',
		shengyin: 'sound',
		liwutexiao: 'gift special effect',
		gengduo: 'more',
		gouwuche: 'shopping cart',
		zaixianguanzhong: 'online audience',
		danmushuoming: 'The platform strictly prohibits minors from recharging and tipping, as well as inducing tipping through private transactions such as playing together. It also strictly prohibits content related to pornography, politics, abuse, etc. Please pay attention to property safety, beware of online fraud, and consume rationally',
		tianjiaguanliyuan: 'Add administrator',
		jinyan: 'mute',
		jiechuejinyan: 'lift the mute',
		tichufangjian: 'kick out of the room',
		shangpinxiangqing: 'Product Details',
		lijijiagou: 'Add to Cart Now',
		xuanzeguige: 'Select specification',
		quanbuliwu: 'All gifts',
		ge: 'a',
		bi: 'coin',
		guanliyuan: 'administrator',
		kuaijieduanyu: 'Quick Phrases',
		gonggao: 'Announcement',
		xinzengkuaijieduanyu: 'New quick phrases',
		qingshuru: 'Please input',
		qingshuruzhengque: 'Please enter a valid amount',
		shuru: 'Input',
		wangjimima: 'Forgot password',
		youxiangzhuce: 'Email registration',
		huoquyanzhengma: 'Obtain verification code',
		youxiang: 'Email',
		yanzhengma: 'Verification Code',
		anquanyanzheng: 'Security Verification',
		fasongyanzhengma: 'Send Code',
		qingshuruyouxiangyanzhengma: 'Please enter email verification code',
		fasongchenggong: 'Sent successfully',
		qingshuruningdeyouxiangzhanghao: 'Enter your email account',
		qingshuruyanzhengma: 'Please enter the verification code',
		qingshurumima: 'Please enter your password',
		mimadenglu: 'Password login',
		woyiyuedubingtongyi: 'I have read and agree',
		yonghuxieyi: 'User Agreement',
		yinsixieyi: 'Privacy Agreement',
		denglu: 'login',
		chongxindenglu: 'Log in again',
		xiayibu: 'Next step',
		haimeizhanghao: 'I do not have an account yet',
		quzhuce: "go register",
		yiyouzhanghao: 'Already have an account',
		qudenglu: 'Go to login',
		shezhijibenxinxi: 'Set basic information',
		nichengtishi: 'Only letters, numbers, and punctuation marks are supported. It must be at least 6 characters long and cannot contain spaces.',
		shezhiyonghuming: 'Set username',
		yonghumingtishi: 'The username should be 6-18 characters long, consisting of uppercase and lowercase letters or numbers',
		shezhijiaoyimima: 'Set transaction password',
		jiaoyimimatishi: 'The transaction password must consist of a combination of 6 digits',
		qingxuanze: 'Please choose',
		yaoqingma: 'Invitation code (optional)',
		qingshuruyaoqingma: 'Enter invitation code',
		shezhixinmima: 'Set new password',
		xuanzeningdeguojia: 'Select your country',
		zhuce: 'register',
		qingshuruyonghuming: 'Please enter your username',
		gaoqinghuazhi: 'high-definition picture quality',
		biaoqinghuazhi: 'Standard definition',
		chaoqinghuazhi: 'Ultra HD',
		putonghuazhi: 'Normal picture quality'
	}, (0, _defineProperty3.default)(_all, 'kaishizhibo', 'Start live streaming'), (0, _defineProperty3.default)(_all, 'zengsong', 'Give'), (0, _defineProperty3.default)(_all, 'jinrulezhibojian', 'Enter the live streaming room'), (0, _defineProperty3.default)(_all, 'shuodianshenmene', 'What do you want to say ...'), (0, _defineProperty3.default)(_all, 'zanwushuju', 'No data available'), (0, _defineProperty3.default)(_all, 'songgei', 'give to'), (0, _defineProperty3.default)(_all, 'huifang', 'playback'), (0, _defineProperty3.default)(_all, 'xunibi', 'virtual currency'), (0, _defineProperty3.default)(_all, 'quanbu', 'all'), (0, _defineProperty3.default)(_all, 'appxiazai', 'Download'), (0, _defineProperty3.default)(_all, 'dingdanjine', 'Order amount'), (0, _defineProperty3.default)(_all, 'dingdanbianhao', 'Order number'), (0, _defineProperty3.default)(_all, 'chuangjianshijian', 'creation time'), (0, _defineProperty3.default)(_all, 'zhubozanshilikai', 'The host is temporarily away'), (0, _defineProperty3.default)(_all, 'mashanghuilai', 'I will be back soon'), (0, _defineProperty3.default)(_all, 'guojianzhuoxiazai', 'International Android Download'), (0, _defineProperty3.default)(_all, 'anzhuoxiazai', 'Android download'), (0, _defineProperty3.default)(_all, 'guojipingguoxiazai', 'International Apple Download'), (0, _defineProperty3.default)(_all, 'pingguoxiazai', 'Apple download'), (0, _defineProperty3.default)(_all, 'weixiazai', 'No download'), (0, _defineProperty3.default)(_all, 'quanbushangpin', "all products"), (0, _defineProperty3.default)(_all, 'yiqiangguang', 'All sold out'), (0, _defineProperty3.default)(_all, 'jiagou', 'add cart'), (0, _defineProperty3.default)(_all, 'shangpinxiangqing', 'Product Details'), (0, _defineProperty3.default)(_all, 'lijijiagou', "immediately add to cart"), (0, _defineProperty3.default)(_all, 'yixuan', 'Selected'), (0, _defineProperty3.default)(_all, 'xuanzeguiige', 'Select Specification'), (0, _defineProperty3.default)(_all, 'xuazeguige', 'Select specification'), (0, _defineProperty3.default)(_all, 'shangchuanzhong', 'Uploading'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', 'Upload failed'), (0, _defineProperty3.default)(_all, 'browserbu\u652F\u6301', 'Your browser does not support media device access'), (0, _defineProperty3.default)(_all, 'qingkaiqi', 'Please enable camera and microphone permissions'), (0, _defineProperty3.default)(_all, 'meiyoushebei', 'No camera or microphone device detected'), (0, _defineProperty3.default)(_all, 'shebeibeizhan', 'Device is occupied by another program, please close it and try again'), (0, _defineProperty3.default)(_all, 'quxianchengong', 'Failed to obtain media permission'), (0, _defineProperty3.default)(_all, 'shifouquedingjieshuzhibo', 'Are you sure to close the live broadcast?'), (0, _defineProperty3.default)(_all, 'qingyuedubingtongyiyonghuxieyiheyinsixieyi', 'Please read and agree to the User Agreement and Privacy Agreement!'), (0, _defineProperty3.default)(_all, 'quedingqudengluma', 'Are you sure you want to log in?'), (0, _defineProperty3.default)(_all, 'remen', 'Hot'), (0, _defineProperty3.default)(_all, 'pinglun', 'Comments'), (0, _defineProperty3.default)(_all, 'huifu', 'Reply'), (0, _defineProperty3.default)(_all, 'shanchu', 'Delete'), (0, _defineProperty3.default)(_all, 'chakanhuifu', 'View replies'), (0, _defineProperty3.default)(_all, 'jiazaizhong', 'Loading'), (0, _defineProperty3.default)(_all, 'jiazaigengduo', 'Load more'), (0, _defineProperty3.default)(_all, 'meiyougengduo', 'No more comments'), (0, _defineProperty3.default)(_all, 'shuodianshenme', 'Write a comment...'), (0, _defineProperty3.default)(_all, 'fasong', 'Send'), (0, _defineProperty3.default)(_all, 'fabiao', 'Post'), (0, _defineProperty3.default)(_all, 'ganggang', 'Just now'), (0, _defineProperty3.default)(_all, 'fenzhongqian', '{n} min ago'), (0, _defineProperty3.default)(_all, 'xiaoshiqian', '{n} h ago'), (0, _defineProperty3.default)(_all, 'tianqian', '{n} d ago'), (0, _defineProperty3.default)(_all, 'shanchupinglun', 'Delete this comment?'), (0, _defineProperty3.default)(_all, 'duanyingyin', 'Short Video'), (0, _defineProperty3.default)(_all, 'wofabu', 'My Published'), (0, _defineProperty3.default)(_all, 'wodianzan', 'My Likes'), (0, _defineProperty3.default)(_all, 'woshoucang', 'My Collects'), (0, _defineProperty3.default)(_all, 'fabuduanyingyin', 'Publish Short Video'), (0, _defineProperty3.default)(_all, 'zhibohuaxu', 'Live Highlights'), (0, _defineProperty3.default)(_all, 'qingshurubiaoti', 'Please enter title'), (0, _defineProperty3.default)(_all, 'shangchuanduanyingyin', 'Upload Short Video'), (0, _defineProperty3.default)(_all, 'yonghuzhuye', 'Profile'), (0, _defineProperty3.default)(_all, 'guanzhuta', 'Follow'), (0, _defineProperty3.default)(_all, 'yiguanzhu', 'Following'), (0, _defineProperty3.default)(_all, 'guanzhu', 'Follow'), (0, _defineProperty3.default)(_all, 'fensi', 'Fans'), (0, _defineProperty3.default)(_all, 'guanzhong', 'Following'), (0, _defineProperty3.default)(_all, 'huguan', 'Mutual'), (0, _defineProperty3.default)(_all, 'shanchuguanzhu', 'Remove follow'), (0, _defineProperty3.default)(_all, 'yichufensi', 'Remove fan'), (0, _defineProperty3.default)(_all, 'huiyuanid', 'Member ID:'), (0, _defineProperty3.default)(_all, 'zhibozhongxin', 'Live Center'), (0, _defineProperty3.default)(_all, 'zongzichanguzhi', 'Total Asset Value'), (0, _defineProperty3.default)(_all, 'liushuijilu', 'Transaction History'), (0, _defineProperty3.default)(_all, 'chongbi', 'Deposit'), (0, _defineProperty3.default)(_all, 'tibi', 'Withdraw'), (0, _defineProperty3.default)(_all, 'gaibizhongbuzhichichongzhi', 'This currency does not support deposits'), (0, _defineProperty3.default)(_all, 'gaibizhongbuzhichitibi', 'This currency does not support withdrawals'), (0, _defineProperty3.default)(_all, 'dashang', 'Tips'), (0, _defineProperty3.default)(_all, 'riqi', 'Date'), (0, _defineProperty3.default)(_all, 'leixing', 'Type'), (0, _defineProperty3.default)(_all, 'miaoshu', 'Description'), (0, _defineProperty3.default)(_all, 'jine', 'Amount'), (0, _defineProperty3.default)(_all, 'zhuangtai', 'Status'), (0, _defineProperty3.default)(_all, 'yiwancheng', 'Completed'), (0, _defineProperty3.default)(_all, 'shenhezhong', 'Pending'), (0, _defineProperty3.default)(_all, 'shenhejujue', 'Rejected'), (0, _defineProperty3.default)(_all, 'tibibeibohui', 'Withdrawal Rejected'), (0, _defineProperty3.default)(_all, 'zhidaole', 'Got it'), (0, _defineProperty3.default)(_all, 'bohuiyuanyin', 'Rejection Reason: '), (0, _defineProperty3.default)(_all, 'kaishiriqi', 'Start Date'), (0, _defineProperty3.default)(_all, 'jieshuriqi', 'End Date'), (0, _defineProperty3.default)(_all, 'wangluo', 'Network'), (0, _defineProperty3.default)(_all, 'dizhi', 'Address'), (0, _defineProperty3.default)(_all, 'tibishuliang', 'Withdrawal Amount'), (0, _defineProperty3.default)(_all, 'daozhangshisuan', 'Arrival Estimate'), (0, _defineProperty3.default)(_all, 'shouxufei', 'Fee'), (0, _defineProperty3.default)(_all, 'meiridaozhang', 'Daily Arrival'), (0, _defineProperty3.default)(_all, 'keyong', 'Available'), (0, _defineProperty3.default)(_all, 'dongjie', 'Frozen'), (0, _defineProperty3.default)(_all, 'zuixiaotibishuliang', 'Min Withdrawal'), (0, _defineProperty3.default)(_all, 'shouxufeibilv', 'Fee'), (0, _defineProperty3.default)(_all, 'meirishenyueddu', 'Daily Remaining Limit'), (0, _defineProperty3.default)(_all, 'shenqingzhibo', 'Apply for Live'), (0, _defineProperty3.default)(_all, 'shenqingjilu', 'Application Records'), (0, _defineProperty3.default)(_all, 'huifangjilu', 'Replay Records'), (0, _defineProperty3.default)(_all, 'yikaifang', 'Open'), (0, _defineProperty3.default)(_all, 'guankanhuifang', 'Watch Replay'), (0, _defineProperty3.default)(_all, 'beisu', 'Speed'), (0, _defineProperty3.default)(_all, 'zhiboriqi', 'Live Date'), (0, _defineProperty3.default)(_all, 'shijianshiduan', 'Time Slot'), (0, _defineProperty3.default)(_all, 'shoujizhibo', 'Mobile Live'), (0, _defineProperty3.default)(_all, 'zhibodaihuo', 'Live Shopping'), (0, _defineProperty3.default)(_all, 'kaiqi', 'On'), (0, _defineProperty3.default)(_all, 'guanbi', 'Off'), (0, _defineProperty3.default)(_all, 'beizhu', 'Remark'), (0, _defineProperty3.default)(_all, 'huodongzhuti', 'Theme, equipment description'), (0, _defineProperty3.default)(_all, 'shenqinghouliucheng', 'Post-application Process'), (0, _defineProperty3.default)(_all, 'shenqinghouliuchengdesc', 'After approval, a confirmation email with the live stream address will be sent.'), (0, _defineProperty3.default)(_all, 'daishenhe', 'Pending'), (0, _defineProperty3.default)(_all, 'tijiaoshenqing', 'Submit Application'), (0, _defineProperty3.default)(_all, 'qingxuanzeriqi', 'Please select a live date'), (0, _defineProperty3.default)(_all, 'qingxuanzeshijian', 'Please select a time slot'), (0, _defineProperty3.default)(_all, 'tijiaochenggong', 'Submitted successfully'), (0, _defineProperty3.default)(_all, 'nian', '/'), (0, _defineProperty3.default)(_all, 'yue', ''), (0, _defineProperty3.default)(_all, 'tongshiduanbukezhongfu', 'No duplicate time slots'), (0, _defineProperty3.default)(_all, 'keshenqingshiduan', 'Available Time Slots'), (0, _defineProperty3.default)(_all, 'querenShiduan', 'Confirm'), (0, _defineProperty3.default)(_all, 'zhanghaoid', 'Account ID'), (0, _defineProperty3.default)(_all, 'qingtianxie', 'Please fill in'), (0, _defineProperty3.default)(_all, 'zhou1', 'Mon'), (0, _defineProperty3.default)(_all, 'zhou2', 'Tue'), (0, _defineProperty3.default)(_all, 'zhou3', 'Wed'), (0, _defineProperty3.default)(_all, 'zhou4', 'Thu'), (0, _defineProperty3.default)(_all, 'zhou5', 'Fri'), (0, _defineProperty3.default)(_all, 'zhou6', 'Sat'), (0, _defineProperty3.default)(_all, 'zhou7', 'Sun'), (0, _defineProperty3.default)(_all, 'shenqingyitijiao', 'Application Submitted'), (0, _defineProperty3.default)(_all, 'shenqingtijiaodesc', 'The admin will review the room, time slot, and product info.'), (0, _defineProperty3.default)(_all, 'chakanshenheJilu', 'View Review Records'), (0, _defineProperty3.default)(_all, 'shenqingriqi', 'Apply Date'), (0, _defineProperty3.default)(_all, 'zhiboshijianduan', 'Live Time Slot'), (0, _defineProperty3.default)(_all, 'zhiboleixing', 'Live Type'), (0, _defineProperty3.default)(_all, 'daihuo', 'Shopping'), (0, _defineProperty3.default)(_all, 'yitongguo', 'Approved'), (0, _defineProperty3.default)(_all, 'weitongguo', 'Rejected'), (0, _defineProperty3.default)(_all, 'xiangqing', 'Details'), (0, _defineProperty3.default)(_all, 'yuanyin', 'Reason'), (0, _defineProperty3.default)(_all, 'shenqingxiangqing', 'Application Details'), (0, _defineProperty3.default)(_all, 'shenheyuanyin', 'Review Reason'), (0, _defineProperty3.default)(_all, 'xutiaozheng', 'Adjustment Needed'), (0, _defineProperty3.default)(_all, 'shenheyuanyindesc', 'The time slot is occupied. Please select a different date or time slot and resubmit.'), (0, _defineProperty3.default)(_all, 'wancheng', 'Done'), (0, _defineProperty3.default)(_all, 'chulizhong', 'Processing'), (0, _defineProperty3.default)(_all, 'daichuli', 'Pending'), (0, _defineProperty3.default)(_all, 'houtaishenhe', 'Admin Review'), (0, _defineProperty3.default)(_all, 'chanshengmiyao', 'Generate Key'), (0, _defineProperty3.default)(_all, 'youjiankuaidi', 'Email Notification'), (0, _defineProperty3.default)(_all, 'kechakan', 'Viewable'), (0, _defineProperty3.default)(_all, 'jinwanxinpinfuli', 'New product live stream tonight'), (0, _defineProperty3.default)(_all, 'chehuishenqing', 'Withdraw Application'), (0, _defineProperty3.default)(_all, 'chongxinshenqing', 'Reapply'), (0, _defineProperty3.default)(_all, 'zhibojinyao', 'Live Key'), (0, _defineProperty3.default)(_all, 'zhibojian', 'Room'), (0, _defineProperty3.default)(_all, 'keyongshiduan', 'Available Time'), (0, _defineProperty3.default)(_all, 'youxiao', 'Valid'), (0, _defineProperty3.default)(_all, 'tuiliudizhi', 'Push URL'), (0, _defineProperty3.default)(_all, 'tuiliumamiyao', 'Stream Key'), (0, _defineProperty3.default)(_all, 'youjiantongzhidesc', 'Keys will not be regenerated for the same room and time slot.'), (0, _defineProperty3.default)(_all, 'yifasong', 'Sent'), (0, _defineProperty3.default)(_all, 'fuzhiquanbu', 'Copy All'), (0, _defineProperty3.default)(_all, 'fuzhichenggong', 'Copied'), (0, _defineProperty3.default)(_all, 'youjiantongzhi', 'Email Notification'), (0, _defineProperty3.default)(_all, 'zhiboshenhetongguo', 'Live Approved'), (0, _defineProperty3.default)(_all, 'shoujianren', 'Recipient'), (0, _defineProperty3.default)(_all, 'youjianneirongdesc', 'Contains room info, available time slots, push/pull stream URLs, keys, and pre-stream settings.'), (0, _defineProperty3.default)(_all, 'youjianbianhao', 'Mail ID'), (0, _defineProperty3.default)(_all, 'chongxinfasong', 'Resend'), (0, _defineProperty3.default)(_all, 'yinyuedaren', 'Music'), (0, _defineProperty3.default)(_all, 'wudaodaren', 'Dance'), (0, _defineProperty3.default)(_all, 'yanzhi', 'Beauty'), (0, _defineProperty3.default)(_all, 'jichushezhi', 'Basic Settings'), (0, _defineProperty3.default)(_all, 'yishangchuan', 'Uploaded'), (0, _defineProperty3.default)(_all, 'zhiboshangpin', 'Live Products'), (0, _defineProperty3.default)(_all, 'laiziyunimall', 'From UNImall Store'), (0, _defineProperty3.default)(_all, 'jian', ' items'), (0, _defineProperty3.default)(_all, 'zhiboliucheng', 'Live Process'), (0, _defineProperty3.default)(_all, 'liuchang', 'Smooth'), (0, _defineProperty3.default)(_all, 'gaoqing', 'HD'), (0, _defineProperty3.default)(_all, 'chaoqing', 'Ultra HD'), (0, _defineProperty3.default)(_all, 'languang', 'Blu-ray'), (0, _defineProperty3.default)(_all, 'tongguo', 'Passed'), (0, _defineProperty3.default)(_all, 'jinxingzhong', 'In Progress'), (0, _defineProperty3.default)(_all, 'daikaiqi', 'Pending'), (0, _defineProperty3.default)(_all, 'qianzhizuoye', 'Pre-setup'), (0, _defineProperty3.default)(_all, 'qingshangchuan', 'Upload'), (0, _defineProperty3.default)(_all, 'shangpinxuhao', 'No.'), (0, _defineProperty3.default)(_all, 'shangpinshoutu', 'Image'), (0, _defineProperty3.default)(_all, 'shangpinmingcheng', 'Product Name'), (0, _defineProperty3.default)(_all, 'shangchengkucun', 'Store Stock'), (0, _defineProperty3.default)(_all, 'zhibokucun', 'Live Stock'), (0, _defineProperty3.default)(_all, 'shangchengjiage', 'Store Price'), (0, _defineProperty3.default)(_all, 'zhibojiage', 'Live Price'), (0, _defineProperty3.default)(_all, 'caozuo', 'Action'), (0, _defineProperty3.default)(_all, 'yichu', 'Remove'), (0, _defineProperty3.default)(_all, 'zhibojiansetting', 'Room Settings'), (0, _defineProperty3.default)(_all, 'kaiqishengyin', 'Sound On'), (0, _defineProperty3.default)(_all, 'guanbishengyin', 'Sound Off'), (0, _defineProperty3.default)(_all, 'kaiqidanmu', 'Danmu On'), (0, _defineProperty3.default)(_all, 'guanbidanmu', 'Danmu Off'), (0, _defineProperty3.default)(_all, 'kaiqimeiyan', 'Beauty On'), (0, _defineProperty3.default)(_all, 'guanbimeiyan', 'Beauty Off'), (0, _defineProperty3.default)(_all, 'kaiqimaikefeng', 'Mic On'), (0, _defineProperty3.default)(_all, 'guanbimaikefeng', 'Mic Off'), (0, _defineProperty3.default)(_all, 'kaiqimaike', 'Mic On'), (0, _defineProperty3.default)(_all, 'guanbimaike', 'Mic Off'), (0, _defineProperty3.default)(_all, 'gonggao', 'Notice'), (0, _defineProperty3.default)(_all, 'fenxianglianjie', 'Share Link'), (0, _defineProperty3.default)(_all, 'xietongzhibo', 'Co-live'), (0, _defineProperty3.default)(_all, 'yaoqingjinbo', 'Invite Co-host'), (0, _defineProperty3.default)(_all, 'tongyikongzhi', 'Unified Control'), (0, _defineProperty3.default)(_all, 'tichuzhubozb', 'Remove Selected'), (0, _defineProperty3.default)(_all, 'zhuborenshushangxian', 'Co-host Limit'), (0, _defineProperty3.default)(_all, 'ren', ''), (0, _defineProperty3.default)(_all, 'tongzhibojinyao', 'Same as Live Key'), (0, _defineProperty3.default)(_all, 'zhuboquanxian', 'Co-host Permissions'), (0, _defineProperty3.default)(_all, 'yunxufayan', 'Allow Chat'), (0, _defineProperty3.default)(_all, 'yunxukamai', 'Allow Mic'), (0, _defineProperty3.default)(_all, 'yunxukashipin', 'Allow Video'), (0, _defineProperty3.default)(_all, 'yikaiqi', 'Enabled'), (0, _defineProperty3.default)(_all, 'shengchengyaoqingjinyao', 'Generate Invite Key'), (0, _defineProperty3.default)(_all, 'xietongzhiborenshu', 'Co-live Capacity'), (0, _defineProperty3.default)(_all, 'dangqianzhibo', 'Current Co-hosts'), (0, _defineProperty3.default)(_all, 'kenenghaiyaoqing', 'Can invite'), (0, _defineProperty3.default)(_all, 'weizhibo', ' more'), (0, _defineProperty3.default)(_all, 'baocunshangxian', 'Save Limit'), (0, _defineProperty3.default)(_all, 'fenxiangyaoqing', 'Share Invite'), (0, _defineProperty3.default)(_all, 'yaoqinglianjie', 'Invite Link'), (0, _defineProperty3.default)(_all, 'fenxiangfangshi', 'Share Method'), (0, _defineProperty3.default)(_all, 'fuzhilianjie', 'Copy Link'), (0, _defineProperty3.default)(_all, 'baocunerweima', 'Save QR Code'), (0, _defineProperty3.default)(_all, 'fuzhiyaoqinglianjie', 'Copy Invite Link'), (0, _defineProperty3.default)(_all, 'zhubo', 'Co-host'), (0, _defineProperty3.default)(_all, 'guanli', 'Manage'), (0, _defineProperty3.default)(_all, 'yijinru', 'Joined'), (0, _defineProperty3.default)(_all, 'maikefeng', 'Microphone'), (0, _defineProperty3.default)(_all, 'shexiangtou', 'Camera'), (0, _defineProperty3.default)(_all, 'guanbishexiangtou', 'Turn off camera'), (0, _defineProperty3.default)(_all, 'kaiqishexiangtou', 'Turn on camera'), (0, _defineProperty3.default)(_all, 'guanbijingxiang', 'Turn off mirror'), (0, _defineProperty3.default)(_all, 'kaiqijingxiang', 'Turn on mirror'), (0, _defineProperty3.default)(_all, 'sheweizhuyemian', 'Set as Main'), (0, _defineProperty3.default)(_all, 'quxiaozhuyemian', 'Cancel Main'), (0, _defineProperty3.default)(_all, 'tichuzhibo', 'Remove from Room'), (0, _defineProperty3.default)(_all, 'tichuhoubukejinru', 'Cannot re-enter after removal'), (0, _defineProperty3.default)(_all, 'tongyikongmai', 'Unified Mic Control'), (0, _defineProperty3.default)(_all, 'quanjukongzhi', 'Global Control'), (0, _defineProperty3.default)(_all, 'quantijingyin', 'Mute All'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaimai', 'Allow Co-host Mic'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaishipin', 'Allow Co-host Video'), (0, _defineProperty3.default)(_all, 'huifukaimai', 'Unmute'), (0, _defineProperty3.default)(_all, 'guanbishipin', 'Disable Video'), (0, _defineProperty3.default)(_all, 'kaiqishipin', 'Video On'), (0, _defineProperty3.default)(_all, 'yunxushipin', 'Allow Video'), (0, _defineProperty3.default)(_all, 'yingyongshezhi', 'Apply Settings'), (0, _defineProperty3.default)(_all, 'shipin', 'Video'), (0, _defineProperty3.default)(_all, 'kaimai', 'Mic On'), (0, _defineProperty3.default)(_all, 'weikaiqi', 'Off'), (0, _defineProperty3.default)(_all, 'shipinkaiqi', 'Video On'), (0, _defineProperty3.default)(_all, 'shipinguanbi', 'Video Off'), (0, _defineProperty3.default)(_all, 'bimai', 'Mute'), (0, _defineProperty3.default)(_all, 'yunxufayan', 'Allow Chat'), (0, _defineProperty3.default)(_all, 'jinzhifayan', 'Disallow Chat'), (0, _defineProperty3.default)(_all, 'zhuboxiwei', 'Co-host Seat'), (0, _defineProperty3.default)(_all, 'guankanzhibo', 'Watch Live'), (0, _defineProperty3.default)(_all, 'goumai', 'Buy'), (0, _defineProperty3.default)(_all, 'goumaishangpin', 'Buy Product'), (0, _defineProperty3.default)(_all, 'yishouqing', 'Sold Out'), (0, _defineProperty3.default)(_all, 'qianggou', 'Buy Now'), (0, _defineProperty3.default)(_all, 'dashang', 'Reward'), (0, _defineProperty3.default)(_all, 'chakangg', 'Notice'), (0, _defineProperty3.default)(_all, 'quxiao', 'Cancel'), (0, _defineProperty3.default)(_all, 'queren', 'Confirm'), (0, _defineProperty3.default)(_all, 'wodequanbao', 'My Wallet'), (0, _defineProperty3.default)(_all, 'jiangjie', 'Explain'), (0, _defineProperty3.default)(_all, 'jiangjiezhong', 'Explaining'), (0, _defineProperty3.default)(_all, 'kucun', 'Stock'), (0, _defineProperty3.default)(_all, 'qrcodenotexist', 'QR Code not found'), (0, _defineProperty3.default)(_all, 'qrcodesaved', 'QR Code saved successfully'), (0, _defineProperty3.default)(_all, 'wodeqianbao', 'My Wallet'), (0, _defineProperty3.default)(_all, 'lianshangbaobishibei', 'On-chain Token'), (0, _defineProperty3.default)(_all, 'zonge', 'Total'), (0, _defineProperty3.default)(_all, 'keyongshuliang', 'Available'), (0, _defineProperty3.default)(_all, 'dongjieshuliang', 'Frozen'), (0, _defineProperty3.default)(_all, 'chakanliushui', 'View Transactions'), (0, _defineProperty3.default)(_all, 'chongzhitip', 'Only same-chain transfers supported. Blockchain confirmed transfers are irreversible.'), (0, _defineProperty3.default)(_all, 'chongzhishuliang', 'Deposit Amount'), (0, _defineProperty3.default)(_all, 'zuidicharge', 'Minimum deposit amount '), (0, _defineProperty3.default)(_all, 'xiaoyuzuixiaoe', 'Recharge below the minimum amount will not be credited'), (0, _defineProperty3.default)(_all, 'yujidaozhang', 'Estimated Arrival'), (0, _defineProperty3.default)(_all, 'shijidaozhang', 'Actual Received'), (0, _defineProperty3.default)(_all, 'lijichongzhi', 'Deposit Now'), (0, _defineProperty3.default)(_all, 'chongzhierweima', 'Deposit QR Code'), (0, _defineProperty3.default)(_all, 'chongbidizhi', 'Deposit Address'), (0, _defineProperty3.default)(_all, 'chongbixiangqing', 'Recharge Details'), (0, _defineProperty3.default)(_all, 'tibixiangqing', 'Withdrawal Details'), (0, _defineProperty3.default)(_all, 'fuzhidizhi', 'Copy Address'), (0, _defineProperty3.default)(_all, 'chongzhichenggong', 'Deposit Success'), (0, _defineProperty3.default)(_all, 'dengdaiquerenzhong', 'Waiting for confirmation...'), (0, _defineProperty3.default)(_all, 'baocunchenggong', 'Saved successfully'), (0, _defineProperty3.default)(_all, 'chongbichenggong', 'Deposit Successful'), (0, _defineProperty3.default)(_all, 'bizhong', 'Token'), (0, _defineProperty3.default)(_all, 'shuliang', 'Amount'), (0, _defineProperty3.default)(_all, 'shijian', 'Time'), (0, _defineProperty3.default)(_all, 'tibidizhi', 'Withdrawal Address'), (0, _defineProperty3.default)(_all, 'qingshurutibidizhi', 'Enter withdrawal address'), (0, _defineProperty3.default)(_all, 'tibishisuan', 'Withdrawal Estimate'), (0, _defineProperty3.default)(_all, 'zuiditixianjin', 'Minimum withdrawal amount'), (0, _defineProperty3.default)(_all, 'tibishenqingyitijiao', 'Withdrawal Request Submitted'), (0, _defineProperty3.default)(_all, 'tibishenqingdesc', 'After backend review, the on-chain withdrawal will proceed.'), (0, _defineProperty3.default)(_all, 'shenhezhong', 'Under Review'), (0, _defineProperty3.default)(_all, 'zhuangtai', 'Status'), (0, _defineProperty3.default)(_all, 'chakantibi', 'View Withdrawal Records'), (0, _defineProperty3.default)(_all, 'meiriyushutixian', 'Daily remaining withdrawal amount'), (0, _defineProperty3.default)(_all, 'keyongyu', 'Available balance'), (0, _defineProperty3.default)(_all, 'tijiaotibi', 'Submit Withdrawal'), (0, _defineProperty3.default)(_all, 'xuanzetibidizhi', 'Select Withdrawal Address'), (0, _defineProperty3.default)(_all, 'sousuodizhi', 'Search address'), (0, _defineProperty3.default)(_all, 'xuanze', 'Select'), (0, _defineProperty3.default)(_all, 'querentbi', 'Confirm Withdrawal'), (0, _defineProperty3.default)(_all, 'xuanzedashangbizhong', 'Select Reward Token'), (0, _defineProperty3.default)(_all, 'xuanzebizhong', 'Select Currency'), (0, _defineProperty3.default)(_all, 'chuzhidizhi', 'Deposit Address'), (0, _defineProperty3.default)(_all, 'yue', 'Balance'), (0, _defineProperty3.default)(_all, 'dashangjine', 'Reward Amount'), (0, _defineProperty3.default)(_all, 'zhanshidashangxinxi', 'Show reward information'), (0, _defineProperty3.default)(_all, 'zidingyi', 'Custom'), (0, _defineProperty3.default)(_all, 'querendashang', 'Confirm Reward'), (0, _defineProperty3.default)(_all, 'zaixianguanzhong', 'Viewers'), (0, _defineProperty3.default)(_all, 'yizhibo', 'Live'), (0, _defineProperty3.default)(_all, 'jieshizhibo', 'End Live'), (0, _defineProperty3.default)(_all, 'zhibozhong', 'Live'), (0, _defineProperty3.default)(_all, 'zanwuzaixianguanzhong', 'No viewers online'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', 'Video upload failed, please try again later'), (0, _defineProperty3.default)(_all, 'qingshurucontent', 'Please fill in the title and upload the video'), (0, _defineProperty3.default)(_all, 'fabuchenggong', 'Publish successful'), (0, _defineProperty3.default)(_all, 'fabushibai', 'Publish failed'), (0, _defineProperty3.default)(_all, 'qingshurushuju', 'Please enter data'), (0, _defineProperty3.default)(_all, 'confirmDelete', 'Confirm delete this video?'), (0, _defineProperty3.default)(_all, 'shanchuchenggong', 'Delete successful'), (0, _defineProperty3.default)(_all, 'confirmWithdraw', 'Confirm withdraw this video?'), (0, _defineProperty3.default)(_all, 'chehuichenggong', 'Withdraw successful'), (0, _defineProperty3.default)(_all, 'yongjiujinyan', 'Permanent Ban'), (0, _defineProperty3.default)(_all, 'jiaruzhibo', 'Join Live'), (0, _defineProperty3.default)(_all, 'jiaruxietongzhibo', 'Join Co-live'), (0, _defineProperty3.default)(_all, 'tuichuxietongzhibo', 'Exit Co-live'), (0, _defineProperty3.default)(_all, 'zhubojinyao', 'Co-host Key'), (0, _defineProperty3.default)(_all, 'qingshuruzhubojinyao', 'Please enter co-host key'), (0, _defineProperty3.default)(_all, 'jiaru', 'Join'), (0, _defineProperty3.default)(_all, 'shenqingchenggong', 'Application successful'), (0, _defineProperty3.default)(_all, 'youxiaoqi', 'Validity Period'), (0, _defineProperty3.default)(_all, 'tichubenchang', 'Kick Out'), (0, _defineProperty3.default)(_all, 'zhanshidashangxiaoxi', 'Show Tip Messages'), (0, _defineProperty3.default)(_all, 'zanwugonggao', 'No Notice'), (0, _defineProperty3.default)(_all, 'dashang', 'Tip'), (0, _defineProperty3.default)(_all, 'songgei', 'sent'), (0, _defineProperty3.default)(_all, 'ge', ''), (0, _defineProperty3.default)(_all, 'bi', 'tokens'), (0, _defineProperty3.default)(_all, 'zanweiyourenjiaruxietongzhibo', 'No one has joined the co-live yet'), (0, _defineProperty3.default)(_all, 'zanweikaiqi', 'Co-live streaming is not enabled yet'), _all)
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(61);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _all;

var _ja = __webpack_require__(281);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	all: (_all = {
		jiantizhongwen: '簡体字中国語',
		fantizhongwen: '繁体字中国語',
		yingwen: '英語',
		ribenyu: '日本語',
		hanguoyu: '韓国語',
		jizhuzhanghao: 'アカウントを記憶',
		jizhumima: 'パスワードを記憶',
		jizhuzhanghaomima: 'アカウントとパスワードを記憶',
		yuyanxuanze: '言語選択',
		shezhi: '設定',
		xiugaimima: 'パスワードの変更',
		yinsizhengce: 'プライバシーポリシー',
		guanyuwomen: '私たちについて',
		mimashuoming: 'パスワードは8〜20文字の大文字小文字の英字と数字の組み合わせでなければなりません。純粋な数字または純粋な英字は使用できません',
		qingshurujiumima: '古いパスワードを入力してください',
		qingshuruxinmima: '新しいパスワードを入力してください',
		quedingxiugai: '変更を確認',

		shouye: 'ホーム',
		zhibo: 'ライブ',
		wode: 'マイページ',
		xitongxiaoxi: 'システムメッセージ',
		wodedingdan: '私の注文',
		bangzhufankui: 'ヘルプフィードバック',
		xiugaiziliao: 'プロフィールの変更',
		xiaofeimingxi: '消費明細',
		zhibojilu: 'ライブ記録',
		tijiao: '提出',
		caozuochenggong: '操作成功',
		tishi: '通知',
		quedingtuichudengluma: 'ログアウトしますか？',
		queding: '確定',
		wentibangzhu: '問題ヘルプ',
		woyaofankui: 'フィードバック',
		fankuiwenti: 'フィードバック問題',
		qingmiaoshuniyaofankuidewenti: 'フィードバックしたい問題を説明してください...',
		sousuo: '検索',
		sousuoniganxingqudeneirong: '興味のあるコンテンツを検索',
		zhibojianbiaoti: 'ライブタイトル',
		zhibojianbeijing: 'ライブ背景',
		zhibojianfengmian: 'ライブカバー',
		xuanzebackground: '背景選択',
		shangchuanbeijing: '背景アップロード',
		yixuanze: '選択済み',
		qingxuanzebeijing: '背景を選択してください',
		zhibojianbiaoqian: 'ライブタグ',
		zhibojianhuazhi: 'ライブ画質',
		geinidezhibojianqugemingziba: 'ライブルームに名前を付けてください~',
		qingshurukaibomiyao: 'ストリームキーを入力してください',
		kaishizhibo: 'ライブを開始',
		shengyin: '音声',
		liwutexiao: 'ギフト効果',
		gengduo: 'もっと',
		gouwuche: 'ショッピングカート',
		zaixianguanzhong: 'オンライン視聴者',
		danmushuoming: 'プラットフォームは未成年者のチャージとチップを厳禁しています。遊び同伴などでチップを誘導したり、プライベート取引をしたりすることは禁止されています。また、ポルノ、政治、罵詈雑言などのコンテンツも禁止されています。財産の安全に注意し、ネット詐欺にご用心ください。理性的に消費してください。',
		tianjiaguanliyuan: '管理者を追加',
		jinyan: 'ミュート',
		jiechuejinyan: 'ミュート解除',
		tichufangjian: '部屋から追い出す',
		shangpinxiangqing: '商品詳細',
		lijijiagou: '即購入',
		xuanzeguige: '仕様を選択',
		quanbuliwu: '全てのギフト',
		ge: '個',
		bi: 'コイン',
		guanliyuan: '管理者',
		kuaijieduanyu: 'クイックフレーズ',
		gonggao: 'お知らせ',
		xinzengkuaijieduanyu: '新しいクイックフレーズ',
		qingshuru: '入力してください',
		qingshuruzhengque: '正しい金額を入力してください',
		shuru: '入力',
		wangjimima: 'パスワードを忘れた',
		youxiangzhuce: 'メール登録',
		huoquyanzhengma: '認証コードを取得',
		youxiang: 'メール',
		yanzhengma: '認証コード',
		anquanyanzheng: 'セキュリティ認証',
		fasongyanzhengma: '認証コード送信',
		qingshuruyouxiangyanzhengma: 'メール認証コードを入力してください',
		fasongchenggong: '送信成功',
		qingshuruningdeyouxiangzhanghao: 'メールアカウントを入力',
		qingshuruyanzhengma: '認証コードを入力してください',
		qingshurumima: 'パスワードを入力してください',
		mimadenglu: 'パスワードログイン',
		woyiyuedubingtongyi: '読みました。同意します',
		yonghuxieyi: '利用規約',
		yinsixieyi: 'プライバシー契約',
		denglu: 'ログイン',
		chongxindenglu: '再ログイン',
		xiayibu: '次のステップ',
		haimeizhanghao: 'アカウントをお持ちでない方',
		quzhuce: '登録に行く',
		yiyouzhanghao: 'アカウントをお持ちの方',
		qudenglu: 'ログインに行く',
		shezhijibenxinxi: '基本情報の設定',
		nichengtishi: '英字、数字、句読点のみ使用可能です。最小6文字、空白は使用できません',
		shezhiyonghuming: 'ユーザー名の設定',
		yonghumingtishi: 'ユーザー名は6〜18文字の大文字小文字の英字または数字です',
		shezhijiaoyimima: '取引パスワードの設定',
		jiaoyimimatishi: '取引パスワードは6桁の数字の組み合わせでなければなりません',
		qingxuanze: '選択してください',
		yaoqingma: '招待コード（任意）',
		qingshuruyaoqingma: '招待コードを入力',
		shezhixinmima: '新しいパスワードの設定',
		xuanzeningdeguojia: '国を選択',
		zhuce: '登録',
		qingshuruyonghuming: 'ユーザー名を入力してください',
		gaoqinghuazhi: '高清画質',
		biaoqinghuazhi: '標準画質',
		chaoqinghuazhi: '超清画質',
		putonghuazhi: '通常画質',
		zengsong: '贈る',
		jinrulezhibojian: 'ライブルームに入る',
		shuodianshenmene: '何か言いたいこと...',
		zanwushuju: 'データなし',
		songgei: '贈る',
		huifang: 'リプレイ',
		xunibi: '仮想通貨',
		quanbu: '全て',
		appxiazai: 'アプリダウンロード',
		dingdanjine: '注文金額',
		dingdanbianhao: '注文番号',
		chuangjianshijian: '作成時間',
		zhubozanshilikai: '配信者が一時的に離れています',
		mashanghuilai: 'すぐに戻ります',
		guojianzhuoxiazai: '国際版Androidダウンロード',
		anzhuoxiazai: 'Androidダウンロード',
		guojipingguoxiazai: '国際版iOSダウンロード',
		pingguoxiazai: 'iOSダウンロード',
		weixiazai: 'ダウンロードなし',
		quanbushangpin: '全ての商品',
		yiqiangguang: '売り切れ',
		jiagou: 'カートに追加',
		yixuan: '選択済み',
		xuanzeguiige: 'スペックを選択',
		xuazeguige: '仕様を選択',
		shangchuanzhong: 'アップロード中',
		shangchuanshibai: 'アップロード失敗',
		browserbu支持: 'ブラウザがメディアデバイスへのアクセスをサポートしていません',
		qingkaiqi: 'カメラとマイクの権限を有効にしてください',
		meiyoushebei: 'カメラまたはマイクデバイスが検出されません',
		shebeibeizhan: 'デバイスが他のプログラムによって使用されています。閉じてからやり直してください',
		quxianchengong: 'メディア権限の取得に失敗しました',
		shifouquedingjieshuzhibo: 'ライブを終了しますか？',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi: '利用規約とプライバシー契約を読み同意してください！',
		quedingqudengluma: 'ログインしますか？',
		remen: '人気',
		pinglun: 'コメント',
		huifu: '返信',
		shanchu: '削除',
		chakanhuifu: '返信を見る',
		jiazaizhong: '読み込み中',
		jiazaigengduo: 'もっと見る',
		meiyougengduo: 'コメントはこれ以上ありません',
		shuodianshenme: 'コメントを入力...',
		fasong: '送信',
		fabiao: '投稿',
		ganggang: 'たった今',
		fenzhongqian: '{n}分前',
		xiaoshiqian: '{n}時間前',
		tianqian: '{n}日前',
		shanchupinglun: 'このコメントを削除しますか？',
		duanyingyin: 'ショートビデオ',
		wofabu: '私の投稿',
		wodianzan: '私のいいね',
		woshoucang: '私のお気に入り',
		fabuduanyingyin: 'ショートビデオを公開',
		zhibohuaxu: 'ライブハイライト',
		qingshurubiaoti: 'タイトルを入力してください',
		shangchuanduanyingyin: 'ショートビデオをアップロード',
		yonghuzhuye: 'プロフィール',
		guanzhuta: 'フォロー',
		yiguanzhu: 'フォロー中',
		guanzhu: 'フォロー',
		fensi: 'ファン',
		guanzhong: 'フォロー中',
		huguan: '相互フォロー',
		shanchuguanzhu: 'フォロー解除',
		yichufensi: 'ファン削除',
		huiyuanid: '会員ID:',
		zhibozhongxin: 'ライブセンター',
		zongzichanguzhi: '総資産価値',
		liushuijilu: '取引履歴',
		chongbi: '入金',
		tibi: '出金',
		gaibizhongbuzhichichongzhi: 'この通貨は入金に対応していません',
		gaibizhongbuzhichitibi: 'この通貨は出金に対応していません',
		dashang: 'チップ',
		riqi: '日付',
		leixing: '種類',
		miaoshu: '説明',
		jine: '金額',
		zhuangtai: '状態',
		yiwancheng: '完了',
		shenhezhong: '審査中',
		shenhejujue: '審査却下',
		tibibeibohui: '出金が却下されました',
		zhidaole: '確認',
		bohuiyuanyin: '却下理由：',
		kaishiriqi: '開始日',
		jieshuriqi: '終了日',
		wangluo: 'ネットワーク',
		dizhi: 'アドレス',
		tibishuliang: '出金額',
		daozhangshisuan: '到着予測',
		shouxufei: '手数料',
		meiridaozhang: '毎日到着',
		keyong: '利用可能',
		dongjie: '凍結',
		zuixiaotibishuliang: '最小出金額',
		shouxufeibilv: '手数料',
		meirishenyueddu: '毎日残り限度額',
		shenqingzhibo: 'ライブ申請',
		shenqingjilu: '申請記録',
		huifangjilu: 'リプレイ記録',
		yikaifang: '開放済み',
		guankanhuifang: 'リプレイを見る',
		beisu: '速度',
		zhiboriqi: '配信日',
		shijianshiduan: '時間帯',
		shoujizhibo: 'モバイル配信',
		zhibodaihuo: 'ライブコマース',
		kaiqi: 'オン',
		guanbi: 'オフ',
		beizhu: '備考',
		huodongzhuti: 'テーマ、機器の説明',
		shenqinghouliucheng: '申請後の流れ',
		shenqinghouliuchengdesc: '審査通過後、配信アドレスがメールで送信されます。',
		daishenhe: '審査待ち',
		tijiaoshenqing: '申請を提出',
		qingxuanzeriqi: '配信日を選択してください',
		qingxuanzeshijian: '時間帯を選択してください',
		tijiaochenggong: '提出成功',
		nian: '年',
		yue: '月',
		tongshiduanbukezhongfu: '同時間帯は重複不可',
		keshenqingshiduan: '申請可能な時間帯',
		querenShiduan: '確認',
		zhanghaoid: 'アカウント ID',
		qingtianxie: '入力してください',
		zhou1: '月',
		zhou2: '火',
		zhou3: '水',
		zhou4: '木',
		zhou5: '金',
		zhou6: '土',
		zhou7: '日',
		shenqingyitijiao: '申請が提出されました',
		shenqingtijiaodesc: '管理者が配信ルーム、時間帯、商品情報を審査します。',
		chakanshenheJilu: '審査記録を確認',
		shenqingriqi: '申請日',
		zhiboshijianduan: '配信時間帯',
		zhiboleixing: '配信タイプ',
		daihuo: 'ライブコマース',
		yitongguo: '承認済み',
		weitongguo: '未承認',
		xiangqing: '詳細',
		yuanyin: '理由',
		shenqingxiangqing: '申請詳細',
		shenheyuanyin: '審査理由',
		xutiaozheng: '調整が必要',
		shenheyuanyindesc: 'この時間帯は占有されています。別の日付または時間帯を選択して再提出してください。',
		wancheng: '完了',
		chulizhong: '処理中',
		daichuli: '処理待ち',
		houtaishenhe: '管理者審査',
		chanshengmiyao: 'キー生成',
		youjiankuaidi: 'メール通知',
		kechakan: '閲覧可能',
		jinwanxinpinfuli: '今晩新商品ライブ',
		chehuishenqing: '申請を撤回',
		chongxinshenqing: '再申請',
		zhibojinyao: '配信キー',
		zhibojian: '配信ルーム',
		keyongshiduan: '利用可能時間',
		youxiao: '有効',
		tuiliudizhi: 'プッシュURL',
		tuiliumamiyao: 'ストリームキー',
		youjiantongzhidesc: '同じルームと時間帯ではキーは再生成されません。',
		yifasong: '送信済み',
		fuzhiquanbu: 'すべてコピー',
		fuzhichenggong: 'コピー成功',
		youjiantongzhi: 'メール通知',
		zhiboshenhetongguo: '配信審査通過',
		shoujianren: '受信者',
		youjianneirongdesc: '配信ルーム、利用可能時間帯、プッシュ/プルURL、キー、配信前設定入口を含みます',
		youjianbianhao: 'メールID',
		chongxinfasong: '再送信',
		yinyuedaren: '音楽',
		wudaodaren: 'ダンス',
		yanzhi: 'ビジュアル',
		jichushezhi: '基本設定',
		yishangchuan: 'アップロード済み',
		zhiboshangpin: '配信商品',
		laiziyunimall: 'UNImallストアから',
		jian: '件',
		zhiboliucheng: '配信フロー',
		liuchang: '滑らか',
		gaoqing: 'HD',
		chaoqing: '超HD',
		languang: 'ブルーレイ',
		tongguo: '通過',
		jinxingzhong: '進行中',
		daikaiqi: '待機中',
		qianzhizuoye: '事前準備',
		qingshangchuan: 'アップロード',
		shangpinxuhao: '番号',
		shangpinshoutu: '商品画像',
		shangpinmingcheng: '商品名',
		shangchengkucun: 'ストア在庫',
		zhibokucun: '配信在庫',
		shangchengjiage: 'ストア価格',
		zhibojiage: '配信価格',
		caozuo: '操作',
		yichu: '削除',
		zhibojiansetting: 'ルーム設定',
		kaiqishengyin: '音声オン',
		guanbishengyin: '音声オフ',
		kaiqidanmu: '弾幕オン',
		guanbidanmu: '弾幕オフ',
		kaiqimeiyan: '美顔オン',
		guanbimeiyan: '美顔オフ',
		kaiqimaikefeng: 'マイクオン',
		guanbimaikefeng: 'マイクオフ',
		kaiqimaike: 'マイクオン',
		guanbimaike: 'マイクオフ'
	}, (0, _defineProperty3.default)(_all, 'gonggao', 'お知らせ'), (0, _defineProperty3.default)(_all, 'fenxianglianjie', 'リンク共有'), (0, _defineProperty3.default)(_all, 'xietongzhibo', 'コラボ配信'), (0, _defineProperty3.default)(_all, 'yaoqingjinbo', 'アシスタント招待'), (0, _defineProperty3.default)(_all, 'tongyikongzhi', '一括管理'), (0, _defineProperty3.default)(_all, 'tichuzhubozb', '選択を削除'), (0, _defineProperty3.default)(_all, 'zhuborenshushangxian', 'アシスタント上限'), (0, _defineProperty3.default)(_all, 'ren', '人'), (0, _defineProperty3.default)(_all, 'tongzhibojinyao', '配信キーと同じ'), (0, _defineProperty3.default)(_all, 'zhuboquanxian', 'アシスタント権限'), (0, _defineProperty3.default)(_all, 'yunxufayan', '発言を許可'), (0, _defineProperty3.default)(_all, 'yunxukamai', 'マイクを許可'), (0, _defineProperty3.default)(_all, 'yunxukashipin', 'ビデオを許可'), (0, _defineProperty3.default)(_all, 'yikaiqi', '有効'), (0, _defineProperty3.default)(_all, 'shengchengyaoqingjinyao', '招待キーを生成'), (0, _defineProperty3.default)(_all, 'xietongzhiborenshu', 'コラボ配信人数'), (0, _defineProperty3.default)(_all, 'dangqianzhibo', '現在のアシスタント'), (0, _defineProperty3.default)(_all, 'kenenghaiyaoqing', 'あと招待可能'), (0, _defineProperty3.default)(_all, 'weizhibo', '名'), (0, _defineProperty3.default)(_all, 'baocunshangxian', '上限を保存'), (0, _defineProperty3.default)(_all, 'fenxiangyaoqing', '招待を共有'), (0, _defineProperty3.default)(_all, 'yaoqinglianjie', '招待リンク'), (0, _defineProperty3.default)(_all, 'fenxiangfangshi', '共有方法'), (0, _defineProperty3.default)(_all, 'fuzhilianjie', 'リンクをコピー'), (0, _defineProperty3.default)(_all, 'baocunerweima', 'QRコードを保存'), (0, _defineProperty3.default)(_all, 'fuzhiyaoqinglianjie', '招待リンクをコピー'), (0, _defineProperty3.default)(_all, 'zhubo', 'アシスタント'), (0, _defineProperty3.default)(_all, 'guanli', '管理'), (0, _defineProperty3.default)(_all, 'yijinru', '参加済み'), (0, _defineProperty3.default)(_all, 'maikefeng', 'マイク'), (0, _defineProperty3.default)(_all, 'shexiangtou', 'カメラ'), (0, _defineProperty3.default)(_all, 'guanbishexiangtou', 'カメラをオフ'), (0, _defineProperty3.default)(_all, 'kaiqishexiangtou', 'カメラをオン'), (0, _defineProperty3.default)(_all, 'guanbijingxiang', 'ミラーをオフ'), (0, _defineProperty3.default)(_all, 'kaiqijingxiang', 'ミラーをオン'), (0, _defineProperty3.default)(_all, 'sheweizhuyemian', 'メイン画面に設定'), (0, _defineProperty3.default)(_all, 'quxiaozhuyemian', 'メイン画面を解除'), (0, _defineProperty3.default)(_all, 'tichuzhibo', '配信ルームから削除'), (0, _defineProperty3.default)(_all, 'tichuhoubukejinru', '削除後は再入室できません'), (0, _defineProperty3.default)(_all, 'tongyikongmai', '一括マイク管理'), (0, _defineProperty3.default)(_all, 'quanjukongzhi', '全体管理'), (0, _defineProperty3.default)(_all, 'quantijingyin', '全員ミュート'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaimai', 'アシスタントのマイクを許可'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaishipin', 'アシスタントのビデオを許可'), (0, _defineProperty3.default)(_all, 'huifukaimai', 'ミュート解除'), (0, _defineProperty3.default)(_all, 'guanbishipin', 'ビデオ無効'), (0, _defineProperty3.default)(_all, 'kaiqishipin', 'ビデオオン'), (0, _defineProperty3.default)(_all, 'yunxushipin', 'ビデオ許可'), (0, _defineProperty3.default)(_all, 'yingyongshezhi', '設定を適用'), (0, _defineProperty3.default)(_all, 'shipin', 'ビデオ'), (0, _defineProperty3.default)(_all, 'kaimai', 'マイクオン'), (0, _defineProperty3.default)(_all, 'weikaiqi', 'オフ'), (0, _defineProperty3.default)(_all, 'shipinkaiqi', 'ビデオオン'), (0, _defineProperty3.default)(_all, 'shipinguanbi', 'ビデオオフ'), (0, _defineProperty3.default)(_all, 'bimai', 'ミュート'), (0, _defineProperty3.default)(_all, 'yunxufayan', 'チャット許可'), (0, _defineProperty3.default)(_all, 'jinzhifayan', 'チャット禁止'), (0, _defineProperty3.default)(_all, 'zhuboxiwei', 'コホスト席'), (0, _defineProperty3.default)(_all, 'guankanzhibo', '視聴する'), (0, _defineProperty3.default)(_all, 'goumai', '購入'), (0, _defineProperty3.default)(_all, 'goumaishangpin', '商品購入'), (0, _defineProperty3.default)(_all, 'yishouqing', '売り切れ'), (0, _defineProperty3.default)(_all, 'dashang', 'チップ'), (0, _defineProperty3.default)(_all, 'chakangg', 'お知らせ確認'), (0, _defineProperty3.default)(_all, 'quxiao', 'キャンセル'), (0, _defineProperty3.default)(_all, 'queren', '確認'), (0, _defineProperty3.default)(_all, 'wodequanbao', 'マイウォレット'), (0, _defineProperty3.default)(_all, 'jiangjie', '解説'), (0, _defineProperty3.default)(_all, 'jiangjiezhong', '解説中'), (0, _defineProperty3.default)(_all, 'kucun', '在庫'), (0, _defineProperty3.default)(_all, 'qrcodenotexist', 'QRコードが見つかりません'), (0, _defineProperty3.default)(_all, 'qrcodesaved', 'QRコードを保存しました'), (0, _defineProperty3.default)(_all, 'wodeqianbao', 'マイウォレット'), (0, _defineProperty3.default)(_all, 'lianshangbaobishibei', 'オンチェーントークン'), (0, _defineProperty3.default)(_all, 'zonge', '合計'), (0, _defineProperty3.default)(_all, 'keyongshuliang', '利用可能'), (0, _defineProperty3.default)(_all, 'dongjieshuliang', '凍結'), (0, _defineProperty3.default)(_all, 'chakanliushui', '取引履歴'), (0, _defineProperty3.default)(_all, 'chongzhitip', '同チェーンのみ対応。ブロックチェーン確認後の送金は取消不可。'), (0, _defineProperty3.default)(_all, 'chongzhishuliang', '入金額'), (0, _defineProperty3.default)(_all, 'zuidicharge', '最低入金額'), (0, _defineProperty3.default)(_all, 'xiaoyuzuixiaoe', '最小金額に満たないチャージは入金されません'), (0, _defineProperty3.default)(_all, 'yujidaozhang', '到着予定'), (0, _defineProperty3.default)(_all, 'shijidaozhang', '実際到着'), (0, _defineProperty3.default)(_all, 'lijichongzhi', '今すぐ入金'), (0, _defineProperty3.default)(_all, 'chongzhierweima', '入金QRコード'), (0, _defineProperty3.default)(_all, 'chongbidizhi', '入金アドレス'), (0, _defineProperty3.default)(_all, 'chongbixiangqing', 'チャージ詳細'), (0, _defineProperty3.default)(_all, 'tibixiangqing', '出金詳細'), (0, _defineProperty3.default)(_all, 'fuzhidizhi', 'アドレスをコピー'), (0, _defineProperty3.default)(_all, 'chongzhichenggong', '入金成功'), (0, _defineProperty3.default)(_all, 'dengdaiquerenzhong', '確認待ち...'), (0, _defineProperty3.default)(_all, 'baocunchenggong', '保存しました'), (0, _defineProperty3.default)(_all, 'chongbichenggong', '入金完了'), (0, _defineProperty3.default)(_all, 'bizhong', 'トークン'), (0, _defineProperty3.default)(_all, 'shuliang', '数量'), (0, _defineProperty3.default)(_all, 'shijian', '時間'), (0, _defineProperty3.default)(_all, 'tibidizhi', '出金アドレス'), (0, _defineProperty3.default)(_all, 'qingshurutibidizhi', '出金アドレスを入力してください'), (0, _defineProperty3.default)(_all, 'tibishisuan', '出金試算'), (0, _defineProperty3.default)(_all, 'zuiditixianjin', '最低出金額'), (0, _defineProperty3.default)(_all, 'tibishenqingyitijiao', '出金リクエストが送信されました'), (0, _defineProperty3.default)(_all, 'tibishenqingdesc', 'バックエンド審査後、チェーン上の出金が実行されます。'), (0, _defineProperty3.default)(_all, 'shenhezhong', '審査中'), (0, _defineProperty3.default)(_all, 'zhuangtai', 'ステータス'), (0, _defineProperty3.default)(_all, 'chakantibi', '出金履歴を見る'), (0, _defineProperty3.default)(_all, 'meiriyushutixian', '毎日残り出金額'), (0, _defineProperty3.default)(_all, 'keyongyu', '利用可能残高'), (0, _defineProperty3.default)(_all, 'tijiaotibi', '出金を提出'), (0, _defineProperty3.default)(_all, 'xuanzetibidizhi', '出金アドレスを選択'), (0, _defineProperty3.default)(_all, 'sousuodizhi', 'アドレスを検索'), (0, _defineProperty3.default)(_all, 'xuanze', '選択'), (0, _defineProperty3.default)(_all, 'querentbi', '出金確認'), (0, _defineProperty3.default)(_all, 'xuanzedashangbizhong', 'チップ通貨を選択'), (0, _defineProperty3.default)(_all, 'xuanzebizhong', '通貨を選択'), (0, _defineProperty3.default)(_all, 'chuzhidizhi', '入金アドレス'), (0, _defineProperty3.default)(_all, 'yue', '残高'), (0, _defineProperty3.default)(_all, 'dashangjine', 'チップ金額'), (0, _defineProperty3.default)(_all, 'zhanshidashangxinxi', 'チップ情報を表示'), (0, _defineProperty3.default)(_all, 'zidingyi', 'カスタム'), (0, _defineProperty3.default)(_all, 'querendashang', 'チップを確認'), (0, _defineProperty3.default)(_all, 'zaixianguanzhong', '視聴者'), (0, _defineProperty3.default)(_all, 'yizhibo', '配信中'), (0, _defineProperty3.default)(_all, 'jieshizhibo', '配信終了'), (0, _defineProperty3.default)(_all, 'zhibozhong', '配信中'), (0, _defineProperty3.default)(_all, 'zanwuzaixianguanzhong', '視聴者がいません'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', '動画のアップロードに失敗しました。しばらくしてから再試行してください'), (0, _defineProperty3.default)(_all, 'qingshurucontent', 'タイトルを入力して動画をアップロードしてください'), (0, _defineProperty3.default)(_all, 'fabuchenggong', '公開成功'), (0, _defineProperty3.default)(_all, 'fabushibai', '公開失敗'), (0, _defineProperty3.default)(_all, 'qingshurushuju', 'データを入力してください'), (0, _defineProperty3.default)(_all, 'confirmDelete', 'この動画を削除しますか？'), (0, _defineProperty3.default)(_all, 'shanchuchenggong', '削除成功'), (0, _defineProperty3.default)(_all, 'confirmWithdraw', 'この動画を撤回しますか？'), (0, _defineProperty3.default)(_all, 'chehuichenggong', '撤回成功'), (0, _defineProperty3.default)(_all, 'yongjiujinyan', '永久BAN'), (0, _defineProperty3.default)(_all, 'jiaruzhibo', 'ライブ参加'), (0, _defineProperty3.default)(_all, 'jiaruxietongzhibo', 'コラボライブ参加'), (0, _defineProperty3.default)(_all, 'tuichuxietongzhibo', 'コラボライブ退出'), (0, _defineProperty3.default)(_all, 'zhubojinyao', 'コラボキー'), (0, _defineProperty3.default)(_all, 'qingshuruzhubojinyao', 'コラボキーを入力してください'), (0, _defineProperty3.default)(_all, 'jiaru', '参加'), (0, _defineProperty3.default)(_all, 'shenqingchenggong', '申請成功'), (0, _defineProperty3.default)(_all, 'youxiaoqi', '有効期間'), (0, _defineProperty3.default)(_all, 'tichubenchang', '追放'), (0, _defineProperty3.default)(_all, 'zhanshidashangxiaoxi', '投げ銭メッセージを表示'), (0, _defineProperty3.default)(_all, 'zanwugonggao', 'お知らせはありません'), (0, _defineProperty3.default)(_all, 'dashang', '投げ銭'), (0, _defineProperty3.default)(_all, 'songgei', '贈呈'), (0, _defineProperty3.default)(_all, 'ge', '個'), (0, _defineProperty3.default)(_all, 'bi', 'コイン'), (0, _defineProperty3.default)(_all, 'zanweiyourenjiaruxietongzhibo', 'まだ誰もコラボ配信に参加していません'), (0, _defineProperty3.default)(_all, 'zanweikaiqi', 'コラボ配信はまだ有効になっていません'), _all)
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(61);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _all;

var _ko = __webpack_require__(282);

var _ko2 = _interopRequireDefault(_ko);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	all: (_all = {
		jiantizhongwen: '간체 중국어',
		fantizhongwen: '번체 중국어',
		yingwen: '영어',
		ribenyu: '일본어',
		hanguoyu: '한국어',
		jizhuzhanghao: '계정 기억',
		jizhumima: '비밀번호 기억',
		jizhuzhanghaomima: '계정 및 비밀번호 기억',
		yuyanxuanze: '언어 선택',
		shezhi: '설정',
		xiugaimima: '비밀번호 변경',
		yinsizhengce: '개인정보 보호 정책',
		guanyuwomen: '우리에 대하여',
		mimashuoming: '비밀번호는 8~20자 대소문자와 숫자의 조합이어야 하며, 순수 숫자 또는 순수 영문은 안 됩니다',
		qingshurujiumima: '기존 비밀번호를 입력해주세요',
		qingshuruxinmima: '새 비밀번호를 입력해주세요',
		quedingxiugai: '변경 확인',

		shouye: '홈',
		zhibo: '라이브',
		wode: '마이페이지',
		xitongxiaoxi: '시스템 메시지',
		wodedingdan: '내 주문',
		bangzhufankui: '도움 및 피드백',
		xiugaiziliao: '프로필 수정',
		xiaofeimingxi: '소비 내역',
		zhibojilu: '라이브 기록',
		tijiao: '제출',
		caozuochenggong: '작업 성공',
		tishi: '알림',
		quedingtuichudengluma: '로그아웃 하시겠습니까?',
		queding: '확인',
		wentibangzhu: '문제 도움',
		woyaofankui: '피드백',
		fankuiwenti: '피드백 문제',
		qingmiaoshuniyaofankuidewenti: '피드백하고 싶은 문제를 설명해주세요...',
		sousuo: '검색',
		sousuoniganxingqudeneirong: '관심 있는 내용 검색',
		zhibojianbiaoti: '라이브 제목',
		zhibojianbeijing: '라이브 배경',
		zhibojianfengmian: '라이브 커버',
		xuanzebackground: '배경 선택',
		shangchuanbeijing: '배경 업로드',
		yixuanze: '선택됨',
		qingxuanzebeijing: '배경을 선택해주세요',
		zhibojianbiaoqian: '라이브 태그',
		zhibojianhuazhi: '라이브 화질',
		geinidezhibojianqugemingziba: '라이브 방에 이름을 지어주세요~',
		qingshurukaibomiyao: '스트림 키를 입력해주세요',
		kaishizhibo: '라이브 시작',
		shengyin: '소리',
		liwutexiao: '선물 효과',
		gengduo: '더 보기',
		gouwuche: '쇼핑 카트',
		zaixianguanzhong: '온라인 시청자',
		danmushuoming: '플랫폼은 미성년자의 충전 및 팁을 엄격히 금지합니다. 동료 놀이 등으로 팁을 유도하거나 개인 거래하는 행위를 금지합니다. 음란물, 정치적 내용, 욕설 등을 금지합니다. 재산 안전에 유의하시고, 인터넷 사기에 주의하세요. 합리적인 소비를 해주세요.',
		tianjiaguanliyuan: '관리자 추가',
		jinyan: '음소거',
		jiechuejinyan: '음소거 해제',
		tichufangjian: '방에서 추방',
		shangpinxiangqing: '상품 상세',
		lijijiagou: '즉시 구매',
		xuanzeguige: '규격 선택',
		quanbuliwu: '모든 선물',
		ge: '개',
		bi: '코인',
		guanliyuan: '관리자',
		kuaijieduanyu: '빠른 문구',
		gonggao: '공지',
		xinzengkuaijieduanyu: '새 빠른 문구',
		qingshuru: '입력해주세요',
		qingshuruzhengque: '올바른 금액을 입력해주세요',
		shuru: '입력',
		wangjimima: '비밀번호를 잊으셨나요',
		youxiangzhuce: '이메일 등록',
		huoquyanzhengma: '인증 코드 받기',
		youxiang: '이메일',
		yanzhengma: '인증 코드',
		anquanyanzheng: '보안 인증',
		fasongyanzhengma: '인증 코드 발송',
		qingshuruyouxiangyanzhengma: '이메일 인증 코드를 입력해주세요',
		fasongchenggong: '발송 성공',
		qingshuruningdeyouxiangzhanghao: '이메일 계정을 입력해주세요',
		qingshuruyanzhengma: '인증 코드를 입력해주세요',
		qingshurumima: '비밀번호를 입력해주세요',
		mimadenglu: '비밀번호 로그인',
		woyiyuedubingtongyi: '읽었습니다. 동의합니다',
		yonghuxieyi: '이용 약관',
		yinsixieyi: '개인정보 보호 약관',
		denglu: '로그인',
		chongxindenglu: '다시 로그인',
		xiayibu: '다음 단계',
		haimeizhanghao: '아직 계정이 없으신가요',
		quzhuce: '가입하러 가기',
		yiyouzhanghao: '이미 계정이 있으신가요',
		qudenglu: '로그인하러 가기',
		shezhijibenxinxi: '기본 정보 설정',
		nichengtishi: '영문, 숫자, 구두점만 사용 가능합니다. 최소 6자, 공백은 사용할 수 없습니다',
		shezhiyonghuming: '사용자 이름 설정',
		yonghumingtishi: '사용자 이름은 6~18자 대소문자 또는 숫자입니다',
		shezhijiaoyimima: '거래 비밀번호 설정',
		jiaoyimimatishi: '거래 비밀번호는 6자리 숫자의 조합이어야 합니다',
		qingxuanze: '선택해주세요',
		yaoqingma: '초대 코드 (선택)',
		qingshuruyaoqingma: '초대 코드를 입력해주세요',
		shezhixinmima: '새 비밀번호 설정',
		xuanzeningdeguojia: '국가를 선택해주세요',
		zhuce: '가입',
		qingshuruyonghuming: '사용자 이름을 입력해주세요',
		gaoqinghuazhi: '고화질',
		putonghuazhi: '보통 화질',
		zengsong: '선물하기',
		jinrulezhibojian: '라이브 방에 입장',
		shuodianshenmene: '무엇을 말하고 싶으신가요...',
		zanwushuju: '데이터 없음',
		songgei: '선물하기',
		huifang: '재생',
		xunibi: '가상 화폐',
		quanbu: '모든',
		appxiazai: '앱 다운로드',
		dingdanjine: '주문 금액',
		dingdanbianhao: '주문 번호',
		chuangjianshijian: '생성 시간',
		zhubozanshilikai: '방송인이 일시적으로 떠났습니다',
		mashanghuilai: '곧 돌아옵니다',
		guojianzhuoxiazai: '국제 버전 안드로이드 다운로드',
		anzhuoxiazai: '안드로이드 다운로드',
		guojipingguoxiazai: '국제 버전 iOS 다운로드',
		pingguoxiazai: 'iOS 다운로드',
		weixiazai: '다운로드 없음',
		quanbushangpin: '모든 상품',
		yiqiangguang: '품절',
		jiagou: '장바구니에 추가',
		yixuan: '선택됨',
		xuazeguige: '규격 선택',
		shangchuanzhong: '업로드 중',
		shangchuanshibai: '업로드 실패',
		shifouquedingjieshuzhibo: '라이브를 종료하시겠습니까?',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi: '이용 약관과 개인정보 보호 약관을 읽고 동의해주세요!',
		quedingqudengluma: '로그인하시겠습니까?',
		remen: '인기',
		pinglun: '댓글',
		huifu: '답글',
		shanchu: '삭제',
		chakanhuifu: '답글 보기',
		jiazaizhong: '로딩 중',
		jiazaigengduo: '더 보기',
		meiyougengduo: '더 이상 댓글이 없습니다',
		shuodianshenme: '댓글을 입력하세요...',
		fasong: '보내기',
		fabiao: '게시',
		ganggang: '방금 전',
		fenzhongqian: '{n}분 전',
		xiaoshiqian: '{n}시간 전',
		tianqian: '{n}일 전',
		shanchupinglun: '이 댓글을 삭제하시겠습니까?',
		duanyingyin: '단영상',
		wofabu: '내가 올린',
		wodianzan: '내가 좋아요',
		woshoucang: '내가 추가한',
		fabuduanyingyin: '단영상 게시',
		zhibohuaxu: '라이브 하이라이트',
		qingshurubiaoti: '제목을 입력해주세요',
		shangchuanduanyingyin: '단영상 업로드',
		yonghuzhuye: '프로필',
		guanzhuta: '팔로우',
		yiguanzhu: '팔로잉',
		guanzhu: '팔로우',
		fensi: '팬',
		guanzhong: '팔로잉',
		huguan: '서로 팔로우',
		shanchuguanzhu: '팔로우 취소',
		yichufensi: '팬 삭제',
		huiyuanid: '회원 ID:',
		zhibozhongxin: '라이브 센터',
		zongzichanguzhi: '총 자산 가치',
		liushuijilu: '거래 내역',
		chongbi: '입금',
		tibi: '출금',
		gaibizhongbuzhichichongzhi: '해당 통화는 입금을 지원하지 않습니다',
		gaibizhongbuzhichitibi: '해당 통화는 출금을 지원하지 않습니다',
		dashang: '팁',
		riqi: '날짜',
		leixing: '유형',
		miaoshu: '설명',
		jine: '금액',
		zhuangtai: '상태',
		yiwancheng: '완료',
		shenhezhong: '심사 중',
		shenhejujue: '심사 거절',
		tibibeibohui: '출금 거절',
		zhidaole: '확인',
		bohuiyuanyin: '거절 사유: ',
		kaishiriqi: '시작일',
		jieshuriqi: '종료일',
		wangluo: '네트워크',
		dizhi: '주소',
		tibishuliang: '출금 금액',
		daozhangshisuan: '도착 예측',
		shouxufei: '수수료',
		meiridaozhang: '매일 도착',
		keyong: '사용 가능',
		dongjie: '동결',
		zuixiaotibishuliang: '최소 출금 금액',
		shouxufeibilv: '수수료',
		meirishenyueddu: '일일 잔여 한도',
		shenqingzhibo: '라이브 신청',
		shenqingjilu: '신청 기록',
		huifangjilu: '다시보기 기록',
		yikaifang: '개방됨',
		guankanhuifang: '다시보기',
		beisu: '배속',
		zhiboriqi: '방송 날짜',
		shijianshiduan: '시간대',
		shoujizhibo: '모바일 방송',
		zhibodaihuo: '라이브 커머스',
		kaiqi: '켜기',
		guanbi: '끄기',
		beizhu: '비고',
		huodongzhuti: '활동 주제, 장비 설명',
		shenqinghouliucheng: '신청 후 절차',
		shenqinghouliuchengdesc: '승인 후 방송 주소가 이메일로 발송됩니다.',
		daishenhe: '심사 대기',
		tijiaoshenqing: '신청 제출',
		qingxuanzeriqi: '방송 날짜를 선택해주세요',
		qingxuanzeshijian: '시간대를 선택해주세요',
		tijiaochenggong: '제출 성공',
		nian: '년',
		yue: '월',
		tongshiduanbukezhongfu: '같은 시간대 중복 불가',
		keshenqingshiduan: '신청 가능 시간대',
		querenShiduan: '확인',
		zhanghaoid: '계정 ID',
		qingtianxie: '입력해주세요',
		zhou1: '월',
		zhou2: '화',
		zhou3: '수',
		zhou4: '목',
		zhou5: '금',
		zhou6: '토',
		zhou7: '일',
		shenqingyitijiao: '신청이 제출되었습니다',
		shenqingtijiaodesc: '관리자가 방송방, 시간대 및 상품 정보를 심사합니다.',
		chakanshenheJilu: '심사 기록 보기',
		shenqingriqi: '신청일',
		zhiboshijianduan: '방송 시간대',
		zhiboleixing: '방송 유형',
		daihuo: '라이브 커머스',
		yitongguo: '승인됨',
		weitongguo: '미승인',
		xiangqing: '상세',
		yuanyin: '사유',
		shenqingxiangqing: '신청 상세',
		shenheyuanyin: '심사 사유',
		xutiaozheng: '조정 필요',
		shenheyuanyindesc: '해당 시간대가 이미 사용 중입니다. 다른 날짜 또는 시간대를 선택하여 다시 제출해주세요.',
		wancheng: '완료',
		chulizhong: '처리 중',
		daichuli: '처리 대기',
		houtaishenhe: '관리자 심사',
		chanshengmiyao: '키 생성',
		youjiankuaidi: '이메일 알림',
		kechakan: '열람 가능',
		jinwanxinpinfuli: '오늘 밤 신상품 라이브',
		chehuishenqing: '신청 철회',
		chongxinshenqing: '다시 신청',
		zhibojinyao: '방송 키',
		zhibojian: '방송방',
		keyongshiduan: '사용 가능 시간',
		youxiao: '유효',
		tuiliudizhi: '푸시 URL',
		tuiliumamiyao: '스트림 키',
		youjiantongzhidesc: '같은 방과 시간대에서는 키가 다시 생성되지 않습니다.',
		yifasong: '발송됨',
		fuzhiquanbu: '전체 복사',
		fuzhichenggong: '복사 성공',
		youjiantongzhi: '이메일 알림',
		zhiboshenhetongguo: '방송 승인됨',
		shoujianren: '수신자',
		youjianneirongdesc: '방송방, 사용 가능 시간대, 푸시/풀 URL, 키 및 방송 전 설정 입구를 포함합니다',
		youjianbianhao: '메일 ID',
		chongxinfasong: '재발송',
		yinyuedaren: '음악',
		wudaodaren: '댄스',
		yanzhi: '비주얼',
		jichushezhi: '기본 설정',
		yishangchuan: '업로드됨',
		zhiboshangpin: '방송 상품',
		laiziyunimall: 'UNImall 스토어에서',
		jian: '개',
		zhiboliucheng: '방송 절차',
		liuchang: '원활',
		gaoqing: 'HD',
		chaoqing: '울트라 HD',
		languang: '블루레이',
		tongguo: '통과',
		jinxingzhong: '진행 중',
		daikaiqi: '대기',
		qianzhizuoye: '사전 설정',
		qingshangchuan: '업로드',
		shangpinxuhao: '번호',
		shangpinshoutu: '상품 이미지',
		shangpinmingcheng: '상품명',
		shangchengkucun: '스토어 재고',
		zhibokucun: '방송 재고',
		shangchengjiage: '스토어 가격',
		zhibojiage: '방송 가격',
		caozuo: '작업',
		yichu: '삭제',
		zhibojiansetting: '방 설정',
		kaiqishengyin: '소리 켜기',
		guanbishengyin: '소리 끄기',
		kaiqidanmu: '탄막 켜기',
		guanbidanmu: '탄막 끄기',
		kaiqimeiyan: '뷰티 켜기',
		guanbimeiyan: '뷰티 끄기',
		kaiqimaikefeng: '마이크 켜기',
		guanbimaikefeng: '마이크 끄기',
		kaiqimaike: '마이크 켜기',
		guanbimaike: '마이크 끄기'
	}, (0, _defineProperty3.default)(_all, 'gonggao', '공지'), (0, _defineProperty3.default)(_all, 'fenxianglianjie', '링크 공유'), (0, _defineProperty3.default)(_all, 'xietongzhibo', '협동 방송'), (0, _defineProperty3.default)(_all, 'yaoqingjinbo', '보조 진행자 초대'), (0, _defineProperty3.default)(_all, 'tongyikongzhi', '통합 제어'), (0, _defineProperty3.default)(_all, 'tichuzhubozb', '선택 제거'), (0, _defineProperty3.default)(_all, 'zhuborenshushangxian', '보조 진행자 상한'), (0, _defineProperty3.default)(_all, 'ren', '명'), (0, _defineProperty3.default)(_all, 'tongzhibojinyao', '방송 키와 동일'), (0, _defineProperty3.default)(_all, 'zhuboquanxian', '보조 진행자 권한'), (0, _defineProperty3.default)(_all, 'yunxufayan', '발언 허용'), (0, _defineProperty3.default)(_all, 'yunxukamai', '마이크 허용'), (0, _defineProperty3.default)(_all, 'yunxukashipin', '비디오 허용'), (0, _defineProperty3.default)(_all, 'yikaiqi', '활성화됨'), (0, _defineProperty3.default)(_all, 'shengchengyaoqingjinyao', '초대 키 생성'), (0, _defineProperty3.default)(_all, 'xietongzhiborenshu', '협동 방송 인원'), (0, _defineProperty3.default)(_all, 'dangqianzhibo', '현재 보조 진행자'), (0, _defineProperty3.default)(_all, 'kenenghaiyaoqing', '추가 초대 가능'), (0, _defineProperty3.default)(_all, 'weizhibo', '명'), (0, _defineProperty3.default)(_all, 'baocunshangxian', '상한 저장'), (0, _defineProperty3.default)(_all, 'fenxiangyaoqing', '초대 공유'), (0, _defineProperty3.default)(_all, 'yaoqinglianjie', '초대 링크'), (0, _defineProperty3.default)(_all, 'fenxiangfangshi', '공유 방법'), (0, _defineProperty3.default)(_all, 'fuzhilianjie', '링크 복사'), (0, _defineProperty3.default)(_all, 'baocunerweima', 'QR코드 저장'), (0, _defineProperty3.default)(_all, 'fuzhiyaoqinglianjie', '초대 링크 복사'), (0, _defineProperty3.default)(_all, 'zhubo', '보조 진행자'), (0, _defineProperty3.default)(_all, 'guanli', '관리'), (0, _defineProperty3.default)(_all, 'yijinru', '입장함'), (0, _defineProperty3.default)(_all, 'maikefeng', '마이크'), (0, _defineProperty3.default)(_all, 'shexiangtou', '카메라'), (0, _defineProperty3.default)(_all, 'guanbishexiangtou', '카메라 끄기'), (0, _defineProperty3.default)(_all, 'kaiqishexiangtou', '카메라 켜기'), (0, _defineProperty3.default)(_all, 'guanbijingxiang', '미러 끄기'), (0, _defineProperty3.default)(_all, 'kaiqijingxiang', '미러 켜기'), (0, _defineProperty3.default)(_all, 'sheweizhuyemian', '메인 화면으로 설정'), (0, _defineProperty3.default)(_all, 'quxiaozhuyemian', '메인 화면 해제'), (0, _defineProperty3.default)(_all, 'tichuzhibo', '방송방에서 제거'), (0, _defineProperty3.default)(_all, 'tichuhoubukejinru', '제거 후 재입장 불가'), (0, _defineProperty3.default)(_all, 'tongyikongmai', '통합 마이크 제어'), (0, _defineProperty3.default)(_all, 'quanjukongzhi', '전체 제어'), (0, _defineProperty3.default)(_all, 'quantijingyin', '전체 음소거'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaimai', '보조 진행자 마이크 허용'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaishipin', '보조 진행자 비디오 허용'), (0, _defineProperty3.default)(_all, 'huifukaimai', '음소거 해제'), (0, _defineProperty3.default)(_all, 'guanbishipin', '비디오 끄기'), (0, _defineProperty3.default)(_all, 'kaiqishipin', '비디오 켜기'), (0, _defineProperty3.default)(_all, 'yunxushipin', '비디오 허용'), (0, _defineProperty3.default)(_all, 'yingyongshezhi', '설정 적용'), (0, _defineProperty3.default)(_all, 'shipin', '비디오'), (0, _defineProperty3.default)(_all, 'kaimai', '마이크 켜짐'), (0, _defineProperty3.default)(_all, 'weikaiqi', '꺼짐'), (0, _defineProperty3.default)(_all, 'shipinkaiqi', '비디오 켜짐'), (0, _defineProperty3.default)(_all, 'shipinguanbi', '비디오 꺼짐'), (0, _defineProperty3.default)(_all, 'bimai', '음소거'), (0, _defineProperty3.default)(_all, 'yunxufayan', '채팅 허용'), (0, _defineProperty3.default)(_all, 'jinzhifayan', '채팅 금지'), (0, _defineProperty3.default)(_all, 'zhuboxiwei', '코호스트 좌석'), (0, _defineProperty3.default)(_all, 'guankanzhibo', '시청하기'), (0, _defineProperty3.default)(_all, 'goumai', '구매'), (0, _defineProperty3.default)(_all, 'goumaishangpin', '상품 구매'), (0, _defineProperty3.default)(_all, 'yishouqing', '매진'), (0, _defineProperty3.default)(_all, 'dashang', '선물'), (0, _defineProperty3.default)(_all, 'chakangg', '공지 확인'), (0, _defineProperty3.default)(_all, 'quxiao', '취소'), (0, _defineProperty3.default)(_all, 'queren', '확인'), (0, _defineProperty3.default)(_all, 'wodequanbao', '내 지갑'), (0, _defineProperty3.default)(_all, 'jiangjie', '설명'), (0, _defineProperty3.default)(_all, 'jiangjiezhong', '설명 중'), (0, _defineProperty3.default)(_all, 'kucun', '재고'), (0, _defineProperty3.default)(_all, 'qrcodenotexist', 'QR코드를 찾을 수 없습니다'), (0, _defineProperty3.default)(_all, 'qrcodesaved', 'QR코드를 저장했습니다'), (0, _defineProperty3.default)(_all, 'wodeqianbao', '내 지갑'), (0, _defineProperty3.default)(_all, 'lianshangbaobishibei', '온체인 토큰'), (0, _defineProperty3.default)(_all, 'zonge', '총액'), (0, _defineProperty3.default)(_all, 'keyongshuliang', '사용 가능'), (0, _defineProperty3.default)(_all, 'dongjieshuliang', '동결'), (0, _defineProperty3.default)(_all, 'chakanliushui', '거래 내역 보기'), (0, _defineProperty3.default)(_all, 'chongzhitip', '같은 체인만 지원됩니다. 블록체인 확인 후 전송은 취소할 수 없습니다.'), (0, _defineProperty3.default)(_all, 'chongzhishuliang', '입금액'), (0, _defineProperty3.default)(_all, 'zuidicharge', '최소 입금 금액 '), (0, _defineProperty3.default)(_all, 'xiaoyuzuixiaoe', '최소 금액보다 적게 충전하면 입금되지 않습니다'), (0, _defineProperty3.default)(_all, 'yujidaozhang', '도착 예정'), (0, _defineProperty3.default)(_all, 'shijidaozhang', '실제 도착'), (0, _defineProperty3.default)(_all, 'lijichongzhi', '즉시 입금'), (0, _defineProperty3.default)(_all, 'chongzhierweima', '입금 QR코드'), (0, _defineProperty3.default)(_all, 'chongbidizhi', '입금 주소'), (0, _defineProperty3.default)(_all, 'chongbixiangqing', '충전 상세'), (0, _defineProperty3.default)(_all, 'tibixiangqing', '출금 상세'), (0, _defineProperty3.default)(_all, 'fuzhidizhi', '주소 복사'), (0, _defineProperty3.default)(_all, 'chongzhichenggong', '입금 성공'), (0, _defineProperty3.default)(_all, 'dengdaiquerenzhong', '확인 대기 중...'), (0, _defineProperty3.default)(_all, 'baocunchenggong', '저장 완료'), (0, _defineProperty3.default)(_all, 'chongbichenggong', '입금 완료'), (0, _defineProperty3.default)(_all, 'bizhong', '토큰'), (0, _defineProperty3.default)(_all, 'shuliang', '수량'), (0, _defineProperty3.default)(_all, 'shijian', '시간'), (0, _defineProperty3.default)(_all, 'tibidizhi', '출금 주소'), (0, _defineProperty3.default)(_all, 'qingshurutibidizhi', '출금 주소를 입력하세요'), (0, _defineProperty3.default)(_all, 'tibishisuan', '출금 예상'), (0, _defineProperty3.default)(_all, 'zuiditixianjin', '최소 출금 금액'), (0, _defineProperty3.default)(_all, 'tibishenqingyitijiao', '출금 신청이 제출되었습니다'), (0, _defineProperty3.default)(_all, 'tibishenqingdesc', '백엔드 검토 후 체인 출금이 진행됩니다.'), (0, _defineProperty3.default)(_all, 'shenhezhong', '검토 중'), (0, _defineProperty3.default)(_all, 'zhuangtai', '상태'), (0, _defineProperty3.default)(_all, 'chakantibi', '출금 기록 보기'), (0, _defineProperty3.default)(_all, 'meiriyushutixian', '매일 남은 출금 금액'), (0, _defineProperty3.default)(_all, 'keyongyu', '사용 가능 잔액'), (0, _defineProperty3.default)(_all, 'tijiaotibi', '출금 제출'), (0, _defineProperty3.default)(_all, 'xuanzetibidizhi', '출금 주소 선택'), (0, _defineProperty3.default)(_all, 'sousuodizhi', '주소 검색'), (0, _defineProperty3.default)(_all, 'xuanze', '선택'), (0, _defineProperty3.default)(_all, 'querentbi', '출금 확인'), (0, _defineProperty3.default)(_all, 'xuanzedashangbizhong', '선물 토큰 선택'), (0, _defineProperty3.default)(_all, 'xuanzebizhong', '통화 선택'), (0, _defineProperty3.default)(_all, 'chuzhidizhi', '입금 주소'), (0, _defineProperty3.default)(_all, 'yue', '잔액'), (0, _defineProperty3.default)(_all, 'dashangjine', '선물 금액'), (0, _defineProperty3.default)(_all, 'zhanshidashangxinxi', '선물 정보 보기'), (0, _defineProperty3.default)(_all, 'zidingyi', '직접 입력'), (0, _defineProperty3.default)(_all, 'querendashang', '선물 확인'), (0, _defineProperty3.default)(_all, 'zaixianguanzhong', '시청자'), (0, _defineProperty3.default)(_all, 'yizhibo', '방송 중'), (0, _defineProperty3.default)(_all, 'jieshizhibo', '방송 종료'), (0, _defineProperty3.default)(_all, 'zhibozhong', '방송 중'), (0, _defineProperty3.default)(_all, 'zanwuzaixianguanzhong', '시청자가 없습니다'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', '비디오 업로드에 실패했습니다. 나중에 다시 시도해주세요'), (0, _defineProperty3.default)(_all, 'qingshurucontent', '제목을 입력하고 비디오를 업로드해주세요'), (0, _defineProperty3.default)(_all, 'fabuchenggong', '게시 성공'), (0, _defineProperty3.default)(_all, 'fabushibai', '게시 실패'), (0, _defineProperty3.default)(_all, 'qingshurushuju', '데이터를 입력해주세요'), (0, _defineProperty3.default)(_all, 'confirmDelete', '이 비디오를 삭제하시겠습니까?'), (0, _defineProperty3.default)(_all, 'shanchuchenggong', '삭제 성공'), (0, _defineProperty3.default)(_all, 'confirmWithdraw', '이 비디오를 철회하시겠습니까?'), (0, _defineProperty3.default)(_all, 'chehuichenggong', '철회 성공'), (0, _defineProperty3.default)(_all, 'yongjiujinyan', '영구 밴'), (0, _defineProperty3.default)(_all, 'jiaruzhibo', '라이브 참가'), (0, _defineProperty3.default)(_all, 'jiaruxietongzhibo', '협동 라이브 참가'), (0, _defineProperty3.default)(_all, 'tuichuxietongzhibo', '협동 라이브 탈퇴'), (0, _defineProperty3.default)(_all, 'zhubojinyao', '협동 라이브 키'), (0, _defineProperty3.default)(_all, 'qingshuruzhubojinyao', '협동 라이브 키를 입력해주세요'), (0, _defineProperty3.default)(_all, 'jiaru', '참가'), (0, _defineProperty3.default)(_all, 'shenqingchenggong', '신청 성공'), (0, _defineProperty3.default)(_all, 'youxiaoqi', '유효 기간'), (0, _defineProperty3.default)(_all, 'tichubenchang', '강퇴'), (0, _defineProperty3.default)(_all, 'zhanshidashangxiaoxi', '팁 메시지 표시'), (0, _defineProperty3.default)(_all, 'zanwugonggao', '공지사항 없음'), (0, _defineProperty3.default)(_all, 'dashang', '팁'), (0, _defineProperty3.default)(_all, 'songgei', '보냄'), (0, _defineProperty3.default)(_all, 'ge', '개'), (0, _defineProperty3.default)(_all, 'bi', '코인'), (0, _defineProperty3.default)(_all, 'zanweiyourenjiaruxietongzhibo', '아직 공동 방송에 참여한 사람이 없습니다'), (0, _defineProperty3.default)(_all, 'zanweikaiqi', '공동 방송이 아직 활성화되지 않았습니다'), _all)
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(61);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _all;

var _zhTW = __webpack_require__(283);

var _zhTW2 = _interopRequireDefault(_zhTW);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	all: (_all = {
		jiantizhongwen: '簡體中文',
		fantizhongwen: '繁體中文',
		yingwen: '英文',
		ribenyu: '日文',
		hanguoyu: '韓文',
		jizhuzhanghao: '記住帳號',
		jizhumima: '記住密碼',
		jizhuzhanghaomima: '記住帳號密碼',
		yuyanxuanze: '語言選擇',
		shezhi: '設置',
		xiugaimima: '修改密碼',
		yinsizhengce: '私隱政策',
		guanyuwomen: '關於我們',
		mimashuoming: '密碼必須是8-20位大小寫字母和數字組合，不能是純數字或純字母',
		qingshurujiumima: '請輸入舊密碼',
		qingshuruxinmima: '請輸入新密碼',
		quedingxiugai: '確定修改',

		shouye: '首頁',
		zhibo: '直播',
		wode: '我的',
		xitongxiaoxi: '系統消息',
		wodedingdan: '我的訂單',
		bangzhufankui: '幫助反饋',
		xiugaiziliao: '修改資料',
		xiaofeimingxi: '消費明細',
		zhibojilu: '直播記錄',
		tijiao: '提交',
		caozuochenggong: '操作成功',
		tishi: '提示',
		quedingtuichudenglu: '確定退出登錄嗎？',
		queding: '確定',
		wentibangzhu: '問題幫助',
		woyaofankui: '我要反饋',
		fankuiwenti: '反饋問題',
		qingmiaoshuniyaofankuidewenti: '請描繪你要反饋的問題...',
		sousuo: '搜尋',
		sousuoniganxingqudeneirong: '搜尋你感興趣的內容',
		zhibojianbiaoti: '直播間標題',
		zhibojianbeijing: '直播間背景',
		zhibojianfengmian: '直播間封面',
		xuanzebackground: '選擇背景',
		shangchuanbeijing: '上傳背景',
		yixuanze: '已選擇',
		qingxuanzebeijing: '請選擇背景',
		zhibojianbiaoqian: '直播間標籤',
		zhibojianhuazhi: '直播間畫質',
		geinidezhibojianqugemingziba: '給你的直播間取一個名字吧~',
		qingshurukaibomiyao: '請輸入開播秘鑰',
		kaishizhibo: '開始直播',
		shengyin: '聲音',
		liwutexiao: '禮物特效',
		gengduo: '更多',
		gouwuche: '購物車',
		zaixianguanzhong: '在線觀眾',
		danmushuoming: '平台嚴禁未成年人充值打賞，嚴禁以陪玩等方式誘導打賞私下交易，嚴禁涉黃涉政、謾罵等內容，請注意財產安全，謹防網絡詐騙，理性消費。',
		tianjiaguanliyuan: '添加管理員',
		jinyan: '禁言',
		jiechuejinyan: '解除禁言',
		tichufangjian: '踢出房間',
		shangpinxiangqing: '商品詳情',
		lijijiagou: '立即加購',
		xuanzeguige: '選擇規格',
		quanbuliwu: '全部禮物',
		ge: '個',
		bi: '幣',
		guanliyuan: '管理員',
		kuaijieduanyu: '快捷短語',
		gonggao: '公告',
		xinzengkuaijieduanyu: '新增快捷短語',
		qingshuru: '請輸入',
		qingshuruzhengque: '請輸入正確的金額',
		shuru: '輸入',
		wangjimima: '忘記密碼',
		youxiangzhuce: '郵箱註冊',
		huoquyanzhengma: '獲取驗證碼',
		youxiang: '郵箱',
		yanzhengma: '驗證碼',
		anquanyanzheng: '安全驗證',
		fasongyanzhengma: '發送驗證碼',
		qingshuruyouxiangyanzhengma: '請輸入郵箱驗證碼',
		fasongchenggong: '發送成功',
		qingshuruningdeyouxiangzhanghao: '輸入您的郵箱賬號',
		qingshuruyanzhengma: '請輸入驗證碼',
		qingshurumima: '請輸入密碼',
		mimadenglu: '密碼登錄',
		woyiyuedubingtongyi: '我已閱讀並同意',
		yonghuxieyi: '使用者協議',
		yinsixieyi: '隱私協議',
		denglu: '登錄',
		chongxindenglu: '重新登陸',
		xiayibu: '下一步',
		haimeizhanghao: '還沒有帳號',
		quzhuce: '去註冊',
		yiyouzhanghao: '已有帳號',
		qudenglu: '去登錄',
		shezhijibenxinxi: '設置基本資訊',
		nichengtishi: '僅支持字母、數字和標點符號，最少6位，不能使用空格',
		shezhiyonghuming: '設置用戶名',
		yonghumingtishi: '用戶名為6-18位，大小寫字母或數字',
		shezhijiaoyimima: '設置交易密碼',
		jiaoyimimatishi: '交易密碼必须是6位數字組合',
		qingxuanze: '請選擇',
		yaoqingma: '邀請碼（選填）',
		qingshuruyaoqingma: '輸入邀請碼',
		shezhixinmima: '設置新密碼',
		xuanzeningdeguojia: '選擇您的國家',
		zhuce: '註冊',
		qingshuruyonghuming: '請輸入用戶名',
		gaoqinghuazhi: '高清畫質',
		biaoqinghuazhi: '標清畫質',
		chaoqinghuazhi: '超清畫質',
		putonghuazhi: '普通畫質'
	}, (0, _defineProperty3.default)(_all, 'kaishizhibo', '開始直播'), (0, _defineProperty3.default)(_all, 'zengsong', '贈送'), (0, _defineProperty3.default)(_all, 'jinrulezhibojian', '進入直播間'), (0, _defineProperty3.default)(_all, 'shuodianshenmene', '說點什麼呢...'), (0, _defineProperty3.default)(_all, 'zanwushuju', '暫無數據'), (0, _defineProperty3.default)(_all, 'songgei', '送給'), (0, _defineProperty3.default)(_all, 'huifang', '回放'), (0, _defineProperty3.default)(_all, 'quedingtuichudengluma', '確定退出登錄嗎?'), (0, _defineProperty3.default)(_all, 'xunibi', '虛擬幣'), (0, _defineProperty3.default)(_all, 'quanbu', '全部'), (0, _defineProperty3.default)(_all, 'appxiazai', 'APP下載'), (0, _defineProperty3.default)(_all, 'dingdanjine', '訂單金額'), (0, _defineProperty3.default)(_all, 'dingdanbianhao', '訂單編號'), (0, _defineProperty3.default)(_all, 'chuangjianshijian', '創建時間'), (0, _defineProperty3.default)(_all, 'zhubozanshilikai', '主播暫時離開'), (0, _defineProperty3.default)(_all, 'mashanghuilai', '馬上回來'), (0, _defineProperty3.default)(_all, 'guojianzhuoxiazai', '國際安卓下載'), (0, _defineProperty3.default)(_all, 'anzhuoxiazai', '安卓下載'), (0, _defineProperty3.default)(_all, 'guojipingguoxiazai', '國際蘋果下載'), (0, _defineProperty3.default)(_all, 'pingguoxiazai', '蘋果下載'), (0, _defineProperty3.default)(_all, 'weixiazai', '暫無下載'), (0, _defineProperty3.default)(_all, 'quanbushangpin', '全部商品'), (0, _defineProperty3.default)(_all, 'yiqiangguang', '已搶光'), (0, _defineProperty3.default)(_all, 'jiagou', '加購'), (0, _defineProperty3.default)(_all, 'shangpinxiangqing', '商品詳情'), (0, _defineProperty3.default)(_all, 'lijijiagou', '立即加購'), (0, _defineProperty3.default)(_all, 'yixuan', '已選'), (0, _defineProperty3.default)(_all, 'xuanzeguiige', '選擇規格'), (0, _defineProperty3.default)(_all, 'xuazeguige', '選擇規格'), (0, _defineProperty3.default)(_all, 'shangchuanzhong', '上傳中'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', '上傳失敗'), (0, _defineProperty3.default)(_all, 'browserbu\u652F\u6301', '您的瀏覽器不支援媒體設備訪問'), (0, _defineProperty3.default)(_all, 'qingkaiqi', '請開啟攝像頭和麥克風權限'), (0, _defineProperty3.default)(_all, 'meiyoushebei', '未檢測到攝像頭或麥克風設備'), (0, _defineProperty3.default)(_all, 'shebeibeizhan', '設備被其他程式占用，請關閉後重試'), (0, _defineProperty3.default)(_all, 'quxianchengong', '獲取媒體權限失敗'), (0, _defineProperty3.default)(_all, 'shifouquedingjieshuzhibo', '是否確定關閉直播？'), (0, _defineProperty3.default)(_all, 'qingyuedubingtongyiyonghuxieyiheyinsixieyi', '請閱讀並同意用戶協議和隱私協議！'), (0, _defineProperty3.default)(_all, 'quedingqudengluma', '確定去登錄嗎？'), (0, _defineProperty3.default)(_all, 'remen', '熱門'), (0, _defineProperty3.default)(_all, 'pinglun', '評論'), (0, _defineProperty3.default)(_all, 'huifu', '回覆'), (0, _defineProperty3.default)(_all, 'shanchu', '刪除'), (0, _defineProperty3.default)(_all, 'chakanhuifu', '查看回覆'), (0, _defineProperty3.default)(_all, 'jiazaizhong', '加載中'), (0, _defineProperty3.default)(_all, 'jiazaigengduo', '加載更多'), (0, _defineProperty3.default)(_all, 'meiyougengduo', '沒有更多了'), (0, _defineProperty3.default)(_all, 'shuodianshenme', '發送一條評論吧...'), (0, _defineProperty3.default)(_all, 'fasong', '發送'), (0, _defineProperty3.default)(_all, 'fabiao', '發表'), (0, _defineProperty3.default)(_all, 'ganggang', '剛剛'), (0, _defineProperty3.default)(_all, 'fenzhongqian', '{n}分鐘前'), (0, _defineProperty3.default)(_all, 'xiaoshiqian', '{n}小時前'), (0, _defineProperty3.default)(_all, 'tianqian', '{n}天前'), (0, _defineProperty3.default)(_all, 'shanchupinglun', '確定刪除該評論嗎？'), (0, _defineProperty3.default)(_all, 'duanyingyin', '短視頻'), (0, _defineProperty3.default)(_all, 'wofabu', '我發佈的'), (0, _defineProperty3.default)(_all, 'wodianzan', '我點贊的'), (0, _defineProperty3.default)(_all, 'woshoucang', '我收藏的'), (0, _defineProperty3.default)(_all, 'fabuduanyingyin', '發佈短影音'), (0, _defineProperty3.default)(_all, 'zhibohuaxu', '直播花絮'), (0, _defineProperty3.default)(_all, 'qingshurubiaoti', '請輸入標題'), (0, _defineProperty3.default)(_all, 'shangchuanduanyingyin', '上傳短影音'), (0, _defineProperty3.default)(_all, 'yonghuzhuye', '個人主頁'), (0, _defineProperty3.default)(_all, 'guanzhuta', '關注Ta'), (0, _defineProperty3.default)(_all, 'yiguanzhu', '已關注'), (0, _defineProperty3.default)(_all, 'guanzhu', '關注'), (0, _defineProperty3.default)(_all, 'fensi', '粉絲'), (0, _defineProperty3.default)(_all, 'guanzhong', '關注中'), (0, _defineProperty3.default)(_all, 'huguan', '互關'), (0, _defineProperty3.default)(_all, 'shanchuguanzhu', '移除關注'), (0, _defineProperty3.default)(_all, 'yichufensi', '移除粉絲'), (0, _defineProperty3.default)(_all, 'huiyuanid', '會員ID:'), (0, _defineProperty3.default)(_all, 'zhibozhongxin', '直播中心'), (0, _defineProperty3.default)(_all, 'zongzichanguzhi', '總資產估值'), (0, _defineProperty3.default)(_all, 'liushuijilu', '流水記錄'), (0, _defineProperty3.default)(_all, 'chongbi', '充幣'), (0, _defineProperty3.default)(_all, 'tibi', '提幣'), (0, _defineProperty3.default)(_all, 'gaibizhongbuzhichichongzhi', '該幣種暫不支持充值'), (0, _defineProperty3.default)(_all, 'gaibizhongbuzhichitibi', '該幣種暫不支持提幣'), (0, _defineProperty3.default)(_all, 'dashang', '打賞'), (0, _defineProperty3.default)(_all, 'riqi', '日期'), (0, _defineProperty3.default)(_all, 'leixing', '類型'), (0, _defineProperty3.default)(_all, 'miaoshu', '描述'), (0, _defineProperty3.default)(_all, 'jine', '金額'), (0, _defineProperty3.default)(_all, 'zhuangtai', '狀態'), (0, _defineProperty3.default)(_all, 'yiwancheng', '已完成'), (0, _defineProperty3.default)(_all, 'shenhezhong', '審核中'), (0, _defineProperty3.default)(_all, 'shenhejujue', '審核拒絕'), (0, _defineProperty3.default)(_all, 'tibibeibohui', '提幣被駁回'), (0, _defineProperty3.default)(_all, 'zhidaole', '知道了'), (0, _defineProperty3.default)(_all, 'bohuiyuanyin', '駁回原因：'), (0, _defineProperty3.default)(_all, 'kaishiriqi', '開始日期'), (0, _defineProperty3.default)(_all, 'jieshuriqi', '結束日期'), (0, _defineProperty3.default)(_all, 'wangluo', '網絡'), (0, _defineProperty3.default)(_all, 'dizhi', '地址'), (0, _defineProperty3.default)(_all, 'tibishuliang', '提幣數量'), (0, _defineProperty3.default)(_all, 'daozhangshisuan', '到帳試算'), (0, _defineProperty3.default)(_all, 'shouxufei', '手續費'), (0, _defineProperty3.default)(_all, 'meiridaozhang', '每日到帳'), (0, _defineProperty3.default)(_all, 'keyong', '可用'), (0, _defineProperty3.default)(_all, 'dongjie', '凍結'), (0, _defineProperty3.default)(_all, 'zuixiaotibishuliang', '最小提幣數量'), (0, _defineProperty3.default)(_all, 'shouxufeibilv', '手續費'), (0, _defineProperty3.default)(_all, 'meirishenyueddu', '每日剩餘額度'), (0, _defineProperty3.default)(_all, 'shenqingzhibo', '申請直播'), (0, _defineProperty3.default)(_all, 'shenqingjilu', '申請記錄'), (0, _defineProperty3.default)(_all, 'huifangjilu', '回放記錄'), (0, _defineProperty3.default)(_all, 'yikaifang', '已開放'), (0, _defineProperty3.default)(_all, 'guankanhuifang', '觀看回放'), (0, _defineProperty3.default)(_all, 'beisu', '倍數'), (0, _defineProperty3.default)(_all, 'zhiboriqi', '直播日期'), (0, _defineProperty3.default)(_all, 'shijianshiduan', '時間時段'), (0, _defineProperty3.default)(_all, 'shoujizhibo', '手機直播'), (0, _defineProperty3.default)(_all, 'zhibodaihuo', '直播帶貨'), (0, _defineProperty3.default)(_all, 'kaiqi', '開啟'), (0, _defineProperty3.default)(_all, 'guanbi', '關閉'), (0, _defineProperty3.default)(_all, 'beizhu', '備註'), (0, _defineProperty3.default)(_all, 'huodongzhuti', '活動主題、設備說明'), (0, _defineProperty3.default)(_all, 'shenqinghouliucheng', '申請後流程'), (0, _defineProperty3.default)(_all, 'shenqinghouliuchengdesc', '後台審核通過後，將郵件發送直播會鈴定直播地址。'), (0, _defineProperty3.default)(_all, 'daishenhe', '待審核'), (0, _defineProperty3.default)(_all, 'tijiaoshenqing', '提交申請'), (0, _defineProperty3.default)(_all, 'qingxuanzeriqi', '請選擇直播日期'), (0, _defineProperty3.default)(_all, 'qingxuanzeshijian', '請選擇時間時段'), (0, _defineProperty3.default)(_all, 'tijiaochenggong', '提交成功'), (0, _defineProperty3.default)(_all, 'nian', '年'), (0, _defineProperty3.default)(_all, 'yue', '月'), (0, _defineProperty3.default)(_all, 'tongshiduanbukezhongfu', '同時段不可重複'), (0, _defineProperty3.default)(_all, 'keshenqingshiduan', '可申請時段'), (0, _defineProperty3.default)(_all, 'querenShiduan', '確認時段'), (0, _defineProperty3.default)(_all, 'zhanghaoid', '帳號 ID'), (0, _defineProperty3.default)(_all, 'qingtianxie', '請填寫'), (0, _defineProperty3.default)(_all, 'zhou1', '一'), (0, _defineProperty3.default)(_all, 'zhou2', '二'), (0, _defineProperty3.default)(_all, 'zhou3', '三'), (0, _defineProperty3.default)(_all, 'zhou4', '四'), (0, _defineProperty3.default)(_all, 'zhou5', '五'), (0, _defineProperty3.default)(_all, 'zhou6', '六'), (0, _defineProperty3.default)(_all, 'zhou7', '日'), (0, _defineProperty3.default)(_all, 'shenqingyitijiao', '申請已提交'), (0, _defineProperty3.default)(_all, 'shenqingtijiaodesc', '直播管理員將審核直播間、時段和帶貨資料。'), (0, _defineProperty3.default)(_all, 'chakanshenheJilu', '查看審核記錄'), (0, _defineProperty3.default)(_all, 'shenqingriqi', '申請日期'), (0, _defineProperty3.default)(_all, 'zhiboshijianduan', '直播時間段'), (0, _defineProperty3.default)(_all, 'zhiboleixing', '直播類型'), (0, _defineProperty3.default)(_all, 'daihuo', '帶貨'), (0, _defineProperty3.default)(_all, 'yitongguo', '已通過'), (0, _defineProperty3.default)(_all, 'weitongguo', '未通過'), (0, _defineProperty3.default)(_all, 'xiangqing', '詳情'), (0, _defineProperty3.default)(_all, 'yuanyin', '原因'), (0, _defineProperty3.default)(_all, 'shenqingxiangqing', '申請詳情'), (0, _defineProperty3.default)(_all, 'shenheyuanyin', '審核原因'), (0, _defineProperty3.default)(_all, 'xutiaozheng', '需調整'), (0, _defineProperty3.default)(_all, 'shenheyuanyindesc', '該時段直播間已被占用，請重新選擇直播日期或時間段後再次提交。'), (0, _defineProperty3.default)(_all, 'wancheng', '完成'), (0, _defineProperty3.default)(_all, 'chulizhong', '處理中'), (0, _defineProperty3.default)(_all, 'daichuli', '待處理'), (0, _defineProperty3.default)(_all, 'houtaishenhe', '後台審核'), (0, _defineProperty3.default)(_all, 'chanshengmiyao', '產生金鑰'), (0, _defineProperty3.default)(_all, 'youjiankuaidi', '郵件通知'), (0, _defineProperty3.default)(_all, 'kechakan', '可查看'), (0, _defineProperty3.default)(_all, 'jinwanxinpinfuli', '今晚新品福利直播'), (0, _defineProperty3.default)(_all, 'chehuishenqing', '撤回申請'), (0, _defineProperty3.default)(_all, 'chongxinshenqing', '重新申請'), (0, _defineProperty3.default)(_all, 'zhibojinyao', '直播金鑰'), (0, _defineProperty3.default)(_all, 'zhibojian', '直播間'), (0, _defineProperty3.default)(_all, 'keyongshiduan', '可用時段'), (0, _defineProperty3.default)(_all, 'youxiao', '有效'), (0, _defineProperty3.default)(_all, 'tuiliudizhi', '推流地址'), (0, _defineProperty3.default)(_all, 'tuiliumamiyao', '推流碼/秘鑰'), (0, _defineProperty3.default)(_all, 'youjiantongzhidesc', '同直播間同時段不會重複生成金鑰。'), (0, _defineProperty3.default)(_all, 'yifasong', '已發送'), (0, _defineProperty3.default)(_all, 'fuzhiquanbu', '複製全部'), (0, _defineProperty3.default)(_all, 'fuzhichenggong', '複製成功'), (0, _defineProperty3.default)(_all, 'youjiantongzhi', '郵件通知'), (0, _defineProperty3.default)(_all, 'zhiboshenhetongguo', '直播審核通過'), (0, _defineProperty3.default)(_all, 'shoujianren', '收件人'), (0, _defineProperty3.default)(_all, 'youjianneirongdesc', '內容包含直播間、可用時段、推拉流地址、密鑰和開播前設置入口'), (0, _defineProperty3.default)(_all, 'youjianbianhao', '郵件編號'), (0, _defineProperty3.default)(_all, 'chongxinfasong', '重新發送'), (0, _defineProperty3.default)(_all, 'yinyuedaren', '音樂達人'), (0, _defineProperty3.default)(_all, 'wudaodaren', '舞蹈達人'), (0, _defineProperty3.default)(_all, 'yanzhi', '顏值'), (0, _defineProperty3.default)(_all, 'jichushezhi', '基礎設置'), (0, _defineProperty3.default)(_all, 'yishangchuan', '已上傳'), (0, _defineProperty3.default)(_all, 'zhiboshangpin', '直播商品'), (0, _defineProperty3.default)(_all, 'laiziyunimall', '來自 UNImall 商城控制'), (0, _defineProperty3.default)(_all, 'jian', '件'), (0, _defineProperty3.default)(_all, 'zhiboliucheng', '直播流程'), (0, _defineProperty3.default)(_all, 'liuchang', '流暢'), (0, _defineProperty3.default)(_all, 'gaoqing', '高清'), (0, _defineProperty3.default)(_all, 'chaoqing', '超清'), (0, _defineProperty3.default)(_all, 'languang', '藍光'), (0, _defineProperty3.default)(_all, 'tongguo', '通過'), (0, _defineProperty3.default)(_all, 'jinxingzhong', '進行中'), (0, _defineProperty3.default)(_all, 'daikaiqi', '待開啟'), (0, _defineProperty3.default)(_all, 'qianzhizuoye', '前置作業'), (0, _defineProperty3.default)(_all, 'qingshangchuan', '請上傳'), (0, _defineProperty3.default)(_all, 'shangpinxuhao', '商品序號'), (0, _defineProperty3.default)(_all, 'shangpinshoutu', '商品首圖'), (0, _defineProperty3.default)(_all, 'shangpinmingcheng', '商品名稱'), (0, _defineProperty3.default)(_all, 'shangchengkucun', '商城庫存'), (0, _defineProperty3.default)(_all, 'zhibokucun', '直播庫存'), (0, _defineProperty3.default)(_all, 'shangchengjiage', '商城價格'), (0, _defineProperty3.default)(_all, 'zhibojiage', '直播價格'), (0, _defineProperty3.default)(_all, 'caozuo', '操作'), (0, _defineProperty3.default)(_all, 'yichu', '移除'), (0, _defineProperty3.default)(_all, 'zhibojiansetting', '直播間設置'), (0, _defineProperty3.default)(_all, 'kaiqishengyin', '開啟聲音'), (0, _defineProperty3.default)(_all, 'guanbishengyin', '關閉聲音'), (0, _defineProperty3.default)(_all, 'kaiqidanmu', '開啟彈幕'), (0, _defineProperty3.default)(_all, 'guanbidanmu', '關閉彈幕'), (0, _defineProperty3.default)(_all, 'kaiqimeiyan', '開啟美顏'), (0, _defineProperty3.default)(_all, 'guanbimeiyan', '關閉美顏'), (0, _defineProperty3.default)(_all, 'kaiqimaikefeng', '開啟麥克風'), (0, _defineProperty3.default)(_all, 'guanbimaikefeng', '關閉麥克風'), (0, _defineProperty3.default)(_all, 'kaiqimaike', '開麥克風'), (0, _defineProperty3.default)(_all, 'guanbimaike', '關麥克風'), (0, _defineProperty3.default)(_all, 'gonggao', '公告'), (0, _defineProperty3.default)(_all, 'fenxianglianjie', '分享鏈接'), (0, _defineProperty3.default)(_all, 'xietongzhibo', '協同直播'), (0, _defineProperty3.default)(_all, 'yaoqingjinbo', '邀請助播'), (0, _defineProperty3.default)(_all, 'tongyikongzhi', '統一控制'), (0, _defineProperty3.default)(_all, 'tichuzhubozb', '踢出選中助播'), (0, _defineProperty3.default)(_all, 'zhuborenshushangxian', '助播人數上限'), (0, _defineProperty3.default)(_all, 'ren', '人'), (0, _defineProperty3.default)(_all, 'tongzhibojinyao', '同直播金鑰'), (0, _defineProperty3.default)(_all, 'zhuboquanxian', '助播權限'), (0, _defineProperty3.default)(_all, 'yunxufayan', '允許發言'), (0, _defineProperty3.default)(_all, 'yunxukamai', '允許開麥'), (0, _defineProperty3.default)(_all, 'yunxukashipin', '允許開視頻'), (0, _defineProperty3.default)(_all, 'yikaiqi', '已開啟'), (0, _defineProperty3.default)(_all, 'shengchengyaoqingjinyao', '生成邀請金鑰'), (0, _defineProperty3.default)(_all, 'xietongzhiborenshu', '協同直播人數'), (0, _defineProperty3.default)(_all, 'dangqianzhibo', '當前助播'), (0, _defineProperty3.default)(_all, 'kenenghaiyaoqing', '可能還邀請'), (0, _defineProperty3.default)(_all, 'weizhibo', '位助播'), (0, _defineProperty3.default)(_all, 'baocunshangxian', '保存上限'), (0, _defineProperty3.default)(_all, 'fenxiangyaoqing', '分享邀請'), (0, _defineProperty3.default)(_all, 'yaoqinglianjie', '邀請鏈接'), (0, _defineProperty3.default)(_all, 'fenxiangfangshi', '分享方式'), (0, _defineProperty3.default)(_all, 'fuzhilianjie', '複製鏈接'), (0, _defineProperty3.default)(_all, 'baocunerweima', '保存二維碼'), (0, _defineProperty3.default)(_all, 'fuzhiyaoqinglianjie', '複製邀請鏈接'), (0, _defineProperty3.default)(_all, 'zhubo', '助播'), (0, _defineProperty3.default)(_all, 'guanli', '管理'), (0, _defineProperty3.default)(_all, 'yijinru', '已進入'), (0, _defineProperty3.default)(_all, 'maikefeng', '麥克風'), (0, _defineProperty3.default)(_all, 'shexiangtou', '攝像頭'), (0, _defineProperty3.default)(_all, 'guanbishexiangtou', '關閉攝像頭'), (0, _defineProperty3.default)(_all, 'kaiqishexiangtou', '開啟攝像頭'), (0, _defineProperty3.default)(_all, 'guanbijingxiang', '關閉鏡像'), (0, _defineProperty3.default)(_all, 'kaiqijingxiang', '開啟鏡像'), (0, _defineProperty3.default)(_all, 'sheweizhuyemian', '設為主畫面'), (0, _defineProperty3.default)(_all, 'quxiaozhuyemian', '取消主畫面'), (0, _defineProperty3.default)(_all, 'tichuzhibo', '踢出直播間'), (0, _defineProperty3.default)(_all, 'tichuhoubukejinru', '踢出後不可再進入該直播間'), (0, _defineProperty3.default)(_all, 'tongyikongmai', '統一控麥'), (0, _defineProperty3.default)(_all, 'quanjukongzhi', '全局控制'), (0, _defineProperty3.default)(_all, 'quantijingyin', '全體靜音'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaimai', '允許助播開麥'), (0, _defineProperty3.default)(_all, 'yunxuzhubokaishipin', '允許助播開視頻'), (0, _defineProperty3.default)(_all, 'huifukaimai', '恢復開麥'), (0, _defineProperty3.default)(_all, 'guanbishipin', '關閉視頻'), (0, _defineProperty3.default)(_all, 'yunxushipin', '允許視頻'), (0, _defineProperty3.default)(_all, 'yingyongshezhi', '應用設置'), (0, _defineProperty3.default)(_all, 'shipin', '視頻'), (0, _defineProperty3.default)(_all, 'kaimai', '開麥'), (0, _defineProperty3.default)(_all, 'weikaiqi', '未開啟'), (0, _defineProperty3.default)(_all, 'shipinkaiqi', '視頻開啟'), (0, _defineProperty3.default)(_all, 'shipinguanbi', '視頻關閉'), (0, _defineProperty3.default)(_all, 'bimai', '閉麥'), (0, _defineProperty3.default)(_all, 'yunxufayan', '允許發言'), (0, _defineProperty3.default)(_all, 'jinzhifayan', '禁止發言'), (0, _defineProperty3.default)(_all, 'zhuboxiwei', '助播席位'), (0, _defineProperty3.default)(_all, 'guankanzhibo', '觀看直播'), (0, _defineProperty3.default)(_all, 'goumai', '購買'), (0, _defineProperty3.default)(_all, 'goumaishangpin', '購買商品'), (0, _defineProperty3.default)(_all, 'yishouqing', '已售罄'), (0, _defineProperty3.default)(_all, 'qianggou', '搶購'), (0, _defineProperty3.default)(_all, 'dashang', '打賞'), (0, _defineProperty3.default)(_all, 'chakangg', '查看公告'), (0, _defineProperty3.default)(_all, 'quxiao', '取消'), (0, _defineProperty3.default)(_all, 'queren', '確認'), (0, _defineProperty3.default)(_all, 'wodequanbao', '我的錢包'), (0, _defineProperty3.default)(_all, 'jiangjie', '講解'), (0, _defineProperty3.default)(_all, 'jiangjiezhong', '講解中'), (0, _defineProperty3.default)(_all, 'kucun', '庫存'), (0, _defineProperty3.default)(_all, 'qrcodenotexist', '二維碼不存在'), (0, _defineProperty3.default)(_all, 'qrcodesaved', '二維碼保存成功'), (0, _defineProperty3.default)(_all, 'wodeqianbao', '我的錢包'), (0, _defineProperty3.default)(_all, 'lianshangbaobishibei', '鏈上包幣市幣'), (0, _defineProperty3.default)(_all, 'zonge', '總額'), (0, _defineProperty3.default)(_all, 'keyongshuliang', '可用數量'), (0, _defineProperty3.default)(_all, 'dongjieshuliang', '凍結數量'), (0, _defineProperty3.default)(_all, 'chakanliushui', '查看流水'), (0, _defineProperty3.default)(_all, 'chongzhitip', '充幣提示：僅支持同鏈網絡，區塊鏈確認到鏈轉帳資產無法找回'), (0, _defineProperty3.default)(_all, 'chongzhishuliang', '充值數量'), (0, _defineProperty3.default)(_all, 'zuidicharge', '最低充值金額'), (0, _defineProperty3.default)(_all, 'xiaoyuzuixiaoe', '小於最小金額充值將不會上賬'), (0, _defineProperty3.default)(_all, 'yujidaozhang', '預計到帳'), (0, _defineProperty3.default)(_all, 'shijidaozhang', '實際到帳'), (0, _defineProperty3.default)(_all, 'lijichongzhi', '立即充值'), (0, _defineProperty3.default)(_all, 'chongzhierweima', '充值二維碼'), (0, _defineProperty3.default)(_all, 'chongbixiangqing', '充幣詳情'), (0, _defineProperty3.default)(_all, 'tibixiangqing', '提幣詳情'), (0, _defineProperty3.default)(_all, 'chongbidizhi', '充幣地址'), (0, _defineProperty3.default)(_all, 'fuzhidizhi', '複製地址'), (0, _defineProperty3.default)(_all, 'chongzhichenggong', '充值成功'), (0, _defineProperty3.default)(_all, 'dengdaiquerenzhong', '等待確認中...'), (0, _defineProperty3.default)(_all, 'baocunchenggong', '保存成功'), (0, _defineProperty3.default)(_all, 'chongbichenggong', '充幣成功'), (0, _defineProperty3.default)(_all, 'bizhong', '幣種'), (0, _defineProperty3.default)(_all, 'shuliang', '數量'), (0, _defineProperty3.default)(_all, 'shijian', '時間'), (0, _defineProperty3.default)(_all, 'tibidizhi', '提幣地址'), (0, _defineProperty3.default)(_all, 'qingshurutibidizhi', '請輸入提幣地址'), (0, _defineProperty3.default)(_all, 'tibishisuan', '提幣試算'), (0, _defineProperty3.default)(_all, 'zuiditixianjin', '最低提現金額'), (0, _defineProperty3.default)(_all, 'tibishenqingyitijiao', '提幣申請已提交'), (0, _defineProperty3.default)(_all, 'tibishenqingdesc', '後台審核通過後，將進行鏈上提幣。'), (0, _defineProperty3.default)(_all, 'shenhezhong', '審核中'), (0, _defineProperty3.default)(_all, 'zhuangtai', '狀態'), (0, _defineProperty3.default)(_all, 'chakantibi', '查看提幣記錄'), (0, _defineProperty3.default)(_all, 'meiriyushutixian', '每日剩餘提現金額'), (0, _defineProperty3.default)(_all, 'keyongyu', '可用餘額'), (0, _defineProperty3.default)(_all, 'tijiaotibi', '提交提幣'), (0, _defineProperty3.default)(_all, 'xuanzetibidizhi', '選擇提幣地址'), (0, _defineProperty3.default)(_all, 'sousuodizhi', '搜索地址'), (0, _defineProperty3.default)(_all, 'xuanze', '選擇'), (0, _defineProperty3.default)(_all, 'querentbi', '確認提幣'), (0, _defineProperty3.default)(_all, 'xuanzedashangbizhong', '選擇打賞幣種'), (0, _defineProperty3.default)(_all, 'xuanzebizhong', '選擇幣種'), (0, _defineProperty3.default)(_all, 'chuzhidizhi', '儲值地址'), (0, _defineProperty3.default)(_all, 'yue', '餘額'), (0, _defineProperty3.default)(_all, 'dashangjine', '打賞金額'), (0, _defineProperty3.default)(_all, 'zhanshidashangxinxi', '展示打賞信息'), (0, _defineProperty3.default)(_all, 'zidingyi', '自定義'), (0, _defineProperty3.default)(_all, 'querendashang', '確認打賞'), (0, _defineProperty3.default)(_all, 'zaixianguanzhong', '在線觀眾'), (0, _defineProperty3.default)(_all, 'yizhibo', '已直播'), (0, _defineProperty3.default)(_all, 'jieshizhibo', '結束直播'), (0, _defineProperty3.default)(_all, 'zhibozhong', '直播中'), (0, _defineProperty3.default)(_all, 'zanwuzaixianguanzhong', '暫無在線觀眾'), (0, _defineProperty3.default)(_all, 'shangchuanshibai', '視頻上傳失敗，請稍後重試'), (0, _defineProperty3.default)(_all, 'qingshurucontent', '請填寫標題並上傳視頻'), (0, _defineProperty3.default)(_all, 'fabuchenggong', '發佈成功'), (0, _defineProperty3.default)(_all, 'fabushibai', '發佈失敗'), (0, _defineProperty3.default)(_all, 'qingshurushuju', '請輸入數據'), (0, _defineProperty3.default)(_all, 'confirmDelete', '確認刪除此影片？'), (0, _defineProperty3.default)(_all, 'shanchuchenggong', '刪除成功'), (0, _defineProperty3.default)(_all, 'confirmWithdraw', '確認撤回此影片？'), (0, _defineProperty3.default)(_all, 'chehuichenggong', '撤回成功'), (0, _defineProperty3.default)(_all, 'yongjiujinyan', '永久禁言'), (0, _defineProperty3.default)(_all, 'jiaruzhibo', '加入直播'), (0, _defineProperty3.default)(_all, 'jiaruxietongzhibo', '加入協同直播'), (0, _defineProperty3.default)(_all, 'tuichuxietongzhibo', '退出協同直播'), (0, _defineProperty3.default)(_all, 'zhubojinyao', '助播金鑰'), (0, _defineProperty3.default)(_all, 'qingshuruzhubojinyao', '請輸入助播金鑰'), (0, _defineProperty3.default)(_all, 'jiaru', '加入'), (0, _defineProperty3.default)(_all, 'shenqingchenggong', '申請成功'), (0, _defineProperty3.default)(_all, 'youxiaoqi', '有效期'), (0, _defineProperty3.default)(_all, 'tichubenchang', '踢出本場'), (0, _defineProperty3.default)(_all, 'zhanshidashangxiaoxi', '展示打賞消息'), (0, _defineProperty3.default)(_all, 'zanwugonggao', '暫無公告'), (0, _defineProperty3.default)(_all, 'dashang', '打賞'), (0, _defineProperty3.default)(_all, 'songgei', '送給'), (0, _defineProperty3.default)(_all, 'ge', '個'), (0, _defineProperty3.default)(_all, 'bi', '幣'), (0, _defineProperty3.default)(_all, 'zanweiyourenjiaruxietongzhibo', '暫未有人加入協同直播'), (0, _defineProperty3.default)(_all, 'zanweikaiqi', '暫未開啟協同直播'), _all)
};

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGTSURBVHgB7ZnxUYMwFMY/Pf+3bpANZIRsoBvABnWDdgMdASfQDXADrxMEJ2idoCbX9IBAbMAXg/b97r47khcKX3hJEwAYhmH+AwLjWYCAS9CQaT2MaL/SugMBVAZecejRrFUntKSVcOpvtJ4xM4yBymqrtXe0tbF3EKUPJVJLoX/TPil7zixYormxF3xvRNk2x/IKiSnQ3Exl6wT8BqRtU7bqxgx+UgS6vW1y3DyNR/gNmN4vBs5LMiYKhOf8Ka2RgAp0BhQmcoHpSNDyhglcBbaTWrdam9aFFoiTu9Kq1KpBwD26j/s4ayjQpdDe/maB4VnLS8hSInfKEvHIT5R7hBhw0+QaM4JqMZcMNpAaNpAaNpCaEAMf+D12TvkTBAg0ywaFZoMeYymRea5FgnDKMQz4rhWFmAaCOetZqAYdNSbykx2ZWaWavYKwx0snbt7WbeyxaZM78RKHGc5s6s1buh0SItDP6aIVlwNxCQL4nzg1bMAyNABrz/FsWaMZoNVA/KkVLzFTMnQ/coyNMwzD/DG+AEsY6/ijkeNmAAAAAElFTkSuQmCC"

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAADf0lEQVR4AeyZjVXbMBSFlS5QugGdoGUD2AAmKExAOkFggsIEpBOUDWgngA1gA9gg/b6evHOcxD/5sSMf6hzdSLIl+V49WU+SP6R39hsE9d2gg4UGCy31wGw2OwDn4BJcgVNwuFRs6+zehhykj8EDTF/BHbgBE/ALPHsPfCO9U+hcECS1yA9YKuaYuCp4b0p5y1aVabzeqSDIfYXBIxiDCFMSZ+AzOAKmfxJHGFNP8ZHfKO5MEKQuYaKYeD9eyB+NRqOL0Wh0D17AEzB9zj0FWoZkcnhemdgUrQtCyCGwh31Hgs8tiSPIPxGXBu4p5oSbxkRpQjvRGebXQquCIOB7oFWMJfDG3xlkx8A02epAGcVcFEpouUK2OdmKIIQUX/yD+WMV8J30G/cdQmuB8gaFGTu1R3vmG1ErCCIOnzviV1AZeIpTcfHF51KSiNOzw29TxFCzjXi2sVziXir7VQqC/SkVHD6a3YbJZg1ykMsj3Jw9S8mUCqKCvaA/sBEr/ubP6TYn5ACNJKcHOBqn5V+pIAo5fBRFMl3zsp4Ap9uccAa8lhBQjBxJLoYqQV/mxfQVW/mDef1WIzpVLk42tls67KoEWUHEbGO6Lwhf9rGMUJOgsjqtXeuioUFQF73aZpuDhdrsTdvSnwCXODfErgRqQZ1wJyRXQ1YLIWACpWfgytzthiuBJvRTEGJc5+lXdJJoaidksRBiwgqq0Ne5a/2E42wMVIglEMnVkEUQNBxqREkxLqvctcYKIO3y27sgrOPmL96DW0yiqF00LNTduyCeHmJIpljGpLZ+OQQVuZeux4oFNk3nEFS0isdYm3KuLb93QbwzCor3xpOd0m1ALeuam3sXNOdSPNlxS+3qYN1DlFq/lUUQVtKXxO5TjfqldQ9Sai2aRZAKEOUqQUvF8PPyzsgmSOaImgKPgJ0cFLcOajsgqyBFCUR5xq24RlC+/4Ig2VpY20KtPbHjhv47QbVzfsedvVXzVRaKpbyH9X0TtZUf+jPvHsV4xj3P5ovYdvjJxl2unCTiObvxAqosZOGYHv0E76cMD8hzwa8gnj24olCAR9TF77Je+4dSQfgFh5yH4yHKXnFjlgsOMzlIWk5yM72CUkGWQpS9oBfXe7v2yo17ePnFwW+1iiK7GioFRVGE6b3d9+eG32rdsjt6gt5K3ChopUbPLwyCem6g9O4s9BcAAP//3CBTOwAAAAZJREFUAwBrxluH5fRjggAAAABJRU5ErkJggg=="

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAEh0lEQVR4AeyYi1EbMRCGz6kAOoAKEioIVJCkAqACoAKgAqACSAUhFZAOoANIBdAB+b9jd1jGuqeEz0Ps0Vo6nR77aVdryZ+qD/ZZAS27QVcW+m8t9Pz8vC05lvyS3JhQPlB5470WprjLSVlAbqQwcqL8u2TbhPK5yvdqB2RxsKJAUvJMygICgIp1etL3nQllFetEG8CO66dCX8WADOYw6HWl8s5sNlufzWZbsxdZp07yU+LpRH2LQRUBMoUc5kGaArIviD8qv0nUSfZUuSOhrbIKKO/P82jJBhIM+4C9ghIoCMwcCC+jCIo2P1TnbkgAWdNzVsoG0uwOo2J1IkWBqvp81Ja9dWptgcm2Ugmgb6bQnRSMe8Oq2zP1Ieq5lXbbW3e/zQKSuxGpWFlmGgxDJxPvu6ExcWGrHp5lAWm6ODnuo6pRKfb9PGoE61QSqPfesbljFvsS2uO7QeVcoKiIu94gBRKNHxN1vatKAn3pPet8Q/ai1/71wpg8Fyj6fk6E8r4PinpxzMFMWUCanHDLDyQTcyiNK01dq/BSUY1TgwcXH4tXoyQLyGb0H0YeL6Vg772ktoAc09EkjmVVw7JsIFmJVb2waVGw17XAYDiZ04fupxorBhnqBks2kM3I8cd9n+AAlO8La/KSCWRNglVuVeMw14JhDFXlpSJAUoa9xOkZa6ERil5J8UcJcLgigkXu1QDl3TU5JeyrrkgqAoQmBsXp2S1FNUoTKNj4CGXqeIecq9+ehAXhOVuKAMkKRDhWnx9FXK6vYofqeytJumffQWK7LCApAgguBAyrH8dmg+OC3FxdeI4WpD0LgHtyHc8GGwUkEE7FQCDsFxRDUJj9wLV7U67EZY+bqwvPW2rIeQ33ZP+4uzGOg1FWs+FpMJBgsAQRipwZUYjfDyBQ+Eog1PEuKbyXENnYV5tqxCJgURUrYLAWkbAa+hkEJJgDTYBVfGNjEf4A4abaCqF+ySSwJwkuSZT03zPa8j8D/yJR7i29gQTDinG79MGPpAgW8ZX1+lG5xuIcxxUcV/QxCRqXQwbsBSQY/iDkt8PHZk9EOK/PzgV2rUGwlkPtaX4WU9XdqRNIg+HTcZWAwUW6Rx/ZQlDARCjcj0XtHLETSCMA43uG89a7wmi+OhkU7lc/64uThuuhx3RqBZJ1iEIezYhe0e3SIxasFRS/WUc2JDCdrtcKpIF8ACIYoVlVi02CYq8STZmYIMEWoJyURiCzjne+0MD4dXKQBVTGxSQSNk7ZCKQe8RiykH2jOZNJi4mFEN7varFxP8pzkgRSBywT986U1nGlf1sBmMaIlwRSR4dRseK8VVGYWKKXfG3SpQkIC3mfZbBOJbcjMLkuUT/Xs86bgLwjjc7MBSlPIpqfazvnOgeJ+r3RqQmI44d3wl85/WrcaZI05uIYo1uMenr9mpJAZt549HjtMW0Jt2s9ECeB0FlQnH65q3D8YEXYlFMJ1wruTFwaPXyj5pw0AnlLgXER477DoXQqOZQeHL2wkKuWzDuBkr2WuHIFtMTGqVVbWahehiX++nAW+gcAAP//XLVBjgAAAAZJREFUAwBX3heHEfDWWgAAAABJRU5ErkJggg=="

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGfSURBVHgB7ZjRTcMwEIY/YIGO4A1gA7wBfeQtGYENyAawQcsEhQkCEwATpLzxRjtBsZVEhaSijtNzapRP+qVWcqT/4vP5cjAyMhI1ZwzDxOi6+v1JRCij3GhTKSUiEqMvtuatNJEw5bfxWhMiQBkVtM3PiISUtnmbSopIeKUdQEok2BxvvvmUiFBsjd8jkDYn9MO+4Quj8+r/h9Gz0eqPZ3S13j63pjzgL0ZvBMQav6Vd12stKEtnjdqz3soGkhAAvcdIM+cLx7W17hBk2tGMr5yDOMUdRbjLZ40Ac8K8/RsEUBDEfIYQGYibL/DA9QxcIs8DgriWzT7SeOC6AyH69iUedCmjR8kxBeC1y64BrJBH44FrAEvkucID1wDekUfjsQuuAYTq1W0brhCg+WkofSNrBMiBTUDNXEx1KaNPhEVxYGwahWgpaiUIkEEQ8wVChNqFBEGkv4tzArAAEfMFgWamE7qPSwZPnSaKwwaRMQCK3UHklLfpzxbZjhLnO9bbouA9ieg7G62xB9saXBo9sr/91pTz0bXj+pGRkf/KNz3JzWNGdv0eAAAAAElFTkSuQmCC"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAADc0lEQVR4AeyagV3VMBDG+1xA2AAmACcQJhA2gAmQCdQJfE4gG4gT4AbqBLABbPD8f/01ktcml5IUyIPyu8+0yd3lvlxf0yS+aV7430xw0xM8SQZXq9U++AHOSgdEPsAV2C/1JftJCOLoKzgCSwLbosySznaJ8QH4DIplKoJ+INkEceLbvuW+WEyCjOgOOEiBKPzA9lL6sXb8KHMUrWzF9Hr15qMcJIgDEbuim2ugMgW/k8uRNiGf37F1Ip8hnX7db+K9BjvO0C8HBDtFOfFH07ep8Vrk9GLyn6Q2zgFBakVMBlw2f5qmuWjSuEPHiTI4xiakI1vn54aLkE6/TnqoNor5pOn9hQjq0XBq54vF4nSRAMoaCIpWRtmEfGJ9DpzchHT6dSj7NiJJ1b2ECA7SfK9e5ZX/9AzevCGCVbLIDWomOHLk/nZ6+t24H31XNb7g9yVb98jperxxRHOqDOqz6pg+DkGpvMPBKfBfHtzmySQEGfk7cAmKR10+wAVwmcxj1llNQrDzVWXxMIJVUrCDevUEtZBNrib4fn02HfK3B6KSyqAWsvrwrhlaIGcTjBpuSkMqg/q673+913b/yxrsFMFvzEfJ1cRz6kDuC4hKimDUcFMaZoKbkqlYnMUZZA7UBlUMycUz9to9y7aPEXP1RQQJTvOjdt5iuEXno+usX3Ztt9Rb9uoDlTwpIkiX2qCiMOWD0freaHNN+kpKPglOuV+WEtSaTfNQDJpHpdPv193rFR+zdfXaxMpeOhURZP5bgkMDx7T5O26OWFuqDVj2ajM/xVpHxj9FBA2/1TTNBKtJRWYgj5nBzJCmNZsJWuPJRH0GdKpjwT/rWHOHrXYMdPRt2Rcdi2dnkOA0+eoVrsnegvZM14h5N9oxOOLeslcfqORJNkHmL02+moxTPVs6P1PGtFv2NNuSTVBuIamd7G2udyPYRieaga7Nst9FR33gPk+KCKpLAtCudnsmwXW/VJalFgU2ln3xTnkxwWjklTTMBCtJRHYYrzKD/vJGE/kJc161ILWfgBN3EOvum1AGtbHr3n6ahPWfc2qGPhJESDFrga3r/xgQ1GubVp2wFr+i8fNUInJa+Q9iHhBURJDUSGiC1bG0yNYOfRDoyVP4awgSlAYkNWnrWFrHybVDGVTYA0QJDjQ3tGIm+GSJe6SOXnwG/wEAAP//MSAZswAAAAZJREFUAwCJyWmeG8VRvQAAAABJRU5ErkJggg=="

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAEAUlEQVR4AeyaXVIaQRCAe1awUISCG+AN9AZygoQTCC8ByhdzAsMJiE8WJlUxJ4g5AeYEcgO5AUQQCAsz6d4/EGFnF2YXtXbLYee3u7/pZZidVoN3fkWAb93BkQcjD77yGYge0VfuIKl5oXkwcdXJ7Td6nf1G/yF+3T+SWqaoQyiABMe0eBNtzgCIXFzAL6rDcuB/gQMSCMExBJvRiJyGwNQ2qwsmFyhg5kcn8xLOBjEhqY9dE8Q9MEAyfKzHm889t4ggcmM91qS+iy2qyoEBjvWdOghhLSaiDRxqjtFmvmuUBRyN9XjdyAfwEQhgstGrg2BF017R1SfTAgeENCsAvdrWJyyPxS4mXHdEca/RDwRSOeD+t96FADiH2VXSz7KtWdHM6WcHLc6hYJYAEPqcxoLiSymgYSCHL2BdjLPSoJy+tYovbqNq6o5zUXIacKwhw6nYPKMMMHn1WMTvmQOH+dpT9eBGZuKomr6hvk4/hEx+75865Q0z/gBdlAmNfXCaOdQG1dQM1mlYnjH64hi7lU+48+jadevelQHiolETAu4EsM+GwT4tMsYgJMq4nUynnidHpkYdIC4aw0oqPywffJUpXdVOkCijsGxRWjVGVq8MUKZoW+0R4LZmXpXeyIOqZnJbciIPbmvmVemNPKhqJrclJ/LgtmZelV6pB+m8JIzTL79AXm2SAv4bx+81Lfaw1/g7/5bu1x6l/emlmGyiQ2SZYFdAmiU8SsgZQoQ2e98zKrb3ga9UJ6Z2kSMbzfzyT1fA5UPeVq0rYCIB5qkXrHWtHCTYTmdlo88GmY2ugN1SVhlgIjG9BS5+MgGXg0ryt0+Old1lNroCrpS6RgMZMqimi0+V1Pkaw9ce4hmQMWYuNmurUjcQnwKMUnmTJwUUcyfS3kSG0suabNaWaZMCMmDW91Dk6EdfJjDodssGw4NCCAWAgv+xjR6NYlYwxa4J/66Pdj7aWpnGNgecCs05etd2oG7NoK0j1Dvp5pp24SjlzLHNqVvIaAvlF0WKH2ClGTyhUBdu3ZKN/ikpw/pQ/kgX7lhOMMw2F28U7YGHnxspIBHgqTUFSJzvIi48N+NxrLNP/1Rw3bvfu+41A0mNR9wDPz6QLtx7NmEWb+xyPqXwG5nnmrwB4qk155NjBFt85jOAXmUCTgJJwHIME8xfDFoYb8yPqtlFW+Z7OXlPgNSbBA7L6UMAUaAdCW5477ysYjR2k2TpaOEEXmI8MT/4lDr2c7TvGdA2coDxPtqRYAwhP6ykDwflFLPT7u4ky3nscJNEMmx5dLd0HD/hDshaD2xTPN19A7pJpe3YqLrX3iSRDDcdftuUAvpVHkb/CDCMWQ5SR+TBIGf3meyACu/eg/8BAAD//9woJCYAAAAGSURBVAMAtAUFjyLJGrwAAAAASUVORK5CYII="

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAADzUlEQVR4AcSYgVXbMBCGbRZo2QAmKGwAE7RMAEwAnQCYAJgAOgEwAXQC2gmgE8AG9PsOn57iGF5C4zTPZ51O0n9/7iTZ8kozx+/l5eUzcoBcIPfIE5KXurYrDLvI2hzQpetMhADfQm4Z9YScIXvIBvIZyUtd2zcMl8gDYyS3hT7z9S4hANcQiShDwI94+oXcIeoUE5fkbsGQ2EwRe5MQIAdA3yM1kWfqJ8g2stq27Xrbtptt2263r3qL3bZzypqgxEznIfZ3r0FCkDlilKkxDaiN4Hs4XUWOkTtEck3/h922Q8p12vYRx1I0Yp122M1bvylC3YDjaoD/1ij8qGwzqZByLm3SWQyKuI47H1Hp3yYI0dE01WROAPXfDkajDzZUZ/wzYqpMdXaRlLasl7IQgoyTrk+mrpdBH1EgJVZN6qjzOQFXCGE9RcwzRXPeAagvTDrMTJ++LvrgQQimriRXgu1OQv+N+hgitj7Edn/Tt3pIEEJz7lDE5Sr68JwJhHduREnsidTV3VeIjnOnRIcBc6+mGnAWHR+uPonZ3SiZPvXGCNUhuwnrcm45l/Tmo8gyCH0N7fV2/Vos5e7jJh19ScUImbKoE8q6U9hGvPkMTHgfyqHXhHLmR8PYN/68cyh9lqBIKCdUNo7NpcaXlPXkEHNIg1KMVpYkSai4M0Jp/B+EMlXJISKUqfJlbNmkklByCEK/S7yapsz2ZuQfG3K9//1Jd6asXn51p+wzVplPB/GvvCkSchtXV+pnmvUxpd6Qf6ajlW4/yA3RY85uNo5Vki4fFTl/buAwMYf0Wz99fZsbbXJDRmzf2fWr+O5uGWLKGhgaIUWjzOsB2hYpYutDzOvOt3pIEAqtaTwh5H5wyD9xYNe0mKLDzHdpfX3vIxdCMDWP/dQtjFRHxrfF5OABQp9Zj7IQsgYp89kn5VnKvNtlboGIC8X39ZqMZzd9TeFNELIVUg6sSRliT51zrz7IuJo8/YohfIpviR6xcy6lPXbqUkmlI2V+zbNmB17iwA8IZ5SDGyh2o6Ezjzh+mPBU4VgxxKpfAMWYIjUVIUcqkDKknjprEMHdPAXC/4sE1Y3gA+Mk4YcJo1yn2RXs6XeHPp79c+6I53jJ0dQMRyhauEHqEUmQmhitcQko2AY1dYqJSyJ+iFCCBHhho1fUKR0nqVhAb0aIjuUSBJFYfkCQnM9A05D91LX5KHLO+GFCIhLIPlGCJRkjVbe5IW/NRChQuAmEXCI7iCnQKWpc6tr2qXnylSCjhi/6GH1J1Qvo01yEhqH/zQox55vRN5o3fwEAAP//fEQf+AAAAAZJREFUAwAvbXHidhxHlgAAAABJRU5ErkJggg=="

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABSUlEQVR4AeyWQWoCMRSG/6SFupgDdNGjuGuhvUW7ENreqC0u7C0UdOdRXHiAWShonvOURByIhLyIA76B54RJ3j8fn7N4Fh2/bguw91M/P/zVryX/lGIGGcwamt4RjRm0FGQxQEN4DFAGT2EtXBQDFHJE2xUwqiZxQw0miooeU4NRNYkbajBRVPSYGoyqSdxQg4miosdODPKY1Put33MKoP7xLdTPyeAeHtuOOUAA5A2e5yxolFcY+OAmdJCXQaP2PNlkHWKNw+awuv4vEe49RQBcfVWzrTNvDuYjrzD0oc7RMC+jeTeZl/V3NfFZAZAf8Mbqs/rPKcDM4S9r5zkZ+55GlI/h+wkgP+ha3Qrg5byrQalbNagGpQak/foNqkGpAWl/uW+QsPAw5LD0a+m9GGCYJ1vzXGcAGWQ/T7bmOX4uqWIGJRDnencAAAD//40HXKYAAAAGSURBVAMA9VsKYNBuxXgAAAAASUVORK5CYII="

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tijiaoshengqing_134@2x.09fdc35.png";

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAACpUlEQVR4AeyYr3MUMRiG93DUomtrwYLFFluNRXbqoJKpK0gG10qKLBYk/RuKpZIiizyeZycJ4S67ud1uj2HmOnk33+b79d6X7G7Se82Iv/l8vgP2wAE4Au8D3tI7pm5nROhmECGSSeSAROIpvUkf0Me2heCYOolJ9jFjK7eVCEFkC7wgqkRMiJjaD6TvATf0eZPsc3yFZHNdUa4SIphBD/F+BGK7RPgA9mez2SvwOmCfsZfgBFyD2KzSYYgVx4p9L6EQwKpIygBW4Izkb8AX4L3jCYxdgwuwSMwYTmNvpXoJkWUPGIiu8Rdbic/erAJIXWB3DPSla4zl1CsX0UmI6ljmOE0GPCaBfTFQ12DwkVSspg+GsYsunYSwfgZiOw+B4/2gPvi+y5ysfHb7RywSCtWxvFpeEtDSK48GMb7hLOgan9qHCosoEsIoThVi88nLRDjP4jzJ5CR2EYrvmpvwy5LDbYQQK62lUqwlQkyXj6XQ3hee/ZS4CsGctrgswlBT/HTkRj+T5XSCb/bOaEsVwvI+WFfLf3ybs0SoVfyry4ZQrfKbCm0qVKtATf/fraHet2rt13bof2XjSy/hUoXih1W/wRsynSrIv4/bi7YlQvm2IO5fFv1uc5/HzLc5bcy/CPGld2sZvy9uzCavEFsQY0ZS2+T0DNeS8ZIIoZBIvrW8Ysz97+QgcSSE2OySJ01dIoTG00DcB3HbyNwj0F1g1wQB5kyFyAnlqz/Ytt06LvOYJCfkadMz11eU64Q5T8nZtkTIxQY8lZ7S9wLPj8DNfydqMTK9OV3ohCxvYVtF5eJZ/wibTrBQ1WEyrKUKDXO7O+uxhJz3Gqv8DFazTfpRhJh/CYkUaEHw6D3qtDuKkMkhdUbvk+n/ihAbD4DKJ+hc7I4Nxm8AAAD//0Q8FbEAAAAGSURBVAMA2PQ4xGzZm0YAAAAASUVORK5CYII="

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAYAAAC5UQwxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFtSURBVHgB7VVdToNAGJxtjc/1BvQE0sb6ao/QG9ieQG9QPEH1BO0R2hv4ZiJN4QZyBJ4N8XN2A4YgCBRs+sAkJR+7053vZwCgQ4dzh8KRsF2Z8s9LpRAcbtQil/MmFnqY4xIbf6QCvXaBmkiEGE71vYhZ/iU4dmXJrUeGA/k0S04twaxQCW9NMStOaKsrTPZLBSsLsX29PlYUmsVLAeOFf6te0zwjOHLlA3FGR4OzEmXEQgq9+BPl5NGSCi00xRc2Zpwpg+TBuJQVChrAm6jKbq/t0r9gezJABBv5SoGuvFVBFcFD0XgihLxetSpI0+wguC7Y3pmk9OWUM+zhxGi1pfHzDP1K43O4y+MkFQZoDxb7ux3vZU3XWtnN0t7rVxtTnnNK90Wc9AzJd3jzwHDAX8j4+TBRT5UFfw7Sn5o+HB59h4z1s6ZJcZMkA3KGtQQzh0152DIRLnKpvZeZEqxizhBNYb/L3LS8Q4f/xDfWJHyqiB/VkwAAAABJRU5ErkJggg=="

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAADo0lEQVR4AcSYgXnaMBBG5SzQjEAmaJmgZAMyQcgEYYOkE6SZIHSCsEHoBEknCJ0gdAL6nuJz7RoK9MPApx/Jknz3fJZkyydpx99yueyha/SAXtEbimT5mYNHZJ/ejubT1kA4GKEnHLyir2iEdHhKHsnyJw6GyD4CC3jJ8VZpIxAQAyTEAxYHKNKCwgua1DSlPEP1JOBEG2gj2FogTj5Fd1g2KkaCYhLiPqV0js6KougXRXFV/NEF5XNU0G6fb+SRehQEu8OukeSwnVYCcYInCzKunfKFshBjHM6QcFStTrTbx9t6Rg8vgiwnbXob9ZEr6n8toBqMobbvnL8+Dm7RPyHo10qcM0dCCKYt+wjzVPryuFIDiA6G0sh4gp0cE8I4Vjz+bwElTB8D2iRL+nA26jPFrwFE5Q2yI1maYsQxsXNU0pof9hboguaA8i7ok6r3VAERHe+3obXFq7my0JG0rQ/Nj/Fdzd4KiJY6qTNlb5HBdiMRJW0bqah3ScnlDASh0Ylbdc8JQZ87dfGHD8elM1fzrv55jcpA1FyjSK6wUe4615fR0o9BSSdEx8g4uKycQN55dHSk8CVMLJ4+EXpGyOeO7SoaLR9KMeP0NxTosyUF8d/PIau7lmPJSOnno0DeMg+OAZMIgjAxTAZ1oF9SHUk/Sr+nAsXS/VZWHjPLQMcEaPk2Qt7DVsOBKz6U/hZ1oFiLyraDZjFs5gJ9L127fEdDWXWwLB6uPwVyHdCzMAePEk+KgJFhJlBjpbT2wMrPsNLn9ISFyUUpFsVLiI1U2d5thi8X5fyUx9OLLEaIcopnmDDxkmZ912q9ZWQgyNxbGSkBbiDvfCzhw+jExbsRyEHJQFIgXyvJcmq9fOfaPf0B451wMxEWb6NQARElx1Hsn6SP18rou89c2/rQpm+oOToeVEAeIEljGRhyJXuNFPbcDT/iJ97BHCb6pOo9NYCIko8RX77taA9PXLvLtMO2AsZx+Ux/bZIlfbQ2Ew2gxA+o3JGiOVkytH7FcE9uOe3yA8SouKMRJs73LggTPiqTLSBbSih3mTGmrHZGCOZ3ofrqaltDJYTvyL7E++Wkflu0uRJGIyuBbADKXaYQzr76lbiyui/H79LccSZkyEgI4SxynXFGaVIbgvixwqFhXUtrgaInYO5E/FAgmKGOJnMj5ZgQMuRYCQj7OHtH2PHLiWXr1mojUJyJQcG8jcIZOZ+BAtav1rKRcKG1jxBGpZrWYW9d/hsAAP//Ff8ZugAAAAZJREFUAwCWCWsqfCqVIwAAAABJRU5ErkJggg=="

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAEJUlEQVR4AcSWPWwTSRTH34y9cewQzrmr7hpMw0mnO47TVYcOXdLcHRII6ECKRFKFiIJUIEEBDUjQAFVwmgQJCShQKJBANEloqBBfFTRxKiqIwQlJHHse77/Z2dhmvVnjDYx2dnZ23sdv3ryZXU0tls7R+Vz62sKJzNjCeDr/YTaTL81LZa/OZ8ZKT9P50mRXfuEoZFs0T5GBukY/DKTHSlNaJ2eV4ivEPKBI5cRhVqq9ssS0SxEdZOIJyEIHcBSxbAgks+xN5xdmWatxxdRLLRboAC4jNqKANQXKjs9nu/KlyzLLKUWMSLSI0ijOOZaoyeQuw3bjqO0HAklUcuVVZ4qJRijmIpMbKZedp/ARZPozIAgq7UxJjuwKUojnHee0+ICvRnt1QAglYGQWMSxRo6vGvkAlkpPwWTtSB7RaTp79OjAeguzIlbJz1uu5jQ+Ebb0ZOeN6CblJAEY6R0v+7vWBjNZ1pCE2Yh/ScqRYoy4QoiOkm5Y3e35M0L5c0voMaDlnzygXyCTU0QCpWF6d/rODHuxP0+1/OwlgzYwaxQMY09h66gtOYChvVI//6tAZAbJy33XIR8V2GlowgEUnKOEnVINMW93+HUm6tDvl27jwpEz35ip+P+hBaX1Qs1YHggbbebfze00X/6qHOS9AG9lUKvG7FqFYk3nbFkX3JWeyqbXlufFqlaLACAfJn0JvrEBrMBmyMI/eVGloZsX1Fe3GWS2Ctf8z0q2/spKIlyT8+d4UhSWlhdnWvRaZF28NHXm4TC0WFyhU5285Q47/5lD/DsfdukHCjTBzJUOHHy5RcYWDxEPfIULFMImX76r03jO856cE5f9ZT1boIYK3/kuTjQxg9t5borlS6zBir6jlpykUCIb/FwcWqv9nh7CEouxet+TA2/kD5kUCYagNGNgraGV4Bk9hFflw8vF6cmIJceAhWogadLE8bcLILxjPaWZ6RhHKjdcVGppeT1J8EhAtqMYBAzta6UnNytxFJ0oFVNCZckqihyhGsREmUzWrM3p5uKfAiqYpYsEnAFDPZVsjvxA1gEZUbyomKzUNFjcbucrXm0oGDABq952P9MvNRYoDBi60UhNui9vy8NYJ2W0FPH+byoXFoS1uUNwIAYKNGkT7LaoifY68or2Wloe7pxXTVduvaTf1ET5tdODIB0LHSVVAGukYgHz7lQueT99UHVBxsKdoTOUQE3+FfOKCMdU++PRp5KEOSPqydD0FFkHeTChFzwCDbQ6ftfUzIAxCMNVR/QPri36cFTY7nEoffATZDQSCIEK5eKx7xBgejCdaLEtEfbAJ2/ARVJsCWWGcUUtDW7e7YEyRT3TyCk5gRWrgo9jATvZeN202BLKaLtix7j5jKhYO30DZkVzz+8JFZi4QqwlmJdFNbl8Sndptbe01az8BAAD//9Y5kLwAAAAGSURBVAMAWrPCMuTRIK0AAAAASUVORK5CYII="

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/youxiu_logo_wenzi@2x.cca5f3b.png";

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEb0lEQVR4AbSWXWwUVRTHZ6bbbbu6D7bRKmkNirYSkZpI0Er8SITyYHmQVsVoAvhg0weJ2vggNhpF6gMBgkYNqTH2QTEE+lJ8UGiCCSmKEhptDNRqiG4abNgSWGh3p7sznN/A3c7O7sxO+GjumXPuOf9zzr/33rmzhhb+r0qgTSJPi3SIrBd57apg4yMGBqyEyo8wBOJS5nGRdSKqQZ3Y7ibY+GgOBkJocgXqP4IIULRVUl8SWSLCXFToARlyHwnK8CMA87WS+JDI9Q4IQISaRbVKEWAp2wVZMkH81zKoRU1qF+R7CQBsEwRaVPEw6u+NVW3at6b64z97aj5L7kSwoy9/wnYVJ8x7qFlU20sAlgDn01yW8cBTdVWbj/RWPLi63ahtbNIj0RiCHXly44bYrsk+MK4Ur0ltekRVwE2AvQKgYgWawlXde3r06nidnZpKmPt6t6ffa3kTmfthxxd2+kJSk1i1YMAWJBdO6EEvx6sIFDidiOcR7ehrV80z21Ztzx7cNW79/88MMjf4/mim74mPrOn/xiER7dy6xpPunXK46akpAnlGXiRz9t24eyl3gZb58tXPaYrfLfjMge6v8el3LW4hBztAeLUdAuwH76wv1lj6bANBazpxyjr5UxK7lBCzL0wlOBfaPcuLTrwnp1nmUVZgoRg3bNjZzAzFjHh9DTpA+McXQmBBAOhmhxZAoNxS5UkYtQ3Nsd2p3UFi1DYGbme+2BWjDgK3XrGLn5FVrzcZj61rLI6E8zj5cncEoOMQ8P3IVLa98WL1xv7egAK+IT1eG4t29vVwL/iCNM05hL5xdaD0W26vsbOmc7h8we6AXEp6zW3OIbRmzp91h7w2K5DxOtXc+vvXE9gVj3autE4eHsYOI7mJYyPGkpXOvWGNHTwakGNC4KIfIDv0wc/85xws+1ximnfcD6v8XNN2+vwsOZqsRPb4/nEVK6FTEPC/WOSqzY0OHSCxovWV57Oj3x+y/v19hHkpyZ35azR36shIZFnHC8Szx/YPWQEXl2CSEJgUw3eY/RuGc2OHhrjdKuWLp+m2zsfHmjg6zM2YOzNxAhuffnEqGVm21mlOjvnNpqDlp+ckBE6L5XsOJKZlPn3uAAWxjcaW1srVb3Xr9YuabXN2Vp+7lMbGZ9y34hkw2d8G95KDXUZOQ8AUUNA+SVhzSKR3tm9WW6DH72iouPP+hyGEzRvDSoAx+9eHObD0dA4hDcZ4lBP2M711xcBMV7yL3wMKn/6qa0vmw+Xvpre17QWj/GX0ceKsADoljz9EQg9+Dyiw9cu3CT7Hah5C05yezudY4fNO5bhJmsb0csqrFWDCWeCVA8C8rHAv8CaUBc4DqE2PvMdNACeAH8VAiwoes28v2pJ+Z/GOYFQ+Ss2i2l4CoLmYYEkC8xsh1KImtQvqlSIAgIQ9YuT3SuxrHRzuQUmmpqjC4UdAoSAAEd5Z5Qujudh4tcnlNmReMq8cAZJgfliMARE0ZFhKd1FsfMTAfCdYvhkp0YHjMgAAAP//HK7qRgAAAAZJREFUAwA2M55aIXOIpAAAAABJRU5ErkJggg=="

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAE5ElEQVR4AayWS0hjVxjHYxepkY4LgyLDDLrwsdAyo25MQSgogpJZaGGsgqiIjy7FB2KzqxQfWHcdHygmG6uCKBMfFJUuxCmCjNBuDC5UhllIBV+Y6kLm+93MiclN7k2YmXC+e875nv9zzne+k68s8f++FtUcoe+FfhBqEGr9SIzhIUMHXRHFbvEAeCRuvhP6UUgFsMs4NAhjeARHB0D02IqqcTMDgFOHmNYK5Qsxly7uBhhsi8wsjACAvFoMvxX63AYAgOAzwlc0AGylUzSDBhMTE47b29vRgYGB58L/lIYvfOI7zF4PAMVy0aCX7qFZrdakjo6Ohvr6+qcrKysvjo6OOgEFMR4bG+O4HgwiR/iM8K0HAEoUw8xbW1vfHBwc7FsFhMfjcVVWVjozMjJymEOM29raGi8uLn4tLS2NWGWIM3wTw6p4oQA4KxSULKx3Op3uy8vLM5h3d3c3PT09I9nZ2R3Q4ODgK2TJycn2xcXFzjhAEAtXFgWAwEGmJtF9Dg8Pb/r7+2dgs2p6eFBvb+9+UVFR//HxsQ8QQ0NDL5CbEMlNzCAA0+BZWVlJ0PDwsG9efjh2uVyNoSsFSHNzswYwPz//GfromRBXWwPAeXBnDXWrqqqebGxs/IRCTU3Nplrp1NRUIzxFm5ubZ6enp+/YIYfDYZYLmOTKx8oRZMogZiPR5ubmSlFkpZx5KA8+5Pf7b+jT09Nt9CbEwjMB8NhEKUxUXFz8DAYrVfnwUn7d3d2mO4iNAT0GQKytimpLPmxvb28idEk+xHHmqOrJDoBv9Fw1Z2UUHjXX9yUlJfMqH7xeLw9QmAr2oYkaJgxMHgHA8JHp6uqqofAEdC0Wm82WpMaqJx+oC7m5uc/JEaVjt9uT5Dp2UheUbpTeCoAo/ADL7w8kVEpKio0gqampT1lVQBr4kg+jo6NuZpIOL9PS0p6QoNjAOz8//4/eiABwayTc3d19i6y2trZsa2sreN76baUQqXxAf0d+5eXl/IewrK2tvYFnQHcAuDYQWvr6+v5m5Vw3WYmfO06lW11dde3t7TWyGxD2TU1NXuSMCwsLC7BhJxYWFnzwDOgKAFp9j6ZAdVtaWvIiq66udi4vL2/s7+/vUGgkiIMzhjh7dOvq6n4HMMeAzezs7GuOiLEBnQHgvYFQY1P51tfXXxO0paWl8f7+PmFycnKGLT85OTnw+XxvZVe0okMwt9s9jyFAYqwetfcAOJLRrZBhq6io8AICBVYOkJycnFy//K6vr/8XXgFPMbWApxtwAOYGwMPOgI4AcCdCs3MSscUCiLKysj6OAAbbzNWT4A7GiYmJNt4MZOQD5y87Y5+enub9h60nYmpJiOBfPrGILS4oKHAnJCS08X9A6Tc0NPySl5f3M9URHvkgOTPCMUixKjXYhT102QH6K/n8IxR3U8Ew8Hg87wjKWBFgpUS/Gh8fn9HLRIfgxNSeY5lrLcjUZl/gA8j29nZ9HSAwsbQIageYkAtcORSYxyTeAW5CTMUHBXwTI8gJBQAThT9lQC+decvMzByRgvObuVZQis8I33oAaFOYQIkB8y9B+MInvsP8RQOAAgazMgielYw/tZHci2KMT+nCmxEApQUAgHBnFS+ensLG1caWJGQe1S4WAIxA/pcMeHLpAcNWhjplDA8ZOn+I/o7QlZBp+wAAAP//S8byOAAAAAZJREFUAwDHzABp8SMLCQAAAABJRU5ErkJggg=="

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAESUlEQVR4AeyYgVXbMBCGRSegG8AEpRMUNigTFCYAJihMUJgAmKB0gtAJ6AZkg7JB+n96Pr9LLNtyIjvpe/B0lm3pdP9/dzo5fAj/+d87gZwALhaLY8nXnLlD54wegQr4TMB+6v67+qJtdAJCuy+xdl2axBQEDLz1RUlsgwBEipGYmsAf0FdShMTUBO4E/kZiDRI/7GGdfmoCYW9v71pAzyXWLrWx7+1haD85AQCKxIN6T+JsXRJbISDwRKIIia0RKEWiOAGlwoGElLhQT25/A2ybuHR6q+agO5OuPwCroWZXhICM8a1zr/6vTLxKAH6r/kxyLOlsFYkTTTIS6GSR2IiAAOMtAPOtA9gurwHuWSCTTSQ4IzyJI03sJbEWAQE/kgAaTx/IkDUDSb2nygDoUINRBHKu+9am8cEkBhMQ8AshADxh1m1seDaCFYgTyaXkQfIsmVcCuTi566K5g0gMIiDwfA6T25YqeBTACGCzQHYRYMyRYH1ekU4vsu+jzfuQTUDKeJ5TNCrqQpp8ljG8r8eyTetaJIwE4NkT9LWxLAICjxKeN8UbGSBNinjcFl3tZQPwpCY9w+CAhGVAdgRmIaAf5U4L+0jEl2NdZAvwFAQzAYn652lvBOR98h4lFmBDXnIzlcg++U+1M5MQqtO2k4CUAU59N2XCafej97IPeCoeOLAHeAoGPc+9KUSoTJmyWCtG7REvAs8nCOAt39nUFI0lDJ0RED4qj7rY/A+R+GKsi8Bjl69VA0/K4PlG0WgloEU4qMz71Pgl5inw0tmX8F10q55/o7yqt8a9rZdSj+80mT3nK96jNnISPAqtBDTocx9v6FW6yWgErVH7LsKDPv00FACPU0Lbn9YBvK9wlGuPo6HaReCLm/3L3de3MsinM3mKANpCbnMIOWLPrb3W4rfxKnj/nNRNEtBieAtBifRpgNAcAL9ogvcq84gWdftQof+o8StJa9M6pB1l0pdnPN8LnkWTBDRA+VIX2+94rS4yaF4nT83jAGeTA/pcwLMqltZCn+j5NEE/CzyQ2gh4r1IBmBtkkKhg0I/zTQTwawGHSJzbd3FrmbPQZbMSwT71eryNwKd6RgjUXw8eEkF/VCUMDv4m6gBfO0vrZ7U2AgbyDa86g/bewA822LIWB1R0VBZqN6mPwDxhEEMYhIRbKuuWyLLxVx2xzlrRYINABTgO6kJeUt68wVOiorF1GpWGjYsujiAF1wbPIg0CemlgdRvYYBxIQX8Y2tig1qEVAc9CKQK8NzFv8Xwlz0OC+03kUco4gujqdrOWIuBB2+ocLE/2MLD3QPkxdCZH+HcDl1uenkMAr3NoLWtmPgksxDmZAc4eyNTMm5YisKo56IBaVeZZJDiZSR0ei0ofAX5CjmK4FIsUAVLG1s/+JjGF2E94aRBQuDldT4WBSrHT3hfG9G9ikXiSQIQ5Oy2NCOw02gS4dwIJp0z66h8AAAD//6DUBkoAAAAGSURBVAMAnTSkcEBEF4oAAAAASUVORK5CYII="

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFQElEQVR4AeyYgVUbMQyGL12gdILSDcoGMEHpBMAEpRMAE0AngE4AnQA2gE4AI3QD+n1+0eG72JccSR6P95JnRT5blvRLss/Jh+adfzYA3jqBmwxsMrBkBNZSQs/Pz9vQPnQIbS/p4+DylQLAWR2+xeIjdA1dQvdQsSEv0FP4QVFggcGVAMCBr5CO6vBuz+4Wc7UsHCN7Al0hcwlt0R/VlgaA0R9YNOpf4dHu6PyD5rWnTOCQ/j36amCZnm0dAC6GjMQFfK4iZIzeBWojcg/09yaTyR7cPqzeJpOJa4+QCLDavEWvnOH5rQMAcaMgGdVHFKmsWJ/M6fwpa6L9oqPzRp/uYg0QV0juQJENndduBIWpeusD6Bu3nq1PwZiZVCY473ju/BmOHEMRybrFwgzrdN6syZUQhPvJ/iB1AKBIAF9YYVpDGY+NCs2MNRqbtZl+dD4HMx0ex7CtPUFEEDyG3eSDijoAlFQRdAUJRIW/Hc/ILAjIIY0J2v7CRAY9tczofr4Im4IweDF8guxgKc0AiJVyFN5BRl4wKu5vTJVbr5bYAcYCmMuHyPJQ7zVrOnsMezcsjKCofzALRQAoNTqtYpQ+QWbFzSaZFaOPrdR03M0oENe6R9JE5etPNl468QxWiHigRH+GFwEgZXTcvNY7jy8NIA/QIfSJUQ1FtHhMzbW+F6ogWOueMQguMMpmxH4i5i2l0OuLsKqrBiAp4kvlsHLDkFlxn1hiOqThkrBZaTM6FbA0Qn6XrPedPJvKyTp7xYGgeQBCbpADxBIzKwIpZUXnzGiU2DZrLEFlQ7fvlejL8/32zYESrQRArhjH8qwYxYiyYu4VS0wgltlnBgUCazyZ2oyjx/EA4aWvnVM4aASAWLIYxwGzcgo3K5aZJZYvTllhIByTC5Chtv1te03Tn2v8rA0ANb2lAQkQ/eM4z4oiQelYZW04axZirtUXA/K1AUC5zviOaDcvQMyKJVbLio63xzE6PkKDbZ0ANJzKJIuoY4kA089K1Hua58u9ItFNrQhm3QCS5aEvgERWfEFK7pVSid0QCLPaOVLfHABOebdKGAETL0lLzCM2XmZpni+dF4Sn2AnPzZsCwHlLxBuuDumcPiUCjHvF00sw/ay4V/wtvf1mAHDeUyVFEY91qFjjALHE4iX5HVkve7DG8acagDi+0j0EY+lVn/Nm+c85KnQc1lg6RrmJD7bOoc4NFzA3kCA+wc1MtYTiRDBKvjFnCOXeZcLeKM5anbd8XGewdMp+IuYFpn6PVG2n8fjCedekx1oGfjJbOgkYbps/NjTUDozotBuXNUc41LflbZWp1DqZSSPZVxEACs2AG8iTwPtMTlGDZsc/rzJ1C3fVa3T9EyD0pcVE38zEy09gyqW50lcRgIKAcJN4EnifaYk5jauYbuMFzHKwvzBNdRv5zjGJ82b0JFOk3bCVDb90qwBeRLo9jFt/1qzcyWMM50YdG03o0HnrXe56gzdYPgqNBuAiQFhi7hMfJc9kTw3LyudRVHDeqFu2c/W8CoBaAWFt5kY8NXwpVX98uK5POO9vXn+6RuR13r0h74vPPL8agJoA4Wnhnohy0gnvLP47bV+xKuG8+8e/FyNzOr2w8ypeCoAKAGEmvIRp3CFJ5yX7Q5RfH6z3HfTleobWprmlAahFo5BvRrPh/nA4yNOs5pT7yGPUqHtdiEzG2rl8JQDCCiA8OcyGYDypBOT7JEQ6HPl0NYB3jtOO0JyHlQIIWzhk1HVOQLXoh/hSfC0AmqVcGrd4A2BcvFYvvcnA6mM6TuO7z8B/AAAA///ElDyJAAAABklEQVQDANY3Bn8CmbUVAAAAAElFTkSuQmCC"

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEZElEQVR4AeyYgXXTQAyGEyaADWACYAJgAmACygSUCVomACagTNAyQbtBywR0hG5Qvu+e5Se7PieO09f0veRZ1uVOJ+mXdOeznywe+W8P4KETuM/APgMzI3AvJXR7e/sc+gAdQM9n+jg6fasAcFaHz7H4DzqFfkGX0OCFvECP4Z8GBdbo3AoAHHgF6agOv+3ZfcpYLQuHyB5BJ8j8gp7SnnTNBoDRL1g06q/gcV3QuIFWXddJ4ID2JfpqYBm+e80CgDGj9wO1Ebkr2u+Wy+U7uG1Y/Voul879jESA1flz9MrpXn1tDAAjOn+cTPykrfNGn+Z6FyBOkHwNRTZ0XhARFIbq10YAcN46z85/w5FDKCJZtzgwwjydN2tyJQTherI9SpMB4Hxfuc5nMKMGa4MJRATBbdhFXptS+qsAcNSd5Qfc3aElZrk9CoLm4gzDk51Hp7rV+WGRfugyA66J6D1CdrSUBgEwyRJxZ3GHcXfIFLuNxr6GpYnc8lDnKbY6zwBAnKEr1pHOj2ZhEAAKvkNOhlWvY4wJoiowMvAnjZnlyGh05ywYxOi/w2sAIsrW4wtm9ekZzv+mf6OLuZZdzDdQZqTVxbiBabNAlqyIdjw3agBC5kZlAySwkNmUWxo66vy3A05+c6Chzlpp+gpbBaAI3ceNoBiEXCo+V7Kp/CB8nwdy+8EA6AQgLBOB+NedyXKyvWDM/gDhoa8dKwLNbQKAZsb2WSxoHewv5r/JXH+sDO0CgIiyDsXmYVsyC3JJgPIO7QKA7GTHOf6MjTG8WOwCgMHIFu/WuO0CgFw2sa2G6y+jAR/Mxi4AeINzceX1YF/OTh+c4w9bQjy8PA/F7nLRbJ3FMcZ0Pp7AV3msCDS3B8tA42B+ePli07hVWDjvn35m7CtUAxD15gt5ecxjsMPL7Hk3D4wR/WsiHGej0JqPD55Qo7/DawACsWn0WH2HAORZpqNs3T/M1XnLxykGy7cx24UYF1gcswUXD7synm81AJ5RBhdNmuzLhoZS19rNvPN8Jvp9W55WQ1k/M9Ff+CCARqFREYinwkyRTrPj21lRNPGmXmvejwChr6gg+mamjT6dysGGr0EAigoCOoF8cWmJMY1HxDyAWQ50r3+h07Iw8h7m2ok4b0bzwtZu2GrlcqMKIAvlNsat2Y/0yWGLQwwf2ZhD6NB515pcVQZvtHwUmgzASYBwkef3Yb9vfscJy0qRScQ8nc7OG3XLdqWejQCoFRDWZjbiruSnwerLh/P6hPO+8/pdVRAO67xrQ+7/UdoYgFoB4W7hmohy0okznPLrtG3FqoSc68fPi5E5nV7beRXPAqACQJiJ/GnQbp2XbI9RflhZ76/RJ4ixOZ2x2QDUplHILxdmw/Vhd5A7Ts0p15HbqFE/QEdkMuau5FsBEFZwwJ3DbAjGnUpAPk9CpMOR98veR3hnO+0IrfizVQBhC4eMus4JqBb9EJ/F7wXAYpZL0ybvAUyL1/al9xnYfkynaXz0GfgPAAD//61I69AAAAAGSURBVAMAJIhycDsYc3cAAAAASUVORK5CYII="

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAC5klEQVR4AeyZMWsVQRSF94mFhYVlCkshWlgEEtTKhAS0s7UQ1MoigopCBFsLBYMKCnYqKvgTFBRjF0kKIU2KBFKkSCBlihSBl+/ADOwmb2Z23mQ2Cdlwz7szb3buuWfuZpOdOVEc8Z9WwEEXMKoC3W53GEyB15nwmLiXYhallgCCDoI/BJ4DL8DDTHhF3Fm45sAg7aAFBRBonCjzYBQ0ZcMQzcN9Fe81rwACDDD7KzgNZEt83AdjmaDKrhBbJs7v5HBGHRe8Apg0BSQCV/zi42Kn03kPZjLhLRwXgLhwhbiVg9o9ERJw08zawt8iaXma+cxw3IVhG8ju6MMFpwBKd5ZJWgFcMUvgdTWaAFyr8MwA2QC52DzUr8ApgKtOAmv2vrT9JvxmieRUqV1p+gRULjysnVbAQVemrUBbgcQVaG+hxAVMnt5WIHkJEwNEVCCRKdP0VkCmha0dtq1A7aXKdGFfFeAFYxzc3oVrmXL0ho0WQNJKVO+sn4hcxg/GtIPB181ZtABSs++qNPdY+S1uz2COL6IF8L76m0SuA71slzHB2E++b9SiBSg7JQo+74KEabhR9CWg0QwDZMdTAE+beyBlh/oZ851bJYFFrwxHVwDiG0T4ALSP2S+eM/8BSLZoATCuAd+jlOFapt23Whf6LooWwJPnHwHPg5Qd6iHifCNGstUVUPkDBfkySNmh/p+cuQngE1DeiXZurpo4OVz5XKCcS4XLKYAV1r0uaMIov7zarVY7O+DSgl02RGsmF9OtOqcAc5n+WVNTt9BHAu/Lo08BXTAcXxi3XDohotvbQgKmmWarMEF7AYJJoIrkwKQ4gLhwhbh18Kd2T3gFULoNZumUxt6D5+i/AzqxdKMo+h1TbHFAUeh8QKdC3oMVrwBFQcRf/BDQSSWuEdPpzAjcwX8QgwKULoEWwQjtK+AJeJMJT4mrxMfgW6QdtFoCbBSC6qxsGv8oE14SN6rSUQKskMPkj7yAHQAAAP//ofH0AQAAAAZJREFUAwCmutlwFlRZGwAAAABJRU5ErkJggg=="

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADsklEQVR4AeyXgXHUMBBFZSo4Osh1kFQA6QAqACqADggVQAcJFQAVBCpIOkg6gA6O/268N7K1kmXfgZ0Z32hPsrT7tV9rr6Rn4Yn/VgJzB3CNwBqBI1cg+wrtdruN5KPkVlJb7qT4psYn6dXgD+K5BAR+JifuJFeSl5Laci7FG9k/SMDQY1rasRr8QTyXgKa8lcQOPOr554Dca9wKtkRuYx29uga/Ci8hoNV5q8lwQFXA8cumabZN01CX5CKEsJVgoyqA8SH0fiPwq/ASAprvvcQKDrPy9lysm6bB+XeR0ouobc1q/Bo8jwDvHZPdtwC0q0U2EIYINt73Mwp/CM8jwMTIH/4mihEomY/Bz+KVCJQmX8zYSmDuUJQiQBqc6t9mquFYO48AWQScM+VsL4swlhXZQPyQabKKJxrwCPyKsK9bh6KufFO6EGaXNaUv1nBqiDrdblc2oh4BJrW0xSScazhUcTQoyYOmxnls1AyPyuFfQ/obFWEtCnjZiCYENCn5+VLzGgk1AwCsbkmYKLQ/bMFoHztVdYTlPPOxKAbA4lp7XycE6BUJVo9zDceC9lDFyKCwup+kdQGGaq/gBAQZg3QuwlURdQmAjMiJGwnOqKoqnJ2upEkUgUikHSM6RgIdL8KQYwxBFxvaHSkS6Gie8EEkaiM8GNFZCNhaiMhQhAcjOisBI3JM7RLQ188mRsr8rfYpyjeBxO904rPGvTsy6bt4x04ICIiJuK+SwrIbSOJBueOVhnEGbDW7JZqzfwfn4y7esRMCgv4sMcfJJnxIxwgZRJABzOvg/8j1MTls4vTNGG8EGB0EjwCrhRIgW31ofEiTRUDcbVkINQMrGuKfVj93B8eOvQg/MIFEcsf2CKCMkOpsYp4niRYADFvNZAUFmr0jyxbn2Uylti/JHbtEYG/xH/4sKu4dXCR4fSGCK3yX1AdZAgFzhkhZu18bgX5/WBKBxLmajpVAzSr9S50lRYA0mePqZa+97hIIkGVwhuNLkmW0T0DskKlQjMUjYNngXMZZ5jFIqd1i4EROLXtDky2E2KXNlsuQtfe1RyDedDi/sIVPFs3CzcoI/NBzv+CUpUn07IaGHc7Thw0ba3LH9giw81kUMGYVjhGLIpjJUUAbFf3ctowEzvLKMDdthDF0aHckISBAlDmHfO9oTn/AQd5zrqZgJ0jMKeHcw+LZG4AedsU7dkIAK4ERrteqp5Wu1XM9chh0nWc+E+n1b2jYFe/YLgEDfAr1SmDuKK0RmDsCfwEAAP//fa90JQAAAAZJREFUAwDEoGR/Vx6NUQAAAABJRU5ErkJggg=="

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADwklEQVR4AeyYgVnbMBCFRSdgBLpBmaCwQTtBywTQCYAN6ATQCRiBdgLYADZoN6D/LyyjYOE4sQRpP/Lp5WxZurt3urMtvwv/+O+NwGsv4P+/Avf399vitSP9nP3RFcDxHSZeg98cf0FuXBslgLfbQBKIcAaJdOz5RmCUwNbW1g1e/gA2yVxBQun5RmBAQAfBIUiOHuGpRBDBFTCduFy1XaNtrRRdIIASHTTnz0IIxyCwCn+Qn4ES0aR9QOsF9m+BPnA6rS0QYMoVSAqOUBajAok7+iWB6JuEfnI2F2l1URW0vVKa9gRw9msIQQWBnw7v43jKf1dCR79xLW8HjHHcHOyi8D3QJiLog2kbpvx6Agw+BKnpkA6n8yhx1tRKpLbpXClajC829Or8QXbxY3Y8epgTMA8dfNMp9LgEo5OW3Whdlgat2odNAyYRp+75l4MM8YF6jDwB2o2XcwKxgz9zG1FuGPK69aB00B4KY8F7MhOJQK8G3dFxOm7BCdDWOTK2EoF4YewPEhqSRBpmVGLBp44aEuc/oce7oo6bspzG1q/QWgRUAQmXPC/qqk9qnPeOaHr26aLdp1ibgIog0aSo1Q36KHNssPY7iXhsswh0apoUdafbVPWOKCTRdT+K2QRYBYvZelCquVZRn6L7PSg6riExm4BKMGKkJOGpmF3U6LRw1TWKFQiM6ik9qasW9XPWqxHQAFFrWdSaGKAqgU57y6LuTDyK6gRYBYvZelBqqVZRq2uA6gS0AInqRa3eEpoQ0BAkvP01e1JrQzQjoHJINC/qpgQkAdYqat6FJr0cNifAKljM6xR12iOnfQqxGLbmBDQJiXWL2jdRv1icsyIeq24BL0JAi5BYtagl7VThft0NzWA1XoyAXkBiclEz1o2+++ScSL6pUWV4UQLRYgiTixoSFyEE9wGnyLylPXmRwE4+svYxTo0V9SDCjL8Dvpm6It/xR0iKw7BAwBy1c4eCyXdD9lUFDpkW3pmSXl+/dTLleB/hNMA54KiDQYiX8hT6FXse/p6t+ofL8/9xxIDlT2q/NiTF1ko6HpU5AScZGSeYRn6n9Bbmx6vaUH+AhDbThzLtClPmaZ/9RfQEUOaymFuJhBNcUtOpNi5J05TveVFrM7fv+Sh6Ao6ChOwtFm9fgzx0TCUYmJgy2DRw1oNS9Su9fi8QcLZA6QXYBS1bn/8YMeqS0LxwVZRLUSSwdFaDAZBIRS0Zb5WTrLQhMMn0cBAkzoCfUrylDgcUejaKQMG/pV1vBJaGqPGAtxVoHOCl6v8CAAD//6NtcAsAAAAGSURBVAMAJ5/tcMYd/7kAAAAASUVORK5CYII="

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACiElEQVR4AeyYgVXbMBCG7U6QEcgGZYKWDbpB2wnKBoQN2glIJ+gIlAlgAxiBDcL3+XFCfnbAEGyL95x3f+6iSLr77yQ9y5+qD/5ZCMxdwKUCSwUOzMCyhA5M4MHDOxXY7XYrcAYuwVRyjaPvb2HTIsAkR0xyDTbgK5hKPuNoi/9bYAz8HCYtAgy5BPkEd/z+PzJumD9E31Z+FQ0v6UQA5j/o7ASoysBP6rpe13WtHhPHVVWtgT5RlTGcVgM/iQD9f4EQAzbz8XtUXde1wf/MnHzJ7GfNnIDr0M43jxNqTwZ8mjCJ6LOz/1ghcbhssK2S/aqcQNPA1z2YS4JA8k+wTeA03AIPlzP0BWikj0DzRwlfBP+NOOJUXGGHpAoVS4DgPRH/EXFaLtgdKZYAkaYsY7s/Th416klKJmCU7glPRCEJ21oomcA5J9Ma9AYeLIolQOCeOBHnXv0KAnvnmPWPhcCs6cf5UgGSMKssFZg1/TgvtgI8Cw26IxdLgOTGHTnuKTR1pWQCRuuTqG8sLqiItm0tlEzAB7kI1vu6F5pONYolwLOQF33vyTmR/FLTkCuWgNFBYov2HnCOziW9iukj0LvW8tEj2p0MQ+IO+GRqRf7gW0gKs2pd6uO5+4gNk9+Gmo5jf+HTxMUaTxkOv5CQyClapBcPeQWuojN6767nv3cXgjdh3oFj7t9hvKRzAg6KDWM2fE/pEearvjHh6WLw+jReM/1XYwgSAUpjWVxbQcLxltTsjIkIXH/6NgbtQUgE7A0J2btZPL4669A+I8H950lzbAyv8dEiEAOZZAucDDWJ+NZhgydXQYQxSPcSGDSykE7jEJiQ3EJgwmT3uloq0JuWCRs/fAUeAAAA//+nBnjzAAAABklEQVQDAPf2gHB3HKNlAAAAAElFTkSuQmCC"

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADTElEQVR4AeyXgVXbMBCG7U5ANygbwASlE7RM0DIBbNAwAekEwAS0E0AngA3KBqQTpP9ndH7n2JZPSWh4fc3T5STFOn06nU/Km+qVf/4DbrpB/74Hl8vlkWQu+SV5klDQt6qcSt5t4sW1PcjEkltNjpxKA7InTUEfqTKXAH6hZ+lTs6ysBajJPmuaewkQUk151PdVku/StKWacqbve41jEarGSzGgJgEKEPPInab7UNf1fl3XJ/WzHEvvq/9EYqDAse02Tj9NlyJAwTHJpTN7LhDggHTdz1X9xkIO1bqWUBh/QyUqRYAyOpMwiVQFHG3qoyLIheSLHrBF8FKxC+qaLmFAeY+tIfaw+qhJJ+F40Anbbc2vVpnSYUAZ8qsuhau0IGLRe5EFy2y+lAAeOFM/Xb2k+sM9bKHiuvrVEsDWYPJG39p0z4N7xC/YdXerJYDdkZu3niImSgAXZlAvTOtN6wtq77XfkTElgH57PkWMDzzz3vV5e667Wy0B5PgyL1q66VrLtJLXbWF3imOzlRlVVWHAZPBbsnagCcO5LI3xJwgnTOrOqzBgMsPtxFY+i0DqmT0Jx6PF35UWa0dfMjuuigBlGLhjZw7ISwEMvjTqJ7lz6+GoYxjJ+pxKVIoAMSpITgMggaWLybnzcZ26ERTAaNIId0WDB46LBZpxISkGFABe4YK6elSxhbwEAKP978TuoRZXBMcKwoCASfAIAiTjTZjYpw28i6fZzrcCO5PQZ8+H9SSgoAjyC1lcBQOAGwoAXFbxkDiaQh/bOVNrLTDN15QsoOCIH8C4sjcD9EWKMADeyEVVqTdTsCMhNnNC2PSsjALKoMERWwxkG/EK1/pSr3A9IzZzwj9Dm4v5GhkEdHBA8iCnCFvIttIuFR+fY2NxQG/hg4CyQGI1uGvFEX+CeoP1XKho/FwyVYhjIDs2e4DyHkeYvaUPssq2dAb9zUYHUHB4jXiBgdWQkKnvTDqAojA4VStSBJDVLj8tYPKeXaO4DoUP9JdcQAuoSXyscWtR13YLTpCM5cLJPPgx4fCf1//7St1bUYQQjhiSyTxoUC+5tbl8SLz3Ulm7xUonvBRSNavcirtWjch4Lh/G8uCq0V23Ww/uGmRs/lcP+AcAAP//y2uqXwAAAAZJREFUAwBMt1JgYo468AAAAABJRU5ErkJggg=="

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAmUlEQVR4AeyR0Q2AIAxExUl0E0d3E9kE7whpaFKDCH4YMZwphdzT6zy9/PwIEEJYoCNpuZtsTUQbTGlMsca2vGoAZTfjxncAmI05o55/wLlwPhTrGJgArr4g3mp4CQAepJJOsUarfeWAdjfDYQCMUHRrRKTzMHZ5RDvOfRJrlGqxV30uAOech9YkGil39B+dC0C5ddwMQDHMEwAA//8ty/xUAAAABklEQVQDAKlvPDHnp8g5AAAAAElFTkSuQmCC"

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.9b60a61.png";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(787)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  "data-v-4ad01b5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(796)
__webpack_require__(795)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  "data-v-57eb2ee1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(754)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  "data-v-01619501",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(824)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(1048),
  /* scopeId */
  "data-v-e274896a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(811)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  "data-v-7d73bdbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _locale = __webpack_require__(129);

var _locale2 = _interopRequireDefault(_locale);

var _vueI18n = __webpack_require__(923);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _langs = __webpack_require__(457);

var _langs2 = _interopRequireDefault(_langs);

var _en = __webpack_require__(221);

var _en2 = _interopRequireDefault(_en);

var _cn = __webpack_require__(220);

var _cn2 = _interopRequireDefault(_cn);

var _tw = __webpack_require__(224);

var _tw2 = _interopRequireDefault(_tw);

var _ja = __webpack_require__(222);

var _ja2 = _interopRequireDefault(_ja);

var _ko = __webpack_require__(223);

var _ko2 = _interopRequireDefault(_ko);

var _en3 = __webpack_require__(280);

var _en4 = _interopRequireDefault(_en3);

var _zhCN = __webpack_require__(191);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _zhTW = __webpack_require__(283);

var _zhTW2 = _interopRequireDefault(_zhTW);

var _ja3 = __webpack_require__(281);

var _ja4 = _interopRequireDefault(_ja3);

var _ko3 = __webpack_require__(282);

var _ko4 = _interopRequireDefault(_ko3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);

var i18n = new _vueI18n2.default({
	locale: localStorage.getItem('Language') ? localStorage.getItem('Language') : "tw",
	messages: {
		'cn': (0, _extends3.default)({}, _cn2.default, _zhCN2.default),
		'en': (0, _extends3.default)({}, _en2.default, _en4.default),
		'tw': (0, _extends3.default)({}, _tw2.default, _zhTW2.default),
		'ja': (0, _extends3.default)({}, _ja2.default, _ja4.default),
		'ko': (0, _extends3.default)({}, _ko2.default, _ko4.default)
	}
});

exports.default = i18n;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(143);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(471);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(472);

var _createClass3 = _interopRequireDefault(_createClass2);

var _store = __webpack_require__(140);

var _store2 = _interopRequireDefault(_store);

var _jsCookie = __webpack_require__(106);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebSocketUtil = function () {
  function WebSocketUtil(url) {
    (0, _classCallCheck3.default)(this, WebSocketUtil);

    this.url = url;
    this.socket = null;
    this.listeners = {};
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectInterval = 3000;
    this.heartbeatInterval = 1000;
    this.heartbeatTimer = null;
    this.isManualClose = false;
  }

  (0, _createClass3.default)(WebSocketUtil, [{
    key: 'connect',
    value: function connect(userId, token) {
      var _this = this;

      if (this.socket) {
        console.warn('WebSocket is already connected.');
        return;
      }

      this.isManualClose = false;
      if (token) {
        this.socket = new WebSocket(this.url + '/' + userId + '/' + token);
      } else {
        this.socket = new WebSocket(this.url + '/' + userId);
      }

      this.socket.onopen = function () {
        console.log('WebSocket connection opened.');
        _this.emit('open');
        _this.startHeartbeat();
        _this.resetTimer = setTimeout(function () {
          _this.reconnectAttempts = 0;
        }, 10000);
      };

      this.socket.onmessage = function (event) {
        var data = JSON.parse(event.data);
        _this.onMessage(event.data);
      };

      this.socket.onclose = function (event) {
        console.log('WebSocket 连接关闭, code:', event.code, 'reason:', event.reason);
        _this.emit('close');
        _this.stopHeartbeat();
        if (_this.resetTimer) {
          clearTimeout(_this.resetTimer);
          _this.resetTimer = null;
        }
        _this.socket = null;

        if (_this.isManualClose) return;

        _this.handleReconnect(userId, token);
      };

      this.socket.onerror = function (error) {
        console.error('WebSocket error:', error);
        _this.emit('error', error);
      };
    }
  }, {
    key: 'send',
    value: function send(message) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(message);
      } else {
        console.warn('WebSocket 未连接.');
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.isManualClose = true;
      if (this.socket) {
        this.socket.close();
        console.log('WebSocket 关闭成功.');
      } else {
        console.warn('WebSocket 未连接.');
      }
    }
  }, {
    key: 'handleReconnect',
    value: function handleReconnect(userId, token) {
      var _this2 = this;

      if (this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts++;
        console.log('Attempting to reconnect (' + this.reconnectAttempts + '/' + this.maxReconnectAttempts + ')...');
        setTimeout(function () {
          _this2.connect(userId, token);
        }, this.reconnectInterval);
      } else {
        console.error('达到重新连接最大次数.');
      }
    }
  }, {
    key: 'startHeartbeat',
    value: function startHeartbeat() {
      var _this3 = this;

      this.heartbeatTimer = setInterval(function () {
        if (_this3.socket && _this3.socket.readyState === WebSocket.OPEN) {
          _this3.send((0, _stringify2.default)({ type: 'heartbeat' }));
        }
      }, this.heartbeatInterval);
    }
  }, {
    key: 'stopHeartbeat',
    value: function stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
        console.log('心跳停止.');
      }
    }
  }, {
    key: 'on',
    value: function on(event, callback) {
      if (!this.listeners[event]) {
        this.listeners[event] = [];
      }
      this.listeners[event].push(callback);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      if (this.listeners[event]) {
        this.listeners[event] = this.listeners[event].filter(function (listener) {
          return listener !== callback;
        });
      }
    }
  }, {
    key: 'emit',
    value: function emit(event) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.listeners[event]) {
        this.listeners[event].forEach(function (listener) {
          return listener.apply(undefined, args);
        });
      }
    }
  }]);
  return WebSocketUtil;
}();

exports.default = WebSocketUtil;

/***/ }),
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */,
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(774)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'app',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['isVideoCallIncoming'])),
	watch: {
		isVideoCallIncoming: function isVideoCallIncoming(newVal) {
			if (newVal) {
				this.$refs.audio.play();
			} else {
				this.$refs.audio.currentTime = 0;
				this.$refs.audio.pause();
			}
		}
	},
	methods: {},
	mounted: function mounted() {}
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

var _qrcode = __webpack_require__(88);

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			data: '',
			androidUrl: '',
			iosUrl: ''
		};
	},
	mounted: function mounted() {
		this.getAppDownloadConfig();
	},

	watch: {
		androidUrl: function androidUrl(val) {
			var _this = this;

			if (val) {
				this.$nextTick(function () {
					setTimeout(function () {
						_this.generateAndroidQRCode();
					}, 100);
				});
			}
		},
		iosUrl: function iosUrl(val) {
			var _this2 = this;

			if (val) {
				this.$nextTick(function () {
					setTimeout(function () {
						_this2.generateIosQRCode();
					}, 100);
				});
			}
		}
	},
	methods: {
		getAppDownloadConfig: function getAppDownloadConfig() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return (0, _user.getAppDownloadConfig)();

							case 3:
								res = _context.sent;

								_this3.data = res.data;
								console.log('APP下载配置:', _this3.data);
								_this3.resolveDownloadUrl();
								console.log('解析后的下载地址 - Android:', _this3.androidUrl, 'iOS:', _this3.iosUrl);
								_this3.$nextTick(function () {
									_this3.generateQRCodes();
								});
								_context.next = 14;
								break;

							case 11:
								_context.prev = 11;
								_context.t0 = _context['catch'](0);

								console.error('获取下载配置失败:', _context.t0);

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3, [[0, 11]]);
			}))();
		},
		resolveDownloadUrl: function resolveDownloadUrl() {
			if (!this.data) return;
			var isInternational = this.isInternationalVersion();
			if (isInternational) {
				this.androidUrl = this.data.androidDownloadUrl || '';
				this.iosUrl = this.data.iosDownloadUrl || '';
			} else {
				this.androidUrl = this.data.androidUrl || '';
				this.iosUrl = this.data.iosUrl || '';
			}
		},
		isInternationalVersion: function isInternationalVersion() {
			var lang = localStorage.getItem('language') || 'tw';
			var internationalLangs = ['en', 'ja', 'ko'];
			return internationalLangs.includes(lang);
		},
		generateQRCodes: function generateQRCodes() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!_this4.androidUrl) {
									_context2.next = 3;
									break;
								}

								_context2.next = 3;
								return _this4.generateAndroidQRCode();

							case 3:
								if (!_this4.iosUrl) {
									_context2.next = 6;
									break;
								}

								_context2.next = 6;
								return _this4.generateIosQRCode();

							case 6:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this4);
			}))();
		},
		generateAndroidQRCode: function generateAndroidQRCode() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (_this5.$refs.androidCanvas) {
									_context3.next = 3;
									break;
								}

								console.error('安卓Canvas不存在');
								return _context3.abrupt('return');

							case 3:
								_context3.prev = 3;
								_context3.next = 6;
								return _qrcode2.default.toCanvas(_this5.$refs.androidCanvas, _this5.androidUrl, {
									width: 220,
									margin: 2,
									color: {
										dark: '#000000',
										light: '#ffffff'
									}
								});

							case 6:
								console.log('安卓二维码生成成功');
								_context3.next = 12;
								break;

							case 9:
								_context3.prev = 9;
								_context3.t0 = _context3['catch'](3);

								console.error('生成安卓二维码失败:', _context3.t0);

							case 12:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this5, [[3, 9]]);
			}))();
		},
		generateIosQRCode: function generateIosQRCode() {
			var _this6 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (_this6.$refs.iosCanvas) {
									_context4.next = 3;
									break;
								}

								console.error('iOS Canvas不存在');
								return _context4.abrupt('return');

							case 3:
								_context4.prev = 3;
								_context4.next = 6;
								return _qrcode2.default.toCanvas(_this6.$refs.iosCanvas, _this6.iosUrl, {
									width: 220,
									margin: 2,
									color: {
										dark: '#000000',
										light: '#ffffff'
									}
								});

							case 6:
								console.log('iOS二维码生成成功');
								_context4.next = 12;
								break;

							case 9:
								_context4.prev = 9;
								_context4.t0 = _context4['catch'](3);

								console.error('生成iOS二维码失败:', _context4.t0);

							case 12:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this6, [[3, 9]]);
			}))();
		}
	}
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Carousel',

  props: {
    images: {
      type: Array,
      required: true
    },
    interval: {
      type: Number,
      default: 3000
    }
  },
  data: function data() {
    return {
      currentIndex: 1,
      timer: null,
      defaultGoodsImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png'
    };
  },

  methods: {
    handleImgError: function handleImgError(e) {
      e.target.src = this.defaultGoodsImg;

      e.target.onerror = null;
    },
    play: function play() {
      var _this = this;

      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(function () {
        _this.next();
      }, this.interval);
    },
    pause: function pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    next: function next() {
      var _this2 = this;

      this.currentIndex++;

      if (this.currentIndex === this.images.length + 1) {
        setTimeout(function () {
          _this2.$el.querySelector('.carousel-track').style.transition = 'none';
          _this2.currentIndex = 1;

          _this2.$nextTick(function () {
            _this2.$el.querySelector('.carousel-track').style.transition = 'transform 0.5s ease';
          });
        }, 500);
      }
    }
  },
  mounted: function mounted() {
    this.play();
  },
  beforeDestroy: function beforeDestroy() {
    this.pause();
  }
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'Danmu',
	data: function data() {
		return {
			inUserList: [],
			userQueue: [],
			isUserAnimating: false,
			animateTotalTime: 3000,
			animateGap: 1000,
			msgList: [{
				title: this.$t('all.danmushuoming')
			}],
			form: {
				content: ''
			},
			kjdyList: [],
			show_kjdy: true,
			zbUserId: ''
		};
	},
	mounted: function mounted() {
		this.checkIsLogin();

		this.getLiveCommonExpressionsList();
		this.getChatRoomDetails();
	},
	beforeDestroy: function beforeDestroy() {
		console.log(this.$ws, 'this.$ws');
		this.$ws.close();
	},

	methods: {
		checkIsLogin: function checkIsLogin() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.checkIsLogin)();

							case 2:
								res = _context.sent;

								if (res.data == 1) {
									_this.$ws.connect(_this.$route.query.liveId, _this.$store.state.userId);
								} else {
									_this.$ws.connect(_this.$route.query.liveId);
								}
								_this.getMessage();

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getMessage: function getMessage() {
			var _this2 = this;

			this.$ws.onMessage = function (res) {
				if (res) {
					var data = JSON.parse(res);

					if (data.data && data.data.pushType == 1) {
						console.log(data, 123);
						var newUser = {
							name: data.data.details.sendUserInfo.nickName
						};
						_this2.addUserToQueue(newUser);
						var msg = data.data.details;
						msg.title = _this2.$t('all.jinrulezhibojian');
						msg.type = 1;
						_this2.msgList.push(msg);
						_this2.$nextTick(function () {
							_this2.scrollToBottom();
						});
						_this2.$emit('changeUser');
						if (_this2.zbUserId == data.data.details.sendUserId) {
							_this2.$emit('pulling', data.data.details.sendUserId);
						}
					}
					if (data.data && data.data.pushType == 2) {
						console.log(data, 123);
						_this2.$emit('changeUser');
					}
					if (data.data && data.data.pushType == 3) {
						console.log(data);
						var _msg = data.data.details;
						_msg.title = data.data.content;
						_this2.msgList.push(_msg);
						_msg.type = 3;
						_this2.$nextTick(function () {
							_this2.scrollToBottom();
						});
					}

					if (data.data && data.data.pushType == 4) {}
					if (data.data && data.data.pushType == 5) {}
					if (data.data && data.data.pushType == 6) {}
					if (data.data && data.data.pushType == 7) {}
					if (data.code == 401) {
						_this2.$ws.close();
						_this2.$router.replace('/login');
						sessionStorage.setItem('user', null);
						_this2.$store.commit('changeToken', null);
						_this2.$store.commit('changeUserId', null);
						_this2.$store.commit('changeUserInfo', null);
						_this2.$router.go(-1);
					}
					if (data.code == 401) {
						if (_this2.$store.state.changeUserId == data.data.details.toUserId) {
							_this2.$ws.close();
							_this2.$router.go(-1);
						}
					}
					if (data.data && data.data.pushType == 15) {
						_this2.msgList.push({
							type: -1,
							title: data.data.content
						});
					}
					if (data.data && data.data.pushType == 16) {
						console.log(data.data);
						var newGift = data.data;

						var _msg2 = data.data.details;
						_msg2.type = 12;
						_this2.msgList.push(_msg2);
						_this2.$nextTick(function () {
							_this2.scrollToBottom();
						});
						_this2.$emit('addLwToQueue', newGift);
						_this2.$emit('addSvgaToQueue', data.data.details.giftInfo.gifUrl);
					}
					if (data.data && data.data.pushType == 21) {
						_this2.$router.go(-1);
					}
					if (data.data && data.data.pushType == 24) {
						_this2.getLiveCommonExpressionsList();
					}
				}
			};
		},
		getChatRoomDetails: function getChatRoomDetails() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this3.$route.query.liveId });

							case 2:
								res = _context2.sent;

								if (res.data.chatRoomDetails.noticeText) {
									_this3.msgList.push({
										type: -1,
										title: res.data.chatRoomDetails.noticeText
									});
								}
								_this3.zbUserId = res.data.chatRoomDetails.hostUserId;

							case 5:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this3);
			}))();
		},
		getLiveCommonExpressionsList: function getLiveCommonExpressionsList() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return (0, _zhibo.getLiveCommonExpressionsList)({ liveId: _this4.$route.query.liveId });

							case 2:
								res = _context3.sent;

								_this4.kjdyList = res.data;

							case 4:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this4);
			}))();
		},
		handleEnter: function handleEnter(event) {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var contentToSend, params;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								event.preventDefault();contentToSend = _this5.form.content.trim().replace(/\n/g, '');

								if (contentToSend) {
									_context4.next = 4;
									break;
								}

								return _context4.abrupt('return');

							case 4:
								params = {
									liveId: _this5.$route.query.liveId,
									content: contentToSend,
									text: contentToSend };
								_context4.next = 7;
								return (0, _zhibo.chatRoomSendMsg)(params);

							case 7:
								_this5.form.content = '';
							case 8:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this5);
			}))();
		},
		handleFsKjdy: function handleFsKjdy(content) {
			var _this6 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var params;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								params = {
									liveId: _this6.$route.query.liveId,
									content: content };
								_context5.next = 3;
								return (0, _zhibo.chatRoomSendMsg)(params);

							case 3:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this6);
			}))();
		},
		addUserToQueue: function addUserToQueue(user) {
			if (!user || !user.name) return;

			user.id = Date.now() + Math.random().toString(36).substr(2, 9);
			this.userQueue.push(user);

			if (!this.isUserAnimating) {
				this.showNextUser();
			}
		},
		showNextUser: function showNextUser() {
			var _this7 = this;

			if (this.userQueue.length === 0) {
				this.isUserAnimating = false;
				return;
			}

			this.isUserAnimating = true;

			var user = this.userQueue.shift();

			this.inUserList.push(user);

			setTimeout(function () {
				_this7.inUserList = _this7.inUserList.filter(function (item) {
					return item.id !== user.id;
				});

				setTimeout(function () {
					_this7.showNextUser();
				}, _this7.animateGap);
			}, this.animateTotalTime);
		},
		scrollToBottom: function scrollToBottom() {
			var _this8 = this;

			this.$nextTick(function () {
				var container = _this8.$refs.danmuContainer;
				container.scrollTop = container.scrollHeight;
			});
		},
		handleShowUser: function handleShowUser(data) {
			if (data.sendUserInfo) {
				this.$emit('show_user', data.sendUserId);
			}
			if (data.type == -1) {
				this.getChatRoomUserIsAdmin();
			}
		},
		getChatRoomUserIsAdmin: function getChatRoomUserIsAdmin() {
			var _this9 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				var res;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.next = 2;
								return (0, _zhibo.getChatRoomUserDetails)({
									liveId: _this9.$route.query.liveId,
									toUserId: JSON.parse(_this9.$store.state.userId)
								});

							case 2:
								res = _context6.sent;

								if (res.data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isAdmin == 1) {
									_this9.$emit('updataNotice');
								}

							case 4:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this9);
			}))();
		}
	}
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = __webpack_require__(80);

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

var _map = __webpack_require__(465);

var _map2 = _interopRequireDefault(_map);

var _user = __webpack_require__(14);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _pinglun = __webpack_require__(939);

var _pinglun2 = _interopRequireDefault(_pinglun);

var _sp_dz_12x = __webpack_require__(306);

var _sp_dz_12x2 = _interopRequireDefault(_sp_dz_12x);

var _sp_dz_22x = __webpack_require__(893);

var _sp_dz_22x2 = _interopRequireDefault(_sp_dz_22x);

var _sp_pinglun2x = __webpack_require__(894);

var _sp_pinglun2x2 = _interopRequireDefault(_sp_pinglun2x);

var _sp_shoucang2x = __webpack_require__(895);

var _sp_shoucang2x2 = _interopRequireDefault(_sp_shoucang2x);

var _sp_shoucang_12x = __webpack_require__(896);

var _sp_shoucang_12x2 = _interopRequireDefault(_sp_shoucang_12x);

var _sp_bf_872x = __webpack_require__(892);

var _sp_bf_872x2 = _interopRequireDefault(_sp_bf_872x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playStateCacheMap = new _map2.default();
exports.default = {
	name: 'duanshippin',
	components: {
		kong: _kong2.default,
		pinglun: _pinglun2.default
	},
	props: {
		isHost: {
			type: [String, Number],
			default: ''
		},

		userId: {
			type: [String, Number],
			default: ''
		},

		videoId: {
			type: [String, Number],
			default: ''
		},

		size: {
			type: Number,
			default: 10
		}
	},
	data: function data() {
		return {
			spDz1: _sp_dz_12x2.default,
			spDz2: _sp_dz_22x2.default,
			spPinglun: _sp_pinglun2x2.default,
			spShoucang1: _sp_shoucang2x2.default,
			spShoucang2: _sp_shoucang_12x2.default,
			spBf: _sp_bf_872x2.default,
			list: [],
			page: 1,
			hasMore: true,
			isLoading: false,
			loaded: false,
			currentIndex: 0,
			muted: false,
			showComment: false,
			resumeIndex: null,
			startApplied: false,
			leaving: false,
			clickTimer: null,
			refreshLock: false,
			touchStartY: 0,

			isTouching: false,
			isDragging: false,
			dragStartY: 0,
			dragStartTop: 0,
			dragMoved: false,
			isSeeking: false,
			seekRect: null,
			snapTimer: null,

			snapAnimating: false,
			snapAnimTimer: null,
			isWheelLock: false,

			isFullscreen: false,
			wheelTarget: -1,
			wheelEndTimer: null,
			wheelUnlockTimer: null,

			barInput: '',
			barSubmitting: false,
			barEmojiShow: false,
			emojiList: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '😱', '😨', '😰', '😥', '😓', '😳', '🥺', '👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '👏', '🙏', '💪', '❤️', '💔', '💕', '💖', '🌹', '🎉', '🔥', '💯', '✨', '🎁', '🍺', '☕', '🍉', '⚽', '🏀', '🎮', '💰', '🌙', '⭐', '🌈']
		};
	},

	computed: {
		currentVideo: function currentVideo() {
			return this.list.length > 0 ? this.list[this.currentIndex] : null;
		}
	},
	mounted: function mounted() {
		var _this = this;

		window.addEventListener('keydown', this.handleKeydown);

		document.addEventListener('fullscreenchange', this.onFullscreenChange);
		document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);

		var key = this.cacheKey();
		var cached = this.videoId ? null : playStateCacheMap.get(key);
		if (cached) {
			playStateCacheMap.delete(key);
			this.list = cached.list;
			this.currentIndex = cached.currentIndex;
			this.page = cached.page;
			this.hasMore = cached.hasMore;
			this.muted = cached.muted;
			this.loaded = true;
			this.$nextTick(function () {
				var swiper = _this.$refs.swiper;
				if (swiper && cached.scrollTop) swiper.scrollTop = cached.scrollTop;
				var idx = cached.playingIndex;
				if (idx > -1 && _this.list[idx]) {
					var el = _this.getVideoEl(idx);
					if (el) {
						if (_this.list[idx].pTime) {
							try {
								el.currentTime = _this.list[idx].pTime;
							} catch (e) {}
						}
						el.muted = _this.muted;
						var p = el.play();
						if (p && p.catch) p.catch(function () {});
					}
				}
			});
			return;
		}
		this.fetchList(1);
	},

	watch: {
		isHost: function isHost() {
			this.showComment = false;
			this.barInput = '';
			this.barEmojiShow = false;
			this.fetchList(1);
		}
	},
	beforeDestroy: function beforeDestroy() {
		var _this2 = this;

		window.removeEventListener('keydown', this.handleKeydown);
		document.removeEventListener('fullscreenchange', this.onFullscreenChange);
		document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
		if (this.clickTimer) {
			clearTimeout(this.clickTimer);
			this.clickTimer = null;
		}
		if (this.snapTimer) {
			clearTimeout(this.snapTimer);
			this.snapTimer = null;
		}
		if (this.snapAnimTimer) {
			clearTimeout(this.snapAnimTimer);
			this.snapAnimTimer = null;
		}
		if (this.wheelEndTimer) {
			clearTimeout(this.wheelEndTimer);
			this.wheelEndTimer = null;
		}
		if (this.wheelUnlockTimer) {
			clearTimeout(this.wheelUnlockTimer);
			this.wheelUnlockTimer = null;
		}
		this.isDragging = false;
		document.body.style.userSelect = '';

		this.leaving = true;

		if (!this.videoId) {
			var swiper = this.$refs.swiper;
			playStateCacheMap.set(this.cacheKey(), {
				list: this.list.map(function (item) {
					return (0, _extends3.default)({}, item, { playing: false });
				}),
				currentIndex: this.currentIndex,
				page: this.page,
				hasMore: this.hasMore,
				scrollTop: swiper ? swiper.scrollTop : 0,
				muted: this.muted,
				playingIndex: this.list.findIndex(function (item) {
					return item.playing;
				})
			});

			if (playStateCacheMap.size > 10) {
				var firstKey = playStateCacheMap.keys().next().value;
				playStateCacheMap.delete(firstKey);
			}
		}

		this.list.forEach(function (item, i) {
			var el = _this2.getVideoEl(i);
			if (el) el.pause();
		});
	},
	deactivated: function deactivated() {
		this.leaving = true;
		var idx = this.list.findIndex(function (item) {
			return item.playing;
		});
		if (idx > -1) {
			this.resumeIndex = idx;
			var el = this.getVideoEl(idx);
			if (el) el.pause();
		}
	},
	activated: function activated() {
		var _this3 = this;

		this.leaving = false;
		this.$nextTick(function () {
			var swiper = _this3.$refs.swiper;
			if (swiper && swiper.clientHeight) {
				swiper.scrollTop = _this3.currentIndex * swiper.clientHeight;
			}
		});
		if (this.resumeIndex === null) return;
		var idx = this.resumeIndex;
		this.resumeIndex = null;
		this.$nextTick(function () {
			var el = _this3.getVideoEl(idx);
			if (el) {
				el.muted = _this3.muted;
				var p = el.play();
				if (p && p.catch) p.catch(function () {});
			}
		});
	},

	methods: {
		cacheKey: function cacheKey() {
			return [this.userId || '', this.isHost === undefined ? '' : this.isHost].join('|');
		},
		parseRows: function parseRows(response) {
			var data = response.data || response;
			return Array.isArray(data) ? data : data.rows || data.list || [];
		},
		parseTotal: function parseTotal(response, fallbackLen) {
			var data = response.data || response;
			return data.total || response.total || fallbackLen || 0;
		},
		handleGoUserHome: function handleGoUserHome(item) {
			var userId = item.userId || item.userInfo && item.userInfo.userId;
			if (!userId) return;
			this.$router.push({ path: '/yonghuzhuye', query: { userId: userId } });
		},
		formatItem: function formatItem(item) {
			return (0, _extends3.default)({}, item, {
				id: item.id || item.videoId || item.video_id,
				isGiveLike: item.isGiveLike || 0,
				giveLikeNumber: item.giveLikeNumber || 0,
				isCollect: item.isCollect || 0,
				collectNumber: item.collectNumber || 0,
				commentNumber: item.commentNumber || 0,
				playing: false,

				buffering: false,
				pTime: 0,
				dTime: 0
			});
		},
		fetchList: function fetchList(page) {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var response, rows, total, idx;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!_this4.isLoading) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								_this4.isLoading = true;
								_context.prev = 3;
								_context.next = 6;
								return _this4.fetchPage(page);

							case 6:
								response = _context.sent;
								rows = _this4.parseRows(response);
								total = _this4.parseTotal(response, rows.length);

								_this4.page = page;
								_this4.hasMore = page < Math.ceil(total / _this4.size);
								_this4.list = rows.map(function (item) {
									return _this4.formatItem(item);
								});
								_this4.currentIndex = 0;
								if (_this4.$refs.swiper) _this4.$refs.swiper.scrollTop = 0;

								if (!(!_this4.startApplied && _this4.videoId)) {
									_context.next = 25;
									break;
								}

								_this4.startApplied = true;
								idx = _this4.list.findIndex(function (item) {
									return String(item.id) === String(_this4.videoId);
								});

								if (!(idx < 0)) {
									_context.next = 21;
									break;
								}

								_context.next = 20;
								return _this4.loadMoreUntilFound();

							case 20:
								idx = _context.sent;

							case 21:
								if (!(idx > 0)) {
									_context.next = 25;
									break;
								}

								_this4.currentIndex = idx;
								_this4.$nextTick(function () {
									var el = _this4.$refs.swiper;
									if (el && el.clientHeight) el.scrollTop = idx * el.clientHeight;
									_this4.playCurrent();
								});
								return _context.abrupt('return');

							case 25:
								_this4.$nextTick(function () {
									_this4.playCurrent();
								});
								_context.next = 31;
								break;

							case 28:
								_context.prev = 28;
								_context.t0 = _context['catch'](3);

								console.error('获取视频列表失败:', _context.t0);

							case 31:
								_context.prev = 31;

								_this4.isLoading = false;
								_this4.loaded = true;
								return _context.finish(31);

							case 35:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this4, [[3, 28, 31, 35]]);
			}))();
		},
		loadMoreUntilFound: function loadMoreUntilFound() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var nextPage, response, rows, total, formatted, idx;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!_this5.hasMore) {
									_context2.next = 26;
									break;
								}

								_context2.prev = 1;
								nextPage = _this5.page + 1;
								_context2.next = 5;
								return _this5.fetchPage(nextPage);

							case 5:
								response = _context2.sent;
								rows = _this5.parseRows(response);
								total = _this5.parseTotal(response, 0);

								if (!(rows.length === 0)) {
									_context2.next = 11;
									break;
								}

								_this5.hasMore = false;
								return _context2.abrupt('break', 26);

							case 11:
								_this5.page = nextPage;
								_this5.hasMore = nextPage < Math.ceil(total / _this5.size);
								formatted = rows.map(function (item) {
									return _this5.formatItem(item);
								});

								_this5.list = [].concat((0, _toConsumableArray3.default)(_this5.list), (0, _toConsumableArray3.default)(formatted));
								idx = _this5.list.findIndex(function (item) {
									return String(item.id) === String(_this5.videoId);
								});

								if (!(idx >= 0)) {
									_context2.next = 18;
									break;
								}

								return _context2.abrupt('return', idx);

							case 18:
								_context2.next = 24;
								break;

							case 20:
								_context2.prev = 20;
								_context2.t0 = _context2['catch'](1);

								console.error('加载更多视频失败:', _context2.t0);
								return _context2.abrupt('break', 26);

							case 24:
								_context2.next = 0;
								break;

							case 26:
								return _context2.abrupt('return', -1);

							case 27:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this5, [[1, 20]]);
			}))();
		},
		fetchPage: function fetchPage(page) {
			if (this.userId) {
				return (0, _user.viewUserVideoList)({ page: page, size: this.size, viewUserId: this.userId });
			}
			return (0, _user.getVideoList)({ isHost: this.isHost, page: page, size: this.size });
		},
		tryRefresh: function tryRefresh() {
			var _this6 = this;

			if (this.refreshLock || this.isLoading) return;
			this.refreshLock = true;
			this.fetchList(1).finally(function () {
				setTimeout(function () {
					_this6.refreshLock = false;
				}, 1500);
			});
		},
		loadMore: function loadMore() {
			var _this7 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var nextPage, response, rows, total;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(_this7.isLoading || !_this7.hasMore || _this7.list.length === 0)) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt('return');

							case 2:
								_this7.isLoading = true;
								_context3.prev = 3;
								nextPage = _this7.page + 1;
								_context3.next = 7;
								return _this7.fetchPage(nextPage);

							case 7:
								response = _context3.sent;
								rows = _this7.parseRows(response);
								total = _this7.parseTotal(response, 0);

								if (!(rows.length === 0)) {
									_context3.next = 13;
									break;
								}

								_this7.hasMore = false;
								return _context3.abrupt('return');

							case 13:
								_this7.page = nextPage;
								_this7.list = [].concat((0, _toConsumableArray3.default)(_this7.list), (0, _toConsumableArray3.default)(rows.map(function (item) {
									return _this7.formatItem(item);
								})));
								_this7.hasMore = nextPage < Math.ceil(total / _this7.size);
								_context3.next = 21;
								break;

							case 18:
								_context3.prev = 18;
								_context3.t0 = _context3['catch'](3);

								console.error('加载更多视频失败:', _context3.t0);

							case 21:
								_context3.prev = 21;

								_this7.isLoading = false;
								return _context3.finish(21);

							case 24:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this7, [[3, 18, 21, 24]]);
			}))();
		},
		handleScroll: function handleScroll() {
			var _this8 = this;

			var el = this.$refs.swiper;
			if (!el || el.clientHeight === 0 || this.list.length === 0) return;

			if (this.isWheelLock) return;
			var index = Math.round(el.scrollTop / el.clientHeight);
			if (index !== this.currentIndex && index >= 0 && index < this.list.length) {
				this.currentIndex = index;
				this.showComment = false;
				this.barEmojiShow = false;
				this.playCurrent();
			}

			if (this.currentIndex >= this.list.length - 1 && el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
				this.loadMore();
			}

			if (this.snapTimer) clearTimeout(this.snapTimer);
			this.snapTimer = setTimeout(function () {
				_this8.snapTimer = null;
				if (!_this8.isDragging) _this8.snapToNearest();
			}, 150);
		},
		snapToNearest: function snapToNearest() {
			var _this9 = this;

			var el = this.$refs.swiper;
			if (!el || el.clientHeight === 0 || this.list.length === 0) return;
			var index = Math.min(this.list.length - 1, Math.max(0, Math.round(el.scrollTop / el.clientHeight)));

			this.snapAnimating = true;
			if (this.snapAnimTimer) clearTimeout(this.snapAnimTimer);
			this.snapAnimTimer = setTimeout(function () {
				_this9.snapAnimTimer = null;
				_this9.snapAnimating = false;
			}, 350);
			el.scrollTo({ top: index * el.clientHeight, behavior: 'smooth' });
		},
		handleWheel: function handleWheel(e) {
			e.preventDefault();
			var el = this.$refs.swiper;
			if (!el || this.list.length === 0) return;

			if (this.isWheelLock) {
				this.markWheelActive();
				return;
			}
			var deltaY = e.deltaY;
			if (Math.abs(deltaY) < 5) return;
			if (deltaY < 0) {
				if (this.currentIndex === 0 && el.scrollTop <= 5) {
					this.tryRefresh();
					return;
				}
				this.wheelTo(this.currentIndex - 1);
			} else {
				if (this.currentIndex >= this.list.length - 1 && el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
					this.loadMore();
					return;
				}
				this.wheelTo(this.currentIndex + 1);
			}
		},
		markWheelActive: function markWheelActive() {
			var _this10 = this;

			if (this.wheelEndTimer) clearTimeout(this.wheelEndTimer);
			this.wheelEndTimer = setTimeout(function () {
				_this10.wheelEndTimer = null;
				_this10.finishWheel();
			}, 260);
		},
		finishWheel: function finishWheel() {
			var _this11 = this;

			var el = this.$refs.swiper;
			if (el && this.wheelTarget >= 0 && this.wheelTarget < this.list.length) {
				el.scrollTo({ top: this.wheelTarget * el.clientHeight, behavior: 'smooth' });
			}
			if (this.wheelUnlockTimer) clearTimeout(this.wheelUnlockTimer);
			this.wheelUnlockTimer = setTimeout(function () {
				_this11.wheelUnlockTimer = null;
				_this11.isWheelLock = false;
				_this11.wheelTarget = -1;
			}, 300);
		},
		wheelTo: function wheelTo(index) {
			var el = this.$refs.swiper;
			if (!el) return;
			if (index < 0 || index > this.list.length - 1) {
				this.snapToNearest();
				return;
			}
			this.isWheelLock = true;
			this.wheelTarget = index;

			if (this.currentIndex !== index) {
				this.currentIndex = index;
				this.showComment = false;
				this.barEmojiShow = false;
				this.playCurrent();
			}
			el.scrollTo({ top: index * el.clientHeight, behavior: 'smooth' });
			this.markWheelActive();
		},
		handleTouchStart: function handleTouchStart(e) {
			this.isTouching = true;
			this.touchStartY = e.touches[0].clientY;
		},
		handleTouchMove: function handleTouchMove(e) {
			var el = this.$refs.swiper;
			if (!el || this.list.length === 0) return;
			var deltaY = e.touches[0].clientY - this.touchStartY;
			if (deltaY > 30 && el.scrollTop <= 0 && this.currentIndex === 0) {
				this.tryRefresh();
			}
		},
		handleTouchEnd: function handleTouchEnd() {
			var _this12 = this;

			this.snapToNearest();

			setTimeout(function () {
				_this12.isTouching = false;
			}, 350);
		},
		playCurrent: function playCurrent() {
			var _this13 = this;

			this.list.forEach(function (item, i) {
				var el = _this13.getVideoEl(i);
				if (!el) return;
				if (i === _this13.currentIndex) {
					_this13.$set(_this13.list[i], 'buffering', true);
					if (el.getAttribute('src')) {
						_this13.startCurrentPlay(el, i);
					} else {
						_this13.$nextTick(function () {
							var cur = _this13.getVideoEl(i);
							if (cur && i === _this13.currentIndex) _this13.startCurrentPlay(cur, i);
						});
					}
				} else {
					el.pause();
					_this13.$set(_this13.list[i], 'playing', false);
				}
			});
		},
		startCurrentPlay: function startCurrentPlay(el, i) {
			var item = this.list[i];
			if (!item) return;

			if (!item.dTime && el.duration && !isNaN(el.duration)) {
				this.$set(item, 'dTime', el.duration);
			}

			el.muted = this.muted;
			var p = el.play();
			if (p && p.catch) {
				p.catch(function () {
					el.muted = true;
					var p2 = el.play();
					if (p2 && p2.catch) p2.catch(function () {});
				});
			}
			this.$set(item, 'playing', true);
		},
		getVideoEl: function getVideoEl(i) {
			var ref = this.$refs['video' + i];
			return Array.isArray(ref) ? ref[0] : ref;
		},
		videoSrc: function videoSrc(item, index) {
			if (Math.abs(index - this.currentIndex) <= 1) return item.videoUrl;
			return null;
		},
		handleVideoClick: function handleVideoClick(index) {
			var _this14 = this;

			if (this.dragMoved) {
				this.dragMoved = false;
				return;
			}
			if (this.clickTimer) {
				clearTimeout(this.clickTimer);
				this.clickTimer = null;
				return;
			}
			this.clickTimer = setTimeout(function () {
				_this14.clickTimer = null;
				_this14.togglePlay(index);
			}, 250);
		},
		handleVideoDblClick: function handleVideoDblClick(item) {
			if (this.clickTimer) {
				clearTimeout(this.clickTimer);
				this.clickTimer = null;
			}
			if (item.isGiveLike === 1) return;
			this.handleToggleLike(item);
		},
		progressPercent: function progressPercent(item) {
			if (!item.dTime || isNaN(item.dTime)) return 0;
			return Math.min(100, item.pTime / item.dTime * 100);
		},
		handleProgressDown: function handleProgressDown(e, index) {
			var _this15 = this;

			var el = this.getVideoEl(index);
			if (!el || !el.duration || isNaN(el.duration)) return;
			this.isSeeking = true;
			this.seekRect = e.currentTarget.getBoundingClientRect();
			this.seekVideo(el, index, e.clientX);
			var move = function move(ev) {
				if (!_this15.isSeeking) return;
				_this15.seekVideo(el, index, ev.clientX);
			};
			var up = function up() {
				_this15.isSeeking = false;
				window.removeEventListener('mousemove', move);
				window.removeEventListener('mouseup', up);
			};
			window.addEventListener('mousemove', move);
			window.addEventListener('mouseup', up);
		},
		seekVideo: function seekVideo(el, index, clientX) {
			if (!this.seekRect || this.seekRect.width === 0) return;
			var ratio = (clientX - this.seekRect.left) / this.seekRect.width;
			ratio = Math.min(1, Math.max(0, ratio));
			el.currentTime = ratio * el.duration;
			this.$set(this.list[index], 'pTime', el.currentTime);
		},
		handleDragDown: function handleDragDown(e) {
			var _this16 = this;

			if (e.button !== 2 && e.button !== 0) return;
			var el = this.$refs.swiper;
			if (!el || this.list.length === 0) return;

			el.scrollTo({ top: el.scrollTop });

			this.isWheelLock = false;
			this.wheelTarget = -1;
			if (this.wheelEndTimer) {
				clearTimeout(this.wheelEndTimer);
				this.wheelEndTimer = null;
			}
			if (this.wheelUnlockTimer) {
				clearTimeout(this.wheelUnlockTimer);
				this.wheelUnlockTimer = null;
			}
			this.isDragging = false;
			this.dragStartY = e.clientY;
			this.dragStartTop = el.scrollTop;
			if (e.button === 0) {
				this.dragMoved = false;
			}
			var isRight = e.button === 2;
			var threshold = isRight ? 0 : 5;
			var dragFactor = 3;
			var move = function move(ev) {
				var dy = ev.clientY - _this16.dragStartY;
				if (!_this16.isDragging && Math.abs(dy) <= threshold) return;
				if (!_this16.isDragging) {
					if (!isRight) _this16.dragMoved = true;
					_this16.isDragging = true;
					document.body.style.userSelect = 'none';
				}

				el.scrollTop = _this16.dragStartTop - dy * dragFactor;
			};
			var up = function up() {
				var wasDragging = _this16.isDragging;
				_this16.isDragging = false;
				document.body.style.userSelect = '';
				window.removeEventListener('mousemove', move);
				window.removeEventListener('mouseup', up);

				if (wasDragging) _this16.snapToNearest();
			};
			window.addEventListener('mousemove', move);
			window.addEventListener('mouseup', up);
		},
		togglePlay: function togglePlay(index) {
			var el = this.getVideoEl(index);
			if (!el) return;
			if (el.paused) {
				var p = el.play();
				if (p && p.catch) p.catch(function () {});
				this.$set(this.list[index], 'playing', true);
			} else {
				el.pause();
				this.$set(this.list[index], 'playing', false);
			}
		},
		toggleMute: function toggleMute(index) {
			this.muted = !this.muted;
			var el = this.getVideoEl(index);
			if (el) el.muted = this.muted;
		},
		toggleFullscreen: function toggleFullscreen() {
			var el = this.getVideoEl(this.currentIndex);
			if (!el) return;
			if (this.isFullscreen) {
				var exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
				if (exit) exit.call(document);
			} else {
				var req = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
				if (req) req.call(el);
			}
		},
		onFullscreenChange: function onFullscreenChange() {
			var fs = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
			this.isFullscreen = !!fs;
		},
		handleToggleLike: function handleToggleLike(item) {
			var _this17 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var liked;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.prev = 0;
								_context4.next = 3;
								return (0, _user.addGiveLikeOrCancelGiveLikeVideo)({ videoId: item.id });

							case 3:
								liked = item.isGiveLike === 1;

								_this17.$set(item, 'isGiveLike', liked ? 0 : 1);
								_this17.$set(item, 'giveLikeNumber', Math.max(0, item.giveLikeNumber + (liked ? -1 : 1)));
								_context4.next = 11;
								break;

							case 8:
								_context4.prev = 8;
								_context4.t0 = _context4['catch'](0);

								console.error('点赞操作失败:', _context4.t0);

							case 11:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this17, [[0, 8]]);
			}))();
		},
		handleToggleCollect: function handleToggleCollect(item) {
			var _this18 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var collected;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.prev = 0;
								_context5.next = 3;
								return (0, _user.addCollectOrCancelCollectVideo)({ videoId: item.id });

							case 3:
								collected = item.isCollect === 1;

								_this18.$set(item, 'isCollect', collected ? 0 : 1);
								_this18.$set(item, 'collectNumber', Math.max(0, item.collectNumber + (collected ? -1 : 1)));
								_context5.next = 11;
								break;

							case 8:
								_context5.prev = 8;
								_context5.t0 = _context5['catch'](0);

								console.error('收藏操作失败:', _context5.t0);

							case 11:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this18, [[0, 8]]);
			}))();
		},
		handleShowComment: function handleShowComment(item) {
			this.currentIndex = this.list.indexOf(item);
			this.showComment = true;
		},
		handleKeydown: function handleKeydown(e) {
			var tag = e.target && e.target.tagName || '';
			if (tag === 'INPUT' || tag === 'TEXTAREA' || e.target && e.target.isContentEditable) return;

			if (this.leaving || this.isDragging || this.isTouching || this.snapAnimating) return;
			switch (e.key) {
				case 'ArrowUp':
				case 'ArrowLeft':
				case 'PageUp':
					e.preventDefault();
					if (!this.isWheelLock) this.wheelTo(this.currentIndex - 1);
					break;
				case 'ArrowDown':
				case 'ArrowRight':
				case 'PageDown':
					e.preventDefault();
					if (!this.isWheelLock) this.wheelTo(this.currentIndex + 1);
					break;
				case ' ':
				case 'Spacebar':
					e.preventDefault();
					this.togglePlay(this.currentIndex);
					break;
				case 'm':
				case 'M':
					this.toggleMute(this.currentIndex);
					break;
			}
		},
		onCommentCountChange: function onCommentCountChange(delta) {
			var item = this.list[this.currentIndex];
			if (item) {
				this.$set(item, 'commentNumber', Math.max((item.commentNumber || 0) + delta, 0));
			}
		},
		toggleBarEmoji: function toggleBarEmoji() {
			this.barEmojiShow = !this.barEmojiShow;
		},
		pickBarEmoji: function pickBarEmoji(e) {
			this.barInput = (this.barInput || '') + e;
		},
		submitBarComment: function submitBarComment() {
			var _this19 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				var item, content, res;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								item = _this19.list[_this19.currentIndex];
								content = (_this19.barInput || '').trim();

								if (!(!content || _this19.barSubmitting || !item)) {
									_context6.next = 4;
									break;
								}

								return _context6.abrupt('return');

							case 4:
								_this19.barSubmitting = true;
								_context6.prev = 5;
								_context6.next = 8;
								return (0, _user.commentVideo)({ videoId: item.id, content: content });

							case 8:
								res = _context6.sent;

								_this19.barInput = '';
								_this19.barEmojiShow = false;
								_this19.onCommentCountChange(1);

								if (_this19.showComment) {
									_this19.$nextTick(function () {
										var pinglun = _this19.$refs.pinglun;
										if (!pinglun) return;

										var created = _this19.pickCreatedForPinglun(res);
										if (created) {
											pinglun.list.unshift(created);
											pinglun.total = (pinglun.total || 0) + 1;
										} else if (pinglun.resetList) {
											pinglun.resetList();
										}
									});
								}
								_context6.next = 18;
								break;

							case 15:
								_context6.prev = 15;
								_context6.t0 = _context6['catch'](5);

								console.error('评论失败:', _context6.t0);

							case 18:
								_context6.prev = 18;

								_this19.barSubmitting = false;
								return _context6.finish(18);

							case 21:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this19, [[5, 15, 18, 21]]);
			}))();
		},
		pickCreatedForPinglun: function pickCreatedForPinglun(response) {
			var d = response && response.data;
			if (!d || (typeof d === 'undefined' ? 'undefined' : (0, _typeof3.default)(d)) !== 'object') return null;
			var cid = d.commentId !== undefined ? d.commentId : d.id;
			if (!cid || !d.content) return null;
			var store = this.$store.state || {};
			return {
				id: cid,
				userId: d.userId || store.userId || '',
				avatar: d.userHeadPortrait || store.userInfo && store.userInfo.headPortrait || '',
				nickName: d.userNickName || store.userInfo && store.userInfo.nickName || '',
				content: d.content,
				createTime: d.createTime || new Date().toISOString().replace('T', ' ').slice(0, 19),
				isPresentUser: 1,
				replyNumber: 0,
				childs: [],
				childPage: 1,
				childHasMore: false,
				childLoading: false
			};
		},
		onVideoPlay: function onVideoPlay(index) {
			if (this.list[index]) this.$set(this.list[index], 'playing', true);
		},
		onVideoPause: function onVideoPause(index) {
			if (this.list[index]) this.$set(this.list[index], 'playing', false);
		},
		onVideoWaiting: function onVideoWaiting(index) {
			if (this.list[index]) this.$set(this.list[index], 'buffering', true);
		},
		onVideoPlaying: function onVideoPlaying(index) {
			if (this.list[index]) this.$set(this.list[index], 'buffering', false);
		},
		onVideoCanPlay: function onVideoCanPlay(index) {
			if (this.list[index]) this.$set(this.list[index], 'buffering', false);
		},
		onTimeUpdate: function onTimeUpdate(index) {
			var el = this.getVideoEl(index);
			if (el && index === this.currentIndex) {
				var item = this.list[index];
				if (!item) return;

				if (!item.dTime && el.duration && !isNaN(el.duration)) {
					this.$set(item, 'dTime', el.duration);
				}
				this.$set(item, 'pTime', el.currentTime);
			}
		},
		onLoadedMetadata: function onLoadedMetadata(index) {
			var el = this.getVideoEl(index);
			if (el) {
				this.$set(this.list[index], 'dTime', el.duration || 0);
			}
		},
		formatTime: function formatTime(seconds) {
			if (!seconds || isNaN(seconds)) return '00:00';
			var min = Math.floor(seconds / 60);
			var sec = Math.floor(seconds % 60);
			return String(min).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
		}
	}
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _txycos = __webpack_require__(91);

var _duanyingyin = __webpack_require__(455);

var _user = __webpack_require__(14);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default
	},
	data: function data() {
		return {
			isModalVisible: false,
			cosClient: null,
			appConfigInfo: null,

			videoTab: 0,
			form: {
				title: '',
				videoUrl: '',
				videoName: '',
				duration: 0,
				coverUrl: ''
			},
			uploading: false,
			uploadProgress: 0,
			videoList: [],
			queryParams: {
				page: 1,
				size: 10
			},
			hasMore: true,
			isLoading: false,
			loaded: false
		};
	},

	computed: {
		videoTabList: function videoTabList() {
			return [{ key: 'wofabu' }, { key: 'wodianzan' }, { key: 'woshoucang' }];
		}
	},
	mounted: function mounted() {
		this.cosClient = (0, _txycos.client)();
		this.getVideoList();
		this.getPresentUserInfo();
	},

	methods: {
		getPresentUserInfo: function getPresentUserInfo() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return (0, _user.getPresentUserInfo)();

							case 3:
								res = _context.sent;

								_this.appConfigInfo = res.data;
								_context.next = 10;
								break;

							case 7:
								_context.prev = 7;
								_context.t0 = _context['catch'](0);

								console.error('获取APP配置失败:', _context.t0);

							case 10:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 7]]);
			}))();
		},
		getVideoList: function getVideoList() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var apiFn, res, data, newList, total, totalPages;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!(_this2.isLoading || !_this2.hasMore)) {
									_context2.next = 2;
									break;
								}

								return _context2.abrupt('return');

							case 2:
								_this2.isLoading = true;
								_context2.prev = 3;
								apiFn = void 0;

								if (_this2.videoTab === 0) apiFn = _duanyingyin.getPresentUserVideoList;else if (_this2.videoTab === 1) apiFn = _user.getUserGiveLikeVideoList;else apiFn = _user.getUserCollectVideoList;

								_context2.next = 8;
								return apiFn(_this2.queryParams);

							case 8:
								res = _context2.sent;
								data = res.data || res;
								newList = Array.isArray(data) ? data : data.rows || data.list || [];

								if (_this2.queryParams.page === 1) {
									_this2.videoList = newList;
								} else {
									_this2.videoList = [].concat((0, _toConsumableArray3.default)(_this2.videoList), (0, _toConsumableArray3.default)(newList));
								}
								total = data.total || newList.length;
								totalPages = Math.ceil(total / _this2.queryParams.size);

								_this2.hasMore = _this2.queryParams.page < totalPages;
								_context2.next = 20;
								break;

							case 17:
								_context2.prev = 17;
								_context2.t0 = _context2['catch'](3);

								console.error('获取视频列表失败：', _context2.t0);

							case 20:
								_context2.prev = 20;

								_this2.isLoading = false;
								_this2.loaded = true;
								return _context2.finish(20);

							case 24:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[3, 17, 20, 24]]);
			}))();
		},
		switchVideoTab: function switchVideoTab(tab) {
			if (this.videoTab === tab) return;
			this.videoTab = tab;
			this.queryParams.page = 1;
			this.hasMore = true;
			this.videoList = [];
			this.loaded = false;
			this.getVideoList();
		},
		loadMore: function loadMore() {
			if (this.isLoading || !this.hasMore) return;
			this.queryParams.page++;
			this.getVideoList();
		},
		handleShowModal: function handleShowModal() {
			this.isModalVisible = true;
			this.form = {
				title: '',
				videoUrl: '',
				videoName: '',
				duration: 0,
				coverUrl: ''
			};
			this.uploading = false;
			this.uploadProgress = 0;
		},
		handleUploadClick: function handleUploadClick() {
			if (this.uploading) return;
			this.$refs.fileInput.click();
		},
		handleFileChange: function handleFileChange(event) {
			var fileList = event.target.files;
			if (!fileList || fileList.length === 0) return;
			this.uploadVideoToCOS(fileList[0]);
			event.target.value = '';
		},
		uploadVideoToCOS: function uploadVideoToCOS(file) {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var duration, coverBlob, fileExt, fileName, uploadResult, videoUrl, coverKey;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(!file || !file.type.startsWith('video/'))) {
									_context3.next = 3;
									break;
								}

								_this3.$message.error(_this3.$t('all.qingshurubiaoti'));
								return _context3.abrupt('return');

							case 3:
								_this3.uploading = true;
								_this3.uploadProgress = 0;
								_this3.form.videoName = file.name;
								_context3.prev = 6;
								_context3.next = 9;
								return _this3.getVideoDuration(file);

							case 9:
								duration = _context3.sent;

								_this3.form.duration = Math.floor(duration);
								coverBlob = null;
								_context3.prev = 12;
								_context3.next = 15;
								return _this3.getVideoCoverBlob(file);

							case 15:
								coverBlob = _context3.sent;
								_context3.next = 21;
								break;

							case 18:
								_context3.prev = 18;
								_context3.t0 = _context3['catch'](12);

								console.error('获取视频封面失败：', _context3.t0);

							case 21:
								fileExt = file.name.split('.').pop() || 'mp4';
								fileName = 'webStorage/web_/' + Date.now() + '_' + Math.random().toString(36).substr(2, 10) + '.' + fileExt;
								_context3.next = 25;
								return new _promise2.default(function (resolve, reject) {
									_this3.cosClient.putObject({
										Bucket: _this3.cosClient.options.bucket,
										Region: _this3.cosClient.options.region,
										Key: fileName,
										Body: file,
										ContentType: file.type || 'video/mp4',
										onProgress: function onProgress(progressData) {
											_this3.uploadProgress = progressData.percent * 100;
										}
									}, function (err, result) {
										if (err) reject(err);else resolve(result);
									});
								});

							case 25:
								uploadResult = _context3.sent;
								videoUrl = 'https://' + _this3.cosClient.options.bucket + '.cos.' + _this3.cosClient.options.region + '.myqcloud.com/' + fileName;

								_this3.form.videoUrl = videoUrl;

								if (!coverBlob) {
									_context3.next = 33;
									break;
								}

								coverKey = 'webStorage/web_/' + Date.now() + '_' + Math.random().toString(36).substr(2, 10) + '_cover.jpg';
								_context3.next = 32;
								return new _promise2.default(function (resolve, reject) {
									_this3.cosClient.putObject({
										Bucket: _this3.cosClient.options.bucket,
										Region: _this3.cosClient.options.region,
										Key: coverKey,
										Body: coverBlob,
										ContentType: 'image/jpeg'
									}, function (err, result) {
										if (err) reject(err);else resolve(result);
									});
								});

							case 32:
								_this3.form.coverUrl = 'https://' + _this3.cosClient.options.bucket + '.cos.' + _this3.cosClient.options.region + '.myqcloud.com/' + coverKey;

							case 33:
								_this3.$message.success(_this3.$t('all.shangchuanzhong'));
								_context3.next = 40;
								break;

							case 36:
								_context3.prev = 36;
								_context3.t1 = _context3['catch'](6);

								console.error('视频上传失败：', _context3.t1);
								_this3.$message.error(_this3.$t('all.shangchuanshibai'));

							case 40:
								_context3.prev = 40;

								_this3.uploading = false;
								return _context3.finish(40);

							case 43:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3, [[6, 36, 40, 43], [12, 18]]);
			}))();
		},
		getVideoDuration: function getVideoDuration(file) {
			return new _promise2.default(function (resolve, reject) {
				var video = document.createElement('video');
				video.preload = 'metadata';
				video.onloadedmetadata = function () {
					resolve(video.duration);
					URL.revokeObjectURL(video.src);
				};
				video.onerror = function () {
					reject(new Error('无法获取视频时长'));
					URL.revokeObjectURL(video.src);
				};
				video.src = URL.createObjectURL(file);
			});
		},
		getVideoCoverBlob: function getVideoCoverBlob(file) {
			return new _promise2.default(function (resolve, reject) {
				var video = document.createElement('video');
				var url = URL.createObjectURL(file);
				video.preload = 'metadata';
				video.muted = true;
				video.playsInline = true;
				video.src = url;

				video.onloadeddata = function () {
					try {
						video.currentTime = 0.1;
					} catch (e) {
						URL.revokeObjectURL(url);
						reject(e);
					}
				};

				video.onseeked = function () {
					try {
						if (!video.videoWidth || !video.videoHeight) {
							URL.revokeObjectURL(url);
							reject(new Error('无法读取视频画面'));
							return;
						}
						var canvas = document.createElement('canvas');
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
						canvas.toBlob(function (blob) {
							URL.revokeObjectURL(url);
							if (blob) resolve(blob);else reject(new Error('生成封面失败'));
						}, 'image/jpeg', 0.8);
					} catch (e) {
						URL.revokeObjectURL(url);
						reject(e);
					}
				};
				video.onerror = function () {
					URL.revokeObjectURL(url);
					reject(new Error('视频加载失败'));
				};
			});
		},
		formatDuration: function formatDuration(seconds) {
			var mins = Math.floor(seconds / 60);
			var secs = Math.floor(seconds % 60);
			return mins.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0');
		},
		handleDeleteVideo: function handleDeleteVideo(item) {
			var _this4 = this;

			var videoId = item.id || item.videoId;
			if (!videoId) {
				this.$message.error(this.$t('all.qingshurushuju'));
				return;
			}
			var status = item.status;
			var apiFunc = null;
			var confirmMsg = '';
			var successMsg = '';
			if (status === 1) {
				apiFunc = _duanyingyin.deleteVideo;
				confirmMsg = this.$t('all.confirmDelete') || '确认删除该视频？';
				successMsg = this.$t('all.shanchuchenggong') || '删除成功';
			} else if (status === 0) {
				apiFunc = _duanyingyin.returnVideo;
				confirmMsg = this.$t('all.confirmWithdraw') || '确认撤回该视频？';
				successMsg = this.$t('all.chehuichenggong') || '撤回成功';
			} else {
				this.$message.error('当前状态无法操作');
				return;
			}
			this.$confirm(confirmMsg).then(function () {
				apiFunc({ videoId: videoId }).then(function (res) {
					_this4.$message.success(res.msg);
					_this4.queryParams.page = 1;
					_this4.hasMore = true;
					_this4.getVideoList();
				}).catch(function (err) {
					_this4.$message.error(err.message || '操作失败');
				});
			}).catch(function () {});
		},
		handlePublish: function handlePublish() {
			var _this5 = this;

			if (!this.form.title || !this.form.videoUrl) {
				this.$message.error(this.$t('all.qingshurucontent'));
				return;
			}
			this.uploading = true;
			try {
				var params = {
					vo: {},
					title: this.form.title,
					videoUrl: this.form.videoUrl,
					coverUrl: this.form.coverUrl || '',
					duration: this.form.duration
				};
				(0, _duanyingyin.releaseVideo)(params).then(function (res) {
					_this5.$message.success(_this5.$t('all.fabuchenggong'));
					_this5.isModalVisible = false;
					_this5.queryParams.page = 1;
					_this5.hasMore = true;
					_this5.getVideoList();
					_this5.form = {
						title: '',
						videoUrl: '',
						videoName: '',
						duration: 0,
						coverUrl: ''
					};
				}).catch(function (err) {
					_this5.$message.error(err.message || _this5.$t('all.fabushibai'));
				}).finally(function () {
					_this5.uploading = false;
				});
			} catch (error) {
				this.uploading = false;
				this.$message.error(this.$t('all.fabushibai'));
			}
		},
		handlePlayVideo: function handlePlayVideo(item) {
			if (!item.videoUrl) return;
			this.$router.push({
				path: '/bofangshipin',
				query: {
					userId: item.userId || item.createUserId || this.$store.state.userId || '',
					videoId: item.id || item.videoId || ''
				}
			});
		}
	}
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			noticeText: ''
		};
	},
	mounted: function mounted() {
		this.getChatRoomDetails();
	},

	methods: {
		getChatRoomDetails: function getChatRoomDetails() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this.$route.query.liveId });

							case 2:
								res = _context.sent;

								_this.noticeText = res.data.chatRoomDetails.noticeText;

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		handleClose: function handleClose() {
			this.$emit('close_gg');
		},
		updNotice: function updNotice() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var params, res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								params = {
									noticeText: _this2.noticeText,
									liveId: _this2.$route.query.liveId
								};
								_context2.next = 3;
								return (0, _zhibo.updNotice)(params);

							case 3:
								res = _context2.sent;

								_this2.$message({ message: res.msg, type: 'success' });
								_this2.$emit('close_gg');

							case 6:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		}
	}
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _carousel = __webpack_require__(925);

var _carousel2 = _interopRequireDefault(_carousel);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		carousel: _carousel2.default
	},
	data: function data() {
		return {
			list: [],
			listIndex: 0,
			originList: [],
			carouselImages: ['https://belatedly.oss-cn-beijing.aliyuncs.com/image/belatedly/iOS/925421766804676585', 'https://belatedly.oss-cn-beijing.aliyuncs.com/image/belatedly/iOS/925421766804676585'],
			show: false,
			num: 1,
			ggIndex: 0,
			isDetail: false,
			data: '',
			defaultGoodsImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png'
		};
	},
	mounted: function mounted() {
		this.getGoodsList();
	},

	methods: {
		getGoodsList: function getGoodsList() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getGoodsList)({ liveId: _this.$route.query.liveId });

							case 2:
								res = _context.sent;

								_this.list = res.data;
								_this.list.forEach(function (v) {
									v.masterImg = [];
									v.inventory = 0;
									v.price = 0;
									v.mediasList.forEach(function (i) {
										v.masterImg.push(i.uri);
									});
									v.specificationList.forEach(function (i) {
										v.inventory += i.inventory;
									});
									var priceArr = v.specificationList.map(function (item) {
										return item.price;
									});
									if (v.specificationList.length === 1) {
										v.price = priceArr[0];
									} else {
										var minPrice = Math.min.apply(Math, (0, _toConsumableArray3.default)(priceArr));
										var maxPrice = Math.max.apply(Math, (0, _toConsumableArray3.default)(priceArr));

										if (minPrice === maxPrice) {
											v.price = minPrice;
										} else {
											v.price = minPrice + "-" + maxPrice;
										}
									}
									console.log(v.masterImg);
								});
								_this.originList = _this.list;

							case 6:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		handleClose: function handleClose() {
			this.$emit('close');
		},
		handleDetail: function handleDetail(index) {
			this.data = this.list[index];
			this.isDetail = true;
		},
		handleNum: function handleNum(data) {
			if (this.num == 1 && data == -1) {
				return;
			}
			this.num = this.num + data;
		},
		handleGg: function handleGg(index) {
			this.ggIndex = index;
		},
		submitOrder: function submitOrder() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var params, res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								params = {
									num: _this2.num,
									dbSpecificationId: _this2.data.specificationList[_this2.ggIndex].dbSpecificationId
								};
								_context2.next = 3;
								return (0, _zhibo.submitOrder)(params);

							case 3:
								res = _context2.sent;

								_this2.$message({ message: res.msg, type: 'success' });

							case 5:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		handleImgError: function handleImgError(e) {
			e.target.src = this.defaultGoodsImg;

			e.target.onerror = null;
		}
	}
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			show: false
		};
	},
	mounted: function mounted() {},

	methods: {
		showModel: function showModel() {
			this.show = true;
		},
		closeChatRoom: function closeChatRoom() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.closeChatRoom)({ liveId: _this.$route.query.liveId });

							case 2:
								res = _context.sent;

								_this.$message({ message: _this.$t('all.caozuochenggong'), type: 'success' });
								_this.$router.replace({ path: '/shouye' });

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	}
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default
	},
	data: function data() {
		return {
			list: [],
			isKong: false,
			isKjdyModel: false,
			content: ''
		};
	},
	mounted: function mounted() {
		this.getChatRoomAdminUserList();
	},

	methods: {
		getChatRoomAdminUserList: function getChatRoomAdminUserList() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getChatRoomAdminUserList)({ liveId: _this.$route.query.liveId, page: 1, size: 5000 });

							case 2:
								res = _context.sent;

								_this.list = res.rows;
								if (res.total > 0) {
									_this.isKong = false;
								} else {
									_this.isKong = true;
								}

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		handleClose: function handleClose() {
			this.$emit('close_gly');
		},
		delAdmin: function delAdmin(id) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var params, res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								params = {
									toUserId: id,
									liveId: _this2.$route.query.liveId
								};
								_context2.next = 3;
								return (0, _zhibo.delAdmin)(params);

							case 3:
								res = _context2.sent;

								_this2.getChatRoomAdminUserList();

							case 5:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		}
	}
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(473);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default
	},
	data: function data() {
		return {
			show: false,
			currentTab: 0,
			list: [],
			page: 1,
			pageSize: 10,
			hasMore: true,
			isLoading: false,
			loaded: false,
			followTotal: 0,
			fansTotal: 0,
			menuIndex: -1,
			followLoadingMap: {}
		};
	},

	methods: {
		showGuanzhu: function showGuanzhu(tab) {
			this.currentTab = tab === 1 ? 1 : 0;
			this.show = true;
			this.followTotal = 0;
			this.fansTotal = 0;
			this.loadCounts();
			this.loadFirstPage();
		},
		handleClose: function handleClose() {
			this.show = false;
			this.menuIndex = -1;
		},
		handleMaskClick: function handleMaskClick() {
			if (this.menuIndex >= 0) {
				this.menuIndex = -1;
				return;
			}
			this.handleClose();
		},
		handleModalClick: function handleModalClick() {
			if (this.menuIndex >= 0) {
				this.menuIndex = -1;
			}
		},
		switchTab: function switchTab(idx) {
			if (idx === this.currentTab) return;
			this.currentTab = idx;
			this.menuIndex = -1;
			this.loadFirstPage();
		},
		loadFirstPage: function loadFirstPage() {
			this.list = [];
			this.page = 1;
			this.hasMore = true;
			this.loaded = false;
			this.getList();
		},
		loadCounts: function loadCounts() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var params, _ref, _ref2, fRes, fanRes;

				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								params = { page: 1, size: 1 };
								_context.next = 4;
								return _promise2.default.all([(0, _user.getUserFollowList)(params), (0, _user.getUserVermicelliList)(params)]);

							case 4:
								_ref = _context.sent;
								_ref2 = (0, _slicedToArray3.default)(_ref, 2);
								fRes = _ref2[0];
								fanRes = _ref2[1];

								if (fRes && fRes.total != null) _this.followTotal = fRes.total;
								if (fanRes && fanRes.total != null) _this.fansTotal = fanRes.total;
								_context.next = 15;
								break;

							case 12:
								_context.prev = 12;
								_context.t0 = _context["catch"](0);

								console.error('获取关注/粉丝数量失败:', _context.t0);

							case 15:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 12]]);
			}))();
		},
		getList: function getList() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var params, res, rows, normalized;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!(_this2.isLoading || !_this2.hasMore)) {
									_context2.next = 2;
									break;
								}

								return _context2.abrupt("return");

							case 2:
								_this2.isLoading = true;
								_context2.prev = 3;
								params = { page: _this2.page, size: _this2.pageSize };
								res = void 0;

								if (!(_this2.currentTab === 0)) {
									_context2.next = 12;
									break;
								}

								_context2.next = 9;
								return (0, _user.getUserFollowList)(params);

							case 9:
								res = _context2.sent;
								_context2.next = 15;
								break;

							case 12:
								_context2.next = 14;
								return (0, _user.getUserVermicelliList)(params);

							case 14:
								res = _context2.sent;

							case 15:
								rows = res.rows || (Array.isArray(res.data) ? res.data : []);

								if (res.total != null) {
									if (_this2.currentTab === 0) {
										_this2.followTotal = res.total;
									} else {
										_this2.fansTotal = res.total;
									}
								}
								normalized = rows.map(function (r) {
									return (0, _extends3.default)({}, r, {
										headPortrait: r.headPortrait || r.avatar || '',
										nickName: r.nickName || r.userNickName || r.nickname || '',
										recodeCode: r.recodeCode || r.memberId || r.code || '',
										userId: r.userId || r.uid || r.id || ''
									});
								});

								if (_this2.page === 1) {
									_this2.list = normalized;
								} else {
									_this2.list = [].concat((0, _toConsumableArray3.default)(_this2.list), (0, _toConsumableArray3.default)(normalized));
								}
								if (normalized.length < _this2.pageSize) {
									_this2.hasMore = false;
								} else {
									_this2.page++;
								}
								_context2.next = 25;
								break;

							case 22:
								_context2.prev = 22;
								_context2.t0 = _context2["catch"](3);

								console.error('列表加载失败:', _context2.t0);

							case 25:
								_context2.prev = 25;

								_this2.isLoading = false;
								_this2.loaded = true;
								return _context2.finish(25);

							case 29:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[3, 22, 25, 29]]);
			}))();
		},
		handleScroll: function handleScroll() {
			if (this.isLoading || !this.hasMore) return;
			var container = this.$refs.listContainer;
			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
			if (isAtBottom) {
				this.getList();
			}
		},
		toggleFollow: function toggleFollow(item, index) {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var uid, prev;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								uid = item.userId || item.id;

								if (!(!uid || _this3.followLoadingMap[uid])) {
									_context3.next = 3;
									break;
								}

								return _context3.abrupt("return");

							case 3:
								_this3.followLoadingMap[uid] = true;
								_context3.prev = 4;
								_context3.next = 7;
								return (0, _user.followOrCancelFollow)({ viewUserId: uid });

							case 7:
								if (_this3.currentTab === 0) {
									_this3.list.splice(index, 1);
									_this3.followTotal = Math.max(_this3.followTotal - 1, 0);
								} else {
									prev = item.followHe == 1;

									_this3.$set(_this3.list, index, (0, _extends3.default)({}, item, { followHe: prev ? 0 : 1 }));
									if (prev) {
										_this3.followTotal = Math.max(_this3.followTotal - 1, 0);
									} else {
										_this3.followTotal = _this3.followTotal + 1;
									}
								}
								_this3.$emit('change');
								_context3.next = 14;
								break;

							case 11:
								_context3.prev = 11;
								_context3.t0 = _context3["catch"](4);

								console.error('关注操作失败:', _context3.t0);

							case 14:
								_context3.prev = 14;

								_this3.followLoadingMap[uid] = false;
								return _context3.finish(14);

							case 17:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3, [[4, 11, 14, 17]]);
			}))();
		},
		toggleMenu: function toggleMenu(index) {
			this.menuIndex = this.menuIndex === index ? -1 : index;
		},
		handleDelete: function handleDelete(item, index) {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var uid;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_this4.menuIndex = -1;
								uid = item.userId || item.id;

								if (!(!uid || _this4.followLoadingMap[uid])) {
									_context4.next = 4;
									break;
								}

								return _context4.abrupt("return");

							case 4:
								_this4.followLoadingMap[uid] = true;
								_context4.prev = 5;

								if (!(_this4.currentTab === 1)) {
									_context4.next = 13;
									break;
								}

								_context4.next = 9;
								return (0, _user.deleteVermicelli)({ viewUserId: uid });

							case 9:
								_this4.list.splice(index, 1);
								_this4.fansTotal = Math.max(_this4.fansTotal - 1, 0);
								_context4.next = 17;
								break;

							case 13:
								_context4.next = 15;
								return (0, _user.followOrCancelFollow)({ viewUserId: uid });

							case 15:
								_this4.list.splice(index, 1);
								_this4.followTotal = Math.max(_this4.followTotal - 1, 0);

							case 17:
								_this4.$emit('change');
								_context4.next = 23;
								break;

							case 20:
								_context4.prev = 20;
								_context4.t0 = _context4["catch"](5);

								console.error('删除操作失败:', _context4.t0);

							case 23:
								_context4.prev = 23;

								_this4.followLoadingMap[uid] = false;
								return _context4.finish(23);

							case 26:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this4, [[5, 20, 23, 26]]);
			}))();
		},
		handleGoUser: function handleGoUser(item) {
			var uid = item.userId || item.id;
			if (!uid) return;
			this.handleClose();
			this.$router.push({ path: '/yonghuzhuye', query: { userId: uid } });
		}
	}
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'kong',
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {}
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default
	},
	data: function data() {
		return {
			list: [],
			isKong: false,
			isKjdyModel: false,
			content: ''
		};
	},
	mounted: function mounted() {
		this.getLiveCommonExpressionsList();
	},

	methods: {
		getLiveCommonExpressionsList: function getLiveCommonExpressionsList() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getLiveCommonExpressionsList)({ liveId: _this.$route.query.liveId });

							case 2:
								res = _context.sent;

								_this.list = res.data;
								if (_this.list.length > 0) {
									_this.isKong = false;
								} else {
									_this.isKong = true;
								}

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		handleAdd: function handleAdd() {
			this.isKjdyModel = true;
			this.content = '';
		},
		handleClose: function handleClose() {
			this.$emit('close_kjdy');
		},
		addLiveCommonExpressions: function addLiveCommonExpressions() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var params, res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								params = {
									content: _this2.content,
									liveId: _this2.$route.query.liveId
								};
								_context2.next = 3;
								return (0, _zhibo.addLiveCommonExpressions)(params);

							case 3:
								res = _context2.sent;

								_this2.isKjdyModel = false;
								_this2.getLiveCommonExpressionsList();

							case 6:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		delLiveCommonExpressions: function delLiveCommonExpressions(id) {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var params, res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								params = {
									id: id,
									liveId: _this3.$route.query.liveId
								};
								_context3.next = 3;
								return (0, _zhibo.delLiveCommonExpressions)(params);

							case 3:
								res = _context3.sent;

								_this3.getLiveCommonExpressionsList();

							case 5:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		}
	}
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _user = __webpack_require__(14);

var _popup = __webpack_require__(328);

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'liwu',
  components: {
    popup: _popup2.default
  },
  data: function data() {
    return {
      list: [],
      listIndex: null,
      giftList: [],
      screenWidth: window.innerWidth - 535,
      virtualBalance: 0,
      showPopup: false,
      popupPosition: {
        x: 0,
        y: 0
      },

      hidePopupTimeoutId: null
    };
  },
  mounted: function mounted() {
    this.getGiftList();
    this.checkIsLogin();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);

    if (this.hidePopupTimeoutId) {
      clearTimeout(this.hidePopupTimeoutId);
    }
  },

  methods: {
    getGiftList: function getGiftList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _zhibo.getGiftList)({ liveId: _this.$route.query.liveId });

              case 2:
                res = _context.sent;

                _this.giftList = res.data;
                _this.list = res.data.flatMap(function (v) {
                  return v.giftList;
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkIsLogin: function checkIsLogin() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _zhibo.checkIsLogin)();

              case 2:
                res = _context2.sent;

                if (res.data == 1) {
                  _this2.getPresentUserInfo();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPresentUserInfo: function getPresentUserInfo() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var res;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _user.getPresentUserInfo)();

              case 2:
                res = _context3.sent;

                _this3.virtualBalance = res.data.virtualBalance;
                console.log('更新了吗', _this3.virtualBalance, res.data.virtualBalance);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleShowGdlw: function handleShowGdlw() {
      this.$emit('show_gdlw');
    },
    handleChoose: function handleChoose(index, event) {
      if (this.listIndex === index) {
        return;
      }
      this.listIndex = index;
      this.showGiftPopup(event);
    },
    giveGift: function giveGift() {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var params, res;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  liveId: _this4.$route.query.liveId,
                  giftId: _this4.list[_this4.listIndex].giftId,
                  num: 1
                };
                _context4.next = 3;
                return (0, _zhibo.giveGift)(params);

              case 3:
                res = _context4.sent;

                _this4.hidePopupImmediately();
                _this4.getPresentUserInfo();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleGiveGif: function handleGiveGif(data) {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var params, res;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  liveId: _this5.$route.query.liveId,
                  giftId: _this5.list[_this5.listIndex].giftId,
                  num: data
                };
                _context5.next = 3;
                return (0, _zhibo.giveGift)(params);

              case 3:
                res = _context5.sent;

                _this5.hidePopupImmediately();
                _this5.getPresentUserInfo();

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    showGiftPopup: function showGiftPopup(event) {
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }

      var targetImage = this.$refs.giftImages[this.listIndex];
      if (!targetImage) return;

      var rect = targetImage.getBoundingClientRect();

      var POPUP_WIDTH = 352;

      var popupX = rect.left + rect.width / 2;
      var popupY = rect.top - 5;
      var popupLeftEdge = popupX - POPUP_WIDTH / 2;
      var popupRightEdge = popupX + POPUP_WIDTH / 2;

      if (popupLeftEdge < 0) {
        popupX = POPUP_WIDTH / 2;
      } else if (popupRightEdge > window.innerWidth) {
          popupX = window.innerWidth - POPUP_WIDTH / 2;
        }

      this.popupPosition = { x: popupX, y: popupY };
      this.showPopup = true;
    },
    handleListMouseLeave: function handleListMouseLeave() {
      var _this6 = this;

      this.hidePopupTimeoutId = setTimeout(function () {
        _this6.hidePopupImmediately();
        _this6.hidePopupTimeoutId = null;
      }, 100);
    },
    handlePopupMouseEnter: function handlePopupMouseEnter() {
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }
    },
    handlePopupMouseLeave: function handlePopupMouseLeave() {
      this.hidePopupImmediately();
    },
    hidePopupImmediately: function hidePopupImmediately() {
      this.showPopup = false;
      this.listIndex = null;
    },
    handleResize: function handleResize() {
      this.screenWidth = window.innerWidth - 535;
      if (this.showPopup && this.listIndex !== null) {
        this.showGiftPopup();
      }
    }
  }
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			inLwList: [],
			lwQueue: [],
			isLwAnimating: false,
			animateTotalTime: 3000,
			animateGap: 100
		};
	},
	mounted: function mounted() {},

	methods: {
		addLwToQueue: function addLwToQueue(gift) {
			this.lwQueue.push(gift);
			if (!this.isLwAnimating) {
				this.showNextLw();
			}
		},
		showNextLw: function showNextLw() {
			var _this = this;

			if (this.lwQueue.length === 0) {
				this.isLwAnimating = false;
				return;
			}

			this.isLwAnimating = true;
			var gift = this.lwQueue.shift();
			this.inLwList.push(gift);

			setTimeout(function () {
				_this.inLwList = _this.inLwList.filter(function (item) {
					return item.giftId !== gift.giftId;
				});
				setTimeout(function () {
					_this.showNextLw();
				}, _this.animateGap);
			}, this.animateTotalTime);
		}
	}
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "mainscreenplayer",
  props: {
    mainScreenData: {
      type: Object,
      default: null
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    selfUserId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      player: null,
      playerId: null,
      selfContainerId: null,
      isPlaying: false,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license"
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log(this.mainScreenData, 'mainScreenData');
    if (this.isSelf && this.selfUserId) {
      this.selfContainerId = 'pusher-' + this.selfUserId;
    } else {
      this.playerId = 'mainscreen-player-' + Date.now();
      this.$nextTick(function () {
        _this.initPlayer();
      });
    }
  },

  watch: {
    mainScreenData: {
      immediate: true,
      handler: function handler(newVal) {
        var _this2 = this;

        if (newVal && !this.isSelf) {
          this.$nextTick(function () {
            _this2.initPlayer();
          });
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      try {
        this.player.pause();
        this.player.src('');
        this.player.dispose();
      } catch (e) {
        console.warn('播放器清理异常:', e);
      }
      this.player = null;
    }
  },

  methods: {
    initPlayer: function initPlayer() {
      var _this3 = this;

      if (!this.mainScreenData || !this.mainScreenData.pullUrl || this.mainScreenData.cameraStatus === 0) return;

      if (!this.playerId) {
        this.playerId = 'mainscreen-player-' + Date.now();
      }

      this.$nextTick(function () {
        if (!document.getElementById(_this3.playerId)) {
          console.warn('播放器容器不存在:', _this3.playerId);
          return;
        }

        if (!_this3.player) {
          _this3.player = TCPlayer(_this3.playerId, {
            sources: [{
              src: _this3.mainScreenData.pullUrl
            }],
            licenseUrl: _this3.licenseUrl,
            autoplay: true,
            controls: false,
            playsinline: true,
            posterImage: false,
            bigPlayButton: false,
            webrtcConfig: {
              connectRetryCount: 999999
            }
          });

          _this3.player.on('webrtcevent', function (event) {
            console.log('mainscreen webrtcevent:', event.data);
            if (event.data.code == 1005 || event.data.code == 1009) {
              _this3.isPlaying = false;
            }
            if (event.data.code == 1003) {
              _this3.isPlaying = true;
            }
          });

          _this3.player.on('play', function () {
            _this3.isPlaying = true;
          });

          _this3.player.on('playing', function () {
            _this3.isPlaying = true;
          });

          _this3.player.on('loadeddata', function () {
            _this3.isPlaying = true;
          });

          setTimeout(function () {
            if (!_this3.isPlaying) {
              _this3.isPlaying = true;
            }
          }, 500);
        } else {
          _this3.player.src(_this3.mainScreenData.pullUrl);
          _this3.player.play();
        }
      });
    }
  }
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = __webpack_require__(80);

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'pinglun',
	components: {
		kong: _kong2.default
	},
	props: {
		videoId: {
			type: [String, Number],
			default: ''
		}
	},
	data: function data() {
		return {
			list: [],
			total: 0,
			page: 1,
			size: 20,
			loading: false,
			loaded: false,
			hasMore: true,
			inputValue: '',
			submitting: false,

			replyTarget: null,

			delTarget: null,
			delSubmitting: false,

			emojiShow: false,
			emojiList: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '😱', '😨', '😰', '😥', '😓', '😳', '🥺', '👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '👏', '🙏', '💪', '❤️', '💔', '💕', '💖', '🌹', '🎉', '🔥', '💯', '✨', '🎁', '🍺', '☕', '🍉', '⚽', '🏀', '🎮', '💰', '🌙', '⭐', '🌈']
		};
	},

	computed: {
		inputPlaceholder: function inputPlaceholder() {
			if (this.replyTarget) {
				var name = this.replyTarget.child ? this.replyTarget.child.nickName : this.replyTarget.parent.nickName;
				return this.$t('all.huifu') + ' @' + name;
			}
			return this.$t('all.shuodianshenme');
		},
		replyChipText: function replyChipText() {
			if (!this.replyTarget) return '';
			var name = this.replyTarget.child ? this.replyTarget.child.nickName : this.replyTarget.parent.nickName;
			return this.$t('all.huifu') + ' @' + name;
		}
	},
	watch: {
		videoId: function videoId() {
			this.resetList();
		}
	},
	created: function created() {
		this.resetList();
	},
	beforeDestroy: function beforeDestroy() {
		this.emojiShow = false;
	},

	methods: {
		toggleEmoji: function toggleEmoji() {
			this.emojiShow = !this.emojiShow;
		},
		pickEmoji: function pickEmoji(e) {
			this.inputValue = (this.inputValue || '') + e;
		},
		resetList: function resetList() {
			this.list = [];
			this.total = 0;
			this.page = 1;
			this.hasMore = true;
			this.replyTarget = null;
			this.emojiShow = false;
			if (this.$refs.list) this.$refs.list.scrollTop = 0;
			this.loadList();
		},
		handleListScroll: function handleListScroll() {
			var el = this.$refs.list;
			if (!el) return;
			if (el.scrollTop + el.clientHeight >= el.scrollHeight - 30) {
				this.loadList();
			}
		},
		loadList: function loadList() {
			var _this = this;

			if (this.loading || !this.hasMore || !this.videoId) return;
			this.loading = true;
			(0, _user.getVideoCommentList)({
				videoId: this.videoId,
				page: this.page,
				size: this.size
			}).then(function (response) {
				var rows = response && response.rows || [];
				_this.total = response && response.total || 0;
				_this.list = _this.list.concat(rows.map(function (r) {
					return _this.normalize(r);
				}));
				if (rows.length < _this.size) {
					_this.hasMore = false;
				}
				_this.page++;
			}).catch(function (e) {
				console.error('获取评论列表失败:', e);
			}).finally(function () {
				_this.loading = false;
				_this.loaded = true;
			});
		},
		sortChilds: function sortChilds(list) {
			return (list || []).sort(function (a, b) {
				return (b.createTime || '').localeCompare(a.createTime || '');
			});
		},
		normalize: function normalize(c) {
			var _this2 = this;

			var preloaded = c.childList || [];
			return {
				id: c.commentId,
				userId: c.userId,
				avatar: c.userHeadPortrait || '',
				nickName: c.userNickName || '',
				content: c.content || '',
				createTime: c.createTime || '',

				isPresentUser: c.isPresentUser,

				replyNumber: c.childCount || 0,
				childs: this.sortChilds(preloaded.map(function (r) {
					return _this2.normalize(r);
				})),
				childPage: 1,
				childHasMore: preloaded.length < (c.childCount || 0),
				childLoading: false
			};
		},
		isMine: function isMine(c) {
			return c.isPresentUser == 1;
		},
		loadChilds: function loadChilds(c) {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var response, rows, existing;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(c.childLoading || !c.childHasMore)) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								c.childLoading = true;
								_context.prev = 3;
								_context.next = 6;
								return (0, _user.getChildCommentList)({
									commentId: c.id,
									page: c.childPage,
									size: _this3.size
								});

							case 6:
								response = _context.sent;
								rows = response && response.rows || [];
								existing = {};

								c.childs.forEach(function (x) {
									existing[x.id] = true;
								});
								rows.forEach(function (r) {
									var n = _this3.normalize(r);
									if (!existing[n.id]) {
										c.childs.push(n);
										existing[n.id] = true;
									}
								});
								_this3.sortChilds(c.childs);
								if (rows.length < _this3.size || c.childs.length >= c.replyNumber) {
									c.childHasMore = false;
								} else {
									c.childPage++;
								}
								_context.next = 18;
								break;

							case 15:
								_context.prev = 15;
								_context.t0 = _context['catch'](3);

								console.error('获取回复列表失败:', _context.t0);

							case 18:
								_context.prev = 18;

								c.childLoading = false;
								return _context.finish(18);

							case 21:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3, [[3, 15, 18, 21]]);
			}))();
		},
		childMoreText: function childMoreText(c) {
			return c.childLoading ? this.$t('all.jiazaizhong') : this.$t('all.jiazaigengduo');
		},
		startReply: function startReply(parent, child) {
			this.replyTarget = { parent: parent, child: child || null };
		},
		submit: function submit() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var content, response, parent, created, _created;

				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								content = (_this4.inputValue || '').trim();

								if (!(!content || _this4.submitting)) {
									_context2.next = 3;
									break;
								}

								return _context2.abrupt('return');

							case 3:
								_this4.submitting = true;
								_context2.prev = 4;
								response = void 0;

								if (!_this4.replyTarget) {
									_context2.next = 25;
									break;
								}

								parent = _this4.replyTarget.parent;
								_context2.next = 10;
								return (0, _user.replyCommentVideo)({
									videoId: _this4.videoId,
									commentId: parent.id,
									content: content
								});

							case 10:
								response = _context2.sent;
								created = _this4.pickCreated(response);

								if (!created) {
									_context2.next = 17;
									break;
								}

								parent.childs.unshift(created);
								parent.replyNumber++;
								_context2.next = 23;
								break;

							case 17:
								parent.childs = [];
								parent.childPage = 1;
								parent.childHasMore = true;
								_context2.next = 22;
								return _this4.loadChilds(parent);

							case 22:
								parent.replyNumber++;

							case 23:
								_context2.next = 31;
								break;

							case 25:
								_context2.next = 27;
								return (0, _user.commentVideo)({
									videoId: _this4.videoId,
									content: content
								});

							case 27:
								response = _context2.sent;
								_created = _this4.pickCreated(response);

								if (_created) {
									_this4.list.unshift(_created);
									_this4.total++;
								} else {
									_this4.resetList();
								}
								_this4.$emit('count-change', 1);

							case 31:
								_this4.inputValue = '';
								_this4.replyTarget = null;
								_context2.next = 38;
								break;

							case 35:
								_context2.prev = 35;
								_context2.t0 = _context2['catch'](4);

								console.error('评论失败:', _context2.t0);

							case 38:
								_context2.prev = 38;

								_this4.submitting = false;
								return _context2.finish(38);

							case 41:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this4, [[4, 35, 38, 41]]);
			}))();
		},
		pickCreated: function pickCreated(response) {
			var d = response && response.data;
			if (d && (typeof d === 'undefined' ? 'undefined' : (0, _typeof3.default)(d)) === 'object' && d.content && (d.commentId !== undefined || d.id !== undefined)) {
				return this.normalize(d);
			}
			return null;
		},
		delComment: function delComment(c, ci) {
			this.delTarget = { type: 'comment', item: c, index: ci };
		},
		delReply: function delReply(parent, r, ri) {
			this.delTarget = { type: 'reply', parent: parent, item: r, childIndex: ri };
		},
		confirmDel: function confirmDel() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var t;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(!_this5.delTarget || _this5.delSubmitting)) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt('return');

							case 2:
								_this5.delSubmitting = true;
								_context3.prev = 3;
								t = _this5.delTarget;
								_context3.next = 7;
								return (0, _user.deleteComment)({ commentId: t.item.id });

							case 7:
								if (t.type === 'comment') {
									_this5.list.splice(t.index, 1);
									_this5.total = Math.max(_this5.total - 1, 0);
									_this5.$emit('count-change', -1);
								} else {
									t.parent.childs.splice(t.childIndex, 1);
									t.parent.replyNumber = Math.max(t.parent.replyNumber - 1, 0);
								}
								_this5.delTarget = null;
								_context3.next = 14;
								break;

							case 11:
								_context3.prev = 11;
								_context3.t0 = _context3['catch'](3);

								console.error('删除评论失败:', _context3.t0);

							case 14:
								_context3.prev = 14;

								_this5.delSubmitting = false;
								return _context3.finish(14);

							case 17:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this5, [[3, 11, 14, 17]]);
			}))();
		},
		formatTime: function formatTime(str) {
			if (!str) return '';
			var t = new Date(String(str).replace(/-/g, '/')).getTime();
			if (!t || isNaN(t)) return str;
			var diff = Date.now() - t;
			var min = Math.floor(diff / 60000);
			if (min < 1) return this.$t('all.ganggang');
			if (min < 60) return this.$t('all.fenzhongqian', { n: min });
			var hour = Math.floor(min / 60);
			if (hour < 24) return this.$t('all.xiaoshiqian', { n: hour });
			var day = Math.floor(hour / 24);
			if (day < 7) return this.$t('all.tianqian', { n: day });
			return String(str).slice(0, 10);
		}
	}
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgaplayerweb = __webpack_require__(865);

var _svgaplayerweb2 = _interopRequireDefault(_svgaplayerweb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      player: null,
      parser: null,
      giftQueue: [],
      isPlaying: false,
      playLock: false,
      currentFrame: 0,
      totalFrames: 0,
      frameTimer: null,
      playTimeout: null };
  },
  mounted: function mounted() {
    this.initSVGA();
  },
  beforeUnmount: function beforeUnmount() {
    this.destroySVGA();
  },

  methods: {
    initSVGA: function initSVGA() {
      var _this = this;

      if (this.player) return;

      try {
        var container = this.$refs.drawContainer;
        if (!container) {
          console.error('SVGA 容器不存在');
          return;
        }

        this.player = new _svgaplayerweb2.default.Player(container);
        this.player.loops = 1;
        this.player.clearsAfterStop = true;
        this.player.fillMode = "forwards";

        this.player.onFinished = function () {
          console.log('原生onFinished事件触发');
          _this.stopCurrentPlay();
          _this.resetPlayState();
          _this.playNextGift();
        };

        this.parser = new _svgaplayerweb2.default.Parser();
        console.log('SVGA 初始化完成');
      } catch (error) {
        console.error('SVGA 初始化失败：', error);
      }
    },
    addGiftToQueue: function addGiftToQueue(svgaUrl) {
      if (!svgaUrl) return;

      var isExisted = this.giftQueue.some(function (url) {
        return url === svgaUrl;
      });
      if (isExisted) return;

      this.giftQueue.push(svgaUrl);
      console.log('添加礼物到队列：' + svgaUrl + '，队列长度：' + this.giftQueue.length);

      this.playNextGift();
    },
    playNextGift: function playNextGift() {
      var _this2 = this;

      if (this.playLock || this.giftQueue.length === 0) {
        console.log('播放条件不满足：锁=' + this.playLock + '，队列长度=' + this.giftQueue.length);
        return;
      }

      this.playLock = true;
      this.isPlaying = true;

      var currentGiftUrl = this.giftQueue.shift();
      console.log('开始播放礼物：', currentGiftUrl);

      this.parser.load(currentGiftUrl, function (videoItem) {
        if (!videoItem) {
          console.error('解析失败：', currentGiftUrl);
          _this2.resetPlayState();
          _this2.playNextGift();
          return;
        }

        try {
          _this2.stopCurrentPlay();

          _this2.totalFrames = videoItem.frames || 0;
          _this2.currentFrame = 0;

          var frameInterval = 1000 / (videoItem.fps || 24);
          _this2.player.stopAnimation();
          _this2.player.clear();
          _this2.player.setVideoItem(videoItem);
          _this2.player.startAnimation();
          console.log('\u5F00\u59CB\u64AD\u653E\uFF0C\u603B\u5E27\u6570\uFF1A' + _this2.totalFrames + '\uFF0C\u5E27\u7387\uFF1A' + (videoItem.fps || 24) + '\uFF0C\u95F4\u9694\uFF1A' + frameInterval + 'ms');

          _this2.frameTimer = setInterval(function () {
            _this2.currentFrame++;
            console.log('\u5F53\u524D\u5E27\uFF1A' + _this2.currentFrame + '/' + _this2.totalFrames);

            if (_this2.currentFrame >= _this2.totalFrames - 1) {
              _this2.stopCurrentPlay();
              _this2.resetPlayState();
              _this2.playNextGift();
            }
          }, frameInterval);

          _this2.playTimeout = setTimeout(function () {
            console.warn('播放超时，强制停止');
            _this2.stopCurrentPlay();
            _this2.resetPlayState();
            _this2.playNextGift();
          }, _this2.totalFrames * frameInterval + 1000);
        } catch (playError) {
          console.error('播放礼物时出错：', playError);
          _this2.stopCurrentPlay();
          _this2.resetPlayState();
          _this2.playNextGift();
        }
      }, function (error) {
        console.error('加载失败：', error);
        _this2.resetPlayState();
        _this2.playNextGift();
      });
    },
    stopCurrentPlay: function stopCurrentPlay() {
      try {
        clearInterval(this.frameTimer);
        clearTimeout(this.playTimeout);
        this.frameTimer = null;
        this.playTimeout = null;

        if (this.player) {
          this.player.stopAnimation();
          this.player.clear();
        }

        this.currentFrame = 0;
        this.totalFrames = 0;
        console.log('当前播放已停止并清理');
      } catch (stopError) {
        console.error('停止播放时出错：', stopError);
      }
    },
    resetPlayState: function resetPlayState() {
      this.isPlaying = false;
      this.playLock = false;
      console.log('播放状态已重置');
    },
    clearGiftQueue: function clearGiftQueue() {
      this.giftQueue = [];
      this.stopCurrentPlay();
      this.resetPlayState();
    },
    destroySVGA: function destroySVGA() {
      try {
        this.stopCurrentPlay();

        if (this.player) {
          this.player.onFinished = null;
          this.player = null;
        }

        this.parser = null;
        this.giftQueue = [];
        this.resetPlayState();
      } catch (destroyError) {
        console.error('销毁SVGA时出错：', destroyError);
      }
    }
  }
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Popup',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      list: [1, 10, 66, 188, 520, 999, 1314, 5200]
    };
  },

  methods: {
    handleZs: function handleZs(data) {
      console.log(123123);
      this.$emit('giveGif', data);
    }
  }
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(61);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _methods;

var _zhibo = __webpack_require__(7);

var _user = __webpack_require__(14);

var _popup = __webpack_require__(328);

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'quanbuliwu',
  components: {
    popup: _popup2.default
  },
  data: function data() {
    return {
      categoryList: [],

      listIndex: 0,

      currentGiftList: [],

      currentGiftIndex: -1,

      virtualBalance: 0,
      showPopup: false,
      popupPosition: { x: 0, y: 0 },
      hidePopupTimeoutId: null
    };
  },
  mounted: function mounted() {
    this.getGiftList();
    this.getPresentUserInfo();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.hidePopupTimeoutId) {
      clearTimeout(this.hidePopupTimeoutId);
    }
  },

  methods: (_methods = {
    getGiftList: function getGiftList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _zhibo.getGiftList)({ liveId: _this.$route.query.liveId });

              case 2:
                res = _context.sent;

                _this.categoryList = res.data;

                _this.currentGiftList = res.data[0].giftList;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getPresentUserInfo: function getPresentUserInfo() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _user.getPresentUserInfo)();

              case 2:
                res = _context2.sent;

                _this2.virtualBalance = res.data.virtualBalance;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleChooseCategory: function handleChooseCategory(index) {
      if (this.listIndex === index) {
        return;
      }
      this.listIndex = index;

      this.currentGiftList = this.categoryList[index].giftList;

      this.currentGiftIndex = -1;

      this.hidePopupImmediately();
    },
    giveGift: function giveGift() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var params, res;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  liveId: _this3.$route.query.liveId,
                  giftId: _this3.currentGiftList[_this3.currentGiftIndex].giftId,
                  num: 1
                };
                _context3.next = 3;
                return (0, _zhibo.giveGift)(params);

              case 3:
                res = _context3.sent;

                _this3.hidePopupImmediately();
                _this3.$emit('updateUser');

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleGiveGif: function handleGiveGif(data) {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var params, res;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  liveId: _this4.$route.query.liveId,
                  giftId: _this4.currentGiftList[_this4.currentGiftIndex].giftId,
                  num: data
                };
                _context4.next = 3;
                return (0, _zhibo.giveGift)(params);

              case 3:
                res = _context4.sent;

                console.log('送了礼物');
                _this4.$emit('updateUser');

                _this4.hidePopupImmediately();

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleGiftMouseEnter: function handleGiftMouseEnter(index, event) {
      if (this.currentGiftIndex === index) {
        return;
      }
      this.currentGiftIndex = index;

      this.showGiftPopup(event);
    },
    handleGiveGiftClick: function handleGiveGiftClick(item) {
      console.log("准备赠送礼物:", item);
    },
    showGiftPopup: function showGiftPopup(event) {
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }

      var targetImage = event.currentTarget.querySelector('.qblw-box-list-item-img');
      if (!targetImage) return;

      var rect = targetImage.getBoundingClientRect();
      var POPUP_WIDTH = 352;

      var popupX = rect.left + rect.width / 2;
      var popupY = rect.top;

      var popupLeftEdge = popupX - POPUP_WIDTH / 2;
      var popupRightEdge = popupX + POPUP_WIDTH / 2;

      if (popupLeftEdge < 0) {
        popupX = POPUP_WIDTH / 2;
      } else if (popupRightEdge > window.innerWidth) {
        popupX = window.innerWidth - POPUP_WIDTH / 2;
      }

      this.popupPosition = { x: popupX, y: popupY };
      this.showPopup = true;
    },
    handleListMouseLeave: function handleListMouseLeave() {
      var _this5 = this;

      this.hidePopupTimeoutId = setTimeout(function () {
        _this5.hidePopupImmediately();
        _this5.hidePopupTimeoutId = null;
      }, 100);
    },
    handlePopupMouseEnter: function handlePopupMouseEnter() {
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }
    },
    handlePopupMouseLeave: function handlePopupMouseLeave() {
      this.hidePopupImmediately();
    },
    hidePopupImmediately: function hidePopupImmediately() {
      this.showPopup = false;

      this.currentGiftIndex = -1;
    }
  }, (0, _defineProperty3.default)(_methods, "handleGiveGif", function handleGiveGif(data) {
    var _this6 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
      var currentGift, params;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(_this6.currentGiftIndex === -1)) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              currentGift = _this6.currentGiftList[_this6.currentGiftIndex];
              params = {
                liveId: _this6.$route.query.liveId,
                giftId: currentGift.giftId,
                num: data
              };
              _context5.prev = 4;

              _this6.$emit('updateUser');
              _context5.next = 8;
              return (0, _zhibo.giveGift)(params);

            case 8:
              _this6.getPresentUserInfo();_context5.next = 14;
              break;

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](4);

              console.error("赠送礼物失败:", _context5.t0);

            case 14:
              _context5.prev = 14;

              _this6.hidePopupImmediately();
              return _context5.finish(14);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this6, [[4, 11, 14, 17]]);
    }))();
  }), (0, _defineProperty3.default)(_methods, "handleClose", function handleClose() {
    this.$emit('close');
  }), _methods),
  watch: {
    listIndex: function listIndex(newVal) {
      if (newVal !== null && this.currentGiftList.length > 0) {}
    }
  }
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			show: false,
			navList: [{
				img: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688018165_oj1l4sf0cy.png',
				name: this.$t('all.yuyanxuanze')
			}, {
				img: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688073263_tqfg1nieeam.png',
				name: this.$t('all.xiugaimima')
			}, {
				img: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688100314_5kqt1l5o5tf.png',
				name: this.$t('all.yinsizhengce')
			}, {
				img: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688115602_hte1guphbwo.png',
				name: this.$t('all.guanyuwomen')
			}],
			navListIndex: 0,
			yyList: [{
				name: this.$t('all.jiantizhongwen'),
				language: 'cn'
			}, {
				name: this.$t('all.fantizhongwen'),
				language: 'tw'
			}, {
				name: this.$t('all.yingwen'),
				language: 'en'
			}, {
				name: this.$t('all.ribenyu'),
				language: 'ja'
			}, {
				name: this.$t('all.hanguoyu'),
				language: 'ko'
			}],
			yyListIndex: 0,
			form: {
				password: '',
				oldPassword: ''
			},
			isPassword: true,
			isOldPassword: true,
			data: ''
		};
	},
	mounted: function mounted() {
		var lang = localStorage.getItem('Language');
		this.yyListIndex = lang === 'cn' ? 0 : lang === 'tw' ? 1 : lang === 'en' ? 2 : lang === 'ja' ? 3 : 4;
	},

	methods: {
		showModel: function showModel() {
			this.show = true;
		},
		handleNav: function handleNav(index) {
			this.navListIndex = index;
			if (index == 2) {
				this.getHtmlContentByType();
			}
		},
		handleChooseYy: function handleChooseYy(index, language) {
			this.yyListIndex = index;
			this.$i18n.locale = language;
			localStorage.setItem("Language", language);
			var langStr = 'chinese';
			if (language === 'en') langStr = 'english';else if (language === 'tw') langStr = 'taiwan';else if (language === 'ja') langStr = 'japanese';else if (language === 'ko') langStr = 'korean';
			this.$store.commit('changeLanguage', langStr);
			window.location.reload();
		},
		updatePassWord: function updatePassWord() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _user.updatePassWord)(_this.form);

							case 2:
								res = _context.sent;

								_this.$message({ message: res.msg, type: 'success' });
								_this.form = {
									password: '',
									oldPassword: ''
								};

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getHtmlContentByType: function getHtmlContentByType() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _user.getHtmlContentByType)({ type: 2 });

							case 2:
								res = _context2.sent;

								_this2.data = res.data;

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		}
	}
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _playSvga = __webpack_require__(139);

var _playSvga2 = _interopRequireDefault(_playSvga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "tengxunyun",
  components: {
    playSvga: _playSvga2.default
  },
  data: function data() {
    return {
      data: "",
      player: null,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license",
      playerId: null,

      verticalAspectRatio: 9 / 16,
      horizontalAspectRatio: 16 / 9,
      currentAspectRatio: 9 / 16,
      screenType: 0,
      show_svga: true,
      muted: true,
      isShowCover: true,
      backgroundUrl: '',
      isRefresh: sessionStorage.getItem('isPageRefreshed')
    };
  },
  mounted: function mounted() {
    this.playerId = this.generateId();

    this.calculatePlayerSize();

    window.addEventListener("resize", this.calculatePlayerSize);

    this.getChatRoomDetails();

    window.addEventListener("beforeunload", this.updateRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.calculatePlayerSize);
    console.log('刷新页面');

    if (this.player) {
      try {
        this.player.pause();

        this.player.src('');

        this.player.off('webrtcevent');

        this.player.dispose();
        console.log('播放器已完整销毁，音频和事件已清理');
      } catch (e) {
        console.warn('播放器清理过程中出现异常，忽略继续:', e);
      }

      this.player = null;
    }

    this.playerId = null;
    this.isShowCover = true;
    this.show_svga = false;
    this.muted = true;
  },

  methods: {
    updateRefresh: function updateRefresh() {
      sessionStorage.setItem('isPageRefreshed', 1);
    },
    generateId: function generateId() {
      return "player-container-" + Date.now();
    },
    calculatePlayerSize: function calculatePlayerSize() {
      var container = this.$refs.playerContainer;
      if (!container) return;

      var parentContainer = container.parentElement;
      var parentWidth = parentContainer.offsetWidth;
      var viewportHeight = window.innerHeight;

      var maxAvailableHeight = viewportHeight - 126;

      var maxPlayerWidth = void 0;
      if (this.screenType === 1) {
        maxPlayerWidth = parentWidth * 0.5;
      } else {
        maxPlayerWidth = parentWidth;
      }

      var calculatedWidth = maxAvailableHeight * this.currentAspectRatio;

      var finalWidth = void 0,
          finalHeight = void 0;

      if (calculatedWidth > maxPlayerWidth) {
        finalWidth = maxPlayerWidth;

        finalHeight = finalWidth / this.currentAspectRatio;
      } else {
        finalHeight = maxAvailableHeight;

        finalWidth = calculatedWidth;
      }

      if (finalHeight > maxAvailableHeight) {
        finalHeight = maxAvailableHeight;
        finalWidth = finalHeight * this.currentAspectRatio;
      }

      container.style.width = finalWidth + "px";
      container.style.height = finalHeight + "px";
    },
    getChatRoomDetails: function getChatRoomDetails() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _zhibo.getChatRoomDetails)({ liveId: _this.$route.query.liveId });

              case 3:
                res = _context.sent;

                _this.data = res.data;
                _this.backgroundUrl = res.data.chatRoomDetails.bgUrl;

                _this.screenType = res.data.chatRoomDetails.screenType || 0;

                _this.currentAspectRatio = _this.screenType === 1 ? _this.horizontalAspectRatio : _this.verticalAspectRatio;
                _this.calculatePlayerSize();

                if (!_this.player) {
                  _this.player = TCPlayer(_this.playerId, {
                    sources: [{
                      src: res.data.chatRoomDetails.pullUrl }],
                    licenseUrl: _this.licenseUrl,
                    autoplay: true,
                    controls: false,
                    webrtcConfig: {
                      connectRetryCount: 999999
                    },
                    errorDisplay: false
                  });
                  _this.player.on('webrtcevent', function (event) {
                    console.log(event.data.code);
                    if (event.data.code == 1005 || event.data.code == 1009) {
                      _this.isShowCover = true;
                    }
                    if (event.data.code == 1003) {
                      _this.isShowCover = false;
                      console.log(_this.isShowCover, '我隐藏了封面');
                    }
                  });
                  _this.player.on('error', function (event) {
                    console.log(event, '视频播放出现错误时触发。');
                  });
                } else {
                  _this.player.src(res.data.chatRoomDetails.pullUrl);
                  _this.player.play();

                  _this.calculatePlayerSize();
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.error("获取直播信息失败:", _context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12]]);
      }))();
    },
    addGiftToQueue: function addGiftToQueue(data) {
      this.$refs.svga.addGiftToQueue(data);
    },
    updateMuted: function updateMuted(data) {
      console.log(data);
      this.player.muted(data ? false : true);
    },
    updateSvga: function updateSvga(data) {
      console.log(data);
      this.show_svga = data;
    },
    refreshPlay: function refreshPlay() {
      this.isRefresh = 0;
      sessionStorage.setItem('isPageRefreshed', 1);
      this.player.src(this.data.chatRoomDetails.pullUrl);
      this.player.play();
    }
  }
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _playSvga = __webpack_require__(139);

var _playSvga2 = _interopRequireDefault(_playSvga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		playSvga: _playSvga2.default
	},
	data: function data() {
		return {
			livePusher: null,
			audioEffectManager: null,
			videoEffectManager: null,
			cameraStreamId: null,
			data: '',
			show_svga: true,
			isDeviceReady: false,
			isPushing: false,
			isMirrored: false,
			screenType: 0,
			verticalAspectRatio: 9 / 16,
			horizontalAspectRatio: 16 / 12,
			currentAspectRatio: 9 / 16 };
	},
	mounted: function mounted() {
		this.calculatePlayerSize();
		window.addEventListener("resize", this.calculatePlayerSize);
		this.getLivePusher();
	},

	methods: {
		calculatePlayerSize: function calculatePlayerSize() {
			var container = this.$refs.videoWrapper;
			if (!container) return;

			var parentContainer = container.parentElement;
			if (!parentContainer) return;
			var parentWidth = parentContainer.offsetWidth;
			var viewportHeight = window.innerHeight;
			var maxAvailableHeight = viewportHeight - 126;

			var maxPlayerWidth = void 0;
			if (this.screenType === 1) {
				maxPlayerWidth = parentWidth * 0.5;
			} else {
				maxPlayerWidth = parentWidth;
			}

			var calculatedWidth = maxAvailableHeight * this.currentAspectRatio;

			var finalWidth = void 0,
			    finalHeight = void 0;

			if (calculatedWidth > maxPlayerWidth) {
				finalWidth = maxPlayerWidth;
				finalHeight = finalWidth / this.currentAspectRatio;
			} else {
				finalHeight = maxAvailableHeight;
				finalWidth = calculatedWidth;
			}

			if (finalHeight > maxAvailableHeight) {
				finalHeight = maxAvailableHeight;
				finalWidth = finalHeight * this.currentAspectRatio;
			}

			container.style.width = finalWidth + "px";
			container.style.height = finalHeight + "px";
		},
		getLivePusher: function getLivePusher(data) {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var quality;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								quality = data ? data : '720p';

								_this.livePusher = new TXLivePusher();
								_this.audioEffectManager = _this.livePusher.getAudioEffectManager();
								_this.videoEffectManager = _this.livePusher.getVideoEffectManager();

								_this.videoEffectManager.enableMixing(true);
								_this.livePusher.setRenderView('local_video');
								_this.livePusher.videoView.muted = true;

								_this.livePusher.setVideoQuality(quality);

								_this.livePusher.setAudioQuality('standard');

								_this.livePusher.setProperty('setVideoFPS', 25);

								_this.livePusher.setObserver({
									onPushStatusUpdate: function onPushStatusUpdate(code, message) {
										console.log('推流状态更新:', code, message);
										if (code === 1001) {
											_this.isPushing = false;
										} else if (code === 1002) {
											_this.isPushing = true;
											console.log('推流真正成功了');
										} else if (code === -1307) {
											_this.isPushing = false;
											console.error('推流连接断开');
										}
										if (code == 2) {
											_this.sendRefreshMsg();
										}
									},
									onPushError: function onPushError(code, message) {
										console.error('推流错误:', code, message);
										_this.isPushing = false;
									}
								});

								_context.prev = 11;

								console.log('正在启动摄像头和麦克风...');
								_context.next = 15;
								return _this.livePusher.startCamera();

							case 15:
								_this.cameraStreamId = _context.sent;
								_context.next = 18;
								return _this.livePusher.startMicrophone();

							case 18:
								_this.isDeviceReady = true;
								console.log('摄像头和麦克风启动成功, streamId:', _this.cameraStreamId);

								_context.next = 22;
								return _this.getChatRoomDetails();

							case 22:
								_context.next = 28;
								break;

							case 24:
								_context.prev = 24;
								_context.t0 = _context["catch"](11);

								console.error('媒体设备启动失败:', _context.t0);
								_this.isDeviceReady = false;

							case 28:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this, [[11, 24]]);
			}))();
		},
		sendRefreshMsg: function sendRefreshMsg() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _zhibo.sendRefreshMsg)({ liveId: _this2.$route.query.liveId });

							case 2:
								res = _context2.sent;

							case 3:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		startPush: function startPush() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var pushUrl, newUrl;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (_this3.isDeviceReady) {
									_context3.next = 3;
									break;
								}

								console.warn('设备未就绪，推流取消');
								return _context3.abrupt("return");

							case 3:
								pushUrl = _this3.data.chatRoomDetails.pushUrl;
								newUrl = pushUrl.replace(/^rtmp:\/\//, 'webrtc://');
								_context3.prev = 5;

								console.log('正在尝试推流:', newUrl);
								_context3.next = 9;
								return _this3.livePusher.startPush(newUrl);

							case 9:
								console.log('startPush 调用成功，等待状态更新...');
								_context3.next = 16;
								break;

							case 12:
								_context3.prev = 12;
								_context3.t0 = _context3["catch"](5);

								console.error('推流发起失败:', _context3.t0);
								_this3.isPushing = false;

							case 16:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3, [[5, 12]]);
			}))();
		},
		setVideoQuality: function setVideoQuality(data) {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var quality;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (_this4.livePusher) {
									_this4.livePusher.stopPush();
									_this4.livePusher.stopCamera();
									_this4.livePusher.stopMicrophone();
									_this4.livePusher.destroy();
									_this4.livePusher = null;
								}
								_this4.isDeviceReady = false;
								_this4.isPushing = false;
								quality = data === 0 ? '720p' : data === 1 ? '360p' : '1080p';
								_context4.next = 6;
								return _this4.getLivePusher(quality);

							case 6:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		getChatRoomDetails: function getChatRoomDetails() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var res;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								if (_this5.$route.query.liveId) {
									_context5.next = 2;
									break;
								}

								return _context5.abrupt("return");

							case 2:
								_context5.next = 4;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this5.$route.query.liveId });

							case 4:
								res = _context5.sent;

								_this5.data = res.data;
								_this5.screenType = res.data.chatRoomDetails.screenType || 0;
								_this5.currentAspectRatio = _this5.screenType === 1 ? _this5.horizontalAspectRatio : _this5.verticalAspectRatio;
								_this5.calculatePlayerSize();
								console.log('获取推流链接, screenType:', _this5.screenType);
								_this5.startPush();

							case 11:
							case "end":
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		setVolume: function setVolume(data) {
			console.log(data);
			this.audioEffectManager.setVolume(data);
		},
		addGiftToQueue: function addGiftToQueue(data) {
			console.log(data, 123);
			this.$refs.svga.addGiftToQueue(data);
		},
		showSvga: function showSvga(data) {
			this.show_svga = data;
		},
		toggleCamera: function toggleCamera(enable) {
			var _this6 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								if (_this6.livePusher) {
									_context6.next = 2;
									break;
								}

								return _context6.abrupt("return");

							case 2:
								try {
									if (enable) {
										_this6.livePusher.setVideoMute(false);
									} else {
										_this6.livePusher.setVideoMute(true);
									}
								} catch (error) {
									console.error('切换摄像头失败:', error);
								}

							case 3:
							case "end":
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		toggleMic: function toggleMic(enable) {
			if (!this.livePusher) return;
			try {
				this.livePusher.setAudioMute(!enable);
			} catch (error) {
				console.error('切换麦克风失败:', error);
			}
		},
		toggleMirror: function toggleMirror(enable) {
			if (!this.videoEffectManager || !this.cameraStreamId) {
				console.error('视频效果管理器或流ID不可用');
				return;
			}
			try {
				this.videoEffectManager.setMirror({
					streamId: this.cameraStreamId,
					mirrorType: enable ? 1 : 0 });
				this.isMirrored = enable;
				console.log('镜像设置成功:', enable ? '开启' : '关闭');
			} catch (error) {
				console.error('切换镜像失败:', error);
			}
		},
		cleanup: function cleanup() {
			if (this.livePusher) {
				try {
					this.livePusher.stopCamera();
					this.livePusher.stopMicrophone();
					this.livePusher.stopPush();
					this.livePusher.destroy();
					this.livePusher = null;
				} catch (e) {
					console.warn('清理推流失败:', e);
				}
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener("resize", this.calculatePlayerSize);
		if (this.livePusher) {
			this.livePusher.stopCamera();
			this.livePusher.stopMicrophone();
			this.livePusher.stopPush();
			this.livePusher.destroy();
			this.livePusher = null;
		}
		console.log('停止采集');
	}
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _zhubo = __webpack_require__(90);

var _playSvga = __webpack_require__(139);

var _playSvga2 = _interopRequireDefault(_playSvga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "tengxunyunzhubo",
  components: {
    playSvga: _playSvga2.default
  },
  data: function data() {
    return {
      data: "",
      player: null,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license",
      playerId: null,
      show_svga: true,
      muted: true,
      isShowCover: true,
      backgroundUrl: '',
      isRefresh: sessionStorage.getItem('isPageRefreshed')
    };
  },
  mounted: function mounted() {
    this.playerId = this.generateId();
    this.calculatePlayerSize();
    window.addEventListener("resize", this.calculatePlayerSize);
    this.getChatRoomDetails();
    window.addEventListener("beforeunload", this.updateRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.calculatePlayerSize);
    if (this.player) {
      try {
        this.player.pause();
        this.player.src('');
        this.player.off('webrtcevent');
        this.player.dispose();
      } catch (e) {
        console.warn('播放器清理过程中出现异常:', e);
      }
      this.player = null;
    }
    this.playerId = null;
    this.isShowCover = true;
    this.show_svga = false;
    this.muted = true;
  },

  methods: {
    updateRefresh: function updateRefresh() {
      sessionStorage.setItem('isPageRefreshed', 1);
    },
    generateId: function generateId() {
      return "player-container-" + Date.now();
    },
    calculatePlayerSize: function calculatePlayerSize() {
      var container = this.$refs.playerContainer;
      if (!container) return;

      var parentContainer = container.parentElement;
      var parentWidth = parentContainer.offsetWidth;
      var viewportHeight = window.innerHeight;

      var maxAvailableHeight = viewportHeight - 126;
      var aspectRatio = 9 / 16;
      var calculatedWidth = maxAvailableHeight * aspectRatio;

      var finalWidth = void 0,
          finalHeight = void 0;

      if (calculatedWidth > parentWidth) {
        finalWidth = parentWidth;
        finalHeight = finalWidth / aspectRatio;
      } else {
        finalHeight = maxAvailableHeight;
        finalWidth = calculatedWidth;
      }

      container.style.width = finalWidth + "px";
      container.style.height = finalHeight + "px";
    },
    getChatRoomDetails: function getChatRoomDetails() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _zhibo.getChatRoomDetails)({ liveId: _this.$route.query.liveId });

              case 2:
                res = _context.sent;

                console.log(res, 1234);
                res.data.helpLiveUserList.forEach(function (v) {
                  if (v.isMainScreen == 1) {
                    _this.data = v;
                    _this.backgroundUrl = v.userInfo.headPortrait;

                    if (!_this.player) {
                      _this.player = TCPlayer(_this.playerId, {
                        sources: [{
                          src: v.pullUrl
                        }],
                        licenseUrl: _this.licenseUrl,
                        autoplay: true,
                        controls: false,
                        webrtcConfig: {
                          connectRetryCount: 999999
                        }
                      });
                      _this.player.on('webrtcevent', function (event) {
                        if (event.data.code == 1005 || event.data.code == 1009) {
                          _this.isShowCover = true;
                        }
                        if (event.data.code == 1003) {
                          _this.isShowCover = false;
                        }
                      });
                      _this.player.on('error', function (event) {
                        console.log(event, '视频播放出现错误时触发。');
                      });
                    } else {
                      _this.player.src(v.pullUrl);
                      _this.player.play();
                      _this.calculatePlayerSize();
                    }
                  }
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toggleMicrophone: function toggleMicrophone() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var newStatus, res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this2.data);

                if (!(!_this2.data || !_this2.data.helpId)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                newStatus = _this2.data.isPermitMicrophone === 1 ? 0 : 1;
                _context2.prev = 4;
                _context2.next = 7;
                return (0, _zhubo.updateHelpLiveUser)({
                  helpId: _this2.data.helpId,
                  isPermitMicrophone: newStatus
                });

              case 7:
                res = _context2.sent;

                _this2.$message.success(res.msg);
                _this2.data.isPermitMicrophone = newStatus;
                if (_this2.player) {
                  _this2.player.muted(newStatus !== 1);
                }
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](4);

                console.error('切换麦克风失败:', _context2.t0);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 13]]);
      }))();
    },
    addGiftToQueue: function addGiftToQueue(data) {
      this.$refs.svga.addGiftToQueue(data);
    },
    updateMuted: function updateMuted(data) {
      this.player.muted(data ? false : true);
    },
    updateSvga: function updateSvga(data) {
      this.show_svga = data;
    },
    refreshPlay: function refreshPlay() {
      this.isRefresh = 0;
      sessionStorage.setItem('isPageRefreshed', 1);
      this.player.src(this.data.chatRoomDetails.pullUrl);
      this.player.play();
    }
  }
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			show: false,
			data: -1
		};
	},
	mounted: function mounted() {},

	methods: {
		checkIsLogin: function checkIsLogin() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.checkIsLogin)();

							case 2:
								res = _context.sent;

								_this.data = res.data;
								_this.show = true;

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		showModel: function showModel() {
			this.checkIsLogin();
		},
		logout: function logout() {
			this.$router.replace('/login');
			sessionStorage.setItem('user', null);
			this.$store.commit('changeToken', null);
			this.$store.commit('changeUserId', null);
			this.$store.commit('changeUserInfo', null);
			setTimeout(function () {
				window.history.pushState(null, null, '/login');
				window.addEventListener('popstate', function () {
					window.history.pushState(null, null, '/login');
				});
			}, 100);
		},
		login: function login() {
			this.$router.replace('/login');

			setTimeout(function () {
				window.history.pushState(null, null, '/login');
				window.addEventListener('popstate', function () {
					window.history.pushState(null, null, '/login');
				});
			}, 100);
		}
	}
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _zbjlItem = __webpack_require__(332);

var _zbjlItem2 = _interopRequireDefault(_zbjlItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default,
		zbjlItem: _zbjlItem2.default
	},
	data: function data() {
		return {
			show_user: false,
			data: '',
			form: {
				toUserId: '',
				liveId: this.$route.query.liveId
			},
			queryParams: {
				page: 1,
				size: 10,
				viewUserId: ''
			},
			list: [],
			isKong: false,
			hasMore: true,

			isLoading: false,
			isZb: false,
			isAdmin: 0
		};
	},
	mounted: function mounted() {},

	methods: {
		showUser: function showUser(userId) {
			this.show_user = true;
			this.form.toUserId = userId;
			this.queryParams.viewUserId = userId;
			this.getChatRoomUserDetails();
			this.getUserLiveRecordList();
			this.getChatRoomUserIsAdmin();
		},
		getChatRoomUserDetails: function getChatRoomUserDetails() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this.data = '';
								_context.next = 3;
								return (0, _zhibo.getChatRoomUserDetails)(_this.form);

							case 3:
								res = _context.sent;

								_this.data = res.data;

								if (res.data.subjoinParameter.chatRoomUserCurrentRecordsInfo.userId == JSON.parse(_this.$store.state.userId)) {
									_this.isZb = true;
								} else {
									_this.isZb = false;
								}

							case 6:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getChatRoomUserIsAdmin: function getChatRoomUserIsAdmin() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _zhibo.getChatRoomUserDetails)({
									liveId: _this2.$route.query.liveId,
									toUserId: JSON.parse(_this2.$store.state.userId)
								});

							case 2:
								res = _context2.sent;

								_this2.isAdmin = res.data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isAdmin;

							case 4:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		addAdmin: function addAdmin() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return (0, _zhibo.addAdmin)(_this3.form);

							case 2:
								res = _context3.sent;

								_this3.$message({ message: _this3.$t('all.caozuochenggong'), type: 'success' });
								_this3.show_user = false;
								_this3.$emit('addAdmin');

							case 6:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		bannedToPostUser: function bannedToPostUser() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var res;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.next = 2;
								return (0, _zhibo.bannedToPostUser)(_this4.form);

							case 2:
								res = _context4.sent;

								_this4.$message({ message: _this4.$t('all.caozuochenggong'), type: 'success' });
								_this4.getChatRoomUserDetails();

							case 5:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		relieveBannedToPostUser: function relieveBannedToPostUser() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var res;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return (0, _zhibo.relieveBannedToPostUser)(_this5.form);

							case 2:
								res = _context5.sent;

								_this5.$message({ message: _this5.$t('all.caozuochenggong'), type: 'success' });
								_this5.getChatRoomUserDetails();

							case 5:
							case "end":
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		kickOutChatRoom: function kickOutChatRoom() {
			var _this6 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				var res;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_this6.form.kickOutMinutes = 1;
								_context6.next = 3;
								return (0, _zhibo.kickOutChatRoom)(_this6.form);

							case 3:
								res = _context6.sent;

								_this6.$message({ message: _this6.$t('all.caozuochenggong'), type: 'success' });
								_this6.show_user = false;

							case 6:
							case "end":
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		getUserLiveRecordList: function getUserLiveRecordList() {
			var _this7 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
				var response, newList, totalPages;
				return _regenerator2.default.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								if (!(_this7.isLoading || !_this7.hasMore)) {
									_context7.next = 2;
									break;
								}

								return _context7.abrupt("return");

							case 2:
								_context7.prev = 2;

								_this7.isLoading = true;

								_context7.next = 6;
								return (0, _zhibo.getUserLiveRecordList)(_this7.queryParams);

							case 6:
								response = _context7.sent;
								newList = response.rows || [];


								if (_this7.queryParams.page === 1) {
									_this7.list = newList;
								} else {
									_this7.list = [].concat((0, _toConsumableArray3.default)(_this7.list), (0, _toConsumableArray3.default)(newList));
								}

								totalPages = Math.ceil((response.total || 0) / _this7.queryParams.size);

								_this7.hasMore = _this7.queryParams.page < totalPages;
								if (response.total > 0) {
									_this7.isKong = false;
								} else {
									_this7.isKong = true;
								}
								_context7.next = 17;
								break;

							case 14:
								_context7.prev = 14;
								_context7.t0 = _context7["catch"](2);

								console.error("获取直播记录列表失败:", _context7.t0);

							case 17:
								_context7.prev = 17;

								_this7.isLoading = false;
								return _context7.finish(17);

							case 20:
							case "end":
								return _context7.stop();
						}
					}
				}, _callee7, _this7, [[2, 14, 17, 20]]);
			}))();
		},
		handleScroll: function handleScroll() {
			if (this.isLoading || !this.hasMore) {
				return;
			}
			var container = this.$refs.listContainer;

			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;
			if (isAtBottom) {
				console.log("滚动到底部，准备加载第", this.queryParams.page + 1, "页");
				this.queryParams.page++;
				this.getUserLiveRecordList();
			}
		}
	}
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _user = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'xitongxiaoxi',
  components: {
    kong: _kong2.default
  },
  data: function data() {
    return {
      queryParams: {
        page: 1,
        size: 10
      },
      list: [],
      isKong: false
    };
  },
  mounted: function mounted() {
    this.getFaqList();
  },

  methods: {
    getFaqList: function getFaqList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _user.getFaqList)(_this.queryParams);

              case 2:
                response = _context.sent;

                _this.list = response.data;
                if (_this.list.length > 0) {
                  _this.isKong = false;
                } else {
                  _this.isKong = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleUploadFk: function handleUploadFk() {
      this.$emit('uploadFk');
    }
  }
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'xitongxiaoxi',
  components: {
    kong: _kong2.default
  },
  data: function data() {
    return {
      queryParams: {
        page: 1,
        size: 10
      },
      list: [],
      hasMore: true,

      isLoading: false,
      defaultGoodsImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png'
    };
  },
  mounted: function mounted() {
    this.getUserOrderList();
  },

  methods: {
    handleImgError: function handleImgError(e) {
      e.target.src = this.defaultGoodsImg;

      e.target.onerror = null;
    },
    getUserOrderList: function getUserOrderList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response, newList, totalPages;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.isLoading || !_this.hasMore)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;

                _this.isLoading = true;

                _context.next = 6;
                return (0, _zhibo.getUserOrderList)(_this.queryParams);

              case 6:
                response = _context.sent;
                newList = response.rows || [];


                if (_this.queryParams.page === 1) {
                  _this.list = newList;
                } else {
                  _this.list = [].concat((0, _toConsumableArray3.default)(_this.list), (0, _toConsumableArray3.default)(newList));
                }

                totalPages = Math.ceil((response.total || 0) / _this.queryParams.size);

                _this.hasMore = _this.queryParams.page < totalPages;

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);

                console.error("获取系统消息列表失败:", _context.t0);

              case 16:
                _context.prev = 16;

                _this.isLoading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 13, 16, 19]]);
      }))();
    },
    handleScroll: function handleScroll() {
      if (this.isLoading || !this.hasMore) {
        return;
      }

      var container = this.$refs.listContainer;

      var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;

      if (isAtBottom) {
        console.log("滚动到底部，准备加载第", this.queryParams.page + 1, "页");
        this.queryParams.page++;
        this.getUserOrderList();
      }
    }
  }
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _from = __webpack_require__(225);

var _from2 = _interopRequireDefault(_from);

var _txycos = __webpack_require__(91);

var _user = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'woyaofankui',
  data: function data() {
    return {
      form: {
        content: '',
        imgContent: ''
      },
      imagesList: [],
      cosClient: null,
      cosConfig: {
        bucket: 'unishow-live-1383640469',
        region: 'ap-hongkong'
      }
    };
  },

  computed: {
    canSubmit: function canSubmit() {
      return this.form.content.trim() !== '' || this.imagesList.some(function (img) {
        return img.status === 'success';
      });
    }
  },
  created: function created() {
    this.cosClient = (0, _txycos.client)();
    if (!this.cosClient) {
      this.$message.error('腾讯云 COS 客户端初始化失败');
    }
  },

  methods: {
    handleUploadClick: function handleUploadClick() {
      this.$refs.fileInput.click();
    },
    handleFileChange: function handleFileChange(event) {
      var _this = this;

      var fileList = event.target.files;
      if (!fileList.length) return;

      if (this.imagesList.length + fileList.length > 4) {
        this.$message.warning('最多只能上传4张图片');
        return;
      }

      (0, _from2.default)(fileList).forEach(function (file) {
        var imageItem = {
          id: Date.now() + Math.random(),
          file: file,
          url: null,
          status: 'uploading'
        };
        _this.imagesList.push(imageItem);
        _this.uploadToCOS(imageItem);
      });

      event.target.value = '';
    },
    uploadToCOS: function uploadToCOS(imageItem) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var file, id, index, fileExt, fileName, imageUrl, _index, _index2;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = imageItem.file, id = imageItem.id;

                if (!(!_this2.cosClient || typeof _this2.cosClient.putObject !== 'function')) {
                  _context.next = 6;
                  break;
                }

                _this2.$message.error('COS 客户端异常，无法上传图片');
                index = _this2.imagesList.findIndex(function (item) {
                  return item.id === id;
                });

                if (index !== -1) {
                  _this2.$set(_this2.imagesList, index, (0, _extends3.default)({}, _this2.imagesList[index], {
                    status: 'error'
                  }));
                }
                return _context.abrupt('return');

              case 6:
                _context.prev = 6;
                fileExt = file.name.split('.').pop() || 'png';
                fileName = 'webStorage/web_/' + Date.now() + '_' + Math.random().toString(36).substr(2, 10) + '.' + fileExt;
                _context.next = 11;
                return new _promise2.default(function (resolve, reject) {
                  _this2.cosClient.putObject({
                    Bucket: _this2.cosClient.options.bucket,
                    Region: _this2.cosClient.options.region,
                    Key: fileName,
                    Body: file,
                    ContentType: file.type || 'image/jpeg',
                    onProgress: function onProgress(progressData) {
                      console.log('\u6587\u4EF6 ' + file.name + ' \u4E0A\u4F20\u8FDB\u5EA6\uFF1A', (progressData.percent * 100).toFixed(2) + '%');
                    }
                  }, function (err, result) {
                    if (err) {
                      reject(err);
                    } else {
                      resolve(result);
                    }
                  });
                });

              case 11:
                imageUrl = 'https://' + _this2.cosClient.options.bucket + '.cos.' + _this2.cosClient.options.region + '.myqcloud.com/' + fileName;
                _index = _this2.imagesList.findIndex(function (item) {
                  return item.id === id;
                });

                if (_index !== -1) {
                  _this2.$set(_this2.imagesList, _index, (0, _extends3.default)({}, _this2.imagesList[_index], {
                    url: imageUrl,
                    status: 'success'
                  }));
                }
                _context.next = 22;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](6);

                console.error('\u6587\u4EF6 ' + file.name + ' \u4E0A\u4F20\u5931\u8D25:', _context.t0);
                _index2 = _this2.imagesList.findIndex(function (item) {
                  return item.id === id;
                });

                if (_index2 !== -1) {
                  _this2.$set(_this2.imagesList, _index2, (0, _extends3.default)({}, _this2.imagesList[_index2], {
                    status: 'error'
                  }));
                }
                _this2.$message.error('\u56FE\u7247 ' + file.name + ' \u4E0A\u4F20\u5931\u8D25');

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 16]]);
      }))();
    },
    delImage: function delImage(index) {
      this.imagesList.splice(index, 1);
    },
    submitFeedbackForm: function submitFeedbackForm() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var imageUrls, res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                imageUrls = _this3.imagesList.filter(function (img) {
                  return img.status === 'success';
                }).map(function (img) {
                  return img.url;
                }).join(',');

                _this3.form.imgContent = imageUrls;
                _context2.next = 4;
                return (0, _user.submitFeedback)(_this3.form);

              case 4:
                res = _context2.sent;

                _this3.$emit('closeFk');
                _this3.$message.success(res.msg);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _user = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default
	},
	data: function data() {
		return {
			show: false,
			queryParams: {
				page: 1,
				size: 20
			},
			list: [],
			hasMore: true,
			isLoading: false,
			isKong: false
		};
	},
	mounted: function mounted() {
		this.getBalanceBillList();
	},

	methods: {
		getBalanceBillList: function getBalanceBillList() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var response, newList, totalPages;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(_this.isLoading || !_this.hasMore)) {
									_context.next = 2;
									break;
								}

								return _context.abrupt("return");

							case 2:
								_context.prev = 2;

								_this.isLoading = true;

								_context.next = 6;
								return (0, _user.getBalanceBillList)(_this.queryParams);

							case 6:
								response = _context.sent;
								newList = response.rows || [];


								if (_this.queryParams.page === 1) {
									_this.list = newList;
								} else {
									_this.list = [].concat((0, _toConsumableArray3.default)(_this.list), (0, _toConsumableArray3.default)(newList));
								}

								totalPages = Math.ceil((response.total || 0) / _this.queryParams.size);

								_this.hasMore = _this.queryParams.page < totalPages;
								if (response.total == 0) {
									_this.isKong = true;
								} else {
									_this.isKong = false;
								}
								_context.next = 17;
								break;

							case 14:
								_context.prev = 14;
								_context.t0 = _context["catch"](2);

								console.error("获取直播列表失败:", _context.t0);

							case 17:
								_context.prev = 17;

								_this.isLoading = false;
								return _context.finish(17);

							case 20:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this, [[2, 14, 17, 20]]);
			}))();
		},
		handleScroll: function handleScroll() {
			if (this.isLoading || !this.hasMore) {
				return;
			}

			var container = this.$refs.listContainer;

			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;

			if (isAtBottom) {
				console.log("滚动到底部，触发加载更多");
				this.queryParams.page++;
				this.getBalanceBillList();
			}
		},
		showXfmx: function showXfmx() {
			this.show = true;
		},
		handleClose: function handleClose() {
			this.show = false;
		}
	}
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

var _qrcode = __webpack_require__(88);

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			show: false,
			data: '',
			androidUrl: '',
			iosUrl: ''
		};
	},

	watch: {
		androidUrl: function androidUrl(val) {
			var _this = this;

			if (val) {
				this.$nextTick(function () {
					_this.generateAndroidQRCode();
				});
			}
		},
		iosUrl: function iosUrl(val) {
			var _this2 = this;

			if (val) {
				this.$nextTick(function () {
					_this2.generateIosQRCode();
				});
			}
		}
	},
	methods: {
		showModel: function showModel(data) {
			this.show = true;
			this.androidUrl = '';
			this.iosUrl = '';
			this.getAppDownloadConfig();
		},
		getAppDownloadConfig: function getAppDownloadConfig() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return (0, _user.getAppDownloadConfig)();

							case 3:
								res = _context.sent;

								_this3.data = res.data;
								_this3.resolveDownloadUrl();
								_this3.$nextTick(function () {
									if (_this3.androidUrl) _this3.generateAndroidQRCode();
									if (_this3.iosUrl) _this3.generateIosQRCode();
								});
								_context.next = 12;
								break;

							case 9:
								_context.prev = 9;
								_context.t0 = _context['catch'](0);

								console.error('获取下载配置失败:', _context.t0);

							case 12:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3, [[0, 9]]);
			}))();
		},
		resolveDownloadUrl: function resolveDownloadUrl() {
			if (!this.data) return;
			var isInternational = this.isInternationalVersion();
			if (isInternational) {
				this.androidUrl = this.data.androidDownloadUrl || '';
				this.iosUrl = this.data.iosDownloadUrl || '';
			} else {
				this.androidUrl = this.data.androidUrl || '';
				this.iosUrl = this.data.iosUrl || '';
			}
		},
		isInternationalVersion: function isInternationalVersion() {
			var lang = localStorage.getItem('language') || 'tw';
			var internationalLangs = ['en', 'ja', 'ko'];
			return internationalLangs.includes(lang);
		},
		generateAndroidQRCode: function generateAndroidQRCode() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (_this4.$refs.androidCanvas) {
									_context2.next = 2;
									break;
								}

								return _context2.abrupt('return');

							case 2:
								_context2.prev = 2;
								_context2.next = 5;
								return _qrcode2.default.toCanvas(_this4.$refs.androidCanvas, _this4.androidUrl, {
									width: 220,
									margin: 2,
									color: {
										dark: '#000000',
										light: '#ffffff'
									}
								});

							case 5:
								_context2.next = 10;
								break;

							case 7:
								_context2.prev = 7;
								_context2.t0 = _context2['catch'](2);

								console.error('生成安卓二维码失败:', _context2.t0);

							case 10:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this4, [[2, 7]]);
			}))();
		},
		generateIosQRCode: function generateIosQRCode() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (_this5.$refs.iosCanvas) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt('return');

							case 2:
								_context3.prev = 2;
								_context3.next = 5;
								return _qrcode2.default.toCanvas(_this5.$refs.iosCanvas, _this5.iosUrl, {
									width: 220,
									margin: 2,
									color: {
										dark: '#000000',
										light: '#ffffff'
									}
								});

							case 5:
								_context3.next = 10;
								break;

							case 7:
								_context3.prev = 7;
								_context3.t0 = _context3['catch'](2);

								console.error('生成iOS二维码失败:', _context3.t0);

							case 10:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this5, [[2, 7]]);
			}))();
		}
	}
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(61);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(467);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _values = __webpack_require__(468);

var _values2 = _interopRequireDefault(_values);

var _zhibo = __webpack_require__(7);

var _zhubo = __webpack_require__(90);

var _qrcode = __webpack_require__(88);

var _qrcode2 = _interopRequireDefault(_qrcode);

var _xietongzhubo = __webpack_require__(950);

var _xietongzhubo2 = _interopRequireDefault(_xietongzhubo);

var _zhuboplayer = __webpack_require__(956);

var _zhuboplayer2 = _interopRequireDefault(_zhuboplayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'XietongZhibo',
	components: {
		xietongzhubo: _xietongzhubo2.default,
		zhuboplayer: _zhuboplayer2.default
	},
	props: {
		isHost: {
			type: Boolean,
			default: false
		},
		roomData: {
			type: Object,
			default: null
		}
	},
	data: function data() {
		return {
			localData: this.roomData || null,
			helpLiveUserList: [],
			activeIndex: 0,
			showPanel: false,
			showInvite: false,
			showLimitPanel: false,
			showShareInvite: false,
			showCohostList: false,
			showManagePanel: false,
			showControlModal: false,
			showJoinLive: false,
			joinKey: '',
			controlForm: {
				helpLiveConfigId: null,
				isPermitCamera: 1,
				isPermitMicrophone: 1,
				isPermitSpeech: 1
			},
			managingCohost: {},
			maxCohost: 12,
			tempMaxCohost: 12,
			limitOptions: [8, 12, 16],
			zbForm: {
				isPermitCamera: 1,
				isPermitMicrophone: 1,
				isPermitSpeech: 1,
				isSynLiveTime: 1,
				keyEndTime: '',
				keyStartTime: '',
				liveId: this.$route.query.liveId,
				peopleNumber: 12
			},
			liveConfig: '',
			liveId: this.$route.query.liveId,
			players: {},
			selfPusher: null,
			licenseUrl: 'https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license',
			helpUserList: [],
			helpKeyInfo: { helpKey: '' },
			helpKey: this.$route.query.helpKey,
			isAgentJoin: true
		};
	},

	computed: {
		mainScreenUser: function mainScreenUser() {
			if (this.localData && this.localData.helpLiveUserList && this.localData.helpLiveUserList.length > 0) {
				return this.localData.helpLiveUserList.find(function (item) {
					return item.isMainScreen === 1;
				});
			}
			return null;
		},
		isJoinedHelpLive: function isJoinedHelpLive() {
			if (!this.$store.state.userId) return false;
			var currentUserId = JSON.parse(this.$store.state.userId);
			if (this.localData && this.localData.helpLiveUserList) {
				return this.localData.helpLiveUserList.some(function (item) {
					return item.userInfo && item.userInfo.userId === currentUserId;
				});
			}
			if (this.helpUserList.length > 0) {
				return this.helpUserList.some(function (item) {
					return item.userInfo && item.userInfo.userId === currentUserId;
				});
			}
			return false;
		},
		hostUser: function hostUser() {
			if (this.localData && this.localData.chatRoomDetails) {
				return {
					pullUrl: this.localData.chatRoomDetails.pullUrl,
					info: this.localData.chatRoomDetails
				};
			}
			return null;
		},
		isSelfMainScreen: function isSelfMainScreen() {
			if (!this.$store.state.userId || !this.mainScreenUser) return false;
			var currentUserId = JSON.parse(this.$store.state.userId);
			return this.mainScreenUser.userId === currentUserId;
		}
	},
	watch: {
		helpLiveUserList: {
			handler: function handler(newList, oldList) {
				console.log('helpLiveUserList变化:', newList ? newList.length : 0, '->', oldList ? oldList.length : 0);
			},

			deep: true
		},
		'localData.helpLiveUserList': {
			handler: function handler(newList, oldList) {
				console.log('localData.helpLiveUserList变化:', newList ? newList.length : 0, '->', oldList ? oldList.length : 0);
			},

			deep: true
		}
	},
	mounted: function mounted() {
		this.getChatRoomDetails();
	},
	beforeDestroy: function beforeDestroy() {
		if (this._retryTimers) {
			(0, _values2.default)(this._retryTimers).forEach(function (timer) {
				return clearInterval(timer);
			});
			this._retryTimers = {};
		}

		this.destroyPlayers();

		if (this.selfPusher) {
			try {
				this.selfPusher.stopCamera();
				this.selfPusher.stopMicrophone();
				this.selfPusher.stopPush();
				this.selfPusher.destroy();
			} catch (error) {
				console.error('销毁推流失败:', error);
			}
			this.selfPusher = null;
		}
	},

	methods: {
		getChatRoomDetails: function getChatRoomDetails() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res, currentUserId, isAlreadyJoined;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this.liveId });

							case 2:
								res = _context.sent;

								_this.localData = res.data;
								if (_this.isHost) {
									_this.getAppHelpLiveConfig();
								}
								if (_this.localData.isOpenHelp == 1) {
									if (!_this.isHost && _this.localData.helpLiveUserList) {
										_this.helpLiveUserList = _this.localData.helpLiveUserList;
										if (_this.helpKey) {
											currentUserId = _this.$store.state.userId ? JSON.parse(_this.$store.state.userId) : null;
											isAlreadyJoined = _this.helpLiveUserList.some(function (item) {
												return item.userInfo && item.userInfo.userId === currentUserId;
											});

											if (!isAlreadyJoined && _this.isAgentJoin) {
												_this.handleJoinLive();
											}
										}
									}
									_this.$nextTick(function () {
										_this.destroyPlayers();
										setTimeout(function () {
											_this.initPlayers();
										}, 200);
									});
								}

							case 6:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		initPlayers: function initPlayers() {
			var _this2 = this;

			var userList = this.isHost ? this.localData.helpLiveUserList : this.helpLiveUserList;
			if (!userList || userList.length === 0) {
				console.warn('助播列表为空');
				return;
			}

			console.log('初始化播放器列表，用户列表:', userList.length);

			var currentUserId = this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
			userList.forEach(function (item) {
				console.log('处理用户:', item.userId, 'cameraStatus:', item.cameraStatus, 'isMainScreen:', item.isMainScreen, 'pullUrl:', !!item.pullUrl);

				if (currentUserId && item.userId == currentUserId) {
					if (item.cameraStatus !== 0) {
						_this2.initSelfPusher(item);
					} else {
						if (_this2.selfPusher) {
							try {
								_this2.selfPusher.stopCamera();
							} catch (e) {
								console.warn('停止摄像头失败:', e);
							}
						}
					}
				} else if (item.pullUrl && item.isMainScreen !== 1 && item.cameraStatus !== 0) {
					_this2.initPlayer(item);
				}
			});
		},
		isSelfCohost: function isSelfCohost(item) {
			var currentUserId = this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
			return currentUserId && item.userId == currentUserId;
		},
		initSelfPusher: function initSelfPusher(item) {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var pusherId, videoContainer, webrtcUrl;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								pusherId = 'pusher-' + item.userId;
								videoContainer = document.getElementById(pusherId);

								if (videoContainer) {
									_context2.next = 6;
									break;
								}

								console.warn('推流容器不存在，延迟重试');
								setTimeout(function () {
									_this3.initSelfPusher(item);
								}, 100);
								return _context2.abrupt("return");

							case 6:
								_context2.prev = 6;

								if (!_this3.selfPusher) {
									_context2.next = 18;
									break;
								}

								_context2.prev = 8;
								_context2.next = 11;
								return _this3.selfPusher.startCamera();

							case 11:
								console.log('协同助播摄像头重新启动成功');
								return _context2.abrupt("return");

							case 15:
								_context2.prev = 15;
								_context2.t0 = _context2["catch"](8);

								console.warn('重新启动摄像头失败，尝试重新初始化:', _context2.t0);

							case 18:
								_this3.selfPusher = new TXLivePusher();
								_this3.selfPusher.setRenderView(pusherId);
								_this3.selfPusher.videoView.muted = true;
								if (_this3.selfPusher.videoView) {
									_this3.selfPusher.videoView.style.width = '100%';
									_this3.selfPusher.videoView.style.height = '100%';
									_this3.selfPusher.videoView.style.objectFit = 'cover';
								}
								_this3.selfPusher.setVideoQuality('720p');
								_this3.selfPusher.setAudioQuality('standard');
								_this3.selfPusher.setProperty('setVideoFPS', 25);

								_this3.selfPusher.setObserver({
									onPushStatusUpdate: function onPushStatusUpdate(code, message) {
										console.log('推流状态更新:', code, message);
										if (code === 1001) {
											_this3.isPushing = false;
										} else if (code === 1002) {
											_this3.isPushing = true;
											console.log('推流真正成功了');
										} else if (code === -1307) {
											_this3.isPushing = false;
											console.error('推流连接断开');
										}
										if (code == 2) {
											_this3.sendRefreshMsg();
										}
									},
									onPushError: function onPushError(code, message) {
										console.error('推流错误:', code, message);
										_this3.isPushing = false;
									}
								});

								_context2.next = 28;
								return _this3.selfPusher.startCamera();

							case 28:
								_context2.next = 30;
								return _this3.selfPusher.startMicrophone();

							case 30:
								console.log('协同助播摄像头和麦克风启动成功');

								if (!item.pushUrl) {
									_context2.next = 36;
									break;
								}

								webrtcUrl = item.pushUrl.replace(/^rtmp:\/\//, 'webrtc://');
								_context2.next = 35;
								return _this3.selfPusher.startPush(webrtcUrl);

							case 35:
								console.log('协同助播推流成功');

							case 36:
								_context2.next = 41;
								break;

							case 38:
								_context2.prev = 38;
								_context2.t1 = _context2["catch"](6);

								console.error('协同助播推流失败:', _context2.t1);

							case 41:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this3, [[6, 38], [8, 15]]);
			}))();
		},
		sendRefreshMsg: function sendRefreshMsg() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return (0, _zhibo.sendRefreshMsg)({ liveId: _this4.liveId });

							case 2:
								res = _context3.sent;

							case 3:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this4);
			}))();
		},
		initPlayer: function initPlayer(item) {
			var _this5 = this;

			var playerId = 'player-' + item.userId;
			var videoContainer = document.getElementById(playerId);
			if (!videoContainer) {
				console.warn('播放器容器不存在:', playerId);
				return;
			}

			if (this['_retrying_' + item.userId]) {
				console.log('助播', item.userId, '正在重连中，跳过初始化');
				return;
			}

			if (this.players[item.userId]) {
				console.log('助播', item.userId, '播放器已存在，先销毁再重新初始化');
				this.destroySinglePlayer(item.userId);
			}

			if (!item.pullUrl) {
				console.warn('助播', item.userId, '没有拉流地址');
				return;
			}

			try {
				var videoEl = document.createElement('video');
				videoEl.id = 'tc-' + playerId;
				videoEl.preload = 'auto';
				videoEl.style.width = '100%';
				videoEl.style.height = '100%';
				videoEl.style.objectFit = 'cover';
				videoEl.style.background = 'transparent';
				videoEl.setAttribute('playsinline', true);
				videoEl.setAttribute('webkit-playsinline', true);
				videoEl.setAttribute('x5-playsinline', true);
				videoContainer.appendChild(videoEl);

				console.log('创建视频元素:', videoEl.id, '拉流地址:', item.pullUrl);

				var player = TCPlayer('tc-' + playerId, {
					src: item.pullUrl,
					licenseUrl: this.licenseUrl,
					autoplay: true,
					controls: false,
					playsinline: true,
					allowFullScreen: false,
					playbackRate: [1],
					webrtcConfig: {
						connectRetryCount: 999999
					},
					errorDisplay: false,
					posterImage: false,
					bigPlayButton: false,
					width: '100%',
					height: '100%'
				});

				console.log('TCPlayer初始化成功:', item.userId);

				var playerVideoElement = videoContainer.querySelector('video');
				if (playerVideoElement) {
					playerVideoElement.style.position = 'absolute';
					playerVideoElement.style.top = '0';
					playerVideoElement.style.left = '0';
					playerVideoElement.style.width = '100%';
					playerVideoElement.style.height = '100%';
					playerVideoElement.style.background = 'transparent';
					playerVideoElement.style.objectFit = 'cover';
				}

				player.muted(item.isPermitMicrophone !== 1);

				this.players[item.userId] = player;

				player.on('play', function () {
					console.log('助播', item.userId, '开始播放');
				});

				player.on('playing', function () {
					console.log('助播', item.userId, '正在播放（有画面）');
				});

				player.on('loadedmetadata', function () {
					console.log('助播', item.userId, '元数据加载完成');
				});

				player.on('loadeddata', function () {
					console.log('助播', item.userId, '第一帧数据加载完成');
				});

				player.on('timeupdate', function () {});

				player.on('webrtcevent', function (e) {
					console.log('助播', item.userId, 'WebRTC事件:', e.data);
				});

				player.on('error', function (e) {
					console.error('助播', item.userId, '播放错误:', e);

					_this5.handlePlayerError(item);
				});

				this.playPlayerVideo(item.userId, item.pullUrl);
			} catch (error) {
				console.error('初始化播放器失败:', item.userId, error);
			}
		},
		handlePlayerError: function handlePlayerError(item) {
			var _this6 = this;

			var userId = item.userId;

			if (this['_retrying_' + userId]) return;
			this['_retrying_' + userId] = true;

			this.destroySinglePlayer(userId);

			var retryCount = 0;
			var maxRetry = 60;
			var retryTimer = setInterval((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var res, userList, updatedItem;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								retryCount++;

								if (!(retryCount > maxRetry)) {
									_context4.next = 6;
									break;
								}

								clearInterval(retryTimer);
								_this6['_retrying_' + userId] = false;
								console.warn('助播', userId, '重连超过最大次数，停止重试');
								return _context4.abrupt("return");

							case 6:
								_context4.prev = 6;
								_context4.next = 9;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this6.liveId });

							case 9:
								res = _context4.sent;
								userList = res.data.helpLiveUserList || [];
								updatedItem = userList.find(function (u) {
									return u.userId == userId;
								});


								if (updatedItem && updatedItem.pullUrl && updatedItem.cameraStatus !== 0) {
									clearInterval(retryTimer);
									_this6['_retrying_' + userId] = false;
									console.log('助播', userId, '重连中，第', retryCount, '次尝试，发现有效拉流地址');

									_this6.destroySinglePlayer(userId);
									_this6.$nextTick(function () {
										setTimeout(function () {
											_this6.initPlayer(updatedItem);
										}, 500);
									});
								} else {
									console.log('助播', userId, '重连中，第', retryCount, '次尝试，暂无有效流');
								}
								_context4.next = 18;
								break;

							case 15:
								_context4.prev = 15;
								_context4.t0 = _context4["catch"](6);

								console.warn('助播', userId, '重连查询失败:', _context4.t0);

							case 18:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this6, [[6, 15]]);
			})), 5000);

			if (!this._retryTimers) this._retryTimers = {};
			this._retryTimers[userId] = retryTimer;
		},
		destroySinglePlayer: function destroySinglePlayer(userId) {
			var player = this.players[userId];
			if (player) {
				try {
					player.pause();
					player.src('');
					player.dispose();
				} catch (error) {
					console.warn('销毁播放器失败:', userId, error);
				}
				delete this.players[userId];
			}

			var container = document.getElementById('player-' + userId);
			if (container) {
				container.innerHTML = '';
			}
		},
		playPlayerVideo: function playPlayerVideo(userId, videoUrl) {
			var player = this.players[userId];
			if (!player) {
				console.warn('播放器未就绪:', userId);
				return;
			}

			if (player.currentSrc && player.currentSrc() !== videoUrl) {
				player.src(videoUrl);
			}

			try {
				player.play();
				console.log('播放器播放成功:', userId);
			} catch (e) {
				console.warn('自动播放失败:', userId, e);
			}
		},
		destroyPlayers: function destroyPlayers() {
			var _this7 = this;

			(0, _keys2.default)(this.players).forEach(function (userId) {
				var player = _this7.players[userId];
				if (player) {
					try {
						player.pause();
						player.src('');
						player.dispose();
					} catch (error) {
						console.error('销毁播放器失败:', error);
					}
				}
			});
			this.players = {};
		},
		toggleMicrophone: function toggleMicrophone(item) {
			var _this8 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var newStatus, res, player;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								if (item.helpId) {
									_context5.next = 2;
									break;
								}

								return _context5.abrupt("return");

							case 2:
								if (_this8.isHost) {
									_context5.next = 4;
									break;
								}

								return _context5.abrupt("return");

							case 4:
								newStatus = item.isPermitMicrophone === 1 ? 0 : 1;
								_context5.next = 7;
								return (0, _zhubo.updateHelpLiveUser)({
									helpId: item.helpId,
									isPermitMicrophone: newStatus
								});

							case 7:
								res = _context5.sent;

								_this8.$message.success(res.msg);
								item.isPermitMicrophone = newStatus;
								player = _this8.players[item.userId];

								if (player) {
									player.muted(newStatus !== 1);
								}

							case 12:
							case "end":
								return _context5.stop();
						}
					}
				}, _callee5, _this8);
			}))();
		},
		showModel: function showModel() {
			if (this.localData.isOpenHelp == 0) {
				this.showInvite = true;
			}
			if (this.localData.isOpenHelp == 1) {
				this.showPanel = true;
			}
		},
		handleGenerateKey: function handleGenerateKey() {
			var _this9 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				var res;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.next = 2;
								return (0, _zhubo.createHelpLive)(_this9.zbForm);

							case 2:
								res = _context6.sent;

								_this9.$message.success(res.msg);
								_this9.showInvite = false;
								_this9.getChatRoomDetails();
								if (_this9.isHost) {
									_this9.getAppHelpLiveConfig();
								}

							case 7:
							case "end":
								return _context6.stop();
						}
					}
				}, _callee6, _this9);
			}))();
		},
		getAppHelpLiveConfig: function getAppHelpLiveConfig() {
			var _this10 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
				var res;
				return _regenerator2.default.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								if (_this10.isHost) {
									_context7.next = 2;
									break;
								}

								return _context7.abrupt("return");

							case 2:
								_context7.next = 4;
								return (0, _zhubo.getAppHelpLiveConfig)({ liveId: _this10.liveId });

							case 4:
								res = _context7.sent;

								_this10.liveConfig = res.data;
								console.log(_this10.liveConfig);

								if (_this10.liveConfig) {
									_this10.controlForm.helpLiveConfigId = _this10.liveConfig.helpLiveConfigId;
									_this10.controlForm.isPermitCamera = _this10.liveConfig.isPermitCamera;
									_this10.controlForm.isPermitMicrophone = _this10.liveConfig.isPermitMicrophone;
									_this10.controlForm.isPermitSpeech = _this10.liveConfig.isPermitSpeech;
								}

							case 8:
							case "end":
								return _context7.stop();
						}
					}
				}, _callee7, _this10);
			}))();
		},
		handleInvite: function handleInvite() {
			var _this11 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
				return _regenerator2.default.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								_this11.showShareInvite = true;
								_this11.$nextTick(function () {
									_this11.generateQRCode();
								});

							case 2:
							case "end":
								return _context8.stop();
						}
					}
				}, _callee8, _this11);
			}))();
		},
		generateQRCode: function generateQRCode() {
			if (!this.liveConfig.shareUrl) return;
			var canvas = this.$refs.qrcodeCanvas;
			if (canvas) {
				_qrcode2.default.toCanvas(canvas, this.liveConfig.shareUrl, {
					width: 160,
					margin: 2,
					color: {
						dark: '#000000',
						light: '#ffffff'
					}
				}, function (error) {
					if (error) {
						console.error(error);
					}
				});
			}
		},
		handleOpenList: function handleOpenList() {
			var _this12 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
				var res;
				return _regenerator2.default.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								_context9.next = 2;
								return (0, _zhubo.getHelpUserList)({ liveId: _this12.liveId });

							case 2:
								res = _context9.sent;

								_this12.helpUserList = res.data;
								if (res.data.length > 0) {
									_this12.showCohostList = true;
								} else {
									_this12.$message.warning(_this12.$t('all.zanweiyourenjiaruxietongzhibo'));
								}

							case 5:
							case "end":
								return _context9.stop();
						}
					}
				}, _callee9, _this12);
			}))();
		},
		handleSelect: function handleSelect(index) {
			this.activeIndex = index;
			this.showCohostList = true;
			this.$emit('select', index);
		},
		handleControl: function handleControl() {
			var _this13 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
				return _regenerator2.default.wrap(function _callee10$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								_this13.showPanel = false;

								if (!_this13.isHost) {
									_context10.next = 4;
									break;
								}

								_context10.next = 4;
								return _this13.getAppHelpLiveConfig();

							case 4:
								setTimeout(function (v) {
									_this13.showControlModal = true;
								}, 200);

							case 5:
							case "end":
								return _context10.stop();
						}
					}
				}, _callee10, _this13);
			}))();
		},
		handleKick: function handleKick() {
			var _this14 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
				var res;
				return _regenerator2.default.wrap(function _callee11$(_context11) {
					while (1) {
						switch (_context11.prev = _context11.next) {
							case 0:
								_context11.next = 2;
								return (0, _zhubo.kickOutHelp)({ helpId: _this14.localData.helpLiveUserList[_this14.activeIndex].helpId });

							case 2:
								res = _context11.sent;

								_this14.$message.success(res.msg);
								_this14.localData.helpLiveUserList.splice(_this14.activeIndex, 1);

							case 5:
							case "end":
								return _context11.stop();
						}
					}
				}, _callee11, _this14);
			}))();
		},
		handleOpenLimit: function handleOpenLimit() {
			this.tempMaxCohost = this.maxCohost;
			this.showLimitPanel = !this.showLimitPanel;
		},
		handleSaveLimit: function handleSaveLimit() {
			this.maxCohost = this.tempMaxCohost;
			this.zbForm.peopleNumber = this.maxCohost;
			this.showLimitPanel = false;
		},
		handleCopyLink: function handleCopyLink() {
			navigator.clipboard.writeText(this.liveConfig.shareUrl);
			this.$message.success(this.$t('all.fuzhichenggong'));
		},
		handleSaveQr: function handleSaveQr() {
			var canvas = this.$refs.qrcodeCanvas;
			if (!canvas) {
				this.$message.info('二维码不存在');
				return;
			}
			var link = document.createElement('a');
			link.download = 'qrcode.png';
			link.href = canvas.toDataURL('image/png');
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			this.$message.success('二维码保存成功');
		},
		handleCopyInviteLink: function handleCopyInviteLink() {
			navigator.clipboard.writeText(this.localData.shareUrl);
			this.$message.success(this.$t('all.fuzhichenggong'));
		},
		handleManageCohost: function handleManageCohost(item, index) {
			var _this15 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
				var res, sort;
				return _regenerator2.default.wrap(function _callee12$(_context12) {
					while (1) {
						switch (_context12.prev = _context12.next) {
							case 0:
								_context12.next = 2;
								return (0, _zhubo.getHelpUserInfo)({ helpId: item.helpId });

							case 2:
								res = _context12.sent;

								_this15.managingCohost = res.data;
								sort = index + 1;

								_this15.managingCohost.sort = sort < 10 ? '0' + sort : sort;
								_this15.showManagePanel = true;

							case 7:
							case "end":
								return _context12.stop();
						}
					}
				}, _callee12, _this15);
			}))();
		},
		handleUpdatePerm: function handleUpdatePerm(field) {
			var _this16 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
				var res;
				return _regenerator2.default.wrap(function _callee13$(_context13) {
					while (1) {
						switch (_context13.prev = _context13.next) {
							case 0:
								_this16.managingCohost[field] = _this16.managingCohost[field] === 1 ? 0 : 1;
								_context13.next = 3;
								return (0, _zhubo.updateHelpLiveUser)((0, _defineProperty3.default)({
									helpId: _this16.managingCohost.helpId
								}, field, _this16.managingCohost[field]));

							case 3:
								res = _context13.sent;

								_this16.$message.success(res.msg);
								_context13.next = 7;
								return _this16.refreshHelpUserList();

							case 7:
							case "end":
								return _context13.stop();
						}
					}
				}, _callee13, _this16);
			}))();
		},
		refreshHelpUserList: function refreshHelpUserList() {
			var _this17 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
				var userRes, roomRes, updated;
				return _regenerator2.default.wrap(function _callee14$(_context14) {
					while (1) {
						switch (_context14.prev = _context14.next) {
							case 0:
								_context14.next = 2;
								return (0, _zhubo.getHelpUserList)({ liveId: _this17.liveId });

							case 2:
								userRes = _context14.sent;

								if (userRes.data && userRes.data.length) {
									_this17.helpUserList = userRes.data;
								}
								_context14.next = 6;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this17.liveId });

							case 6:
								roomRes = _context14.sent;

								_this17.localData = roomRes.data;
								_this17.$nextTick(function () {
									_this17.destroyPlayers();
									_this17.initPlayers();
								});
								if (_this17.managingCohost && _this17.managingCohost.helpId) {
									updated = _this17.localData.helpLiveUserList.find(function (item) {
										return item.helpId === _this17.managingCohost.helpId;
									});

									if (updated) {
										_this17.managingCohost = updated;
									}
								}

							case 10:
							case "end":
								return _context14.stop();
						}
					}
				}, _callee14, _this17);
			}))();
		},
		handleSetMain: function handleSetMain() {
			var _this18 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
				var newStatus, res;
				return _regenerator2.default.wrap(function _callee15$(_context15) {
					while (1) {
						switch (_context15.prev = _context15.next) {
							case 0:
								newStatus = _this18.managingCohost.isMainScreen === 1 ? 0 : 1;
								_context15.prev = 1;
								_context15.next = 4;
								return (0, _zhubo.updateHelpLiveUser)({
									helpId: _this18.managingCohost.helpId,
									isMainScreen: newStatus
								});

							case 4:
								res = _context15.sent;

								_this18.$message.success(res.msg);
								_this18.managingCohost.isMainScreen = newStatus;
								_this18.showManagePanel = false;
								_this18.showCohostList = false;
								_context15.next = 11;
								return _this18.refreshHelpUserList();

							case 11:
								_this18.$emit('mainScreenChange', newStatus === 1 ? _this18.managingCohost : null);
								_context15.next = 17;
								break;

							case 14:
								_context15.prev = 14;
								_context15.t0 = _context15["catch"](1);

								console.error('设置主画面失败:', _context15.t0);

							case 17:
							case "end":
								return _context15.stop();
						}
					}
				}, _callee15, _this18, [[1, 14]]);
			}))();
		},
		handleKickCohost: function handleKickCohost() {
			var _this19 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16() {
				var res;
				return _regenerator2.default.wrap(function _callee16$(_context16) {
					while (1) {
						switch (_context16.prev = _context16.next) {
							case 0:
								_context16.next = 2;
								return (0, _zhubo.kickOutHelp)({ helpId: _this19.managingCohost.helpId });

							case 2:
								res = _context16.sent;

								_this19.$message.success(res.msg);
								_this19.showManagePanel = false;
								_context16.next = 7;
								return _this19.refreshHelpUserList();

							case 7:
							case "end":
								return _context16.stop();
						}
					}
				}, _callee16, _this19);
			}))();
		},
		handleApplyControl: function handleApplyControl() {
			var _this20 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
				var res;
				return _regenerator2.default.wrap(function _callee17$(_context17) {
					while (1) {
						switch (_context17.prev = _context17.next) {
							case 0:
								_context17.next = 2;
								return (0, _zhubo.updateHelpLiveConfig)(_this20.controlForm);

							case 2:
								res = _context17.sent;

								_this20.$message.success(res.msg);
								_this20.getChatRoomDetails();
								_this20.showControlModal = false;

							case 6:
							case "end":
								return _context17.stop();
						}
					}
				}, _callee17, _this20);
			}))();
		},
		handleJoinLive: function handleJoinLive() {
			var _this21 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
				var res;
				return _regenerator2.default.wrap(function _callee18$(_context18) {
					while (1) {
						switch (_context18.prev = _context18.next) {
							case 0:
								console.log(_this21.helpKey, 'helpKey');

								if (!_this21.helpKey) {
									_context18.next = 10;
									break;
								}

								_context18.next = 4;
								return (0, _zhubo.getHelpKeyInfo)({ liveId: _this21.liveId, helpKey: 'sXsXcfWsSiGW4dgn' });

							case 4:
								res = _context18.sent;

								_this21.helpKeyInfo = res.data;
								_this21.showJoinLive = true;
								_this21.joinKey = '';
								_context18.next = 11;
								break;

							case 10:
								_this21.showJoinLive = true;

							case 11:
							case "end":
								return _context18.stop();
						}
					}
				}, _callee18, _this21);
			}))();
		},
		handleSubmitJoin: function handleSubmitJoin() {
			var _this22 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19() {
				var hasPermission, res;
				return _regenerator2.default.wrap(function _callee19$(_context19) {
					while (1) {
						switch (_context19.prev = _context19.next) {
							case 0:
								if (_this22.helpKeyInfo.helpKey) {
									_context19.next = 3;
									break;
								}

								_this22.$message.warning(_this22.$t('all.qingshuruzhubojinyao'));
								return _context19.abrupt("return");

							case 3:
								_context19.prev = 3;
								_context19.next = 6;
								return _this22.checkMediaPermission();

							case 6:
								hasPermission = _context19.sent;

								if (hasPermission) {
									_context19.next = 9;
									break;
								}

								return _context19.abrupt("return");

							case 9:
								_context19.next = 11;
								return (0, _zhubo.joinHelpLive)({ helpKey: _this22.helpKeyInfo.helpKey });

							case 11:
								res = _context19.sent;

								_this22.$message.success(res.msg);
								_this22.showJoinLive = false;
								_context19.next = 16;
								return _this22.getChatRoomDetails();

							case 16:
								console.log('xietongzhibo: handleSubmitJoin success, data:', _this22.localData);
								console.log('xietongzhibo: isJoinedHelpLive:', _this22.isJoinedHelpLive);
								_this22.$emit('joinsuccess');
								_context19.next = 24;
								break;

							case 21:
								_context19.prev = 21;
								_context19.t0 = _context19["catch"](3);

								console.error('加入协同直播失败:', _context19.t0);

							case 24:
							case "end":
								return _context19.stop();
						}
					}
				}, _callee19, _this22, [[3, 21]]);
			}))();
		},
		handleExitHelp: function handleExitHelp() {
			var _this23 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20() {
				var currentUserId, helpInfo, res;
				return _regenerator2.default.wrap(function _callee20$(_context20) {
					while (1) {
						switch (_context20.prev = _context20.next) {
							case 0:
								currentUserId = JSON.parse(_this23.$store.state.userId);
								helpInfo = _this23.localData.helpLiveUserList.find(function (item) {
									return item.userInfo && item.userInfo.userId === currentUserId;
								});

								if (helpInfo) {
									_context20.next = 5;
									break;
								}

								console.error('找不到当前用户的助播信息');
								return _context20.abrupt("return");

							case 5:
								_context20.next = 7;
								return (0, _zhubo.exitHelp)({ helpId: helpInfo.helpId });

							case 7:
								res = _context20.sent;

								_this23.isAgentJoin = false;
								_this23.$message.success(res.msg);
								if (_this23.selfPusher) {
									try {
										_this23.selfPusher.stopCamera();
										_this23.selfPusher.stopMicrophone();
										_this23.selfPusher.stopPush();
										_this23.selfPusher.destroy();
									} catch (error) {
										console.error('销毁推流失败:', error);
									}
									_this23.selfPusher = null;
								}
								_context20.next = 13;
								return _this23.getChatRoomDetails();

							case 13:
							case "end":
								return _context20.stop();
						}
					}
				}, _callee20, _this23);
			}))();
		},
		checkMediaPermission: function checkMediaPermission() {
			var _this24 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21() {
				var stream;
				return _regenerator2.default.wrap(function _callee21$(_context21) {
					while (1) {
						switch (_context21.prev = _context21.next) {
							case 0:
								if (!(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)) {
									_context21.next = 3;
									break;
								}

								_this24.$message.warning(_this24.$t('all.browserbu支持'));
								return _context21.abrupt("return", false);

							case 3:
								_context21.prev = 3;
								_context21.next = 6;
								return navigator.mediaDevices.getUserMedia({
									video: true,
									audio: true
								});

							case 6:
								stream = _context21.sent;

								stream.getTracks().forEach(function (track) {
									return track.stop();
								});
								return _context21.abrupt("return", true);

							case 11:
								_context21.prev = 11;
								_context21.t0 = _context21["catch"](3);

								console.error('媒体权限获取失败:', _context21.t0);
								if (_context21.t0.name === 'NotAllowedError' || _context21.t0.name === 'PermissionDeniedError') {
									_this24.$message.warning(_this24.$t('all.qingkaiqi'));
								} else if (_context21.t0.name === 'NotFoundError' || _context21.t0.name === 'DevicesNotFoundError') {
									_this24.$message.warning(_this24.$t('all.meiyoushebei'));
								} else if (_context21.t0.name === 'NotReadableError' || _context21.t0.name === 'TrackStartError') {
									_this24.$message.warning(_this24.$t('all.shebeibeizhan'));
								} else {
									_this24.$message.warning(_this24.$t('all.quxianchengong'));
								}
								return _context21.abrupt("return", false);

							case 16:
							case "end":
								return _context21.stop();
						}
					}
				}, _callee21, _this24, [[3, 11]]);
			}))();
		}
	}
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _zhubo = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "xietongzhubo",
  props: {
    mainScreenData: {
      type: Object,
      default: null
    },
    liveId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      data: "",
      userInfo: { userInfo: {} },
      livePusher: null,
      audioEffectManager: null,
      videoEffectManager: null,
      cameraStreamId: null,
      videoContainerId: null,
      isDeviceReady: false,
      isPushing: false,
      isMirrored: false
    };
  },

  watch: {
    mainScreenData: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.userInfo = newVal;
          if (!this.isDeviceReady && newVal.cameraStatus !== 0) {
            this.getLivePusher();
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.videoContainerId = "xtzbzhubo-container-" + Date.now();
    if (this.mainScreenData) {
      this.userInfo = this.mainScreenData;
      if (this.mainScreenData.cameraStatus !== 0) {
        this.$nextTick(function () {
          _this.getLivePusher();
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.livePusher) {
      this.livePusher.stopCamera();
      this.livePusher.stopMicrophone();
      this.livePusher.stopPush();
      this.livePusher.destroy();
      this.livePusher = null;
    }
  },

  methods: {
    getLivePusher: function getLivePusher(data) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var quality;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                quality = data ? data : "720p";

                _this2.livePusher = new TXLivePusher();
                _this2.audioEffectManager = _this2.livePusher.getAudioEffectManager();
                _this2.videoEffectManager = _this2.livePusher.getVideoEffectManager();

                _this2.videoEffectManager.enableMixing(true);
                _this2.livePusher.setVideoQuality(quality);
                _this2.livePusher.setAudioQuality("standard");
                _this2.livePusher.setProperty("setVideoFPS", 25);
                _this2.livePusher.setRenderView(_this2.videoContainerId);
                if (_this2.livePusher.videoView) {
                  _this2.livePusher.videoView.muted = true;
                }

                _this2.livePusher.setObserver({
                  onPushStatusUpdate: function onPushStatusUpdate(code, message) {
                    console.log('推流状态更新:', code, message);
                    if (code === 1001) {
                      _this2.isPushing = false;
                    } else if (code === 1002) {
                      _this2.isPushing = true;
                      console.log('推流真正成功了');
                    } else if (code === -1307) {
                      _this2.isPushing = false;
                      console.error('推流连接断开');
                    }
                    if (code == 2) {
                      _this2.sendRefreshMsg();
                    }
                  },
                  onPushError: function onPushError(code, message) {
                    console.error('推流错误:', code, message);
                    _this2.isPushing = false;
                  }
                });

                _context.prev = 11;
                _context.next = 14;
                return _this2.livePusher.startCamera();

              case 14:
                _this2.cameraStreamId = _context.sent;
                _context.next = 17;
                return _this2.livePusher.startMicrophone();

              case 17:
                _this2.isDeviceReady = true;
                _context.next = 20;
                return _this2.getChatRoomDetails();

              case 20:
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](11);

                console.error("媒体设备启动失败:", _context.t0);
                _this2.isDeviceReady = false;

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[11, 22]]);
      }))();
    },
    sendRefreshMsg: function sendRefreshMsg() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _zhibo.sendRefreshMsg)({ liveId: _this3.liveId });

              case 2:
                res = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    startPush: function startPush() {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var pushUrl, newUrl;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.isDeviceReady) {
                  _context3.next = 3;
                  break;
                }

                console.warn("设备未就绪，推流取消");
                return _context3.abrupt("return");

              case 3:
                pushUrl = _this4.data.chatRoomDetails ? _this4.data.chatRoomDetails.pushUrl : "";

                if (pushUrl) {
                  _context3.next = 7;
                  break;
                }

                console.warn("推流地址为空");
                return _context3.abrupt("return");

              case 7:
                newUrl = pushUrl.replace(/^rtmp:\/\//, "webrtc://");
                _context3.prev = 8;
                _context3.next = 11;
                return _this4.livePusher.startPush(newUrl);

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](8);

                if (_context3.t0.message && _context3.t0.message.includes("stream is pushing")) {
                  console.warn("推流已在进行中");
                } else {
                  console.error("推流发起失败:", _context3.t0);
                  _this4.isPushing = false;
                }

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[8, 13]]);
      }))();
    },
    getChatRoomDetails: function getChatRoomDetails() {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var res;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this5.$route.query.liveId) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.next = 4;
                return (0, _zhibo.getChatRoomDetails)({ liveId: _this5.$route.query.liveId });

              case 4:
                res = _context4.sent;

                _this5.data = res.data;
                _this5.startPush();

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    toggleMicrophone: function toggleMicrophone() {
      var _this6 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var newStatus, res;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!_this6.userInfo || !_this6.userInfo.helpId)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                newStatus = _this6.userInfo.isPermitMicrophone === 1 ? 0 : 1;
                _context5.prev = 3;
                _context5.next = 6;
                return (0, _zhubo.updateHelpLiveUser)({
                  helpId: _this6.userInfo.helpId,
                  isPermitMicrophone: newStatus
                });

              case 6:
                res = _context5.sent;

                _this6.$message.success(res.msg);
                _this6.userInfo.isPermitMicrophone = newStatus;

                if (!_this6.livePusher) {
                  _context5.next = 16;
                  break;
                }

                if (!(newStatus === 1)) {
                  _context5.next = 15;
                  break;
                }

                _context5.next = 13;
                return _this6.livePusher.startMicrophone();

              case 13:
                _context5.next = 16;
                break;

              case 15:
                _this6.livePusher.stopMicrophone();

              case 16:
                _context5.next = 21;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5["catch"](3);

                console.error("切换麦克风失败:", _context5.t0);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[3, 18]]);
      }))();
    },
    toggleCamera: function toggleCamera(enable) {
      if (!this.livePusher) return;
      try {
        this.livePusher.setVideoMute(!enable);
      } catch (error) {
        console.error('切换摄像头失败:', error);
      }
    },
    toggleMic: function toggleMic(enable) {
      if (!this.livePusher) return;
      try {
        this.livePusher.setAudioMute(!enable);
      } catch (error) {
        console.error('切换麦克风失败:', error);
      }
    },
    toggleMirror: function toggleMirror(enable) {
      if (!this.videoEffectManager || !this.cameraStreamId) {
        console.error('视频效果管理器或流ID不可用');
        return;
      }
      try {
        this.videoEffectManager.setMirror({
          streamId: this.cameraStreamId,
          mirrorType: enable ? 1 : 0
        });
        this.isMirrored = enable;
      } catch (error) {
        console.error('切换镜像失败:', error);
      }
    },
    setVolume: function setVolume(val) {
      if (this.audioEffectManager) {
        this.audioEffectManager.setVolume(val);
      }
    }
  }
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			show: false,
			data: '',
			type: ''
		};
	},
	mounted: function mounted() {},

	methods: {
		showModel: function showModel(data) {
			this.show = true;
			this.type = data;
			this.getHtmlContentByType(data);
		},
		getHtmlContentByType: function getHtmlContentByType(data) {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _user.getHtmlContentByType)({ type: data });

							case 2:
								res = _context.sent;

								_this.data = res.data;

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	}
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _user = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default
	},
	data: function data() {
		return {
			queryParams: {
				page: 1,
				size: 10
			},
			list: [],
			hasMore: true,
			isLoading: false,
			isKong: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.getAppSysMsgList();
		setTimeout(function (v) {
			_this.getMsgUnreadCount();
		}, 1000);
	},

	methods: {
		getAppSysMsgList: function getAppSysMsgList() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var response, newList, totalPages;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(_this2.isLoading || !_this2.hasMore)) {
									_context.next = 2;
									break;
								}

								return _context.abrupt("return");

							case 2:
								_context.prev = 2;

								_this2.isLoading = true;

								_context.next = 6;
								return (0, _user.getAppSysMsgList)(_this2.queryParams);

							case 6:
								response = _context.sent;
								newList = response.rows || [];


								if (_this2.queryParams.page === 1) {
									_this2.list = newList;
								} else {
									_this2.list = [].concat((0, _toConsumableArray3.default)(_this2.list), (0, _toConsumableArray3.default)(newList));
								}

								totalPages = Math.ceil((response.total || 0) / _this2.queryParams.size);

								_this2.hasMore = _this2.queryParams.page < totalPages;
								if (response.total == 0) {
									_this2.isKong = true;
								} else {
									_this2.isKong = false;
								}
								_context.next = 17;
								break;

							case 14:
								_context.prev = 14;
								_context.t0 = _context["catch"](2);

								console.error("获取直播列表失败:", _context.t0);

							case 17:
								_context.prev = 17;

								_this2.isLoading = false;
								return _context.finish(17);

							case 20:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this2, [[2, 14, 17, 20]]);
			}))();
		},
		handleScroll: function handleScroll() {
			if (this.isLoading || !this.hasMore) {
				return;
			}

			var container = this.$refs.listContainer;

			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;

			if (isAtBottom) {
				console.log("滚动到底部，触发加载更多");
				this.queryParams.page++;
				this.getAppSysMsgList();
			}
		},
		formatContent: function formatContent(content) {
			return content ? content.replace(/\n/g, '<br/>') : '';
		},
		getMsgUnreadCount: function getMsgUnreadCount() {
			var _this3 = this;

			(0, _user.getMsgUnreadCount)().then(function (response) {
				_this3.$store.commit('changeSysMsgCount', response.data.sysMsgNoReadCount);
			});
		}
	}
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(143);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

var _txycos = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      show: false,
      form: {
        headPortrait: '',
        nickName: ''
      },
      cosClient: null
    };
  },
  mounted: function mounted() {
    this.cosClient = (0, _txycos.client)();
  },

  methods: {
    getPresentUserInfo: function getPresentUserInfo(data) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _user.getPresentUserInfo)();

              case 2:
                res = _context.sent;

                _this.form = JSON.parse((0, _stringify2.default)(res.data));
                if (data == 1) {
                  _this.$store.commit('changeUserInfo', res.data);
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updUserInfo: function updUserInfo() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _user.updUserInfo)(_this2.form);

              case 2:
                res = _context2.sent;

                _this2.$message({ message: res.msg, type: 'success' });
                _this2.getPresentUserInfo(1);
                _this2.show = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showModel: function showModel() {
      this.show = true;
      this.getPresentUserInfo();
    },
    handleUploadClick: function handleUploadClick() {
      this.$refs.fileInput.click();
    },
    handleFileChange: function handleFileChange(event) {
      var fileList = event.target.files;
      if (!fileList || fileList.length === 0) return;

      this.uploadToCOS(fileList[0]);

      event.target.value = '';
    },
    uploadToCOS: function uploadToCOS(file) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var fileExt, fileName, uploadResult, imageUrl;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!file || !file.type.startsWith('image/'))) {
                  _context3.next = 3;
                  break;
                }

                _this3.$message.error('请选择有效的图片文件');
                return _context3.abrupt('return');

              case 3:
                _context3.prev = 3;
                fileExt = file.name.split('.').pop() || 'png';
                fileName = 'webStorage/web_/' + Date.now() + '_' + Math.random().toString(36).substr(2, 10) + '.' + fileExt;
                _context3.next = 8;
                return new _promise2.default(function (resolve, reject) {
                  _this3.cosClient.putObject({
                    Bucket: _this3.cosClient.options.bucket,
                    Region: _this3.cosClient.options.region,
                    Key: fileName,
                    Body: file,
                    ContentType: file.type || 'image/jpeg',
                    onProgress: function onProgress(progressData) {
                      console.log('图片上传进度：', (progressData.percent * 100).toFixed(2) + '%');
                    }
                  }, function (err, result) {
                    if (err) reject(err);else resolve(result);
                  });
                });

              case 8:
                uploadResult = _context3.sent;
                imageUrl = 'https://' + _this3.cosClient.options.bucket + '.cos.' + _this3.cosClient.options.region + '.myqcloud.com/' + fileName;

                _this3.form.headPortrait = imageUrl;

                console.log('背景图上传成功，地址：', _this3.form.headPortrait);

                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](3);

                console.error('直播背景图上传失败：', _context3.t0);
                _this3.$message.error('背景图上传失败，请稍后重试');

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 14]]);
      }))();
    }
  }
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'VolumeControl',
  data: function data() {
    return {
      volume: 100
    };
  },

  methods: {
    handleVolumeChange: function handleVolumeChange(event) {
      this.volume = Number(event.target.value);
      this.$emit('setVol', this.volume);
    },
    handleSetVol: function handleSetVol(data) {
      this.volume = data;
      this.$emit('setVol', this.volume);
    },
    toggleMute: function toggleMute() {
      this.volume = this.volume === 0 ? 100 : 0;
      this.$emit('setVol', this.volume);
    }
  }
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'zaixianyonghu',
	data: function data() {
		return {
			queryParams: {
				page: 1,
				size: 100,
				liveId: this.$route.query.liveId
			},
			hasMore: true,
			list: [],
			total: 0
		};
	},
	mounted: function mounted() {
		this.getChatRoomOnlineUserList();
		this.getChatRoomOnlineUserCount();
	},

	methods: {
		getChatRoomOnlineUserCount: function getChatRoomOnlineUserCount() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getChatRoomOnlineUserCount)(_this.queryParams);

							case 2:
								res = _context.sent;

								_this.total = res.data;

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getChatRoomOnlineUserList: function getChatRoomOnlineUserList() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var response;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _zhibo.getChatRoomOnlineUserList)(_this2.queryParams);

							case 2:
								response = _context2.sent;

								_this2.list = response.rows;

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		handleScroll: function handleScroll() {},
		handleShowUser: function handleShowUser(id) {
			this.$emit('show_user', id);
		}
	}
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _zhibo = __webpack_require__(7);

exports.default = {
	name: 'zbList',
	props: ['data', 'type'],
	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	methods: {
		handleDetial: function handleDetial(data) {
			sessionStorage.setItem('isPageRefreshed', 0);
			if (this.type == 1) {
				return;
			}

			this.$router.push({ path: '/zhibozhong', query: {
					liveId: data.liveId

				} });
		},
		handlePlayVideo: function handlePlayVideo(replayUrl) {
			this.$router.push({
				path: '/huifang',
				query: {
					url: replayUrl,
					name: this.data.name,
					period: this.data.period || ''
				}
			});
		},
		handleDelete: function handleDelete(item) {
			var _this = this;

			var id = item.id || item.liveId;
			if (!id) {
				this.$message.error(this.$t('all.qingshurushuju'));
				return;
			}
			this.$confirm(this.$t('all.confirmDelete') || '确认删除该直播记录？').then(function () {
				(0, _zhibo.delLiveRecord)({ id: id }).then(function (res) {
					_this.$message.success(res.msg || _this.$t('all.shanchuchenggong') || '删除成功');
					_this.$emit('delete', id);
				}).catch(function (err) {
					_this.$message.error(err.message || '删除失败');
				});
			}).catch(function () {});
		}
	}
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: ['data'],
	data: function data() {
		return {
			newWindow: null
		};
	},
	mounted: function mounted() {},

	methods: {
		handlePlayVideo: function handlePlayVideo(replayUrl) {
			var _this = this;

			this.closeWindow();
			var routeData = this.$router.resolve({
				name: 'bofangshipin',
				query: { url: replayUrl } });

			this.newWindow = window.open(routeData.href, '_blank');

			if (!this.newWindow) {
				this.$message.warning('弹出窗口被阻止，请允许弹出窗口后重试。');
				return;
			}

			this.newWindow.onload = function () {
				try {
					enterFullscreen(_this.newWindow.document.documentElement);
				} catch (e) {
					console.warn("无法自动进入全屏模式，请用户手动按 F11 或使用浏览器菜单进入全屏。", e);
				}
			};
		},
		closeWindow: function closeWindow() {
			if (this.newWindow && !this.newWindow.closed) {
				this.newWindow.close();
			}
			this.newWindow = null;
		}
	}
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _zbjlItem = __webpack_require__(332);

var _zbjlItem2 = _interopRequireDefault(_zbjlItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default,
		zbjlItem: _zbjlItem2.default
	},
	data: function data() {
		return {
			data: '',
			queryParams: {
				page: 1,
				size: 10,
				viewUserId: '',
				liveId: this.$route.query.liveId
			},
			form: {
				liveId: this.$route.query.liveId,
				toUserId: ''
			},
			list: [],
			isKong: false,
			hasMore: true,

			isLoading: false
		};
	},
	mounted: function mounted() {
		this.getChatRoomDetails();
	},

	methods: {
		getChatRoomDetails: function getChatRoomDetails() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this.$route.query.liveId });

							case 2:
								res = _context.sent;

								_this.queryParams.viewUserId = res.data.chatRoomDetails.hostUserInfo.userId;
								_this.form.toUserId = res.data.chatRoomDetails.hostUserInfo.userId;
								_this.getChatRoomUserDetails();
								_this.getUserLiveRecordList();

							case 7:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getChatRoomUserDetails: function getChatRoomUserDetails() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _zhibo.getChatRoomUserDetails)(_this2.form);

							case 2:
								res = _context2.sent;

								_this2.data = res.data;

							case 4:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		getUserLiveRecordList: function getUserLiveRecordList() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var response, newList, totalPages;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(_this3.isLoading || !_this3.hasMore)) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt("return");

							case 2:
								_context3.prev = 2;

								_this3.isLoading = true;

								_context3.next = 6;
								return (0, _zhibo.getUserLiveRecordList)(_this3.queryParams);

							case 6:
								response = _context3.sent;
								newList = response.rows || [];


								if (_this3.queryParams.page === 1) {
									_this3.list = newList;
								} else {
									_this3.list = [].concat((0, _toConsumableArray3.default)(_this3.list), (0, _toConsumableArray3.default)(newList));
								}

								totalPages = Math.ceil((response.total || 0) / _this3.queryParams.size);

								_this3.hasMore = _this3.queryParams.page < totalPages;
								if (response.total > 0) {
									_this3.isKong = false;
								} else {
									_this3.isKong = true;
								}
								_context3.next = 17;
								break;

							case 14:
								_context3.prev = 14;
								_context3.t0 = _context3["catch"](2);

								console.error("获取直播记录列表失败:", _context3.t0);

							case 17:
								_context3.prev = 17;

								_this3.isLoading = false;
								return _context3.finish(17);

							case 20:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3, [[2, 14, 17, 20]]);
			}))();
		},
		handleScroll: function handleScroll() {
			if (this.isLoading || !this.hasMore) {
				return;
			}

			var container = this.$refs.listContainer;

			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;

			if (isAtBottom) {
				console.log("滚动到底部，准备加载第", this.queryParams.page + 1, "页");
				this.queryParams.page++;
				this.getUserLiveRecordList();
			}
		},
		handleCloseZbjl: function handleCloseZbjl() {
			this.$emit('close_zbjl');
		}
	}
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "zhuboplayer",
  props: {
    pullUrl: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      player: null,
      playerId: null,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license"
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.playerId = 'zhubo-player-' + Date.now();
    this.$nextTick(function () {
      _this.initPlayer();
    });
    console.log(this.userInfo);
  },

  watch: {
    pullUrl: {
      immediate: true,
      handler: function handler(newVal) {
        var _this2 = this;

        if (newVal) {
          this.$nextTick(function () {
            _this2.initPlayer();
          });
        }
      }
    },
    userInfo: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('zhuboplayer userInfo updated:', newVal);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      try {
        this.player.pause();
      } catch (e) {
        console.warn('播放器暂停异常:', e);
      }
      try {
        this.player.src('');
      } catch (e) {
        console.warn('播放器设置src异常:', e);
      }
      try {
        var container = document.getElementById(this.playerId);
        if (container) {
          this.player.dispose();
        }
      } catch (e) {
        console.warn('播放器清理异常:', e);
      }
      this.player = null;
    }
  },

  methods: {
    initPlayer: function initPlayer() {
      if (!this.pullUrl) return;

      if (!this.player) {
        this.player = TCPlayer(this.playerId, {
          sources: [{
            src: this.pullUrl
          }],
          licenseUrl: this.licenseUrl,
          autoplay: true,
          controls: false,
          webrtcConfig: {
            connectRetryCount: 999999
          }
        });
      } else {
        this.player.src(this.pullUrl);
        this.player.play();
      }
    }
  }
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _yinliang = __webpack_require__(953);

var _yinliang2 = _interopRequireDefault(_yinliang);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		yinliang: _yinliang2.default
	},
	data: function data() {
		return {
			isSvga: true
		};
	},
	mounted: function mounted() {},

	methods: {
		setVolume: function setVolume(data) {
			this.$emit('setVol', data);
		},
		handleShowKjdy: function handleShowKjdy() {
			this.$emit('show_kjdy');
		},
		handleShowGly: function handleShowGly() {
			this.$emit('show_gly');
		},
		handleShowGg: function handleShowGg() {
			this.$emit('show_gg');
		},
		handleShowSvga: function handleShowSvga() {
			this.isSvga = !this.isSvga;
			this.$emit('show_svga', this.isSvga);
		}
	}
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _xitongxiaoxi = __webpack_require__(951);

var _xitongxiaoxi2 = _interopRequireDefault(_xitongxiaoxi);

var _wodedingdan = __webpack_require__(946);

var _wodedingdan2 = _interopRequireDefault(_wodedingdan);

var _wentibangzhu = __webpack_require__(945);

var _wentibangzhu2 = _interopRequireDefault(_wentibangzhu);

var _woyaofankui = __webpack_require__(947);

var _woyaofankui2 = _interopRequireDefault(_woyaofankui);

var _shezhi = __webpack_require__(941);

var _shezhi2 = _interopRequireDefault(_shezhi);

var _tuichudenglu = __webpack_require__(943);

var _tuichudenglu2 = _interopRequireDefault(_tuichudenglu);

var _appxiazai = __webpack_require__(924);

var _appxiazai2 = _interopRequireDefault(_appxiazai);

var _xiazai = __webpack_require__(330);

var _xiazai2 = _interopRequireDefault(_xiazai);

var _xieyi = __webpack_require__(331);

var _xieyi2 = _interopRequireDefault(_xieyi);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		xitongxiaoxi: _xitongxiaoxi2.default,
		wodedingdan: _wodedingdan2.default,
		wentibangzhu: _wentibangzhu2.default,
		woyaofankui: _woyaofankui2.default,
		shezhi: _shezhi2.default,
		tuichudenglu: _tuichudenglu2.default,
		appxiazai: _appxiazai2.default,
		xiazai: _xiazai2.default,
		xieyi: _xieyi2.default
	},
	data: function data() {
		return {
			isModalVisible: false,
			content: null,
			type: '',
			isFkModalVisible: false,
			defaulImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png',
			sysMsgNoReadCount: 0,
			isLogin: '',
			liveRoomInfo: null
		};
	},

	computed: {
		isSubPage: function isSubPage() {
			var subPages = ['/liushuijilu', '/zhibozhongxin', '/huifang', '/tijiaoshenqing', '/shenqingjilu', '/zhibojinyao', '/youjiantongzhi', '/kaishizhibo', '/zhiboshangpin', '/zhibozhong', '/wodequanbao', '/wodeqianbao', '/chongzhierweima', '/chongzhichenggong', '/querentbi', '/yonghuzhuye'];
			return subPages.includes(this.$route.path);
		},
		subPageTitle: function subPageTitle() {
			var titles = {
				'/zhibozhongxin': this.$t('all.zhibozhongxin'),
				'/tijiaoshenqing': this.$t('all.tijiaoshenqing'),
				'/shenqingjilu': this.$t('all.shenqingjilu'),
				'/zhibojinyao': this.$t('all.zhibojinyao'),
				'/youjiantongzhi': this.$t('all.youjiantongzhi'),
				'/kaishizhibo': this.$t('all.kaishizhibo'),
				'/zhiboshangpin': this.$t('all.zhiboshangpin'),
				'/wodequanbao': this.$t('all.wodequanbao'),
				'/wodeqianbao': this.$t('all.wodeqianbao'),
				'/chongzhierweima': this.$t('all.chongzhierweima'),
				'/chongzhichenggong': this.$t('all.chongzhichenggong'),
				'/querentbi': this.$t('all.querentbi'),
				'/yonghuzhuye': this.$t('all.yonghuzhuye')
			};
			if (this.$route.path === '/liushuijilu') {
				var unitText = this.$route.query.unitText || '';
				return this.$t('all.liushuijilu') + (unitText ? ' ' + unitText : '');
			}
			if (this.$route.path === '/huifang') {
				var name = this.$route.query.name || '';
				var period = this.$route.query.period || '';
				return name + (period ? ' | ' + period : '');
			}
			return titles[this.$route.path] || '';
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem('user');
		console.log(this.$router.options.routes, '$router.options.routes');
		this.$store.commit('changeSearchQuery', null);
		this.checkIsLogin();
		console.log(this.$route.query, '$route.query');
	},

	methods: {
		getMenuName: function getMenuName(meta) {
			var lang = this.$store.state.language;
			if (lang === 'chinese') return meta.CnName;
			if (lang === 'english') return meta.EnName;
			if (lang === 'taiwan') return meta.TwName;
			if (lang === 'japanese') return meta.JaName;
			if (lang === 'korean') return meta.KoName;
			return meta.CnName;
		},
		checkIsLogin: function checkIsLogin() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.checkIsLogin)();

							case 2:
								res = _context.sent;

								_this2.isLogin = res.data;

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},
		goBack: function goBack() {
			this.$router.go(-1);
		},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {
				sessionStorage.removeItem('user');
				_this.$router.push('/login');
			}).catch(function () {});
		},
		handlerouter: function handlerouter(index, item) {
			this.$store.commit('changeCount', index);
			this.$router.push(item.children[0].path);
		},
		handleSearchInput: function handleSearchInput() {
			this.$store.commit('changeSearchQuery', this.content ? this.content : null);
		},
		handleShowModalVisible: function handleShowModalVisible(data) {
			this.isModalVisible = true;
			this.type = data;
		},
		handleUploadFk: function handleUploadFk() {
			this.isModalVisible = false;
			this.isFkModalVisible = true;
		},
		handleShowSz: function handleShowSz() {
			this.$refs.sz.showModel();
		},
		handleShowTc: function handleShowTc() {
			this.$refs.tc.showModel();
		},
		handleImgError: function handleImgError(e) {
			e.target.src = this.defaultImg;

			e.target.onerror = null;
		},
		handleShowModel: function handleShowModel(data) {
			this.$refs.xieyi.showModel(data);
		},
		handleShowXiazai: function handleShowXiazai() {
			this.$refs.xiazai.showModel();
		},
		handleTiaozhuan: function handleTiaozhuan() {
			this.$router.replace({ path: '/wode' });
		},
		getLiveRoomInfo: function getLiveRoomInfo() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!(_this3.$route.path === '/zhibozhong' && _this3.$route.query.liveId && !_this3.$route.query.name)) {
									_context2.next = 13;
									break;
								}

								_context2.prev = 1;
								_context2.next = 4;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this3.$route.query.liveId });

							case 4:
								res = _context2.sent;

								_this3.liveRoomInfo = res.data.chatRoomDetails;
								_context2.next = 11;
								break;

							case 8:
								_context2.prev = 8;
								_context2.t0 = _context2["catch"](1);

								console.error('获取直播间详情失败:', _context2.t0);

							case 11:
								_context2.next = 14;
								break;

							case 13:
								_this3.liveRoomInfo = null;

							case 14:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this3, [[1, 8]]);
			}))();
		},
		handleShowLiveRecord: function handleShowLiveRecord() {
			this.$root.$emit('showLiveRecord');
		}
	},
	watch: {
		$route: {
			handler: function handler() {
				this.getLiveRoomInfo();
			},

			immediate: true
		}
	}
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _login = __webpack_require__(219);

var _user = __webpack_require__(14);

var _xieyi = __webpack_require__(331);

var _xieyi2 = _interopRequireDefault(_xieyi);

var _xiazai = __webpack_require__(330);

var _xiazai2 = _interopRequireDefault(_xiazai);

var _jsCookie = __webpack_require__(106);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		xieyi: _xieyi2.default,
		xiazai: _xiazai2.default
	},
	data: function data() {
		return {
			type: 1,
			countdown: false,
			timeText: 60,
			countdownStartTime: 60,
			timer: null,
			form: {
				email: '',
				password: '',
				loginEmailCode: '',
				smsType: 1,
				countryId: '',
				countryName: '',
				countryImage: '',
				payPassword: '',
				userName: '',
				invitationCode: ''
			},
			isPassword: true,
			isPayPassword: true,
			isFlag: false,
			newWindow: null,
			isModalVisible: false,
			allCountryList: [],
			yyList: [{
				name: this.$t('all.jiantizhongwen'),
				language: 'cn'
			}, {
				name: this.$t('all.fantizhongwen'),
				language: 'tw'
			}, {
				name: this.$t('all.yingwen'),
				language: 'en'
			}, {
				name: this.$t('all.ribenyu'),
				language: 'ja'
			}, {
				name: this.$t('all.hanguoyu'),
				language: 'ko'
			}],
			yyListIndex: 0,
			isModelYy: false,
			isYyPopoverVisible: false,
			isRemember: false
		};
	},
	mounted: function mounted() {
		this.getAllCountry();
		var lang = localStorage.getItem('Language');
		this.yyListIndex = lang === 'cn' ? 0 : lang === 'tw' ? 1 : lang === 'en' ? 2 : lang === 'ja' ? 3 : 4;
		this.loadRememberedCredentials();
	},

	methods: {
		loadRememberedCredentials: function loadRememberedCredentials() {
			var remember = localStorage.getItem('rememberUser');
			this.isRemember = remember === 'true';
			if (this.isRemember) {
				var savedEmail = localStorage.getItem('savedEmail');
				var savedPassword = localStorage.getItem('savedPassword');
				if (savedEmail) {
					this.form.email = savedEmail;
				}
				if (savedPassword) {
					this.form.password = savedPassword;
				}
			}
		},
		toggleRemember: function toggleRemember() {
			this.isRemember = !this.isRemember;
			localStorage.setItem('rememberUser', this.isRemember);
			if (!this.isRemember) {
				localStorage.removeItem('savedEmail');
				localStorage.removeItem('savedPassword');
			}
		},
		saveRememberedCredentials: function saveRememberedCredentials() {
			if (this.isRemember) {
				localStorage.setItem('savedEmail', this.form.email);
				localStorage.setItem('savedPassword', this.form.password);
			}
		},
		getAllCountry: function getAllCountry() {
			var _this = this;

			(0, _login.getAllCountry)().then(function (response) {
				_this.allCountryList = response.data;
				_this.form.countryId = response.data[0].id;
				_this.form.countryName = response.data[0].name;
				_this.form.countryImage = response.data[0].picture;
			});
		},
		toLogin: function toLogin() {
			var _this2 = this;

			if (!this.isFlag) {
				this.$message.error(this.$t('all.qingyuedubingtongyiyonghuxieyiheyinsixieyi'));
				return;
			}
			this.$store.commit('changeToken', '');
			(0, _login.toLogin)(this.form).then(function (response) {
				sessionStorage.setItem('user', 1);
				_this2.$message.success(response.msg);
				_this2.$store.commit('changeToken', response.data.token);
				_this2.$store.commit('changeUserId', response.data.userId);
				_this2.$store.commit('changeCount', 2);
				_this2.saveRememberedCredentials();
				_this2.getPresentUserInfo();
				_this2.getMsgUnreadCount();
			});
		},
		toForgetPassword: function toForgetPassword() {
			var _this3 = this;

			this.$store.commit('changeToken', '');
			(0, _login.toForgetPassword)(this.form).then(function (response) {
				sessionStorage.setItem('user', 1);
				_this3.$message.success(response.msg);
				_this3.$store.commit('changeToken', response.data.token);
				_this3.$store.commit('changeUserId', response.data.userId);
				_this3.$store.commit('changeCount', 2);
				_this3.getPresentUserInfo();
				_this3.getMsgUnreadCount();
			});
		},
		toRegister: function toRegister() {
			var _this4 = this;

			if (!this.isFlag) {
				this.$message.error(this.$t('all.qingyuedubingtongyiyonghuxieyiheyinsixieyi'));
				return;
			}
			this.$store.commit('changeToken', '');
			(0, _login.toRegister)(this.form).then(function (response) {
				sessionStorage.setItem('user', 1);
				_this4.$message.success(response.msg);
				_this4.$store.commit('changeToken', response.data.token);
				_this4.$store.commit('changeUserId', response.data.userId);
				_this4.$store.commit('changeCount', 2);
				_this4.getPresentUserInfo();
				_this4.getMsgUnreadCount();
			});
		},
		getPresentUserInfo: function getPresentUserInfo() {
			var _this5 = this;

			(0, _user.getPresentUserInfo)().then(function (response) {
				_this5.$store.commit('changeUserInfo', response.data);
				_this5.$router.replace({ path: '/shouye' });
			});
		},
		handleWangjimima: function handleWangjimima() {
			this.type = 2;
			this.form.smsType = 2;
			this.form.password = '';
			this.clearTime();
		},
		handleMimadenglu: function handleMimadenglu() {
			this.type = 1;
			this.form.smsType = 1;
			this.form.password = '';
			this.clearTime();
		},
		getCode: function getCode() {
			var _this6 = this;

			(0, _login.sendSmsCode)(this.form).then(function (response) {
				_this6.$message.success(response.msg);
				_this6.countDown();
				_this6.countdown = true;
			});
		},
		countDown: function countDown() {
			var nowTime = this.timeText - 1;
			console.log(nowTime, 'nowTime');
			if (nowTime >= 0) {
				this.timeText = nowTime;
				this.timer = setTimeout(this.countDown, 1000);
			} else {
				this.clearTime();
			}
		},
		clearTime: function clearTime() {
			this.countdown = false;
			this.timeText = this.countdownStartTime;
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
		},
		handleZhuce: function handleZhuce(data) {
			this.type = data;
			this.form.password = '';
			this.form.payPassword = '';
			this.clearTime();
		},
		handleShowModel: function handleShowModel(data) {
			this.$refs.xieyi.showModel(data);
		},
		handleShowXiazai: function handleShowXiazai() {
			this.$refs.xiazai.showModel();
		},
		handleChooseYy: function handleChooseYy(index, language) {
			this.yyListIndex = index;
			this.$i18n.locale = language;
			localStorage.setItem("Language", language);
			var langStr = 'chinese';
			if (language === 'en') langStr = 'english';else if (language === 'tw') langStr = 'taiwan';else if (language === 'ja') langStr = 'japanese';else if (language === 'ko') langStr = 'korean';
			this.$store.commit('changeLanguage', langStr);
			this.isYyPopoverVisible = false;
		},
		getMsgUnreadCount: function getMsgUnreadCount() {
			var _this7 = this;

			(0, _user.getMsgUnreadCount)().then(function (response) {
				_this7.$store.commit('changeSysMsgCount', response.data.sysMsgNoReadCount);
			});
		}
	}
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _duanshippin = __webpack_require__(927);

var _duanshippin2 = _interopRequireDefault(_duanshippin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		duanshippin: _duanshippin2.default
	},
	data: function data() {
		return {
			userId: this.$route.query.userId || '',
			videoId: this.$route.query.videoId || '',

			isHost: this.$route.query.isHost !== undefined ? Number(this.$route.query.isHost) : undefined
		};
	},
	mounted: function mounted() {},

	methods: {
		handleBack: function handleBack() {
			if (window.history.length > 1) {
				this.$router.go(-1);
			} else {
				this.$router.push('/shouye');
			}
		}
	}
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _qianbao = __webpack_require__(79);

var _qrcode = __webpack_require__(88);

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
		data: function data() {
				return {
						data: '',
						rechargeStatus: '',
						pollTimer: null
				};
		},
		mounted: function mounted() {
				this.toRecharge();
		},
		beforeDestroy: function beforeDestroy() {
				if (this.pollTimer) {
						clearInterval(this.pollTimer);
						this.pollTimer = null;
				}
		},

		methods: {
				toRecharge: function toRecharge() {
						var _this = this;

						return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
								var res;
								return _regenerator2.default.wrap(function _callee$(_context) {
										while (1) {
												switch (_context.prev = _context.next) {
														case 0:
																_context.next = 2;
																return (0, _qianbao.toRecharge)({
																		amount: _this.$route.query.amount,
																		blockchainNetworkConfigId: _this.$route.query.blockchainNetworkConfigId
																});

														case 2:
																res = _context.sent;

																_this.data = res.data;

																_this.$nextTick(function () {
																		_this.generateQrCode();
																});

														case 5:
														case 'end':
																return _context.stop();
												}
										}
								}, _callee, _this);
						}))();
				},
				generateQrCode: function generateQrCode() {
						var canvas = this.$refs.qrcodeCanvas;
						if (!canvas || !this.data.address) return;
						_qrcode2.default.toCanvas(canvas, this.data.address, {
								width: 200,
								margin: 2,
								color: {
										dark: '#000000',
										light: '#ffffff'
								}
						}, function (error) {
								if (error) {
										console.error('生成二维码失败:', error);
								}
						});
				},
				startPolling: function startPolling() {
						var _this2 = this;

						if (this.pollTimer) clearInterval(this.pollTimer);
						this.pollTimer = setInterval(function () {
								_this2.checkRechargeStatus();
						}, 2000);
				},
				checkRechargeStatus: function checkRechargeStatus() {
						var _this3 = this;

						return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
								var res, status;
								return _regenerator2.default.wrap(function _callee2$(_context2) {
										while (1) {
												switch (_context2.prev = _context2.next) {
														case 0:
																if (!(!_this3.data || !_this3.data.rechargeId)) {
																		_context2.next = 2;
																		break;
																}

																return _context2.abrupt('return');

														case 2:
																_context2.prev = 2;
																_context2.next = 5;
																return (0, _qianbao.getRechargeStatusInfo)({ rechargeId: _this3.data.rechargeId });

														case 5:
																res = _context2.sent;
																status = res.data && res.data.status;

																if (status === 1 || status === 'success') {
																		_this3.rechargeStatus = 'success';
																		clearInterval(_this3.pollTimer);
																		_this3.pollTimer = null;
																		_this3.$message.success(_this3.$t('all.chongzhichenggong'));
																		setTimeout(function () {
																				_this3.$router.push('/chongzhichenggong');
																		}, 1500);
																} else if (status === 0 || status === 'pending') {
																		_this3.rechargeStatus = 'pending';
																}
																_context2.next = 13;
																break;

														case 10:
																_context2.prev = 10;
																_context2.t0 = _context2['catch'](2);

																console.error('查询充值状态失败:', _context2.t0);

														case 13:
														case 'end':
																return _context2.stop();
												}
										}
								}, _callee2, _this3, [[2, 10]]);
						}))();
				},
				handleSaveQr: function handleSaveQr() {
						var canvas = this.$refs.qrcodeCanvas;
						if (!canvas) return;
						var link = document.createElement('a');
						link.download = 'recharge_qrcode.png';
						link.href = canvas.toDataURL('image/png');
						link.click();
						this.$message.success(this.$t('all.baocunchenggong') || '保存成功');
				},
				handleCopy: function handleCopy() {
						if (this.data && this.data.address) {
								navigator.clipboard.writeText(this.data.address);
								this.$message.success(this.$t('all.fuzhichenggong'));
						}
				}
		}
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      videoUrl: 'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17820917238043760.mp4',
      videoName: '',
      videoPeriod: '',
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      progress: 0,
      playbackRate: 1,
      speeds: [1, 1.5, 2, 0.5],
      speedIndex: 0,
      replayList: [],
      currentIndex: 0,
      isDragging: false
    };
  },
  mounted: function mounted() {
    this.videoPeriod = this.$route.query.period || '';
    this.getReplayList();
    document.addEventListener('mousemove', this.onProgressMouseMove);
    document.addEventListener('mouseup', this.onProgressMouseUp);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mousemove', this.onProgressMouseMove);
    document.removeEventListener('mouseup', this.onProgressMouseUp);
  },

  methods: {
    getReplayList: function getReplayList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _zhibo.getUserLiveRecordList)({ page: 1, size: 20, viewUserId: _this.$route.query.viewUserId ? _this.$route.query.viewUserId : _this.$store.state.userId, queryReplay: 1 });

              case 3:
                response = _context.sent;

                _this.replayList = response.rows;
                _this.videoUrl = _this.replayList[0].replayUrl;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error("获取回放列表失败:", _context.t0);
                _this.replayList = [];

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    togglePlay: function togglePlay() {
      var video = this.$refs.videoPlayer;
      if (this.isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    onTimeUpdate: function onTimeUpdate() {
      if (this.isDragging) return;
      var video = this.$refs.videoPlayer;
      this.currentTime = video.currentTime;
      this.progress = this.duration > 0 ? this.currentTime / this.duration * 100 : 0;
    },
    onLoadedMetadata: function onLoadedMetadata() {
      this.duration = this.$refs.videoPlayer.duration;
    },
    onEnded: function onEnded() {
      this.isPlaying = false;
      this.progress = 0;
      this.currentTime = 0;
    },
    seekVideo: function seekVideo(e) {
      if (this.isDragging) return;
      var bar = this.$refs.progressBar;
      var rect = bar.getBoundingClientRect();
      var percent = (e.clientX - rect.left) / rect.width;
      this.updateProgress(percent);
    },
    onProgressMouseDown: function onProgressMouseDown(e) {
      this.isDragging = true;
      var bar = this.$refs.progressBar;
      var rect = bar.getBoundingClientRect();
      var percent = (e.clientX - rect.left) / rect.width;
      this.updateProgress(percent);
    },
    onProgressMouseMove: function onProgressMouseMove(e) {
      if (!this.isDragging) return;
      var bar = this.$refs.progressBar;
      var rect = bar.getBoundingClientRect();
      var percent = (e.clientX - rect.left) / rect.width;
      percent = Math.max(0, Math.min(1, percent));
      this.updateProgress(percent);
    },
    onProgressMouseUp: function onProgressMouseUp() {
      if (this.isDragging) {
        this.isDragging = false;
      }
    },
    updateProgress: function updateProgress(percent) {
      this.progress = percent * 100;
      this.currentTime = percent * this.duration;
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.currentTime = this.currentTime;
      }
    },
    toggleSpeed: function toggleSpeed() {
      this.speedIndex = (this.speedIndex + 1) % this.speeds.length;
      this.playbackRate = this.speeds[this.speedIndex];
      this.$refs.videoPlayer.playbackRate = this.playbackRate;
    },
    formatTime: function formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00';
      var min = Math.floor(seconds / 60);
      var sec = Math.floor(seconds % 60);
      return String(min).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
    },
    handleSwitchReplay: function handleSwitchReplay(index) {
      var _this2 = this;

      this.currentIndex = index;
      var item = this.replayList[index];
      this.videoUrl = item.replayUrl;
      this.videoName = item.name;
      this.videoPeriod = item.period;
      this.isPlaying = false;
      this.currentTime = 0;
      this.progress = 0;
      this.$nextTick(function () {
        _this2.$refs.videoPlayer.load();
        _this2.$refs.videoPlayer.play().then(function () {
          _this2.isPlaying = true;
        }).catch(function (err) {
          console.warn('自动播放失败:', err);
        });
      });
    },
    handleDelete: function handleDelete(item, index) {
      var _this3 = this;

      var id = item.id || item.liveId;
      if (!id) {
        this.$message.error(this.$t('all.qingshurushuju'));
        return;
      }
      this.$confirm(this.$t('all.confirmDelete') || '确认删除该直播记录？').then(function () {
        (0, _zhibo.delLiveRecord)({ id: id }).then(function (res) {
          _this3.$message.success(res.msg || _this3.$t('all.shanchuchenggong') || '删除成功');
          _this3.replayList.splice(index, 1);
          if (_this3.currentIndex === index && _this3.replayList.length > 0) {
            _this3.currentIndex = Math.min(index, _this3.replayList.length - 1);
            _this3.handleSwitchReplay(_this3.currentIndex);
          } else if (_this3.replayList.length === 0) {
            _this3.videoUrl = '';
          }
        }).catch(function (err) {
          _this3.$message.error(err.message || '删除失败');
        });
      }).catch(function () {});
    }
  }
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _zhubo = __webpack_require__(90);

var _txycos = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form: {
        title: '',
        backgroundUrl: '',
        categoryId: '',
        liveKey: '',
        goodsCount: 4,
        categoryName: '',
        bgUrl: ''
      },
      qualityIndex: 1,
      qualityList: [],
      flowList: [],
      categoryList: [],
      bgList: [],
      cosClient: null,
      showCategoryDropdown: false,
      showBgModal: false,
      uploadProgress: 0,
      selectedBgUrl: ''
    };
  },

  computed: {
    selectedCategoryName: function selectedCategoryName() {
      var _this = this;

      var item = this.categoryList.find(function (c) {
        return c.id === _this.form.categoryId;
      });
      return item ? item.categoryName : '';
    }
  },
  mounted: function mounted() {
    this.cosClient = (0, _txycos.client)();
    this.qualityList = [{
      value: 1,
      label: this.$t('all.biaoqinghuazhi')
    }, {
      value: 0,
      label: this.$t('all.gaoqinghuazhi')
    }, {
      value: 2,
      label: this.$t('all.chaoqinghuazhi')
    }];
    this.getCategoryList();
  },

  watch: {
    showBgModal: function showBgModal(val) {
      if (val) {
        this.getBgList();
        this.selectedBgUrl = this.form.bgUrl || '';
      }
    }
  },
  methods: {
    getCategoryList: function getCategoryList() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _zhibo.getLiveCategoryList)();

              case 3:
                res = _context.sent;

                _this2.categoryList = res.data || res.rows || [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error('获取直播分类失败:', _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },
    getBgList: function getBgList() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _zhubo.getLiveBgList)();

              case 3:
                res = _context2.sent;

                _this3.bgList = res.data || res.rows || [];
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                console.error('获取背景列表失败:', _context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 7]]);
      }))();
    },
    handleUploadBg: function handleUploadBg() {
      this.$refs.bgInput.click();
    },
    handleUploadCover: function handleUploadCover() {
      this.$refs.coverInput.click();
    },
    handleCoverChange: function handleCoverChange(event) {
      var file = event.target.files[0];
      if (!file) return;
      event.target.value = '';
      this.uploadCover(file);
    },
    uploadCover: function uploadCover(file) {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var fileExt, fileName;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this4.uploadProgress = 0;
                fileExt = file.name.split('.').pop() || 'png';
                fileName = "webStorage/web_" + Date.now() + "_" + Math.random().toString(36).substr(2, 10) + "." + fileExt;
                _context3.next = 6;
                return new _promise2.default(function (resolve, reject) {
                  _this4.cosClient.putObject({
                    Bucket: _this4.cosClient.options.bucket,
                    Region: _this4.cosClient.options.region,
                    Key: fileName,
                    Body: file,
                    ContentType: file.type || 'image/png',
                    onProgress: function onProgress(progressData) {
                      _this4.uploadProgress = Math.round(progressData.loaded / progressData.total * 100);
                    }
                  }, function (err, result) {
                    if (err) reject(err);else resolve(result);
                  });
                });

              case 6:
                _this4.uploadProgress = 100;
                _this4.form.backgroundUrl = "https://" + _this4.cosClient.options.bucket + ".cos." + _this4.cosClient.options.region + ".myqcloud.com/" + fileName;
                _this4.$message.success(_this4.$t('all.yishangchuan'));
                setTimeout(function () {
                  _this4.uploadProgress = 0;
                }, 500);
                _context3.next = 17;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](0);

                console.error('封面上传失败:', _context3.t0);
                _this4.uploadProgress = 0;
                _this4.$message.error(_this4.$t('all.shangchuanshibai'));

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 12]]);
      }))();
    },
    handleSelectBg: function handleSelectBg(item) {
      this.selectedBgUrl = item.imgUrl;
    },
    handleConfirmBg: function handleConfirmBg() {
      if (this.selectedBgUrl) {
        this.form.bgUrl = this.selectedBgUrl;
        this.showBgModal = false;
      } else {
        this.$message.warning(this.$t('all.qingxuanzebeijing'));
      }
    },
    handleSelectCategory: function handleSelectCategory(item) {
      console.log(item);
      this.form.categoryId = item.id;
      this.form.categoryName = item.categoryName;
      this.showCategoryDropdown = false;
    },
    handleGoGoods: function handleGoGoods() {
      this.$router.push('/zhiboshangpin');
    },
    handleBgChange: function handleBgChange(event) {
      var file = event.target.files[0];
      if (!file) return;
      event.target.value = '';
      this.uploadImage(file);
    },
    uploadImage: function uploadImage(file) {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var fileExt, fileName, bgUrl;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.uploadProgress = 0;
                fileExt = file.name.split('.').pop() || 'png';
                fileName = "webStorage/web_" + Date.now() + "_" + Math.random().toString(36).substr(2, 10) + "." + fileExt;
                _context4.next = 6;
                return new _promise2.default(function (resolve, reject) {
                  _this5.cosClient.putObject({
                    Bucket: _this5.cosClient.options.bucket,
                    Region: _this5.cosClient.options.region,
                    Key: fileName,
                    Body: file,
                    ContentType: file.type || 'image/png',
                    onProgress: function onProgress(progressData) {
                      _this5.uploadProgress = Math.round(progressData.loaded / progressData.total * 100);
                    }
                  }, function (err, result) {
                    if (err) reject(err);else resolve(result);
                  });
                });

              case 6:
                _this5.uploadProgress = 100;
                bgUrl = "https://" + _this5.cosClient.options.bucket + ".cos." + _this5.cosClient.options.region + ".myqcloud.com/" + fileName;

                _this5.selectedBgUrl = bgUrl;
                _this5.$message.success(_this5.$t('all.yishangchuan'));
                setTimeout(function () {
                  _this5.uploadProgress = 0;
                }, 500);
                _context4.next = 18;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](0);

                console.error('上传失败:', _context4.t0);
                _this5.uploadProgress = 0;
                _this5.$message.error(_this5.$t('all.shangchuanshibai'));

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 13]]);
      }))();
    },
    checkMediaPermission: function checkMediaPermission() {
      var _this6 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var stream;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)) {
                  _context5.next = 3;
                  break;
                }

                _this6.$message.warning(_this6.$t('all.browserbu支持'));
                return _context5.abrupt("return", false);

              case 3:
                _context5.prev = 3;
                _context5.next = 6;
                return navigator.mediaDevices.getUserMedia({ video: true, audio: true });

              case 6:
                stream = _context5.sent;

                stream.getTracks().forEach(function (track) {
                  return track.stop();
                });
                return _context5.abrupt("return", true);

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](3);

                console.error('媒体权限获取失败:', _context5.t0.name, _context5.t0.message);
                if (_context5.t0.name === 'NotAllowedError' || _context5.t0.name === 'PermissionDeniedError') {
                  _this6.$message.warning('摄像头和麦克风权限被拒绝，请在浏览器地址栏左侧点击锁/信息图标，允许摄像头和麦克风权限后刷新页面');
                } else if (_context5.t0.name === 'NotFoundError' || _context5.t0.name === 'DevicesNotFoundError') {
                  _this6.$message.warning('未检测到摄像头或麦克风设备，请检查设备是否已连接');
                } else if (_context5.t0.name === 'NotReadableError' || _context5.t0.name === 'TrackStartError') {
                  _this6.$message.warning('设备被其他应用占用，请关闭其他使用摄像头/麦克风的程序后重试');
                } else {
                  _this6.$message.warning('无法获取设备权限，请检查浏览器设置');
                }
                return _context5.abrupt("return", false);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[3, 11]]);
      }))();
    },
    handleStart: function handleStart() {
      var _this7 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
        var hasPermission, params, res, liveId;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this7.form.title) {
                  _context6.next = 3;
                  break;
                }

                _this7.$message.warning(_this7.$t('all.geinidezhibojianqugemingziba'));
                return _context6.abrupt("return");

              case 3:
                if (_this7.form.liveKey) {
                  _context6.next = 6;
                  break;
                }

                _this7.$message.warning(_this7.$t('all.qingshurukaibomiyao'));
                return _context6.abrupt("return");

              case 6:
                _context6.prev = 6;
                _context6.next = 9;
                return _this7.checkMediaPermission();

              case 9:
                hasPermission = _context6.sent;

                if (hasPermission) {
                  _context6.next = 12;
                  break;
                }

                return _context6.abrupt("return");

              case 12:
                params = {
                  name: _this7.form.title,
                  backgroundUrl: _this7.form.backgroundUrl,
                  bgUrl: _this7.form.bgUrl,
                  categoryId: _this7.form.categoryId,
                  startKey: _this7.form.liveKey,
                  livePictureQuality: _this7.qualityList[_this7.qualityIndex].value
                };
                _context6.next = 15;
                return (0, _zhibo.startLive)(params);

              case 15:
                res = _context6.sent;

                _this7.$message.success(res.msg);
                console.log('开始直播返回数据:', res);
                liveId = res.data;

                if (liveId) {
                  _this7.$router.push({
                    path: '/zhibozhong',
                    query: {
                      liveId: liveId
                    }
                  });
                } else {
                  console.error('开始直播成功但未返回liveId:', res);
                }
                _context6.next = 25;
                break;

              case 22:
                _context6.prev = 22;
                _context6.t0 = _context6["catch"](6);

                console.error('开始直播失败:', _context6.t0);

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[6, 22]]);
      }))();
    }
  }
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _qianbao = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      tabIndex: 0,
      tabs: [],
      dateRange: null,
      list: [],
      unitText: 'NB',
      hasMore: true,
      isLoading: false,
      queryParams: {
        page: 1,
        size: 20,
        type: 0,
        currencyId: this.$route.query.currencyId
      },
      pickerOptions: {},

      showRejectionModal: false,
      rejectionItem: {},

      showAddressModal: false,
      detailAddress: '',
      addressModalType: 'recharge'
    };
  },
  mounted: function mounted() {
    this.getWalletBillTypeEnums();
    this.unitText = this.$route.query.unitText || 'NB';
    this.getList();
  },

  computed: {
    addressModalTitle: function addressModalTitle() {
      return this.addressModalType === 'withdraw' ? this.$t('all.tibixiangqing') : this.$t('all.chongbixiangqing');
    },
    addressModalLabel: function addressModalLabel() {
      return this.addressModalType === 'withdraw' ? this.$t('all.tibidizhi') : this.$t('all.chongbidizhi');
    }
  },
  methods: {
    getWalletBillTypeEnums: function getWalletBillTypeEnums() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _qianbao.getWalletBillTypeEnums)();

              case 2:
                res = _context.sent;

                _this.tabs = res.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleTabChange: function handleTabChange(index) {
      this.tabIndex = index;
      this.queryParams.billType = this.tabs[index].type;
      this.queryParams.page = 1;
      this.hasMore = true;
      this.getList();
    },
    handleDateChange: function handleDateChange(val) {
      if (val) {
        this.queryParams.startDate = val[0];
        this.queryParams.endDate = val[1];
      } else {
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
      }
      this.queryParams.page = 1;
      this.hasMore = true;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res, newList, totalPages;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.isLoading || !_this2.hasMore)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.prev = 2;

                _this2.isLoading = true;
                _context2.next = 6;
                return (0, _qianbao.getWalletBalanceBillList)(_this2.queryParams);

              case 6:
                res = _context2.sent;
                newList = res.rows || res.data || [];


                if (_this2.queryParams.page === 1) {
                  _this2.list = newList;
                } else {
                  _this2.list = [].concat((0, _toConsumableArray3.default)(_this2.list), (0, _toConsumableArray3.default)(newList));
                }

                totalPages = Math.ceil((res.total || 0) / _this2.queryParams.size);

                _this2.hasMore = _this2.queryParams.page < totalPages;
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](2);

                console.error("获取流水记录失败:", _context2.t0);

              case 16:
                _context2.prev = 16;

                _this2.isLoading = false;
                return _context2.finish(16);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 13, 16, 19]]);
      }))();
    },
    handleScroll: function handleScroll() {
      if (this.isLoading || !this.hasMore) {
        return;
      }

      var container = this.$refs.listContainer;
      var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;

      if (isAtBottom) {
        this.queryParams.page++;
        this.getList();
      }
    },
    handleShowRejection: function handleShowRejection(item) {
      this.rejectionItem = item;
      this.showRejectionModal = true;
    },
    getRejectionMsg: function getRejectionMsg(item) {
      if (item.withdrawalRejectionMsg) return item.withdrawalRejectionMsg;
      var desc = item.billDesc || '';
      var matched = desc.match(/(?:驳回原因|駁回原因|Reason)\s*[:：]\s*([\s\S]*)/i);
      return matched ? matched[1].trim() : '';
    },
    isRowClickable: function isRowClickable(item) {
      var status = this.getWithdrawalStatus(item);
      if (status === 1 || status === 2) return true;
      if (this.isRechargeRow(item) && this.getRowAddress(item)) return true;
      return false;
    },
    getWithdrawalStatus: function getWithdrawalStatus(item) {
      if (item.withdrawalStatus !== undefined && item.withdrawalStatus !== null && item.withdrawalStatus !== '') {
        return Number(item.withdrawalStatus);
      }

      var desc = item.billDesc || '';
      if (/驳回原因|駁回原因|[Rr]eject/i.test(desc)) return 2;
      if (/审核通过|審核通過|[Aa]pproved|審査通過|승인/.test(desc)) return 1;
      if (/审核中|審核中|[Pp]ending|審査中|심사/.test(desc)) return 0;
      return null;
    },
    isRechargeRow: function isRechargeRow(item) {
      return item.billTypeName === this.$t('all.chongbi');
    },
    handleRowClick: function handleRowClick(item) {
      var status = this.getWithdrawalStatus(item);

      if (status === 2) {
        this.handleShowRejection(item);
        return;
      }
      if (status === 1) {
        this.openAddressModal(item, 'withdraw');
        return;
      }

      if (this.isRechargeRow(item)) {
        this.openAddressModal(item, 'recharge');
      }
    },
    openAddressModal: function openAddressModal(item, type) {
      var addr = this.getRowAddress(item);
      if (!addr) return;
      this.addressModalType = type;
      this.detailAddress = addr;
      this.showAddressModal = true;
    },
    getRowAddress: function getRowAddress(item) {
      var addr = item.address || item.rechargeAddress || item.withdrawAddress || item.withdrawalAddress || '';
      if (addr) return addr;
      return this.extractAddress(item.billDesc);
    },
    extractAddress: function extractAddress(text) {
      if (!text) return '';
      var labeled = text.match(/(?:地址|Address|アドレス|주소)\s*[:：]\s*(\S+)/i);
      if (labeled && labeled[1]) return labeled[1];
      var evm = text.match(/0x[a-zA-Z0-9]{8,}/);
      if (evm) return evm[0];
      var tron = text.match(/\bT[a-zA-Z0-9]{33}\b/);
      if (tron) return tron[0];
      return '';
    },
    copyDetailAddress: function copyDetailAddress() {
      if (!this.detailAddress) return;
      navigator.clipboard.writeText(this.detailAddress);
      this.$message.success(this.$t('all.fuzhichenggong'));
    }
  }
};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhiboshenqing = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      tabIndex: 0,
      tabs: [],
      list: [],
      showDetail: false,
      detailData: {},
      isLoading: false,
      loaded: false,
      hasMore: true,
      queryParams: {
        page: 1,
        size: 20,
        status: ''
      }
    };
  },

  computed: {
    filteredList: function filteredList() {
      return this.list;
    },
    detailSteps: function detailSteps() {
      var isApproved = this.detailData.status === 1;
      var keyReady = this.detailData.keyReady;
      var steps = [{ name: this.$t('all.tijiaoshenqing'), done: true, current: false, statusText: this.$t('all.wancheng') }, { name: this.$t('all.houtaishenhe'), done: isApproved, current: !isApproved, statusText: isApproved ? this.$t('all.wancheng') : this.$t('all.chulizhong') }, { name: this.$t('all.chanshengmiyao'), done: keyReady, current: isApproved && !keyReady, statusText: keyReady ? this.$t('all.wancheng') : this.$t('all.daichuli') }, { name: this.$t('all.youjiankuaidi'), done: keyReady, current: false, statusText: keyReady ? this.$t('all.wancheng') : this.$t('all.daichuli') }];
      return steps;
    }
  },
  mounted: function mounted() {
    this.tabs = [this.$t('all.quanbu'), this.$t('all.daishenhe'), this.$t('all.yitongguo'), this.$t('all.weitongguo')];
    this.loadData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.$refs.tableBody) {
        _this.$refs.tableBody.removeEventListener('scroll', _this.handleScroll);
        _this.$refs.tableBody.addEventListener('scroll', _this.handleScroll);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$refs.tableBody) {
      this.$refs.tableBody.removeEventListener('scroll', this.handleScroll);
    }
  },

  methods: {
    handleTabChange: function handleTabChange(index) {
      this.tabIndex = index;
      this.queryParams.status = index === 0 ? '' : index - 1;
      this.queryParams.page = 1;
      this.hasMore = true;
      this.list = [];
      this.loadData();
    },
    loadData: function loadData() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response, data, newList, total, totalPages;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.isLoading || !_this2.hasMore)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this2.isLoading = true;
                _context.prev = 3;
                _context.next = 6;
                return (0, _zhiboshenqing.getUserLiveApplyRecordList)(_this2.queryParams);

              case 6:
                response = _context.sent;
                data = response.data || response;
                newList = Array.isArray(data) ? data : data.rows || data.list || [];

                if (_this2.queryParams.page === 1) {
                  _this2.list = newList;
                } else {
                  _this2.list = [].concat((0, _toConsumableArray3.default)(_this2.list), (0, _toConsumableArray3.default)(newList));
                }
                total = data.total || newList.length;
                totalPages = Math.ceil(total / _this2.queryParams.size);

                _this2.hasMore = _this2.queryParams.page < totalPages;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](3);

                console.error("获取申请记录失败:", _context.t0);

              case 18:
                _context.prev = 18;

                _this2.isLoading = false;
                _this2.loaded = true;
                return _context.finish(18);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 15, 18, 22]]);
      }))();
    },
    handleScroll: function handleScroll(e) {
      if (this.isLoading || !this.hasMore) return;
      var target = e.target || this.$refs.tableBody;
      if (!target) return;
      var scrollTop = target.scrollTop;
      var clientHeight = target.clientHeight;
      var scrollHeight = target.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.queryParams.page++;
        this.loadData();
      }
    },
    getStatusText: function getStatusText(status) {
      if (status === 0) return this.$t('all.daishenhe');
      if (status === 1) return this.$t('all.yitongguo');
      if (status === 2) return this.$t('all.weitongguo');
      return '';
    },
    getStatusClass: function getStatusClass(status) {
      if (status === 0) return 'sqjl-status-pending';
      if (status === 1) return 'sqjl-status-pass';
      if (status === 2) return 'sqjl-status-reject';
      return '';
    },
    getDetailStatusClass: function getDetailStatusClass(status) {
      if (status === 0) return 'sqxq-status-pending';
      if (status === 1) return 'sqxq-status-pass';
      if (status === 2) return 'sqxq-status-reject';
      return '';
    },
    getStepDotClass: function getStepDotClass(step) {
      if (step.done) return 'sqxq-step-dot-done';
      if (step.current) return 'sqxq-step-dot-current';
      return 'sqxq-step-dot';
    },
    handleDetail: function handleDetail(item) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _zhiboshenqing.getLiveApplyInfo)({ applyId: item.applyId });

              case 2:
                res = _context2.sent;

                if (res.data.status == 1) {
                  _this3.$router.push({ path: '/zhibojinyao', query: {
                      applyId: item.applyId
                    } });
                } else {
                  _this3.detailData = res.data;
                  _this3.showDetail = true;
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    handleRevoke: function handleRevoke() {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return (0, _zhiboshenqing.returnLiveApply)({ applyId: _this4.detailData.applyId });

              case 3:
                _this4.$message.success(_this4.$t('all.caozuochenggong'));
                _this4.showDetail = false;
                _this4.queryParams.page = 1;
                _this4.hasMore = true;
                _this4.list = [];
                _this4.loadData();
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                console.error("撤回申请失败:", _context3.t0);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 11]]);
      }))();
    },
    handleReapply: function handleReapply() {
      this.showDetail = false;
      this.$router.push({ path: '/zhibozhongxin', query: { showSqModal: 'true' } });
    },
    handleGoKey: function handleGoKey() {
      this.showDetail = false;
      this.$router.push('/zhibojinyao');
    }
  }
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _user = __webpack_require__(14);

var _alioss = __webpack_require__(456);

var _zbList = __webpack_require__(207);

var _zbList2 = _interopRequireDefault(_zbList);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _jsCookie = __webpack_require__(106);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'shouye',
	components: {
		zbList: _zbList2.default,
		kong: _kong2.default
	},
	data: function data() {
		return {
			navList: [],
			navListIndex: 0,
			topNavIndex: 0,
			videoCateIndex: 0,
			videoCateList: [{ categoryName: this.$t('all.quanbu'), id: 0 }, { categoryName: this.$t('all.remen'), id: 1 }],
			queryParams: {
				page: 1,
				size: 20,
				categoryId: '',
				keyWord: ''
			},
			list: [],
			hasMore: true,
			isLoading: false,
			isKong: false,
			stateMonitor: null,
			appConfigInfo: null,

			videoList: [],
			videoPage: 1,
			videoSize: 20,
			videoHasMore: true,
			videoLoading: false,
			videoLoaded: false,
			videoCateId: 0 };
	},
	created: function created() {},
	mounted: function mounted() {
		var _this = this;

		sessionStorage.setItem('user', 1);
		this.stateMonitor = setInterval(function () {
			var currentValue = _this.$store.state.searchQuery;
		}, 10000);
		this.queryParams.page = 1;
		this.getLiveCategoryList();
		this.$store.commit('changeCount', 2);
		this.checkIsLogin();
		this.getAppConfigInfo();

		this.loadVideoList();
	},
	beforeDestroy: function beforeDestroy() {
		clearInterval(this.stateMonitor);
		this.$store.commit('changeSearchQuery', null);
	},

	computed: {
		topNavList: function topNavList() {
			var list = [this.$t('all.zhibo')];
			if (this.appConfigInfo && this.appConfigInfo.videoStatus == 1) {
				list.push(this.$t('all.duanyingyin'));
			}
			return list;
		},
		searchQuery: function searchQuery() {
			return this.$store.state.searchQuery;
		}
	},
	watch: {
		searchQuery: {
			handler: function handler(newValue, oldValue) {
				if (newValue !== oldValue || oldValue === undefined) {
					this.queryParams.keyWord = newValue;
					this.queryParams.page = 1;
					this.hasMore = true;
					this.getLiveCategoryList();
				}
			},

			immediate: true
		},
		videoCateIndex: function videoCateIndex() {
			this.videoPage = 1;
			this.videoHasMore = true;
			this.videoList = [];
			this.videoLoaded = false;
			this.videoCateId = this.videoCateList[this.videoCateIndex].id;
			this.loadVideoList();
		}
	},
	methods: {
		getLiveCategoryList: function getLiveCategoryList() {
			var _this2 = this;

			(0, _zhibo.getLiveCategoryList)().then(function (response) {
				response.data.unshift({
					categoryName: _this2.$t('all.quanbu'),
					id: ''
				});
				_this2.navList = response.data;
				_this2.queryParams.categoryId = response.data[0].id;
				_this2.getLiveList();
			});
		},
		checkIsLogin: function checkIsLogin() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.checkIsLogin)();

							case 2:
								res = _context.sent;

								if (res.data == 0) {
									_this3.$store.commit('changeToken', null);
									_this3.$store.commit('changeUserId', null);
									_this3.$store.commit('changeUserInfo', null);
								}

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this3);
			}))();
		},
		getAppConfigInfo: function getAppConfigInfo() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.prev = 0;
								_context2.next = 3;
								return (0, _user.getAppConfigInfo)();

							case 3:
								res = _context2.sent;

								_this4.appConfigInfo = res.data;

								if (_this4.appConfigInfo && _this4.appConfigInfo.videoStatus != 1 && _this4.topNavIndex === 1) {
									_this4.topNavIndex = 0;
								}
								_context2.next = 11;
								break;

							case 8:
								_context2.prev = 8;
								_context2.t0 = _context2["catch"](0);

								console.error('获取APP配置失败:', _context2.t0);

							case 11:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this4, [[0, 8]]);
			}))();
		},
		handleTopNav: function handleTopNav(index) {
			if (this.topNavIndex === index) return;
			this.topNavIndex = index;
		},
		handleVideoCate: function handleVideoCate(index) {
			if (this.videoCateIndex === index) return;
			this.videoCateIndex = index;
		},
		handleNav: function handleNav(index) {
			this.navListIndex = index;
			this.queryParams.page = 1;
			this.queryParams.categoryId = this.navList[index].id;
			this.hasMore = true;
			this.getLiveList();
		},
		getLiveList: function getLiveList() {
			var _this5 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var response, newList, totalPages;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(_this5.isLoading || !_this5.hasMore)) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt("return");

							case 2:
								_context3.prev = 2;

								_this5.isLoading = true;
								_context3.next = 6;
								return (0, _zhibo.getLiveList)(_this5.queryParams);

							case 6:
								response = _context3.sent;
								newList = response.rows || [];

								if (_this5.queryParams.page === 1) {
									_this5.list = newList;
								} else {
									_this5.list = [].concat((0, _toConsumableArray3.default)(_this5.list), (0, _toConsumableArray3.default)(newList));
								}
								totalPages = Math.ceil((response.total || 0) / _this5.queryParams.size);

								_this5.hasMore = _this5.queryParams.page < totalPages;
								if (response.total == 0) {
									_this5.isKong = true;
								} else {
									_this5.isKong = false;
								}
								_context3.next = 17;
								break;

							case 14:
								_context3.prev = 14;
								_context3.t0 = _context3["catch"](2);

								console.error("获取直播列表失败:", _context3.t0);

							case 17:
								_context3.prev = 17;

								_this5.isLoading = false;
								return _context3.finish(17);

							case 20:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this5, [[2, 14, 17, 20]]);
			}))();
		},
		handleScroll: function handleScroll() {
			if (this.isLoading || !this.hasMore) return;
			var container = this.$refs.listContainer;
			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
			if (isAtBottom) {
				this.queryParams.page++;
				this.getLiveList();
			}
		},
		handleVideoScroll: function handleVideoScroll() {
			if (this.videoLoading || !this.videoHasMore) return;
			var container = this.$refs.videoGridContainer;
			if (!container) return;
			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
			if (isAtBottom) {
				this.videoPage++;
				this.loadVideoList();
			}
		},
		loadVideoList: function loadVideoList() {
			var _this6 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var res, data, newList, total, totalPages;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (!(_this6.videoLoading || !_this6.videoHasMore)) {
									_context4.next = 2;
									break;
								}

								return _context4.abrupt("return");

							case 2:
								_this6.videoLoading = true;
								_context4.prev = 3;
								_context4.next = 6;
								return (0, _user.getVideoList)({
									page: _this6.videoPage,
									size: _this6.videoSize,
									isHost: _this6.videoCateId,
									title: _this6.searchQuery || ''
								});

							case 6:
								res = _context4.sent;
								data = res.rows || res.data || [];
								newList = Array.isArray(data) ? data : [];

								if (_this6.videoPage === 1) {
									_this6.videoList = newList;
								} else {
									_this6.videoList = [].concat((0, _toConsumableArray3.default)(_this6.videoList), (0, _toConsumableArray3.default)(newList));
								}
								total = res.total || newList.length;
								totalPages = Math.ceil(total / _this6.videoSize);

								_this6.videoHasMore = _this6.videoPage < totalPages;
								_context4.next = 18;
								break;

							case 15:
								_context4.prev = 15;
								_context4.t0 = _context4["catch"](3);

								console.error('加载短视频列表失败:', _context4.t0);

							case 18:
								_context4.prev = 18;

								_this6.videoLoading = false;
								_this6.videoLoaded = true;
								return _context4.finish(18);

							case 22:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this6, [[3, 15, 18, 22]]);
			}))();
		},
		handlePlayVideo: function handlePlayVideo(item) {
			var videoId = item.videoId || item.id || '';
			if (!videoId) return;

			var isHost = this.videoCateList[this.videoCateIndex].id;
			this.$router.push({ path: '/bofangshipin', query: { videoId: videoId, isHost: isHost } });
		},
		formatDuration: function formatDuration(seconds) {
			if (!seconds) return '00:00';
			var mins = Math.floor(seconds / 60);
			var secs = Math.floor(seconds % 60);
			return mins.toString().padStart(2, '0') + ":" + secs.toString().padStart(2, '0');
		}
	}
};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      liveDate: '',
      timeSlot: ''
    };
  },
  mounted: function mounted() {
    this.liveDate = this.$route.query.liveDate || '';
    this.timeSlot = this.$route.query.timeSlot || '';
  },

  methods: {
    handleViewRecord: function handleViewRecord() {
      this.$router.push('/shenqingjilu');
    }
  }
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

var _qianbao = __webpack_require__(79);

var _xiaofeimingxi = __webpack_require__(948);

var _xiaofeimingxi2 = _interopRequireDefault(_xiaofeimingxi);

var _xiugaiziliao = __webpack_require__(952);

var _xiugaiziliao2 = _interopRequireDefault(_xiugaiziliao);

var _duanyingyin = __webpack_require__(928);

var _duanyingyin2 = _interopRequireDefault(_duanyingyin);

var _guanzhu = __webpack_require__(934);

var _guanzhu2 = _interopRequireDefault(_guanzhu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		xiaofeimingxi: _xiaofeimingxi2.default,
		xiugaiziliao: _xiugaiziliao2.default,
		duanyingyin: _duanyingyin2.default,
		guanzhu: _guanzhu2.default
	},
	data: function data() {
		return {
			data: '',
			cbList: ['NB Chain', 'USDT', 'ETH'],
			cbListIndex: 0,
			tbList: ['NB Chain', 'USDT', 'ETH'],
			tbListIndex: 0,
			tibiAmount: '',
			userWalletInfo: '',
			appConfigInfo: null
		};
	},
	mounted: function mounted() {
		this.$store.commit('changeCount', 4);
		this.getPresentUserInfo();
		this.getUserWalletList();
		this.getAppConfigInfo();
	},

	methods: {
		getPresentUserInfo: function getPresentUserInfo() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _user.getPresentUserInfo)();

							case 2:
								res = _context.sent;

								_this.data = res.data;

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getUserWalletList: function getUserWalletList() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _qianbao.getUserWalletList)({ queryValuationAmount: 1 });

							case 2:
								res = _context2.sent;

								_this2.userWalletInfo = res.data;

							case 4:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		getAppConfigInfo: function getAppConfigInfo() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return (0, _user.getAppConfigInfo)();

							case 2:
								res = _context3.sent;

								_this3.appConfigInfo = res.data;

							case 4:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		handleScroll: function handleScroll() {
			var container = this.$refs.listContainer;
			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
			if (isAtBottom && this.$refs.duanyingyin) {
				this.$refs.duanyingyin.loadMore();
			}
		},
		handleShowXfmx: function handleShowXfmx() {
			this.$refs.xfmx.showXfmx();
		},
		handleShowXgzl: function handleShowXgzl() {
			this.$refs.xgzl.showModel();
		},
		handleShowGuanzhu: function handleShowGuanzhu(tab) {
			this.$refs.gz.showGuanzhu(tab);
		},
		handleGoLiushui: function handleGoLiushui(data) {
			this.$router.push({ path: '/liushuijilu', query: {
					currencyId: data.currencyId,
					unitText: data.unitText
				} });
		},
		handleGoWallet: function handleGoWallet() {
			this.$router.push('/wodeqianbao');
		},
		handleGoZhibozhongxin: function handleGoZhibozhongxin() {
			this.$router.push('/zhibozhongxin');
		}
	}
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _qianbao = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      data: ''
    };
  },
  mounted: function mounted() {
    this.getUserWalletList();
  },

  methods: {
    getUserWalletList: function getUserWalletList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _qianbao.getUserWalletList)({ queryValuationAmount: 1 });

              case 2:
                res = _context.sent;

                _this.data = res.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleGoDetail: function handleGoDetail(data) {
      console.log(11);
      this.$router.push({ path: '/wodequanbao', query: {
          currencyId: data.currencyId
        } });
    }
  }
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _qianbao = __webpack_require__(79);

var _user = __webpack_require__(14);

var _login = __webpack_require__(219);

var _qrcode = __webpack_require__(88);

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      currencyId: '',
      data: '',
      activeTab: '',
      showAddressModal: false,
      searchAddress: '',
      addressList: [{ label: '常用地址', address: '0x82...8F91' }, { label: '交易所地址', address: '0x82...8F91' }, { label: '冷钱包', address: '0x82...8F91' }],

      rechargeData: { address: '' },
      agreementContent: '',
      currencyList: [],
      showCurrencyPicker: false,

      withdrawAmount: '',
      withdrawAddress: '',
      withdrawFee: '0.00',
      withdrawActual: '0.00',
      withdrawError: '',

      showWithdrawSuccess: false,
      withdrawSuccessStatus: '',
      withdrawSuccessActual: '',

      showVerifyModal: false,
      userEmail: '',
      emailCode: '',
      codeCountdown: 0,
      codeTimer: null
    };
  },

  computed: {
    currentCurrencyName: function currentCurrencyName() {
      var _this = this;

      if (this.data && this.data.currencyName) return this.data.currencyName;
      var cur = this.currencyList.find(function (c) {
        return String(c.currencyId) === String(_this.currencyId);
      });
      return cur ? cur.unitText || cur.currencyName || '' : '';
    }
  },
  mounted: function mounted() {
    this.currencyId = this.$route.query.currencyId || '';
    this.getCurrencyList();
    this.getUserWalletInfo();
    this.getAgreement();
    this.getUserEmail();
  },

  watch: {
    withdrawAmount: function withdrawAmount(val) {
      if (val && val.includes('.')) {
        var maxDecimals = parseInt(this.data && this.data.contractDecimals) || 18;
        var parts = val.split('.');
        if (parts[1] && parts[1].length > maxDecimals) {
          this.withdrawAmount = parts[0] + '.' + parts[1].slice(0, maxDecimals);
          return;
        }
      }
      this.calculateWithdraw(val);
    }
  },
  methods: {
    getCurrencyList: function getCurrencyList() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _qianbao.getUserWalletList)();

              case 3:
                res = _context.sent;

                _this2.currencyList = res && res.data && res.data.walletList || [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error('获取币种列表失败:', _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },
    getAgreement: function getAgreement() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _user.getHtmlContentByType)({ type: 3 });

              case 3:
                res = _context2.sent;

                _this3.agreementContent = res && res.data || '';
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                console.error('获取充值协议失败:', _context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 7]]);
      }))();
    },
    onCurrencyConfirm: function onCurrencyConfirm(item) {
      if (String(item.currencyId) === String(this.currencyId)) {
        this.showCurrencyPicker = false;
        return;
      }
      this.currencyId = item.currencyId;
      this.showCurrencyPicker = false;
      this.getUserWalletInfo();
    },
    generateQrCode: function generateQrCode() {
      var _this4 = this;

      this.$nextTick(function () {
        var canvas = _this4.$refs.qrcodeCanvas;
        if (!canvas || !_this4.rechargeData.address) return;
        _qrcode2.default.toCanvas(canvas, _this4.rechargeData.address, {
          width: 160,
          margin: 2,
          color: { dark: '#000000', light: '#ffffff' }
        }, function (error) {
          if (error) console.error('生成二维码失败:', error);
        });
      });
    },
    getUserWalletInfo: function getUserWalletInfo(skipTabReset) {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var res, hasRecharge, hasWithdraw, netConfig;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _qianbao.getUserWalletInfo)({ currencyId: _this5.currencyId });

              case 2:
                res = _context3.sent;

                _this5.data = res.data;

                if (!skipTabReset) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                hasRecharge = _this5.data.rechargeNetworkConfigList && _this5.data.rechargeNetworkConfigList.length > 0;
                hasWithdraw = _this5.data.withdrawalNetworkConfigList && _this5.data.withdrawalNetworkConfigList.length > 0;

                if (hasRecharge) {
                  _this5.activeTab = 'deposit';
                  netConfig = _this5.data.rechargeNetworkConfigList[0];

                  if (netConfig.blockchainNetworkConfigId) {
                    _this5.fetchRechargeAddress(netConfig.blockchainNetworkConfigId);
                  }
                } else if (hasWithdraw) {
                  _this5.activeTab = 'withdraw';
                } else {
                  _this5.activeTab = '';
                }

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    fetchRechargeAddress: function fetchRechargeAddress(blockchainNetworkConfigId) {
      var _this6 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var res, newData;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return (0, _qianbao.toRecharge)({ blockchainNetworkConfigId: blockchainNetworkConfigId });

              case 3:
                res = _context4.sent;
                newData = res && res.data || {};

                if (newData.address && newData.address !== _this6.rechargeData.address) {
                  _this6.rechargeData = newData;
                  _this6.generateQrCode();
                } else if (newData.address) {
                  _this6.rechargeData = newData;
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error('调用充值接口失败:', _context4.t0);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 8]]);
      }))();
    },
    calculateWithdraw: function calculateWithdraw(val) {
      this.withdrawError = '';
      this.withdrawFee = '0.00';
      this.withdrawActual = '0.00';

      if (!val || parseFloat(val) <= 0) {
        return;
      }

      var amount = parseFloat(val);
      var minAmount = parseFloat(this.data.withdrawalNetworkConfigList[0].minWithdrawalAmount || 0);
      var maxAmount = parseFloat(this.data.withdrawalNetworkConfigList[0].maxWithdrawalAmount || -1);
      var availableAmount = parseFloat(this.data.sumAvailableAmount || 0);
      var feeRatio = parseFloat(this.data.withdrawalNetworkConfigList[0].withdrawalServiceChargeRatio || 0);
      var decimals = parseInt(this.data.contractDecimals) || 18;

      if (amount < minAmount) {
        this.withdrawError = this.$t('all.zuiditixianjin') + minAmount + ' ' + this.data.currencyName;
        return;
      }

      if (maxAmount !== -1 && amount > maxAmount) {
        this.withdrawError = this.$t('all.meiriyushutixian') + maxAmount + ' ' + this.data.currencyName;
        return;
      }

      if (amount > availableAmount) {
        this.withdrawError = this.$t('all.keyongyu') + availableAmount + ' ' + this.data.currencyName;
        return;
      }

      var fee = amount * feeRatio;
      var actual = amount - fee;

      this.withdrawFee = this.truncateDecimal(fee, decimals);
      this.withdrawActual = this.truncateDecimal(actual, decimals);
    },
    truncateDecimal: function truncateDecimal(num, decimals) {
      var d = decimals !== undefined ? decimals : 18;
      if (d === 0) return Math.floor(num).toString();

      var safePrecision = Math.min(d, 10);
      var rounded = parseFloat(num.toFixed(safePrecision));

      var factor = Math.pow(10, safePrecision);
      var truncated = Math.floor(rounded * factor) / factor;

      var result = truncated.toFixed(safePrecision);
      var dotIndex = result.indexOf('.');
      if (dotIndex !== -1) {
        var end = result.length - 1;
        while (end > dotIndex + 2 && result[end] === '0') {
          end--;
        }
        result = result.slice(0, end + 1);
      }
      return result;
    },
    handleGoFlow: function handleGoFlow() {
      this.$router.push({ path: '/liushuijilu', query: {
          currencyId: this.data.currencyId,
          unitText: this.data.currencyName
        } });
    },
    handleSwitchDeposit: function handleSwitchDeposit() {
      if (!this.data.rechargeNetworkConfigList || this.data.rechargeNetworkConfigList.length === 0) {
        this.$message.warning(this.$t('all.gaibizhongbuzhichichongzhi'));
        return;
      }
      this.activeTab = 'deposit';

      var netConfig = this.data.rechargeNetworkConfigList[0];
      if (netConfig.blockchainNetworkConfigId) {
        this.fetchRechargeAddress(netConfig.blockchainNetworkConfigId);
      }
    },
    handleSwitchWithdraw: function handleSwitchWithdraw() {
      if (!this.data.withdrawalNetworkConfigList || this.data.withdrawalNetworkConfigList.length === 0) {
        this.$message.warning(this.$t('all.gaibizhongbuzhichitibi'));
        return;
      }
      this.activeTab = 'withdraw';
    },
    handleCopyAddress: function handleCopyAddress() {
      if (!this.rechargeData.address) return;
      navigator.clipboard.writeText(this.rechargeData.address);
      this.$message.success(this.$t('all.fuzhichenggong'));
    },
    handleWithdraw: function handleWithdraw() {
      if (!this.withdrawAddress) {
        this.$message.warning(this.$t('all.qingshurutibidizhi'));
        return;
      }
      if (!this.withdrawAmount || parseFloat(this.withdrawAmount) <= 0) {
        this.$message.warning(this.$t('all.qingshuru'));
        return;
      }
      if (this.withdrawError) {
        this.$message.warning(this.withdrawError);
        return;
      }

      this.emailCode = '';
      this.showVerifyModal = true;
      if (!this.userEmail) {
        this.getUserEmail();
      }
    },
    getUserEmail: function getUserEmail() {
      var _this7 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var res;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return (0, _user.getPresentUserInfo)();

              case 3:
                res = _context5.sent;

                _this7.userEmail = res && res.data && res.data.email || '';
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);

                console.error('获取用户信息失败:', _context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 7]]);
      }))();
    },
    maskEmail: function maskEmail(email) {
      if (!email) return '';
      var atIndex = email.indexOf('@');
      if (atIndex < 0) return email;
      var name = email.substring(0, atIndex);
      var domain = email.substring(atIndex);
      if (name.length <= 2) return name.charAt(0) + '****' + domain;
      return name.charAt(0) + '****' + name.charAt(name.length - 1) + domain;
    },
    sendEmailCode: function sendEmailCode() {
      var _this8 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
        var res;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this8.codeCountdown > 0)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                if (_this8.userEmail) {
                  _context6.next = 5;
                  break;
                }

                _this8.$message.warning(_this8.$t('all.qingshuruningdeyouxiangzhanghao'));
                return _context6.abrupt("return");

              case 5:
                _context6.prev = 5;
                _context6.next = 8;
                return (0, _login.sendSmsCode)({ email: _this8.userEmail, smsType: 3 });

              case 8:
                res = _context6.sent;

                _this8.$message.success(res.msg || _this8.$t('all.fasongchenggong'));
                _this8.codeCountdown = 60;
                _this8.startCodeCountdown();
                _context6.next = 17;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](5);

                console.error('发送验证码失败:', _context6.t0);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[5, 14]]);
      }))();
    },
    startCodeCountdown: function startCodeCountdown() {
      var _this9 = this;

      this.clearCodeTimer();
      var tick = function tick() {
        _this9.codeCountdown--;
        if (_this9.codeCountdown > 0) {
          _this9.codeTimer = setTimeout(tick, 1000);
        } else {
          _this9.clearCodeTimer();
        }
      };
      this.codeTimer = setTimeout(tick, 1000);
    },
    clearCodeTimer: function clearCodeTimer() {
      if (this.codeTimer) {
        clearTimeout(this.codeTimer);
        this.codeTimer = null;
      }
    },
    closeVerify: function closeVerify() {
      this.showVerifyModal = false;
    },
    confirmVerifyAndWithdraw: function confirmVerifyAndWithdraw() {
      var _this10 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
        var res;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this10.emailCode) {
                  _context7.next = 3;
                  break;
                }

                _this10.$message.warning(_this10.$t('all.qingshuruyanzhengma'));
                return _context7.abrupt("return");

              case 3:
                _context7.prev = 3;
                _context7.next = 6;
                return (0, _qianbao.toWithdrawal)({
                  blockchainNetworkConfigId: _this10.data.withdrawalNetworkConfigList[0].blockchainNetworkConfigId,
                  amount: _this10.withdrawAmount,
                  address: _this10.withdrawAddress,
                  smsCode: _this10.emailCode
                });

              case 6:
                res = _context7.sent;

                _this10.showVerifyModal = false;
                _this10.withdrawSuccessStatus = res && res.data && res.data.statusName || _this10.$t('all.shenhezhong') || '审核中';
                _this10.withdrawSuccessActual = _this10.withdrawActual;
                _this10.showWithdrawSuccess = true;
                _this10.withdrawAmount = '';
                _this10.withdrawAddress = '';
                _this10.emailCode = '';
                _this10.getUserWalletInfo(true);
                _context7.next = 21;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7["catch"](3);

                console.error('提币失败:', _context7.t0);
                if (_context7.t0 && _context7.t0.msg) {
                  _this10.$message.error(_context7.t0.msg);
                }

              case 21:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[3, 17]]);
      }))();
    },
    handleSelectAddress: function handleSelectAddress(item) {
      this.showAddressModal = false;
      this.$router.push('/querentbi');
    },
    formatAddress: function formatAddress(address) {
      if (!address) return '';
      if (address.length <= 10) return address;
      return address.slice(0, 6) + '...' + address.slice(-4);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearCodeTimer();
  }
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _user = __webpack_require__(14);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _sp_dz_12x = __webpack_require__(306);

var _sp_dz_12x2 = _interopRequireDefault(_sp_dz_12x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		kong: _kong2.default
	},
	data: function data() {
		return {
			userId: '',
			data: '',
			appConfigInfo: null,
			videoList: [],
			videoPage: 1,
			videoSize: 10,
			videoLoading: false,
			videoHasMore: true,
			loaded: false,
			followLoading: false,
			dzIcon: _sp_dz_12x2.default
		};
	},

	computed: {
		isSelf: function isSelf() {
			if (!this.data || !this.$store.state.userInfo) return false;
			var selfId = this.$store.state.userInfo.userId;
			var pageId = this.data.userId;
			return selfId && pageId && String(selfId) === String(pageId);
		}
	},
	mounted: function mounted() {
		this.userId = this.$route.query.userId || '';
		this.getUserInfo();
		this.getVideoList();
		this.getAppConfigInfo();
	},

	methods: {
		getUserInfo: function getUserInfo() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (_this.userId) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								_context.prev = 2;
								_context.next = 5;
								return (0, _user.viewUserInfo)({ viewUserId: _this.userId });

							case 5:
								res = _context.sent;

								_this.data = res.data;
								_context.next = 12;
								break;

							case 9:
								_context.prev = 9;
								_context.t0 = _context['catch'](2);

								console.error('获取用户详情失败:', _context.t0);

							case 12:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[2, 9]]);
			}))();
		},
		getAppConfigInfo: function getAppConfigInfo() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.prev = 0;
								_context2.next = 3;
								return (0, _user.getAppConfigInfo)();

							case 3:
								res = _context2.sent;

								_this2.appConfigInfo = res.data;
								_context2.next = 10;
								break;

							case 7:
								_context2.prev = 7;
								_context2.t0 = _context2['catch'](0);

								console.error('获取配置失败:', _context2.t0);

							case 10:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[0, 7]]);
			}))();
		},
		getVideoList: function getVideoList() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res, rows;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(!_this3.userId || _this3.videoLoading || !_this3.videoHasMore)) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt('return');

							case 2:
								_this3.videoLoading = true;
								_context3.prev = 3;
								_context3.next = 6;
								return (0, _user.viewUserVideoList)({
									page: _this3.videoPage,
									size: _this3.videoSize,
									viewUserId: _this3.userId
								});

							case 6:
								res = _context3.sent;
								rows = res.rows || [];

								_this3.videoList = _this3.videoPage === 1 ? rows : [].concat((0, _toConsumableArray3.default)(_this3.videoList), (0, _toConsumableArray3.default)(rows));
								if (rows.length < _this3.videoSize) _this3.videoHasMore = false;
								_this3.videoPage++;
								_this3.loaded = true;
								_context3.next = 17;
								break;

							case 14:
								_context3.prev = 14;
								_context3.t0 = _context3['catch'](3);

								console.error('获取短影音列表失败:', _context3.t0);

							case 17:
								_context3.prev = 17;

								_this3.videoLoading = false;
								return _context3.finish(17);

							case 20:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3, [[3, 14, 17, 20]]);
			}))();
		},
		handleScroll: function handleScroll() {
			var container = this.$refs.listContainer;
			if (!container) return;
			var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
			if (isAtBottom) this.getVideoList();
		},
		toggleFollow: function toggleFollow() {
			var _this4 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var res, wasFollowed;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (!(!_this4.userId || _this4.followLoading)) {
									_context4.next = 2;
									break;
								}

								return _context4.abrupt('return');

							case 2:
								_this4.followLoading = true;
								_context4.prev = 3;
								_context4.next = 6;
								return (0, _user.followOrCancelFollow)({ viewUserId: _this4.userId });

							case 6:
								res = _context4.sent;
								wasFollowed = _this4.data.isFollowHe === 1;

								_this4.data = (0, _extends3.default)({}, _this4.data, {
									isFollowHe: wasFollowed ? 0 : 1,
									followCount: wasFollowed ? Math.max(_this4.data.followCount - 1, 0) : _this4.data.followCount + 1
								});
								if (res && res.msg) _this4.$message.success(res.msg);
								_context4.next = 15;
								break;

							case 12:
								_context4.prev = 12;
								_context4.t0 = _context4['catch'](3);

								console.error('关注操作失败:', _context4.t0);

							case 15:
								_context4.prev = 15;

								_this4.followLoading = false;
								return _context4.finish(15);

							case 18:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4, [[3, 12, 15, 18]]);
			}))();
		},
		handlePlayVideo: function handlePlayVideo(item) {
			this.$router.push({
				path: '/bofangshipin',
				query: {
					userId: this.userId,
					videoId: item.videoId || item.id || ''
				}
			});
		},
		formatDuration: function formatDuration(seconds) {
			if (!seconds) return '00:00';
			var mins = Math.floor(seconds / 60);
			var secs = Math.floor(seconds % 60);
			return mins.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0');
		}
	}
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhiboshenqing = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      liveType: 2,
      data: ''
    };
  },
  mounted: function mounted() {
    this.getLiveApplyInfo();
  },

  methods: {
    getLiveApplyInfo: function getLiveApplyInfo() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _zhiboshenqing.getLiveApplyInfo)({ applyId: _this.$route.query.applyId });

              case 2:
                res = _context.sent;

                _this.data = res.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleResend: function handleResend() {
      this.$message.success(this.$t('all.caozuochenggong'));
    }
  }
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _txycos = __webpack_require__(91);

var _tengxunyunzb = __webpack_require__(206);

var _tengxunyunzb2 = _interopRequireDefault(_tengxunyunzb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		tengxunyunzb: _tengxunyunzb2.default
	},
	data: function data() {
		return {
			livePusher: null,
			form: {
				name: '',
				backgroundUrl: '',
				categoryId: '',
				livePictureQuality: 0,
				startKey: ''
			},
			bqList: [],
			bqListIndex: 0,
			hzList: [{
				value: 0,
				label: this.$t('all.gaoqinghuazhi')
			}, {
				value: 1,
				label: this.$t('all.putonghuazhi')
			}],
			hzListIndex: 0,
			cosClient: null
		};
	},
	mounted: function mounted() {
		this.getLiveCategoryList();
		this.getLivePusher();
		this.$store.commit('changeCount', 3);
		this.cosClient = (0, _txycos.client)();
	},

	methods: {
		getLiveCategoryList: function getLiveCategoryList() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getLiveCategoryList)();

							case 2:
								res = _context.sent;

								_this.bqList = res.data;
								_this.form.categoryId = res.data[0].id;

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getLivePusher: function getLivePusher() {
			this.livePusher = new TXLivePusher();
			this.livePusher.setRenderView('local_video');
			this.livePusher.videoView.muted = true;

			this.livePusher.setVideoQuality('720p');

			this.livePusher.setAudioQuality('standard');

			this.livePusher.setProperty('setVideoFPS', 25);

			this.livePusher.startCamera();

			this.livePusher.startMicrophone();
		},
		handleBq: function handleBq(index) {
			this.bqListIndex = index;
			this.form.categoryId = this.bqList[index].id;
		},
		handleHz: function handleHz(index) {
			this.hzListIndex = index;
			this.form.livePictureQuality = this.hzList[index].value;
			this.$refs.txyzb.setVideoQuality(index);
		},
		handleUploadClick: function handleUploadClick() {
			this.$refs.fileInput.click();
		},
		handleFileChange: function handleFileChange(event) {
			var fileList = event.target.files;
			if (!fileList || fileList.length === 0) return;

			this.uploadToCOS(fileList[0]);

			event.target.value = '';
		},
		uploadToCOS: function uploadToCOS(file) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var fileExt, fileName, uploadResult, imageUrl;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!(!file || !file.type.startsWith('image/'))) {
									_context2.next = 3;
									break;
								}

								_this2.$message.error('请选择有效的图片文件');
								return _context2.abrupt("return");

							case 3:
								_context2.prev = 3;
								fileExt = file.name.split('.').pop() || 'png';
								fileName = "webStorage/web_/" + Date.now() + "_" + Math.random().toString(36).substr(2, 10) + "." + fileExt;
								_context2.next = 8;
								return new _promise2.default(function (resolve, reject) {
									_this2.cosClient.putObject({
										Bucket: _this2.cosClient.options.bucket,
										Region: _this2.cosClient.options.region,
										Key: fileName,
										Body: file,
										ContentType: file.type || 'image/jpeg',
										onProgress: function onProgress(progressData) {
											console.log('图片上传进度：', (progressData.percent * 100).toFixed(2) + '%');
										}
									}, function (err, result) {
										if (err) reject(err);else resolve(result);
									});
								});

							case 8:
								uploadResult = _context2.sent;
								imageUrl = "https://" + _this2.cosClient.options.bucket + ".cos." + _this2.cosClient.options.region + ".myqcloud.com/" + fileName;

								_this2.form.backgroundUrl = imageUrl;

								console.log('背景图上传成功，地址：', _this2.form.backgroundUrl);

								_context2.next = 18;
								break;

							case 14:
								_context2.prev = 14;
								_context2.t0 = _context2["catch"](3);

								console.error('直播背景图上传失败：', _context2.t0);
								_this2.$message.error('背景图上传失败，请稍后重试');

							case 18:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[3, 14]]);
			}))();
		},
		startLive: function startLive() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return (0, _zhibo.startLive)(_this3.form);

							case 2:
								res = _context3.sent;

								_this3.$store.commit('changeLiveId', res.data);
								_this3.$router.push({ path: '/zhibojian', query: { liveId: res.data } });

							case 5:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.livePusher.destroy();
	}
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _zaixianguanzhong = __webpack_require__(954);

var _zaixianguanzhong2 = _interopRequireDefault(_zaixianguanzhong);

var _danmu = __webpack_require__(926);

var _danmu2 = _interopRequireDefault(_danmu);

var _liwu = __webpack_require__(936);

var _liwu2 = _interopRequireDefault(_liwu);

var _gouwuche = __webpack_require__(931);

var _gouwuche2 = _interopRequireDefault(_gouwuche);

var _gengduoliwu = __webpack_require__(929);

var _gengduoliwu2 = _interopRequireDefault(_gengduoliwu);

var _tengxunyun = __webpack_require__(329);

var _tengxunyun2 = _interopRequireDefault(_tengxunyun);

var _tengxunyunzb = __webpack_require__(206);

var _tengxunyunzb2 = _interopRequireDefault(_tengxunyunzb);

var _liwudonghua = __webpack_require__(937);

var _liwudonghua2 = _interopRequireDefault(_liwudonghua);

var _quanbuliwu = __webpack_require__(940);

var _quanbuliwu2 = _interopRequireDefault(_quanbuliwu);

var _zhuboshezhi = __webpack_require__(957);

var _zhuboshezhi2 = _interopRequireDefault(_zhuboshezhi);

var _kuaijieduanyu = __webpack_require__(935);

var _kuaijieduanyu2 = _interopRequireDefault(_kuaijieduanyu);

var _guanliyuan = __webpack_require__(933);

var _guanliyuan2 = _interopRequireDefault(_guanliyuan);

var _user = __webpack_require__(944);

var _user2 = _interopRequireDefault(_user);

var _zhibojilu = __webpack_require__(955);

var _zhibojilu2 = _interopRequireDefault(_zhibojilu);

var _gonggao = __webpack_require__(930);

var _gonggao2 = _interopRequireDefault(_gonggao);

var _playSvga = __webpack_require__(139);

var _playSvga2 = _interopRequireDefault(_playSvga);

var _guanbizhibo = __webpack_require__(932);

var _guanbizhibo2 = _interopRequireDefault(_guanbizhibo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		zaixianguanzhong: _zaixianguanzhong2.default,
		danmu: _danmu2.default,
		liwu: _liwu2.default,
		gouwuche: _gouwuche2.default,
		gengduoliwu: _gengduoliwu2.default,
		tengxunyun: _tengxunyun2.default,
		liwudonghua: _liwudonghua2.default,
		quanbuliwu: _quanbuliwu2.default,
		tengxunyunzb: _tengxunyunzb2.default,
		zhuboshezhi: _zhuboshezhi2.default,
		kuaijieduanyu: _kuaijieduanyu2.default,
		guanliyuan: _guanliyuan2.default,
		user: _user2.default,
		zhibojilu: _zhibojilu2.default,
		playSvga: _playSvga2.default,
		gongao: _gonggao2.default,
		guanbizhibo: _guanbizhibo2.default
	},
	data: function data() {
		return {
			data: '',
			show_gdlw: false,
			show_gwc: false,
			show_kjdy: false,
			show_gly: false,
			show_zbjl: false,
			show_gg: false,
			muted: true,
			svga: true,
			isZb: -1,
			isShowGift: true
		};
	},
	mounted: function mounted() {
		this.getChatRoomDetails();
	},

	methods: {
		getChatRoomDetails: function getChatRoomDetails() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _zhibo.getChatRoomDetails)({ liveId: _this.$route.query.liveId });

							case 2:
								res = _context.sent;

								_this.data = res.data;
								if (_this.$store.state.userId && res.data.chatRoomDetails.hostUserInfo.userId == JSON.parse(_this.$store.state.userId)) {
									if (res.data.chatRoomDetails.liveType == 2) {
										_this.isZb = 2;
										_this.isShowGift = false;
									} else {
										_this.isZb = 1;
										_this.isShowGift = false;
									}
								} else {
									_this.isZb = 2;
									_this.isShowGift = true;
								}

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		updateChangeUser: function updateChangeUser() {
			this.$refs.zaixian.getChatRoomOnlineUserList();
			this.$refs.zaixian.getChatRoomOnlineUserCount();
		},
		handleAddLwToQueue: function handleAddLwToQueue(data) {
			this.$refs.lwdh.addLwToQueue(data);
		},
		goBack: function goBack() {
			if (this.isZb == 1) {
				this.$refs.gbzb.showModel();
			} else {
				this.$router.go(-1);
			}
		},
		hanldeShowGdlw: function hanldeShowGdlw() {
			this.show_gdlw = true;
			this.show_gwc = false;
			this.show_zbjl = false;
		},
		handleShowGwc: function handleShowGwc() {
			this.show_gdlw = false;
			this.show_gwc = true;
			this.show_zbjl = false;
		},
		handleUpdateUser: function handleUpdateUser() {
			this.$refs.liwu.getPresentUserInfo();
		},
		handleSetVol: function handleSetVol(data) {
			this.$refs.txyzb.setVolume(data);
		},
		handleShowKjdy: function handleShowKjdy() {
			this.show_kjdy = true;
			this.show_gly = false;
			this.show_zbjl = false;
			this.show_gg = false;
		},
		handleShowGly: function handleShowGly() {
			this.show_kjdy = false;
			this.show_gly = true;
			this.show_zbjl = false;
			this.show_gg = false;
		},
		handleShowUser: function handleShowUser(data) {
			this.$refs.user.showUser(data);
		},
		handleAddAdmin: function handleAddAdmin() {
			if (this.show_gly) {
				this.$refs.gly.getChatRoomAdminUserList();
			}
		},
		handleShowZbjl: function handleShowZbjl() {
			this.show_gdlw = false;
			this.show_gwc = false;
			this.show_kjdy = false;
			this.show_gly = false;
			this.show_zbjl = true;
			this.show_gg = false;
		},
		handleShowGg: function handleShowGg() {
			this.show_gdlw = false;
			this.show_gwc = false;
			this.show_kjdy = false;
			this.show_gly = false;
			this.show_zbjl = false;
			this.show_gg = true;
		},
		updateGg: function updateGg() {
			this.show_gg = false;
			this.$refs.danmu.getChatRoomDetails();
		},
		hanldeAddSvgaToQueue: function hanldeAddSvgaToQueue(data) {
			if (this.isZb == 1) {
				if (this.svga) {
					this.$refs.txyzb.addGiftToQueue(data);
				}
			} else {
				this.$refs.txy.addGiftToQueue(data);
			}
		},
		hanldeShowSvga: function hanldeShowSvga(data) {
			this.$refs.txyzb.showSvga(data);
		},
		handleUpdateMuted: function handleUpdateMuted() {
			this.muted = !this.muted;
			this.$refs.txy.updateMuted(this.muted);
		},
		handleUpdateSvga: function handleUpdateSvga() {
			this.svga = !this.svga;
			this.$refs.txy.updateSvga(this.svga);
		},
		updatePulling: function updatePulling() {
			var _this2 = this;

			if (this.$refs.txy) {
				setTimeout(function (v) {
					_this2.$refs.txy.refreshPlay();
					console.log('重新拉流了');
				}, 2000);
			}
		}
	}
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _zbList = __webpack_require__(207);

var _zbList2 = _interopRequireDefault(_zbList);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { zbList: _zbList2.default, kong: _kong2.default },
  data: function data() {
    return {
      tabIndex: 0,
      categoryList: [],
      list: [],
      queryParams: {
        page: 1,
        size: 20,
        viewUserId: ''
      },
      hasMore: true,
      isLoading: false,
      loaded: false
    };
  },
  mounted: function mounted() {
    this.$store.commit('changeCount', 3);
    this.categoryList = [{ name: this.$t('all.quanbu') }, { name: this.$t('all.yinyuedaren') }, { name: this.$t('all.wudaodaren') }, { name: this.$t('all.yanzhi') }];
    this.queryParams.viewUserId = this.$store.state.userId;
    this.getList();
  },

  methods: {
    handleTabChange: function handleTabChange(index) {
      this.tabIndex = index;
      this.queryParams.page = 1;
      this.hasMore = true;
      this.list = [];
      this.loaded = false;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response, newList, totalPages;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.isLoading || !_this.hasMore)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.isLoading = true;
                _context.prev = 3;
                _context.next = 6;
                return (0, _zhibo.getUserLiveRecordList)(_this.queryParams);

              case 6:
                response = _context.sent;
                newList = response.rows || [];

                if (_this.queryParams.page === 1) {
                  _this.list = newList;
                } else {
                  _this.list = [].concat((0, _toConsumableArray3.default)(_this.list), (0, _toConsumableArray3.default)(newList));
                }
                totalPages = Math.ceil((response.total || 0) / _this.queryParams.size);

                _this.hasMore = _this.queryParams.page < totalPages;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);

                console.error("获取直播记录失败:", _context.t0);

              case 16:
                _context.prev = 16;

                _this.isLoading = false;
                _this.loaded = true;
                return _context.finish(16);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 13, 16, 20]]);
      }))();
    },
    handleScroll: function handleScroll() {
      if (this.isLoading || !this.hasMore) return;
      var container = this.$refs.listContainer;
      var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
      if (isAtBottom) {
        this.queryParams.page++;
        this.getList();
      }
    },
    handleShenqing: function handleShenqing() {
      this.$router.push('/zhibozhongxin');
    },
    handleKaishi: function handleKaishi() {
      this.$router.push('/kaishizhibo');
    }
  }
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhiboshenqing = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      showToast: false,
      data: ''
    };
  },
  mounted: function mounted() {
    this.getLiveApplyInfo();
  },

  methods: {
    getLiveApplyInfo: function getLiveApplyInfo() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _zhiboshenqing.getLiveApplyInfo)({ applyId: _this.$route.query.applyId });

              case 2:
                res = _context.sent;

                _this.data = res.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleGoMail: function handleGoMail() {
      this.$router.push({ path: '/youjiantongzhi', query: {
          applyId: this.$route.query.applyId
        } });
    },
    handleCopyAll: function handleCopyAll() {
      if (!this.data) return;
      var text = '';
      if (this.data.liveType === 2) {
        if (this.data.obsUrl) text += this.$t('all.tuiliudizhi') + '\uFF1A' + this.data.obsUrl + '\n';
        if (this.data.obsCode) text += this.$t('all.tuiliumamiyao') + '\uFF1A' + this.data.obsCode + '\n';
      }
      if (this.data.startKey) text += this.$t('all.zhibojinyao') + '\uFF1A' + this.data.startKey;
      if (text) {
        this.copyToClipboard(text);
      }
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this2 = this;

      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(function () {
          _this2.showCopyToast();
        });
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.showCopyToast();
      }
    },
    showCopyToast: function showCopyToast() {
      var _this3 = this;

      this.showToast = true;
      setTimeout(function () {
        _this3.showToast = false;
      }, 2000);
    }
  }
};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      list: []
    };
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    loadData: function loadData() {
      var mockList = [];
      for (var i = 0; i < 20; i++) {
        mockList.push({
          imgUrl: 'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17815051910743367.png',
          name: '速修熬夜眼\n7天眼周焕亮',
          mallStock: 23456,
          liveStock: 341,
          mallPrice: 100,
          livePrice: 68
        });
      }
      this.list = mockList;
    },
    decreaseLiveStock: function decreaseLiveStock(item) {
      if (item.liveStock > 0) item.liveStock--;
    },
    increaseLiveStock: function increaseLiveStock(item) {
      if (item.liveStock < item.mallStock) item.liveStock++;
    },
    decreaseLivePrice: function decreaseLivePrice(item) {
      if (item.livePrice > 0) item.livePrice--;
    },
    increaseLivePrice: function increaseLivePrice(item) {
      item.livePrice++;
    },
    handleRemove: function handleRemove(index) {
      this.list.splice(index, 1);
    }
  }
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _zhubo = __webpack_require__(90);

var _qianbao = __webpack_require__(79);

var _tengxunyunzb = __webpack_require__(206);

var _tengxunyunzb2 = _interopRequireDefault(_tengxunyunzb);

var _tengxunyun = __webpack_require__(329);

var _tengxunyun2 = _interopRequireDefault(_tengxunyun);

var _xietongzhibo = __webpack_require__(949);

var _xietongzhibo2 = _interopRequireDefault(_xietongzhibo);

var _tengxunyunzhubo = __webpack_require__(942);

var _tengxunyunzhubo2 = _interopRequireDefault(_tengxunyunzhubo);

var _mainscreenplayer = __webpack_require__(938);

var _mainscreenplayer2 = _interopRequireDefault(_mainscreenplayer);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _qrcode = __webpack_require__(88);

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    tengxunyunzb: _tengxunyunzb2.default,
    tengxunyun: _tengxunyun2.default,
    xietongzhibo: _xietongzhibo2.default,
    tengxunyunzhubo: _tengxunyunzhubo2.default,
    mainscreenplayer: _mainscreenplayer2.default,
    kong: _kong2.default
  },
  data: function data() {
    return {
      soundOn: true,
      danmuOn: true,
      micOn: true,
      cameraOn: true,
      mirrorOn: false,
      showLiveRecord: false,
      liveRecordList: [],
      recordPage: 1,
      recordHasMore: true,
      recordLoading: false,

      beautyOn: false,
      coLiveOn: true,
      showNotice: false,
      noticeText: '',
      lastNoticeText: '',
      volume: 30,
      isHost: false,
      onlineCount: 0,
      onlineUserList: [],
      liveStartTimestamp: Date.now(),
      liveTimeText: '00:00:00',
      liveTimer: null,
      chatContent: '',
      msgList: [{ title: this.$t('all.danmushuoming') }],
      kjdyList: [],
      showKjdyTags: true,
      showKjdyModal: false,
      showKjdyAdd: false,
      newKjdyContent: '',
      isDragging: false,
      dragStartX: 0,
      dragScrollLeft: 0,
      goodsList: null,
      startKeyId: null,
      showRewardModal: false,
      rewardCoinIndex: 0,
      rewardAmountIndex: 0,
      rewardCoins: ['NB Chain', 'USDT', 'ETH'],
      rewardAmounts: [10, 50, 100, 200],
      customAmount: '',
      coliveList: [],
      data: null,
      showModelFj: false,
      sendUserId: null,
      msgIndex: null,
      showProductPopup: false,
      productPopupData: null,
      sendUserInfo: null,
      showOnlineFj: false,
      onlineIndex: -1,
      onlineUserInfo: null,
      rewardList: [],
      rewardTimer: null,
      giveAmountConfig: null,
      walletList: null,
      liveId: this.$route.query.liveId,
      showGoodsModal: false,
      showGoodsDetail: false,
      detailCarouselIndex: 0,
      showViewerLeft: false,
      selectedGoods: null,
      selectedSpec: null,
      buyCount: 1,
      showShareLink: false
    };
  },

  computed: {
    currentUserId: function currentUserId() {
      return this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
    },
    selectedGoodsImages: function selectedGoodsImages() {
      if (!this.selectedGoods || !this.selectedGoods.mediasList) return [];
      return this.selectedGoods.mediasList.map(function (item) {
        return item.uri;
      });
    },
    backgroundStyle: function backgroundStyle() {
      var bgUrl = this.data && this.data.chatRoomDetails && this.data.chatRoomDetails.backgroundUrl;
      if (bgUrl) {
        return {
          backgroundImage: "url(" + bgUrl + ")",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      }
      return {};
    },
    mainScreenUser: function mainScreenUser() {
      if (!this.data || !this.data.helpLiveUserList) return null;
      return this.data.helpLiveUserList.find(function (item) {
        return item.isMainScreen === 1;
      });
    },
    isSelfMainScreen: function isSelfMainScreen() {
      if (!this.currentUserId || !this.mainScreenUser) return false;
      return this.mainScreenUser.userInfo && this.mainScreenUser.userInfo.userId === this.currentUserId;
    },
    isJoinedHelpLive: function isJoinedHelpLive() {
      if (!this.currentUserId || !this.data || !this.data.helpLiveUserList) return false;
      return this.data.helpLiveUserList.some(function (item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
    },
    viewerMicOn: function viewerMicOn() {
      if (!this.currentUserId || !this.data || !this.data.helpLiveUserList) return true;
      var helpUser = this.data.helpLiveUserList.find(function (item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
      return helpUser ? helpUser.microphoneStatus === 1 : true;
    },
    viewerCameraOn: function viewerCameraOn() {
      if (!this.currentUserId || !this.data || !this.data.helpLiveUserList) return true;
      var helpUser = this.data.helpLiveUserList.find(function (item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
      return helpUser ? helpUser.cameraStatus === 1 : true;
    }
  },
  mounted: function mounted() {
    this.getChatRoomDetails();
    this.getOnlineUserList();
    this.getLiveCommonExpressionsList();
    this.startLiveTimer();
    this.connectWebSocket();
    this.getGiveAmountConfig();
    this.getLiveIsExplainGoodsInfo();
    document.addEventListener('click', this.handleDocumentClick);
    this.$root.$on('showLiveRecord', this.handleShowLiveRecord);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.liveTimer) clearInterval(this.liveTimer);
    if (this.rewardTimer) clearInterval(this.rewardTimer);
    this.$ws.close();
    document.removeEventListener('click', this.handleDocumentClick);
    this.$root.$off('showLiveRecord', this.handleShowLiveRecord);
    this.quitChatRoom();
    this.cleanupMediaDevices();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.cleanupMediaDevices();
    next();
  },

  methods: {
    cleanupMediaDevices: function cleanupMediaDevices() {
      if (this.$refs.txyzb && this.$refs.txyzb.livePusher) {
        try {
          this.$refs.txyzb.livePusher.stopCamera();
          this.$refs.txyzb.livePusher.stopMicrophone();
          this.$refs.txyzb.livePusher.stopPush();
          this.$refs.txyzb.livePusher.destroy();
          this.$refs.txyzb.livePusher = null;
        } catch (e) {
          console.warn('清理推流失败:', e);
        }
      }
      if (this.$refs.xietongzhibo && this.$refs.xietongzhibo.selfPusher) {
        try {
          this.$refs.xietongzhibo.selfPusher.stopCamera();
          this.$refs.xietongzhibo.selfPusher.stopMicrophone();
          this.$refs.xietongzhibo.selfPusher.stopPush();
          this.$refs.xietongzhibo.selfPusher.destroy();
          this.$refs.xietongzhibo.selfPusher = null;
        } catch (e) {
          console.warn('清理协同推流失败:', e);
        }
      }
      if (this.$refs.xietongzhibo) {
        this.$refs.xietongzhibo.destroyPlayers();
      }
      navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then(function (stream) {
        stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }).catch(function () {});
      console.log('媒体设备已清理');
    },
    quitChatRoom: function quitChatRoom() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('我退出了直播间');

                if (!_this.liveId) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return (0, _zhibo.quitChatRoom)({ liveId: _this.liveId });

              case 4:
                res = _context.sent;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getChatRoomDetails: function getChatRoomDetails() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var res, newNoticeText;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _zhibo.getChatRoomDetails)({ liveId: _this2.$route.query.liveId });

              case 3:
                res = _context2.sent;

                _this2.data = res.data;
                newNoticeText = res.data.chatRoomDetails.noticeText || '';

                if (newNoticeText && newNoticeText !== _this2.lastNoticeText) {
                  _this2.msgList.push({
                    type: -1,
                    title: newNoticeText
                  });
                  _this2.lastNoticeText = newNoticeText;
                }
                _this2.noticeText = newNoticeText;
                _this2.onlineCount = res.data.chatRoomDetails.onlineUserCount;

                if (_this2.$store.state.userId && res.data.chatRoomDetails.hostUserInfo && res.data.chatRoomDetails.hostUserInfo.userId == JSON.parse(_this2.$store.state.userId)) {
                  _this2.isHost = true;
                } else {
                  _this2.isHost = false;
                }
                _this2.startKeyId = res.data.chatRoomDetails.startKeyId;
                _this2.getGoodsList();
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);

                console.error('获取直播间详情失败:', _context2.t0);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 14]]);
      }))();
    },
    getGoodsList: function getGoodsList() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var res;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _zhibo.getGoodsList)({ liveId: _this3.liveId, startKeyId: _this3.startKeyId });

              case 2:
                res = _context3.sent;

                _this3.goodsList = res.data.map(function (item) {
                  var totalStock = (item.specificationList || []).reduce(function (sum, spec) {
                    return sum + (parseInt(spec.inventory) || 0);
                  }, 0);
                  return (0, _extends3.default)({}, item, { totalStock: totalStock });
                });
                _this3.goodsList.forEach(function (v) {
                  var priceArr = v.specificationList.map(function (item) {
                    return item.price;
                  });
                  if (v.specificationList.length === 1) {
                    v.price = _this3.formatPrice(priceArr[0]);
                  } else {
                    var minPrice = Math.min.apply(Math, (0, _toConsumableArray3.default)(priceArr));
                    var maxPrice = Math.max.apply(Math, (0, _toConsumableArray3.default)(priceArr));
                    if (minPrice === maxPrice) {
                      v.price = _this3.formatPrice(minPrice);
                    } else {
                      v.price = _this3.formatPrice(minPrice) + "-" + _this3.formatPrice(maxPrice);
                    }
                  }
                  v.specificationList.forEach(function (a) {
                    a.price = _this3.formatPrice(a.price);
                  });
                });
                console.log(_this3.goodsList);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleBuyGoods: function handleBuyGoods(item) {
      this.selectedGoods = item;
      this.selectedSpec = item.specificationList[0];
      this.buyCount = 1;
      this.showGoodsModal = true;
    },
    handleDetailBuy: function handleDetailBuy() {
      var _this4 = this;

      this.showGoodsDetail = false;
      setTimeout(function (v) {
        _this4.showGoodsModal = true;
      }, 100);
    },
    selectSpec: function selectSpec(spec) {
      this.selectedSpec = spec;
    },
    decreaseBuyCount: function decreaseBuyCount() {
      if (this.buyCount > 1) {
        this.buyCount--;
      }
    },
    increaseBuyCount: function increaseBuyCount() {
      var maxStock = this.selectedSpec.stock || this.selectedSpec.inventory || 999;
      if (this.buyCount < maxStock) {
        this.buyCount++;
      }
    },
    handleAddToCart: function handleAddToCart() {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var res;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this5.selectedSpec) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.next = 4;
                return (0, _zhibo.submitOrder)({ dbSpecificationId: _this5.selectedSpec.dbSpecificationId, num: _this5.buyCount });

              case 4:
                res = _context4.sent;

                _this5.$message.success(res.msg);
                _this5.showGoodsModal = false;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    handleShowNotice: function handleShowNotice() {
      this.showNotice = true;
    },
    handleCloseNotice: function handleCloseNotice() {
      this.showNotice = false;
    },
    handleUpdateNotice: function handleUpdateNotice() {
      var _this6 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return (0, _zhibo.updNotice)({
                  noticeText: _this6.noticeText,
                  liveId: _this6.$route.query.liveId
                });

              case 3:
                _this6.$message.success(_this6.$t('all.caozuochenggong'));
                _this6.handleCloseNotice();
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);

                console.error('更新公告失败:', _context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 7]]);
      }))();
    },
    getOnlineUserList: function getOnlineUserList() {
      var _this7 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
        var res;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _zhibo.getChatRoomOnlineUserList)({ liveId: _this7.$route.query.liveId, page: 1, size: 100 });

              case 2:
                res = _context6.sent;

                _this7.onlineUserList = res.rows;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    getLiveCommonExpressionsList: function getLiveCommonExpressionsList() {
      var _this8 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
        var res;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return (0, _zhibo.getLiveCommonExpressionsList)({ liveId: _this8.$route.query.liveId });

              case 3:
                res = _context7.sent;

                _this8.kjdyList = res.data || [];
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);

                console.error('获取快捷短语失败:', _context7.t0);

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 7]]);
      }))();
    },
    connectWebSocket: function connectWebSocket() {
      var _this9 = this;

      var liveId = this.$route.query.liveId;
      var userId = this.$store.state.userId;
      this.$ws.connect(liveId, userId);
      this.$ws.onMessage = function (res) {
        if (!res) return;
        var data = JSON.parse(res);
        if (data.data && data.data.pushType == 1) {
          var msg = data.data.details;
          msg.title = _this9.$t('all.jinrulezhibojian');
          msg.type = 1;
          _this9.msgList.push(msg);
          _this9.getOnlineUserList();
          _this9.scrollToBottom();
          _this9.getChatRoomOnlineUserCount();
        }
        if (data.data && data.data.pushType == 2) {
          _this9.getOnlineUserList();
          _this9.getChatRoomOnlineUserCount();
          if (_this9.$refs.xietongzhibo) {
            _this9.$refs.xietongzhibo.getChatRoomDetails();
          }
        }
        if (data.data && data.data.pushType == 3) {
          var _msg = data.data.details;
          _msg.title = data.data.content;
          _msg.type = 3;
          _this9.msgList.push(_msg);
          _this9.scrollToBottom();
        }
        if (data.data && data.data.pushType == 15) {
          _this9.msgList.push({ type: -1, title: data.data.content });
          _this9.scrollToBottom();
        }
        if (data.data && data.data.pushType == 16) {
          var _msg2 = data.data.details;
          _msg2.type = 12;
          _this9.msgList.push(_msg2);
          _this9.scrollToBottom();
        }
        if (data.data && data.data.pushType == 21) {
          _this9.$router.back();
        }
        if (data.data && data.data.pushType == 24) {
          _this9.getLiveCommonExpressionsList();
          _this9.getChatRoomDetails();
          if (_this9.$refs.xietongzhibo) {
            _this9.$refs.xietongzhibo.getChatRoomDetails();
          }
        }
        if (data.data && data.data.pushType == 31) {
          _this9.$refs.xietongzhibo.getChatRoomDetails();
        }
        if (data.data && data.data.pushType == 32) {
          console.log(data.data);
          _this9.rewardList.push(data.data.details);
          if (_this9.rewardList.length > 20) {
            _this9.rewardList.shift();
          }
          _this9.scrollRewardToBottom();
        }
        if (data.data && data.data.pushType == 33) {
          _this9.getGoodsList();
          _this9.getLiveIsExplainGoodsInfo();
        }
        if (data.data && data.data.pushType == 34) {
          _this9.getChatRoomOnlineUserCount();
        }
      };
    },
    getChatRoomOnlineUserCount: function getChatRoomOnlineUserCount() {
      var _this10 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
        var res;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0, _zhibo.getChatRoomOnlineUserCount)({ liveId: _this10.liveId });

              case 2:
                res = _context8.sent;

                _this10.onlineCount = res.data;

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },
    startLiveTimer: function startLiveTimer() {
      var _this11 = this;

      this.liveTimer = setInterval(function () {
        var elapsed = Math.floor((Date.now() - _this11.liveStartTimestamp) / 1000);
        var h = String(Math.floor(elapsed / 3600)).padStart(2, '0');
        var m = String(Math.floor(elapsed % 3600 / 60)).padStart(2, '0');
        var s = String(elapsed % 60).padStart(2, '0');
        _this11.liveTimeText = h + ":" + m + ":" + s;
      }, 1000);
    },
    scrollRewardToBottom: function scrollRewardToBottom() {
      var _this12 = this;

      this.$nextTick(function () {
        var container = _this12.$refs.rewardContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    toggleSound: function toggleSound() {
      this.soundOn = !this.soundOn;
    },
    toggleDanmu: function toggleDanmu() {
      this.danmuOn = !this.danmuOn;
    },
    toggleViewerMic: function toggleViewerMic() {
      var _this13 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
        var helpUser, newStatus, res;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(!_this13.data || !_this13.data.helpLiveUserList)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                helpUser = _this13.data.helpLiveUserList.find(function (item) {
                  return item.userInfo && item.userInfo.userId === this.currentUserId;
                }.bind(_this13));

                if (helpUser) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return");

              case 5:
                newStatus = helpUser.microphoneStatus === 1 ? 0 : 1;
                _context9.next = 8;
                return (0, _zhubo.updateMicrophoneStatus)({ helpId: helpUser.helpId, status: newStatus });

              case 8:
                res = _context9.sent;

                _this13.$message.success(res.msg);
                _this13.getChatRoomDetails();
                if (_this13.$refs.xietongzhibo) {
                  _this13.$refs.xietongzhibo.getChatRoomDetails();
                }

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this13);
      }))();
    },
    toggleViewerCamera: function toggleViewerCamera() {
      var _this14 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
        var helpUser, newStatus, res;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!_this14.data || !_this14.data.helpLiveUserList)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return");

              case 2:
                helpUser = _this14.data.helpLiveUserList.find(function (item) {
                  return item.userInfo && item.userInfo.userId === this.currentUserId;
                }.bind(_this14));

                if (helpUser) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return");

              case 5:
                newStatus = helpUser.cameraStatus === 1 ? 0 : 1;
                _context10.next = 8;
                return (0, _zhubo.updateCameraStatus)({ helpId: helpUser.helpId, status: newStatus });

              case 8:
                res = _context10.sent;

                _this14.$message.success(res.msg);
                _this14.getChatRoomDetails();
                if (_this14.$refs.xietongzhibo) {
                  _this14.$refs.xietongzhibo.getChatRoomDetails();
                }

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this14);
      }))();
    },
    handleColiveSelect: function handleColiveSelect(index) {
      console.log('协同直播切换:', index);
    },
    handleJoinSuccess: function handleJoinSuccess() {
      var _this15 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
        return _regenerator2.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                console.log('112233');
                _context11.next = 3;
                return _this15.getChatRoomDetails();

              case 3:
                _this15.viewerMicOn = true;
                console.log(_this15.viewerMicOn, 'this.viewerMicOn');

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this15);
      }))();
    },
    handleViewerSound: function handleViewerSound() {
      if (this.$refs.txy) {
        this.soundOn = !this.soundOn;
        this.$refs.txy.updateMuted(!this.soundOn);
      }
    },
    getGiveAmountConfig: function getGiveAmountConfig() {
      var _this16 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
        var res;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return (0, _qianbao.getGiveAmountConfig)();

              case 2:
                res = _context12.sent;

                _this16.giveAmountConfig = res.data;

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this16);
      }))();
    },
    handleReward: function handleReward() {
      var _this17 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
        var res;
        return _regenerator2.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return (0, _qianbao.getUserWalletList)();

              case 2:
                res = _context13.sent;

                _this17.walletList = res.data.walletList;
                _this17.showRewardModal = true;

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this17);
      }))();
    },
    handleCustomAmountInput: function handleCustomAmountInput(e) {
      var val = e.target.value;
      val = val.replace(/[^\d.]/g, '');
      val = val.replace(/^\./, '');
      val = val.replace(/\.{2,}/g, '.');
      val = val.replace(/(\.\d{2})\d*/, '$1');
      this.customAmount = val;
    },
    handleConfirmReward: function handleConfirmReward() {
      var _this18 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
        var amount, res;
        return _regenerator2.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                amount = _this18.rewardAmountIndex >= 0 ? _this18.giveAmountConfig.amountList[_this18.rewardAmountIndex] : _this18.customAmount;

                if (!(!amount || parseFloat(amount) <= 0)) {
                  _context14.next = 4;
                  break;
                }

                _this18.$message.error(_this18.$t('all.qingshuruzhengque'));
                return _context14.abrupt("return");

              case 4:
                _context14.next = 6;
                return (0, _qianbao.toGive)({
                  amount: amount,
                  currencyId: _this18.walletList[_this18.rewardCoinIndex].currencyId,
                  liveId: _this18.$route.query.liveId
                });

              case 6:
                res = _context14.sent;

                _this18.$message.success(res.msg);
                _this18.showRewardModal = false;

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this18);
      }))();
    },
    toggleMic: function toggleMic() {
      this.micOn = !this.micOn;
      if (this.micOn) {
        this.volume = 100;
      } else {
        this.volume = 0;
      }
      if (this.$refs.txyzb) {
        this.$refs.txyzb.toggleMic(this.micOn);
      } else if (this.$refs.xietongzhibo) {
        var hostPusher = this.$refs.xietongzhibo.getHostPusherComponent();
        if (hostPusher) {
          hostPusher.toggleMic(this.micOn);
        }
      }
    },
    toggleHostCamera: function toggleHostCamera() {
      var _this19 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
        var hostPusher;
        return _regenerator2.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this19.cameraOn = !_this19.cameraOn;

                if (!_this19.$refs.txyzb) {
                  _context15.next = 6;
                  break;
                }

                _context15.next = 4;
                return _this19.$refs.txyzb.toggleCamera(_this19.cameraOn);

              case 4:
                _context15.next = 7;
                break;

              case 6:
                if (_this19.$refs.xietongzhibo) {
                  hostPusher = _this19.$refs.xietongzhibo.getHostPusherComponent();

                  if (hostPusher) {
                    hostPusher.toggleCamera(_this19.cameraOn);
                  }
                }

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this19);
      }))();
    },
    toggleHostMirror: function toggleHostMirror() {
      this.mirrorOn = !this.mirrorOn;
      if (this.$refs.txyzb) {
        this.$refs.txyzb.toggleMirror(this.mirrorOn);
      } else if (this.$refs.xietongzhibo) {
        var hostPusher = this.$refs.xietongzhibo.getHostPusherComponent();
        if (hostPusher) {
          hostPusher.toggleMirror(this.mirrorOn);
        }
      }
    },
    handleShare: function handleShare() {
      var _this20 = this;

      this.showShareLink = true;
      this.$nextTick(function () {
        var canvas = _this20.$refs.qrcodeCanvas;
        if (canvas) {
          _qrcode2.default.toCanvas(canvas, _this20.data.shareUrl, {
            width: 160,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#ffffff'
            }
          }, function (error) {
            if (error) {
              console.error(error);
            }
          });
        }
      });
    },
    handleShowLiveRecord: function handleShowLiveRecord() {
      var _this21 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16() {
        return _regenerator2.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this21.showLiveRecord = true;
                _this21.recordPage = 1;
                _this21.recordHasMore = true;
                _this21.liveRecordList = [];
                _context16.next = 6;
                return _this21.loadLiveRecordList();

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this21);
      }))();
    },
    loadLiveRecordList: function loadLiveRecordList() {
      var _this22 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
        var hostUserId, response, newList, total;
        return _regenerator2.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(_this22.recordLoading || !_this22.recordHasMore)) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt("return");

              case 2:
                _this22.recordLoading = true;
                _context17.prev = 3;
                hostUserId = _this22.data && _this22.data.chatRoomDetails && _this22.data.chatRoomDetails.hostUserInfo ? _this22.data.chatRoomDetails.hostUserInfo.userId : '';
                _context17.next = 7;
                return (0, _zhibo.getUserLiveRecordList)({ page: _this22.recordPage, size: 20, viewUserId: hostUserId });

              case 7:
                response = _context17.sent;
                newList = response.rows || response.data || [];

                if (_this22.recordPage === 1) {
                  _this22.liveRecordList = newList;
                } else {
                  _this22.liveRecordList = [].concat((0, _toConsumableArray3.default)(_this22.liveRecordList), (0, _toConsumableArray3.default)(newList));
                }
                total = response.total || 0;

                _this22.recordHasMore = _this22.liveRecordList.length < total;
                _context17.next = 17;
                break;

              case 14:
                _context17.prev = 14;
                _context17.t0 = _context17["catch"](3);

                console.error('获取直播记录失败:', _context17.t0);

              case 17:
                _context17.prev = 17;

                _this22.recordLoading = false;
                return _context17.finish(17);

              case 20:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this22, [[3, 14, 17, 20]]);
      }))();
    },
    handleRecordScroll: function handleRecordScroll(e) {
      if (this.recordLoading || !this.recordHasMore) return;
      var target = e.target;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 50) {
        this.recordPage++;
        this.loadLiveRecordList();
      }
    },
    handlePlayRecord: function handlePlayRecord(item) {
      if (item.replayUrl) {
        this.showLiveRecord = false;
        this.$router.push({ path: '/huifang', query: { url: item.replayUrl, name: item.name } });
      }
    },
    handleShowGoods: function handleShowGoods() {
      this.showViewerLeft = !this.showViewerLeft;
    },
    handleCopyLink: function handleCopyLink() {
      navigator.clipboard.writeText(this.data.shareUrl);
      this.$message.success(this.$t('all.fuzhichenggong'));
    },
    handleSaveQr: function handleSaveQr() {
      var canvas = this.$refs.qrcodeCanvas;
      if (!canvas) {
        this.$message.info(this.$t('all.qrcodenotexist'));
        return;
      }
      var link = document.createElement('a');
      link.download = 'qrcode.png';
      link.href = canvas.toDataURL('image/png');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$message.success(this.$t('all.qrcodesaved'));
    },
    handleVolumeChange: function handleVolumeChange() {
      var vol = Number(this.volume);
      this.micOn = vol > 0;
      if (this.$refs.txyzb) {
        this.$refs.txyzb.setVolume(vol);
      } else if (this.$refs.xietongzhibo) {
        var hostPusher = this.$refs.xietongzhibo.getHostPusherComponent();
        if (hostPusher) {
          hostPusher.setVolume(vol);
        }
      }
    },
    setVolume: function setVolume(val) {
      this.volume = val;
      this.micOn = val > 0;
      if (this.$refs.txyzb) {
        this.$refs.txyzb.setVolume(val);
      } else if (this.$refs.xietongzhibo) {
        var hostPusher = this.$refs.xietongzhibo.getHostPusherComponent();
        if (hostPusher) {
          hostPusher.setVolume(val);
        }
      }
    },
    decreaseStock: function decreaseStock(item) {
      if (item.liveStock > 0) item.liveStock--;
    },
    increaseStock: function increaseStock(item) {
      item.liveStock++;
    },
    handleSend: function handleSend() {
      var _this23 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
        var content;
        return _regenerator2.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                content = _this23.chatContent.trim();

                if (content) {
                  _context18.next = 3;
                  break;
                }

                return _context18.abrupt("return");

              case 3:
                _context18.prev = 3;
                _context18.next = 6;
                return (0, _zhibo.chatRoomSendMsg)({ liveId: _this23.$route.query.liveId, content: content });

              case 6:
                _this23.chatContent = '';
                _context18.next = 12;
                break;

              case 9:
                _context18.prev = 9;
                _context18.t0 = _context18["catch"](3);

                console.error('发送消息失败:', _context18.t0);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this23, [[3, 9]]);
      }))();
    },
    handleSendKjdy: function handleSendKjdy(content) {
      var _this24 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19() {
        return _regenerator2.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return (0, _zhibo.chatRoomSendMsg)({ liveId: _this24.$route.query.liveId, content: content });

              case 3:
                _context19.next = 8;
                break;

              case 5:
                _context19.prev = 5;
                _context19.t0 = _context19["catch"](0);

                console.error('发送快捷短语失败:', _context19.t0);

              case 8:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this24, [[0, 5]]);
      }))();
    },
    handleAddKjdy: function handleAddKjdy() {
      var _this25 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20() {
        return _regenerator2.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (_this25.newKjdyContent.trim()) {
                  _context20.next = 2;
                  break;
                }

                return _context20.abrupt("return");

              case 2:
                _context20.prev = 2;
                _context20.next = 5;
                return (0, _zhibo.addLiveCommonExpressions)({ content: _this25.newKjdyContent, liveId: _this25.$route.query.liveId });

              case 5:
                _this25.newKjdyContent = '';
                _this25.showKjdyAdd = false;
                _this25.getLiveCommonExpressionsList();
                _context20.next = 13;
                break;

              case 10:
                _context20.prev = 10;
                _context20.t0 = _context20["catch"](2);

                console.error('添加快捷短语失败:', _context20.t0);

              case 13:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this25, [[2, 10]]);
      }))();
    },
    handleDelKjdy: function handleDelKjdy(id) {
      var _this26 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21() {
        return _regenerator2.default.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return (0, _zhibo.delLiveCommonExpressions)({ id: id, liveId: _this26.$route.query.liveId });

              case 3:
                _this26.getLiveCommonExpressionsList();
                _context21.next = 9;
                break;

              case 6:
                _context21.prev = 6;
                _context21.t0 = _context21["catch"](0);

                console.error('删除快捷短语失败:', _context21.t0);

              case 9:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this26, [[0, 6]]);
      }))();
    },
    handleEndLive: function handleEndLive() {
      var _this27 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22() {
        return _regenerator2.default.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                _context22.next = 3;
                return (0, _zhibo.closeChatRoom)({ liveId: _this27.$route.query.liveId });

              case 3:
                _this27.$message.success(_this27.$t('all.caozuochenggong'));
                _this27.$router.go(-1);
                _context22.next = 10;
                break;

              case 7:
                _context22.prev = 7;
                _context22.t0 = _context22["catch"](0);

                console.error('结束直播失败:', _context22.t0);

              case 10:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this27, [[0, 7]]);
      }))();
    },
    scrollToBottom: function scrollToBottom() {
      var _this28 = this;

      this.$nextTick(function () {
        var container = _this28.$refs.chatContainer;
        if (container) container.scrollTop = container.scrollHeight;
      });
    },
    autoResize: function autoResize() {
      var el = this.$refs.chatInput;
      if (el) {
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 80) + 'px';
      }
    },
    startDragScroll: function startDragScroll(e) {
      this.isDragging = true;
      this.dragStartX = e.pageX - this.$refs.quickTags.offsetLeft;
      this.dragScrollLeft = this.$refs.quickTags.scrollLeft;
    },
    doDragScroll: function doDragScroll(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      var x = e.pageX - this.$refs.quickTags.offsetLeft;
      var walk = (x - this.dragStartX) * 1.5;
      this.$refs.quickTags.scrollLeft = this.dragScrollLeft - walk;
    },
    stopDragScroll: function stopDragScroll() {
      this.isDragging = false;
    },
    handleShowModelFj: function handleShowModelFj(data, index) {
      if (!data.sendUserId) return;
      if (this.showModelFj && this.sendUserId === data.sendUserId) {
        this.showModelFj = false;
        this.sendUserId = null;
      } else {
        this.msgIndex = index;
        this.getChatRoomUserDetails(data.sendUserId);
      }
    },
    getChatRoomUserDetails: function getChatRoomUserDetails(userId) {
      var _this29 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee23() {
        var res;
        return _regenerator2.default.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return (0, _zhibo.getChatRoomUserDetails)({
                  liveId: _this29.$route.query.liveId,
                  toUserId: userId
                });

              case 2:
                res = _context23.sent;

                _this29.sendUserInfo = res.data.subjoinParameter.chatRoomUserCurrentRecordsInfo;
                console.log(_this29.sendUserInfo);
                _this29.sendUserId = userId;
                _this29.showModelFj = true;

              case 7:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this29);
      }))();
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (e.target.closest('.zbz-chat-item-fj')) return;
      if (e.target.closest('.zbz-chat-content-wrapper')) return;
      this.closeModelFj();
      this.closeOnlineFj();
    },
    closeModelFj: function closeModelFj() {
      this.showModelFj = false;
      this.sendUserId = null;
      this.msgIndex = -1;
    },
    closeOnlineFj: function closeOnlineFj() {
      this.showOnlineFj = false;
      this.onlineIndex = -1;
    },
    handleShowOnlineFj: function handleShowOnlineFj(item, index) {
      if (!item.userId) return;
      if (this.showOnlineFj && this.onlineIndex === index) {
        this.showOnlineFj = false;
        this.onlineIndex = -1;
      } else {
        this.onlineIndex = index;
        this.getOnlineUserDetails(item.userId);
      }
    },
    getOnlineUserDetails: function getOnlineUserDetails(userId) {
      var _this30 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee24() {
        var res;
        return _regenerator2.default.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return (0, _zhibo.getChatRoomUserDetails)({
                  liveId: _this30.$route.query.liveId,
                  toUserId: userId
                });

              case 2:
                res = _context24.sent;

                _this30.onlineUserInfo = res.data.subjoinParameter.chatRoomUserCurrentRecordsInfo;
                _this30.showOnlineFj = true;

              case 5:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this30);
      }))();
    },
    handleBannedUserById: function handleBannedUserById() {
      var _this31 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee25() {
        var res;
        return _regenerator2.default.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (_this31.onlineUserInfo) {
                  _context25.next = 2;
                  break;
                }

                return _context25.abrupt("return");

              case 2:
                _context25.prev = 2;
                res = void 0;

                if (!(_this31.onlineUserInfo.isBannedToPost == 0)) {
                  _context25.next = 10;
                  break;
                }

                _context25.next = 7;
                return (0, _zhibo.bannedToPostUser)({
                  liveId: _this31.$route.query.liveId,
                  toUserId: _this31.onlineUserInfo.userId
                });

              case 7:
                res = _context25.sent;
                _context25.next = 13;
                break;

              case 10:
                _context25.next = 12;
                return (0, _zhibo.relieveBannedToPostUser)({
                  liveId: _this31.$route.query.liveId,
                  toUserId: _this31.onlineUserInfo.userId
                });

              case 12:
                res = _context25.sent;

              case 13:
                _this31.$message.success(res.msg);
                _this31.closeOnlineFj();
                _context25.next = 20;
                break;

              case 17:
                _context25.prev = 17;
                _context25.t0 = _context25["catch"](2);

                console.error('禁言失败:', _context25.t0);

              case 20:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this31, [[2, 17]]);
      }))();
    },
    handleKickUserById: function handleKickUserById(userId) {
      var _this32 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee26() {
        return _regenerator2.default.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                _context26.next = 3;
                return (0, _zhibo.kickOutChatRoom)({
                  liveId: _this32.$route.query.liveId,
                  toUserId: userId,
                  kickOutMinutes: 1
                });

              case 3:
                _this32.$message.success(_this32.$t('all.caozuochenggong'));
                _this32.closeOnlineFj();
                _this32.getOnlineUserList();
                _context26.next = 11;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](0);

                console.error('踢出失败:', _context26.t0);

              case 11:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this32, [[0, 8]]);
      }))();
    },
    handleBannedUser: function handleBannedUser(msg) {
      var _this33 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee27() {
        var res;
        return _regenerator2.default.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (msg.sendUserId) {
                  _context27.next = 2;
                  break;
                }

                return _context27.abrupt("return");

              case 2:
                res = void 0;

                if (!(_this33.sendUserInfo.isBannedToPost == 0)) {
                  _context27.next = 7;
                  break;
                }

                _context27.next = 6;
                return (0, _zhibo.bannedToPostUser)({
                  liveId: _this33.$route.query.liveId,
                  toUserId: msg.sendUserId
                });

              case 6:
                res = _context27.sent;

              case 7:
                if (!(_this33.sendUserInfo.isBannedToPost == 1)) {
                  _context27.next = 11;
                  break;
                }

                _context27.next = 10;
                return (0, _zhibo.relieveBannedToPostUser)({
                  liveId: _this33.$route.query.liveId,
                  toUserId: msg.sendUserId
                });

              case 10:
                res = _context27.sent;

              case 11:
                _this33.$message.success(res.msg);
                _this33.closeModelFj();

              case 13:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this33);
      }))();
    },
    handleKickUser: function handleKickUser(msg) {
      var _this34 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee28() {
        var res;
        return _regenerator2.default.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (msg.sendUserId) {
                  _context28.next = 2;
                  break;
                }

                return _context28.abrupt("return");

              case 2:
                _context28.next = 4;
                return (0, _zhibo.kickOutChatRoom)({
                  liveId: _this34.$route.query.liveId,
                  toUserId: msg.sendUserId,
                  kickOutMinutes: 1
                });

              case 4:
                res = _context28.sent;

                _this34.$message.success(res.msg);
                _this34.closeModelFj();
                _this34.getOnlineUserList();

              case 8:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this34);
      }))();
    },
    handleCreateHelpLive: function handleCreateHelpLive() {
      this.$refs.xietongzhibo.showModel();
    },
    handleHelpLiveToggle: function handleHelpLiveToggle() {
      var _this35 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee29() {
        return _regenerator2.default.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!(_this35.data.isOpenHelp != 1)) {
                  _context29.next = 3;
                  break;
                }

                _this35.$message.warning(_this35.$t('all.zanweikaiqi'));
                return _context29.abrupt("return");

              case 3:
                if (!_this35.isJoinedHelpLive) {
                  _context29.next = 11;
                  break;
                }

                if (!_this35.$refs.xietongzhibo) {
                  _context29.next = 9;
                  break;
                }

                _context29.next = 7;
                return _this35.$refs.xietongzhibo.handleExitHelp();

              case 7:
                _context29.next = 9;
                return _this35.getChatRoomDetails();

              case 9:
                _context29.next = 12;
                break;

              case 11:
                if (_this35.$refs.xietongzhibo) {
                  _this35.$refs.xietongzhibo.handleJoinLive();
                }

              case 12:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this35);
      }))();
    },
    handleExitHelpLive: function handleExitHelpLive() {
      if (this.$refs.xietongzhibo) {
        this.$refs.xietongzhibo.handleExitHelp();
      }
    },
    setGoodsExplain: function setGoodsExplain(data) {
      var _this36 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee30() {
        var res;
        return _regenerator2.default.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return (0, _zhibo.setGoodsExplain)({ liveId: _this36.liveId, dbGoodsId: data.dbGoodsId });

              case 2:
                res = _context30.sent;

                _this36.$message.success(res.msg);

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this36);
      }))();
    },
    getLiveIsExplainGoodsInfo: function getLiveIsExplainGoodsInfo() {
      var _this37 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee31() {
        var res, priceArr, minPrice, maxPrice;
        return _regenerator2.default.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return (0, _zhibo.getLiveIsExplainGoodsInfo)({ liveId: _this37.liveId });

              case 2:
                res = _context31.sent;

                if (res.data) {
                  _context31.next = 5;
                  break;
                }

                return _context31.abrupt("return");

              case 5:
                _this37.productPopupData = res.data;
                priceArr = _this37.productPopupData.specificationList.map(function (item) {
                  return item.price;
                });

                if (_this37.productPopupData.specificationList.length === 1) {
                  _this37.productPopupData.price = _this37.formatPrice(priceArr[0]);
                } else {
                  minPrice = Math.min.apply(Math, (0, _toConsumableArray3.default)(priceArr));
                  maxPrice = Math.max.apply(Math, (0, _toConsumableArray3.default)(priceArr));

                  if (minPrice === maxPrice) {
                    _this37.productPopupData.price = _this37.formatPrice(minPrice);
                  } else {
                    _this37.productPopupData.price = _this37.formatPrice(minPrice) + "-" + _this37.formatPrice(maxPrice);
                  }
                }
                _this37.productPopupData.specificationList.forEach(function (v) {
                  v.price = _this37.formatPrice(v.price);
                });
                _this37.showProductPopup = true;

              case 10:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this37);
      }))();
    },
    hideProduct: function hideProduct() {
      this.showProductPopup = false;
    },
    handleProductClick: function handleProductClick() {
      this.selectedGoods = this.productPopupData;
      this.selectedSpec = this.productPopupData.specificationList[0];
      this.buyCount = 1;
      this.detailCarouselIndex = 0;
      this.showGoodsDetail = true;
    },
    handleViewGoodsDetail: function handleViewGoodsDetail(item) {
      this.selectedGoods = item;
      this.selectedSpec = item.specificationList[0];
      this.buyCount = 1;
      this.detailCarouselIndex = 0;
      this.showGoodsDetail = true;
    },
    formatPrice: function formatPrice(price) {
      return price;
    },
    handlePlayVideo: function handlePlayVideo(data) {
      this.$router.push({
        path: '/huifang',
        query: {
          url: data.replayUrl,
          viewUserId: this.data.chatRoomDetails.hostUserInfo.userId
        }
      });
    }
  }
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _zhiboshenqing = __webpack_require__(111);

var _kong = __webpack_require__(19);

var _kong2 = _interopRequireDefault(_kong);

var _zbList = __webpack_require__(207);

var _zbList2 = _interopRequireDefault(_zbList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { kong: _kong2.default, zbList: _zbList2.default },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.showSqModal = to.query.showSqModal === 'true';
      if (vm.showSqModal) {
        vm.handleShenqingZhibo(true);
      }
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var shouldShow = to.query.showSqModal === 'true';
    this.showSqModal = shouldShow;
    if (shouldShow) {
      this.handleShenqingZhibo(true);
    }
    next();
  },
  data: function data() {
    return {
      list: [],
      queryParams: {
        page: 1,
        size: 20,
        viewUserId: ''
      },
      showSqModal: false,
      showCalendar: false,
      sqForm: {
        liveDate: '',
        timeSlot: '',
        timeRange: null,
        liveType: 1,
        isDaihuo: false,
        remark: '',
        accountId: ''
      },
      calendarYear: new Date().getFullYear(),
      calendarMonth: new Date().getMonth() + 1,
      selectedDay: new Date().getDate(),
      selectedSlot: -1,
      timeSlots: [],
      weekDays: [],
      isLoading: false,
      loaded: false
    };
  },

  computed: {
    calendarMonthText: function calendarMonthText() {
      return this.calendarYear + this.$t('all.nian') + this.calendarMonth + this.$t('all.yue');
    },
    calendarDays: function calendarDays() {
      var year = this.calendarYear;
      var month = this.calendarMonth;
      var firstDay = new Date(year, month - 1, 1).getDay();
      var daysInMonth = new Date(year, month, 0).getDate();
      var today = new Date();
      var todayDate = today.getDate();
      var todayMonth = today.getMonth() + 1;
      var todayYear = today.getFullYear();

      var offset = firstDay === 0 ? 6 : firstDay - 1;
      var days = [];
      for (var i = 0; i < offset; i++) {
        days.push({ num: null });
      }
      for (var d = 1; d <= daysInMonth; d++) {
        var isPast = year < todayYear || year === todayYear && month < todayMonth || year === todayYear && month === todayMonth && d < todayDate;
        days.push({ num: d, isPast: isPast, isSelected: this.selectedDay === d });
      }
      return days;
    }
  },
  mounted: function mounted() {
    this.queryParams.viewUserId = this.$store.state.userId;
    this.weekDays = [this.$t('all.zhou1'), this.$t('all.zhou2'), this.$t('all.zhou3'), this.$t('all.zhou4'), this.$t('all.zhou5'), this.$t('all.zhou6'), this.$t('all.zhou7')];
    this.getList();
  },

  methods: {
    getList: function getList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.isLoading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.isLoading = true;
                _context.prev = 3;
                _context.next = 6;
                return (0, _zhibo.getUserLiveRecordList)(_this.queryParams);

              case 6:
                response = _context.sent;

                _this.list = response.rows || [];
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

                console.error("获取直播记录失败:", _context.t0);
                _this.list = [];

              case 14:
                _context.prev = 14;

                _this.isLoading = false;
                _this.loaded = true;
                return _context.finish(14);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 10, 14, 18]]);
      }))();
    },
    handleShenqingZhibo: function handleShenqingZhibo() {
      var _this2 = this;

      var showModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var today;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (showModal) {
                  _this2.showSqModal = true;
                }
                _this2.showCalendar = false;
                _this2.sqForm.liveDate = '';
                _this2.sqForm.timeSlot = '';
                today = new Date();

                _this2.calendarYear = today.getFullYear();
                _this2.calendarMonth = today.getMonth() + 1;
                _this2.selectedDay = today.getDate();
                _this2.selectedSlot = -1;
                _context2.next = 11;
                return _this2.fetchAvailableSlots();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleShowCalendar: function handleShowCalendar() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var today, parts;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.showCalendar = true;
                today = new Date();

                if (_this3.sqForm.liveDate) {
                  parts = _this3.sqForm.liveDate.split('/');

                  if (parts.length === 3) {
                    _this3.calendarYear = parseInt(parts[0]);
                    _this3.calendarMonth = parseInt(parts[1]);
                    _this3.selectedDay = parseInt(parts[2]);
                  }
                } else {
                  _this3.calendarYear = today.getFullYear();
                  _this3.calendarMonth = today.getMonth() + 1;
                  _this3.selectedDay = today.getDate();
                }
                _context3.next = 5;
                return _this3.fetchAvailableSlots();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    fetchAvailableSlots: function fetchAvailableSlots() {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var dateStr, res, data;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                dateStr = _this4.calendarYear + "-" + String(_this4.calendarMonth).padStart(2, '0') + "-" + String(_this4.selectedDay || new Date().getDate()).padStart(2, '0');
                _context4.next = 4;
                return (0, _zhiboshenqing.getLiveApplyTimeList)({ liveDate: dateStr });

              case 4:
                res = _context4.sent;
                data = res.data || res;

                if (Array.isArray(data)) {
                  _this4.timeSlots = data;
                }
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);

                console.error("获取可用时段失败:", _context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    handleShenqingJilu: function handleShenqingJilu() {
      this.$router.push('/shenqingjilu');
    },
    handleHuifangJilu: function handleHuifangJilu() {
      this.$router.push('/huifang');
    },
    handlePlayVideo: function handlePlayVideo(item) {
      this.$router.push({
        path: '/huifang',
        query: {
          url: item.replayUrl,
          name: item.name,
          period: item.period
        }
      });
    },
    handleListDelete: function handleListDelete() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleSubmitSq: function handleSubmitSq() {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var vo, res;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                vo = {
                  isGoods: _this5.sqForm.isDaihuo ? 1 : 0,
                  liveDate: _this5.sqForm.liveDate.replace(/\//g, '-'),
                  liveTime: _this5.sqForm.timeSlot,
                  liveType: _this5.sqForm.liveType,
                  businessAccount: _this5.sqForm.accountId || '',
                  submitMsg: _this5.sqForm.remark || ''
                };
                _context5.next = 3;
                return (0, _zhiboshenqing.submitLiveApply)(vo);

              case 3:
                res = _context5.sent;

                _this5.$message.success(res.msg || _this5.$t('all.tijiaochenggong'));
                _this5.showSqModal = false;
                _this5.sqForm = {
                  liveDate: '',
                  timeSlot: '',
                  timeRange: null,
                  liveType: 1,
                  isDaihuo: true,
                  remark: '',
                  accountId: ''
                };
                _this5.$router.push({
                  path: '/tijiaoshenqing',
                  query: {
                    liveDate: vo.liveDate,
                    timeSlot: vo.liveTime
                  }
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    changeMonth: function changeMonth(offset) {
      this.calendarMonth += offset;
      if (this.calendarMonth > 12) {
        this.calendarMonth = 1;
        this.calendarYear++;
      } else if (this.calendarMonth < 1) {
        this.calendarMonth = 12;
        this.calendarYear--;
      }
      this.fetchAvailableSlots();
    },
    getDayClass: function getDayClass(day) {
      if (!day.num) return 'sq-calendar-day-empty';
      if (day.isSelected) return 'sq-calendar-day-selected';
      if (day.isPast) return 'sq-calendar-day-past';
      return 'sq-calendar-day';
    },
    selectDay: function selectDay(day) {
      if (!day.num || day.isPast) return;
      this.selectedDay = day.num;
      this.selectedSlot = -1;
      this.fetchAvailableSlots();
    },
    confirmDateTime: function confirmDateTime() {
      if (!this.selectedDay) {
        this.$message.warning(this.$t('all.qingxuanzeriqi'));
        return;
      }
      if (this.selectedSlot < 0) {
        this.$message.warning(this.$t('all.qingxuanzeshijian'));
        return;
      }
      var month = String(this.calendarMonth).padStart(2, '0');
      var day = String(this.selectedDay).padStart(2, '0');
      this.sqForm.liveDate = this.calendarYear + "/" + month + "/" + day;
      this.sqForm.timeSlot = this.timeSlots[this.selectedSlot];
      this.showCalendar = false;
    }
  }
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(3);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(49);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(2);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zhibo = __webpack_require__(7);

var _trtcSdkV = __webpack_require__(867);

var _trtcSdkV2 = _interopRequireDefault(_trtcSdkV);

var _jsCookie = __webpack_require__(106);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			loading: false,
			data: '',
			userList: [],
			trtc: null,
			remoteStream: null,
			roomId: this.$route.query.roomId,
			token: this.$store.state.token,
			userSign: null,
			appId: 1600106184,
			userId: null,
			msgList: [{
				title: '平台严禁未成年人充值打赏，严禁以陪玩等方式诱导打赏私下交易，严禁涉黃涉政、谩骂等内容，请注意财产安全，谨防网络诈骗，理性消费。'
			}],
			liveInData: '',
			timer: null,
			goodsList: [],
			openK: false,
			formK: {},
			navList: [{
				name: '在线'
			}, {
				name: '已封禁'
			}],
			navListIndex: 0,

			open2: false,
			form2: {
				dbRecordId: '',
				time: '',
				roomId: this.$route.query.roomId
			},
			open3: false,
			form3: {
				dbRecordId: '',
				time: '',
				roomId: this.$route.query.roomId
			},
			rules: {}
		};
	},
	created: function created() {
		this.getRoomInfo();

		this.getLiveRoomAddGoodsList();
		this.getMessage();
	},

	methods: {
		getMessage: function getMessage() {
			var _this = this;

			this.$ws.onMessage = function (res) {
				var data = JSON.parse(res);
				if (data.data && data.data.pushType == 1) {
					console.log('更新用户');
					_this.getLiveOnlineUserList();
				}
				if (data.data && data.data.pushType == 3) {
					console.log(data);
					var msg = data.data.details;
					msg.title = data.data.title;
					console.log(msg);
					_this.msgList.push(msg);
					_this.$nextTick(function () {
						return _this.scrollDanmuToBottom();
					});
				}
				if (data.data && data.data.pushType == 2) {
					console.log('更新用户3');
					_this.getLiveOnlineUserList();
				}
				if (data.data && data.data.pushType == 4) {
					_this.getRoomInfo();
				}
				if (data.data && data.data.pushType == 5) {
					_this.getRoomInfo();
					setTimeout(function (v) {
						_this.destroyTRTC();
					}, 500);
				}
				if (data.data && data.data.pushType == 7) {
					console.log(data);
					if (data.data.details.sendUserInfo) {
						var _msg = data.data.details;
						_msg.title = data.data.title;
						_this.msgList.push(_msg);
						_this.$nextTick(function () {
							return _this.scrollDanmuToBottom();
						});
					}
				}
				if (data.data && data.data.pushType == 9) {
					_this.getLiveRoomAddGoodsList();
				}
				if (data.data && data.data.pushType == 10) {
					console.log(data);
					_this.data.giveCount = data.data.details.giveCount;
					if (data.data.details.sendUserInfo) {
						var _msg2 = data.data.details;
						_msg2.title = data.data.title;
						_msg2.type = 10;
						_this.msgList.push(_msg2);
					}
					_this.$nextTick(function () {
						return _this.scrollDanmuToBottom();
					});
				}
				if (data.code == 401) {
					_this.destroyTRTC();
				}
			};
		},
		scrollDanmuToBottom: function scrollDanmuToBottom() {
			var danmuContainer = this.$refs.danmuContainer;
			if (danmuContainer) {
				danmuContainer.scrollTop = danmuContainer.scrollHeight;
			}
		},
		getRoomInfo: function getRoomInfo() {
			var _this2 = this;

			this.loading = true;
			(0, _zhibo.getRoomInfo)({ roomId: this.roomId }).then(function (response) {
				_this2.loading = false;
				_this2.data = response.data;
				if (_this2.data.roomStatus == 1) {
					_this2.getLiveOnlineUserList();

					_this2.getLiveInStatistics();
					_this2.timer = setInterval(function (v) {
						_this2.getLiveInStatistics();
					}, 20000);
					if (!_this2.trtc) {
						_this2.createTencentCloudImUserSig();
					}
					_this2.$ws.connect(_this2.roomId, _this2.token);
				} else {
					_this2.getEndStatistics();
				}
			});
		},
		handleNav: function handleNav(index) {
			this.navListIndex = index;
			if (index == 0) {
				this.getLiveOnlineUserList();
			} else {
				this.getForbidUserList();
			}
		},
		getLiveOnlineUserList: function getLiveOnlineUserList() {
			var _this3 = this;

			(0, _zhibo.getLiveOnlineUserList)({ roomId: this.roomId, page: 1, size: 5000 }).then(function (response) {
				_this3.userList = response.rows;
			});
		},
		getForbidUserList: function getForbidUserList() {
			var _this4 = this;

			(0, _zhibo.getForbidUserList)({ roomId: this.roomId, page: 1, size: 5000, type: 2 }).then(function (response) {
				_this4.userList = response.rows;
			});
		},
		getLiveRoomAddGoodsList: function getLiveRoomAddGoodsList() {
			var _this5 = this;

			(0, _zhibo.getLiveRoomAddGoodsList)({ roomId: this.roomId, page: 1, size: 1000 }).then(function (response) {
				_this5.goodsList = response.rows;
			});
		},
		getLiveInStatistics: function getLiveInStatistics() {
			var _this6 = this;

			(0, _zhibo.getLiveInStatistics)({ roomId: this.roomId }).then(function (response) {
				_this6.liveInData = response.data;
			});
		},
		getEndStatistics: function getEndStatistics() {
			var _this7 = this;

			(0, _zhibo.getEndStatistics)({ roomId: this.roomId }).then(function (response) {
				_this7.liveInData = response.data;
			});
		},
		handleUpdateKc: function handleUpdateKc(row) {
			var _this8 = this;

			(0, _zhibo.getGoodsDetails)({ goodsId: row.goodsId }).then(function (response) {
				_this8.formK = response.data;
				_this8.openK = true;
			});
		},
		addForbid: function addForbid(id, type) {
			var that = this;
			that.$confirm(type === 1 ? '确定禁止该用户购买商品吗？' : type === 2 ? '确定禁止该用户访问直播间吗？' : '确定禁止该用户发布评论吗？', '提示').then(function () {
				(0, _zhibo.addForbid)({
					toUserId: id,
					type: type,
					roomId: that.roomId
				}).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.getLiveOnlineUserList();
				});
			});
		},
		handleCommand: function handleCommand(data) {
			console.log(data, data.data.sendUserInfo, 123);
			this.addForbid(data.data.sendUserInfo.userId, data.type);
		},
		relieveForbid: function relieveForbid(id, type) {
			var that = this;
			that.$confirm(type === 1 ? '确定允许该用户购买商品吗？' : type === 2 ? '确定允许该用户访问直播间吗？' : '确定允许该用户发布评论吗？', '提示').then(function () {
				(0, _zhibo.relieveForbid)({
					toUserId: id,
					type: type,
					roomId: that.roomId
				}).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					if (type == 2) {
						that.getForbidUserList();
					} else {
						that.getLiveOnlineUserList();
					}
				});
			});
		},
		submitFormK: function submitFormK() {
			var that = this;
			this.$confirm('确定修改商品库存吗？', '提示').then(function () {
				(0, _zhibo.updGoods)(that.formK).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.openK = false;
					that.getLiveRoomAddGoodsList();
				});
			});
		},
		updateGoodsExplanationStatus: function updateGoodsExplanationStatus(dbRecordId, status) {
			var that = this;
			that.$confirm(status === 1 ? '确定讲解该商品吗？' : '确定取消讲解该商品吗？', '提示').then(function () {
				(0, _zhibo.updateGoodsExplanationStatus)({
					dbRecordId: dbRecordId,
					status: status,
					roomId: that.roomId
				}).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.getLiveRoomAddGoodsList();
				});
			});
		},
		updateGoodsStatus: function updateGoodsStatus(dbRecordId, goodsStatus) {
			var that = this;
			that.$confirm(goodsStatus === 1 ? '确定上架该商品吗？' : goodsStatus === 2 ? '确定下架该商品吗？' : '确定设置该商品已售罄吗？', '提示').then(function () {
				(0, _zhibo.updateGoodsStatus)({
					dbRecordId: dbRecordId,
					goodsStatus: goodsStatus,
					roomId: that.roomId
				}).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.getLiveRoomAddGoodsList();
				});
			});
		},
		handleDelete: function handleDelete(row) {
			var that = this;
			that.$confirm('确定删除该商品吗？', '提示').then(function () {
				(0, _zhibo.delGoods)({
					roomId: that.roomId,
					dbRecordId: row.dbRecordId
				}).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.getLiveRoomAddGoodsList();
				});
			});
		},
		updateGoodsSort: function updateGoodsSort(dbRecordId, type) {
			var that = this;
			that.$confirm(type === 1 ? '确定下移该商品吗？' : '确定上移该商品吗？', '提示').then(function () {
				(0, _zhibo.updateGoodsSort)({
					dbRecordId: dbRecordId,
					type: type,
					roomId: that.roomId
				}).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.getLiveRoomAddGoodsList();
				});
			});
		},
		handleUpdateDssj: function handleUpdateDssj(row) {
			this.form2.dbRecordId = row.dbRecordId;
			this.form2.time = row.taskListedTime;
			this.open2 = true;
		},
		submitForm2: function submitForm2() {
			var that = this;
			this.$confirm('确定修改定时上架时间吗？', '提示').then(function () {
				(0, _zhibo.updateGoodsTaskListedTime)(that.form2).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.open2 = false;
					that.getLiveRoomAddGoodsList();
				});
			});
		},
		handleUpdateDsxj: function handleUpdateDsxj(row) {
			this.form3.dbRecordId = row.dbRecordId;
			this.form3.time = row.taskShelvesTime;
			this.open3 = true;
		},
		submitForm3: function submitForm3() {
			var that = this;
			this.$confirm('确定修改定时下架时间吗？', '提示').then(function () {
				(0, _zhibo.updateGoodsTaskShelvesTime)(that.form3).then(function (response) {
					that.$message({ message: response.msg, type: 'success' });
					that.open3 = false;
					that.getLiveRoomAddGoodsList();
				});
			});
		},
		createTencentCloudImUserSig: function createTencentCloudImUserSig() {
			var _this9 = this;

			(0, _zhibo.createTencentCloudImUserSig)({ roomId: this.roomId }).then(function (response) {
				_this9.userSign = response.data.userSig;
				_this9.userId = response.data.token;
				_this9.initTRTC();
			});
		},
		initTRTC: function initTRTC() {
			var _this10 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_this10.trtc = _trtcSdkV2.default.create();

								_this10.trtc.on(_trtcSdkV2.default.EVENT.REMOTE_VIDEO_AVAILABLE, function () {
									var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref2) {
										var userId = _ref2.userId,
										    streamType = _ref2.streamType;
										return _regenerator2.default.wrap(function _callee$(_context) {
											while (1) {
												switch (_context.prev = _context.next) {
													case 0:
														console.log('远端视频流可用1', userId, streamType);
														_context.prev = 1;
														_context.next = 4;
														return new _promise2.default(function (resolve) {
															return setTimeout(resolve, 500);
														});

													case 4:
														_context.next = 6;
														return _this10.trtc.startRemoteVideo({
															userId: userId,
															streamType: streamType,
															view: document.getElementById('remote-video'),

															renderParams: {
																mirror: false,
																objectFit: 'cover',
																smooth: true }
														});

													case 6:
														_this10.isVideoSubscribed = true;
														_context.next = 12;
														break;

													case 9:
														_context.prev = 9;
														_context.t0 = _context['catch'](1);

														console.error('启动远程视频失败:', _context.t0);

													case 12:
														_context.prev = 12;
														return _context.finish(12);

													case 14:
													case 'end':
														return _context.stop();
												}
											}
										}, _callee, _this10, [[1, 9, 12, 14]]);
									}));

									return function (_x) {
										return _ref.apply(this, arguments);
									};
								}());

								_this10.trtc.on(_trtcSdkV2.default.EVENT.REMOTE_VIDEO_UNAVAILABLE, function (_ref3) {
									var userId = _ref3.userId,
									    streamType = _ref3.streamType;

									console.log('远端视频流不可用', userId, streamType);
								});

								_this10.trtc.on(_trtcSdkV2.default.EVENT.REMOTE_VIDEO_STREAM_TYPE_CHANGED, function (_ref4) {
									var userId = _ref4.userId,
									    oldStreamType = _ref4.oldStreamType,
									    newStreamType = _ref4.newStreamType;

									console.log('\u7528\u6237 ' + userId + ' \u89C6\u9891\u6D41\u7C7B\u578B\u4ECE ' + oldStreamType + ' \u53D8\u4E3A ' + newStreamType);
								});
								_this10.trtc.on(_trtcSdkV2.default.EVENT.KICKED_OUT, function (event) {});

								_context2.prev = 5;
								_context2.next = 8;
								return _this10.trtc.enterRoom({
									strRoomId: _this10.roomId,
									sdkAppId: _this10.appId,
									userId: _this10.userId,
									userSig: _this10.userSign,
									enableAutoPlayDialog: false
								});

							case 8:
								console.log('加入房间成功');
								_context2.next = 14;
								break;

							case 11:
								_context2.prev = 11;
								_context2.t0 = _context2['catch'](5);

								console.error('加入房间失败' + _context2.t0);

							case 14:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this10, [[5, 11]]);
			}))();
		},
		destroyTRTC: function destroyTRTC() {
			if (this.trtc) {
				this.trtc.exitRoom();
				this.trtc.destroy();
				this.trtc = null;
			}
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
			this.$ws.close();
		}
	},
	beforeUnmount: function beforeUnmount() {
		this.destroyTRTC();
	}
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.releaseVideo = releaseVideo;
exports.getPresentUserVideoList = getPresentUserVideoList;
exports.deleteVideo = deleteVideo;
exports.returnVideo = returnVideo;

var _request = __webpack_require__(60);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function releaseVideo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/releaseVideo/v1_0_0',
    method: 'post',
    data: data
  });
}
function getPresentUserVideoList(query) {
  return (0, _request2.default)({
    url: '/app-api/service/video/getPresentUserVideoList/v1_0_0',
    method: 'get',
    params: query
  });
}
function deleteVideo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/deleteVideo/v1_0_0',
    method: 'post',
    data: data
  });
}
function returnVideo(data) {
  return (0, _request2.default)({
    url: '/app-api/service/video/returnVideo/v1_0_0',
    method: 'post',
    data: data
  });
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.client = client;
var OSS = __webpack_require__(346);

function client() {
  var client = new OSS({
    region: 'oss-cn-hangzhou',
    accessKeyId: 'LTAI5t8CctpYgPCddVeMRSM2',
    accessKeySecret: 'h7QMmbHgab6RY9SObNrSg7H0QW8RvR',
    bucket: 'ahhzy',
    secure: true,
    cname: false,
    endpoint: 'https://oss-cn-hangzhou.aliyuncs.com' });
  return client;
}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en = __webpack_require__(221);

var _en2 = _interopRequireDefault(_en);

var _cn = __webpack_require__(220);

var _cn2 = _interopRequireDefault(_cn);

var _tw = __webpack_require__(224);

var _tw2 = _interopRequireDefault(_tw);

var _ja = __webpack_require__(222);

var _ja2 = _interopRequireDefault(_ja);

var _ko = __webpack_require__(223);

var _ko2 = _interopRequireDefault(_ko);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    en: _en2.default,
    cn: _cn2.default,
    tw: _tw2.default,
    ja: _ja2.default,
    ko: _ko2.default
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(336);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(344);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(210);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(337);

__webpack_require__(338);

var _vueRouter = __webpack_require__(211);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(140);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(141);

var _vuex2 = _interopRequireDefault(_vuex);

var _i18n2 = __webpack_require__(334);

var _i18n3 = _interopRequireDefault(_i18n2);

var _axios = __webpack_require__(208);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(343);

var _qs2 = _interopRequireDefault(_qs);

var _routes = __webpack_require__(209);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(339);

var _vueQuillEditor = __webpack_require__(345);

var _vueQuillEditor2 = _interopRequireDefault(_vueQuillEditor);

__webpack_require__(341);

__webpack_require__(342);

__webpack_require__(340);

var _WebSocket = __webpack_require__(335);

var _WebSocket2 = _interopRequireDefault(_WebSocket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueQuillEditor2.default);
_vue2.default.use(_elementUi2.default, {
  i18n: function i18n(key, value) {
    return _i18n3.default.t(key, value);
  }
});
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);


_vue2.default.config.productionTip = false;

var wsUrl = 'wss://test.unishow.live/prod-api/liveWebSocket';
var wsClient = new _WebSocket2.default(wsUrl);

_vue2.default.prototype.$ws = wsClient;

_axios2.default.defaults.baseURL = 'http://120.55.74.21:8840/';

_vue2.default.prototype.$http = _axios2.default;
_vue2.default.prototype.qs = _qs2.default;

var router = new _vueRouter2.default({
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.path === '/') {
    next({ path: '/shouye' });
    return;
  }
  var user = JSON.parse(sessionStorage.getItem('user'));
  var publicPaths = ['/shouye', '/zhibozhong', '/bofangshipin', '/zhibojian'];
  if (!user && !publicPaths.includes(to.path)) {
    next({ path: '/shouye' });
  } else {
    next();
  }
});
new _vue2.default({
  router: router,
  store: _store2.default,
  i18n: _i18n3.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(211);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var router = new _vueRouter2.default({});

exports.default = router;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADPSURBVHgB5VMxDsIwDHSrTqysdGWFPzDSvIaVkR+1KzN/YGWFFcZwFxlRheKkiK0nnZLW54vjJCIJeO83ZEpXShprcPUPoyxMxQinU0smYm0ZBfYYXYaJU239YVQUxQVDCzaWmcYaajUnoOqLEOgg5NRxxHdrmHT9WBWvGJvlmIQ8+b4FJjH5Ds7096CJaRSZmSbB6PUgIToaZg8jHvLZIz5KNmNQaFWhCPk8/qu8e/AL5sKKUdoSkx14U44BC1iAh9BsvaFbGV8ZFz5h++cnNStnM+ygoHwAAAAASUVORK5CYII="

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAADjklEQVR4AeyYL1RUQRTGd21SqVipUrVaMUrV5iFyaIhJpCERbVCpUK0S1ShGrFSN6+/32Ls78/bt+3ee5xjg3G9n3p2ZO9+7d2beHR6M/rO/QQhNJpNVMcS79SYEgXWwC44hciisg1dglede0pmQk4GXzLYL1sEKCLH+hIdD+vQi1poQE6yA50y2D56CkN9UvoIf4BaEBDHHhK6xbEUIIhtYksgmpV6gGEnkfDwe74zH44/gA9ij4RSkxDYZr8ckSFO91BLCULFOMLEN0nXxmec3ELCkOhd0VzwdgS8gxLGGcB+b1kO/UFYSYpDh2aJ3rBOqhRiWd0yqZ/RQoSz/0H4LztDrsW+UIY+o6K0t56C+IAuEph0l8izpbQiOmMSw/Er0tVX6S+yETuUwaltvRfjpcicLhFC/AGtA0QsXVA4wfk3ZSxh7BfSWtrSpHUPnUrA+Q0YI77iNYwfpFYlcYiyMzAb2qWDnknEHIOy5Rp0T1Z1khFClO+ECA5JCPZxMbZ4nFsMBhapMyEVXNDDQ3VLU/8HPd2zOvER9JmVCscgyzxDKDXAMPtXA3eO6mBlfVuFlJfOnqr1MqKqPusf8BFmqlSKZ2AyVHdoo2xJyMXoG1cHPx882k9b1aUUIF3ueeAbVwc+Hoaibr7GtFaFGKwN2uCfU5MxWHmKrm6JuU5ohdkV2Eg9CCCN+DM2JNN4V5lCYaCetPIQpU4jssETXVjp9lJcRekh4Zgch2/4a7IHXPeAZVkXeg1R9dlSUCXnw2Ukyns7WBwcvm37Es/yqTCj9oJrVxVsMRgoy2kwT/zTVHWWECIfxFhLQS2Z16WD1vQAR02JteVmQlHZM3GI+n3NChWY0MuWMBSypTreGqY2sgIw7UyLuOG3abqjSvEjdIiG85CIzq4sbhR19I28NnkXW1TUCImvA/Fyk47Rtju5cmZ0sZNEiKSB78+Cb0FN6Fpn3SC6dgKa5QMLweGt5i1bvUBTippHI0ltLJaFiKD+Q8iuvt8q3BneJJ7YlPecCGQ/R92gsKQpxCZxgz2whWzNFa/JTSyj6YcjFp7e8NYRaD+kpPSY5w+k/HvRMrBND4hgvCx6uMXZp2YpQjIaYh5zE0q0qMcNiOIOIQzxCJNLp1tKJkLNAyjB6KzWUEtMLNgnrsU5O7auyCzoTCuNMdgPOwA46veanxX88NK4T+i+V3oRSi5DSay7cVN2r/hcAAP//rxDLeAAAAAZJREFUAwAk+JxYmqFtvwAAAABJRU5ErkJggg=="

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAADB0lEQVR4AeyZi3nTMBSFJSZoN4AN2gmgEwATUCYgGwAblAkKE5QNChO0I3SDdgNzftc3yGkcW/JL7Sd/upEUS/L5dfVI5FfuhV8F8Lk7uHiweDDzHihDNHMH9corHuztoswLFA9m7qBeeVl5sKqqI9mF7F5m4VKJ170kHQWyAWwgbqTzi+xIZuFciRvdP1EcHbIAlHg8dC31xIrcg3Puj3Puzj1eAF835R6/Gfi5OmAjOoQD6tR7fyaGU9kvGQHIDYkYWxWwA+7Mew+kU4wnQ6j3MXCUXQ1wDxx6fguqhiODKQ8kRjba4gCjm99foQOOwhvd+0TCTPkPSjM8FbkWvBtwLQ4owSwku3PuR6D1p8rUkIpZOS/De0F6UHJRQAneB8ecY559DxQD+U15OsK8x/C1BUe3hoXFAA/A1cNOcw2gEPKrEAzuVunPsuiwCGAfnKluIHe9BBxeTlpoZgccCgekyjLnwq1gFBxtzgoowV1zrh6WCDBTWeDCOTcajrZnA5Tg1eFmA8wFbhbAnOAmB8wNblLAHOEmA8wVbhLASDhW1is9OPyFkryJq53eMGqbSIBjnwMSYZPsczR0yJIBnwMc4MmAqhx6g18mDDVi3fof9nTEIp4zBUmAEs2fUBtqQGUJB2QSoCq+k1nY6F8AkJav46qq6IDQy4t6rhahj1TAt6pr4a8lLJaHs4BDTzSgxLPE88uf+rfyXut/mu5nA4fAaEBVCofn1nsC49idubn6sJTGbRgLKK6Kdwkcud+rVTZxPKikY16y+LQ87Ba+UgDD+cdhEe8SbMia/E449ciJ7ErGUXyK8TKGaWLPOhhHAUoUDe/C2ANYJTn++6gvOHoHUskngWNAhjJDPcXO1SL1FfWHKMBmQeGlCC2HQMe6BxRbBsd7h4bl7qESbcUYbZuG3npRgLQmEOaVIj8UiGpb895fKHMse5Niqk9ndo0ONdkO0YDt6mk5iXyQ3aVY7BNXAYwVOaZ8ARzTeznULR7MwQtjNBQPjum9HOoWDy7mhZke9OI9+A8AAP//xr3mVAAAAAZJREFUAwCLBq6AVYs0oQAAAABJRU5ErkJggg=="

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAACqklEQVR4AeyZgTUDQRCGExVQATqgAnRABagAFYQKUIGogA5QAR0kHUgH8f33bN6S5MXs3uw7eevt2Lu93Zn59r/bJLcbvTX/q4D/XeCqYFWw4zNQb9FlAk2n052StiyPVe1mBb+hPnE8KmnEHWE7xDQVMyDeD7FNrHQRnGKb4qYAxgHGnLw62wf+k0su4E2/3z/qOxpk91hyyQVMDlxqYAUsNdNecaqCXjNbym9V8MdMz58c8O3izNMIaf5wZ8ys5Cp4hqcHZzvFf3LJBUwOXGpgLuCQRM+d7RH/ySUX8I2vaUNPg0zfdanSSi5gWtSCoypgwcl2CVUVdJnWgk6rggUn2yVUVdBlWgs6rQoWnGyXUFXBtqaVH8Wb2AC7aMvnX/x4KjiLD9QeJy/YNXbHedI+A2PNxR0QGCkmOEGGBLXPIMhBaPCq3QAB0/aawO5IPmzWaC9DRlNTrun3ggm4aWj7nwsgCR+T6DsWvzDSHsM+P453adcxVVPUR5BZ714aTwv+tQoImBaSW+I8YbFq2qC5BG5Ce4/6kvoEC2pKwSHjH7Awjsv5pTVAEpMSUk3Jh8yeOZBqc68dgNS1I67H71z0lu4dXwLmUn5pBZCEpJqet5CYlLoC4gTT8cJMuTbGBHVFh9BPPlpbgHIBtZD8Vk1qSTUtLuS9ugCpvvv0DLcshz0tQNom39ZJquUCDggcL//3JKvnLU6ULqsL46SmFqCbqLfU1Gdn1GQ7zAUM0QQksPj5C9dMNaACEqh8msYu6twGoJZ83ZK6NRfFMLcBKTjdsvJtHh8PSAEUiBLQoqBFZLb8x45zj4GcYLoj9OY8xFNsk2szIEGbZ4V6C9NSbwpo7UwMvTnfpVY8gZpcmAFN3jvQuQJ2QISsFKqCWdPXgcHdUdBpMtYe8AsAAP//GsLJggAAAAZJREFUAwA2B5+AfQzPYwAAAABJRU5ErkJggg=="

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bohui_102@2x.14f3165.png";

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAaZJREFUeAHtmY1NwzAQRr+gDtARwgawQUaACWCDskHTiRghbFA2SDaADY6zfAHnB0GcO8up+qRTpFQ9vzhO7IuBKxuDiPYcR46G4jlzPMEabqTkaEmP1uUM2yigCCdv+FAFpzqJJew57kY57oui+IQ2LPwiPdNwVIhk5k7VyB13wYFwgy0Q9nJ/7gZ5041P5C48QUVYxtsDtoATDR6OIxShYPLpz2n0cPh+rLWlTXDvydEMpSI918NqWEibCksDqtLmwtKImnQSYWlIRTqZsDS2WjqpsDS4SnpOeCc/VHwooU/H8Y6f9a27APDa9oRYaDhTpeJfPU2/zHT6K/m/ia50dnx73vgCHuFLEwsOGJY8J26zRo6Qr55D6oX/nwwJM9bKSo40whqyksdeWEtWctkKa8pKPjthbVnJaSNsISt59YVpOlPWUIIS1HT5Tgoh0ssVlKHUy8u1WA2JpOQubLUg04f8N+KeMyzgxAeOD/J7FCUiIf+trg2Ev/c7tLcMXvkQfhR05dHSAqHEsFzr+FV5CwsowaaMlfizDItYGvIV93YeuovhC4TxXDzcfcp6AAAAAElFTkSuQmCC"

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAABHklEQVR4AeyT0Q3CMAxEWyaADdmAbgBMgBiBCWEDcxb9qhLsSK1jwaFYIq5dn+/BbvixDxfKDpSESCjYAf7kgg1vHkdCzZYFN5BQsOHN40io2bLgBhIKNrx5HAk1WxbcQEJrGr7Fu0hoC1fXfOf/EhKRs4g85RM3r6uoD+1zEYIoXeCCJfZzTMjpHdf6QU1onypxLYTCI2J5TstE4R7dN3gXKmjNmfIudC/IfxRyy1R0n4/QOI76f1FxLyjWuCI34fvXg5rQPhXjJTRA3IQ4zKFCtd8M1If2uRcylScp4EJJQFRlkFDVmiQPSCgJiKoMEqpak+SBm1ASvaYMLmRa1LmAhDoDMMeTkGlR5wIS6gzAHE9CpkWdC0ioMwBz/BsAAP//5f6cmQAAAAZJREFUAwCh1FppvQ/kwAAAAABJRU5ErkJggg=="

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAADVElEQVR4AeyYi1UbMRBF5TQQ6AA6CBUEKghUAFQQqABSAUkFOBXgVACpADqAEujAuRc8ObJ37fUa22s48tFDu/rMzNPMaCU+pQ/2K4Q23aHFQ8VDa16BEnJrXvDW6oqHWi/ZmidM9dBwONwCF+AWbEq5x5DjWWtUS4hJO0y6B5dgH2xK+YIhfex7BNrI63ipJcSQWxATnnnubwAG2PAELNpm5Gz5kqNCCOYnDHACVVLIbq/XO+11j6OU0gFwganSTkrpLE38KoTo/w6iGG75e7SvvWahL1BqGuRe+UrbWKkjZJzGICdfIsyYnZmMMWHZNbr3wSNyzWft4TGFl1zwlP/qCEX/Aw95zJqM1wjX1XSttqgHmMsidErkHM1/QG1pImTM/shmml96y+08lGTdb3+ExMvnAkmGV+6BX7SZzz+pp5ZZhBIbwRPQ1btI+A2i2OYus9QwhIwLJhHlR3jdoVQiZ9iih3idXmYSimkIkpjKTmmbDEM9tpC3kPVSIGKeGFrXNIQs9RygW/hMV3OZi1CIQXgf6C3DMFZLAyTVOr8gYnhdIV8yEV7KVf4euvQO3fOXVoRCLIoMiT3e8zDUg4Zh5dvAuEqBjJ8Dd698vN89iVyiQ2KVeU0NCxFSKAojDCUWIaG3rjBWj31z3CToM7zME5M78sQd1dA6Uu7knDbvCxMKJRjwAAzDyfwaYPwNOAaSOKE2tER86/TCOfP1SuvwChvy+s2EQhhGed5zm8/D8JB+2yVhwkee0Jzm2oYd2AZLI6RSSEUY6rGcmN0BPWF4zbUNx6R566USCqUZsW3a9Jrh6OFymz7JSIqu5ZeVEAozMf4Z3AG3+wG1ORPdK6lXSmglFjcILYQaFqjz7uKhzl3QYEDxUMMCdd5dPNS5C14N+PxaVf/WeSiOJYecjuN4X53ZUcvIpjite+0Ys6SO0N/RCMl4t7EeNXVbjch4w/XepTHeqaz/o46Qg+LC5i3Uf5DfIMwrdqfAam+42sRj8mRfOdFXCI0OkJ6Qg5Sr4b1GQV0jokXbtDFN/iqEHAAp2Xun8dhfiVPHdATzO/6BIqmKGbWEYhTEPPZ7PeZxI4p3qZn/QJlJKIi9p7oQ2nRvFQ8VD615BUrIrXnBW6v7cB76BwAA//+n55XdAAAABklEQVQDAOeSOYd+BeVIAAAAAElFTkSuQmCC"

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAsCAYAAADIIYBkAAAInklEQVR4AeyXy2sVWR7Hq+pW3UcSYxJfMyq0oxF7FFTIiMigHfCBouJKNy4EFRS3LhQUNKgLV7rwDxB0IepKQcRnRheDOo4PRlGMknGMYHwlMbk39956zOd7rEonMemWXojd3FC/e875nd/39z6nKo71B/qrBPO9FrNSmUplvkEGKm32DZL8m0xUKvOb0vYNQJXKDE9yFEW2aDj/a9bCib5W9pfkBiojhaJBwrbmMU/z4WQN34vXgiWyyTwZB/MTvPYGk0lMrCuRNzzb1hCJZ7CxzAB2IBhxJMwo4YQceJo769evl6xIa3v//v2aI26eiN8IWWsQP5GRfIp9yYuMjOQkD99ixK9IctpnaR5jM7ELx4kxkmNpG5zwCTlosbVgVw6ZOWu7ublZiuWEx9o9c+aMGTWHUq2trc6GDRskw9KSYjlpP3r0SFjhUidPnvQaGxuFE7mWZYnvSgbHTHaxm4zCSZ8ze/ZsF5yxiV3hRI5sEpyNHhGDeTQXWcq8gjDc+EcK5aw7efJkOZGGn0lo/Pjxmnvt7e0ykGpqanJbWlpsnDOB4KjBIp9ua2vzIMkbirHunTt3PHCplpYWkwBGW2ucVbDe48eP0x8+fBBGtrPSBWVkk+AkoyqZAOArGRosOa6FmlGbDkrFk6Pe69evpTBTXV2dS+jdu3dSLsXeixcv3EKhYJ8/fz5FMCkF0tXV5TY0NMgJYXNYETZbU1OT7e/vz9bV1WX6+vrcN2/euKdPn3YT7N27d50JEyZ49fX1BkswslNlWZZG6ZHN9KRJk5Rg2VNA8hWRz8/AQtmB5bx//16Ru2PGjElXVVVJURXGq1euXDkuCIJqZGBXGeU44Mr57u5uh7ZwNCcBHo7IoVw2m5UzNTNmzKjr7e2thrKlUilXLBbTUGrs2LEpdNjTpk1LKRD2vHK5rCQIVz137tyx2KuBZFc2s+AUjNpQyVMR1OKmu8yZoW8jMgvGssm0gvE+ffqUyefzuUuXLv0Ir/ns2bN///jxY/ODBw/m4VxtLpfLKmCy7dJKLvJKQIoKpHP8rV69uh7+QrA/gfmJgBcfP378L2EY5nzfz7x9+zZNZZVMV+1DEC4yGQLO7dmz58+vXr1aIBxneqnmJLMBB4VVomTToeWEh22pq6zkzGihDYfyp2gpRZ++cePGX5cvXz6NDLtCaCRbf7py5UoTRtI45lIF7aWomvP06VPxvGXLltVy+JumTJlSJ4ywtbW12U2bNv144sQJBZQhaNNqnKPU9OnThXeRTR85cmTywYMH5wsrnEjzc+fO/W379u0NBKtglHD5a8cdFUlODI2Gpk6daqv0tJVLZmsWL148xWwM+5k4cWL1sWPHpioYthzOgcNZUlUc8Xbt2vUDPLUL20OfdevW/TBz5swscikq6wkn0poEeZs3b545FPF55Xmeu3fvXu25JMIEQ2vbcUcZoSQYVcamnDalNvMtW7ZMNBKj/CxYsKAO4w6KbapilJM1h7ZzOAPq8xGRnue527Ztq6eFHVrTQtZCj01nOmvWrMmqgiMCYZLEGqrnYMf4CGvIkwRjNTU1WVzFZhPFZvyKH6PUcZxQsrSnhTE7k8mo9cQakWhNn1skojIW51A6LIKzuQBGlE+Ynue5JEtLg+FMWvF7RzwrCSbiVom4iXQrRBza8N69e5+MxCg/7HdxcQRsR1Qzoj0j1hHGAvbewR/1uXXrVgHZkMqESoSIdcA1XaDlekcDdnR0dLGnxBk/GxsbrTlz5mgO2/ocDGU2C360IQeDAwcOvL1582YHvC+ezs7OPlqlQw5Q8oB3gwIKmCvj/s6dO19yTRe/AMK4du1a+9WrV+VwxLkKU6lUSDICdIV0RPno0aNtiH3xkCR/69atT9go04o+V3lEZcJ9+/bJZ9hxMCgSQxTCVTBlxtKSJUueXL58uT1xTAovXrz4X264f5HNIq0huXI6nfaRD3hZ+vDLz549y2/cuPHf9+/ffwPfPD09Pf3cSM+WLl3ahp7iuHHjSq7rBmADXoQD2EOHDnUePnz4P4Mr9PLly64dO3bcx7Yq44Pzudrlp7pB7xpbRsx7hspoYYLhQAZcl3JSmc2vWLHiCZm/sXDhwlbG1lWrVj15+PBhDxkt4nyJG9DnOg+E01nwPK+Es/kLFy58WLRo0QMSdXXevHn/oA1vcpMp6wUMKxE+50uVDKhIwEVSJsAi566we/fu/5H5f86fP79V2FmzZt0+depUp3Ai2eH7zQTDWgHJd8u8ZzBIPJEYES+wgKwo0yUEZTjPmL99+3YPTvZhVOt+MlpEqUoeoDgUDjmfA20SQSsUyGAfvN7nz593MwonfQUcLaGnzO0ZqFUIIqDKPm/3Eq+F/li2j5dmt7DYzXOO8yRTe/Ir4PtNXSS/Ef/8mMpoGgckAZFPpuWUgP1UoAAZZzgX/dx6CqRIEAH3fMAhDLhVQr60Qw6lMlamrYqSRXcBBwtUW3g5U6RKZW4zI89+sHbt2oBk+NxuPpWWzSLyslkgacIqCUUSpW5RomUjVCTyGx3mMbcZTLWZFW+EckzKkTABUQHjPGtjiFvP5yoP4yAiPhhDERmPcEaGhBOVCE4O9FNtYUVyWJkNFDzJ0JezPqdCYalWmSSVJE8CdbaElQ7p+yIQ+S7Ct5/bTIuE+OZRdeRUAjaKCLKMcV/EVe4rADBqTwbL0vr69euqlnjClmmjRI/WhhQEDoS6iUTMLY38CyDZkBYycmB9EcrFF09+iaQftmUKEBfBMpWxhv5JcIAwlIBDgjSOEoz2jaKhUMvw2BfGEHg5orlGg9N+4oA19E/7IsmLhElIa5H2zaFHt+moRMVIwSR7ZoyNGgWGYVnJXKNxXjIJxTIDg/gsjGw8JvPRsMl+MgIb+Yl1D2z+ajADkr+DSSWY77VIlcpUKvMNMvCHaLMkT5Vgkkx8b2OlMt9bRRJ//g8AAP//LYdC3AAAAAZJREFUAwA3tvGVl4+e4wAAAABJRU5ErkJggg=="

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAx0lEQVR4AbzUMQ7CMAyF4YSNjrByOO7QkY6ssHJAZtau4X9ShCLhpHGEQDaxwPlwQ9Vd+PHrf2BKaVJ6L8CcMEML2EJ9ZO0OE4wxrghKYbMHNUEwxZ23J+lCq2Ce0o1WQSYLI2gTHEE3wQp61udWdoHFxpjrfV6/li6Q22Zi50yeyBf5IM3YBA3sxp8l1A96Mf1CdcIRrAnyZXlmzcuk9xPmhHm6A106q26M/mCCHLoeDBcartRCKfvCBLUVaFWq9mQV9CBl7xsAAP//NXkLXAAAAAZJREFUAwBcw1EpRUIHFAAAAABJRU5ErkJggg=="

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAVRJREFUSEu9lb1KxEAUhb9VttXCSnFr0VcQHyBBGxu3mBAI4lO4lfgcCSQE0tgoyQOIr6DY6qqVhbbBH+7iQJDsrJHMTBeSOd+ck3vvDIAT+lmfwDvwAtwCr03ZQY+gpu4XcA/cAB/ywhZIQ5+BSmC2QQK8A65dgCTGCxegmStXoDcjaDgcDpRSoziOH0wdoJTaLIriqa5rialtmYtBBNI0nVRVden7/lWbQlmW+57nHURRdG460MLotFAbzPTu96EWgmRDm2AXSKeGbQrLRonLFOm/HOlNGibPXSCdHDUjtApyEp2TYnBS3mEYjpIkOf1LwwZBcJZl2XTeBJE+OgaW2j6QETQej2U6PJpGkBwoz/OpYQTNLr4jYLWf23y+ioD2gG0XoDXg8Odat8YTR7Ksu9KgZRlfwIYtSxok+gLbBbZsxNgEaTPyz3aAdWBlXul3df4NTYy7UfMF9HQAAAAASUVORK5CYII="

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACy0lEQVR4AeyZMU7dQBCGeZEokiJCSpEqUhIpKVJRpKGJOEJyg+QGcILACcgNopyAHCFdCpCgoaGBgoYOUUAB0uP7ze7Klu3H7nofHhDR/N4x8c7MZ89INjxbeOD/ngDGfoCP7wlMp9NFtIJel7i7xNmSSsTqitF4AiRa5KIv6BVa5vwFa5axdwntsXlNwl9lLW4NgMlkckWGcyQTzGc5OSLWGfv+IG/bQLz1J6XWBoALus96gWQvSfpJTo6A+MW+f0i2xOE3KmotAJLqKezWsrwHYsg8fCPWMZKtEmtLTim1ABQYCLXRgXyn7Hkgllrph4ujZQ2IYvPQCaAsJD5iPUWyofOgNlpXIKdi89AL4BKZn4eZADwF8/MwE0BPAQjT83AngIMwOw9RAIJAJuchGoBWMjkP0QA8gQUgzM1DEoCDMDUPyQCCQGbmIQuAVjIzDwkA3PeaAWFiHrIBxALE6PMwCEAQaNR5KAGgN9UJIN6uvZO56vXbb9VHkPc71xIAH4j8HMkuaKtDOTniO+En+74imT6C9DEkv1eDAEj4kchvkEyfof/l5IhYy+zbQN7WuRmC8OedazYACfUbCwH4wIckvPQnKSux9LG/XduzSay/tfNeNwuAhCp+pRZVxZ/UzlNdfScLQvv2Kb7+JPSzXmUBEG3Uvid/sGQA7r7aZtS+D9XjJAFQvFpHAGytTK1z731fZXaHaABXvIm+d7VXSzQAV5vpe2oJFgXA3VfbmOn7UD3OnQAUb67vqTvYTABXvLm+D9XjzATg/032PXUF6wXg7pvt+1A9TicAxZvue+oO1gJwxZvu+1A9TguAn5nve2oM1gBwd19/4NMF+e/32n2r77dLdYx6v6+uTDg0AHiN9UXrDxvZ7zk+P/He4W9K+FHv91ybZA0A7STRJdpBQ97vFaoScTak6mQOhxbAHHLMNeQTwFxvb0TwGwAAAP//mEgpxwAAAAZJREFUAwCtlFpw4yh+eAAAAABJRU5ErkJggg=="

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kong.6d03128.png";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.d57c957.png";

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABgElEQVR4AeSVrU4DURBGu6QCgUTgMEgQiIoqBKYCBAoJDh4AEngCSOABwMEDEAQVGEJQkECCAIlAIpAIRJPt+ZLWNHt/ZrapaTMns232zmlvv97ONCb8mHJhWZav8AGL49r51JbOIlqGN6Tr9NqVErYx3MM8dJHu0WtVVFgUxR/TN+Ec9GkvkJ5Bk+euigo1EWkPDrneh384gDukc3RzJYXDiUgvud6AX+jAO1JzmLKFCBpIH+gt+IIlMIfJJEQg6Td9FVxhMgsRSeoOk0s4kIbCFE2wWyip4HsdDdO2Xg9RWzgY3KMLWrxqC/lp7KBQgBboXbiBYLmFiJpwwuQr0Cl0St9ii3U4cFldLiEinTK3jDwCCXYRHUNyW81CZDpdnhHp1PmhdxBd07PKJES2xtQX0F/WJ72N7ImeXdlCZKPhkEynTrZMNyaFiELh0GmjGSaiQmTucITeRVTIokdwhYN1lZUSapErHFpYRVRIAluwAuZwVMn0WlSoG8bNxIV9AAAA///EWbEDAAAABklEQVQDANEhiDm9WgMOAAAAAElFTkSuQmCC"

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABb0lEQVR4AeTV4VHCMBiH8dYJGEE3kBHYQDZwA2UCYQJ1EnQC2AA30A1kg/o8Sjw42pA0Pb7A5X9Ne21+15eXcFWd+XPhYNM0n81froeqfEpJxVbAt0Ogp8AxyBsR3YA+Mi8aUbCu6y2ZIiyI4xn0yUnfRMGwKOic+Yw45qBLMvIkN0mgi4K+cLTEXxzviCW21EzTRzLokqAfHCdEVCy7mbJAoApUzDft1UzZ4A7t3Uy9QFHD2x41k9djKQJdGPSgmejee693pRhsWfi75dr/pWKQN3pgtQ2xa9e88TvzzlEEgrnrWFKBVzB/Ms470wsEGpElq9o0HKoZWNI+mw0CWTpL6G6zRZuAhbfkND6yQDD/olYsKfq7AYCtOU8eySDYfnO4y4zBRJMxb0wCwfabYwE0JZbTNbISBYHamiM0ShYUbo6C3BSaw9JZwuTm4NnWcQr0ITE70b8mz4sSBfmebnYRLYLCw1Ew3DTk8ezgDwAAAP//1TY7JwAAAAZJREFUAwB3CH45oCB+gwAAAABJRU5ErkJggg=="

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABdElEQVR4AeyV4W3CMBBGcSdgBLpB2aBsUCZpmaAwAR2hG9ANGIFuUEZgg/S9KpEqgo3tRPwC3Sfbh3NPvnyYh8mNP3dgdsObppmhH5V6aJSWAnkCskczlIzBQGCvEA5I2BfjHEVjEBDYO5U/kLEJISxDCCcXMVUBAU3RjqJrZKwAdXPXURUDAdk6W/hC1SOaA+tOyTIdRUBgz5QTJlTYAtg3uezIBgLTHDpxSvU/cwATyjI/soDAtpTs2pZlDvZfjKtAYJ7qrX062xzt/t6QBALTGL43W1dkjh6pTSSB7PF9MYwXSSCm+ASlQXTlgRN3rSVdF0mgJYEuGTfI2AL1dnFepatAqwL1Flk5R2ugO1TV7iwgkAlQfxZezBpIM9liW+3X2coGWhGot8qCuVBhe07qXxOpvCgCWhKoME9aZaZiYAs9Aa4yUxVQqAJabKZBwBbaM5P5mAYDLcxJ/5vJVFSjAK0O9IgeleuYRgPGAOf5mwN/AQAA//+KZXQ7AAAABklEQVQDAJjyfTm9QoooAAAAAElFTkSuQmCC"

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADN0lEQVR4AeyZjVnbMBCG5U5AN2CDwgYwQbtBywTNBoQJoBukE7SdADaADaAbsEH6varOCP/IMphI8OBHX2Tr5+4+3Z2cKB/cK7/eCZR24NvwwHa7vdz2r9vSq5uj3zxwMDB4X5yOBtqrajICx7LqLIJufRki5jtq+fAEmqa5EdYGGXcnUD7zUTM8gQED/4S21+GBYGxc3YSHvdrzYMwDvwMBqnORYJeqCecYBgYJKBfu1Wl5QBixG9WElRZ1Xza6QQJ0CJYHunVXzrkawMI6XfdaZL/AKQKWBxrvzjThuDRkiDdadWtbikCcB4SR5pUrIWTMjjY6RglotXGXMa7hfWDGs4pZHmCgMY0n014CX4JS4p989I+jHvC9zhnTGt4Hn9z/y2zyT1MEqsiDsfiHQZJARXkQh/AsD0CyhjwYjH+MS3qAAUJg7ErmwWD8y7bkm5h+UDQPUvGPcZMeqCAPRuM/iwCDhJJ5MBr/sisrhBhXMg9G4x/DJkOIQUKRPJiKf9mV54GCeZCM/2wCDBRK5EEy/mVTngcYKJTIg2T8y6ZZBHaaBznxP4tAJw9OpeD2JSHjLgUr5n17buvcXcgmWB7sqYEf1S8NqXGPvv+7zjWXwIXm/xA2O8SJdI2WWQQURnfCSjjZIeLc6xHJJqB4PxIuBA64fqn+2pO2UINkczKepSuLgAR+l20kFTUHXOzPG7W3J2TqX6RIJgtzLWFdXSwcuaeuhzJJQAJJVGLfZrEj2GkFJ2Rr63huHXSRX2ZorIuFW3V1TBLQhHjSoWL/UG38n4Bw3TpWjHoJfIuEcJCGLmCnEHglGuKyXmT2NryS8d5o1XjAtlQ89EjoMx5MFpuFN1q6OJ/6GWTyq9DG+KYcD/z1I507kIvNtTQZMRTwvARMFkkcG0r4ePkixOL5ez5yCBCTjMX4a5FYCyQ0iUx7cptjwAzEskha02Vhara0IicJiDGuNBeyKqeabSvCavDfmpqi8sTboMvkZemaJIAtEkxy8Ub0OaA2XI0ikhoSalqmSBe7WlcXb3+SuqcriwCmSfBGwGBVzcemafhTECJ0LwrJ7uri7d8zHqXZBBhcI94JlPbKPwAAAP//gKW2bQAAAAZJREFUAwAfIjt/edk9vAAAAABJRU5ErkJggg=="

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFH0lEQVR4AeyZi1VUMRCGoxVoBUoHUIFQgVABUAFYAVABUgFYAXQAVgBWAB1gB/h/y8x17iOPXViUc9iTIbnJvP5JZm52eZ9e+ecNwL/ewLcdeJU78PDw8EG0JzoVXQa61vi2QpGf8bn4t0WfFwnG3EdIhlZl6Fr0XbQjWg/EGo6UKPIz3pT8mQgwyGvY3uYCIOdx7Fzq6dVV2504IHXVhk5A0FeZnWEuABI6FLmBG403RB/f5T8rWoLUjRuyojURutSlDymlU1Fzawag6HNctk0zUd2SS1ei3zY3d4esCOcJhOtZly2OVpO+ZgDSdiDydijDgPDnJ/XShfO7QQnFgd0IU9PDJgCKCM770bmQwR/T6haflc4LSV+JaNjaZ1CjKgA5jzLOvuv65oMl9HEXKNPYLpqpApB0dP5IkXq2oyPdvWa6j2ySI1RN6CIARX+YuNR+07+0DhsepGpCFwHIRc6+ulkjcUm22cOy/mgXsBGPaXEXsgAs+n4Gb6S4OXEly1WD6O1oDDWXRQIjW72Elo54jGHpaBKABHA8Rn+rkygMJIfjyN2K7VJE9CDesNyRWNN0U/NcgJmEJicY92gSgDj2RIBQl84UET+TKfeR8/BzRyJaU8ZYPxQfQBjnVM3mZZOSyk7wjL7JsjoCIAMoj8wxEijLERFH1tcxjh4oHj942BGcct5cTy6QE6yzC8gy7mgEQCtEUN2snSgSLdHnaLhy+Ln/cNVAHqKarUgja+oSvABLpY/ZPjEeAGPHHh+7HgCLfrzvUNIeOVOxw0Fn2DDD/jzrbY47z+xZf4goTmlYbPjguzAqCD0AUrNI9KkwRFTiqZgvBoKjlfTB+er9XzI477sgscT3h+SfIYBPvqDeDWlYbO48TL/4U6GfYT3KhunRkF3wyS8+oB8CICrMQyCn/x8o69cQQIxONckMmScmj73oMDFB8dhE2QnWbuprN0qpJzMEEI9Na5LxhcR3a9MKQZr62FpXJHS+qfVTrN2cyex3Eyn1ynoPgCn0ms22RcGg4+9QMjgfk4waPzrb5gjvChd2O/6c64sv1R4A00Alwike2YWRMywMiCTzrYWfty3fqpCH+CGA6wVriN4JOHYYZ8lAxyD2oo/gCIAU44hHlF04hrFEkgEwNR5ZZ+XdADAolj544HW+Uh9B8kJEtsc/AmCrGMUpHjnX6wxKJBBElbctURoZkiz6WFuDV8/FZtHv8kXM+KSu3yYByIAbc+7RK9wXhr1k+d4AEKLMV0SIMdcL1tA9FJt65tj5PHJTQUmTAJCSIyB2Ie728RjAUiTJ85MLb2aIcavjSdHn+Hm5ZWezCZ8FYN4RPRumYykmJ/x5Kb3ZiDse82BkswiAKErCazUVJFYELS2lDctmNvpYLwKAQcQu+PYfKEIA0fTzN9MdI07SFw1VAWgXyAMvqyjjKyL9MiiW7KafcKoAzMsnJbTpKHaKPonrhYLEjTuRlW0CoF3gCHGUXBFv2WdLaDnPsWxOXHeCvgkAjAJBMkM84jx3nlUZZ8zc3ISsiJckNR8Q6KDsFhMXJqdmACbALrAbPFKn+RXiXk7kGnciaHJdSu5FXPDQpWEi36qJm8JnLgDaBQzwVqUParJDogplGcICOvkhgD5Ml4dzAUCVQHD/BwS7wfcHjlWku5QSTuQI+cjP/8f2U0rckVjTsL3NDQDVAkGV4KwSMX6FiMSdp0Q4Gvl3pY+bph9NTDTTQgCatb8A4xuAFwhy0cSr34E/AAAA///wpcCVAAAABklEQVQDADF7Jn+lNZySAAAAAElFTkSuQmCC"

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAYAAADj79JYAAAEsklEQVR4AezcgVHbQBCFYZEKUkJKoATogFQQ6AAqACoAKgAqIB2QEighJaQD5/3MmdF4QFp57L3d8zHayLLOlvRlOZ1W2N+G/uMq0MFduYehg3dwZwHnzfUM7+DOAs6b6xnewZ0FnDfXM7yD70dgtVodK6738+72dz2IDBf0D5G8KG70uCq6CVw7mnYSMNivOgDmmg1V0ZsG/wQbcKIaerPgE9iAE1XQmwQ3YANOgH7JA69oDnwBNsb/9M8fhdvUFPgW2KdHR0dvbtraUDPgC7F16IM7NhttAlzY33Uw46GfFienC+/MXu9NevAtsZ/WAN7z1OAj7GMjHJldDZt9TAueEXu34Lybb9BnWzP7Vn121cxe06TMcGX3ow5gCfaN2oeY0oEX7HOjHpkdBpt9TgWeHTsVuLDvtMNpM1v7/j6lyHBhX2tvrUWmcN2I9v1jCg9esK39cGhs1EODt4YdGnwh9oPG2dbfAo67WoTM8IXYz8K29u/VoNcbDge+BbZ15LI+5qpzZ/DpY20dm6MPA74Q+03dSKrMBpsIAS7sX9oZ60mPW2Knap9yqg5esK2VvHdsZTc3fzv4UoFDw8anWoYvxP6rneWmb9rM1v6/T1XAhU0t29qNNIONuDt4weZuDdufizU287m2Kda7go+w+bOGOSCQ6UaYz7VNs94VXCrcGjtYbB2/+wdjDxq7BjjbnAq6j+a6kfEBe3cp421/9Tj90O+rA+N5b/C5LoWPhbzq5DrXjn1PGd7gFiTG6NwwtrRN18YbnKKTpcs4V5Y3ie4KrqITxacrY1peCp279cbmOZq5gkMidC7preh8BqcpdHfwgn6v+a3CMoFOvdzSNnybKuCoKNO54WBFf1L3csbrskc1cOAK+jOPDfEodEYwhqZxm1QFh0Xo3Jv8zeOZYGzOGJ2x+kzTuKurgxeaC80ZwWg2OX2gT7YKvDIEuLKcsTljdGopc1xkeNpMDwGO8BboL+rTyXhenibCgCMmdDLcmumcQPkOFF6aJkKBo1bQf+ox3Yxmk9OJspybGpONIq0MBw6O0DmBgs7iXKSqu4QER1jofMsDoxcW5yJN3SUsOMJCp+5ivRqlBBC+7hIavKAvKQGAHrruEh58hP7AY0NQdzkxtKvSJAU4Mupe+JSDte7CGJ1hIy8NFWnAURM6dRdOpixOBRdEL6vViqvSqXbu61KBFx2Giwwby+KXM7DDlQDSgSvLuSACnavSL7XLijU6GV+eqjtLBw6X0MG2lgBCoacE30An43lqKjiBhigBpAVHd5TpFvSzCHWX1OAFnROotQRA3aXq1Wh68ILOLTorOlej1dCbAC/oS+suXEjxUtdoBhw19elL6i536tPd6y5NgY/QrXWXe6EzguGlLtEcOGrKdLoLS93l+zAMlAsGr58mwQse6IxgyuKnM75nhXafrtzHk82CK8sZm09djfJ1Ta7Y/Ac2C87BTaCDzQmWZq7RNDiSQt+su1zpuSrY7E/z4BykgEGnwsi3K/On0jxdJQ4CHFmh86U2XByxWC0OBrya8MaGO/gGyL4XO/i+hTfev4NvgOx7sYPbhHfWqoPvjNL2Rh3c5rSzVh18Z5S2N/oPAAD//3W0EcAAAAAGSURBVAMAN3tqyImX5WgAAAAASUVORK5CYII="

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABh0lEQVR4AeyWIW/CUBSFzwoOgwI70IjNIZegIf0LS0BTjUcvaEgmket+wSZxm0DDLJjVIEl37xp4iD5um9f0IV7TA5e+03u/nJcCHuiIff8+7vc/SL+k2ILemIFQ4P0Xx+MXfXgi1Uk2Th/EwCweFS9EYAuERp/POrG88pb550v2iwcGso+hCOq3BgQHpHYnvTJPqNEA5nNgsQBqtfQpOa6aA7XbQLMJMFirlWN0utUcqIBULtHMgS67FVA7IClEl5B5Qvw493qATp2OmtHt6n18P/dS7tRK3rLpFBiP9eJBp9aDgd7HPWazk1P7LgMdDtqbcy9k6CUDBQEwmei1XCou/vnQeTkhlnKnVjIQ37ZeAzrt9+xItNnofdstUEhCyajSXrMlVBoO3B80MWu3ZVJE5gmtVsBuB/Djz5ImCutZgK634O+W0QgYDhOo625x1RxIHJHP4ICkvDihSDKVue4hjr/LHCjMevdQrT4DuIWUIlQqgXcXhj9UPAIIYeeIaJc+mYFZ/gAAAP//VyfJQAAAAAZJREFUAwAw49AlJ9HsbgAAAABJRU5ErkJggg=="

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABNklEQVR4AeyYwU3DMBSGfzvhgNq06YGWIyPQDRihK7ABmzACIwATwAZlBAYoSlonoi2VHvbxyRbv0BC3ki09te93kvflS07RsKuqvm/qZvtWm21lf6n3anfPjsGiQLs/KldL29xBoUSMRbRQF2rpWLTK9SNigfCbLy3Uk4aiBc+jdrc66nh/eHlqQEhA/lPiSTLEffhdMuQ74UkyxH34XTLkO+GJaKhtG3ytVp2UMYZPD3Qi0Ga9xn6/66Qaswkg8EgEKooCeZ4jy7KjazQe8+mBTgcyFg2LEa6mM0xn10fXYDBk1w41IlDopP/MEpBkNxlKhiQD0v5ZvkPSTXW6nwxJOk/SUC1R97nvDH30OfCvWUR41fRD9/ag+JYINQ70oCeTy08LNbcfrV4QYzkQ4J0ONHcsvwAAAP//GzU7bwAAAAZJREFUAwBu2x8CzxNePQAAAABJRU5ErkJggg=="

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sp_bf_87@2x.fa6d08c.png";

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAIhklEQVR4AeSaa2wc1RXHz9hrZ+PgR0ziUNo0pIpaqa0EX0L6pVIqUalV+YCaD5agpSIkgigfSqWqpnXUlIqUh0QfUtNIVOojYCoqpLqi70gtggoESkAg8fjAQ+IRkRjbcQLOc738f+PdTTaenZ2Ze8deO9E9O3fu3PM/5/zn3Nc4bTbP/8rlcoekS9ItWSlZJVkjuULyiYpQH1B9tYQ+Pbqi0zHP7lruBCmwdskKCYFeoQBXSXoll0mKEoLGj0D1aqHerpuChD4rdEWnSma/8MCkjx7lV3AsF3QFsFzSL/ABSY+EQAlcVaeCz8uEACZZdrnsLNd9LgVj3oDlaCC5TLJGoH0SAtEl19Ip9D7ZhCxs+3gJgpwt3giSgwwDsqVb0N5whZW0MNywDVH4klQvtp9zICKmU7JaVkh5ZzzhuBZ8YFJngie7nPAAywwgYiDlcgEwmerSUgWfmJ+Y3DM7lokgEcPKRNZ4S+XMETRXZHtANjEEm/e+qEdqgkQOEy9LNW/oIriWvcVXtgj4nsrJVASJHJbTlbKQSk/9W6HgM3sxYkjsD0qJOoschhNLt9dlNJFxf53wnS1BV1LIRASJHFhnQk6K2+r9eisxNfWzKUECYtw6rQRNvViYDpBEbLHWYwkSOcz8i31YNSKgOtyIsVGfpodVzlL1JDaEWpQPiI0YGzpPh8iHyh6GFctj5PMl1FhQrA3n10iCpMAWPfFMvwTI4tMJMc8JJZIg9SJ7dLmkSmTMcwhS9rDfuRSG1sVvn6FG7HXtdQSJHGZ2vvTVdbqEbuZ8T6ojSETA4MVtas5Q9u3rsU9ftc1W9P7R2osHLeh4OxTqXd0j9sl1t9vwXRx448F37vxU2BcddGdxDoeYtGHjvvtiV6J4A3VPiR0Oao001G5UcZ+Yn3himQ1c+QPb+d1D9s57P7Xp6a/aTOlKYTNsC2H95Kmv2OHDP7af3f2srVy1J5IoyOvt/4X95sGnw77onMexGg427tx10PrX3GXYliHHEk2QhhfHidhNU1PD37n1Krvu6wdsbOwOK5frDDXQLdqxqVvs3nsO2MZNm2t9qN+z50k7fmJQbRCrS2wp2uTEdrvua08aPsR2bfqwrcJF2LEt/J39ccseHHv4oVErndswC5fid6Y0YAef329fvPob9nkJ9XK5NwXCbNdSaa09PDLqgSSSJcQMCRJjZE7kPiDs1eyH1B4ZedRmynyTbta70fOCvfzKPntVYpYka6JxIHtkZMRGR11e+LIKJ7WjBn+SiTaYpPWbgz8y3l6SvvF9CnqM6OJQSqX1tu32OxwQUA0Psm3UJOGNrukLk+nkxLfTK+asMT6+zVhJs5sJOakSlH14/eF3W+SDWwYKIIdStLvvvdEBd5YgjTX+9BtkBpqc/HIT3YV7PDFxfmVM7wV/BO0ggyAovXpV4/SpL1SrLXc9czb9ilofREiQ26TotnLVu+P7bibcoLqgtpNBLPEuIEtZtwBBbhkUBBMty1Bb+1FH38IMyj5BY72j43UuLSmdzr6FBJFF2ePr63squ3LOmt3dzzlaCCDHLYM2bvyXoxP5qV977d8dwUOC3DD+NvqyFYtPu4HkoN3ZecjwzRGaDCo7Yphdc/UDzhi+AT732V97gCz7IeiZ/z9jXV0HPDjkB2J58X/20gv/9gA2A0ElD0BmN31r2ILgIy9YbiCn7Jabh9wgatoeCXpw77u2/jPDNeiFqqxft8v2yhc/9kv+MgiH3njtz9bXu5/qgkhP7yP25uuPeLQdEnTOI6DZXx7brVXNbW+UxaFi8Sn762PDWVRjdM6RQWdjOqR/tHnzafv5/dutozB/O+z2wlv2k107DNvpPY7TONsWBAEEuS/1F5rZseO4bd96o7W3v3Nhcy51bNy2ddCGhnyfCWfghgzC79P8eBUmyttu3ZIrSSE5soEtr86HYCRO7aP9mbDJ9w+O50VSvuTARJg01Qw6RUsukgdJ+ZMDFSEnIUEaa2wWQ8Z44l1qJGkydQWfH3LOVDipDTHcPslPbgJJQ3feYBwisxrpKLxmQz+83uNGsJEn09UHYQZxI8YgaIZ6brJn95jtHxk0zkppjfDF4KE/XW9gpNVN179U4SLUqhEU3pnlf5YavGHa/vH41lSHWwj95+M3GboVR3O81LIHG1EE5ZtFWGVD9+Khrdbf/1tuY6Wn51GdzG/OYRMYZZbY65KkjiClFhvGD6M0vbdt2FCy8SO7bWCg8bek1at/aVPj3zP6encgEvBEhYPawzqCaFUHGPR7PgO4kRx57wFbv+77+lQyVesSBFO2du2wHT18f60t/8q5IAjqhhcm5xBEo+S8s7rJvXAC/+9/rrEvbdoSyt5fbbK33/x97nbrDUTGHEmQmGRnPYfNejzPd8xLfJlEOMulg3ft/VEl5jk4kQTRSwowOn9DDaMLIwyt441MNySoosAJuVypL8ULqxYxNowtliBlEUeQSWkvRZKI6VglRoUYXWIJQkUAnNEYbtwuJZmqxBYbU1OC0BYQx5ClRBLkEBPhxUoigkAQSaxqx1QnNXVZlAXfGVbEkiiAxASBJpJgfbHOSUzIk5UYCCeRpCIIRBlgThpTfTFtAfD1g4rvcj15SU0Q0DLEJwFI4lhCUysLm8AxfM7iZCaCqoZklA3WuO55Q7q0VMGn8YqPmR1zIgircoDPk2QTqxzjnOaFFHw4Lr/IGo5MTr44E1S1LodYGfg/gSfUxgZTl3ktEIPto/LF29D3RhBUyLGy5EMJRLElcH6D4DYRFg2W7iOyi22W8iYqyR97JehCs3L2pIT5CbKYqwiEt3xhtyx1COBPMgxpsmVCdth+pMNK2Ds3gqr25TwrHisJgRxR+wcSgmMYECh/wWRIErgehYU6bTyjD33RYal+X5jsZ6Z1pU+okNfPxwAAAP//PxPo9AAAAAZJREFUAwCT7q2RJkq5+AAAAABJRU5ErkJggg=="

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAACy0lEQVR4AdyZIVTdMBSG27lhN7lZNBa7WWaZxSIZbnpnDpCzmxwW7CY3y+Swm8WCfHw/9PaktA9yk/alwMn/kvbl3vv1vjZpwrPqkf09TeDFYrGGNtCmU+v0XxvzR7w3wwRTwH0CHqFdtOPUjS1+9tELbLPLIDDOldFtvCvgOnVukQ9dbK6fahAYrwJ9S23lksYP9NWh7/T9hS6Q7M+os0sPmOwqs68azwp0XNf1Xl3Xqn9Tx+onfb+hj0j2uuDGbXrVAQZWP51lVrAHBBslUDpi17IDzFfvkJVTYP/bwVzqFpjsavhRhsV2AeysMisoqQXmwO5bmtW5PqYSydFwuZHiPwQOx8l/Kc5ibIAVqEahXdrhLRhjvnRY0wMX5SChU+h7ywsdZjghtt+EZ0O320lg6YJeObBAgT6lToIuAgxslQpdDDgVuihwCnRxYC/0LIA90C5gxkzNUN5VR3R/wPUqGk5avSEvGhhYm6H0Ij6lXgMeFkHbO87SmS40sHY4Q9m5VdXPLdDSDFsHqxk3NUN94diz6kjpG94ShKtOiP1HDSkaWJ0xPEOxKw53P2K8ROEtIVjNipy+LS7gW5NpPnlG9Oa2FXjvweq7WQDHws4C2ANbHNgLWxQ4BbYYcCpsEWBgNWM+OBoIbkglRolwxhwcuoZA7VwIfGUnqcPBm8PxChOPzZjaVepMCjFRQmA5MptNa0xRA60ZM4wXHaYFxol+KnOi7VbbY4t2toqOLXAT7O5KdrJbo4nnrjrAZFkZtj017bV94KmeVaY7wM3l6kGwVzxBbwP9Ge2gNyh6BUFf2R5RS6NceA+YLF+iT8BbpmlW2nfTg/ieA89qQ5C6aEn2mOeVHrC5A/qY9gH6i3KLfOhlPtfP/UskoM/RIVH2kOAV1COtUPTvgkP8jLI5vjTDALaFYLpNBO9dRWi81XDZ+sptRAHnBhnT/hoAAP//7t4LvAAAAAZJREFUAwDohdloUcRM7gAAAABJRU5ErkJggg=="

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAACmElEQVR4AeyYIXAUMRSG93DU1oItFltsbZHUUlscU0ctgys4GBy12NZiqQVbSyW1tcf3LRtmbzebfYFD3Ew7759kkpc/f95u3r3tvabyb7lc7oADcDiDfeZ3KumbsCDIt8AhGxyDPbA7g6fMH7sGbNEPWVgQbM+AImiqzDUH0RUhQZzQ0D/pSG9pz8HpDD4xry9Ns9tx2C9iUpAEwJC/g8HHRNPa58VicQGuZnCJ9xeQTK6PHadRS+MrbVYQi9rnj6eRGT7/G8ajdpVxlNML4R6j6ZEgxKh+v+f5k/4PkOxx6gTaRz0fDyLSUPYWjgThnd4Vus05j+WEzluQbA/RntD3ooTnLOgf7BSuV4z5/tG0NopSTpAh1fsGggs7tL6cfSKjaAooYXiwNjpwydn24X4AViwnKDn4qFK/6Yj6ov7MFToepL0EA58kaPh+xhOjhJ2ol/Q/AK91CfqcsKZ/01hWtlKEsivZ4BZ8A5cz0McIZXmmBqsFTRGta/xO0FwkNzdCJMNSEnSuJoNPBioUIcRY/5SSoHNH+KWkOrnh3ERIECT3QcSifpNcIUHkG9O9ia6UCP2t+j65U3AiJEguRJnoSskwV2q4tAphQVWs/+C8uYK4QdvAT6Aq1AYrFCGEWP+8gdzaugqs7RdpUJQtJAiKh+BvrSo3RQV57a1rvqKqFmesCVtIEFfeGsjK74x+LVJ1GBIVERQiWpfTRgkaFeDrikKJJxehVAebd9YuijSwjaD0+ZP2Yui35QT5Te6sYvwer0qEbFjyt2Z6AbncNM3oxzgnyOudlHuSqkTILiX/I+blpGm8faPvvJEgrrWO/qvF1oX/A3K/7/Za4R8JchbHa+B3uPWPEatNhlP+csn5Gv5r9xriFwAAAP//V5BMqwAAAAZJREFUAwDy+bXpYHz9PAAAAABJRU5ErkJggg=="

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADVklEQVR4AeSYjVnbMBBAlS5Q2KDdoGwAG5QJKBPQTgBMUDoBdIKyAXQDNoANygb0PddnlMQ/smMI31d/Oku2pLvnO+us5F1648f/Bfj09LSPnCKXtRxRf9gkSLN4EIgd5BKQG+QM+VLLFfU9fafUk8osgFgWTCiaVXmszs+nMyBvkNHe3BgQo3rnU81yR32wWCx2Fxy0j5EHxLLPaTTkRoDA6RFDiu0kyCFct6k+aBviAy6vEYvjfRVsF8lGgFgwtFRVOQNIyOoiTt5DDrkOcBdSeJzb/WUyIN4ztHpECz+A+GmjR86zPsOdXXY3JwECpwfy0Ea721JKuXd3UuExGhA4lf/K9B/jvdVVm3U3zfC2N0rGOy6NBmRWHtpz4OLdoqu35IsjFk3vBDtHAeI9c91XJyIPwJWENjEvf6gr5uXhRlV3KQbEiCHSUGgzfUS7s67nxYMIli+WznnRUQzIBI0ISTMZWo3ZHpLBVNSnoAgQLxjao1rRJqEdSkW1iedqEBA4vfbqoQ3EQUAGjg4tD2UqykNrKip9JTD5XHoBMXTC0AjtLatPWG4NFj2u5x3oV6Y0FTl+SToBgdNAAPn07kyWJrddMM/PWJOKGBM6aI4vnYCo8mthqGim1o1AWjmA86HyhOzWq/irsaKuumwFxJAh8nvrIBNr6erTW0I6b0wqcnyrrAECpwENOcHQFiVW5k1KRRrpkzVABn9GoowJrV6PeUVfmRjcV7cBxnvnvN+eCkSP63mHzhJaFSltgKNe6n+hTZGK7kakIu0PyhBg7s01ZcDpte91hw/m1r6+nKdqA8w19wIy0JQSY2YNLbqr0gaoJ6pOTu+R1oL3XBQmZftNRRc25pYhwN3cIFD+g3BKfc99FwZVKk5FacLRBuiP71AljD8TT4Dy4/+HDsF892gmvf2NhSFkeoljDRBjGo3fDIIIZvginHI4xgS+x/gY6/3ZZQ2wtuDGYPXzJlT1TwFQ/rVRlMRrfZOrVkAAHhE/XXtoFtb08ZF77usmb53QNbq0AoYWgEy8rtBr2nowul6tXgJkIbgo4s/HbdVukhsHNIDAuQhcoYZ2m3IBS2z1lv5ZML28WLpoXDLckKF5nRoP+o4hLgSqrRYZhKwepQGsrt7g6S8AAAD//4KwQGcAAAAGSURBVAMA2WqSYKa7WksAAAAASUVORK5CYII="

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE6UlEQVR4AeyZT6hOaRzHzzvNwmIWs5hpZso0MzVlpmlCCAshCivsLBTKgiiEEAtiQQhFWCEKKyyEIqxcueWWBQtyi0JZWFhYqOvzOd3n7bk557zvOfc9977k9vve53nOOc/v9/ue3/Pn95z3u+QL//tGYLQDWCoCAwMDk8EWcKgmbETv1DIvpS0CKB0HbqP4AdgL1teEA+jtwdYDMI56S2lJAEVz0NILZoGRkskY6sX2TMpCKSSAgl/pfQ78AJSn/FsLZtcEI9uPbkWbF/DhRxt5KCRApy1AEhTJTf7932g0joE7NeEINv4F2qJItK0P1jPRisCSwV4fKJfitCXV+mTQxgosfATKUv/lIZcAoRtLJ98ARdKD4jdWRgLYeomdO0AZiy/BD9tDkEuAp74HQVQY6iNVvo8MjYnqQ6pFBOIHQzjja11Rb5dAVzib5cTXQ4CJsgycBwtB7pjLegujeS2NAA67aZzGEZfNy5TPwXbQ9ZISwEvX9x7KIC5bK0OD0qWsK6OSEmDddZWZgaPzgRGQENWmzKX2ikiZhU6i3jWSEtAbSYAbYDHtv8BWEPISqok5ibmKSZbZ4joIeS0Zzb8mgdgJSLwG+4BEzEKdH3FUzBYP08eonIJIqRyefh2TTAJqx6kxAhJ3gbnJb1w3An2UQZwXy2mYwz/meQ87v9AeMcklgAdOZN+w4/6/RqPxDiJHwETuTQEnwDsQ5B8qHnb6IXIJzKNduxQR0Lhj3Le+yUYAJHrBatpGJY0A9SBGZRGN65B4AXaDP2jXIq0IFBqFxAdwBkznQfN4j4SvqQcxo91Bw6hcg0jHN8lhEcCxpkDiCdjMBSd+GgHqsYQl2qjsh8z4+GbVescIBAcgYVSuUC7gmmR2UsbL8U+0HZJ9kLgHTGEcdlwuL5UIYHQO0HCMzyYtJPrBLiCREIF4OZ6Gyy7RLhbH0Vl6OS5NACM66plVwzGctH7BwKfPBRLxJmkEnkRPuVisou1y/BAb66ibn1EUS2kCqDPtoMiU+BSX+QBE3CQPUjrpnfy+hDgqE+joJmn6QrVYShPA8C1UOhxcPmPM5d4N7rUtPO9ZO2ySRsDvT1n9bxOVzE2yNAG1Y9jh4PIZQ2LeLg30uUmepHSDdKM0AvEm+SdK403S5ZlLSVKJQNqzpn+Q6AMbUB82yfB1gkuJq5VLdPNbUdcR0EsBCZdjI+xXQFcxI+Am6Ry87jOiEgHG4xpgjlQV2+nv29SHTHBf3em4h4zL8TYe/B38TPsqZSqlCaB4IT2PAnOkqthD/zWgSOJxn455HP8I4rlRaQ6EMBYZb+deux/LjFTu8lw6AryB+3hn6uzYrIqJ6LmInmFLuwR8C01jGH8GhvOFOj4UNfVWqRQRiHdHE7Aq+ofTx/Qi9I99CdfSMpcAb9ixLnxwFpM3nUg26ga2PA2a6GnK1CP4YXsIcgkMPmWeYtVJ5OF9yFDyRqeB89o4i15LisRfiCwz0YrAQXoF9iZXjzDgHmBE6oBL6yNsaosi0banPOuZKCTAMHpLLz83hjH4N233AH+xzEeSVL2nbm1gJvH3AX8VKvxhpZCAWiBxl9IEKy9T5HbHxfxnCrZbJogtCegaijzvmimav3sYMVusA34N1PHZ2tR2K7RFIChBqfm7h5EN1OuAXwNLRboUgUCkm8ovnsAnAAAA//887lWQAAAABklEQVQDAEtDxX/+nMhtAAAAAElFTkSuQmCC"

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFfklEQVR4AeyYTahVVRTHzw0HDhokGCoYFRQUNCgqKigoCioKLDJSCFIyelHRCwqLJjkzNFRSVDQoCHRQqIMwoahGPvBBNhMKfFCgAweCDhwIz99vv7OO5953z/08Bz94j/W/a+199l5r/ffnOe+W7Ab/WyBwrSdwYQZu6hmYnZ19H7zbJMnGlhCJryLxnWBPbmPWL40RINXbQEjZjrpadJMEakmwn5OBCLAEFoOV/ZzV9ZxYy8GiQfz1JIATE9+HowvgP8qnwfPYjQi+nwX/4PwMuIC9DSzGrpSeBOi1G2wAMRp3YR/G6UvoWgWfr+HwF3APUEx8EuMbUCmVBHDoxluT97yEPgkUHUvCgJbHBrH0dRBHMVDGMiZV2Tqe36rRDZUEaCwBk8XMfuTnUaBGZQY6iGMDWx4ZuY9y8sYwlrOhX2Mt1eiGggCO3gIHwCoQiUefy61W6zKFtcAAqPFJEMcBKCf/HY7X5rEw+0sigCOnyM4umcN0Ow2+AG2iY/A6lduB4ug4E29bGAbE/Ij2DoY+MLPt+F4PHKhs0L9EgMautyl0yHIMNy8qyUoCFrNCkI+pLZPYz3MTorq/5G2jvx1MXp/aQyERICFZP0XPF4AzICHMQp7DOkNgj7WHsTP6GLAtCZ73JZG3aeuX+9Lt0EgE7IUT1/kx9KuU7wafgRkQ4qb2WJsmiRPAZDfxcCsI2Ur9A1Ho1Dx7kLpy+83EcyCoHk0KAuXuOD0LvgISeZpn7o/yrDxCnaPoheMJ8StlxfX8hkYF3LS28bHJf64xDroSKDuExJ9gPXUrgDPgGY2ZxH2xDsslhkrigZCMLj/lZ8e6PB+6qpIA070UeLSaZNZqtc5DZAd4iCie03vQ50GnTNDvEJWPg8alkgCRHS2Xjpu37aMEEtPgPdo4K85A+QST8Cs8mwAh+gq7Vt2LQARy83YdTUhcAt+DJ2h8P3CDnkV3yk5m5SiV7h1UfTIIgYGiQeIU+JTGbnxnIF4FqEriEf1ksuZ+ls2p8X5rIcDoLhOmAgln5Qj6RcqS+RJdPo4pJvEGP06/Yp+l2iF/aiFATJfPDMkcAumio87LbgYim4BEnIHOS9KlGftsN30fs98wqIuAMWPzvmmBZO4Dd2oLSJQvyU+oOwVC3Gdu+in6/AW8JAfa+HURKH+lxdHqaDorR0mouJ0h4iX5NdpZc/M7A+VL0tvaS7J8twTReXpsAiS3Ba++dqAy36lcJtoBl06xrGhfJjMFkbgknYHp6NShf6ffRjBv449FAIfbCORyQCWZJKG/k1X943dv2+alj5fkXrQXpBelMxAzqSc/ZTdjOKPus+IfDCMTyJP31QK/SUx+V7J6/JDkDh77EePS8ZJs27w8Pwl8wYtL8g/ah8Q+2xgVIxHoSN5ls4GgJhZ+e+q8reTLm9fZLPrRxuPYS/IZKj3FnAEvSeMVd8xQBEh8ETiAQ4Oj0ppfQ7BvLQwD+kh4NX1MCJVN4nsfSG+r6PjvRBzHvrneQcPb6fszOsmgBExcxybvZ6edDWzyP1kYBSRiX/3pSxd+BfpdbqwtkPD/UG5el45E/GYp742sF4FzeAzHjtQJympUMfImYHlkdCFhjOM49PRy83qTS4iq+VJJAMcXae5GQ2WOgOeztmf2ap6PnbzORO7LmdC3Vb70GVP7B56bi/Y8VBLIW36I9l/k4fhfyi/j8Ai6VsGnA+JLYLw3GXM/QcwB1V16EsCpJ4EOltB9BeV7wW/YjQi+fd3wxHGzLqH8DpBIZbyeBKKXToBHWFQ1qon1P+iZeCQwEIFofD3qJgmUjztPtEb4N0NgLlUvmw8wJ1gO2pj1S2MESNpLZxd6b/1pX/XYGIGrIZq1Fgg0O779vd/wM3AFAAD//9iqHRAAAAAGSURBVAMANR3qcJH9OYQAAAAASUVORK5CYII="

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFQ0lEQVR4AeyZX4hVVRTG90QPvgQ+GPoQNFJSUpFRURFRYaI9REYTGRgUBhUFCSUaIRn0YFSoVGBQMFHQBEoGExUI+WBUIGSoKCioIKjggw8++CCMv994tu479547d+9z9So4rO/udfaftda39zr77HPmhnCN/10nMOgF7PsKTExMzACLwWqwAXwK3gULwYx+E+4bAYKbA74gwOPgd7AerATvgc/AdnCcPpKajd4X6QsBgnqRaPaDt8FMUCe2SWo3YxbXdcqpb0yAQD7A4RgwOIpwlp8fwCvgyQqvUdrHNtQwh59xxq6gbCSNCBDA83j/GETZgjI8NDT0MvgO7KjwLeVLtM0DphdFuJGfzdhYSFksxQRw7CxuTjyvI8gXwMmkrkWl7Rh4msqNQJHEKLbi6lmXhWICeFkNZgFlC4F9pNIjVtHPm5oi3MLPO6BIiggwY26H5rhOzWtvXvWeANlzdHwTWFKEaCvk/hURwMnDIC77OAHVpg39OgpjDtGwAyjDTMrdKrkoJXBX4igGkVT1rKZj7+15VNKxlEDMfU05k5YlOJYMSm0m1d3VUgKpVXeS9LpUj/dD1vhSAunM3ZnlsbXz7cnliUTvWS0l8H/i4YlEz1WfSgbsSvSe1VICu/FwBChL2EHuUMkBY+6nv7sZRdjFrnRUJRdFBHBmvo5WzrwHfJr6bKiquhcEb9843s6enSyzUUSg8vIJZVwFZ/LHKjCq66Xq8zM94r7van7NdZEUE2AVfAIvx6slRVgaQvibAGv3c9oep89/YAlQHLu8suV1NjIItNvG8V/UGriBoIYFIQTP+hLxTWwFQb8O1A3cB1fctc7Qdyk29lEWSyMCeiWAPyjdiQ5QRjGlfBP7hgpPrOqS43JSTJsHq7GTFaU/jQgwszPBWzj3eJzu6VR1Fc9Rrk5tunUdnTQWESDoWWADdg6DL4Ez7m6EGkynvSgel7dRjoN/wCkQZRjFVTHd/sTWo1wXSTYBnDnjB/Hmu60ziRoM0Gt3lptIjXvAIvAceAY8Am6moxihdAv1HkANpt9O7LqLZb/s90wAB7PBbyEEZ9zA47NgHsEZ4CbKfcB6urULbafAVvAqrZKRdDxCLKPOFcl62e+JAIHfhnFnOW5/6gsMBBSdRhl3FmzC7lzge7Wp52uqL/u+7VE9vUxLgOA9JuzElHlLEXT2GM4bbX8aEtiRyFp0z0U+GL2X1uP3Q+qmla4EMHIrFvyK4Mw4Q8twuBbUpgn9iwSbPlP8DBO343X4937raq+WAIM9r/gtx5k34BGc/NTVWsNG7LsCkohpuZE4uu5QtQSIxTx0e0QNazD+q8rlBn68qRfhx23XdBqDhJsGVe3SkQADfGquqbpvw+jnlX5FCvy5EvFLhZ9d/PrX0XdHAvT0BjKFzPs3uL7iAglXPB6zVzKpHZ/0bQTo6Ox7QDNoUyf7k4kD+4T3seMkmkqmNJet0kaA5viV7DR68TmdsY2FVfDdO67CCJPbdi+0EKCDaRNnfxQDsm8cSEMDPuw0YfDPqqRoIUCDW5YdUYNfmi0HCibRg6HHb+OIk6s+iakEzH8bnPl/Va4SeBIwFA+LlhcxlYB7r42m0kMqg0aV1g9UccT4qssQphL4hRZvXoqwncHfA/+nNSj4P7c9BBMfqPGGpuqCtBAg3wzeY60p5Cr40u6Rd1Dws33c/8eI76sLYV/6bSFgNZ18x52P7n8WvXl8KuYhhH7192DnG53nMP9FFab+tRGwAySOgFXgPjB3gJiPb9/othpXJ3Qk0Knj1Vp3ncCgV+aaX4HzAAAA//8+HLyhAAAABklEQVQDAPmBIX/h3jq6AAAAAElFTkSuQmCC"

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADmUlEQVR4AeyYv2sUQRTHN5IihYUBCwUFBe0sLPQvsNBCUDBi0ikqCipGUIhgZyMYyIkGlaSwEBIhQiwEU1hb2CjYKSgoaGEhxCJF4Px85Q2MuZu9nZ0dNHLhffPe/Pq+953Z29vbDcU6/+sL+NsH2D+B//oE2u32BXAup8hslxCFH6Hwe+CBxYTNWzYBlLoJOPNj19eIzymgkQJ7kVQSwCUwBLb1ImtqnFxbwGAVvlIBkKjwGYiWwWfaH8FB4iwG9wHwHvKvYJl4CgwRB61UAKvugzPA7cYO4kVI9QElbM7gPAbbC7ALyFT4OMFdELSgAAj1wRu1lSv4N0Am4gXGlVDtZBjXPERuo5RLOekqTjK+UUE3BAUwWQJULGGxwL/9QB5XKNE8xMkijMMvXjmUS6fhcm1W0A1lAvz5qwMDA6t0jAElwKWL6FL8I4jHLBdhb6sq4DeTiMFxGi0gcydxWo0YUPxl5vs734L7FNBGMVTNogQ4SpJcIfZFzFpBdPc2m6v12gAtUPHiVByFWgKUYY0IdbWsMMVB2BwV7+bULl4EtQVosYmYVGyYpMA9Fnc4xvbS6c+/ZRx017MkAUpJAdfwrihdEidoh0x3Lc3RuIq/riAFyQIs+XPzcsF7NoP+2BLtZIsQkJwrC0FfQJZtjSDtn0DEZmWZ2j+BLNsaQdrUCfi/0n6U5P/pjflrvO64MFkAjwe3STkBZHqSXFQQwBP6NQdXTLD2poIUJAmggCmSXwXOxnm0eOsaaz1j7+jz598wDrrrWW0Blli/WV1mFT/tGiGPiDuM/bHOuOiOt1oCLKErQpfEeSusUgU2163XmnHjVByFKAEkGQRzZHDJVfwoBT2kL8pYo5MYYZE4cIVEzMDvnlbV1xNVBej9kIhVvHtTocQq/mnPLIEJiNBa8YlLs/QKZy5GRJmA7zA64qPEr4F2DFeoP6l4kQhdRCjHK8YOAZler6gWxR0ICoBY92y9JdAivV7RrynFIhxhXLundjKMSychbvHt459y4orHjKsWxR0ICrCZl/B6Re6IP9A+DOEzfKMGpzZEJ/3JiJVzllg14LpbqQBIV4AIhlm+lXg3eEmcxeBeAjsh3w6Gic8CCaHZ3UoFuCUiAd9cO7cn1xdQWriroZIAN/lf9DkF+A91wbtI6qbkEUBVXAL6oF8k1Le0/9aCruYsmwCViIhpEP0trbVVkVVA1SJS5vUFpOxeE2vX/Qn8AgAA//9Ktq8EAAAABklEQVQDAHVoEHC2gMI1AAAAAElFTkSuQmCC"

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE2UlEQVR4AeyYT6hVVRTG9wsHDR0EGRQUGhUhGTRoEik0zwhRSOhFQU1CJaEiQaMigySFBkYDlYIMgp7QwEGhjXIQ+IJAB0FGgwwaNGjgIHj+fse9ZN97j+/d+87eiOBlfWfts/+stb619z773HNHusV/twnc7AlsOgNLS0ubwMMtSTYjQOCvEvh5cCGXKdaXJgQI+E5CPQBCDlK3Nm5q6iYECNDsr0OHGPyuuKmpqxPImS6z/38OeHduy7d1VHUChPUmMOOodJLLl0CxrvosVCVAhl02u40WXAHvgg9As1moSoBAzb4bmGI6Pjc3dxH8llIqZ8E+VNWRagRy9l/LYZn9ch+Mz8Ldud9gVY0AkZjZyP5RMv83dZ1QdhY+7W5Sss/7uTxYVSHQk/2DPZF9RN1/QJlnzAYLQ1GFAEF8CMwsKo1k3wrBLFxGfwyUNVzeAYNlMAEy+ShR7ADKv1z6sk91J0e42geVdjL2IQtDsGoCOF8LXPdnCSCyf5hMX1/71I8IbQZ/OFc6C2exsQvE+Nw0vZqZAM4MfD8ufgdm+y604kZ1nVteDodo/BUonhsS+hO7+4GHnfVTY2oCGF8H3sOygfuILJ19Q/1TZNjHJ8UbC33cyFvo4RhUJyZBm3/h4xMw9WN2RQIYWw8+x42B70NH4J6ux7l/kKC2ATcptysLff8B2+j5OFgAQdyl5El+CZ9TEbkhAQwY+DGMXwSvAI2jUgT+CEG8BFw61s8Mxi6C5xgoEZdSH5FjxPIYfXplggCdDfwLehv4PNrNllJKTr1ONuB0UODYHBHs+cqxh8oHgD5KIsawSFzfgvW0j8gEAVq/BztBBO6Tw/V5H472gD9oayLYvgyCiA8IfYevrRROgxHpI+CGKjv9zM1pDJfGqGon+HI/Gez48rx33GsfAde7BqLvMxTOMX1nwLOUmwo+ngZncOL58gQ6xAS6nOK+0xMEYP81La5FnwYlkc3UL2D8PKhKBHtrwPPgJ3wYuL4oduIsGMs9ObauMi4TBGyg4xXgsS8RX5Hd0DaJTVyCyHacxtOJ6tmEsQb+IqMuAM+FJ9EhBm7GfdodIZ7Y2NHe6V4CXQsXB4HPKG4EbqJFdIhE/Mu4qs8mBB+Be5aUb6ae0hH4Cfz72A6fE3pZAtFbI+AU8Hk9TuR++h0loK/QUwl9PV/GA3fpbMXHRrBi4OFoKgLRWY3xIOLm1qnVYgeBvWBhOdDH/WOGo5s2NmN3CzgVldPqmQmEYZz9AHyniVdpmw4QYJwf3o+ANveLz/eon9cG+DEqZtWrJhCOcO5Tyyxa5Vpebha20ym+lZ5j7AnuB8lgAtm7J3Uupn1kemIWqBvP/lsxYIiuQoBMugTKWXi5J6jyc+N3eUxPt9mqqhDILstZcC+Y8a4pZ7/MuK/lXdvQSzUCOaO+2xuT/7TesJBRZn+Bvr/k+sGqGoEciZ8S4+DZS+b9++lMlNkvZyoPW72qSoDMelKXnxH9mOsff2fEKKtmX4NVCWgQjHxG5N4XMVTyXaZq9jVanQCz4EtYOQvxH/okbdXWvsGL6gQ0CspZ4LbLvvvDclU0IUCmnQVf1iJYPzdeipuaugmBdC3C11F7M95GN5FmBJgF/xQdQgs38K1FoEm0PUabzUCPryZVtwk0SesMRq8CAAD//zlp6PQAAAAGSURBVAMAoSmOcIEsrJgAAAAASUVORK5CYII="

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAB40lEQVR4AeSVIVcCQRDHD5tGrVrNVo1asVq1+Yw+mk+TPBtGqX4H+QxaMUqVSpWIv9/CnvC4Ox4cR9E3f2Zud2f+O7Oz61ay4b9/RDgajXbAATgsib2iUwolhcBF9ywUDXQZPBHvjBiZEgiZOQaSfqDfSuIH/4WErAnyXqvVOmVAlCGYETL2qHYcjBlqrx0Q2RcXBPaoTtHJQkKcbKI6Wlh2/RaC9a6VaKa8hYQ4XRHZBjpHCxtCzWehbDMrmaQ97FRyCSGzkUSf1e0JBmgzPUQXSTgvFuhnE2KOJZeQ6ViKF5qoKxh7BcqJPzn4ZvwLNCc+mH9SROguBziZVfQwW+1df7LA+jZ4BtN+6dIiQne5R2mns4lZf6YRljSKCDvE8hJfQtoAD3zXgTvvoleSXMJJSZpENVObxDJqtyZzTC0vuYSGMjDwPK7Rt0DbDJ3OBJXYB16HzPlCwkyPxYPe3dz7WgWh3e22vK83GDPZVkEIR2Kz2VhHfPiWosZSFeGQ846vTMw4MFZFGIJD6tV65MPXJzwakdASMJ6c0WHWfmUQxIc7xksg7YP0mYuEvhy2uzX3v0EZWEIzg3teAiE78M28Y7q1BnhfbRhCzUsgjMMQ99aAtJwx7rSeIZyeqMreOOEvAAAA///om5aNAAAABklEQVQDAAFVLkgXqSDeAAAAAElFTkSuQmCC"

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABH0lEQVR4AeyV4RHBQBCFEw1QghLoQAl0QAWoBBWgAqMCOqADOqCD+J65H5fLYXIzh8mc2Wfty9p92dxOWtmPP0lAmsD/TaAoih5YGyzx3ZiL4pvAjoZjgyl+CaKZT4B7x+1o3SnsEwD9PUsCgifAdnTAwKAT+tCCBNBUB/VC04PByXCE9SxIAC0GwL5rCRIHXc9CBdTr8iY7CWj2BNgMvdh2+IPB0D0OsSewoKGaakOENXHJYgsoNSOwV5cwy74t4NnU/vpLAXdb4YvfVw9/83Burcr/fBPoU2gFNkB+gi9ZnudHCPHKEcZwezjX5hCqoRxhRFyyigAKXcEMTIB8RbUqcG0DlCNsxbngul1LeWc3pyLATYgdJwHNn8CnM/QAAAD//32fPs4AAAAGSURBVAMAialTQWDXi6EAAAAASUVORK5CYII="

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAFjElEQVR4AeSaO2sUURSARbQwQgS30EKLWFj4gBSKSlBBCxvBLmDakNTpQsRWdn/E1vEfBC200BAVLBTRwkILLbSIkBQGNIXnu+xZZmdndud1X2u4Z+9j7z33nG/OPTO72YMH3P9Ny5YzIudELonc6sldqZPC+A0ZuybCXNa0pO20uAB0WDzCORy9I22cPi/1GZGTIlM9kWqgMA5MoDCXNaqD+pTMZo5U9ootQGkoOIejjNf1Bh3omhVFRJnCkm7zpWlAGH9WzMRwhSJdq0Vh3ZZd2LvRqGoKUBIMRtIXe52WI7IbexNR1NKtX5oAxBUkr2CUDzBpCgqKiMK29Pul+nUAAYNjxBXDqFIbO5iMTdjGHfBQ1f2qAuKcEzXcnaru7Wodd8Cbshk2S1WuVAFE2F6XbbhCUkVRsBWbT5S1tiwgIoaw5XiV3cv3fGy+LEbgg1TFShlAJGFyTjHN4c7CB3wpZGFRQFAvrLTQzn4n4Qs+jbWiCCDOLdTHKotsAj6RT0eaPQ4QmZ9H+pFKIn6TD8v4mOvCKEAkteGEnKsqyjfUx9znpFGAOKfcHqP0vITR+IivmUvyAHE2CyWxTK3xDfIwic9DlucBmuS8MwShN4DPQ0ctCxDhRtj11vmvOp3OhW63e8WyJfhMJA1skwZERj89MMNzZ3Nz8/7q6mp7cXHxYbvdvmjZHNLKQBSlAfE1JiQt21FMPXDm5uYWdHar1eICatdGzV1tIIrSgIKJnjScra2tx8vLy29sUEnpHIiiJKBgoicLjkTSesoRW12iqB8oSUD9QVs7F9HrGY6ayH9bTFsBcbYznwPMLEcvgcDBW1iYZK2AjjPqUwKCoxjMiVJApqPvuK4DhAMCc8wUEP/BZNC5BAoHDoYJgDhvZG4GbUiuzoDhYDNMpgFkSDHiUgKHoyhaAOIOpgNO6kjgwOIIgJxGUERwADQFIM4aHesSGRx4HAOQeSCiZ1MihGNwAMh6DlpZWZmRz1L9T+V88JS+q89WxtGKLyYHVVxbfNn8/PxVnR0RHGMyEWQaNl+Oyp/qn5I/bcdQOwG0sbHR/x5ndnb2HvkoBjjYCKDfNGzK2traB46W7iH5ZyESSHsAUrut1gJlPUJIfwC0a5VMQnmEkPYBtJfwwXozMkg7ALKeg9LUx0JKL/DXNznol4/9I4G0SwTtCKC/Is5L4JBgsg0gwDhL1GyWlIAhGSYK6EfSaNftQCF9g4MC+k7HpwQIaRseCsicNwZ8SkCQgGMefxQQXLweMwxAAoFkjhf2JAFxzIgkxr2KZ0g8F8LCMEgCAs5XMxrASxYkB78PwvM+HDpJQPQBBCja3iUNqWX/90FET/94ASANCDhA4r0gBEjdbvdRp9N54OD3QUSPSc7qfBoQ4wCCJO0gZGlp6TXfKVk2Bp8/p/fIAkQUvU9P/A/6mT5nAYIFzwFEEu0YpK6NX0QBPks1WPIAMYtwI+xoT7LgI75m+jgKEEftlayilmoiC77h436ed6MAsYaM/pbGhMo78Qsfpcou4wCxirP5kcaECT79HOdTEUDoIGHnnlMmRCb4gk9jzS4KCEUohTrtmAUf8KWQD2UAoRDq5CSSG/2YBJtJyPhQ2O6ygFDM1yIvpMHtUaooCrZiM/m0lMFVALEBmf+lNEpdDZnvo/AQCBxsLr1/VUBsRMhynglbrhBjIQk2YdsnMSr3OUfeG1nqAFLFhO1z6ZD4MEqaXgsXDluIGmyrZUwTgNQAjOKKUfsApWCeiUHYUDlqZH2/NAkIpZxzjCOieEqtfQVROkbYg6PeKBjds2lAqpeaL5+IKAxXWFxl3qsj6FAoT0QRe3CzKBcxsrBIsQlI9yeqFNZTGcQhrjhO4Sj/wcw6kowhfBxgLmvIK6qDMStQxMZ++QcAAP//wMnVFwAAAAZJREFUAwDMNbT7Ap9dgwAAAABJRU5ErkJggg=="

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFCUlEQVR4AeyYi3EUORCG5YuAywAy4DKACO4uAkwEQAQ2EQARYCKADCADyABCIAPzfVr10J7HzszuTFFUsaUevVrS/6u7Jdl/ld/894fArzbgrha4vb19qOxJcjcCAL8E+GeF8nPyXdIiAgB4hFwj91eguEq6V4y9l+qbFWcJtIU/sqKA3pPPJsaom8kKfhcrzBJoaL+1XJ9+1cqjGeAFrvv0+5/RJ5F++1n1WQIXFxffWeF/JNJzgBzbzScoSoKs3JRS3iEmwR8bp85qmSXgjJD4Qv4CifQKEg+jEjltAs+7/5K+ayTS5lZYRMDVIfGa/A0S6X0DHHVzwUrC8g1jvilUdrPCYgKAKIDRBbSGVYF2Qd3I6D72Ke6+uSIxXdHyplZYRcDVEeNhLKgFSXdNdfdriQ/E1Q/rbRoLqwk0MJIAWk0GtSfT1O5XJT66YFjBe0EL0nxeWk3A5SChG+Wg1rXsUt7Q745b7oQ2wYcVbPeuMD9LTiLgigByRzMgmwVuu+UxsU8i9l22uLF8spxMwBUh4c5rDatVaJNELfc/9Ak+k/4IiSeIcdFXX1RfTcDFkOzvxkOAvk+f8XBsca3Q6aPoZfeZcSfFxWICLHAP0W+/umgre7QKRhI012RQa5la6X+aFR7THncDxWJAe4ppkbfMbb0s+c0ScDIkgLtImNvXab2NAaUb5aAevakDEPpecN7YD2jrE7H9K2suIjJJgAl0B83rjmfg+rHtDwAicDAULaFrZP8eu6lL/jF+iohqi4gMCDTgPp8Fnny9CNzbVeBPXbz0frTpOkFKN+hu6p7qnSrjTiYyIMDMgn9EHikDv2Yx69E3lhsPxoV9s89vlUKYOxNxs2IeVbSI2Cx3MkYgfDyU3NFPTD4HvOqj56KSqHU+R4Oa/kFqc3yio7+mVqX5Zxoj8JRuQZDVpDU8HRTLtfHYBwCSXhzUeS5c2D9f3WmlHhKtXzJ5zto8IMDiHxBPhykinhA5NupE/Q9zrArqHvC8UQLXnYw957yz1IBA9ALAF+UYEc14w4KzRJhjNqiZxyeFu61k4HrBJXP8jUzG3iSBDYkYD4Jxyi6oG3BPurd0ZOD6vsDd8XxHoDZMswRiCLuQLaKPR1dYZPQJwTjBSyL0DWr/XyRwx0a7wB+jr8wCj0GLCcQAFpDIP9R9DrgoxZoENhobjJFwDsAcnM4haMVynWzpZzWBmBhQHq2SyMC8sUPlTo6+AZhvavtf0n4ScAcrJxNwsAIAgcXO+fwYtULTzUFt079+zpGzCbTFPeZasfjI61+G0WduPBgXlrugtnKKbEIAK2gBRQwGpjttuRNOHdt99AleEtFn7Az0o3Mu34RAWyRbYexfJ97k/6kL4X5QH31+O2ZKNiMAKC2guJYu1O0qu+9DTAt0b3z0jZ0c1LPPbyfuy2YE2sQDKwBe4FetX2KtWHQnSWqNwk+9Rc9vdLu0KQF2VQsoLiBYAXoqCc427xBjwHKI8RBtq4N6UwINkY/AVizPKOg+ZDVlC9UGSAteErXOZ1VQb06gAYqngFY4tvvgLbqSbpQvxMVBvTmBcviN3ciD3T+oHr4QHwtqN+CgMPHdhQBgdIt8woz5/gAS44wZrWFfWM7ypOxCoByW0wrGg6Cyexx6p7/Gg9byjeQfM9Oa9OxGgN38jrjz/rN3FghYamKMf9j7B0ycZrV96rMbgakFt27/Q2DrHV07329vgR8AAAD//7gthq0AAAAGSURBVAMA55T+cN3qv8wAAAAASUVORK5CYII="

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAD3ElEQVR4AeyYjVHjMBCFlauA6wA64DqASggVABUkV8EdFRA6uA6gA64DKIEOwvs02rDxD3bs1TDMkNFaki3vvvdWP4Yf6Yv/vgl8dgKrZmC73Z5iNUlWIyDgSwF/wtS+Vl2lVCMgtCuZlZVIHFknsq5CQGABf+yAAr5KFsIJCDzAmT4Of25e6RlEcifqEk5AwC5kkFCVNimlexkF8OFZCCUghQHu1f8t5GuZlfAshBIQSsBCQs20WSwWL1iqmIUwAkV9po/w5oL6uaELxF5VU0KzEEZAyACpKpesfm7pUrJwqyYldC2EEBhQH9DYX10sC5wLNtV0e3oJIaDwXv3borhuvxfdA7xlgQecFdSzbDaBhvovQoPSqjoLzyDCw2V5l/Zkm0xAwY9kqMj3jgG4l9KQsP5erWeA91l4kI8LGetib+zYzsEECCYD+LOCMHUsOMBRWLc/LIxhLINYBxx2T/iU0ef+aBtNQM5N8SZwgj3qcl4UVrO/lDHnGmEntJoJ4IhBRu4Ui34a8xskgDNZl+L4Rz2AY6Yq9z80keCA48Q+0cAmEe4/K+YoIr0E5OBYBsCm4sxj7p8IyKUM9YXj8KJ3+4jgbBSRFgGBBviDPADcnawJ4JyuBny04mngN4dIi4BiAf5MtRUPfK1g9O1ZaC3fPiOI5UUiI2Dbi9lFwHYVG/hfjUc5rwZc/veKYgGcqdmM2VrcXQQu5Q0HqnIhG+wOGO18s9ZFU/hMhtLYqYsDmRvXz80WAbH/J2N36CPCDuHXRnY09yLQHrgXCuBMJ9YeZ8heqBYBeyoSfFF2ESGNGwUMISI/fFKgNuaBMwuWwvFT1rv2egnUJlKAs9PdKZYHztwHOIr7M0LD2mWQgL0iFXxGWNj2yDLyx24M1QLPWIDzrg0HOAciNgjcXhpNwF4oRH6pz+cAQdXM5VrABteGxrAd+j/u8QFojHZ2NvZyMAFzLCJsrZDwOwPfMzakr+azxJ7dyM8k4OZgMgFzIADsDKYcp3hvFor6Nm0QgHfN1aR6NoESlW2uNNNaQJuHoT1bWUO1f0fdaSWEgLJABjBQoLCf49xLIsXc5xl91Lfx9CdbCIES3Sva9a8Trz6HZHltXhVGoJEFptAuCw312Y45pOYhL2+HESj+WlkQeKaNV9+PKa9Nr0IJ9GSBXQkSoAxVH4ehBHAo8/P7Sn0Wr6pcQtXHYzgBZYH5bZ8CrIVq6lchgFNZ14kcrr7ipPAM4LRkwf8DK3zuEwerQiDhOSWywHpgO/XfSynyV42AsvAqQ3n+2ctfVZG4d76qEdhFqNz4JlBZ4EH3Xz4DbwAAAP//iDcaqgAAAAZJREFUAwBU+3tw11K+qwAAAABJRU5ErkJggg=="

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFP0lEQVR4AeyYgVUbMQyGL12gdILSDdoN2gnaTgBMUDoBMAF0AugE0AlgA+gEMEI3oN/ndzp8F/uSI8nj8V7yrJNjy5J+SfY5edO88s8WwEsncJuBbQZWjMBGSujx8XEX+gbtQ7sr+ji6fK0AcFaHr7F4D11C59AtVGzIC/QYvlcUWGJwLQBw4COkozr8eWB3h7laFg6RPYIukDmHduhPaisDwOgPLBr1j/BoN3T+QYvaQyawT/8WfTWwTM+3HgAXQ0biDL5QETJG7wy1Ebk7+l9ms9kXuH1Yvc1mM9ceIBFgtXmNXjnDi1sPAOJGQTKq9yhSWbE+mdP5Y9ZE+0VH540+3eUaIC6Q/ARFNnReuxEUpuptCGBo3Hq2PgVjZlKZ4LzjufMnOHIIRSTrFgszrNN5syZXQhDuJ/uj1AOAIgF8YIVpDWV8bVRoZqzR2KxN+9H5HEw7PI1hW3uCiCB4DLvJRxX1ACipIugCEogKfzuekVkQkEMaE7T9pYkMemqZ0W/5ImwKwuDF8BGyo6U0ByBWylF4Axl5wah4uDFVbr1aYnsYC2AuHyPLQ72XrOntMexdsTCCov7RLBQBoNTodIpR+gCZFTebZFaMPrZS03E3o0Bc6x5JE5XHn2y8dOIZrBDxQIn+HC8CQMrouHmtd74+NYDcQfvQO0Y1FNHia2qu9b1QBcFa94xBcIFRNiP2EzFvKYVeX4RVXTUASREPlcPKDUNmxX1iiemQhkvCZqXLaCtgaYT8Z7I+dPKklZP19ooDQYsAhNwoB4glZlYEUsqKzpnRKLFd1liCyoZu3yvRl+f77asDJVoLgFwxjuVZMYoRZcXcK5aYQCyz9wwKBNZ4MnUZR4/jAcJLXzencNAEALFkOY4DZuUYblYsM0ssX5yywkA4JhcgQ1372/WaZjjX+NkYAGp6RwMSIIbHcZ4VRYLSscracNYsxFynLwbkGwOAcp3xHdFtXoCYFUuslhUd745jdLyFRtsmAWg4lUkWUccSAWaYlaj3NM/DvSLRTa0IZtMAkuWxB0AiK74gJfdKqcSuCIRZ7R2pLw4Ap7xbJYyAiZekJeYRGy+zNM9D5wXhKXbE9+ZFAeC8JeINV4d0Tp8SAca94uklmGFW3Cv+lt59MQA476mSoojHOlSscYBYYvGS/I6slz1Y4/hDDUAcX+kegrH0qs95s/rnFBU6Dmt0xig38cHWKdS74QLmChLEO7iZqZZQnAhGyTfmHKHcu0zYm8RZq/OWj+sMlqViPxHzAlO/R6q203g8cN416WstA26g0kmQFrUPf2xoqP06iXUbl1UHODS05W2VqdR6mUkj2aMIoFVoVATifSanqEGz459Xmbqlu+o1uv4JEPrSYqJvZuLlJzDl0lzpUQSgoCAgTwLvMx0xp3EV0228gFkO9pcm9FrzRr53TOK8GT3KFGk3bGXDT90qgCeRfg/j1p8bSe7kIYZzo45NJnTovPUud73BGy0fhSYDcBEg3OQ/7bfkmeypYVm1Q8uzgvNG3bJdqORZANQKCGszN+Kp4Uup+uPDdUPCeX/z+tM1Iq/z7g35UHzu+7MBqAkQnhbuiSgnnfDO4r/T9hWrEs67f/x7MTKn00s7r+KVAKgAEGbCS5jGHZJ0XrI/Rvn1wXr/hL5cz9jaNLcyALVoFPLNaDbcHw4HeeLUnHIfeYwada8LkclYu5CvBUBYAYQnh9kQjCeVgHyfhEiPI5+uBvDecdoTWvBlrQDCFg4ZdZ0TUC36Ib4S3wiAZiWXpi3eApgWr/VLbzOw/phO0/jqM/AfAAD//ywBsqUAAAAGSURBVAMA1jcGfwKZtRUAAAAASUVORK5CYII="

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEZklEQVR4AeyYgVHbQBBF5VRAOiAVBCoIVBCoIFBBSAVABZAKIBUAFZAOIBWEEugA/rvR16xknSxZ8tjM2KP1nu72dvfv7p1O+lR88N8WwLoTuM3ANgMjI7CSEnp7e9sVHYlORLsjfeycPikAOYvDj7L4X3QnuhE9iVovyQP0QvxHq0CPzkkAyIE9EY7i8EHD7o7Gclk4k+y56FYyN6IdtQddowHI6E9ZJOp74r7+qvEqWnS9BIETtZ+kLwdWw/PXKAAyRvSupdaRe1b7cDabHYrTFstfs9mMuaeSMFicf5ReuLoXX0sDkBGcvwgmfquN80RfzX6XQNxKcl/kbOA8IBwUDeWvpQDIeeo8On8pR85EjmTeYsuI5uE8WYMjAQjWE+1OGgxAzjeV43wE02kwNxhAOAhswyzy3JTUnwUgR9lZrsXZHSrSLLZHQKhZ3MvwYOelE93oPCrCT7rIAGvCveeS7SylVgCaRImws7DDsDtE8m6DsV+2NJBTHui8k63aM0Ag7qXL6wjnO7PQCkAKrkRMFsteFzIGiKxAx8BDGCPLzqi7YxYIovvneA6Ao0w9ftGsJn2W83/Uv9SluZSd5xMoMlLp0jiBqbKgLFER1Xhs5ABY5hVlLQQwyyzLKQ0cZf5Bi5OXDJRUWytlX2KLACShVfwpKAQhlgrPlWgqPgi/x4HYXhsAnBAIygQg3LIzUU60C43RbxAc+qqxJFD+DQBQzpieeUHjYHMx/wvmmmNpaBMAOMo45M2DNkQW4BAA4TXaBADRyZpzuuka03BRbAKA1sgm73r8bQKAWDbeVu36VzfEW7OxCQC+yTlfcT3QF7PTBMf4ektIDy/OQ95dHsqtMzmmMZz3E/g5jiWB8m9tGSgdjA8vTrmlW4nZeW6amaEvUQ6A640X8vSYl8EaT7PH/XFgdPSJsM9G1hqPD5xQ3V/jOQBGTBo5Vs+RAHGWqSnre6O5OE/5MIVgHdMwaRxgPma/qHz8sLNIxXMAOKO0LppqZlHwsoGh0NW7GXeeUznYtMVp1cqamXF/4q0ASoW8owKEU2Ekp5PsNOs2Ke3xx4sQL/N8BLC+NE3RJzNV9NWJnFj71QoAUUCIbkW8uFSkMUA5YhzAKAd197+kk5on8hzmqolynozGhY1d26rkYiMLIArFtoy7ZuEMnclwNErfYJIOnGetwZlP8DrLB6HBAJgkECxyyoBbiO+bV3KCsuJ+EGkeTkfniTplu1DPUgDQKhDUZjTCrsSnwezLB/OaJOd55+W7KiAYxnnWBpz7TloaAFoFgt2CNeFywol7OcXXadqIZUlyrB8+LzpzON3beRSPAoACgSAT8dMg3TgP0e6i+LCi3velDxBdc2pjowGgDaMivlyQDdYH3SYeRDmnWEdso0T9RDqcSc9dyCcBYCtygJ2DbACGpyuAeJ5YpMYlz5e9Y/HadloTWnAzKQDbkkNEHecAlIu+xUfxlQAoRrk0bPIWwLB4TS+9zcD0MR2m8cNn4B0AAP//O9O/yAAAAAZJREFUAwAZOXJw/cXHLAAAAABJRU5ErkJggg=="

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 923 */,
/* 924 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(822)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  "data-v-cd56ccae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(790)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-4baf1c81",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(807)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  "data-v-6f97f135",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(794)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-5679ba0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  "data-v-0c35159e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(814)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(783)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  "data-v-3ccbbbb2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(766)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  "data-v-1301cfbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(784)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  "data-v-3e0cd58f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(828)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(1051),
  /* scopeId */
  "data-v-f1a6f5be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(818)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  "data-v-98f7ce4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(792)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  "data-v-4f534b1f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(810)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  "data-v-7d46a2e1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(809)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  "data-v-766935ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(821)
__webpack_require__(820)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  "data-v-c5620b7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(797)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  "data-v-581be669",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(770)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  "data-v-1f786e61",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(800)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  "data-v-69779a3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(830)
__webpack_require__(829)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(1052),
  /* scopeId */
  "data-v-f7c374d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(799)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  "data-v-610b04e1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(808)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  "data-v-70e8d0e1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(758)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  "data-v-06b04941",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(765)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  "data-v-11ce1af7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(825)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(1049),
  /* scopeId */
  "data-v-e30e120e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(782)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-33a59b65",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(779)
__webpack_require__(778)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  "data-v-2986d701",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(813)
__webpack_require__(812)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  "data-v-7fe7aa81",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(819)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  "data-v-c35c95be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  "data-v-0b27b721",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  "data-v-6f7b2361",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  "data-v-051e393e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(798)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  "data-v-58a41fa3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(827)
__webpack_require__(826)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  "data-v-ee6a24a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(781)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  "data-v-32bc1781",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(823)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1047),
  /* scopeId */
  "data-v-de4c14c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(764)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  "data-v-10cf67cb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(777)
__webpack_require__(776)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  "data-v-2702782d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(817)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  "data-v-95adaa70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(791)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  "data-v-4f3e3964",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(831)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1053),
  /* scopeId */
  "data-v-fae70244",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  "data-v-0c5b086a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(760)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  "data-v-09097e58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(805)
__webpack_require__(804)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  "data-v-6f723c9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(789)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  "data-v-4afefa8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(801)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  "data-v-6a71d0e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(767)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  "data-v-153b4e68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(755)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  "data-v-016659b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(772)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  "data-v-24234428",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(768)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  "data-v-18d640ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(788)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  "data-v-4ae76454",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(773)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  "data-v-243e9278",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(775)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  "data-v-26977070",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(803)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  "data-v-6da9224c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(769)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  "data-v-1a6a89b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(793)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  "data-v-53d6ed6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(802)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  "data-v-6d667eec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(785)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  "data-v-43405ffa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(786)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  "data-v-4a9c2088",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(815)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  "data-v-93be9d40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(816)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  "data-v-94908a4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xiazai-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xiazai-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "app-box-ewm"
  }, [_c('div', {
    staticClass: "app-box-ewm-item"
  }, [_c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [(_vm.androidUrl) ? _c('canvas', {
    ref: "androidCanvas"
  }) : _c('div', {
    staticClass: "app-box-ewm-item-empty"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.weixiazai')))])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.anzhuoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(299),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("GET IN ON")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.anzhuoxiazai')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item"
  }, [_c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [(_vm.iosUrl) ? _c('canvas', {
    ref: "iosCanvas"
  }) : _c('div', {
    staticClass: "app-box-ewm-item-empty"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.weixiazai')))])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.pingguoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(302),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("Download on the")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.pingguoxiazai')))])])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjsq-box"
  }, [_c('div', {
    staticClass: "tjsq-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tjsq-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingyitijiao')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingtijiaodesc')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info"
  }, [_c('div', {
    staticClass: "tjsq-info-item"
  }, [_c('span', {
    staticClass: "tjsq-info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboriqi')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info-item-right"
  }, [_c('span', {
    staticClass: "tjsq-info-item-value"
  }, [_vm._v(_vm._s(_vm.liveDate))]), _vm._v(" "), _c('img', {
    staticClass: "tjsq-info-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info-item"
  }, [_c('span', {
    staticClass: "tjsq-info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijianshiduan')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info-item-right"
  }, [_c('span', {
    staticClass: "tjsq-info-item-value"
  }, [_vm._v(_vm._s(_vm.timeSlot))]), _vm._v(" "), _c('img', {
    staticClass: "tjsq-info-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-status"
  }, [_c('span', {
    staticClass: "tjsq-status-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuangtai')))]), _vm._v(" "), _c('span', {
    staticClass: "tjsq-status-value"
  }, [_vm._v(_vm._s(_vm.$t('all.daishenhe')))])]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-btn",
    on: {
      "click": _vm.handleViewRecord
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chakanshenheJilu')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjsq-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(309),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zx-box"
  }, [_c('div', {
    staticClass: "zx-box-title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(325),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.zaixianguanzhong')) + "：" + _vm._s(_vm.total))])]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "zx-box-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zx-box-list-item",
      on: {
        "click": function($event) {
          return _vm.handleShowUser(item.userId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "videoWrapper",
    staticClass: "video-wrapper",
    class: {
      'video-wrapper-horizontal': _vm.screenType === 1
    }
  }, [_c('div', {
    staticClass: "zb-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": "local_video"
    }
  }), _vm._v(" "), (_vm.show_svga) ? _c('playSvga', {
    ref: "svga"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xitongxiaoxi"
  }, [_c('div', {
    staticClass: "xt-title"
  }, [_c('span', {
    staticClass: "xt-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.wentibangzhu')))]), _vm._v(" "), _c('span', {
    staticClass: "xt-title-span1",
    on: {
      "click": _vm.handleUploadFk
    }
  }, [_vm._v(_vm._s(_vm.$t('all.woyaofankui')))])]), _vm._v(" "), _c('div', {
    staticClass: "xt-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "wt-list-item"
    }, [(index == 0) ? _c('img', {
      attrs: {
        "src": __webpack_require__(898),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      attrs: {
        "src": __webpack_require__(899),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      attrs: {
        "src": __webpack_require__(900),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 3) ? _c('img', {
      attrs: {
        "src": __webpack_require__(901),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 4) ? _c('img', {
      attrs: {
        "src": __webpack_require__(902),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "wt-list-item-box"
    }, [_c('div', {
      staticClass: "wt-list-item-box-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "wt-list-item-box-content"
    }, [_vm._v(_vm._s(item.content))])])])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svga-box"
  }, [_c('div', {
    ref: "drawContainer",
    staticClass: "drawBtn"
  })])
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kszb-container"
  }, [_c('div', {
    staticClass: "kszb-box"
  }, [_c('div', {
    staticClass: "kszb-left"
  }, [_c('div', {
    staticClass: "kszb-section-title"
  }, [_vm._v(_vm._s(_vm.$t('all.jichushezhi')))]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-row"
  }, [_c('div', {
    staticClass: "kszb-form-item"
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoti')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "kszb-form-item-input",
    attrs: {
      "placeholder": _vm.$t('all.geinidezhibojianqugemingziba')
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": __webpack_require__(870),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-item",
    on: {
      "click": function($event) {
        _vm.showBgModal = true
      }
    }
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbeijing')))]), _vm._v(" "), (_vm.form.bgUrl) ? _c('span', {
    staticClass: "kszb-form-item-value kszb-text-green"
  }, [_vm._v(_vm._s(_vm.$t('all.yishangchuan')))]) : _c('span', {
    staticClass: "kszb-form-item-value"
  }, [_vm._v(_vm._s(_vm.$t('all.qingshangchuan')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": __webpack_require__(304),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-item",
    on: {
      "click": _vm.handleUploadCover
    }
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianfengmian')))]), _vm._v(" "), (_vm.form.backgroundUrl) ? _c('span', {
    staticClass: "kszb-form-item-value kszb-text-green"
  }, [_vm._v(_vm._s(_vm.$t('all.yishangchuan')))]) : _c('span', {
    staticClass: "kszb-form-item-value"
  }, [_vm._v(_vm._s(_vm.$t('all.qingshangchuan')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": __webpack_require__(304),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    ref: "coverInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleCoverChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-row"
  }, [_c('div', {
    staticClass: "kszb-form-item kszb-form-item-select",
    on: {
      "click": function($event) {
        _vm.showCategoryDropdown = !_vm.showCategoryDropdown
      }
    }
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoqian')))]), _vm._v(" "), _c('span', {
    staticClass: "kszb-form-item-value"
  }, [_vm._v(_vm._s(_vm.form.categoryName || _vm.$t('all.qingxuanze')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": __webpack_require__(871),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.showCategoryDropdown) ? _c('div', {
    staticClass: "kszb-dropdown",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "kszb-dropdown-item",
      class: {
        'kszb-dropdown-item-active': _vm.form.categoryId === item.id
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectCategory(item)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-item"
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojinyao')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.liveKey),
      expression: "form.liveKey"
    }],
    staticClass: "kszb-form-item-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshurukaibomiyao')
    },
    domProps: {
      "value": (_vm.form.liveKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "liveKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": __webpack_require__(881),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "kszb-quality-row"
  }, _vm._l((_vm.qualityList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.qualityIndex === index ? 'kszb-quality-active' : 'kszb-quality',
      on: {
        "click": function($event) {
          _vm.qualityIndex = index
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "kszb-btn",
    on: {
      "click": _vm.handleStart
    }
  }, [_vm._v(_vm._s(_vm.$t('all.kaishizhibo')))])])]), _vm._v(" "), (_vm.showBgModal) ? _c('div', {
    staticClass: "kszb-bg-overlay",
    on: {
      "click": function($event) {
        _vm.showBgModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBgModal) ? _c('div', {
    staticClass: "kszb-bg-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kszb-bg-modal-header"
  }, [_c('span', {
    staticClass: "kszb-bg-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzebackground')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-bg-modal-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showBgModal = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-modal-body"
  }, [(_vm.selectedBgUrl) ? _c('div', {
    staticClass: "kszb-bg-preview"
  }, [_c('span', {
    staticClass: "kszb-bg-preview-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yixuanze')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-bg-preview-img",
    attrs: {
      "src": _vm.selectedBgUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-grid"
  }, [_c('div', {
    staticClass: "kszb-bg-item kszb-bg-item-upload",
    on: {
      "click": _vm.handleUploadBg
    }
  }, [_c('div', {
    staticClass: "kszb-bg-upload-icon"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "kszb-bg-upload-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shangchuanbeijing')))]), _vm._v(" "), _c('input', {
    ref: "bgInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleBgChange
    }
  })]), _vm._v(" "), _vm._l((_vm.bgList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "kszb-bg-item",
      class: {
        'kszb-bg-item-active': _vm.selectedBgUrl === item.imgUrl
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectBg(item)
        }
      }
    }, [_c('img', {
      staticClass: "kszb-bg-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])
  })], 2)]), _vm._v(" "), (_vm.uploadProgress > 0 && _vm.uploadProgress < 100) ? _c('div', {
    staticClass: "kszb-bg-progress"
  }, [_c('div', {
    staticClass: "kszb-bg-progress-bar"
  }, [_c('div', {
    staticClass: "kszb-bg-progress-fill",
    style: ({
      width: _vm.uploadProgress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "kszb-bg-progress-text"
  }, [_vm._v(_vm._s(_vm.uploadProgress) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-modal-footer"
  }, [_c('div', {
    staticClass: "kszb-bg-modal-cancel",
    on: {
      "click": function($event) {
        _vm.showBgModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.quxiao')))]), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-modal-confirm",
    on: {
      "click": _vm.handleConfirmBg
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queren')))])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xgzl-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xgzl-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xgzl-box-model-top"
  }, [_c('div', {
    staticClass: "xgzl-box-model-top-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xiugaiziliao')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xgzl-box-model-img"
  }, [_c('img', {
    staticClass: "xgzl-box-model-img-img",
    attrs: {
      "src": _vm.form.headPortrait,
      "alt": ""
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xgzl-box-model-img-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nickName),
      expression: "form.nickName"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.form.nickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nickName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xgzl-box-model-btn"
  }, [_c('div', {
    staticClass: "xgzl-box-model-bottom",
    on: {
      "click": _vm.updUserInfo
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-div"
  }, [_vm._v(_vm._s(_vm.$t('all.duanyingyin')))]), _vm._v(" "), (_vm.videoTab === 0 && _vm.appConfigInfo && _vm.appConfigInfo.videoReleasePermission == 1) ? _c('div', {
    staticClass: "fabu",
    on: {
      "click": _vm.handleShowModal
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fabuduanyingyin')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dyy-tabs"
  }, _vm._l((_vm.videoTabList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dyy-tab-item",
      class: _vm.videoTab === index ? 'dyy-tab-active' : '',
      on: {
        "click": function($event) {
          return _vm.switchVideoTab(index)
        }
      }
    }, [_c('span', {
      class: _vm.videoTab === index ? 'dyy-tab-text-active' : 'dyy-tab-text'
    }, [_vm._v(_vm._s(_vm.$t('all.' + item.key)))])])
  }), 0), _vm._v(" "), (_vm.videoList.length > 0) ? _c('div', {
    staticClass: "duanyingyin-list"
  }, _vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "video-item",
      on: {
        "click": function($event) {
          return _vm.handlePlayVideo(item)
        }
      }
    }, [_c('img', {
      staticClass: "video-item-img",
      attrs: {
        "src": item.coverUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "video-item-content"
    }, [_c('span', {
      staticClass: "video-item-content-span"
    }, [_vm._v(_vm._s(item.title || ''))]), _vm._v(" "), _c('span', {
      staticClass: "video-item-content-span1"
    }, [_vm._v(_vm._s(item.duration ? _vm.formatDuration(item.duration) : '00:00'))])]), _vm._v(" "), (_vm.videoTab === 0) ? _c('img', {
      staticClass: "video-item-del",
      attrs: {
        "src": __webpack_require__(134),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDeleteVideo(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.videoTab === 0 && item.status != 1) ? _c('div', {
      staticClass: "video-item-status"
    }, [_vm._v(_vm._s(item.status === 0 ? _vm.$t('all.shenhezhong') : item.status === 2 ? _vm.$t('all.shenhejujue') : ''))]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.loaded && _vm.videoList.length === 0) ? _c('kong') : _vm._e(), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.isModalVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fabuduanyingyin')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "modal-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshurubiaoti')
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-upload-box",
    on: {
      "click": _vm.handleUploadClick
    }
  }, [(!_vm.form.videoUrl) ? _c('div', {
    staticClass: "modal-upload-content"
  }, [_c('span', {
    staticClass: "modal-upload-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shangchuanduanyingyin')))])]) : _c('div', {
    staticClass: "modal-video-preview"
  }, [_c('video', {
    staticClass: "modal-video",
    attrs: {
      "src": _vm.form.videoUrl,
      "controls": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "modal-video-name"
  }, [_vm._v(_vm._s(_vm.form.videoName))])])]), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "modal-progress-box"
  }, [_c('div', {
    staticClass: "modal-progress-bar"
  }, [_c('div', {
    staticClass: "modal-progress-fill",
    style: ({
      width: _vm.uploadProgress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "modal-progress-text"
  }, [_vm._v(_vm._s(_vm.uploadProgress.toFixed(1)) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-btn",
    class: {
      disabled: !_vm.form.title || !_vm.form.videoUrl || _vm.uploading
    },
    on: {
      "click": _vm.handlePublish
    }
  }, [_vm._v("发布")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "video/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hf-box"
  }, [_c('div', {
    staticClass: "hf-content"
  }, [_c('div', {
    staticClass: "hf-video-wrap"
  }, [_c('video', {
    ref: "videoPlayer",
    staticClass: "hf-video",
    attrs: {
      "src": _vm.videoUrl
    },
    on: {
      "timeupdate": _vm.onTimeUpdate,
      "loadedmetadata": _vm.onLoadedMetadata,
      "ended": _vm.onEnded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hf-controls"
  }, [_c('div', {
    staticClass: "hf-controls-btn",
    on: {
      "click": _vm.togglePlay
    }
  }, [(_vm.isPlaying) ? _c('span', [_vm._v("❚❚")]) : _c('span', [_vm._v("▶")])]), _vm._v(" "), _c('span', {
    staticClass: "hf-controls-time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.currentTime)))]), _vm._v(" "), _c('div', {
    ref: "progressBar",
    staticClass: "hf-controls-progress",
    on: {
      "click": _vm.seekVideo,
      "mousedown": _vm.onProgressMouseDown
    }
  }, [_c('div', {
    staticClass: "hf-controls-progress-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "hf-controls-progress-fill",
    style: ({
      width: _vm.progress + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "hf-controls-progress-dot",
    style: ({
      left: _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "hf-controls-time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.duration)))]), _vm._v(" "), _c('div', {
    staticClass: "hf-controls-speed",
    on: {
      "click": _vm.toggleSpeed
    }
  }, [_vm._v(_vm._s(_vm.$t('all.beisu')) + " x" + _vm._s(_vm.playbackRate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hf-sidebar"
  }, [_c('div', {
    staticClass: "hf-sidebar-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('div', {
    staticClass: "hf-sidebar-list"
  }, _vm._l((_vm.replayList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.currentIndex === index ? 'hf-sidebar-item-active' : 'hf-sidebar-item',
      on: {
        "click": function($event) {
          return _vm.handleSwitchReplay(index)
        }
      }
    }, [_c('div', {
      staticClass: "hf-sidebar-item-cover",
      style: ({
        backgroundImage: 'url(' + item.backgroundUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "hf-sidebar-item-info"
    }, [_c('span', {
      staticClass: "hf-sidebar-item-info-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "hf-sidebar-item-info-tag"
    }, [_vm._v(_vm._s(item.categoryName))]), _vm._v(" "), _c('span', {
      staticClass: "hf-sidebar-item-info-time"
    }, [_vm._v(_vm._s(item.liveStartTime) + " - " + _vm._s(item.liveEndTime))])]), _vm._v(" "), (item.isHot) ? _c('img', {
      staticClass: "hf-sidebar-item-hot",
      attrs: {
        "src": __webpack_require__(134),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.$route.query.viewUserId || _vm.$route.query.viewUserId == _vm.$store.state.userId) ? _c('img', {
      staticClass: "hf-sidebar-item-del",
      attrs: {
        "src": __webpack_require__(134),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelete(item, index)
        }
      }
    }) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('img', {
    staticClass: "header-left-img",
    attrs: {
      "src": __webpack_require__(327),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "header-left-img1",
    attrs: {
      "src": __webpack_require__(314),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.isSubPage) ? _c('div', {
    staticClass: "header-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "header-back-img",
    attrs: {
      "src": __webpack_require__(889),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.$route.path === '/zhibozhongxin') ? _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibozhongxin')) + "·"), _c('span', {
    staticClass: "header-back-status"
  }, [_vm._v(_vm._s(_vm.$t('all.yikaifang')))])]) : (_vm.$route.path === '/huifang') ? _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.guankanhuifang')))]) : (_vm.$route.path === '/zhiboshangpin') ? _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')) + " · "), _c('span', {
    staticClass: "header-back-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('all.laiziyunimall')))])]) : (_vm.$route.path === '/zhibozhong') ? [(_vm.$route.query.name) ? [_c('img', {
    staticClass: "header-back-avatar",
    attrs: {
      "src": _vm.$route.query.backgroundUrl || '',
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowLiveRecord.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-back-user",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowLiveRecord.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "header-back-name"
  }, [_vm._v(_vm._s(_vm.$route.query.name || ''))]), _vm._v(" "), _c('span', {
    staticClass: "header-back-subtitle"
  }, [_vm._v(_vm._s(_vm.$route.query.categoryName || ''))])])] : (_vm.liveRoomInfo) ? [_c('img', {
    staticClass: "header-back-avatar",
    attrs: {
      "src": _vm.liveRoomInfo.hostUserInfo && _vm.liveRoomInfo.hostUserInfo.headPortrait || '',
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowLiveRecord.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-back-user",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowLiveRecord.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "header-back-name"
  }, [_vm._v(_vm._s(_vm.liveRoomInfo.hostUserInfo && _vm.liveRoomInfo.hostUserInfo.nickName || ''))]), _vm._v(" "), _c('span', {
    staticClass: "header-back-subtitle"
  }, [_vm._v(_vm._s(_vm.liveRoomInfo.categoryName || ''))])])] : _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.guankanzhibo')))])] : _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.subPageTitle))])], 2) : _vm._e()]), _vm._v(" "), (_vm.$store.state.count == 2 && !_vm.isSubPage) ? _c('div', {
    staticClass: "sousuo"
  }, [_c('div', {
    staticClass: "sousuo-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.sousuoniganxingqudeneirong'),
      "placeholder-style": "color:rgba(255,255,255,0.6)",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sousuo-right",
    on: {
      "click": _vm.handleSearchInput
    }
  }, [_c('div', {
    staticClass: "sousuo-right-xian"
  }), _vm._v(" "), _c('img', {
    staticClass: "sousuo-right-img",
    attrs: {
      "src": __webpack_require__(305),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sousuo-right-span"
  }, [_vm._v(_vm._s(_vm.$t('all.sousuo')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(4)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(868),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.appxiazai')))])]), _vm._v(" "), _c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(310),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xitongxiaoxi')))]), _vm._v(" "), (_vm.$store.state.sysMsgCount > 0) ? _c('div', {
    staticClass: "header-right-item-num"
  }, [_vm._v(_vm._s(_vm.$store.state.sysMsgCount))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(904),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.wodedingdan')))])]), _vm._v(" "), _c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(869),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.bangzhufankui')))])]), _vm._v(" "), (_vm.$store.state.userInfo) ? _c('img', {
    staticClass: "header-right-img",
    attrs: {
      "src": _vm.$store.state.userInfo.headPortrait,
      "alt": ""
    },
    on: {
      "error": _vm.handleImgError,
      "click": _vm.handleTiaozhuan
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.userInfo) ? _c('img', {
    staticClass: "header-right-img",
    attrs: {
      "src": _vm.defaulImg,
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('aside', {
    staticClass: "menu-expanded"
  }, [_c('div', {
    staticClass: "aside-box"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('div', {
      class: _vm.$store.state.count === index ? 'active-aside-box-item' : 'aside-box-item',
      on: {
        "click": function($event) {
          return _vm.handlerouter(index, item)
        }
      }
    }, [(_vm.$store.state.count != index) ? _c('img', {
      staticClass: "icon",
      attrs: {
        "src": item.iconCls,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$store.state.count == index) ? _c('img', {
      staticClass: "icon",
      attrs: {
        "src": item.selectedIconCls,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      class: _vm.$store.state.count === index ? 'aside-box-item-span' : 'aside-box-item-span1'
    }, [_vm._v(_vm._s(_vm.getMenuName(item.children[0].meta)))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "aside-bottom"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(903),
      "alt": ""
    },
    on: {
      "click": _vm.handleShowSz
    }
  }), _vm._v(" "), (_vm.isLogin == 0) ? _c('img', {
    attrs: {
      "src": __webpack_require__(874),
      "alt": ""
    },
    on: {
      "click": _vm.handleShowTc
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLogin == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(897),
      "alt": ""
    },
    on: {
      "click": _vm.handleShowTc
    }
  }) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "shouye"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path !== '/zhibozhong') ? _c('div', {
    staticClass: "custom-bg-bottom"
  }, [_c('div', {
    staticClass: "custom-bg-bottom-xy"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.handleShowModel(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yonghuxieyi')))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.handleShowModel(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yinsixieyi')))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.handleShowXiazai
    }
  }, [_vm._v(_vm._s(_vm.$t('all.appxiazai')))])]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom-des"
  }, [_vm._v("COPYRIGHT © 2026 WWW.UNISHOW.LIVE")])]) : _vm._e()])]), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.isModalVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay-content"
  }, [(_vm.type == 1) ? _c('xitongxiaoxi') : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('wodedingdan') : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('wentibangzhu', {
    on: {
      "uploadFk": _vm.handleUploadFk
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 4) ? _c('appxiazai') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isFkModalVisible) ? _c('div', {
    staticClass: "modal-overlay-fk",
    on: {
      "click": function($event) {
        _vm.isFkModalVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFkModalVisible) ? _c('div', {
    staticClass: "modal-overlay-content-fk"
  }, [_c('woyaofankui', {
    on: {
      "closeFk": function($event) {
        _vm.isFkModalVisible = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('shezhi', {
    ref: "sz"
  }), _vm._v(" "), _c('tuichudenglu', {
    ref: "tc"
  }), _vm._v(" "), _c('xieyi', {
    ref: "xieyi"
  }), _vm._v(" "), _c('xiazai', {
    ref: "xiazai"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xitongxiaoxi"
  }, [_c('div', {
    staticClass: "xt-title"
  }, [_vm._v(_vm._s(_vm.$t('all.wodedingdan')))]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "xt-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "dd-list-item"
    }, [_c('div', {
      staticClass: "dd-list-item-top"
    }, [_c('div', {
      staticClass: "dd-list-item-top-left"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(913),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.liveInfo.name))])]), _vm._v(" "), _c('span', {
      staticClass: "dd-list-item-top-span"
    }, [_vm._v(_vm._s(item.orderStatusName))])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods"
    }, [_c('img', {
      attrs: {
        "src": item.goodsInfo.mediasList[0].uri,
        "alt": ""
      },
      on: {
        "error": _vm.handleImgError
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods-content"
    }, [_c('div', {
      staticClass: "dd-list-item-goods-content-name"
    }, [_vm._v(_vm._s(item.goodsInfo.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods-content-price"
    }, [_c('div', {
      staticClass: "dd-list-item-goods-content-price-left"
    }, [_c('span', {
      staticClass: "dd-list-item-goods-content-price-left-span1"
    }, [_vm._v("USDN" + _vm._s(item.goodsInfo.specificationList[0].price))])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods-content-price-right"
    }, [_vm._v("x" + _vm._s(item.number))])])])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-bottom"
    }, [_vm._v(_vm._s(_vm.$t('all.dingdanjine')) + "：USDN" + _vm._s(item.orderPrice))]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-no"
    }, [_c('span', {
      staticClass: "dd-list-item-no-span"
    }, [_vm._v(_vm._s(_vm.$t('all.dingdanbianhao')))]), _vm._v(" "), _c('span', {
      staticClass: "dd-list-item-no-span1"
    }, [_vm._v(_vm._s(item.orderOn))])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-no"
    }, [_c('span', {
      staticClass: "dd-list-item-no-span"
    }, [_vm._v(_vm._s(_vm.$t('all.chuangjianshijian')))]), _vm._v(" "), _c('span', {
      staticClass: "dd-list-item-no-span1"
    }, [_vm._v(_vm._s(item.createTime))])])])
  }), _vm._v(" "), (!_vm.hasMore && _vm.list.length === 0) ? _c('kong') : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gwc-box"
  }, [(!_vm.isDetail) ? _c('div', {
    staticClass: "gwc-box-container"
  }, [_c('div', {
    staticClass: "gwc-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.quanbushangpin')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(135),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      class: index == _vm.listIndex ? 'gwc-box-list-item' : 'gwc-box-list-item1'
    }, [_c('div', {
      staticClass: "gwc-box-list-item-img"
    }, [_c('img', {
      staticClass: "gwc-box-list-item-img-img",
      attrs: {
        "src": item.masterImg[0],
        "alt": ""
      },
      on: {
        "error": _vm.handleImgError
      }
    }), _vm._v(" "), (item.inventory == 0) ? _c('div', {
      staticClass: "yiqiangguang"
    }, [_vm._v("- " + _vm._s(_vm.$t('all.yiqiangguang')) + " -")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content"
    }, [_c('div', {
      staticClass: "gwc-box-list-item-content-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content-kucun"
    }, [_vm._v("剩余库存：" + _vm._s(item.inventory))]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content-price"
    }, [_c('div', {
      staticClass: "gwc-box-list-item-content-price-left"
    }, [_c('span', {
      staticClass: "gwc-box-list-item-content-price-left-span"
    }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
      staticClass: "gwc-box-list-item-content-price-left-span1"
    }, [_vm._v(_vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content-price-btn",
      on: {
        "click": function($event) {
          return _vm.handleDetail(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.jiagou')))])])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isDetail) ? _c('div', {
    staticClass: "gwc-box-container"
  }, [_c('div', {
    staticClass: "gwc-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(135),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq"
  }, [_c('div', {
    staticClass: "gwc-box-xq-lbt"
  }, [_c('carousel', {
    attrs: {
      "images": _vm.data.masterImg,
      "interval": 3000
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-name"
  }, [_vm._v(_vm._s(_vm.data.goodsName))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-price"
  }, [_c('div', {
    staticClass: "gwc-box-xq-price-left"
  }, [_c('span', {
    staticClass: "gwc-box-xq-price-span"
  }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
    staticClass: "gwc-box-xq-price-span-span1"
  }, [_vm._v(_vm._s(_vm.data.price))])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-price-right"
  }, [_vm._v("剩余库存：" + _vm._s(_vm.data.inventory))])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-title"
  }, [_c('span', {
    staticClass: "gwc-box-xq-title-span"
  }), _vm._v(" "), _c('span', {
    staticClass: "gwc-box-xq-title-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('span', {
    staticClass: "gwc-box-xq-title-span"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-img"
  }, _vm._l((_vm.data.masterImg), function(item, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-btn"
  }, [_c('div', {
    staticClass: "gwc-box-xq-btn-btn",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "gwc-mask",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "gwc-mask-model"
  }, [_c('div', {
    staticClass: "gwc-mask-model-top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(135),
      "alt": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods"
  }, [_c('img', {
    staticClass: "gwc-mask-model-goods-img",
    attrs: {
      "src": _vm.data.masterImg[0],
      "alt": ""
    },
    on: {
      "error": _vm.handleImgError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content"
  }, [_c('div', {
    staticClass: "gwc-mask-model-goods-content-price"
  }, [_c('span', {
    staticClass: "gwc-mask-model-goods-content-price-span"
  }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
    staticClass: "gwc-mask-model-goods-content-price-span1"
  }, [_vm._v(_vm._s(_vm.data.specificationList[_vm.ggIndex].price * _vm.num))])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content-kucun"
  }, [_vm._v("剩余库存：" + _vm._s(_vm.data.inventory))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content-num"
  }, [_c('div', {
    staticClass: "gwc-mask-model-goods-content-num-left"
  }, [_vm._v(_vm._s(_vm.$t('all.yixuan')) + "：" + _vm._s(_vm.data.specificationList[_vm.ggIndex].name))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content-num-right"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(891),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleNum(-1)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.num))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(890),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleNum(1)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-gg"
  }, [_c('div', {
    staticClass: "gwc-mask-model-gg-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzeguige')))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-gg-list"
  }, _vm._l((_vm.data.specificationList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.ggIndex === index ? 'gwc-mask-model-gg-list-item' : 'gwc-mask-model-gg-list-item1',
      on: {
        "click": function($event) {
          return _vm.handleGg(index)
        }
      }
    }, [_c('div', {
      staticClass: "gwc-mask-model-gg-list-item-left"
    }, [_c('img', {
      attrs: {
        "src": _vm.data.masterImg[0],
        "alt": ""
      },
      on: {
        "error": _vm.handleImgError
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.ggIndex === index ? 'gwc-mask-model-gg-list-item-left-span' : 'gwc-mask-model-gg-list-item-left-span1'
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      class: _vm.ggIndex === index ? 'gwc-mask-model-gg-list-item-left-span2' : 'gwc-mask-model-gg-list-item-left-span3'
    }, [_vm._v("库存：" + _vm._s(item.inventory))])]), _vm._v(" "), _c('div', {
      staticClass: "gwc-mask-model-gg-list-item-right"
    }, [_c('span', {
      class: index === _vm.ggIndex ? 'gwc-mask-model-gg-list-item-right-span' : 'gwc-mask-model-gg-list-item-right-span_1'
    }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
      class: index === _vm.ggIndex ? 'gwc-mask-model-gg-list-item-right-span1' : 'gwc-mask-model-gg-list-item-right-span1_1'
    }, [_vm._v(_vm._s(item.price))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-btn"
  }, [_c('div', {
    staticClass: "gwc-box-xq-btn-btn",
    on: {
      "click": _vm.submitOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shouye"
  }, [_c('div', {
    staticClass: "navList"
  }, _vm._l((_vm.topNavList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "navList-item",
      on: {
        "click": function($event) {
          return _vm.handleTopNav(index)
        }
      }
    }, [_c('span', {
      class: _vm.topNavIndex === index ? 'navList-item-span' : 'navList-item-span1'
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('span', {
      class: _vm.topNavIndex === index ? 'navList-item-xian' : 'navList-item-xian1'
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "subNavList"
  }, [(_vm.topNavIndex === 0) ? _vm._l((_vm.navList), function(item, index) {
    return _c('div', {
      key: 'live' + index,
      staticClass: "subNavList-item",
      class: _vm.navListIndex === index ? 'subNavList-item-active' : '',
      on: {
        "click": function($event) {
          return _vm.handleNav(index)
        }
      }
    }, [_c('span', {
      class: _vm.navListIndex === index ? 'subNavList-item-span' : 'subNavList-item-span1'
    }, [_vm._v(_vm._s(item.categoryName))])])
  }) : _vm._l((_vm.videoCateList), function(item, index) {
    return _c('div', {
      key: 'video' + index,
      staticClass: "subNavList-item",
      class: _vm.videoCateIndex === index ? 'subNavList-item-active' : '',
      on: {
        "click": function($event) {
          return _vm.handleVideoCate(index)
        }
      }
    }, [_c('span', {
      class: _vm.videoCateIndex === index ? 'subNavList-item-span' : 'subNavList-item-span1'
    }, [_vm._v(_vm._s(item.categoryName))])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topNavIndex === 0),
      expression: "topNavIndex===0"
    }],
    ref: "listContainer",
    staticClass: "list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('zbList', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }), 1), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 1), _vm._v(" "), (_vm.topNavIndex === 1) ? _c('div', {
    ref: "videoGridContainer",
    staticClass: "video-grid-wrap",
    on: {
      "scroll": _vm.handleVideoScroll
    }
  }, [(_vm.videoList.length > 0) ? _c('div', {
    staticClass: "video-grid"
  }, _vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: item.videoId || item.id || index,
      staticClass: "video-item",
      on: {
        "click": function($event) {
          return _vm.handlePlayVideo(item)
        }
      }
    }, [_c('img', {
      staticClass: "video-item-img",
      attrs: {
        "src": item.coverUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "video-item-content"
    }, [_c('div', {
      staticClass: "video-item-content-text"
    }, [_c('span', {
      staticClass: "video-item-content-title"
    }, [_vm._v(_vm._s(item.title || ''))]), _vm._v(" "), _c('span', {
      staticClass: "video-item-content-desc"
    }, [_vm._v(_vm._s(item.nickName || ''))])]), _vm._v(" "), _c('span', {
      staticClass: "video-item-content-duration"
    }, [_vm._v(_vm._s(item.duration ? _vm.formatDuration(item.duration) : '00:00'))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.videoLoaded && !_vm.videoLoading && _vm.videoList.length === 0) ? _c('kong') : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "wqb-box"
  }, [_c('div', {
    staticClass: "wqb-asset-card"
  }, [_c('div', {
    staticClass: "wqb-asset-header"
  }, [_c('span', {
    staticClass: "wqb-asset-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zongzichanguzhi')))])]), _vm._v(" "), _c('div', {
    staticClass: "wqb-asset-amount"
  }, [_vm._v(_vm._s(_vm.data.valuationAmount) + " " + _vm._s(_vm.data.toName))])]), _vm._v(" "), _c('div', {
    staticClass: "wqb-currency-list"
  }, _vm._l((_vm.data.walletList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "wqb-currency-item",
      on: {
        "click": function($event) {
          return _vm.handleGoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "wqb-currency-icon"
    }, [_c('img', {
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wqb-currency-info"
    }, [_c('span', {
      staticClass: "wqb-currency-name"
    }, [_vm._v(_vm._s(item.currencyName))]), _vm._v(" "), _c('span', {
      staticClass: "wqb-currency-detail"
    }, [_vm._v(_vm._s(_vm.$t('all.keyong')) + " " + _vm._s(item.sumAvailableAmount) + " " + _vm._s(_vm.$t('all.dongjie')) + " " + _vm._s(item.sumFreezeAmount))])]), _vm._v(" "), _vm._m(0, true)])
  }), 0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wqb-currency-arrow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-room"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": __webpack_require__(915),
      "alt": ""
    },
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), (_vm.data && _vm.data.chatRoomDetails) ? _c('div', {
    staticClass: "user-content",
    on: {
      "click": _vm.handleShowZbjl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.data.chatRoomDetails.backgroundUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-content-div"
  }, [_c('span', {
    staticClass: "user-content-div-span"
  }, [_vm._v(_vm._s(_vm.data.chatRoomDetails.name))]), _vm._v(" "), _c('span', {
    staticClass: "user-content-div-span1"
  }, [_vm._v("ID：" + _vm._s(_vm.data.chatRoomDetails.thirdId))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-left"
  }, [(_vm.data && _vm.data.chatRoomDetails) ? _c('img', {
    staticClass: "bj",
    attrs: {
      "src": _vm.data.chatRoomDetails.backgroundUrl,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-left-top"
  }, [(_vm.isZb == 2) ? _c('tengxunyun', {
    ref: "txy"
  }) : _vm._e(), _vm._v(" "), (_vm.isZb == 1) ? _c('div', {
    staticClass: "tengxunyunzb"
  }, [_c('tengxunyunzb', {
    ref: "txyzb"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isZb == 2) ? _c('div', {
    staticClass: "txy-list-btn"
  }, [_c('div', {
    staticClass: "txy-list-btn-item",
    on: {
      "click": _vm.handleUpdateMuted
    }
  }, [(_vm.muted) ? _c('img', {
    attrs: {
      "src": __webpack_require__(921),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.muted) ? _c('img', {
    attrs: {
      "src": __webpack_require__(920),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.shengyin')))])]), _vm._v(" "), _c('div', {
    staticClass: "txy-list-btn-item",
    on: {
      "click": _vm.handleUpdateSvga
    }
  }, [(_vm.svga) ? _c('img', {
    attrs: {
      "src": __webpack_require__(919),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.svga) ? _c('img', {
    attrs: {
      "src": __webpack_require__(918),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.liwutexiao')))])])]) : _vm._e(), _vm._v(" "), (_vm.show_gdlw) ? _c('quanbuliwu', {
    on: {
      "close": function($event) {
        _vm.show_gdlw = false
      },
      "updateUser": _vm.handleUpdateUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_gwc) ? _c('gouwuche', {
    on: {
      "close": function($event) {
        _vm.show_gwc = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_kjdy) ? _c('kuaijieduanyu', {
    on: {
      "close_kjdy": function($event) {
        _vm.show_kjdy = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_gly) ? _c('guanliyuan', {
    ref: "gly",
    on: {
      "close_gly": function($event) {
        _vm.show_gly = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_zbjl) ? _c('zhibojilu', {
    on: {
      "close_zbjl": function($event) {
        _vm.show_zbjl = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_gg) ? _c('gongao', {
    on: {
      "close_gg": function($event) {
        _vm.show_gg = false
      },
      "update_gg": _vm.updateGg
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-left-bottom"
  }, [(_vm.isZb == 2 && _vm.isShowGift) ? _c('liwu', {
    ref: "liwu",
    on: {
      "show_gdlw": _vm.hanldeShowGdlw
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isZb == 1 || !_vm.isShowGift) ? _c('zhuboshezhi', {
    ref: "zhuboshezhi",
    on: {
      "setVol": _vm.handleSetVol,
      "show_kjdy": _vm.handleShowKjdy,
      "show_gly": _vm.handleShowGly,
      "show_gg": _vm.handleShowGg,
      "show_svga": _vm.hanldeShowSvga
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isZb == 2 && _vm.isShowGift) ? _c('div', {
    staticClass: "gouwuche",
    on: {
      "click": _vm.handleShowGwc
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(916),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.gouwuche')))])]) : _vm._e()], 1), _vm._v(" "), _c('liwudonghua', {
    ref: "lwdh"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-right"
  }, [_c('zaixianguanzhong', {
    ref: "zaixian",
    on: {
      "show_user": _vm.handleShowUser
    }
  }), _vm._v(" "), _c('danmu', {
    ref: "danmu",
    on: {
      "addSvgaToQueue": _vm.hanldeAddSvgaToQueue,
      "changeUser": _vm.updateChangeUser,
      "show_user": _vm.handleShowUser,
      "addLwToQueue": _vm.handleAddLwToQueue,
      "pulling": _vm.updatePulling,
      "updataNotice": _vm.handleShowGg
    }
  }), _vm._v(" "), _c('user', {
    ref: "user",
    on: {
      "addAdmin": _vm.handleAddAdmin
    }
  })], 1), _vm._v(" "), _c('guanbizhibo', {
    ref: "gbzb"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qblw-box"
  }, [_c('div', {
    staticClass: "qblw-box-container"
  }, [_c('div', {
    staticClass: "qblw-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.quanbuliwu')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(18),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qblw-box-fl"
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('div', {
      key: index,
      class: index === _vm.listIndex ? 'qblw-box-fl-item' : 'qblw-box-fl-item1',
      on: {
        "click": function($event) {
          return _vm.handleChooseCategory(index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.categoryName) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "qblw-box-list",
    on: {
      "mouseleave": _vm.handleListMouseLeave
    }
  }, _vm._l((_vm.currentGiftList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.currentGiftIndex === index ? 'qblw-box-list-item' : 'qblw-box-list-item1',
      on: {
        "mouseenter": function($event) {
          return _vm.handleGiftMouseEnter(index, $event)
        }
      }
    }, [_c('img', {
      staticClass: "qblw-box-list-item-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), (_vm.currentGiftIndex !== index) ? _c('div', {
      staticClass: "qblw-box-list-item-span"
    }, [_vm._v(_vm._s(item.giftName))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "qblw-box-list-item-span1"
    }, [_vm._v(_vm._s(item.price) + "US" + _vm._s(_vm.$t('all.bi')))]), _vm._v(" "), (_vm.currentGiftIndex === index) ? _c('div', {
      staticClass: "qblw-box-list-item-zs",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.giveGift()
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('all.zengsong')) + "\n        ")]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.showPopup) ? _c('popup', {
    attrs: {
      "show": _vm.showPopup,
      "x": _vm.popupPosition.x,
      "y": _vm.popupPosition.y
    },
    on: {
      "mouseenter": _vm.handlePopupMouseEnter,
      "mouseleave": _vm.handlePopupMouseLeave,
      "giveGif": _vm.handleGiveGif
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbList",
    on: {
      "click": function($event) {
        return _vm.handleDetial(_vm.data)
      }
    }
  }, [_c('img', {
    staticClass: "zbList-img",
    attrs: {
      "src": _vm.data.backgroundUrl,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.type == 1) ? _c('img', {
    staticClass: "zbList-del",
    attrs: {
      "src": __webpack_require__(134),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelete(_vm.data)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbList-box"
  }, [_c('div', {
    staticClass: "zbList-box-fl-box"
  }, [_c('div', {
    staticClass: "zbList-box-fl"
  }, [_vm._v(_vm._s(_vm.data.categoryName))])]), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "zbList-box-zbjl"
  }, [_c('div', {
    staticClass: "zbList-box-zbjl-top"
  }, [_c('span', {
    staticClass: "zbList-box-zbjl-left-span"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.isOpenReplay == 1 && _vm.data.replayUrl) ? _c('div', {
    staticClass: "zbList-box-zbjl-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePlayVideo(_vm.data.replayUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(202),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.huifang')))])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "zbList-box-zbjl-left-span1"
  }, [_vm._v(_vm._s(_vm.data.liveStartTime) + "-" + _vm._s(_vm.data.liveEndTime))])]) : _c('div', {
    staticClass: "zbList-box-title"
  }, [_c('div', {
    staticClass: "zbList-box-title-left"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "zbList-box-title-right"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(914),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.onlineUserCount))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wd-box"
  }, [_c('div', {
    ref: "listContainer",
    staticClass: "wd-box-container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "wd-user"
  }, [_c('div', {
    staticClass: "wd-user-left"
  }, [_c('img', {
    staticClass: "wd-user-img",
    attrs: {
      "src": _vm.$store.state.userInfo.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wd-user-content"
  }, [_c('span', {
    staticClass: "wd-user-content-span"
  }, [_vm._v(_vm._s(_vm.$store.state.userInfo.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "wd-user-content-span1"
  }, [_vm._v("ID " + _vm._s(_vm.data.recodeCode))]), _vm._v(" "), _c('div', {
    staticClass: "wd-user-count"
  }, [_c('span', {
    staticClass: "wd-user-count-item",
    on: {
      "click": function($event) {
        return _vm.handleShowGuanzhu(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.guanzhong')) + "： " + _vm._s(_vm.data.followCount || 0))]), _vm._v(" "), _c('span', {
    staticClass: "wd-user-count-item",
    on: {
      "click": function($event) {
        return _vm.handleShowGuanzhu(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fensi')) + "： " + _vm._s(_vm.data.vermicelliCount || 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "wd-user-edit",
    on: {
      "click": _vm.handleShowXgzl
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(905),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xiugaiziliao')))])])]), _vm._v(" "), _c('div', {
    staticClass: "zhibozhongxin",
    on: {
      "click": _vm.handleGoZhibozhongxin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhibozhongxin')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wd-zican"
  }, [_c('div', {
    staticClass: "wd-zican-title"
  }, [_c('span', {
    staticClass: "wd-zican-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.zongzichanguzhi')))])]), _vm._v(" "), _c('div', {
    staticClass: "wd-zican-box",
    on: {
      "click": _vm.handleGoWallet
    }
  }, [_c('div', {
    staticClass: "wd-zican-box-num"
  }, [_vm._v(_vm._s(_vm.userWalletInfo ? _vm.userWalletInfo.valuationAmount : 0) + " " + _vm._s(_vm.userWalletInfo.toName))]), _vm._v(" "), _c('div', {
    staticClass: "wd-zican-box-right"
  }, _vm._l((_vm.userWalletInfo.walletList), function(item, index) {
    return _c('div', {
      staticClass: "wd-zican-box-right-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleGoLiushui(item)
        }
      }
    }, [(item.currencyLogo) ? _c('img', {
      staticClass: "wd-zican-box-right-item-logo",
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "wd-zican-box-right-item-text"
    }, [_c('span', {
      staticClass: "wd-zican-box-right-item-span"
    }, [_vm._v(_vm._s(item.currencyName))]), _vm._v(" "), _c('span', {
      staticClass: "wd-zican-box-right-item-span1"
    }, [_vm._v(_vm._s(_vm.$t('all.keyong')) + " " + _vm._s(item.sumAvailableAmount) + " " + _vm._s(_vm.$t('all.dongjie')) + " " + _vm._s(item.sumFreezeAmount))])])])
  }), 0)])]), _vm._v(" "), (_vm.appConfigInfo && _vm.appConfigInfo.videoStatus == 1) ? _c('duanyingyin', {
    ref: "duanyingyin"
  }) : _vm._e()], 1), _vm._v(" "), _c('xiaofeimingxi', {
    ref: "xfmx"
  }), _vm._v(" "), _c('xiugaiziliao', {
    ref: "xgzl"
  }), _vm._v(" "), _c('guanzhu', {
    ref: "gz",
    on: {
      "change": _vm.getPresentUserInfo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "listContainer",
    staticClass: "yzh-box",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "yzh-user"
  }, [_c('img', {
    staticClass: "yzh-user-avatar",
    attrs: {
      "src": _vm.data.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yzh-user-info"
  }, [_c('span', {
    staticClass: "yzh-user-name"
  }, [_vm._v(_vm._s(_vm.data.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "yzh-user-id"
  }, [_vm._v("ID " + _vm._s(_vm.data.recodeCode))]), _vm._v(" "), _c('div', {
    staticClass: "yzh-user-fan"
  }, [_c('span', {
    staticClass: "yzh-user-fan-item"
  }, [_vm._v(_vm._s(_vm.$t('all.guanzhu')) + "： "), _c('span', {
    staticClass: "yzh-user-fan-num"
  }, [_vm._v(_vm._s(_vm.data.followCount || 0))])]), _vm._v(" "), _c('span', {
    staticClass: "yzh-user-fan-item"
  }, [_vm._v(_vm._s(_vm.$t('all.fensi')) + "： "), _c('span', {
    staticClass: "yzh-user-fan-num"
  }, [_vm._v(_vm._s(_vm.data.vermicelliCount || 0))])])])]), _vm._v(" "), (!_vm.isSelf) ? _c('div', {
    staticClass: "yzh-user-follow",
    class: {
      'yzh-user-follow--active': _vm.data.isFollowHe === 1
    },
    on: {
      "click": _vm.toggleFollow
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.data.isFollowHe === 1 ? _vm.$t('all.yiguanzhu') : _vm.$t('all.guanzhuta')) + "\n\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.appConfigInfo && _vm.appConfigInfo.videoStatus == 1) ? _c('div', {
    staticClass: "yzh-video"
  }, [_c('div', {
    staticClass: "yzh-video-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shipin')) + " " + _vm._s(_vm.videoList.length))]), _vm._v(" "), (_vm.videoList.length > 0) ? _c('div', {
    staticClass: "yzh-grid"
  }, _vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: item.videoId || index,
      staticClass: "yzh-card",
      on: {
        "click": function($event) {
          return _vm.handlePlayVideo(item)
        }
      }
    }, [(item.coverUrl) ? _c('img', {
      staticClass: "yzh-card-cover",
      attrs: {
        "src": item.coverUrl
      }
    }) : _c('div', {
      staticClass: "yzh-card-cover yzh-card-cover--empty"
    }), _vm._v(" "), _c('div', {
      staticClass: "yzh-card-mask"
    }, [_c('div', {
      staticClass: "yzh-card-likes"
    }, [_c('img', {
      staticClass: "yzh-card-likes-icon",
      attrs: {
        "src": _vm.dzIcon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "yzh-card-likes-num"
    }, [_vm._v(_vm._s(item.giveLikeNumber || 0))])]), _vm._v(" "), _c('div', {
      staticClass: "yzh-card-title"
    }, [_vm._v(_vm._s(item.title || ''))]), _vm._v(" "), _c('div', {
      staticClass: "yzh-card-meta"
    }, [_c('span', {
      staticClass: "yzh-card-duration"
    }, [_vm._v(_vm._s(item.duration ? _vm.formatDuration(item.duration) : '00:00'))])])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.videoLoading && _vm.loaded && _vm.videoList.length === 0) ? _c('kong') : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yjtz-box"
  }, [(_vm.data) ? _c('div', {
    staticClass: "yjtz-content"
  }, [_c('div', {
    staticClass: "yjtz-info-card"
  }, [_c('div', {
    staticClass: "yjtz-info-left"
  }, [_c('span', {
    staticClass: "yjtz-info-title"
  }, [_vm._v(_vm._s(_vm.data.emailInfo.title))]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-info-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.shoujianren')) + "：" + _vm._s(_vm.data.emailInfo.recipient))])]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-info-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.yifasong')))])]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-type-row"
  }, [_c('div', {
    class: _vm.data.liveType === 1 ? 'yjtz-type-active' : 'yjtz-type'
  }, [_vm._v(_vm._s(_vm.$t('all.shoujizhibo')))]), _vm._v(" "), _c('div', {
    class: _vm.data.liveType === 2 ? 'yjtz-type-active' : 'yjtz-type'
  }, [_vm._v("OBS" + _vm._s(_vm.$t('all.zhibo')))])]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-mail-card"
  }, [_c('span', {
    staticClass: "yjtz-mail-title"
  }, [_vm._v(_vm._s(_vm.data.emailInfo.statusTitle))]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-mail-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.data.emailInfo.content.replace(/\n/g, '<br>'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-item"
  }, [_c('span', {
    staticClass: "yjtz-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youjianbianhao')))]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-item-value yjtz-text-green"
  }, [_vm._v(_vm._s(_vm.data.emailInfo.emailNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-btn",
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongxinfasong')))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-bg"
  }, [_c('div', {
    staticClass: "custom-bg-top"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(327),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.type == 1) ? _c('img', {
    staticClass: "box-img",
    attrs: {
      "src": __webpack_require__(314),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('all.wangjimima')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiangzhuce')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-input"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(876),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruningdeyouxiangzhanghao'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.type != 1) ? _c('div', {
    staticClass: "box-yzm"
  }, [_c('div', {
    staticClass: "box-input1"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(875),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loginEmailCode),
      expression: "form.loginEmailCode"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyanzhengma'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.loginEmailCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loginEmailCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "huoqu",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.countdown ? _vm.timeText : _vm.$t('all.huoquyanzhengma')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-input"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(201),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "text",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "password",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(107),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPassword = !_vm.isPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(108),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPassword = !_vm.isPassword
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "remember-row"
  }, [_c('div', {
    staticClass: "remember-box"
  }, [_c('div', {
    staticClass: "remember-item",
    on: {
      "click": _vm.toggleRemember
    }
  }, [(_vm.isRemember) ? _c('img', {
    attrs: {
      "src": __webpack_require__(313),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(312),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.jizhuzhanghaomima')))])])]), _vm._v(" "), _c('div', {
    staticClass: "wjma",
    on: {
      "click": _vm.handleWangjimima
    }
  }, [_vm._v(_vm._s(_vm.$t('all.wangjimima')) + "？")])]) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('div', {
    staticClass: "wjma",
    on: {
      "click": _vm.handleMimadenglu
    }
  }, [_vm._v(_vm._s(_vm.$t('all.mimadenglu')))]) : _vm._e(), _vm._v(" "), (_vm.type != 1) ? _c('div', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('all.mimashuoming')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(301),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyonghuming'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.yonghumingtishi')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(300),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "text",
      "placeholder": _vm.$t('all.shezhijiaoyimima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('all.shezhijiaoyimima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(107),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(108),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.jiaoyimimatishi')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input3"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": _vm.form.countryImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "xian"
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('all.qingxuanze')
    },
    model: {
      value: (_vm.form.countryId),
      callback: function($$v) {
        _vm.$set(_vm.form, "countryId", $$v)
      },
      expression: "form.countryId"
    }
  }, _vm._l((_vm.allCountryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invitationCode),
      expression: "form.invitationCode"
    }],
    staticClass: "box-input-input1",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyaoqingma'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.invitationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invitationCode", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type != 2) ? _c('div', {
    staticClass: "xieyi",
    on: {
      "click": function($event) {
        _vm.isFlag = !_vm.isFlag
      }
    }
  }, [(!_vm.isFlag) ? _c('img', {
    attrs: {
      "src": __webpack_require__(312),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFlag) ? _c('img', {
    attrs: {
      "src": __webpack_require__(313),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span"
  }, [_vm._v(_vm._s(_vm.$t('all.woyiyuedubingtongyi')))]), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowModel(1)
      }
    }
  }, [_vm._v("《" + _vm._s(_vm.$t('all.yonghuxieyi')) + "》、")]), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowModel(2)
      }
    }
  }, [_vm._v("《" + _vm._s(_vm.$t('all.yinsixieyi')) + "》")])]) : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.denglu')))]) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toForgetPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongxindenglu')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhuce')))]) : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "zhuce",
    on: {
      "click": function($event) {
        return _vm.handleZhuce(3)
      }
    }
  }, [_c('span', {
    staticClass: "zhuce-span"
  }, [_vm._v(_vm._s(_vm.$t('all.haimeizhanghao')) + "？")]), _vm._v(" "), _c('span', {
    staticClass: "zhuce-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.quzhuce')))])]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "zhuce",
    on: {
      "click": function($event) {
        return _vm.handleZhuce(1)
      }
    }
  }, [_c('span', {
    staticClass: "zhuce-span"
  }, [_vm._v(_vm._s(_vm.$t('all.yiyouzhanghao')) + "，")]), _vm._v(" "), _c('span', {
    staticClass: "zhuce-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.qudenglu')))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom"
  }, [_c('div', {
    staticClass: "custom-bg-bottom-xy"
  }, [_c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    on: {
      "click": function($event) {
        return _vm.handleShowModel(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yonghuxieyi')))]), _vm._v(" "), _c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    on: {
      "click": function($event) {
        return _vm.handleShowModel(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yinsixieyi')))]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom-xy-div"
  }, [_c('el-popover', {
    attrs: {
      "placement": "top",
      "trigger": "click"
    },
    model: {
      value: (_vm.isYyPopoverVisible),
      callback: function($$v) {
        _vm.isYyPopoverVisible = $$v
      },
      expression: "isYyPopoverVisible"
    }
  }, [_c('div', {
    staticClass: "custom-bg-bottom-xy-div-model"
  }, _vm._l((_vm.yyList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.yyListIndex === index ? 'custom-bg-bottom-xy-div-model-item' : 'custom-bg-bottom-xy-div-model-item1',
      on: {
        "click": function($event) {
          return _vm.handleChooseYy(index, item.language)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.$t('all.yuyanxuanze')))])])], 1), _vm._v(" "), _c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    on: {
      "click": _vm.handleShowXiazai
    }
  }, [_vm._v(_vm._s(_vm.$t('all.appxiazai')))])]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom-des"
  }, [_vm._v("COPYRIGHT © 2026 WWW.UNISHOW.LIVE")])]), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.isModalVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-content-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shezhijibenxinxi')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-des"
  }, [_vm._v(_vm._s(_vm.$t('all.nichengtishi')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list"
  }, [_c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shezhiyonghuming')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(301),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyonghuming'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.yonghumingtishi')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shezhijiaoyimima')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(300),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "password",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(107),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(108),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.jiaoyimimatishi')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list"
  }, [_c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzeningdeguojia')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input3"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": _vm.form.countryImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "xian"
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('all.qingxuanze')
    },
    model: {
      value: (_vm.form.countryId),
      callback: function($$v) {
        _vm.$set(_vm.form, "countryId", $$v)
      },
      expression: "form.countryId"
    }
  }, _vm._l((_vm.allCountryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqingma')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invitationCode),
      expression: "form.invitationCode"
    }],
    staticClass: "box-input-input1",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyaoqingma'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.invitationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invitationCode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhuce')))])]) : _vm._e(), _vm._v(" "), _c('xieyi', {
    ref: "xieyi"
  }), _vm._v(" "), _c('xiazai', {
    ref: "xiazai"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzb-box"
  }, [(_vm.localData.isOpenHelp == 1) ? _c('div', {
    staticClass: "xtzb-list"
  }, [(_vm.mainScreenUser && _vm.isHost) ? _c('div', {
    staticClass: "xtzb-zhubo"
  }, [_c('xietongzhubo', {
    attrs: {
      "main-screen-data": _vm.mainScreenUser,
      "liveId": _vm.liveId
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isHost && _vm.isJoinedHelpLive && _vm.isSelfMainScreen && _vm.hostUser) ? _c('div', {
    staticClass: "xtzb-zhubo"
  }, [_c('zhuboplayer', {
    attrs: {
      "pull-url": _vm.hostUser.pullUrl,
      "user-info": _vm.hostUser.info
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(((_vm.isHost ? _vm.localData.helpLiveUserList : _vm.helpLiveUserList)), function(item, index) {
    return (item.isMainScreen !== 1) ? _c('div', {
      key: index,
      staticClass: "xtzb-item",
      class: {
        'xtzb-item-active': _vm.activeIndex === index
      }
    }, [_c('div', {
      staticClass: "xtzb-item-bg",
      style: ({
        backgroundImage: 'url(' + (item.userInfo && item.userInfo.headPortrait) + ')'
      })
    }), _vm._v(" "), (item.cameraStatus !== 0) ? [(_vm.isSelfCohost(item)) ? _c('div', {
      staticClass: "xtzb-item-video xtzb-item-pusher",
      staticStyle: {
        "position": "absolute",
        "top": "0",
        "left": "0",
        "width": "100%",
        "height": "100%",
        "z-index": "2",
        "overflow": "hidden"
      },
      attrs: {
        "id": 'pusher-' + item.userId
      }
    }) : _c('div', {
      staticClass: "xtzb-item-player",
      attrs: {
        "id": 'player-' + item.userId
      }
    })] : _vm._e(), _vm._v(" "), (item.cameraStatus === 0) ? _c('div', {
      staticClass: "xtzb-item-cover"
    }, [_c('div', {
      staticClass: "xtzb-item-cover-box"
    }, [_c('img', {
      staticClass: "xtzb-item-cover-img",
      attrs: {
        "src": item.userInfo && item.userInfo.headPortrait,
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (item.isPermitMicrophone == 1) ? _c('img', {
      staticClass: "xtzb-item-vioce",
      attrs: {
        "src": __webpack_require__(315),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMicrophone(item, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.isPermitMicrophone == 0) ? _c('img', {
      staticClass: "xtzb-item-vioce",
      attrs: {
        "src": __webpack_require__(316),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMicrophone(item, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "xtzb-item-user"
    }, [_c('span', {
      staticClass: "xtzb-item-user-sort"
    }, [_vm._v(_vm._s((_vm.mainScreenUser && _vm.isHost) || (!_vm.isHost && _vm.isJoinedHelpLive && _vm.isSelfMainScreen && _vm.hostUser) ? index + 2 : index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-item-user-name"
    }, [_vm._v(_vm._s(item.userInfo.nickName))])])], 2) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localData.isOpenHelp == 1 && _vm.isHost) ? _c('div', {
    staticClass: "xtzb-btn",
    on: {
      "click": _vm.handleOpenList
    }
  }, [_c('span', {
    staticClass: "xtzb-btn-text"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhibo')) + " " + _vm._s(_vm.localData ? _vm.localData.helpLiveUserList.length : 0) + "/" + _vm._s(_vm.localData ? _vm.localData.peopleNumber : 0))])]) : _vm._e(), _vm._v(" "), (_vm.showPanel) ? _c('div', {
    staticClass: "xtzb-panel-overlay",
    on: {
      "click": function($event) {
        _vm.showPanel = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPanel) ? _c('div', {
    staticClass: "xtzb-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-panel-header"
  }, [_c('span', {
    staticClass: "xtzb-panel-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhibo')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-panel-count"
  }, [_vm._v(_vm._s(_vm.localData ? _vm.localData.helpLiveUserList.length : 0) + "/" + _vm._s(_vm.localData ? _vm.localData.peopleNumber : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-users"
  }, [(_vm.localData.helpLiveUserList && _vm.localData.helpLiveUserList.length > 0) ? _vm._l((_vm.localData.helpLiveUserList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xtzb-panel-user",
      class: {
        'xtzb-panel-user-active': _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.handleSelect(index)
        }
      }
    }, [_c('img', {
      staticClass: "xtzb-panel-user-img",
      attrs: {
        "src": item.userInfo.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "xtzb-panel-user-name"
    }, [_vm._v(_vm._s(item.userInfo.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-panel-user-status",
      class: item.isPermitCamera === 1 ? 'xtzb-status-live' : (item.isPermitMicrophone === 1 ? 'xtzb-status-live' : 'xtzb-status-wait')
    }, [_vm._v("\n              " + _vm._s(item.isPermitCamera === 1 ? _vm.$t('all.shipin') : (item.isPermitMicrophone === 1 ? _vm.$t('all.kaimai') : _vm.$t('all.weikaiqi'))) + "\n            ")])])
  }) : _c('div', {
    staticClass: "xtzb-panel-empty"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('all.zanwushuju')) + "\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-actions"
  }, [_c('div', {
    staticClass: "xtzb-panel-action-btn",
    on: {
      "click": _vm.handleInvite
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqingjinbo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-action-btn",
    on: {
      "click": _vm.handleControl
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tongyikongmai')))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-kick-btn",
    on: {
      "click": _vm.handleKick
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tichuzhubozb')))])]) : _vm._e(), _vm._v(" "), (_vm.showInvite) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showInvite = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showInvite) ? _c('div', {
    staticClass: "xtzb-invite-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-invite-title"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqingjinbo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": _vm.handleOpenLimit
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuborenshushangxian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    staticClass: "xtzb-invite-item-value"
  }, [_vm._v(_vm._s(_vm.maxCohost) + _vm._s(_vm.$t('all.ren')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item"
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.keyongshiduan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    staticClass: "xtzb-invite-item-value"
  }, [_vm._v(_vm._s(_vm.$t('all.tongzhibojinyao')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-section-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuboquanxian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": function($event) {
        _vm.zbForm.isPermitSpeech = _vm.zbForm.isPermitSpeech === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxufayan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    class: _vm.zbForm.isPermitSpeech === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.zbForm.isPermitSpeech === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": function($event) {
        _vm.zbForm.isPermitMicrophone = _vm.zbForm.isPermitMicrophone === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxukamai')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    class: _vm.zbForm.isPermitMicrophone === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.zbForm.isPermitMicrophone === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": function($event) {
        _vm.zbForm.isPermitCamera = _vm.zbForm.isPermitCamera === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxukashipin')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    class: _vm.zbForm.isPermitCamera === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.zbForm.isPermitCamera === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-btn",
    on: {
      "click": _vm.handleGenerateKey
    }
  }, [_vm._v(_vm._s(_vm.$t('all.shengchengyaoqingjinyao')))]), _vm._v(" "), (_vm.showLimitPanel) ? _c('div', {
    staticClass: "xtzb-limit-panel"
  }, [_c('div', {
    staticClass: "xtzb-limit-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhiborenshu')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-options"
  }, _vm._l((_vm.limitOptions), function(item) {
    return _c('div', {
      key: item,
      class: _vm.tempMaxCohost === item ? 'xtzb-limit-option-active' : 'xtzb-limit-option',
      on: {
        "click": function($event) {
          _vm.tempMaxCohost = item
        }
      }
    }, [_vm._v(_vm._s(item) + _vm._s(_vm.$t('all.ren')))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-info"
  }, [_c('div', {
    staticClass: "xtzb-limit-info-title"
  }, [_vm._v(_vm._s(_vm.$t('all.dangqianzhibo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-info-num"
  }, [_c('span', {
    staticClass: "xtzb-limit-info-big"
  }, [_vm._v("0")]), _vm._v("/" + _vm._s(_vm.tempMaxCohost))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-info-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.kenenghaiyaoqing')) + " " + _vm._s(_vm.tempMaxCohost) + " " + _vm._s(_vm.$t('all.weizhibo')))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-save",
    on: {
      "click": _vm.handleSaveLimit
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunshangxian')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showShareInvite) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showShareInvite = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareInvite) ? _c('div', {
    staticClass: "xtzb-share-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-share-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangyaoqing')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-qrcode"
  }, [_c('canvas', {
    ref: "qrcodeCanvas"
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-item"
  }, [_c('span', {
    staticClass: "xtzb-share-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqinglianjie')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-share-item-value"
  }, [_vm._v(_vm._s(_vm.liveConfig.shareUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-item"
  }, [_c('span', {
    staticClass: "xtzb-share-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojinyao')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-share-item-value"
  }, [_vm._v(_vm._s(_vm.liveConfig.startKey))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangfangshi')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-actions"
  }, [_c('div', {
    staticClass: "xtzb-share-action-btn xtzb-share-action-gradient",
    on: {
      "click": _vm.handleCopyLink
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhilianjie')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-action-btn",
    on: {
      "click": _vm.handleSaveQr
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunerweima')))])])]) : _vm._e(), _vm._v(" "), (_vm.showControlModal) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showControlModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showControlModal) ? _c('div', {
    staticClass: "xtzb-control-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-control-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tongyikongmai')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-section"
  }, [_vm._v(_vm._s(_vm.$t('all.quanjukongzhi')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item",
    on: {
      "click": function($event) {
        _vm.controlForm.isPermitSpeech = _vm.controlForm.isPermitSpeech === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-control-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxufayan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item-right"
  }, [_c('span', {
    class: _vm.controlForm.isPermitSpeech === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.controlForm.isPermitSpeech === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item",
    on: {
      "click": function($event) {
        _vm.controlForm.isPermitMicrophone = _vm.controlForm.isPermitMicrophone === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-control-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxuzhubokaimai')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item-right"
  }, [_c('span', {
    class: _vm.controlForm.isPermitMicrophone === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.controlForm.isPermitMicrophone === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item",
    on: {
      "click": function($event) {
        _vm.controlForm.isPermitCamera = _vm.controlForm.isPermitCamera === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-control-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxuzhubokaishipin')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item-right"
  }, [_c('span', {
    class: _vm.controlForm.isPermitCamera === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.controlForm.isPermitCamera === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-apply",
    on: {
      "click": _vm.handleApplyControl
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yingyongshezhi')))])]) : _vm._e(), _vm._v(" "), (_vm.showCohostList) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showCohostList = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCohostList) ? _c('div', {
    staticClass: "xtzb-cohost-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-cohost-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhubo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-cohost-list"
  }, _vm._l((_vm.helpUserList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xtzb-cohost-item"
    }, [_c('img', {
      staticClass: "xtzb-cohost-item-avatar",
      attrs: {
        "src": item.userInfo.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "xtzb-cohost-item-info"
    }, [_c('span', {
      staticClass: "xtzb-cohost-item-name"
    }, [_vm._v(_vm._s(item.userInfo.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-box"
    }, [_c('span', {
      staticClass: "xtzb-cohost-item-status",
      class: item.isPermitCamera === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'
    }, [_vm._v("\n\t\t\t\t  " + _vm._s(item.isPermitCamera === 1 ? _vm.$t('all.shipinkaiqi') : _vm.$t('all.shipinguanbi')) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status xtzb-cohost-status-live"
    }, [_vm._v("/")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status",
      class: item.isPermitMicrophone === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'
    }, [_vm._v("\n\t\t\t\t  " + _vm._s(item.isPermitMicrophone === 1 ? _vm.$t('all.kaimai') : _vm.$t('all.bimai')) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status xtzb-cohost-status-live"
    }, [_vm._v("/")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status",
      class: item.isPermitSpeech === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'
    }, [_vm._v("\n\t\t\t\t  " + _vm._s(item.isPermitSpeech === 1 ? _vm.$t('all.yunxufayan') : _vm.$t('all.jinzhifayan')) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "xtzb-cohost-item-manage",
      on: {
        "click": function($event) {
          return _vm.handleManageCohost(item, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.guanli')))])])
  }), 0), _vm._v(" "), (_vm.showManagePanel) ? _c('div', {
    staticClass: "xtzb-manage-panel"
  }, [_c('div', {
    staticClass: "xtzb-manage-close",
    on: {
      "click": function($event) {
        _vm.showManagePanel = false
      }
    }
  }, [_vm._v("✕")]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-user"
  }, [_c('img', {
    staticClass: "xtzb-manage-user-avatar",
    attrs: {
      "src": _vm.managingCohost.userInfo.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-user-info"
  }, [_c('span', {
    staticClass: "xtzb-manage-user-name"
  }, [_vm._v(_vm._s(_vm.managingCohost.userInfo.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-manage-user-id"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuboxiwei')) + " " + _vm._s(_vm.activeIndex + 1))])]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-manage-user-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.yijinru')))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-section-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuboquanxian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-item",
    on: {
      "click": function($event) {
        return _vm.handleUpdatePerm('isPermitSpeech')
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxufayan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-right"
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-status",
    class: {
      'xtzb-manage-perm-status-on': _vm.managingCohost.isPermitSpeech === 1
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isPermitSpeech === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-item",
    on: {
      "click": function($event) {
        return _vm.handleUpdatePerm('isPermitMicrophone')
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-label"
  }, [_vm._v(_vm._s(_vm.$t('all.maikefeng')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-right"
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-status",
    class: {
      'xtzb-manage-perm-status-on': _vm.managingCohost.isPermitMicrophone === 1
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isPermitMicrophone === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-item",
    on: {
      "click": function($event) {
        return _vm.handleUpdatePerm('isPermitCamera')
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shexiangtou')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-right"
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-status",
    class: {
      'xtzb-manage-perm-status-on': _vm.managingCohost.isPermitCamera === 1
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isPermitCamera === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": __webpack_require__(26),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-btn",
    on: {
      "click": _vm.handleSetMain
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isMainScreen === 1 ? _vm.$t('all.quxiaozhuyemian') : _vm.$t('all.sheweizhuyemian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-kick-btn",
    on: {
      "click": _vm.handleKickCohost
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tichuzhibo')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-manage-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.tichuhoubukejinru')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showJoinLive) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showJoinLive = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJoinLive) ? _c('div', {
    staticClass: "xtzb-join-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-join-title"
  }, [_vm._v(_vm._s(_vm.$t('all.jiaruxietongzhibo')))]), _vm._v(" "), (_vm.helpKey) ? _c('div', {
    staticClass: "xtzb-join-item"
  }, [_c('span', {
    staticClass: "xtzb-join-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhubo')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-join-item-value"
  }, [_vm._v(_vm._s(_vm.helpKeyInfo ? _vm.helpKeyInfo.liveName : ''))])]) : _vm._e(), _vm._v(" "), (_vm.helpKey) ? _c('div', {
    staticClass: "xtzb-join-item"
  }, [_c('span', {
    staticClass: "xtzb-join-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiaoqi')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-join-item-value"
  }, [_vm._v(_vm._s(_vm.helpKeyInfo ? _vm.helpKeyInfo.keyStartTime + '-' + _vm.helpKeyInfo.keyEndTime : ''))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xtzb-join-item"
  }, [_c('span', {
    staticClass: "xtzb-join-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhubojinyao')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helpKeyInfo.helpKey),
      expression: "helpKeyInfo.helpKey"
    }],
    staticClass: "xtzb-join-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshuruzhubojinyao')
    },
    domProps: {
      "value": (_vm.helpKeyInfo.helpKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helpKeyInfo, "helpKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-join-btn",
    on: {
      "click": _vm.handleSubmitJoin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jiaru')))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kong-box"
  }, [_c('div', {
    staticClass: "kong"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(882),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.zanwushuju')))])])])
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbsz-box"
  }, [_c('yinliang', {
    on: {
      "setVol": _vm.setVolume
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowGly
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(910),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.guanliyuan')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowKjdy
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(322),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.kuaijieduanyu')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowGg
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(205),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.gonggao')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowSvga
    }
  }, [(_vm.isSvga) ? _c('img', {
    attrs: {
      "src": __webpack_require__(912),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSvga) ? _c('img', {
    attrs: {
      "src": __webpack_require__(909),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.liwutexiao')))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xfmx-box-container",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xfmx-box"
  }, [_c('div', {
    staticClass: "xfmx-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.xiaofeimingxi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(18),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "xfmx-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xfmx-list-item"
    }, [_c('div', {
      staticClass: "xfmx-list-item-left"
    }, [_c('span', {
      staticClass: "xfmx-list-item-left-span"
    }, [_vm._v(_vm._s(item.billDesc))]), _vm._v(" "), _c('span', {
      staticClass: "xfmx-list-item-left-span1"
    }, [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('span', {
      staticClass: "xfmx-list-item-span"
    }, [_vm._v(_vm._s(item.amount))])])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gg-box"
  }, [_c('div', {
    staticClass: "gg-box-container"
  }, [_c('div', {
    staticClass: "gg-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.gonggao')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(18),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gg-box-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeText),
      expression: "noticeText"
    }],
    attrs: {
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.noticeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noticeText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gg-box-btn"
  }, [_c('div', {
    staticClass: "gg-box-btn-btn",
    on: {
      "click": _vm.updNotice
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])])])
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "tc-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model-top"
  }, [_c('div', {
    staticClass: "tc-box-model-top-div"
  }), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-top-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tishi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-center"
  }, [_vm._v(_vm._s(_vm.$t('all.shifouquedingjieshuzhibo')))]), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-bottom",
    on: {
      "click": _vm.closeChatRoom
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbsp-box"
  }, [_c('div', {
    staticClass: "zbsp-table"
  }, [_c('div', {
    staticClass: "zbsp-table-header"
  }, [_c('span', {
    staticClass: "zbsp-col zbsp-col-num"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxuhao')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-img"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinshoutu')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-name"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinmingcheng')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-stock"
  }, [_vm._v("UNImall " + _vm._s(_vm.$t('all.shangchengkucun')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-live-stock"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibokucun')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-price"
  }, [_vm._v("UNImall " + _vm._s(_vm.$t('all.shangchengjiage')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-live-price"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojiage')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-action"
  }, [_vm._v(_vm._s(_vm.$t('all.caozuo')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsp-table-body"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbsp-table-row"
    }, [_c('span', {
      staticClass: "zbsp-col zbsp-col-num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-img"
    }, [_c('img', {
      staticClass: "zbsp-product-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-stock"
    }, [_vm._v(_vm._s(item.mallStock))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-live-stock"
    }, [_c('div', {
      staticClass: "zbsp-counter"
    }, [_c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": __webpack_require__(204),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.decreaseLiveStock(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbsp-counter-value"
    }, [_vm._v(_vm._s(item.liveStock))]), _vm._v(" "), _c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": __webpack_require__(203),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.increaseLiveStock(item)
        }
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-price"
    }, [_vm._v(_vm._s(item.mallPrice))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-live-price"
    }, [_c('div', {
      staticClass: "zbsp-counter"
    }, [_c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": __webpack_require__(204),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.decreaseLivePrice(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbsp-counter-value"
    }, [_vm._v(_vm._s(item.livePrice))]), _vm._v(" "), _c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": __webpack_require__(203),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.increaseLivePrice(item)
        }
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-action"
    }, [_c('span', {
      staticClass: "zbsp-remove",
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.yichu')))])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbz-box"
  }, [_c('div', {
    staticClass: "zbz-box-container"
  }, [_c('div', {
    staticClass: "zbz-bg-layer",
    style: (_vm.backgroundStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-bg-overlay"
  }), _vm._v(" "), (_vm.isHost || _vm.showViewerLeft) ? _c('div', {
    staticClass: "zbz-left"
  }, [(_vm.isHost) ? _c('div', {
    staticClass: "zbz-zhiboshezhi"
  }, [_c('div', {
    staticClass: "zbz-left-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojiansetting')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-settings"
  }, [_c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleSound
    }
  }, [(_vm.soundOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(319),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.soundOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(318),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.soundOn ? _vm.$t('all.kaiqishengyin') : _vm.$t('all.guanbishengyin')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleDanmu
    }
  }, [(_vm.danmuOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(320),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.danmuOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(907),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.danmuOn ? _vm.$t('all.guanbidanmu') : _vm.$t('all.kaiqidanmu')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleMic
    }
  }, [(_vm.micOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(138),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(137),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.micOn ? _vm.$t('all.guanbimaikefeng') : _vm.$t('all.kaiqimaikefeng')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleHostCamera
    }
  }, [(_vm.cameraOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(324),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(323),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.cameraOn ? _vm.$t('all.guanbishexiangtou') : _vm.$t('all.kaiqishexiangtou')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleHostMirror
    }
  }, [(_vm.mirrorOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(911),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(908),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.mirrorOn ? _vm.$t('all.guanbijingxiang') : _vm.$t('all.kaiqijingxiang')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.handleShowNotice
    }
  }, [_c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(205),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.$t('all.gonggao')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.handleShare
    }
  }, [_c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(317),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxianglianjie')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.handleCreateHelpLive
    }
  }, [_c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": __webpack_require__(321),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhibo')))])])])]) : _vm._e(), _vm._v(" "), (!_vm.isHost) ? _c('div', {
    staticClass: "zbz-viewer-goods-title"
  }, [_c('span', {
    staticClass: "zbz-goods-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-viewer-goods-title-img",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showViewerLeft = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-zhiboshangpin"
  }, [(_vm.isHost) ? _c('div', {
    staticClass: "zbz-goods-header"
  }, [_c('span', {
    staticClass: "zbz-goods-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-setting",
    attrs: {
      "src": __webpack_require__(888),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-list"
  }, [_vm._l((_vm.goodsList), function(item, index) {
    return (_vm.isHost) ? _c('div', {
      key: 'h' + index,
      staticClass: "zbz-goods-item"
    }, [_c('img', {
      staticClass: "zbz-goods-img",
      attrs: {
        "src": item.mediasList[0].uri,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-goods-item-content"
    }, [_c('div', {
      staticClass: "zbz-goods-info"
    }, [_c('span', {
      staticClass: "zbz-goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-goods-stock"
    }, [_vm._v(_vm._s(_vm.$t('all.shangchengkucun')) + "：" + _vm._s(item.totalStock))])]), _vm._v(" "), _c('div', {
      staticClass: "zbz-viewer-goods-price"
    }, [_c('span', {
      staticClass: "zbz-viewer-price-text"
    }, [_vm._v("USDN " + _vm._s(item.price))]), _vm._v(" "), _c('div', {
      staticClass: "zbz-viewer-buy-btn",
      on: {
        "click": function($event) {
          return _vm.setGoodsExplain(item)
        }
      }
    }, [_vm._v(_vm._s(item.isExplain === 1 ? _vm.$t('all.jiangjiezhong') : _vm.$t('all.jiangjie')))])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.goodsList), function(item, index) {
    return (!_vm.isHost) ? _c('div', {
      key: 'v' + index,
      staticClass: "zbz-goods-item zbz-viewer-goods-item",
      on: {
        "click": function($event) {
          return _vm.handleViewGoodsDetail(item)
        }
      }
    }, [_c('img', {
      staticClass: "zbz-goods-img",
      attrs: {
        "src": item.mediasList[0].uri,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-goods-item-content"
    }, [_c('div', {
      staticClass: "zbz-goods-info"
    }, [_c('span', {
      staticClass: "zbz-goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-goods-stock"
    }, [_vm._v(_vm._s(_vm.$t('all.shangchengkucun')) + "：" + _vm._s(item.totalStock))])]), _vm._v(" "), _c('div', {
      staticClass: "zbz-viewer-goods-price"
    }, [_c('span', {
      staticClass: "zbz-viewer-price-text"
    }, [_vm._v("USDN " + _vm._s(item.price))]), _vm._v(" "), (item.totalStock > 0) ? _c('div', {
      staticClass: "zbz-viewer-buy-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleBuyGoods(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.qianggou')))]) : _c('div', {
      staticClass: "zbz-viewer-buy-btn1"
    }, [_vm._v(_vm._s(_vm.$t('all.yishouqing')))])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.goodsList && _vm.goodsList.length == 0) ? _c('kong', {
    staticClass: "kong"
  }) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-center"
  }, [_c('div', {
    staticClass: "zbz-video-area"
  }, [_c('div', {
    staticClass: "zbz-video-wrap"
  }, [(_vm.isHost && _vm.data && _vm.data.mainScreenHelpId == 0) ? _c('tengxunyunzb', {
    ref: "txyzb",
    attrs: {
      "room-data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isHost && _vm.data && _vm.data.mainScreenHelpId == 0) ? _c('tengxunyun', {
    ref: "txy"
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.mainScreenHelpId > 0) ? _c('mainscreenplayer', {
    attrs: {
      "main-screen-data": _vm.mainScreenUser,
      "is-self": _vm.isSelfMainScreen,
      "self-user-id": _vm.currentUserId
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data) ? _c('xietongzhibo', {
    ref: "xietongzhibo",
    attrs: {
      "is-host": _vm.isHost,
      "room-data": _vm.data
    },
    on: {
      "select": _vm.handleColiveSelect,
      "joinsuccess": _vm.handleJoinSuccess
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-video-product-popup",
    class: {
      'zbz-video-product-popup-show': _vm.showProductPopup && _vm.productPopupData && !_vm.isHost
    }
  }, [_c('div', {
    staticClass: "zbz-video-product-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.productPopupData && _vm.productPopupData.mediasList && _vm.productPopupData.mediasList[0] ? _vm.productPopupData.mediasList[0].uri : '',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-video-product-info"
  }, [_c('span', {
    staticClass: "zbz-video-product-name"
  }, [_vm._v(_vm._s(_vm.productPopupData && _vm.productPopupData.goodsName ? _vm.productPopupData.goodsName : ''))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-video-product-price"
  }, [_vm._v(_vm._s(_vm.productPopupData ? _vm.productPopupData.price : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-video-product-btn",
    on: {
      "click": _vm.handleProductClick
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-video-product-gb",
    attrs: {
      "src": __webpack_require__(135),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showProductPopup = false
      }
    }
  })])], 1), _vm._v(" "), (_vm.isHost) ? _c('div', {
    staticClass: "zbz-video-bottom"
  }, [_c('div', {
    staticClass: "zbz-volume"
  }, [(_vm.volume > 0) ? _c('img', {
    staticClass: "zbz-volume-icon",
    attrs: {
      "src": __webpack_require__(138),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.setVolume(0)
      }
    }
  }) : _c('img', {
    staticClass: "zbz-volume-icon",
    attrs: {
      "src": __webpack_require__(137),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.setVolume(100)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.volume),
      expression: "volume"
    }],
    staticClass: "zbz-volume-slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.volume)
    },
    on: {
      "input": _vm.handleVolumeChange,
      "__r": function($event) {
        _vm.volume = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-volume-text"
  }, [_vm._v(_vm._s(_vm.volume) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-end-btn",
    on: {
      "click": _vm.handleEndLive
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jieshizhibo')))])]) : _vm._e(), _vm._v(" "), (!_vm.isHost) ? _c('div', {
    staticClass: "zbz-viewer-bottom"
  }, [(_vm.isJoinedHelpLive) ? _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.toggleViewerMic
    }
  }, [(_vm.viewerMicOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(138),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.viewerMicOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(137),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.maikefeng')))])]) : _vm._e(), _vm._v(" "), (_vm.isJoinedHelpLive) ? _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.toggleViewerCamera
    }
  }, [(_vm.viewerCameraOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(324),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.viewerCameraOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(323),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.shipin')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleViewerSound
    }
  }, [(_vm.soundOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(319),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.soundOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(318),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.soundOn ? _vm.$t('all.guanbishengyin') : _vm.$t('all.kaiqishengyin')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.toggleDanmu
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(320),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.danmuOn ? _vm.$t('all.guanbidanmu') : _vm.$t('all.kaiqidanmu')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleShare
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(317),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.fenxianglianjie')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleShowNotice
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(205),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.chakangg')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleShowGoods
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(887),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')))])]), _vm._v(" "), (_vm.data && _vm.data.isOpenHelp == 1) ? _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleHelpLiveToggle
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(321),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isJoinedHelpLive ? _vm.$t('all.tuichuxietongzhibo') : _vm.$t('all.jiaruxietongzhibo')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-reward-btn",
    on: {
      "click": _vm.handleReward
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": __webpack_require__(873),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.dashang')))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "zbz-right"
  }, [_c('div', {
    staticClass: "zbz-online"
  }, [_c('div', {
    staticClass: "zbz-online-title"
  }, [_c('img', {
    staticClass: "zbz-online-icon",
    attrs: {
      "src": __webpack_require__(325),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-online-text"
  }, [_vm._v(_vm._s(_vm.$t('all.zaixianguanzhong')) + "：" + _vm._s(_vm.onlineCount))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-online-list"
  }, [_vm._l((_vm.onlineUserList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-online-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShowOnlineFj(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "zbz-online-item-sort"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-online-item-img",
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-online-item-name"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), (_vm.isHost && _vm.showOnlineFj && _vm.onlineIndex == index) ? _c('div', {
      staticClass: "zbz-chat-item-fj"
    }, [_c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleBannedUserById()
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.onlineUserInfo.isBannedToPost === 0 ? _vm.$t('all.yongjiujinyan') : _vm.$t('all.jiechuejinyan')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": __webpack_require__(136),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleKickUserById(item.userId)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.tichubenchang')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": __webpack_require__(136),
        "alt": ""
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), (_vm.onlineUserList.length === 0) ? _c('div', {
    staticClass: "zbz-online-empty"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.zanwuzaixianguanzhong')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "zbz-dashang"
  }, [_c('div', {
    ref: "rewardContainer",
    staticClass: "zbz-dashang-box"
  }, _vm._l((_vm.rewardList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-reward-item"
    }, [_c('img', {
      staticClass: "zbz-reward-avatar",
      attrs: {
        "src": item.sendUserInfo.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-name"
    }, [_vm._v(_vm._s(item.sendUserInfo.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-text"
    }, [_vm._v(_vm._s(_vm.$t('all.dashang')))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-amount"
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-unit"
    }, [_vm._v(_vm._s(item.unitText))])])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "chatContainer",
    staticClass: "zbz-chat-list"
  }, _vm._l((_vm.msgList), function(msg, index) {
    return (_vm.danmuOn) ? _c('div', {
      key: index,
      staticClass: "zbz-chat-item"
    }, [_c('div', {
      staticClass: "zbz-chat-item-box"
    }, [_c('div', {
      staticClass: "zbz-chat-content-wrapper",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShowModelFj(msg, index)
        }
      }
    }, [(msg.sendUserInfo) ? _c('span', {
      staticClass: "zbz-chat-nickname"
    }, [_vm._v(_vm._s(msg.sendUserInfo.nickName) + "：")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "zbz-chat-text"
    }, [(msg.type == -1) ? [_c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": __webpack_require__(311),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (!msg.sendUserInfo && !msg.type) ? [_c('span', {
      staticClass: "zbz-chat-text-system"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (msg.type == 3) ? [_c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (msg.type == 1) ? [_c('span', {
      staticClass: "zbz-chat-text-join"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (msg.type == 12) ? [_c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v(_vm._s(_vm.$t('all.songgei')) + _vm._s(msg.toUserInfo.nickName) + _vm._s(msg.giftInfo.content))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-gift-img",
      attrs: {
        "src": msg.giftInfo.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v("×" + _vm._s(msg.num))])] : _vm._e()], 2)])]), _vm._v(" "), (_vm.isHost && _vm.showModelFj && _vm.msgIndex == index) ? _c('div', {
      staticClass: "zbz-chat-item-fj"
    }, [_c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleBannedUser(msg)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.sendUserInfo.isBannedToPost === 0 ? _vm.$t('all.yongjiujinyan') : _vm.$t('all.jiechuejinyan')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": __webpack_require__(136),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleKickUser(msg)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.tichubenchang')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": __webpack_require__(136),
        "alt": ""
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zbz-quick-bar"
  }, [(_vm.kjdyList.length > 0) ? _c('div', {
    ref: "quickTags",
    staticClass: "zbz-quick-tags",
    on: {
      "mousedown": _vm.startDragScroll,
      "mousemove": _vm.doDragScroll,
      "mouseup": _vm.stopDragScroll,
      "mouseleave": _vm.stopDragScroll
    }
  }, [_vm._l((_vm.kjdyList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-quick-item",
      on: {
        "click": function($event) {
          return _vm.handleSendKjdy(item.content)
        }
      }
    }, [_vm._v(_vm._s(item.content))])
  }), _vm._v(" "), (_vm.showKjdyTags) ? _c('img', {
    staticClass: "zbz-quick-close",
    attrs: {
      "src": __webpack_require__(110),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyTags = false
      }
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isHost) ? _c('img', {
    staticClass: "zbz-quick-manage-icon",
    attrs: {
      "src": __webpack_require__(322),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyModal = true
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "zbz-send"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatContent),
      expression: "chatContent"
    }],
    ref: "chatInput",
    staticClass: "zbz-send-input",
    attrs: {
      "placeholder": _vm.$t('all.shuodianshenmene'),
      "rows": "1"
    },
    domProps: {
      "value": (_vm.chatContent)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.handleSend.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.chatContent = $event.target.value
      }, _vm.autoResize]
    }
  })]), _vm._v(" "), (_vm.showKjdyModal) ? _c('div', {
    staticClass: "zbz-kjdy-modal"
  }, [_c('div', {
    staticClass: "zbz-kjdy-header"
  }, [_c('img', {
    staticClass: "zbz-kjdy-add",
    attrs: {
      "src": __webpack_require__(307),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyAdd = true
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-kjdy-title"
  }, [_vm._v(_vm._s(_vm.$t('all.kuaijieduanyu')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-kjdy-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyModal = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-kjdy-list"
  }, [_vm._l((_vm.kjdyList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-kjdy-item"
    }, [_c('span', {
      staticClass: "zbz-kjdy-item-text"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-kjdy-item-del",
      attrs: {
        "src": __webpack_require__(110),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.handleDelKjdy(item.id)
        }
      }
    })])
  }), _vm._v(" "), (_vm.kjdyList.length === 0) ? _c('div', {
    staticClass: "zbz-kjdy-empty"
  }, [_vm._v(_vm._s(_vm.$t('all.zanwushuju')))]) : _vm._e()], 2), _vm._v(" "), (_vm.showKjdyAdd) ? _c('div', {
    staticClass: "zbz-kjdy-add-modal"
  }, [_c('div', {
    staticClass: "zbz-kjdy-add-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xinzengkuaijieduanyu')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newKjdyContent),
      expression: "newKjdyContent"
    }],
    staticClass: "zbz-kjdy-add-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.newKjdyContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newKjdyContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-kjdy-add-btns"
  }, [_c('div', {
    staticClass: "zbz-kjdy-add-cancel",
    on: {
      "click": function($event) {
        _vm.showKjdyAdd = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.quxiao')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-kjdy-add-confirm",
    on: {
      "click": _vm.handleAddKjdy
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showNotice) ? _c('div', {
    staticClass: "zbz-notice-modal"
  }, [_c('div', {
    staticClass: "zbz-notice-mask",
    on: {
      "click": _vm.handleCloseNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-notice-content"
  }, [_c('div', {
    staticClass: "zbz-notice-header"
  }, [_c('span', {
    staticClass: "zbz-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('all.gonggao')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-notice-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": _vm.handleCloseNotice
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-notice-body"
  }, [(_vm.isHost || _vm.noticeText) ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeText),
      expression: "noticeText"
    }],
    class: {
      'zbz-notice-textarea-disabled': !_vm.isHost
    },
    attrs: {
      "placeholder": _vm.$t('all.qingshuru'),
      "disabled": !_vm.isHost
    },
    domProps: {
      "value": (_vm.noticeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noticeText = $event.target.value
      }
    }
  })] : _c('div', {
    staticClass: "zbz-notice-empty"
  }, [_vm._v(_vm._s(_vm.$t('all.zanwugonggao')))])], 2), _vm._v(" "), (_vm.isHost) ? _c('div', {
    staticClass: "zbz-notice-footer"
  }, [_c('div', {
    staticClass: "zbz-notice-btn",
    on: {
      "click": _vm.handleUpdateNotice
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (_vm.showRewardModal) ? _c('div', {
    staticClass: "zbz-reward-overlay",
    on: {
      "click": function($event) {
        _vm.showRewardModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRewardModal) ? _c('div', {
    staticClass: "zbz-reward-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-reward-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzedashangbizhong')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-coins"
  }, _vm._l((_vm.walletList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.rewardCoinIndex === index ? 'zbz-reward-coin-active' : 'zbz-reward-coin',
      on: {
        "click": function($event) {
          _vm.rewardCoinIndex = index
        }
      }
    }, [_c('img', {
      staticClass: "zbz-reward-coin-icon",
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-reward-coin-content"
    }, [_c('span', {
      staticClass: "zbz-reward-coin-name"
    }, [_vm._v(_vm._s(item.currencyName))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-coin-balance"
    }, [_vm._v(_vm._s(_vm.$t('all.yue')) + " " + _vm._s(item.sumAvailableAmount))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-section"
  }, [_vm._v(_vm._s(_vm.$t('all.dashangjine')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-amounts"
  }, [_vm._l((_vm.giveAmountConfig.amountList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.rewardAmountIndex === index ? 'zbz-reward-amount-active' : 'zbz-reward-amount-a',
      on: {
        "click": function($event) {
          _vm.rewardAmountIndex = index;
          _vm.customAmount = ''
        }
      }
    }, [_vm._v(_vm._s(item) + " " + _vm._s(_vm.walletList[_vm.rewardCoinIndex].currencyName))])
  }), _vm._v(" "), _c('div', {
    class: _vm.customAmount ? 'zbz-reward-amount-active' : 'zbz-reward-amount-a',
    on: {
      "click": function($event) {
        _vm.rewardAmountIndex = -1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zidingyi')))])], 2), _vm._v(" "), (_vm.rewardAmountIndex === -1) ? _c('div', {
    staticClass: "zbz-reward-custom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customAmount),
      expression: "customAmount"
    }],
    staticClass: "zbz-reward-input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.customAmount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.customAmount = $event.target.value
      }, _vm.handleCustomAmountInput]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-reward-input-unit"
  }, [_vm._v(_vm._s(_vm.walletList[_vm.rewardCoinIndex].currencyName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-total"
  }, [_c('span', {
    staticClass: "zbz-reward-total-label"
  }, [_vm._v(_vm._s(_vm.$t('all.dashangjine')))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-reward-total-value"
  }, [_vm._v(_vm._s(_vm.rewardAmountIndex >= 0 ? _vm.rewardAmounts[_vm.rewardAmountIndex] : _vm.customAmount) + " " + _vm._s(_vm.walletList[_vm.rewardCoinIndex].currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-btn",
    on: {
      "click": _vm.handleConfirmReward
    }
  }, [_vm._v(_vm._s(_vm.$t('all.querendashang')))])]) : _vm._e(), _vm._v(" "), (_vm.showGoodsDetail) ? _c('div', {
    staticClass: "zbz-goods-detail-overlay",
    on: {
      "click": function($event) {
        _vm.showGoodsDetail = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGoodsDetail && _vm.selectedGoods) ? _c('div', {
    staticClass: "zbz-goods-detail-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-goods-detail-header"
  }, [_c('span', {
    staticClass: "zbz-goods-detail-header-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-detail-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showGoodsDetail = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-body"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-carousel"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-carousel-inner",
    style: ({
      transform: 'translateX(-' + _vm.detailCarouselIndex * 100 + '%)'
    })
  }, _vm._l((_vm.selectedGoodsImages), function(img, index) {
    return _c('img', {
      key: index,
      staticClass: "zbz-goods-detail-carousel-img",
      attrs: {
        "src": img,
        "alt": ""
      }
    })
  }), 0), _vm._v(" "), (_vm.selectedGoodsImages.length > 1) ? _c('div', {
    staticClass: "zbz-goods-detail-carousel-dots"
  }, _vm._l((_vm.selectedGoodsImages), function(img, index) {
    return _c('span', {
      key: index,
      class: _vm.detailCarouselIndex === index ? 'zbz-goods-detail-dot-active' : 'zbz-goods-detail-dot',
      on: {
        "click": function($event) {
          _vm.detailCarouselIndex = index
        }
      }
    })
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-price-row"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-price-left"
  }, [_c('span', {
    staticClass: "zbz-goods-detail-price-label"
  }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-price-value"
  }, [_vm._v(_vm._s(_vm.selectedGoods.price))])]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-stock"
  }, [_vm._v(_vm._s(_vm.$t('all.shangchengkucun')) + "：" + _vm._s(_vm.selectedGoods.totalStock))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-name"
  }, [_vm._v(_vm._s(_vm.selectedGoods.goodsName))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-divider"
  }, [_c('span', {
    staticClass: "zbz-goods-detail-divider-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-divider-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-divider-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-images"
  }, _vm._l((_vm.selectedGoodsImages), function(img, index) {
    return _c('img', {
      key: index,
      staticClass: "zbz-goods-detail-desc-img",
      attrs: {
        "src": img,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-footer"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-buy-btn",
    on: {
      "click": _vm.handleDetailBuy
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])])]) : _vm._e(), _vm._v(" "), (_vm.showGoodsModal) ? _c('div', {
    staticClass: "zbz-goods-overlay",
    on: {
      "click": function($event) {
        _vm.showGoodsModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGoodsModal) ? _c('div', {
    staticClass: "zbz-goods-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-goods-modal-header"
  }, [_c('span', {
    staticClass: "zbz-goods-modal-header-span"
  }, [_vm._v(_vm._s(_vm.$t('all.goumaishangpin')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-modal-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showGoodsModal = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-body"
  }, [_c('div', {
    staticClass: "zbz-goods-modal-info"
  }, [_c('img', {
    staticClass: "zbz-goods-modal-img",
    attrs: {
      "src": _vm.selectedGoods.mediasList[0].uri,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-detail"
  }, [_c('span', {
    staticClass: "zbz-goods-modal-name"
  }, [_vm._v(_vm._s(_vm.selectedGoods.goodsName))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-modal-selected"
  }, [_vm._v(_vm._s(_vm.$t('all.yixuan')) + "：" + _vm._s(_vm.selectedSpec.name))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-modal-price"
  }, [_vm._v("USDN " + _vm._s(_vm.selectedSpec.price))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-info-kucun"
  }, [_c('span', {
    staticClass: "zbz-goods-modal-info-kucun-span"
  }, [_vm._v(_vm._s(_vm.$t('all.kucun')) + "：" + _vm._s(_vm.selectedSpec.inventory))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-count"
  }, [_c('img', {
    staticClass: "zbz-goods-modal-count-btn",
    attrs: {
      "src": __webpack_require__(204),
      "alt": ""
    },
    on: {
      "click": _vm.decreaseBuyCount
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-modal-count-num"
  }, [_vm._v(_vm._s(_vm.buyCount))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-modal-count-btn",
    attrs: {
      "src": __webpack_require__(203),
      "alt": ""
    },
    on: {
      "click": _vm.increaseBuyCount
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-section"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzeguiige')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-specs"
  }, _vm._l((_vm.selectedGoods.specificationList), function(item) {
    return _c('div', {
      key: item.dbSpecificationId,
      class: _vm.selectedSpec.dbSpecificationId === item.dbSpecificationId ? 'zbz-goods-modal-spec-active' : 'zbz-goods-modal-spec',
      on: {
        "click": function($event) {
          return _vm.selectSpec(item)
        }
      }
    }, [_c('span', {
      staticClass: "zbz-goods-modal-spec-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-goods-modal-spec-price"
    }, [_vm._v("USDN " + _vm._s(item.price))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-footer"
  }, [_c('div', {
    staticClass: "zbz-goods-modal-add-btn",
    on: {
      "click": _vm.handleAddToCart
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])])])]) : _vm._e(), _vm._v(" "), (_vm.showShareLink) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showShareLink = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareLink) ? _c('div', {
    staticClass: "xtzb-share-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-share-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangyaoqing')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-qrcode"
  }, [_c('canvas', {
    ref: "qrcodeCanvas"
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-item"
  }, [_c('span', {
    staticClass: "xtzb-share-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqinglianjie')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-share-item-value"
  }, [_vm._v(_vm._s(_vm.data.shareUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangfangshi')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-actions"
  }, [_c('div', {
    staticClass: "xtzb-share-action-btn xtzb-share-action-gradient",
    on: {
      "click": _vm.handleCopyLink
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhilianjie')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-action-btn",
    on: {
      "click": _vm.handleSaveQr
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunerweima')))])])]) : _vm._e(), _vm._v(" "), (_vm.showLiveRecord) ? _c('div', {
    staticClass: "zbz-record-overlay",
    on: {
      "click": function($event) {
        _vm.showLiveRecord = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLiveRecord) ? _c('div', {
    staticClass: "zbz-record-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-record-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('div', {
    ref: "recordList",
    staticClass: "zbz-record-list",
    on: {
      "scroll": _vm.handleRecordScroll
    }
  }, [_vm._l((_vm.liveRecordList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-record-item",
      on: {
        "click": function($event) {
          return _vm.handlePlayRecord(item)
        }
      }
    }, [_c('div', {
      staticClass: "zbz-record-item-cover",
      style: ({
        backgroundImage: 'url(' + item.backgroundUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-record-item-info"
    }, [_c('span', {
      staticClass: "zbz-record-item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "zbz-record-item-info-div"
    }, [_c('span', {
      staticClass: "zbz-record-item-tag"
    }, [_vm._v(_vm._s(item.categoryName))]), _vm._v(" "), (item.isOpenReplay == 1 && item.replayUrl) ? _c('div', {
      staticClass: "zbz-record-item-info-div-bf",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handlePlayVideo(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(202),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.huifang')))])]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "zbz-record-item-time"
    }, [_vm._v(_vm._s(item.liveStartTime) + " - " + _vm._s(item.liveEndTime))])])])
  }), _vm._v(" "), (!_vm.recordLoading && _vm.liveRecordList.length === 0) ? _c('kong') : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "gift-popup",
    style: ({
      left: _vm.x + 'px',
      top: _vm.y + 'px'
    }),
    on: {
      "mouseenter": function($event) {
        return _vm.$emit('mouseenter')
      },
      "mouseleave": function($event) {
        return _vm.$emit('mouseleave')
      }
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gift-popup-item",
      on: {
        "click": function($event) {
          return _vm.handleZs(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "wdqb-box"
  }, [_c('div', {
    staticClass: "wdqb-content"
  }, [_c('div', {
    staticClass: "wdqb-left"
  }, [_c('div', {
    staticClass: "wdqb-coin-card"
  }, [_c('img', {
    staticClass: "wdqb-coin-icon",
    attrs: {
      "src": _vm.data.currencyLogo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wdqb-coin-info"
  }, [_c('span', {
    staticClass: "wdqb-coin-name"
  }, [_vm._v(_vm._s(_vm.data.currencyName))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-coin-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.lianshangbaobishibei')))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zonge')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumAmount) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.keyongshuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumAvailableAmount) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.dongjieshuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumFreezeAmount) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-actions"
  }, [_c('div', {
    class: _vm.activeTab === 'deposit' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn',
    on: {
      "click": _vm.handleSwitchDeposit
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongbi')))]), _vm._v(" "), _c('div', {
    class: _vm.activeTab === 'withdraw' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn',
    on: {
      "click": _vm.handleSwitchWithdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tibi')))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-flow-btn",
    on: {
      "click": _vm.handleGoFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chakanliushui')))])]), _vm._v(" "), (_vm.activeTab) ? _c('div', {
    staticClass: "wdqb-right"
  }, [_c('div', {
    staticClass: "wd-right-scroll"
  }, [(_vm.activeTab === 'deposit') ? [_c('div', {
    staticClass: "wdqb-right-item",
    on: {
      "click": function($event) {
        _vm.showCurrencyPicker = true
      }
    }
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzebizhong')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item-right"
  }, [_c('span', {
    staticClass: "wdqb-right-value"
  }, [_vm._v(_vm._s(_vm.currentCurrencyName))]), _vm._v(" "), _c('img', {
    staticClass: "wdqb-right-arrow",
    attrs: {
      "src": __webpack_require__(884),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), (_vm.data.rechargeNetworkConfigList && _vm.data.rechargeNetworkConfigList[0]) ? _c('span', {
    staticClass: "wdqb-right-value wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.data.rechargeNetworkConfigList[0].symbol))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.chongzhitip')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.chongbidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item-right"
  }, [_c('span', {
    staticClass: "wdqb-right-value wdqb-text-green",
    attrs: {
      "title": _vm.rechargeData.address
    }
  }, [_vm._v(_vm._s(_vm.rechargeData.address))]), _vm._v(" "), _c('img', {
    staticClass: "wdqb-right-copy-img",
    attrs: {
      "src": __webpack_require__(89),
      "alt": ""
    },
    on: {
      "click": _vm.handleCopyAddress
    }
  })])]), _vm._v(" "), (_vm.rechargeData.address) ? _c('div', {
    staticClass: "wdqb-qr"
  }, [_c('canvas', {
    ref: "qrcodeCanvas",
    staticClass: "wdqb-qr-canvas"
  })]) : _vm._e(), _vm._v(" "), (_vm.agreementContent) ? _c('div', {
    staticClass: "wdqb-right-agreement",
    domProps: {
      "innerHTML": _vm._s(_vm.agreementContent)
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.activeTab === 'withdraw') ? [_c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tibidizhi')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.withdrawAddress),
      expression: "withdrawAddress"
    }],
    staticClass: "wdqb-right-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshurutibidizhi')
    },
    domProps: {
      "value": (_vm.withdrawAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.withdrawAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-value"
  }, [_vm._v(_vm._s(_vm.data.withdrawalNetworkConfigList && _vm.data.withdrawalNetworkConfigList[0] ? _vm.data.withdrawalNetworkConfigList[0].symbol : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishuliang')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.withdrawAmount),
      expression: "withdrawAmount"
    }],
    staticClass: "wdqb-right-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.withdrawAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.withdrawAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.data.withdrawalNetworkConfigList && _vm.data.withdrawalNetworkConfigList[0] && _vm.data.withdrawalNetworkConfigList[0].minWithdrawalAmount) ? _c('div', {
    staticClass: "wdqb-right-min-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.zuiditixianjin')) + _vm._s(_vm.data.withdrawalNetworkConfigList[0].minWithdrawalAmount) + " " + _vm._s(_vm.data.currencyName))]) : _vm._e(), _vm._v(" "), (_vm.withdrawError) ? _c('div', {
    staticClass: "wdqb-right-error"
  }, [_vm._v(_vm._s(_vm.withdrawError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate"
  }, [_c('div', {
    staticClass: "wdqb-right-estimate-header"
  }, [_c('span', {
    staticClass: "wdqb-right-estimate-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishisuan')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-estimate-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.shouxufeibilv')) + _vm._s(_vm.data.withdrawalNetworkConfigList && _vm.data.withdrawalNetworkConfigList[0] ? _vm.data.withdrawalNetworkConfigList[0].withdrawalServiceChargeRatio : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shouxufei')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.withdrawFee) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shijidaozhang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.withdrawActual) + " " + _vm._s(_vm.data.currencyName))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-btn",
    on: {
      "click": _vm.handleWithdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiaotibi')))])] : _vm._e()], 2), _vm._v(" "), (_vm.activeTab === 'deposit' && _vm.data.rechargeNetworkConfigList && _vm.data.rechargeNetworkConfigList[0]) ? _c('div', {
    staticClass: "wdqb-right-min-tip wdqb-right-min-tip--fixed"
  }, [_vm._v(_vm._s(_vm.$t('all.zuidicharge')) + _vm._s(_vm.data.rechargeNetworkConfigList[0].minRechargeAmount) + " " + _vm._s(_vm.data.currencyName) + "，" + _vm._s(_vm.$t('all.xiaoyuzuixiaoe')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": function($event) {
        _vm.showAddressModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "wdqb-address-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-address-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzetibidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-address-search"
  }, [_c('img', {
    staticClass: "wdqb-address-search-icon",
    attrs: {
      "src": __webpack_require__(305),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAddress),
      expression: "searchAddress"
    }],
    staticClass: "wdqb-address-search-input",
    attrs: {
      "placeholder": _vm.$t('all.sousuodizhi')
    },
    domProps: {
      "value": (_vm.searchAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-address-list"
  }, _vm._l((_vm.addressList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "wdqb-address-item"
    }, [_c('div', {
      staticClass: "wdqb-address-item-info"
    }, [_c('span', {
      staticClass: "wdqb-address-item-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "wdqb-address-item-value"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      staticClass: "wdqb-address-item-btn",
      on: {
        "click": function($event) {
          return _vm.handleSelectAddress(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.xuanze')))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showCurrencyPicker) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": function($event) {
        _vm.showCurrencyPicker = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCurrencyPicker) ? _c('div', {
    staticClass: "wdqb-currency-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-currency-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzebizhong')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-currency-list"
  }, _vm._l((_vm.currencyList), function(item, index) {
    return _c('div', {
      key: item.currencyId,
      staticClass: "wdqb-currency-item",
      class: {
        'wdqb-currency-item--active': String(item.currencyId) === String(_vm.currencyId)
      },
      on: {
        "click": function($event) {
          return _vm.onCurrencyConfirm(item)
        }
      }
    }, [_c('img', {
      staticClass: "wdqb-currency-item-icon",
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wdqb-currency-item-name"
    }, [_vm._v(_vm._s(item.unitText || item.currencyName))]), _vm._v(" "), (String(item.currencyId) === String(_vm.currencyId)) ? _c('span', {
      staticClass: "wdqb-currency-item-check"
    }, [_vm._v("✓")]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showVerifyModal) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": _vm.closeVerify
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showVerifyModal) ? _c('div', {
    staticClass: "wdqb-verify-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-verify-header"
  }, [_c('span', {
    staticClass: "wdqb-verify-title"
  }, [_vm._v(_vm._s(_vm.$t('all.anquanyanzheng')))]), _vm._v(" "), _c('img', {
    staticClass: "wdqb-verify-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": _vm.closeVerify
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-section"
  }, [_c('span', {
    staticClass: "wdqb-verify-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiang')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-box"
  }, [_c('span', {
    staticClass: "wdqb-verify-email"
  }, [_vm._v(_vm._s(_vm.userEmail))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-section"
  }, [_c('span', {
    staticClass: "wdqb-verify-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yanzhengma')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-box wdqb-verify-code-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailCode),
      expression: "emailCode"
    }],
    staticClass: "wdqb-verify-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyouxiangyanzhengma')
    },
    domProps: {
      "value": (_vm.emailCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wdqb-verify-send",
    class: {
      'wdqb-verify-send--disabled': _vm.codeCountdown > 0
    },
    on: {
      "click": _vm.sendEmailCode
    }
  }, [_vm._v("\n            " + _vm._s(_vm.codeCountdown > 0 ? _vm.codeCountdown + 's' : _vm.$t('all.fasongyanzhengma')) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-confirm",
    on: {
      "click": _vm.confirmVerifyAndWithdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queren')))])]) : _vm._e(), _vm._v(" "), (_vm.showWithdrawSuccess) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": function($event) {
        _vm.showWithdrawSuccess = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWithdrawSuccess) ? _c('div', {
    staticClass: "wdqb-success-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-success-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "48",
      "height": "48"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z",
      "fill": "#FFFFFF"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishenqingyitijiao') || '提币申请已提交'))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishenqingdesc') || '后台审核通过后，将进行链上提币。'))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-row"
  }, [_c('span', {
    staticClass: "wdqb-success-row-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuangtai') || '状态'))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-success-row-value"
  }, [_vm._v(_vm._s(_vm.withdrawSuccessStatus || (_vm.$t('all.shenhezhong') || '审核中')))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-row"
  }, [_c('span', {
    staticClass: "wdqb-success-row-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijidaozhang') || '实际到账'))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-success-row-value"
  }, [_vm._v(_vm._s(_vm.withdrawSuccessActual) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-btn",
    on: {
      "click": _vm.handleGoFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chakantibi') || '查看提币记录'))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrtb-box"
  }, [_c('div', {
    staticClass: "qrtb-content"
  }, [_c('div', {
    staticClass: "qrtb-coin-card"
  }, [_c('div', {
    staticClass: "qrtb-coin-icon"
  }, [_vm._v("NB")]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-coin-info"
  }, [_c('span', {
    staticClass: "qrtb-coin-name"
  }, [_vm._v("NB Chain")]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-coin-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.lianshangbaobishibei')))])])]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.bizhong')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("NB")])]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("+1000.00")])]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("NB Chain")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijian')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("2026/06/10 13:20")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v("TxHash")]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value qrtb-text-green"
  }, [_vm._v("0x82...8F91")])])
}]}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-container",
    on: {
      "mouseenter": _vm.pause,
      "mouseleave": _vm.play
    }
  }, [_c('div', {
    staticClass: "carousel-track",
    style: ({
      transform: ("translateX(-" + (_vm.currentIndex * 100) + "%)")
    })
  }, [_c('img', {
    staticClass: "carousel-item",
    attrs: {
      "src": _vm.images[_vm.images.length - 1],
      "alt": "carousel-img"
    },
    on: {
      "error": _vm.handleImgError
    }
  }), _vm._v(" "), _vm._l((_vm.images), function(image, index) {
    return _c('img', {
      key: index,
      staticClass: "carousel-item",
      attrs: {
        "src": image,
        "alt": "carousel-img"
      },
      on: {
        "error": _vm.handleImgError
      }
    })
  }), _vm._v(" "), _c('img', {
    staticClass: "carousel-item",
    attrs: {
      "src": _vm.images[0],
      "alt": "carousel-img"
    },
    on: {
      "error": _vm.handleImgError
    }
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czcg-box"
  }, [_c('div', {
    staticClass: "czcg-content"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "czcg-title"
  }, [_vm._v(_vm._s(_vm.$t('all.chongbichenggong')))]), _vm._v(" "), _c('div', {
    staticClass: "czcg-info"
  }, [_c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.bizhong')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("NB")])]), _vm._v(" "), _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("+1000.00")])]), _vm._v(" "), _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("NB Chain")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijian')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("2026/06/10 13:20")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czcg-icon"
  }, [_c('img', {
    staticClass: "czcg-icon-check",
    attrs: {
      "src": __webpack_require__(309),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v("TxHash")]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value czcg-text-green"
  }, [_vm._v("0x82...8F91")])])
}]}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kidy-box"
  }, [_c('div', {
    staticClass: "kidy-box-container"
  }, [_c('div', {
    staticClass: "kidy-box-top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(307),
      "alt": ""
    },
    on: {
      "click": _vm.handleAdd
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.kuaijieduanyu')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(18),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kidy-box-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "kidy-box-list-item"
    }, [_c('div', {
      staticClass: "kidy-box-list-item-left"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": __webpack_require__(110),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.delLiveCommonExpressions(item.id)
        }
      }
    })])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2), _vm._v(" "), (_vm.isKjdyModel) ? _c('div', {
    staticClass: "kjdy-mask"
  }) : _vm._e(), _vm._v(" "), (_vm.isKjdyModel) ? _c('div', {
    staticClass: "kjdy-mask-model",
    on: {
      "click": function($event) {
        _vm.isKjdyModel = false
      }
    }
  }, [_c('div', {
    staticClass: "kjdy-mask-model-rect",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kjdy-mask-model-rect-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xinzengkuaijieduanyu')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kjdy-mask-model-rect-btn",
    on: {
      "click": _vm.addLiveCommonExpressions
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbjl-box"
  }, [_c('div', {
    ref: "listContainer",
    staticClass: "zbjl-container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "zbjl-steps"
  }, [_c('div', {
    staticClass: "zbjl-step zbjl-step-left",
    on: {
      "click": _vm.handleShenqing
    }
  }, [_c('span', {
    staticClass: "zbjl-step-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "zbjl-step-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingzhibo')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(880),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbjl-step zbjl-step-right",
    on: {
      "click": _vm.handleKaishi
    }
  }, [_c('span', {
    staticClass: "zbjl-step-num1"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "zbjl-step-text"
  }, [_vm._v(_vm._s(_vm.$t('all.kaishizhibo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "zbjl-title"
  }, [_c('div', {
    staticClass: "zbzx-title-box"
  }, [_c('span', {
    staticClass: "zbzx-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('span', {
    staticClass: "zbzx-title-span1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "zbjl-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('zbList', {
      key: index,
      attrs: {
        "data": item,
        "type": 1
      }
    })
  }), 1), _vm._v(" "), (!_vm.isLoading && _vm.loaded && _vm.list.length === 0) ? _c('div', {
    staticClass: "zbjl-kong"
  }, [_c('kong')], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dsp-box"
  }, [(_vm.loaded && _vm.list.length === 0) ? _c('kong') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length > 0),
      expression: "list.length > 0"
    }],
    ref: "swiper",
    staticClass: "dsp-swiper",
    class: {
      'dsp-swiper--narrow': _vm.showComment
    },
    on: {
      "scroll": _vm.handleScroll,
      "wheel": _vm.handleWheel,
      "touchstart": _vm.handleTouchStart,
      "touchmove": _vm.handleTouchMove,
      "touchend": _vm.handleTouchEnd,
      "mousedown": _vm.handleDragDown,
      "contextmenu": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "dsp-swiper-item"
    }, [_c('div', {
      staticClass: "dsp-video-wrap"
    }, [(item.coverUrl) ? _c('img', {
      staticClass: "dsp-video-bg",
      attrs: {
        "src": item.coverUrl
      }
    }) : _vm._e(), _vm._v(" "), (!item.playing && !_vm.leaving && !_vm.isWheelLock && !_vm.isDragging && !_vm.isTouching && !_vm.snapAnimating) ? _c('img', {
      staticClass: "dsp-play-btn",
      attrs: {
        "src": _vm.spBf
      }
    }) : _vm._e(), _vm._v(" "), (index === _vm.currentIndex && item.buffering) ? _c('div', {
      staticClass: "dsp-loading"
    }) : _vm._e(), _vm._v(" "), (index === _vm.currentIndex && !_vm.leaving) ? _c('div', {
      staticClass: "dsp-fullscreen-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFullscreen.apply(null, arguments)
        }
      }
    }, [(!_vm.isFullscreen) ? _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18",
        "fill": "none",
        "stroke": "#FFFFFF",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"
      }
    })]) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18",
        "fill": "none",
        "stroke": "#FFFFFF",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('video', {
      ref: 'video' + index,
      refInFor: true,
      staticClass: "dsp-video",
      attrs: {
        "src": _vm.videoSrc(item, index),
        "poster": item.coverUrl || '',
        "loop": "",
        "playsinline": "",
        "webkit-playsinline": "",
        "preload": "auto"
      },
      on: {
        "click": function($event) {
          return _vm.handleVideoClick(index)
        },
        "dblclick": function($event) {
          return _vm.handleVideoDblClick(item)
        },
        "timeupdate": function($event) {
          return _vm.onTimeUpdate(index)
        },
        "loadedmetadata": function($event) {
          return _vm.onLoadedMetadata(index)
        },
        "play": function($event) {
          return _vm.onVideoPlay(index)
        },
        "pause": function($event) {
          return _vm.onVideoPause(index)
        },
        "waiting": function($event) {
          return _vm.onVideoWaiting(index)
        },
        "playing": function($event) {
          return _vm.onVideoPlaying(index)
        },
        "canplay": function($event) {
          return _vm.onVideoCanPlay(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dsp-info"
    }, [_c('span', {
      staticClass: "dsp-info-user"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "dsp-info-title"
    }, [_vm._v(_vm._s(item.title || ''))])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-actions"
    }, [_c('div', {
      staticClass: "dsp-actions-item"
    }, [_c('img', {
      staticClass: "dsp-actions-avatar",
      attrs: {
        "src": item.headPortrait
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleGoUserHome(item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "dsp-actions-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleToggleLike(item)
        }
      }
    }, [_c('img', {
      staticClass: "dsp-actions-icon",
      attrs: {
        "src": item.isGiveLike === 1 ? _vm.spDz2 : _vm.spDz1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dsp-actions-count"
    }, [_vm._v(_vm._s(item.giveLikeNumber || 0))])]), _vm._v(" "), (item.commentStatus == 1) ? _c('div', {
      staticClass: "dsp-actions-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShowComment(item)
        }
      }
    }, [_c('img', {
      staticClass: "dsp-actions-icon",
      attrs: {
        "src": _vm.spPinglun
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dsp-actions-count"
    }, [_vm._v(_vm._s(item.commentNumber || 0))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "dsp-actions-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleToggleCollect(item)
        }
      }
    }, [_c('img', {
      staticClass: "dsp-actions-icon",
      attrs: {
        "src": item.isCollect === 1 ? _vm.spShoucang2 : _vm.spShoucang1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dsp-actions-count"
    }, [_vm._v(_vm._s(item.collectNumber || 0))])])])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-progress",
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          return _vm.handleProgressDown($event, index)
        }
      }
    }, [_c('div', {
      staticClass: "dsp-progress-track"
    }, [_c('div', {
      staticClass: "dsp-progress-fill",
      style: ({
        width: _vm.progressPercent(item) + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls"
    }, [_c('div', {
      staticClass: "dsp-controls-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.togglePlay(index)
        }
      }
    }, [(item.playing) ? _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7 5h3.4v14H7zM13.6 5H17v14h-3.4z",
        "fill": "#FFFFFF"
      }
    })]) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8 5l11 7-11 7V5z",
        "fill": "#FFFFFF"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "dsp-controls-time"
    }, [_vm._v(_vm._s(_vm.formatTime(item.pTime)) + " / " + _vm._s(_vm.formatTime(item.dTime)))]), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls-input",
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
        },
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "dsp-bar-emoji-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleBarEmoji.apply(null, arguments)
        }
      }
    }, [_c('div', {
      staticClass: "dsp-bar-emoji-face",
      class: {
        'dsp-bar-emoji-face--active': _vm.barEmojiShow
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.barInput),
        expression: "barInput"
      }],
      staticClass: "dsp-controls-field",
      attrs: {
        "placeholder": _vm.$t('all.shuodianshenme')
      },
      domProps: {
        "value": (_vm.barInput)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.submitBarComment.apply(null, arguments)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.barInput = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls-send",
      class: {
        'dsp-controls-send--loading': _vm.barSubmitting
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.submitBarComment.apply(null, arguments)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.fabiao')))])]), _vm._v(" "), _c('div', {
      staticClass: "dsp-controls-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMute(index)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "18",
        "height": "18"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 9v6h4l5 4V5L8 9H4z",
        "fill": "#FFFFFF"
      }
    }), _vm._v(" "), (!_vm.muted) ? _c('path', {
      attrs: {
        "d": "M16.5 8.5a5 5 0 010 7M18.5 6a8 8 0 010 12",
        "stroke": "#FFFFFF",
        "stroke-width": "1.6",
        "fill": "none",
        "stroke-linecap": "round"
      }
    }) : _c('path', {
      attrs: {
        "d": "M16 9l5 6M21 9l-5 6",
        "stroke": "#FFFFFF",
        "stroke-width": "1.6",
        "fill": "none",
        "stroke-linecap": "round"
      }
    })])])]), _vm._v(" "), (_vm.barEmojiShow) ? _c('div', {
      staticClass: "dsp-bar-emoji-panel",
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
        },
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "dsp-bar-emoji-grid"
    }, _vm._l((_vm.emojiList), function(e, ei) {
      return _c('span', {
        key: ei,
        staticClass: "dsp-bar-emoji-item",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.pickBarEmoji(e)
          }
        }
      }, [_vm._v(_vm._s(e))])
    }), 0)]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.showComment && _vm.currentVideo) ? _c('div', {
    staticClass: "dsp-comment"
  }, [_c('div', {
    staticClass: "dsp-comment-header"
  }, [_c('span', {
    staticClass: "dsp-comment-title"
  }, [_vm._v(_vm._s(_vm.currentVideo.commentNumber || 0) + " " + _vm._s(_vm.$t('all.pinglun')))]), _vm._v(" "), _c('div', {
    staticClass: "dsp-comment-close",
    on: {
      "click": function($event) {
        _vm.showComment = false
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 6l12 12M18 6L6 18",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]), _vm._v(" "), _c('pinglun', {
    ref: "pinglun",
    staticClass: "dsp-comment-body",
    attrs: {
      "videoId": _vm.currentVideo.id
    },
    on: {
      "count-change": _vm.onCommentCountChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "playerContainer",
    staticClass: "tengxunyun",
    class: {
      'tengxunyun-horizontal': _vm.screenType === 1
    }
  }, [_c('video', {
    staticClass: "tengxunyun-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), (_vm.isShowCover && _vm.backgroundUrl) ? _c('div', {
    staticClass: "video-cover"
  }, [_c('div', {
    staticClass: "video-cover-box"
  }, [_c('img', {
    staticClass: "video-cover-box-img",
    attrs: {
      "src": _vm.backgroundUrl,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.show_svga) ? _c('playSvga', {
    ref: "svga"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-box"
  }, [_c('div', {
    ref: "list",
    staticClass: "pl-list",
    on: {
      "scroll": _vm.handleListScroll
    }
  }, [_vm._l((_vm.list), function(c, ci) {
    return _c('div', {
      key: c.id,
      staticClass: "pl-item"
    }, [(c.avatar) ? _c('img', {
      staticClass: "pl-avatar",
      attrs: {
        "src": c.avatar
      }
    }) : _c('div', {
      staticClass: "pl-avatar pl-avatar--empty"
    }), _vm._v(" "), _c('div', {
      staticClass: "pl-main"
    }, [_c('div', {
      staticClass: "pl-name"
    }, [_vm._v(_vm._s(c.nickName))]), _vm._v(" "), _c('div', {
      staticClass: "pl-content"
    }, [_vm._v(_vm._s(c.content))]), _vm._v(" "), _c('div', {
      staticClass: "pl-meta"
    }, [_c('span', {
      staticClass: "pl-time"
    }, [_vm._v(_vm._s(_vm.formatTime(c.createTime)))]), _vm._v(" "), _c('span', {
      staticClass: "pl-reply-btn",
      on: {
        "click": function($event) {
          return _vm.startReply(c)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.huifu')))]), _vm._v(" "), (_vm.isMine(c)) ? _c('span', {
      staticClass: "pl-del",
      on: {
        "click": function($event) {
          return _vm.delComment(c, ci)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.shanchu')))]) : _vm._e()]), _vm._v(" "), (c.childs.length) ? _c('div', {
      staticClass: "pl-childs"
    }, [_vm._l((c.childs), function(r, ri) {
      return _c('div', {
        key: r.id,
        staticClass: "pl-child"
      }, [(r.avatar) ? _c('img', {
        staticClass: "pl-child-avatar",
        attrs: {
          "src": r.avatar
        }
      }) : _c('div', {
        staticClass: "pl-child-avatar pl-avatar--empty"
      }), _vm._v(" "), _c('div', {
        staticClass: "pl-main"
      }, [_c('div', {
        staticClass: "pl-name"
      }, [_vm._v(_vm._s(r.nickName))]), _vm._v(" "), _c('div', {
        staticClass: "pl-content"
      }, [_vm._v(_vm._s(r.content))]), _vm._v(" "), _c('div', {
        staticClass: "pl-meta"
      }, [_c('span', {
        staticClass: "pl-time"
      }, [_vm._v(_vm._s(_vm.formatTime(r.createTime)))]), _vm._v(" "), _c('span', {
        staticClass: "pl-reply-btn",
        on: {
          "click": function($event) {
            return _vm.startReply(c, r)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('all.huifu')))]), _vm._v(" "), (_vm.isMine(r)) ? _c('span', {
        staticClass: "pl-del",
        on: {
          "click": function($event) {
            return _vm.delReply(c, r, ri)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('all.shanchu')))]) : _vm._e()])])])
    }), _vm._v(" "), (c.childHasMore) ? _c('div', {
      staticClass: "pl-child-more",
      on: {
        "click": function($event) {
          return _vm.loadChilds(c)
        }
      }
    }, [_vm._v(_vm._s(_vm.childMoreText(c)))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (c.replyNumber > 0 && c.childs.length === 0) ? _c('div', {
      staticClass: "pl-expand",
      on: {
        "click": function($event) {
          return _vm.loadChilds(c)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.chakanhuifu')) + " (" + _vm._s(c.replyNumber) + ")")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loaded && !_vm.loading && _vm.list.length === 0) ? _c('kong') : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "pl-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.jiazaizhong')))]) : _vm._e(), _vm._v(" "), (!_vm.hasMore && _vm.list.length > 0) ? _c('div', {
    staticClass: "pl-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.meiyougengduo')))]) : _vm._e()], 2), _vm._v(" "), (_vm.replyTarget) ? _c('div', {
    staticClass: "pl-reply-chip"
  }, [_c('span', {
    staticClass: "pl-reply-chip-text"
  }, [_vm._v(_vm._s(_vm.replyChipText))]), _vm._v(" "), _c('svg', {
    staticClass: "pl-reply-chip-close",
    attrs: {
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": function($event) {
        _vm.replyTarget = null
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "fill": "rgba(255,255,255,0.15)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.5 8.5l7 7M15.5 8.5l-7 7",
      "stroke": "#FFFFFF",
      "stroke-width": "1.8",
      "stroke-linecap": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.emojiShow) ? _c('div', {
    staticClass: "pl-emoji-panel"
  }, [_c('div', {
    staticClass: "pl-emoji-grid"
  }, _vm._l((_vm.emojiList), function(e, ei) {
    return _c('span', {
      key: ei,
      staticClass: "pl-emoji-item",
      on: {
        "click": function($event) {
          return _vm.pickEmoji(e)
        }
      }
    }, [_vm._v(_vm._s(e))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-input-bar"
  }, [_c('div', {
    staticClass: "pl-emoji-btn",
    on: {
      "click": _vm.toggleEmoji
    }
  }, [_c('div', {
    staticClass: "pl-emoji-face",
    class: {
      'pl-emoji-face--active': _vm.emojiShow
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "pl-input",
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pl-send",
    class: {
      'pl-send--loading': _vm.submitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fasong')))])]), _vm._v(" "), (_vm.delTarget) ? _c('div', {
    staticClass: "pl-confirm"
  }, [_c('div', {
    staticClass: "pl-confirm-card"
  }, [_c('div', {
    staticClass: "pl-confirm-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shanchupinglun')))]), _vm._v(" "), _c('div', {
    staticClass: "pl-confirm-btns"
  }, [_c('div', {
    staticClass: "pl-confirm-btn pl-confirm-btn--cancel",
    on: {
      "click": function($event) {
        _vm.delTarget = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.quxiao')))]), _vm._v(" "), _c('div', {
    staticClass: "pl-confirm-btn pl-confirm-btn--ok",
    on: {
      "click": _vm.confirmDel
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbjl-box"
  }, [_c('div', {
    staticClass: "zbjl-box-container"
  }, [_c('div', {
    staticClass: "zbjl-mask-model-rect-user"
  }, [_c('div', {
    staticClass: "zbjl-mask-model-rect-user-left"
  }, [_c('img', {
    staticClass: "zbjl-mask-model-rect-user-left-img",
    attrs: {
      "src": _vm.data.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbjl-mask-model-rect-user-content"
  }, [_c('span', {
    staticClass: "zbjl-mask-model-rect-user-content-span"
  }, [_vm._v(_vm._s(_vm.data.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "zbjl-mask-model-rect-user-content-span1"
  }, [_vm._v("ID：" + _vm._s(_vm.data.recodeCode))])])]), _vm._v(" "), _c('img', {
    staticClass: "zbjl-mask-model-rect-user-img",
    attrs: {
      "src": __webpack_require__(18),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleCloseZbjl
    }
  })]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "zbjl-mask-model-rect-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "zbjl-mask-model-rect-list-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('zbjlItem', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "tc-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model-top"
  }, [_c('div', {
    staticClass: "tc-box-model-top-div"
  }), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-top-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tishi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), (_vm.data == 1) ? _c('div', {
    staticClass: "tc-box-model-center"
  }, [_vm._v(_vm._s(_vm.$t('all.quedingtuichudengluma')))]) : _vm._e(), _vm._v(" "), (_vm.data == 1) ? _c('div', {
    staticClass: "tc-box-model-bottom",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))]) : _vm._e(), _vm._v(" "), (_vm.data == 0) ? _c('div', {
    staticClass: "tc-box-model-center"
  }, [_vm._v(_vm._s(_vm.$t('all.quedingqudengluma')))]) : _vm._e(), _vm._v(" "), (_vm.data == 0) ? _c('div', {
    staticClass: "tc-box-model-bottom",
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "sz-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "sz-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "sz-box-model-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shezhi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sz-box-model-container"
  }, [_c('div', {
    staticClass: "sz-box-model-container-left"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('div', {
      key: index,
      class: index === _vm.navListIndex ? 'sz-box-model-container-left-item' : 'sz-box-model-container-left-item1',
      on: {
        "click": function($event) {
          return _vm.handleNav(index)
        }
      }
    }, [_c('img', {
      staticClass: "sz-box-model-container-left-item-img",
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sz-box-model-container-left-item-span"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sz-box-model-container-right"
  }, [(_vm.navListIndex == 0) ? _c('div', {
    staticClass: "sz-box-model-container-right-box"
  }, [_c('div', {
    staticClass: "sz-title"
  }, [_vm._v(_vm._s(_vm.$t('all.yuyanxuanze')))]), _vm._v(" "), _c('div', {
    staticClass: "sz-yyxz-list"
  }, _vm._l((_vm.yyList), function(item, index) {
    return _c('div', {
      class: index === _vm.yyListIndex ? 'sz-yyxz-list-item' : 'sz-yyxz-list-item1',
      on: {
        "click": function($event) {
          return _vm.handleChooseYy(index, item.language)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 1) ? _c('div', {
    staticClass: "sz-box-model-container-right-box"
  }, [_c('div', {
    staticClass: "sz-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xiugaimima')))]), _vm._v(" "), _c('div', {
    staticClass: "sz-xgmm"
  }, [_c('div', {
    staticClass: "box-input"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(201),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isOldPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.oldPassword),
      expression: "form.oldPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "text",
      "placeholder": _vm.$t('all.qingshurujiumima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "oldPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOldPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.oldPassword),
      expression: "form.oldPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('all.qingshurujiumima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "oldPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOldPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(107),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isOldPassword = !_vm.isOldPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isOldPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(108),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isOldPassword = !_vm.isOldPassword
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-input"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(201),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruxinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('all.qingshuruxinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(107),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPassword = !_vm.isPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(108),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPassword = !_vm.isPassword
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sz-xgmm-des"
  }, [_vm._v(_vm._s(_vm.$t('all.mimashuoming')))]), _vm._v(" "), _c('div', {
    staticClass: "sz-xgmm-btn",
    on: {
      "click": _vm.updatePassWord
    }
  }, [_vm._v(_vm._s(_vm.$t('all.quedingxiugai')))])])]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 2) ? _c('div', {
    staticClass: "sz-box-model-container-right-box"
  }, [_c('div', {
    staticClass: "sz-title"
  }, [_vm._v(_vm._s(_vm.$t('all.yinsizhengce')))]), _vm._v(" "), _c('div', {
    staticClass: "sz-yszc"
  }, [_vm._v(_vm._s(_vm.data))])]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 3) ? _c('div', {
    staticClass: "sz-box-model-container-right-box"
  }, [_c('div', {
    staticClass: "sz-title"
  }, [_vm._v(_vm._s(_vm.$t('all.guanyuwomen')))]), _vm._v("\n\t\t\t\t\t<"), _vm._m(0)]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sz-gywm"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": __webpack_require__(883),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sqjl-box"
  }, [_c('div', {
    staticClass: "sqjl-top"
  }, [_c('div', {
    staticClass: "sqjl-tabs"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.tabIndex === index ? 'sqjl-tab-active' : 'sqjl-tab',
      on: {
        "click": function($event) {
          return _vm.handleTabChange(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sqjl-table"
  }, [_c('div', {
    staticClass: "sqjl-table-header"
  }, [_c('span', {
    staticClass: "sqjl-table-col sqjl-col"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingriqi')))]), _vm._v(" "), _c('span', {
    staticClass: "sqjl-table-col sqjl-col"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboshijianduan')))]), _vm._v(" "), _c('span', {
    staticClass: "sqjl-table-col sqjl-col"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboleixing')))]), _vm._v(" "), _c('span', {
    staticClass: "sqjl-table-col sqjl-col"
  }, [_vm._v(_vm._s(_vm.$t('all.daihuo')))]), _vm._v(" "), _c('span', {
    staticClass: "sqjl-table-col sqjl-col"
  }, [_vm._v("UNImall【" + _vm._s(_vm.$t('all.zhanghaoid')) + "】")]), _vm._v(" "), _c('span', {
    staticClass: "sqjl-table-col sqjl-col"
  }, [_vm._v(_vm._s(_vm.$t('all.beizhu')))]), _vm._v(" "), _c('span', {
    staticClass: "sqjl-table-col sqjl-col"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuangtai')))])]), _vm._v(" "), (_vm.filteredList.length > 0) ? _c('div', {
    ref: "tableBody",
    staticClass: "sqjl-table-body"
  }, _vm._l((_vm.filteredList), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "sqjl-table-row"
    }, [_c('span', {
      staticClass: "sqjl-table-col sqjl-col"
    }, [_vm._v(_vm._s(item.applyDate || item.liveDate || ''))]), _vm._v(" "), _c('span', {
      staticClass: "sqjl-table-col sqjl-col"
    }, [_vm._v(_vm._s(item.timeSlot || item.liveTime || ''))]), _vm._v(" "), _c('span', {
      staticClass: "sqjl-table-col sqjl-col"
    }, [_vm._v(_vm._s(item.liveType === 1 ? _vm.$t('all.shoujizhibo') : 'OBS' + _vm.$t('all.zhibo')))]), _vm._v(" "), _c('span', {
      staticClass: "sqjl-table-col sqjl-col",
      class: item.isGoods === 1 ? '' : 'sqjl-text-red'
    }, [_vm._v(_vm._s(item.isGoods === 1 ? _vm.$t('all.kaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('span', {
      staticClass: "sqjl-table-col sqjl-col"
    }, [_vm._v(_vm._s(item.businessAccount || item.accountId || '/'))]), _vm._v(" "), _c('span', {
      staticClass: "sqjl-table-col sqjl-col"
    }, [_vm._v(_vm._s(item.submitMsg))]), _vm._v(" "), _c('span', {
      staticClass: "sqjl-table-col sqjl-col"
    }, [_c('div', {
      staticClass: "sqjl-status-wrap"
    }, [_c('span', {
      class: _vm.getStatusClass(item.status)
    }, [_vm._v(_vm._s(_vm.getStatusText(item.status)))]), _vm._v(" "), _c('span', {
      staticClass: "sqjl-detail",
      on: {
        "click": function($event) {
          return _vm.handleDetail(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.xiangqing')))]), _vm._v(" "), (item.status === 2 && item.rejectionMsg) ? _c('span', {
      staticClass: "sqjl-reason"
    }, [_vm._v(_vm._s(_vm.$t('all.yuanyin')) + "：" + _vm._s(item.rejectionMsg))]) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.loaded && _vm.filteredList.length === 0) ? _c('div', {
    staticClass: "sqjl-table-empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('all.zanwushuju')) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.showDetail) ? _c('div', {
    staticClass: "sqxq-overlay",
    on: {
      "click": function($event) {
        _vm.showDetail = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDetail) ? _c('div', {
    staticClass: "sqxq-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "sqxq-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingxiangqing')))]), _vm._v(" "), _c('div', {
    staticClass: "sqxq-info-card"
  }, [_c('div', {
    staticClass: "sqxq-info-card-left"
  }, [_c('span', {
    staticClass: "sqxq-info-card-date"
  }, [_vm._v(_vm._s(_vm.detailData.liveDate) + " " + _vm._s(_vm.detailData.liveTime))]), _vm._v(" "), (_vm.detailData.status !== 2) ? _c('span', {
    staticClass: "sqxq-info-card-desc"
  }, [_vm._v("\n\t\t\t\t  " + _vm._s(_vm.detailData.liveType === 1 ? _vm.$t('all.shoujizhibo') : 'OBS' + _vm.$t('all.zhibo')) + "\n\t\t\t\t  "), (_vm.detailData.businessAccount) ? _c('span', [_vm._v("| " + _vm._s(_vm.$t('all.daihuo')) + "：" + _vm._s(_vm.detailData.businessAccount))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.detailData.status === 2) ? _c('span', {
    staticClass: "sqxq-info-card-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.yuanyin')) + "：" + _vm._s(_vm.detailData.rejectionMsg))]) : _vm._e()]), _vm._v(" "), _c('span', {
    class: _vm.getDetailStatusClass(_vm.detailData.status)
  }, [_vm._v(_vm._s(_vm.getStatusText(_vm.detailData.status)))])]), _vm._v(" "), (_vm.detailData.status === 2) ? _c('div', {
    staticClass: "sqxq-reason-card"
  }, [_c('div', {
    staticClass: "sqxq-reason-card-header"
  }, [_c('span', {
    staticClass: "sqxq-reason-card-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shenheyuanyin')))]), _vm._v(" "), _c('span', {
    staticClass: "sqxq-reason-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.xutiaozheng')))])]), _vm._v(" "), _c('span', {
    staticClass: "sqxq-reason-text"
  }, [_vm._v(_vm._s(_vm.detailData.rejectionMsg))])]) : _vm._e(), _vm._v(" "), (_vm.detailData.status !== 2) ? _c('div', {
    staticClass: "sqxq-steps"
  }, _vm._l((_vm.detailSteps), function(step, idx) {
    return _c('div', {
      key: idx,
      staticClass: "sqxq-step"
    }, [_c('div', {
      staticClass: "sqxq-step-left"
    }, [_c('div', {
      class: _vm.getStepDotClass(step)
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), (idx < _vm.detailSteps.length - 1) ? _c('div', {
      staticClass: "sqxq-step-line"
    }) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "sqxq-step-name"
    }, [_vm._v(_vm._s(step.name))]), _vm._v(" "), _c('span', {
      class: step.done ? 'sqxq-step-status-done' : (step.current ? 'sqxq-step-status-current' : 'sqxq-step-status')
    }, [_vm._v(_vm._s(step.statusText))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.detailData.status === 2) ? _c('div', {
    staticClass: "sqxq-steps"
  }, [_c('div', {
    staticClass: "sqxq-step"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "sqxq-step-name"
  }, [_vm._v(_vm._s(_vm.$t('all.tijiaoshenqing')))]), _vm._v(" "), _c('span', {
    staticClass: "sqxq-step-status-done"
  }, [_vm._v(_vm._s(_vm.$t('all.wancheng')))])]), _vm._v(" "), _c('div', {
    staticClass: "sqxq-step"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "sqxq-step-name"
  }, [_vm._v(_vm._s(_vm.$t('all.houtaishenhe')))]), _vm._v(" "), _c('span', {
    staticClass: "sqxq-step-status-reject"
  }, [_vm._v(_vm._s(_vm.$t('all.weitongguo')))])])]) : _vm._e(), _vm._v(" "), (_vm.detailData.status !== 2) ? _c('div', {
    staticClass: "sqxq-remark-card"
  }, [_c('div', {
    staticClass: "sqxq-remark-card-header"
  }, [_c('span', {
    staticClass: "sqxq-remark-card-title"
  }, [_vm._v(_vm._s(_vm.$t('all.beizhu')))]), _vm._v(" "), _c('span', {
    staticClass: "sqxq-remark-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.kechakan')))])]), _vm._v(" "), _c('span', {
    staticClass: "sqxq-remark-text"
  }, [_vm._v(_vm._s(_vm.$t('all.huodongzhuti')) + "：" + _vm._s(_vm.detailData.submitMsg || _vm.detailData.remark || _vm.$t('all.jinwanxinpinfuli')))])]) : _vm._e(), _vm._v(" "), (_vm.detailData.status === 0) ? _c('div', {
    staticClass: "sqxq-btn",
    on: {
      "click": _vm.handleRevoke
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chehuishenqing')))]) : _vm._e(), _vm._v(" "), (_vm.detailData.status === 1 && _vm.detailData.keyReady) ? _c('div', {
    staticClass: "sqxq-btn sqxq-btn-gradient",
    on: {
      "click": _vm.handleGoKey
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojinyao')))]) : _vm._e(), _vm._v(" "), (_vm.detailData.status === 2) ? _c('div', {
    staticClass: "sqxq-btn sqxq-btn-gradient",
    on: {
      "click": _vm.handleReapply
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongxinshenqing')))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sqxq-step-left"
  }, [_c('div', {
    staticClass: "sqxq-step-dot-done"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "sqxq-step-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sqxq-step-left"
  }, [_c('div', {
    staticClass: "sqxq-step-dot-done"
  }, [_vm._v("2")])])
}]}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbjy-box"
  }, [(_vm.data) ? _c('div', {
    staticClass: "zbjy-content"
  }, [_c('div', {
    staticClass: "zbjy-info-card"
  }, [_c('div', {
    staticClass: "zbjy-info-left"
  }, [_c('span', {
    staticClass: "zbjy-info-room"
  }, [_vm._v(_vm._s(_vm.data.liveName))]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-info-time"
  }, [_vm._v(_vm._s(_vm.$t('all.keyongshiduan')) + "：" + _vm._s(_vm.data.liveDate) + " " + _vm._s(_vm.data.liveTime))])]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-info-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiao')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-type-row"
  }, [_c('div', {
    class: _vm.data.liveType === 1 ? 'zbjy-type-active' : 'zbjy-type'
  }, [_vm._v(_vm._s(_vm.$t('all.shoujizhibo')))]), _vm._v(" "), _c('div', {
    class: _vm.data.liveType === 2 ? 'zbjy-type-active' : 'zbjy-type'
  }, [_vm._v("OBS" + _vm._s(_vm.$t('all.zhibo')))])]), _vm._v(" "), (_vm.data.liveType === 2) ? _c('div', {
    staticClass: "zbjy-item"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tuiliudizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-item-right"
  }, [_c('span', {
    staticClass: "zbjy-item-value zbjy-text-green zbjy-text-wrap"
  }, [_vm._v(_vm._s(_vm.data.obsUrl))]), _vm._v(" "), _c('img', {
    staticClass: "zbjy-item-right-fuzhi",
    attrs: {
      "src": __webpack_require__(89),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.data.obsUrl)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.liveType === 2) ? _c('div', {
    staticClass: "zbjy-item"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tuiliumamiyao')))]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-item-right"
  }, [_c('span', {
    staticClass: "zbjy-item-value zbjy-text-green zbjy-text-wrap"
  }, [_vm._v(_vm._s(_vm.data.obsCode))]), _vm._v(" "), _c('img', {
    staticClass: "zbjy-item-right-fuzhi",
    attrs: {
      "src": __webpack_require__(89),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.data.obsCode)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbjy-item"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojinyao')))]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-item-right"
  }, [_c('span', {
    staticClass: "zbjy-item-value zbjy-text-green zbjy-text-wrap"
  }, [_vm._v(_vm._s(_vm.data.startKey))]), _vm._v(" "), _c('img', {
    staticClass: "zbjy-item-right-fuzhi",
    attrs: {
      "src": __webpack_require__(89),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.data.startKey)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-item2 zbjy-item-mail"
  }, [_c('div', {
    staticClass: "zbjy-item-mail-left"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youjiankuaidi')))]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-info-tag zbjy-info-tag-click",
    on: {
      "click": _vm.handleGoMail
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yifasong')))])]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-item-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.data.emailInfo.content.replace(/\n/g, '<br>'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-btn",
    on: {
      "click": _vm.handleCopyAll
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhiquanbu')))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showToast) ? _c('div', {
    staticClass: "zbjy-toast"
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhichenggong')))]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zb-box"
  }, [_c('div', {
    staticClass: "zb-box-left"
  }, [_c('tengxunyunzb', {
    ref: "txyzb"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right"
  }, [_c('div', {
    staticClass: "zb-box-right-top"
  }, [_c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoti')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.geinidezhibojianqugemingziba')
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbeijing')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bj"
  }, [(!_vm.form.backgroundUrl) ? _c('img', {
    staticClass: "zb-box-right-bj-img",
    attrs: {
      "src": __webpack_require__(308),
      "alt": "添加图片"
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.backgroundUrl) ? _c('img', {
    staticClass: "zb-box-right-bj-img",
    attrs: {
      "src": _vm.form.backgroundUrl,
      "alt": ""
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoqian')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bq"
  }, _vm._l((_vm.bqList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.bqListIndex === index ? 'zb-box-right-bq-item' : 'zb-box-right-bq-item1',
      on: {
        "click": function($event) {
          return _vm.handleBq(index)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianhuazhi')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bq"
  }, _vm._l((_vm.hzList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.hzListIndex === index ? 'zb-box-right-bq-item' : 'zb-box-right-bq-item1',
      on: {
        "click": function($event) {
          return _vm.handleHz(index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.startKey),
      expression: "form.startKey"
    }],
    attrs: {
      "placeholder": _vm.$t('all.qingshurukaibomiyao'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.startKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "startKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bottom-btn",
    on: {
      "click": _vm.startLive
    }
  }, [_vm._v(_vm._s(_vm.$t('all.kaishizhibo')))])])])])
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lsjl-box"
  }, [_c('div', {
    staticClass: "lsjl-top"
  }, [_c('div', {
    staticClass: "lsjl-tabs"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.tabIndex === index ? 'lsjl-tab-active' : 'lsjl-tab',
      on: {
        "click": function($event) {
          return _vm.handleTabChange(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "lsjl-date"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "start-placeholder": _vm.$t('all.kaishiriqi'),
      "end-placeholder": _vm.$t('all.jieshuriqi'),
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.handleDateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lsjl-table"
  }, [_c('div', {
    staticClass: "lsjl-table-header"
  }, [_c('span', {
    staticClass: "lsjl-table-col lsjl-col-date"
  }, [_vm._v(_vm._s(_vm.$t('all.riqi')))]), _vm._v(" "), _c('span', {
    staticClass: "lsjl-table-col lsjl-col-type"
  }, [_vm._v(_vm._s(_vm.$t('all.leixing')))]), _vm._v(" "), _c('span', {
    staticClass: "lsjl-table-col lsjl-col-type"
  }, [_vm._v(_vm._s(_vm.$t('all.miaoshu')))]), _vm._v(" "), _c('span', {
    staticClass: "lsjl-table-col lsjl-col-amount"
  }, [_vm._v(_vm._s(_vm.$t('all.jine')))])]), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    ref: "listContainer",
    staticClass: "lsjl-table-body",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "lsjl-table-row",
      class: {
        'lsjl-table-row--clickable': _vm.isRowClickable(item)
      },
      on: {
        "click": function($event) {
          return _vm.handleRowClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "lsjl-table-col lsjl-col-date"
    }, [_vm._v(_vm._s(item.createTime))]), _vm._v(" "), _c('span', {
      staticClass: "lsjl-table-col lsjl-col-type"
    }, [_vm._v(_vm._s(item.billTypeName))]), _vm._v(" "), _c('span', {
      staticClass: "lsjl-table-col lsjl-col-type"
    }, [_vm._v(_vm._s(item.billDesc))]), _vm._v(" "), _c('span', {
      staticClass: "lsjl-table-col lsjl-col-amount",
      class: item.amount > 0 ? 'lsjl-amount-green' : 'lsjl-amount-red'
    }, [_vm._v("\n            " + _vm._s(item.amount > 0 ? '+' : '') + _vm._s(item.amount) + " " + _vm._s(item.currencyName) + "\n          ")])])
  }), 0) : _c('div', {
    staticClass: "lsjl-table-empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('all.zanwushuju')) + "\n      ")])]), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "lsjl-overlay",
    on: {
      "click": function($event) {
        _vm.showAddressModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "lsjl-addr-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "lsjl-addr-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showAddressModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lsjl-addr-title"
  }, [_vm._v(_vm._s(_vm.addressModalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "lsjl-addr-card"
  }, [_c('span', {
    staticClass: "lsjl-addr-label"
  }, [_vm._v(_vm._s(_vm.addressModalLabel))]), _vm._v(" "), _c('div', {
    staticClass: "lsjl-addr-right"
  }, [_c('span', {
    staticClass: "lsjl-addr-value",
    attrs: {
      "title": _vm.detailAddress
    }
  }, [_vm._v(_vm._s(_vm.detailAddress))]), _vm._v(" "), _c('img', {
    staticClass: "lsjl-addr-copy",
    attrs: {
      "src": __webpack_require__(89),
      "alt": ""
    },
    on: {
      "click": _vm.copyDetailAddress
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showRejectionModal) ? _c('div', {
    staticClass: "lsjl-overlay",
    on: {
      "click": function($event) {
        _vm.showRejectionModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRejectionModal) ? _c('div', {
    staticClass: "lsjl-rejection-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "lsjl-rejection-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showRejectionModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lsjl-result-head"
  }, [_c('img', {
    staticClass: "lsjl-result-icon",
    attrs: {
      "src": __webpack_require__(872),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lsjl-result-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tibibeibohui')))])]), _vm._v(" "), _c('div', {
    staticClass: "lsjl-info-card"
  }, [_c('span', {
    staticClass: "lsjl-info-card-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuangtai')))]), _vm._v(" "), _c('span', {
    staticClass: "lsjl-info-card-value"
  }, [_vm._v(_vm._s(_vm.rejectionItem.withdrawalStatusName || _vm.$t('all.shenhejujue')))])]), _vm._v(" "), _c('div', {
    staticClass: "lsjl-reason-card"
  }, [_c('span', {
    staticClass: "lsjl-reason-label"
  }, [_vm._v(_vm._s(_vm.$t('all.bohuiyuanyin')) + _vm._s(_vm.getRejectionMsg(_vm.rejectionItem)))])]), _vm._v(" "), _c('div', {
    staticClass: "lsjl-rejection-btn",
    on: {
      "click": function($event) {
        _vm.showRejectionModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhidaole')))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "volume-control-container"
  }, [(_vm.volume > 0) ? _c('img', {
    staticClass: "volume-control-container-img",
    attrs: {
      "src": __webpack_require__(138),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSetVol(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.volume == 0) ? _c('img', {
    staticClass: "volume-control-container-img",
    attrs: {
      "src": __webpack_require__(137),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSetVol(100)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "volume-slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100",
      "aria-label": "Volume Level"
    },
    domProps: {
      "value": _vm.volume
    },
    on: {
      "input": _vm.handleVolumeChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "volume-control-container-span"
  }, [_vm._v(_vm._s(_vm.volume))])])
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dm-box"
  }, [_c('div', {
    staticClass: "inRoomUser-box-div"
  }, _vm._l((_vm.inUserList), function(item, index) {
    return _c('div', {
      key: ("user-" + index),
      staticClass: "inRoomUser-box dm-slide-in",
      style: ({
        zIndex: 10 - index
      })
    }, [_c('span', {
      staticClass: "inRoomUser-box-text"
    }, [_vm._v(_vm._s(item.name) + "：")]), _vm._v(" "), _c('span', {
      staticClass: "inRoomUser-box-text1"
    }, [_vm._v(_vm._s(_vm.$t('all.jinrulezhibojian')))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dm-box-container"
  }, [_c('div', {
    ref: "danmuContainer",
    staticClass: "dm-box-container-list"
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dm-box-container-list-item"
    }, [_c('div', {
      staticClass: "dm-box-container-list-item-box",
      on: {
        "click": function($event) {
          return _vm.handleShowUser(item)
        }
      }
    }, [_c('div', {
      staticClass: "dm-content-wrapper"
    }, [(item.sendUserInfo) ? _c('span', {
      staticClass: "dm-box-container-list-item-text1"
    }, [_vm._v(_vm._s(item.sendUserInfo.nickName) + "：")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "dm-content-text"
    }, [(item.type == -1) ? [_c('img', {
      staticClass: "xiaolapa",
      attrs: {
        "src": __webpack_require__(311),
        "alt": ""
      }
    })] : _vm._e(), _vm._v(" "), (!item.sendUserInfo) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text"
    }, [_vm._v(_vm._s(item.title))])] : _vm._e(), _vm._v(" "), (item.type == 3) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text2"
    }, [_vm._v(_vm._s(item.title))])] : _vm._e(), _vm._v(" "), (item.type == 1) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text3"
    }, [_vm._v(_vm._s(item.title))])] : _vm._e(), _vm._v(" "), (item.type == 12) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text2"
    }, [_vm._v(_vm._s(_vm.$t('all.songgei')) + _vm._s(item.toUserInfo.nickName) + _vm._s(item.giftInfo.content))]), _vm._v(" "), _c('img', {
      staticClass: "danmaku-body-item-box-img",
      attrs: {
        "src": item.giftInfo.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dm-box-container-list-item-text2"
    }, [_vm._v("×" + _vm._s(item.num))])] : _vm._e()], 2)])])])
  }), 0), _vm._v(" "), (_vm.show_kjdy && _vm.kjdyList.length > 0) ? _c('div', {
    staticClass: "dm-box-kjdy"
  }, [_vm._l((_vm.kjdyList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dm-box-kjdy-item",
      on: {
        "click": function($event) {
          return _vm.handleFsKjdy(item.content)
        }
      }
    }, [_vm._v(_vm._s(item.content))])
  }), _vm._v(" "), _c('img', {
    staticClass: "closeKjdy",
    attrs: {
      "src": __webpack_require__(110),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show_kjdy = false
      }
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dm-box-textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.content),
      expression: "form.content"
    }],
    attrs: {
      "placeholder": _vm.$t('all.shuodianshenmene'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.content)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnter.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "content", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-box"
  }, [(_vm.show_user) ? _c('div', {
    staticClass: "user-mask"
  }) : _vm._e(), _vm._v(" "), (_vm.show_user) ? _c('div', {
    staticClass: "user-mask-model",
    on: {
      "click": function($event) {
        _vm.show_user = false
      }
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "user-mask-model-rect",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "user-mask-model-rect-user"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-user-left"
  }, [_c('img', {
    staticClass: "user-mask-model-rect-user-left-img",
    attrs: {
      "src": _vm.data.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-user-content"
  }, [_c('span', {
    staticClass: "user-mask-model-rect-user-content-span"
  }, [_vm._v(_vm._s(_vm.data.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "user-mask-model-rect-user-content-span1"
  }, [_vm._v("ID：" + _vm._s(_vm.data.recodeCode))])])]), _vm._v(" "), _c('img', {
    staticClass: "user-mask-model-rect-user-img",
    attrs: {
      "src": __webpack_require__(18),
      "alt": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.show_user = false
      }
    }
  })]), _vm._v(" "), (_vm.isAdmin == 1) ? _c('div', {
    staticClass: "user-mask-model-rect-btn"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.addAdmin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tianjiaguanliyuan')))]), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-btn-xian"
  }), _vm._v(" "), (_vm.data && _vm.data.subjoinParameter && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isBannedToPost == 0) ? _c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.bannedToPostUser
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jinyan')))]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.subjoinParameter && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo && _vm.data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isBannedToPost == 1) ? _c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.relieveBannedToPostUser
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jiechuejinyan')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-btn-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-btn-item",
    on: {
      "click": _vm.kickOutChatRoom
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tichufangjian')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "user-mask-model-rect-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "user-mask-model-rect-list-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('zbjlItem', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lwdh-box"
  }, _vm._l((_vm.inLwList), function(item, index) {
    return _c('div', {
      key: ("lw-" + index),
      staticClass: "inRoomLiwu-box lwdh-slide-in",
      style: ({
        zIndex: 10 - index
      })
    }, [_c('div', {
      staticClass: "inRoomLiwu-box-left"
    }, [_c('img', {
      attrs: {
        "src": item.details.sendUserInfo.headPortrait
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-left-content"
    }, [_c('span', {
      staticClass: "inRoomLiwu-box-left-content-span"
    }, [_vm._v(_vm._s(item.details.sendUserInfo.nickName) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-left-content-div"
    }, [_c('span', {
      staticClass: "inRoomLiwu-box-left-content-div-span"
    }, [_vm._v(_vm._s(_vm.$t('all.songgei')))]), _vm._v(" "), _c('span', {
      staticClass: "inRoomLiwu-box-left-content-div-span1"
    }, [_vm._v(_vm._s(item.details.toUserInfo.nickName))])])])]), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-right"
    }, [_c('img', {
      staticClass: "inRoomLiwu-box-right-img",
      attrs: {
        "src": item.details.giftInfo.imgUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-right-num"
    }, [_c('span', {
      staticClass: "inRoomLiwu-box-right-num-span"
    }, [_vm._v("×")]), _vm._v(" "), _c('span', {
      staticClass: "inRoomLiwu-box-right-num-span1"
    }, [_vm._v(_vm._s(item.details.num))])])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lx-box",
    style: ({
      width: _vm.screenWidth + 'px'
    })
  }, [_c('popup', {
    attrs: {
      "show": _vm.showPopup,
      "x": _vm.popupPosition.x,
      "y": _vm.popupPosition.y
    },
    on: {
      "mouseenter": _vm.handlePopupMouseEnter,
      "mouseleave": _vm.handlePopupMouseLeave,
      "giveGif": _vm.handleGiveGif
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lx-box-list",
    on: {
      "mouseleave": _vm.handleListMouseLeave
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      class: index === _vm.listIndex ? 'lx-box-list-item' : 'lx-box-list-item1',
      on: {
        "mouseenter": function($event) {
          return _vm.handleChoose(index, $event)
        }
      }
    }, [_c('img', {
      ref: "giftImages",
      refInFor: true,
      staticClass: "lx-box-list-item-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), (index != _vm.listIndex) ? _c('div', {
      staticClass: "lx-box-list-item-span"
    }, [_vm._v(_vm._s(item.giftName))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "lx-box-list-item-span1"
    }, [_vm._v(_vm._s(item.price) + "US" + _vm._s(_vm.$t('all.bi')))]), _vm._v(" "), (index == _vm.listIndex) ? _c('div', {
      staticClass: "lx-box-list-item-zs",
      on: {
        "click": _vm.giveGift
      }
    }, [_vm._v(_vm._s(_vm.$t('all.zengsong')))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "lx-box-gengduo",
    on: {
      "click": _vm.handleShowGdlw
    }
  }, [_c('img', {
    staticClass: "lx-box-gengduo-img",
    attrs: {
      "src": __webpack_require__(917),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lx-box-gengduo-div"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.gengduo')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(878),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lx-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "lx-box-jinbi"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(906),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.virtualBalance))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-mask-model-rect-list-item"
  }, [_c('img', {
    staticClass: "user-mask-model-rect-list-item-img",
    attrs: {
      "src": _vm.data.backgroundUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-list-item-content"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-list-item-content-name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-list-item-content-fl"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-list-item-content-fl-left"
  }, [_vm._v(_vm._s(_vm.data.categoryName))]), _vm._v(" "), (_vm.data.isOpenReplay == 1 && _vm.data.replayUrl) ? _c('div', {
    staticClass: "user-mask-model-rect-list-item-content-fl-right",
    on: {
      "click": function($event) {
        return _vm.handlePlayVideo(_vm.data.replayUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(202),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.huifang')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-list-item-content-time"
  }, [_vm._v(_vm._s(_vm.data.liveStartTime) + "-" + _vm._s(_vm.data.liveEndTime))])])])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzbzhubo-wrapper"
  }, [(_vm.userInfo.cameraStatus !== 0) ? _c('div', {
    staticClass: "xtzbzhubo-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.videoContainerId
    }
  }) : _c('div', {
    staticClass: "xtzbzhubo-bg"
  }, [_c('img', {
    staticClass: "xtzbzhubo-bg-img",
    attrs: {
      "src": _vm.userInfo.userInfo && _vm.userInfo.userInfo.headPortrait,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzb-item-user"
  }, [_c('span', {
    staticClass: "xtzb-item-user-sort"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-item-user-name"
  }, [_vm._v("主播")])])
}]}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbzx-box"
  }, [_c('div', {
    staticClass: "zbzx-box-container"
  }, [_c('div', {
    staticClass: "zbzx-top"
  }, [_c('div', {
    staticClass: "zbzx-top-item",
    on: {
      "click": function($event) {
        return _vm.handleShenqingZhibo(true)
      }
    }
  }, [_c('span', {
    staticClass: "zbzx-top-item-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingzhibo')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbzx-top-item",
    on: {
      "click": _vm.handleShenqingJilu
    }
  }, [_c('span', {
    staticClass: "zbzx-top-item-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingjilu')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbzx-top-item",
    on: {
      "click": _vm.handleHuifangJilu
    }
  }, [_c('span', {
    staticClass: "zbzx-top-item-text"
  }, [_vm._v(_vm._s(_vm.$t('all.huifangjilu')))])])]), _vm._v(" "), _c('div', {
    staticClass: "zbzx-title"
  }, [_c('div', {
    staticClass: "zbzx-title-box"
  }, [_c('span', {
    staticClass: "zbzx-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('span', {
    staticClass: "zbzx-title-span1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "zbzx-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('zbList', {
      key: index,
      attrs: {
        "data": item,
        "type": 1
      },
      on: {
        "delete": _vm.handleListDelete
      }
    })
  }), 1), _vm._v(" "), (!_vm.isLoading && _vm.loaded && _vm.list.length === 0) ? _c('div', {
    staticClass: "zbzx-kong"
  }, [_c('kong')], 1) : _vm._e()]), _vm._v(" "), (_vm.showSqModal) ? _c('div', {
    staticClass: "sq-overlay",
    on: {
      "click": function($event) {
        _vm.showSqModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSqModal) ? _c('div', {
    staticClass: "sq-modal-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "sq-modal"
  }, [_c('div', {
    staticClass: "sq-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingzhibo')))]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-row"
  }, [_c('div', {
    staticClass: "sq-modal-field",
    on: {
      "click": _vm.handleShowCalendar
    }
  }, [_c('span', {
    staticClass: "sq-modal-field-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboriqi')))]), _vm._v(" "), _c('span', {
    staticClass: "sq-modal-field-value"
  }, [_vm._v(_vm._s(_vm.sqForm.liveDate || _vm.$t('all.qingxuanze')))]), _vm._v(" "), _c('img', {
    staticClass: "sq-modal-field-icon",
    attrs: {
      "src": __webpack_require__(303),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-field",
    on: {
      "click": _vm.handleShowCalendar
    }
  }, [_c('span', {
    staticClass: "sq-modal-field-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijianshiduan')))]), _vm._v(" "), _c('span', {
    staticClass: "sq-modal-field-value"
  }, [_vm._v(_vm._s(_vm.sqForm.timeSlot || _vm.$t('all.qingxuanze')))]), _vm._v(" "), _c('img', {
    staticClass: "sq-modal-field-icon",
    attrs: {
      "src": __webpack_require__(303),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-row"
  }, [_c('div', {
    class: _vm.sqForm.liveType === 1 ? 'sq-modal-type-active' : 'sq-modal-type',
    on: {
      "click": function($event) {
        _vm.sqForm.liveType = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.shoujizhibo')))]), _vm._v(" "), _c('div', {
    class: _vm.sqForm.liveType === 2 ? 'sq-modal-type-active' : 'sq-modal-type',
    on: {
      "click": function($event) {
        _vm.sqForm.liveType = 2
      }
    }
  }, [_vm._v("OBS" + _vm._s(_vm.$t('all.zhibo')))])]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-item"
  }, [_c('span', {
    staticClass: "sq-modal-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibodaihuo')))]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-item-tag",
    on: {
      "click": function($event) {
        _vm.sqForm.isDaihuo = !_vm.sqForm.isDaihuo
      }
    }
  }, [_vm._v(_vm._s(_vm.sqForm.isDaihuo ? _vm.$t('all.kaiqi') : _vm.$t('all.guanbi')))])]), _vm._v(" "), (_vm.sqForm.isDaihuo) ? _c('div', {
    staticClass: "sq-modal-item"
  }, [_c('span', {
    staticClass: "sq-modal-item-label"
  }, [_vm._v("UNImall【" + _vm._s(_vm.$t('all.zhanghaoid')) + "】")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sqForm.accountId),
      expression: "sqForm.accountId"
    }],
    staticClass: "sq-modal-item-input",
    attrs: {
      "placeholder": _vm.$t('all.qingtianxie')
    },
    domProps: {
      "value": (_vm.sqForm.accountId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sqForm, "accountId", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-item sq-modal-item-beizhu"
  }, [_c('span', {
    staticClass: "sq-modal-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.beizhu')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sqForm.remark),
      expression: "sqForm.remark"
    }],
    staticClass: "sq-modal-item-input",
    attrs: {
      "placeholder": _vm.$t('all.huodongzhuti')
    },
    domProps: {
      "value": (_vm.sqForm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sqForm, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-item"
  }, [_c('span', {
    staticClass: "sq-modal-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqinghouliucheng')))]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-item-tag sq-modal-item-tag-pending"
  }, [_vm._v(_vm._s(_vm.$t('all.daishenhe')))])]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-item-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqinghouliuchengdesc')))]), _vm._v(" "), _c('div', {
    staticClass: "sq-modal-btn",
    on: {
      "click": _vm.handleSubmitSq
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiaoshenqing')))])]), _vm._v(" "), (_vm.showCalendar) ? _c('div', {
    staticClass: "sq-calendar"
  }, [_c('div', {
    staticClass: "sq-calendar-header"
  }, [_c('img', {
    staticClass: "sq-calendar-arrow",
    attrs: {
      "src": __webpack_require__(886),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMonth(-1)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sq-calendar-month"
  }, [_vm._v(_vm._s(_vm.calendarMonthText))]), _vm._v(" "), _c('img', {
    staticClass: "sq-calendar-arrow",
    attrs: {
      "src": __webpack_require__(885),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMonth(1)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sq-calendar-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.tongshiduanbukezhongfu')))])]), _vm._v(" "), _c('div', {
    staticClass: "sq-calendar-weekdays"
  }, _vm._l((_vm.weekDays), function(d) {
    return _c('span', {
      key: d
    }, [_vm._v(_vm._s(d))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sq-calendar-days"
  }, _vm._l((_vm.calendarDays), function(day, idx) {
    return _c('span', {
      key: idx,
      class: _vm.getDayClass(day),
      on: {
        "click": function($event) {
          return _vm.selectDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.num || ''))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sq-calendar-slots-title"
  }, [_vm._v(_vm._s(_vm.$t('all.keshenqingshiduan')))]), _vm._v(" "), _c('div', {
    staticClass: "sq-calendar-slots"
  }, _vm._l((_vm.timeSlots), function(slot, idx) {
    return _c('div', {
      key: idx,
      class: _vm.selectedSlot === idx ? 'sq-calendar-slot-active' : 'sq-calendar-slot',
      on: {
        "click": function($event) {
          _vm.selectedSlot = idx
        }
      }
    }, [_vm._v(_vm._s(slot))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sq-calendar-confirm",
    on: {
      "click": _vm.confirmDateTime
    }
  }, [_vm._v(_vm._s(_vm.$t('all.querenShiduan')))])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-item"
  }, [_c('div', {
    staticClass: "box-content-item-user"
  }, [_c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('button', {
      key: index,
      class: index === _vm.navListIndex ? 'nav-item' : 'nav-item1',
      on: {
        "click": function($event) {
          return _vm.handleNav(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "user-list"
  }, _vm._l((_vm.userList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box-content-item-user-item"
    }, [_c('div', {
      staticClass: "box-content-item-user-item-left"
    }, [_c('img', {
      staticClass: "box-content-item-user-item-left-img",
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-content-item-user-item-left-content"
    }, [_c('div', {
      staticClass: "box-content-item-user-item-left-content-name"
    }, [(item.isAnchor == 1) ? _c('img', {
      attrs: {
        "src": __webpack_require__(922),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('span', {
      staticClass: "box-content-item-user-item-left-content-span"
    }, [_vm._v("ID:" + _vm._s(item.recodeCode))])])]), _vm._v(" "), _c('div', {
      staticClass: "box-content-item-user-item-box"
    }, [(_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidComment == 0) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn1",
      on: {
        "click": function($event) {
          return _vm.addForbid(item.userId, 3)
        }
      }
    }, [_vm._v("禁止评论")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidComment == 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn",
      on: {
        "click": function($event) {
          return _vm.relieveForbid(item.userId, 3)
        }
      }
    }, [_vm._v("允许评论")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidBuy == 0) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn1",
      on: {
        "click": function($event) {
          return _vm.addForbid(item.userId, 1)
        }
      }
    }, [_vm._v("禁止购买")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidBuy == 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn",
      on: {
        "click": function($event) {
          return _vm.relieveForbid(item.userId, 1)
        }
      }
    }, [_vm._v("允许购买")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn1",
      on: {
        "click": function($event) {
          return _vm.addForbid(item.userId, 2)
        }
      }
    }, [_vm._v("禁止访问")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 1 && item.isAnchor != 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn",
      on: {
        "click": function($event) {
          return _vm.relieveForbid(item.userId, 2)
        }
      }
    }, [_vm._v("允许访问")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-content-container"
  }, [_c('div', {
    staticClass: "box-content-container-title"
  }, [_vm._v("直播大屏")]), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "zhiboxiangqing"
  }, [_c('img', {
    staticClass: "zhiboxiangqing-img",
    attrs: {
      "src": _vm.data.coverUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zhiboxiangqing-span"
  }, [_vm._v(_vm._s(_vm.data.roomName))]), _vm._v(" "), _c('div', {
    staticClass: "zhibozhong"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(326),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.roomStatus === 1 ? '直播中' : '已结束'))])]), _vm._v(" "), _c('span', {
    staticClass: "zhiboxiangqing-span1"
  }, [_vm._v("开播时间：" + _vm._s(_vm.data.beginTime))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-data"
  }, [_c('div', {
    staticClass: "chengjiao"
  }, [_c('span', {
    staticClass: "chengjiao-span"
  }, [_vm._v("直播间成交金额")]), _vm._v(" "), _c('span', {
    staticClass: "chengjiao-span1"
  }, [_vm._v("US" + _vm._s(_vm.liveInData.orderPaySumAmount ? _vm.liveInData.orderPaySumAmount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list"
  }, [_c('div', {
    staticClass: "box-data-list-box"
  }, [_c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("实时在线")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.viewUserNum ? _vm.liveInData.viewUserNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("观看人次")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.viewUserCount ? _vm.liveInData.viewUserCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("新增用户")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.adduserNum ? _vm.liveInData.adduserNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("峰值在线人数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.onlineNum ? _vm.liveInData.onlineNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("评论人数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.commentNum ? _vm.liveInData.commentNum : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-box"
  }, [_c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("点赞次数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.giveCount ? _vm.liveInData.giveCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("总订单数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.orderCount ? _vm.liveInData.orderCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("商品浏览次数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.goodsViewCount ? _vm.liveInData.goodsViewCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("成交观众数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.orderUserNum ? _vm.liveInData.orderUserNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "goods-list"
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "goods-list-item"
    }, [_c('div', {
      staticClass: "goods-list-item-top"
    }, [_c('div', {
      staticClass: "goods-list-item-top-img"
    }, [_c('img', {
      staticClass: "goods-list-item-top-img-img",
      attrs: {
        "src": item.masterImg[0],
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "paixu"
    }, [_vm._v(_vm._s(item.sort))]), _vm._v(" "), (item.isExplain == 1) ? _c('div', {
      staticClass: "jiangjiezhong"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(326),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v("讲解中")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-list-item-top-content"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_c('span', {
      staticClass: "goods-price-span"
    }, [_vm._v("US" + _vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-dingshi"
    }, [(item.taskListedTime) ? _c('span', [_vm._v("定时上架时间:" + _vm._s(item.taskListedTime))]) : _vm._e(), _vm._v(" "), (item.taskShelvesTime) ? _c('span', [_vm._v("定时下架时间:" + _vm._s(item.taskShelvesTime))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-list-item-btn"
    }, [_c('span', {
      staticClass: "goods-price-span1"
    }, [_vm._v("库存：" + _vm._s(item.inventory))]), _vm._v(" "), _c('div', {
      staticClass: "goods-list-item-btn-box"
    }, [_c('button', {
      staticClass: "goods-list-item-btn-btn1",
      on: {
        "click": function($event) {
          return _vm.handleUpdateKc(item)
        }
      }
    }, [_vm._v("库存")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsSort(item.dbRecordId, 0)
        }
      }
    }, [_vm._v("上移")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsSort(item.dbRecordId, 1)
        }
      }
    }, [_vm._v("下移")]), _vm._v(" "), (item.goodsStatus == 2 || item.goodsStatus == 3) ? _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsStatus(item.dbRecordId, 1)
        }
      }
    }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (item.goodsStatus == 1) ? _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsStatus(item.dbRecordId, 2)
        }
      }
    }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), (item.goodsStatus == 1 || item.goodsStatus == 2) ? _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsStatus(item.dbRecordId, 3)
        }
      }
    }, [_vm._v("售罄")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn2",
      on: {
        "click": function($event) {
          return _vm.handleUpdateDssj(item)
        }
      }
    }, [_vm._v("定时上架")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn2",
      on: {
        "click": function($event) {
          return _vm.handleUpdateDsxj(item)
        }
      }
    }, [_vm._v("定时下架")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.handleDelete(item)
        }
      }
    }, [_vm._v("移除")]), _vm._v(" "), (item.isExplain == 0) ? _c('button', {
      staticClass: "goods-list-item-btn-btn1",
      on: {
        "click": function($event) {
          return _vm.updateGoodsExplanationStatus(item.dbRecordId, 1)
        }
      }
    }, [_vm._v("讲解")]) : _vm._e(), _vm._v(" "), (item.isExplain == 1) ? _c('button', {
      staticClass: "goods-list-item-btn-btn1",
      on: {
        "click": function($event) {
          return _vm.updateGoodsExplanationStatus(item.dbRecordId, 0)
        }
      }
    }, [_vm._v("取消")]) : _vm._e()])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-content-video"
  }, [_c('div', {
    staticClass: "video-container"
  }, [_c('img', {
    staticClass: "video-bg-img",
    attrs: {
      "src": _vm.data.coverUrl,
      "alt": "视频背景图"
    }
  }), _vm._v(" "), _c('div', {
    ref: "remoteVideo",
    staticClass: "remote-video",
    attrs: {
      "id": "remote-video"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "danmuContainer",
    staticClass: "danmu"
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "danmaku-body-item"
    }, [_c('el-dropdown', {
      on: {
        "command": _vm.handleCommand
      }
    }, [_c('div', {
      staticClass: "danmaku-body-item-box"
    }, [(item.sendUserInfo && item.sendUserInfo.isAnchor == 1) ? _c('span', {
      staticClass: "guanliyuan"
    }, [_vm._v("管理员")]) : _vm._e(), _vm._v(" "), (item.sendUserInfo) ? _c('span', {
      staticClass: "danmaku-body-item-box-text"
    }, [_vm._v(_vm._s(item.sendUserInfo.nickName) + "：")]) : _vm._e(), _vm._v(" "), (item.sendUserInfo && item.type != 10) ? _c('span', {
      staticClass: "danmaku-body-item-box-text1"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!item.sendUserInfo && item.type != 10) ? _c('span', {
      staticClass: "danmaku-body-item-box-text2"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.sendUserInfo && item.type == 10) ? _c('span', {
      staticClass: "danmaku-body-item-box-text3"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, [_c('el-dropdown-item', {
      attrs: {
        "icon": "el-icon-edit",
        "command": {
          data: item,
          type: 3
        }
      }
    }, [_vm._v("\n\t\t\t\t\t      禁止评论\n\t\t\t\t\t    ")]), _vm._v(" "), _c('el-dropdown-item', {
      attrs: {
        "icon": "el-icon-edit",
        "command": {
          data: item,
          type: 1
        }
      }
    }, [_vm._v("\n\t\t\t\t\t      禁止购买\n\t\t\t\t\t    ")]), _vm._v(" "), _c('el-dropdown-item', {
      attrs: {
        "icon": "el-icon-edit",
        "command": {
          data: item,
          type: 2
        }
      }
    }, [_vm._v("\n\t\t\t\t\t      禁止访问\n\t\t\t\t\t    ")])], 1)], 1)], 1)
  }), 0)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改库存",
      "visible": _vm.openK,
      "width": "600px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.openK = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.formK.specificationList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "规格名称",
      "align": "center",
      "prop": "specificationName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格(元)",
      "align": "center",
      "prop": "price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "align": "center",
      "prop": "inventory"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "请输入库存"
          },
          model: {
            value: (scope.row.inventory),
            callback: function($$v) {
              _vm.$set(scope.row, "inventory", $$v)
            },
            expression: "scope.row.inventory"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitFormK
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.openK = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改定时上架时间",
      "visible": _vm.open2,
      "width": "500px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.open2 = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form2,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "定时上架时间",
      "prop": "time"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 23:59:59'
      },
      "placeholder": "定时上架时间",
      "value-format": "HH:mm:ss"
    },
    model: {
      value: (_vm.form2.time),
      callback: function($$v) {
        _vm.$set(_vm.form2, "time", $$v)
      },
      expression: "form2.time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm2
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.open2 = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改定时下架时间",
      "visible": _vm.open3,
      "width": "500px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.open3 = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form3,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "定时下架时间",
      "prop": "time"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 23:59:59'
      },
      "placeholder": "定时下架时间",
      "value-format": "HH:mm:ss"
    },
    model: {
      value: (_vm.form3.time),
      callback: function($$v) {
        _vm.$set(_vm.form3, "time", $$v)
      },
      expression: "form3.time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm3
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.open3 = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bfsp-box"
  }, [_c('div', {
    staticClass: "bfsp-close",
    on: {
      "click": _vm.handleBack
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "22",
      "height": "22"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 6l12 12M18 6L6 18",
      "stroke": "#FFFFFF",
      "stroke-width": "2.4",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('duanshippin', {
    attrs: {
      "userId": _vm.userId,
      "videoId": _vm.videoId,
      "isHost": _vm.isHost
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "gz-box",
    on: {
      "click": _vm.handleMaskClick
    }
  }, [_c('div', {
    staticClass: "gz-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleModalClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "gz-tabs"
  }, [_c('div', {
    staticClass: "gz-tab",
    class: {
      'gz-tab--active': _vm.currentTab === 0
    },
    on: {
      "click": function($event) {
        return _vm.switchTab(0)
      }
    }
  }, [_c('div', {
    staticClass: "gz-tab-item"
  }, [_c('span', {
    staticClass: "gz-tab-label"
  }, [_vm._v(_vm._s(_vm.$t('all.guanzhong')))]), _vm._v(" "), _c('span', {
    staticClass: "gz-tab-num"
  }, [_vm._v(_vm._s(_vm.followTotal))])]), _vm._v(" "), (_vm.currentTab === 0) ? _c('div', {
    staticClass: "gz-tab-line"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gz-tab",
    class: {
      'gz-tab--active': _vm.currentTab === 1
    },
    on: {
      "click": function($event) {
        return _vm.switchTab(1)
      }
    }
  }, [_c('div', {
    staticClass: "gz-tab-item"
  }, [_c('span', {
    staticClass: "gz-tab-label"
  }, [_vm._v(_vm._s(_vm.$t('all.fensi')))]), _vm._v(" "), _c('span', {
    staticClass: "gz-tab-num"
  }, [_vm._v(_vm._s(_vm.fansTotal))])]), _vm._v(" "), (_vm.currentTab === 1) ? _c('div', {
    staticClass: "gz-tab-line"
  }) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "gz-close",
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClose.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "gz-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gz-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleGoUser(item)
        }
      }
    }, [_c('img', {
      staticClass: "gz-item-avatar",
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gz-item-info"
    }, [_c('span', {
      staticClass: "gz-item-nick"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "gz-item-uid"
    }, [_vm._v("ID " + _vm._s(item.recodeCode || item.userId))])]), _vm._v(" "), (_vm.currentTab === 0) ? _c('div', {
      staticClass: "gz-btn",
      class: item.followHe == 1 ? 'gz-btn--mutual' : 'gz-btn--followed',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFollow(item, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.followHe == 1 ? _vm.$t('all.huguan') : _vm.$t('all.yiguanzhu')) + "\n\t\t\t\t")]) : _c('div', {
      staticClass: "gz-btn",
      class: item.followHe == 1 ? 'gz-btn--mutual' : 'gz-btn--follow',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFollow(item, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.followHe == 1 ? _vm.$t('all.huguan') : _vm.$t('all.guanzhu')) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "gz-more-wrap"
    }, [_c('img', {
      staticClass: "gz-more",
      attrs: {
        "src": __webpack_require__(877),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMenu(index)
        }
      }
    }), _vm._v(" "), (_vm.menuIndex === index) ? _c('div', {
      staticClass: "gz-menu",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelete(item, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.currentTab === 0 ? _vm.$t('all.shanchuguanzhu') : _vm.$t('all.yichufensi')) + "\n\t\t\t\t\t")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loaded && _vm.list.length === 0) ? _c('kong') : _vm._e()], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xitongxiaoxi"
  }, [_c('div', {
    staticClass: "xt-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xitongxiaoxi')))]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "xt-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xt-list-item"
    }, [_c('div', {
      staticClass: "xt-list-item-title"
    }, [_c('div', {
      staticClass: "xt-list-item-title-left"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(310),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xitongxiaoxi')))])]), _vm._v(" "), _c('span', {
      staticClass: "xt-list-item-title-span"
    }, [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('div', {
      staticClass: "xt-list-item-content",
      domProps: {
        "innerHTML": _vm._s(_vm.formatContent(item.content))
      }
    })])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrapper"
  }, [(_vm.isSelf && _vm.mainScreenData && _vm.mainScreenData.cameraStatus !== 0) ? _c('div', {
    staticClass: "mainscreen-self",
    attrs: {
      "id": _vm.selfContainerId
    }
  }) : (_vm.isSelf && (!_vm.mainScreenData || _vm.mainScreenData.cameraStatus === 0)) ? _c('div', {
    staticClass: "mainscreen-bg"
  }, [_c('img', {
    staticClass: "mainscreen-bg-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })]) : (!_vm.isSelf && _vm.mainScreenData && _vm.mainScreenData.cameraStatus !== 0) ? _c('div', {
    staticClass: "mainscreen-pull"
  }, [_c('video', {
    staticClass: "zb-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    staticClass: "mainscreen-video-cover"
  }, [_c('div', {
    staticClass: "mainscreen-video-cover-box"
  }, [_c('img', {
    staticClass: "mainscreen-video-cover-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })])]) : _vm._e()]) : _c('div', {
    staticClass: "mainscreen-bg"
  }, [_c('img', {
    staticClass: "mainscreen-bg-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-box"
  }, [_c('div', {
    staticClass: "app-box-ewm"
  }, [_c('div', {
    staticClass: "app-box-ewm-item"
  }, [_c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [(_vm.androidUrl) ? _c('canvas', {
    ref: "androidCanvas"
  }) : _c('div', {
    staticClass: "app-box-ewm-item-empty"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.weixiazai')))])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.anzhuoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(299),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("GET IN ON")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.anzhuoxiazai')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item"
  }, [_c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [(_vm.iosUrl) ? _c('canvas', {
    ref: "iosCanvas"
  }) : _c('div', {
    staticClass: "app-box-ewm-item-empty"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.weixiazai')))])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.pingguoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(302),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("Download on the")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.pingguoxiazai')))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xy-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xy-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xy-box-model-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.type === 1 ? _vm.$t('all.yonghuxieyi') : _vm.$t('all.yinsixieyi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xy-box-model-container"
  }, [_c('div', {
    staticClass: "xy-yszc"
  }, [_vm._v(_vm._s(_vm.data))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "woyaofankui"
  }, [_c('div', {
    staticClass: "fk-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fankuiwenti')))]), _vm._v(" "), _c('div', {
    staticClass: "fk-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.content),
      expression: "form.content"
    }],
    attrs: {
      "placeholder": _vm.$t('all.qingmiaoshuniyaofankuidewenti'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "content", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fk-box-img"
  }, [_vm._l((_vm.imagesList), function(image, index) {
    return _c('div', {
      key: image.id,
      staticClass: "fk-box-img-item"
    }, [(image.status === 'success') ? _c('img', {
      staticClass: "fk-box-img-item-img1",
      attrs: {
        "src": image.url,
        "alt": "反馈图片"
      }
    }) : (image.status === 'uploading') ? _c('div', {
      staticClass: "uploading-indicator"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shangchuanzhong')) + "...")])]) : _c('div', {
      staticClass: "error-indicator"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shangchuanshibai')))])]), _vm._v(" "), (image.status === 'success') ? _c('img', {
      staticClass: "delImg",
      attrs: {
        "src": __webpack_require__(879),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.delImage(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.imagesList.length < 4) ? _c('img', {
    staticClass: "fk-box-img-img",
    attrs: {
      "src": __webpack_require__(308),
      "alt": "添加图片"
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fk-btn"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.submitFeedbackForm
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])])
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhubo-player"
  }, [(_vm.userInfo && _vm.userInfo.backgroundUrl) ? _c('div', {
    staticClass: "zhubo-cover"
  }, [_c('div', {
    staticClass: "zhubo-cover-box"
  }, [_c('img', {
    staticClass: "zhubo-cover-img",
    attrs: {
      "src": _vm.userInfo.backgroundUrl,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('video', {
    staticClass: "zhubo-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzb-item-user"
  }, [_c('span', {
    staticClass: "xtzb-item-user-sort"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-item-user-name"
  }, [_vm._v("主播")])])
}]}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gly-box"
  }, [_c('div', {
    staticClass: "gly-box-container"
  }, [_c('div', {
    staticClass: "gly-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.guanliyuan')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(18),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gly-box-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gly-box-list-item"
    }, [_c('div', {
      staticClass: "gly-box-list-item-left"
    }, [_c('img', {
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gly-box-list-item-left-content"
    }, [_c('span', {
      staticClass: "gly-box-list-item-left-content-span"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "gly-box-list-item-left-content-span1"
    }, [_vm._v("ID：" + _vm._s(item.recodeCode))])])]), _vm._v(" "), _c('img', {
      staticClass: "gly-box-list-item-img",
      attrs: {
        "src": __webpack_require__(110),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.delAdmin(item.userId)
        }
      }
    })])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "playerContainer",
    staticClass: "tengxunyun"
  }, [_c('video', {
    staticClass: "tengxunyun-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), (_vm.isShowCover && _vm.backgroundUrl) ? _c('div', {
    staticClass: "video-cover"
  }, [_c('div', {
    staticClass: "video-cover-box"
  }, [_c('img', {
    staticClass: "video-cover-box-img",
    attrs: {
      "src": _vm.backgroundUrl,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.userInfo) ? _c('div', {
    staticClass: "zhubo-user"
  }, [_c('span', [_vm._v(_vm._s(_vm.data.userInfo.nickName))]), _vm._v(" "), (_vm.data.isPermitMicrophone == 1) ? _c('img', {
    staticClass: "xtzb-item-vioce",
    attrs: {
      "src": __webpack_require__(315),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMicrophone()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.isPermitMicrophone == 0) ? _c('img', {
    staticClass: "xtzb-item-vioce",
    attrs: {
      "src": __webpack_require__(316),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMicrophone()
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_svga) ? _c('playSvga', {
    ref: "svga"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czewm-box"
  }, [(_vm.data) ? _c('div', {
    staticClass: "czewm-content"
  }, [_c('canvas', {
    ref: "qrcodeCanvas",
    staticClass: "czewm-qrcode"
  }), _vm._v(" "), _c('span', {
    staticClass: "czewm-label"
  }, [_vm._v(_vm._s(_vm.data.networkName) + " " + _vm._s(_vm.$t('all.chongbidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "czewm-address"
  }, [_c('span', {
    staticClass: "czewm-address-text"
  }, [_vm._v(_vm._s(_vm.data.address))]), _vm._v(" "), _c('img', {
    staticClass: "czewm-address-copy",
    attrs: {
      "src": __webpack_require__(89),
      "alt": ""
    },
    on: {
      "click": _vm.handleCopy
    }
  })]), _vm._v(" "), (_vm.rechargeStatus) ? _c('div', {
    staticClass: "czewm-status"
  }, [_c('span', {
    class: _vm.rechargeStatus === 'success' ? 'czewm-status-success' : 'czewm-status-pending'
  }, [_vm._v("\n          " + _vm._s(_vm.rechargeStatus === 'success' ? _vm.$t('all.chongzhichenggong') : _vm.$t('all.dengdaiquerenzhong')) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "czewm-btn-gradient",
    on: {
      "click": _vm.handleSaveQr
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunerweima')))]), _vm._v(" "), _c('div', {
    staticClass: "czewm-btn",
    on: {
      "click": _vm.handleCopy
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhidizhi')))])]) : _vm._e()])
},staticRenderFns: []}

/***/ })
],[458]);


// WEBPACK FOOTER //
// static/js/app.f89ef532a746fd73b778.js